import {
  Companion_getInstancemtg0kp3b7ax9 as Companion_getInstance,
  getHierarchyWithComponent1ciosii4aoq76 as getHierarchyWithComponent,
  Companion_instance38lcv7tlpb3vd as Companion_instance,
  get_connectionRootEntity1dc9n7hgx8wjr as get_connectionRootEntity,
  get_parent37cf1epzwukp7 as get_parent,
  Companion_getInstance3fu6fg4j4924q as Companion_getInstance_0,
  SystemBase23pr0o2du1qmtu as SystemBase2,
  Companion_instance1jc5thgshmt53 as Companion_instance_0,
  Companion_getInstance3md4pdk0vm7jd as Companion_getInstance_1,
  Companion_getInstance15akb0udr5r1u as Companion_getInstance_2,
  Companion_getInstanceaxoswaeylgcr as Companion_getInstance_3,
  SceneReloadingComponentwzkuihaopsg1 as SceneReloadingComponent,
  GuestConnectionsComponent3lmt1kel5okm5 as GuestConnectionsComponent,
  get_serializabletahhnzjs6wap as get_serializable,
  get_doStoreInSnapshot2ouhd6iwtr8a6 as get_doStoreInSnapshot,
  Component1lglqnbx5ofkj as Component,
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  get_descendantser7rkq0rhyf2 as get_descendants,
  get_snapRoot2o0fqu30dlj6i as get_snapRoot,
  get_highestPriorityConnectiono70rgyvqxphz as get_highestPriorityConnection,
  Companion_getInstance13kmsjhjtfw4t as Companion_getInstance_4,
  Companion_instance11k45hlj7pzgo as Companion_instance_1,
  SystemBase5u6rlp403okv as SystemBase,
  MovedToValidSnapPositionComponent2bg67k6jwdtcg as MovedToValidSnapPositionComponent,
  Companion_instance3fe9ns9dryzgh as Companion_instance_2,
  ConnectorTagConstants_instance25r6fly62d92a as ConnectorTagConstants_instance,
  ValidationImpl3mtow1d68cfbx as ValidationImpl,
  Companion_getInstance2aog3ggbb4czi as Companion_getInstance_5,
  ConnectorsComponent32a4eg1gtppvf as ConnectorsComponent,
  filterInHierarchy474mzjle21xm as filterInHierarchy,
  get_connectorsComponent2vyt6vnfllddk as get_connectorsComponent,
  SurfaceConnector2qgrveebgrhin as SurfaceConnector,
  get_guestConnections389r296igrsm5 as get_guestConnections,
  Companion_instanceddwlqwaeornb as Companion_instance_3,
  Companion_instance2ncakbr3rm4n6 as Companion_instance_4,
  get_worldTransform2y1gcjubsjrt0 as get_worldTransform,
  SystemBase427s2ha2o9p0tz as SystemBase4,
  Companion_instance1te2lwe2zlow7 as Companion_instance_5,
  findInHierarchyzbv5qkxvu9fi as findInHierarchy,
  Vector1cgy08ha6e7ya as Vector,
  Companion_instance1l2xi6jq9r026 as Companion_instance_6,
  Transform2e9p9l2euepqa as Transform,
  PointConnector2aof4iylw00ug as PointConnector,
  EdgeConnector18c5afzui3cj0 as EdgeConnector,
  Companion_getInstance1k2wrnuhjrbuv as Companion_getInstance_6,
  get_productRefOrEmptyString34p0nb5m8rrfy as get_productRefOrEmptyString,
  get_children2vj8fy0vljjod as get_children,
  ValidationResult2755ec0xe72le as ValidationResult,
  ValidationResultType_FAIL_getInstance3pxpfo6jduhaj as ValidationResultType_FAIL_getInstance,
  get_hierarchy1sm75rhmsdka0 as get_hierarchy,
  get_isPropping1mjc1m9woiddx as get_isPropping,
  PointSeriesSubConnector119yjb8t0h9yl as PointSeriesSubConnector,
  Companion_getInstance27uf09vzwro99 as Companion_getInstance_7,
  setParentsdc2yeqq589r as setParent,
  ValidSnapActionCandidateOrErrors1t6fsuepjdmhc as ValidSnapActionCandidateOrErrors,
  SnapSettingsu2m0ngibwcj8 as SnapSettings,
  Companion_instance3hfkidua2d4d9 as Companion_instance_7,
  get_snappingEntitiesSequence2dh7f7wgfsw8h as get_snappingEntitiesSequence,
  NoValidConnectorAvailableValidationResult51sgxuhhzcvw as NoValidConnectorAvailableValidationResult,
  UnknownErrorValidationResult1fcieadp0rorb as UnknownErrorValidationResult,
  Companion_instance1f7k6iwukor7l as Companion_instance_8,
  get_productRefzq8sc1a3ab3b as get_productRef,
  get_parentComponent913cs0fasf9z as get_parentComponent,
  get_worldPositionwj6kte5ftqpq as get_worldPosition,
  hierarchyExceptSubTreeArray31ltqeh012j6d as hierarchyExceptSubTreeArray,
  get_partKey3h851didm8jbw as get_partKey,
  get_immediateConnectionRootDescendants3hbzl251uhi35 as get_immediateConnectionRootDescendants,
  get_displayName36i430b21ily as get_displayName,
  Companion_instance3mp7ad30soxp7 as Companion_instance_9,
  Companion_getInstance3h5g9rxuq57pv as Companion_getInstance_8,
  SomethingIsDraggedComponent5k4agol20ifb as SomethingIsDraggedComponent,
  resumeViewerUpdatesOnDraggedEntity3h8us1qe5p1pl as resumeViewerUpdatesOnDraggedEntity,
  pauseViewerUpdatesOnDraggedEntity2gxar8yfbd5og as pauseViewerUpdatesOnDraggedEntity,
  Companion_getInstancehtw1u6p869r1 as Companion_getInstance_9,
  setParentMaintainWorldTransform2mp81fq51dsun as setParentMaintainWorldTransform,
  ViewerLineIdsComponent34apowetbbw0j as ViewerLineIdsComponent,
  LogLevel_DEBUG_getInstance3vox4wckmki76 as LogLevel_DEBUG_getInstance,
  Companion_getInstance16rqnzhjkimzu as Companion_getInstance_10,
  Companion_getInstanceuteiyw5uqdpa as Companion_getInstance_11,
  Companion_getInstance1nwvy8hb5b24i as Companion_getInstance_12,
  DebugLinesComponent2rj8crh35vhgh as DebugLinesComponent,
  UpdatedFromSnapshotEventComponent2v4gcwwpi6res as UpdatedFromSnapshotEventComponent,
  EntityManagerWatcher3o9hbfdtrb9zp as EntityManagerWatcher,
  Measurer3qj03p4urq95r as Measurer,
  Companion_getInstance3mtu0wpuna6mm as Companion_getInstance_13,
  Plane1msa79ko6z8u2 as Plane,
  ViewerDragEventComponentfzbgl8e0va3i as ViewerDragEventComponent,
  Companion_getInstanceblwi6p98rjjg as Companion_getInstance_14,
  DraggableComponent2vg3of9uj9uwn as DraggableComponent,
  PolyhedronGroup3vtqeeg09ivxm as PolyhedronGroup,
  Companion_getInstance1cmxj7l93cwya as Companion_getInstance_15,
  DebugLine34r2sssqo89ca as DebugLine,
  ConvexPolyhedron31ds19umtd0r4 as ConvexPolyhedron,
  Companion_getInstance3jrtv4roftybv as Companion_getInstance_16,
  Companion_instanceauu711mmnozu as Companion_instance_10,
  Companion_getInstance1gjpn1yzol595 as Companion_getInstance_17,
  get_isInScene27litrxhfjomh as get_isInScene,
  WorldDragSurfacesComponent1qlawlc64osxl as WorldDragSurfacesComponent,
  InSceneComponentde0noxkj1mf1 as InSceneComponent,
  Companion_getInstanceoonrb8185bmg as Companion_getInstance_18,
  DebugSurfacesComponent2ye435zjrp3pw as DebugSurfacesComponent,
  get_colliderShapeComponent1cprwuuvy5ljn as get_colliderShapeComponent,
  DragSurface3d7ocyb1ribou as DragSurface,
  DragSurfacesComponent2obth6ol1y4en as DragSurfacesComponent,
  Companion_getInstance3nop5w80d2fvp as Companion_getInstance_19,
  ColliderShapeComponent102whak4g71e2 as ColliderShapeComponent,
  triggerMovedToValidSnapPositionComponent2zlcbcx5elfwb as triggerMovedToValidSnapPositionComponent,
  Companion_getInstance2a3twbfroyz1e as Companion_getInstance_20,
  WorldSpaceDragEventComponent5q5f03t88rlk as WorldSpaceDragEventComponent,
  Companion_getInstance1g0yv2gl6yx8v as Companion_getInstance_21,
  Companion_instance1wuloyan4lumr as Companion_instance_11,
  Companion_getInstancebkytj44sbgxv as Companion_getInstance_22,
  get_isAutomaticGroup10cidqe09p5d0 as get_isAutomaticGroup,
  Companion_instance2v4yervvzae2n as Companion_instance_12,
  Companion_getInstance3orxffzckamdl as Companion_getInstance_23,
  SnapRootComponent157nyaf19ls92 as SnapRootComponent,
  get_selectableRootqmacaz6hsycx as get_selectableRoot,
  hierarchyExceptSubTreesWithComponentArray2vchkhklu6mmt as hierarchyExceptSubTreesWithComponentArray,
  get_isSelected3w3gt1bz8axae as get_isSelected,
  get_draggableRootEntity2oj5yri14vpjv as get_draggableRootEntity,
  Companion_getInstance3k1r95ywn5kw9 as Companion_getInstance_24,
  hasAncestor2y0z678tcabqy as hasAncestor,
  TemporaryParentComponentjxe9t8sxbmn1 as TemporaryParentComponent,
  set_displayName21kc1688xgq2d as set_displayName,
  isDescendantOf2ougv59gaurds as isDescendantOf,
  Companion_instance31r63n71hpepn as Companion_instance_13,
  Companion_instance2am4if0k0vik5 as Companion_instance_14,
  forEachInHierarchy2h9zs3d5h4wwz as forEachInHierarchy,
  Companion_instance2xadtclahfaol as Companion_instance_15,
  findWithComponentInUpwardsHierarchy28ehb2p7f3g3t as findWithComponentInUpwardsHierarchy,
  Companion_instance31r4dd7fkzkv0 as Companion_instance_16,
  centerOfConnections3rp3scnx08x94 as centerOfConnections,
  hierarchyExceptSubTreesWithComponentSequence3r6a5pldcjcbz as hierarchyExceptSubTreesWithComponentSequence,
  get_connectors3o1bagte2voxy as get_connectors,
  Companion_getInstance2k1ozwc8kfagp as Companion_getInstance_25,
  UnserializableEntityComponent3dbbopzug8j88 as UnserializableEntityComponent,
  DisplayNameComponent37eao6dtqdntj as DisplayNameComponent,
  RaycastResult2x8clpf8hmgis as RaycastResult,
  get_guestConnectors159rdzxuhz1ct as get_guestConnectors,
  get_hostConnectorsfy90ve2ifxxi as get_hostConnectors,
  RaycastHit45545frb8lqu as RaycastHit,
  get_hierarchySequence36fwaxpen7dj9 as get_hierarchySequence,
  get_objectOrientedBoundingBoxForHierarchy1259c236lwl7n as get_objectOrientedBoundingBoxForHierarchy,
  Companion_instance3o7m6i0by1hrp as Companion_instance_17,
  WorldTransformComponentm4lqdo5dza5x as WorldTransformComponent,
  get_collider2fpb05srk6mij as get_collider,
  hierarchyContains3heici1vjajaj as hierarchyContains,
  ValidationResultType_WARNING_getInstance3uf8cr4ggrfxr as ValidationResultType_WARNING_getInstance,
  Collisionenvj3252kvhl as Collision,
  LogLevel_ERROR_getInstance203rtwgaav6kh as LogLevel_ERROR_getInstance,
  echoStandardConsole2oa0qqsaar076 as echoStandardConsole,
  LogLevel_WARN_getInstance343yembho3ik6 as LogLevel_WARN_getInstance,
  LogLevel_INFO_getInstance2t7zae538qncw as LogLevel_INFO_getInstance,
  Logger353bsqefxu9f as Logger,
  Companion_instance22fugbyjy60j7 as Companion_instance_18,
  SlowReplaceInProgressComponent1dbsrebp9hvu3 as SlowReplaceInProgressComponent,
  get_isConnectionRoot7v6e5jlx4v0s as get_isConnectionRoot,
  get_snappingHierarchyEntities13s2ho7vt0q9e as get_snappingHierarchyEntities,
  Companion_instancericwnzqb4avc as Companion_instance_19,
  Companion_getInstance27n1ww8f1u0xr as Companion_getInstance_26,
  Companion_getInstance1fi195ub4psxa as Companion_getInstance_27,
  Companion_getInstance1v24row485z1k as Companion_getInstance_28,
  Companion_getInstance1jzb2c9nz909x as Companion_getInstance_29,
  SystemBase33jliyb74mzyqn as SystemBase3,
  Companion_getInstance22n010gwukty as Companion_getInstance_30,
  get_viewerObject29ot7toalu4g9 as get_viewerObject,
  AutomaticGroupComponent3avj018e753er as AutomaticGroupComponent,
  SelectedComponentmjsrq13g7qiz as SelectedComponent,
  hasComponentInUpwardsHierarchyketgpzoey4xa as hasComponentInUpwardsHierarchy,
  Companion_instance3ca1skpyodlsq as Companion_instance_20,
  Companion_instanceue8xml419xwh as Companion_instance_21,
  ChildComponent2d030zd3zomve as ChildComponent,
  LoadedModelInfoComponent3liifkjcvcim3 as LoadedModelInfoComponent,
  get_worldRotationjykn4pgiq1i9 as get_worldRotation,
  SnapCandidateComponentt1m6a2tkmtdo as SnapCandidateComponent,
  Companion_instance1714icf3ryhzu as Companion_instance_22,
  Companion_instance29cjaupvwlme8 as Companion_instance_23,
  RestrictAllowedRequiredHostsComponent1sbq773f5zt75 as RestrictAllowedRequiredHostsComponent,
  ValidationResultFail37lbftt1xszsx as ValidationResultFail,
  ValidationResultWarning2nfqcjukfyxxc as ValidationResultWarning,
  get_axisAlignedBoundingBoxForHierarchy3uv948cp1omtd as get_axisAlignedBoundingBoxForHierarchy,
  LocalTransformComponentFromPosAndRot3l4w35iqp44oh as LocalTransformComponentFromPosAndRot,
  AxisAlignedBox3der0ng81kho4 as AxisAlignedBox,
  CollisionValidationResultsw0tl1zrikpj as CollisionValidationResult,
  CollisionValidation1d8vdntob7pqk as CollisionValidation,
  get_isHangingaizup6o5hh9d as get_isHanging,
  get_localTransform18l3q551qwat8 as get_localTransform,
  Radians3bflt61di9nby as Radians,
  fromConnectors3fh5yrw28qlfe as fromConnectors,
  Companion_getInstance321ix5enib7je as Companion_getInstance_31,
  AlwaysHangDownComponent_instance2s6f7ev3q7y3y as AlwaysHangDownComponent_instance,
  Companion_instance3pyqhbbct0szg as Companion_instance_24,
  RenderedComponent23lei7ja9f7xq as RenderedComponent,
  get_snapRootSubTree2hzdt81oiat82 as get_snapRootSubTree,
  fromSizeAndCenter1wsnpvuimuz5l as fromSizeAndCenter,
  Companion_getInstance3bt8g3cy89lt3 as Companion_getInstance_32,
  Companion_getInstance15s3plxmm5ab3 as Companion_getInstance_33,
  Companion_getInstance2hofax3pdsu41 as Companion_getInstance_34,
  AddPartActionh2vxb8orgybz as AddPartAction,
  ReplacePartAction1coduwrmfkb5 as ReplacePartAction,
  RemovePartAction111eypffspa5d as RemovePartAction,
  Companion_instance180k82anvpmzv as Companion_instance_25,
  get_guests2nnamzd9jyn03 as get_guests,
  ReplaceAction1fa7i0xxq6oq1 as ReplaceAction,
  FastReplaceAction212dhglwlr3dq as FastReplaceAction,
  $serializer_getInstance1m03xnpu59c6l as $serializer_getInstance,
  JsonSerializablelbp1cvonvyw3 as JsonSerializable,
  Companion_instance1bk50smddux2z as Companion_instance_26,
  MultiSelectionEnabledComponent_instance221fiubaxomrq as MultiSelectionEnabledComponent_instance,
  Companion_getInstance1dnxx5lu7yxa4 as Companion_getInstance_35,
  ClickEventComponent21i5dkpzq1l7t as ClickEventComponent,
  MultiSelectionEnabledComponent9yk5njwwbqmj as MultiSelectionEnabledComponent,
  get_isSelectableoo9b377znajq as get_isSelectable,
  get_serializable1h8fjfkichiku as get_serializable_0,
  SerializableComponentkfm1jx9phpa4 as SerializableComponent,
  ComponentDeserializer3gfn2wcyjz4fh as ComponentDeserializer,
  __VectorIntConstructorKotlin23vz0u6hkz1es as __VectorIntConstructorKotlin,
  Ray11cma6fe4h4tn as Ray,
  $serializer_getInstance1u6uor4icd059 as $serializer_getInstance_0,
  StaticComponent1ujjt0txbrs9g as StaticComponent,
  afterDeserializeComplete21wl460cpzfw1 as afterDeserializeComplete,
  beforeDeserializeg4ijm0l5kwv as beforeDeserialize,
  beforeParsingComponents1uddyhbyukgzt as beforeParsingComponents,
  DeserializationInterceptor3bc7uplzjkuuu as DeserializationInterceptor,
  findInUpwardsHierarchyxs505279d5su as findInUpwardsHierarchy,
  Companion_getInstance3c0i746p2b3f1 as Companion_getInstance_36,
  fromSize34pw6a0b0kii5 as fromSize,
  LocalTransformComponent1ihphzx3x7pnv as LocalTransformComponent,
  ConnectionRootComponent3fd9sp0aqznxo as ConnectionRootComponent,
  Companion_getInstance39qe8r3ndgbae as Companion_getInstance_37,
  Companion_instancelsy6jo6gbmmg as Companion_instance_27,
  Companion_instance1st59rgzokdzq as Companion_instance_28,
  Companion_instance1cg1b3a1w3dy5 as Companion_instance_29,
  Companion_instance2ofmo3pv93kda as Companion_instance_30,
  Companion_instancemu8gakosrpk3 as Companion_instance_31,
  Companion_instance22st57uvtl8ku as Companion_instance_32,
  Companion_instance36lwzgsqf57la as Companion_instance_33,
  ViewerObjectComponent27r4begfll99a as ViewerObjectComponent,
  Companion_getInstance3p2yxk0ezuu1y as Companion_getInstance_38,
  Companion_instance3bnjpjo9eo1h9 as Companion_instance_34,
  ViewerComponent2txqc9jweitfp as ViewerComponent,
  IsLoadingSnapshotComponentfhpzacbq70od as IsLoadingSnapshotComponent,
  SystemBase535eey1gt93lp7 as SystemBase5,
  SceneComponent_instance2m1l3aroyspd4 as SceneComponent_instance,
  PointSeriesConnector14wrze1fez6ba as PointSeriesConnector,
  Degrees1pmrlnndueajq as Degrees,
  ValidationServiceMeasurern2cdhikkmaju as ValidationServiceMeasurer,
  ModelInfoComponentvt7uz6p6kni4 as ModelInfoComponent,
} from './core-core-api.mjs';
import {
  Unit_instanceat14thlj150z as Unit_instance,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$,
  copyToArray2j022khrow2yi as copyToArray,
  distinct10qe1scfdvu5k as distinct,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  defineProp3hxgpk2knu2px as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  compareBy2697bq0ffft96 as compareBy,
  sortWith23lt7r6b8svqd as sortWith,
  joinToStringxqcavsxcmh4q as joinToString,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  listOfvhqybd2zx248 as listOf,
  toList383f556t1dixk as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0,
  Exception_init_$Create$1f9k5rt5gytdg as Exception_init_$Create$,
  KtMap140uvy3s5zad8 as KtMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptyList1g2z5xcrvp2zy as emptyList,
  addAll1k27qatfgp3k5 as addAll,
  contains1tccixv8iwdcq as contains,
  any3lcolwko9usbz as any,
  any2h2vr68v3604v as any_0,
  LinkedHashSet_init_$Create$161uomhguzhxi as LinkedHashSet_init_$Create$,
  Exceptiondt2hlxn7j7vw as Exception,
  toString1pkumu07cwy4m as toString,
  Paire9pteg33gng7 as Pair,
  asSequence2phdjljfh9jhx as asSequence,
  mapsbvh18eqox7a as map,
  compareTo3ankvs086tmwq as compareTo,
  flatten2mvk8hmq4axux as flatten,
  getOrNull1d60i0672n7ns as getOrNull,
  roundToInt1ue8x8yshtznx as roundToInt,
  toList3jhuyej2anx2q as toList_0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  asSequence2jzw5xbq99nu9 as asSequence_0,
  filter184huxd00uyfg as filter,
  onEach2dt3enhf2rybm as onEach,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  firstOrNull175qkyx53x0vd as firstOrNull,
  Collection1k04j3hzsbod0 as Collection,
  anytbxcu4fk10en as any_1,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  none17v2pcg9wklml as none,
  firstOrNull1gk7vzkf4h3nq as firstOrNull_0,
  firstOrNull1982767dljvdy as firstOrNull_1,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  first1vi3grnpj1175 as first,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  distinct1ludzbuprw0ot as distinct_0,
  plus2l6bq32n2wlna as plus,
  repeat2w4c6j8zoq09o as repeat,
  joinToString1cxrrlmo0chqs as joinToString_0,
  println2shhhgwwt4c61 as println,
  round2mrvepag8eey0 as round,
  toString30pk9tzaqopn as toString_0,
  last3cd86tb14cwl6 as last,
  plus20p0vtfmu0596 as plus_0,
  toSet2orjxp16sotqu as toSet,
  minus165a8u1e0x1lu as minus,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$snys8oz8txtu as LinkedHashMap_init_$Create$_0,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  plus27p1csfyhycs6 as plus_1,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  to2cs3ny02qtbcb as to,
  HashSet_init_$Create$2bsk5herqkxxm as HashSet_init_$Create$,
  Exception_init_$Init$3c1h61we8oiuv as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  addAll3rgorw6ix9mgp as addAll_0,
  UnsupportedOperationException_init_$Create$1usmxm8d6ijjz as UnsupportedOperationException_init_$Create$,
  minus1xf0q16hmdsny as minus_0,
  NoSuchElementException_init_$Create$1admdzgt61c19 as NoSuchElementException_init_$Create$,
  plus310ted5e4i90h as plus_2,
  sortedWith13ny3qsmk2kn8 as sortedWith_0,
  addAll21mdhg523wnoa as addAll_1,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  sorted354mfsiv4s7x5 as sorted,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  NoSuchElementException_init_$Create$3t0s5oqnkdmdn as NoSuchElementException_init_$Create$_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  toMutableList20rdgwi7d3cwi as toMutableList,
  contains3ue2qo8xhmpf1 as contains_0,
  substringAfter35b3qhto7hchb as substringAfter,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  copyOfRangectu1wvlwieiw as copyOfRange,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Companion_getInstanceugb954yhgpyd as Companion_getInstance_39,
  arrayConcat3qsij7vh68m69 as arrayConcat,
  asList2ho2pewtsfvv as asList,
  minus1djrl64vbav3y as minus_1,
  indexOf3ic8eacwbbrog as indexOf,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  getKClass1s3j9wy1cofik as getKClass,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  reversedArray1jvawboiqjp41 as reversedArray,
  reversed22y3au42jl32b as reversed,
  emptyMapr06gerzljqtm as emptyMap,
  Error_init_$Create$3uypstjrbl1xl as Error_init_$Create$,
  mapOf2zpbbmyqk8xpf as mapOf,
  toMap1vec9topfei08 as toMap,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  Random2w0u2xak2xaqi as Random,
  toListx6x8nvfmvvht as toList_1,
  flatten2dh4kibw1u0qq as flatten_0,
  emptySequence25zpp7hgtqwdd as emptySequence,
  endsWith3cq61xxngobwh as endsWith,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_isRoomPartbpuhsyvsgmwq as get_isRoomPart,
  Companion_getInstancezthp1cggtmqt as Companion_getInstance_40,
  get_isRoom1fe449b5enr4j as get_isRoom,
  Companion_getInstance2nzafxewx0x5b as Companion_getInstance_41,
  RoomComponent2gkkpzoq5lilh as RoomComponent,
  Companion_instance1t1j53owkga9v as Companion_instance_35,
  Companion_instancefbh6n0flhkk9 as Companion_instance_36,
  Companion_instance13c20tozi5426 as Companion_instance_37,
  RoomPartComponent1a7o4iq43ookc as RoomPartComponent,
} from './ipex-room-definitions.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  ReferenceArraySerializer3juj1vqolxkrs as ReferenceArraySerializer,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
var sign = Math.sign;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AlignmentConnectionCreationSystem, 'AlignmentConnectionCreationSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AlignmentConnectionsComponent, 'AlignmentConnectionsComponent', AlignmentConnectionsComponent, VOID, [Component]);
initMetadataForClass(AlignmentPlane, 'AlignmentPlane');
initMetadataForCompanion(Companion_1);
initMetadataForObject(HandleUnderAlignmentComponent, 'HandleUnderAlignmentComponent', VOID, VOID, [Component]);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(HandleRotationSystem, 'HandleRotationSystem', VOID, SystemBase);
initMetadataForClass(HostConnectorRotationValidation, 'HostConnectorRotationValidation', HostConnectorRotationValidation, ValidationImpl);
initMetadataForClass(AlignmentLinesReferenceCounter, 'AlignmentLinesReferenceCounter', AlignmentLinesReferenceCounter);
initMetadataForCompanion(Companion_2);
initMetadataForClass(AlignmentLinesSystem, 'AlignmentLinesSystem', VOID, SystemBase4);
initMetadataForCompanion(Companion_3);
initMetadataForClass(EntityWithConnector, 'EntityWithConnector');
initMetadataForClass(IntersectionPointConnectors, 'IntersectionPointConnectors');
initMetadataForClass(IntersectionPointsTracker, 'IntersectionPointsTracker', IntersectionPointsTracker);
initMetadataForCompanion(Companion_4);
initMetadataForClass(RoomAlignmentEdgesComponent, 'RoomAlignmentEdgesComponent', VOID, VOID, [Component]);
initMetadataForClass(SurfaceAlignmentLines, 'SurfaceAlignmentLines');
initMetadataForClass(SurfaceConnectorWithEntity, 'SurfaceConnectorWithEntity');
initMetadataForCompanion(Companion_5);
initMetadataForClass(AllowedDoorPairsComponent, 'AllowedDoorPairsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(AllowedDoorPairsValidation, 'AllowedDoorPairsValidation', AllowedDoorPairsValidation, ValidationImpl);
initMetadataForCompanion(Companion_7);
initMetadataForClass(InvalidDoorPairsResult, 'InvalidDoorPairsResult', VOID, ValidationResult);
initMetadataForClass(AssemblyInstructionsService, 'AssemblyInstructionsService', AssemblyInstructionsService);
initMetadataForInterface(PointSeriesAssemblyInstruction, 'PointSeriesAssemblyInstruction');
initMetadataForClass(PointSeriesAssemblyInstructionImpl, 'PointSeriesAssemblyInstructionImpl', VOID, VOID, [PointSeriesAssemblyInstruction]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(AutoAdaptFeature, 'AutoAdaptFeature', AutoAdaptFeature);
initMetadataForCompanion(Companion_9);
initMetadataForClass(AutoAdaptProductSpecificationsSystem, 'AutoAdaptProductSpecificationsSystem', VOID, SystemBase);
initMetadataForClass(AutoAdaptService, 'AutoAdaptService');
initMetadataForClass(EntityWithSensorZone, 'EntityWithSensorZone');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(AutoAdaptUtils, 'AutoAdaptUtils', AutoAdaptUtils);
initMetadataForCompanion(Companion_11);
initMetadataForClass(AutoAdaptChildFailedEventComponent, 'AutoAdaptChildFailedEventComponent', AutoAdaptChildFailedEventComponent, VOID, [Component]);
initMetadataForClass(ChildInfo, 'ChildInfo');
initMetadataForInterface(SortCriterion, 'SortCriterion');
initMetadataForClass(PreferGuestCriterion, 'PreferGuestCriterion', VOID, VOID, [SortCriterion]);
initMetadataForClass(PreferSameConnectorsCriterion, 'PreferSameConnectorsCriterion', VOID, VOID, [SortCriterion]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(AutoAdaptChildrenSystem, 'AutoAdaptChildrenSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_13);
initMetadataForClass(AutoAdaptDisposeFailedChildrenSystem, 'AutoAdaptDisposeFailedChildrenSystem', AutoAdaptDisposeFailedChildrenSystem, SystemBase);
initMetadataForCompanion(Companion_14);
initMetadataForClass(AutoAdaptCacheSystem, 'AutoAdaptCacheSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_15);
initMetadataForClass(AutoAdaptCachedVariantsComponent, 'AutoAdaptCachedVariantsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(AutoAdaptSessionComponent, 'AutoAdaptSessionComponent', AutoAdaptSessionComponent, VOID, [Component]);
initMetadataForCompanion(Companion_17);
initMetadataForClass(CleanCacheOnFinishedAutoAdaptSystem, 'CleanCacheOnFinishedAutoAdaptSystem', CleanCacheOnFinishedAutoAdaptSystem, SystemBase2);
initMetadataForCompanion(Companion_18);
initMetadataForClass(AutoAdaptGuestComponent, 'AutoAdaptGuestComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_19);
initMetadataForClass(AutoAdaptHostComponent, 'AutoAdaptHostComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_20);
initMetadataForClass(AutoAdaptProductSpecificationsComponent, 'AutoAdaptProductSpecificationsComponent', VOID, VOID, [Component]);
initMetadataForClass(SpecificationPair, 'SpecificationPair');
initMetadataForCompanion(Companion_21);
initMetadataForClass(AutoAdaptVariantComponent, 'AutoAdaptVariantComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_22);
initMetadataForClass(ForceAutoAdaptWhenParentIsDraggedComponent, 'ForceAutoAdaptWhenParentIsDraggedComponent', ForceAutoAdaptWhenParentIsDraggedComponent, VOID, [Component]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(ReplacedWithAutoAdaptEventComponent, 'ReplacedWithAutoAdaptEventComponent', VOID, VOID, [Component]);
function dragStart(draggedRootEntity) {
}
function dragStop(draggedRootEntity) {
}
initMetadataForInterface(DragStrategy, 'DragStrategy');
initMetadataForClass(AbstractDragStrategy, 'AbstractDragStrategy', VOID, VOID, [DragStrategy]);
initMetadataForClass(AutoAdaptDragStrategy, 'AutoAdaptDragStrategy', VOID, AbstractDragStrategy);
initMetadataForCompanion(Companion_24);
initMetadataForInterface(DragSurfaceSelector, 'DragSurfaceSelector');
initMetadataForClass(DragSurfaceCanHostSelector, 'DragSurfaceCanHostSelector', DragSurfaceCanHostSelector, VOID, [DragSurfaceSelector]);
initMetadataForClass(DragSurfaceCanHostWithAutoAdaptSelector, 'DragSurfaceCanHostWithAutoAdaptSelector', VOID, DragSurfaceCanHostSelector);
initMetadataForClass(ValidDragStrategyResult, 'ValidDragStrategyResult');
initMetadataForClass(ValidAutoAdaptDragStrategyResult, 'ValidAutoAdaptDragStrategyResult', VOID, ValidDragStrategyResult);
initMetadataForCompanion(Companion_25);
initMetadataForClass(DebugLineDrawingSystem, 'DebugLineDrawingSystem', VOID, SystemBase2);
initMetadataForClass(LoggingEntityManagerWatcher, 'LoggingEntityManagerWatcher', VOID, VOID, [EntityManagerWatcher]);
initMetadataForObject(DoneEntry, 'DoneEntry');
initMetadataForClass(AddEntry, 'AddEntry');
initMetadataForClass(RemoveEntry, 'RemoveEntry');
initMetadataForClass(CallEntry, 'CallEntry');
initMetadataForClass(MeasuringEntityManagerWatcher, 'MeasuringEntityManagerWatcher', VOID, VOID, [EntityManagerWatcher]);
initMetadataForCompanion(Companion_26);
initMetadataForClass(DragRotationSystem, 'DragRotationSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_27);
initMetadataForClass(DragState, 'DragState');
initMetadataForCompanion(Companion_28);
initMetadataForClass(DragStateComponent, 'DragStateComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(DragSurfaceNormalVisualizationSystem, 'DragSurfaceNormalVisualizationSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_30);
initMetadataForClass(DragSurfaceVisualizationSystem, 'DragSurfaceVisualizationSystem', VOID, SystemBase2);
initMetadataForClass(DragSurfacesUpdateSystem, 'DragSurfacesUpdateSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_31);
initMetadataForClass(DragSystem, 'DragSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_32);
initMetadataForClass(DrawDragGhostSystem, 'DrawDragGhostSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_33);
initMetadataForClass(GhostUtils, 'GhostUtils', GhostUtils);
initMetadataForInterface(PostProcessDragStrategy, 'PostProcessDragStrategy');
initMetadataForClass(HigherPriorityAlignmentPostProcess, 'HigherPriorityAlignmentPostProcess', VOID, VOID, [PostProcessDragStrategy]);
initMetadataForCompanion(Companion_34);
initMetadataForClass(IsDraggedComponent, 'IsDraggedComponent', IsDraggedComponent, VOID, [Component]);
initMetadataForCompanion(Companion_35);
initMetadataForClass(MultiDragCommonParentComponent, 'MultiDragCommonParentComponent', VOID, VOID, [Component]);
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(MultiDragUtils, 'MultiDragUtils');
initMetadataForCompanion(Companion_36);
initMetadataForClass(RemovedDragComponentsComponent, 'RemovedDragComponentsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_37);
initMetadataForClass(TakeSnapshotBeforeDragSystem, 'TakeSnapshotBeforeDragSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_38);
initMetadataForClass(FreeMoveComponent, 'FreeMoveComponent', FreeMoveComponent, VOID, [Component]);
initMetadataForClass(ResolveCollisionsDragStrategy, 'ResolveCollisionsDragStrategy', VOID, AbstractDragStrategy);
initMetadataForClass(SnapCardinalDirectionsDragStrategy, 'SnapCardinalDirectionsDragStrategy', VOID, AbstractDragStrategy);
initMetadataForCompanion(Companion_39);
initMetadataForClass(SnapClosestDragStrategy, 'SnapClosestDragStrategy', VOID, AbstractDragStrategy);
initMetadataForClass(SnapClosestWithSubConnectorsDragStrategy, 'SnapClosestWithSubConnectorsDragStrategy', VOID, AbstractDragStrategy);
initMetadataForCompanion(Companion_40);
initMetadataForCompanion(Companion_41);
initMetadataForClass(CanvasTo3DDragConverterSystem, 'CanvasTo3DDragConverterSystem', VOID, SystemBase);
initMetadataForClass(DragSurfaceEntityPair, 'DragSurfaceEntityPair');
initMetadataForClass(DragSurfaceOnlyRoomSelector, 'DragSurfaceOnlyRoomSelector', DragSurfaceOnlyRoomSelector, VOID, [DragSurfaceSelector]);
initMetadataForCompanion(Companion_42);
initMetadataForClass(LegacyCanvasTo3DDragConverterSystem, 'LegacyCanvasTo3DDragConverterSystem', VOID, SystemBase);
initMetadataForClass(NoDragConverterDetector, 'NoDragConverterDetector', VOID, SystemBase2);
initMetadataForCompanion(Companion_43);
initMetadataForClass(DragProjectionPointComponent, 'DragProjectionPointComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_44);
initMetadataForClass(GrabOffsetComponent, 'GrabOffsetComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_45);
initMetadataForInterface(DragSurfaceProjector, 'DragSurfaceProjector');
initMetadataForClass(AnyDragSurfaceProjector, 'AnyDragSurfaceProjector', VOID, VOID, [DragSurfaceProjector]);
initMetadataForCompanion(Companion_46);
initMetadataForClass(DragSurfaceEntityPairsCacheComponent, 'DragSurfaceEntityPairsCacheComponent', DragSurfaceEntityPairsCacheComponent, VOID, [Component]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(DragSurfaceUpdatesListenerSystem, 'DragSurfaceUpdatesListenerSystem', VOID, SystemBase2);
initMetadataForClass(XYPlaneProjector, 'XYPlaneProjector', XYPlaneProjector, VOID, [DragSurfaceProjector]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(FunctionalMarginComponent, 'FunctionalMarginComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_49);
initMetadataForClass(FunctionalMarginShapeComponent, 'FunctionalMarginShapeComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_50);
initMetadataForClass(FunctionalMarginSystem, 'FunctionalMarginSystem', FunctionalMarginSystem, SystemBase2);
initMetadataForCompanion(Companion_51);
initMetadataForClass(FunctionalMarginValidation, 'FunctionalMarginValidation', VOID, ValidationImpl);
initMetadataForCompanion(Companion_52);
initMetadataForClass(FunctionalMarginWarning, 'FunctionalMarginWarning', VOID, ValidationResult);
initMetadataForClass(FunctionalZone, 'FunctionalZone');
initMetadataForCompanion(Companion_53);
initMetadataForClass(FunctionalZoneUtils, 'FunctionalZoneUtils', FunctionalZoneUtils);
initMetadataForCompanion(Companion_54);
initMetadataForClass(FunctionalZonesLocalComponent, 'FunctionalZonesLocalComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_55);
initMetadataForClass(FunctionalZonesLocalToWorldSystem, 'FunctionalZonesLocalToWorldSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_56);
initMetadataForClass(FunctionalZonesWorldComponent, 'FunctionalZonesWorldComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(ICFDataService, 'ICFDataService');
initMetadataForClass(ICFProductData, 'ICFProductData');
initMetadataForCompanion(Companion_58);
initMetadataForClass(LabelComponent, 'LabelComponent', VOID, VOID, [Component]);
initMetadataForClass(DebugLogger, 'DebugLogger', DebugLogger, VOID, [Logger]);
initMetadataForClass(LoggerException, 'LoggerException', LoggerException, Exception);
initMetadataForCompanion(Companion_59);
initMetadataForClass(CurrentProppingComponent, 'CurrentProppingComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_60);
initMetadataForClass(DisposeProppingOnSlowReplacedEntitySystem, 'DisposeProppingOnSlowReplacedEntitySystem', DisposeProppingOnSlowReplacedEntitySystem, SystemBase);
initMetadataForCompanion(Companion_61);
initMetadataForClass(LargestFittingProppingComponent, 'LargestFittingProppingComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_62);
initMetadataForClass(ProppingConvertColliderToFunctionalZoneSystem, 'ProppingConvertColliderToFunctionalZoneSystem', ProppingConvertColliderToFunctionalZoneSystem, SystemBase);
initMetadataForCompanion(Companion_63);
initMetadataForClass(ProppingDisposalSystem, 'ProppingDisposalSystem', ProppingDisposalSystem, SystemBase2);
initMetadataForCompanion(Companion_64);
initMetadataForClass(ProppingHostConnectorDataComponent, 'ProppingHostConnectorDataComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_65);
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ProppingHostConnectorDataCreationSystem, 'ProppingHostConnectorDataCreationSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_66);
initMetadataForClass(ProppingParentComponent, 'ProppingParentComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_67);
initMetadataForClass(ProppingSpaceCalculationSystem, 'ProppingSpaceCalculationSystem', VOID, SystemBase3);
initMetadataForCompanion(Companion_68);
initMetadataForClass(SelectLargestProppingPlacementSystem, 'SelectLargestProppingPlacementSystem', VOID, SystemBase);
initMetadataForClass(SizeProppingPair, 'SizeProppingPair');
initMetadataForCompanion(Companion_69);
initMetadataForClass(TemporarilyIgnoreMyProppingFunctionalZonesComponent, 'TemporarilyIgnoreMyProppingFunctionalZonesComponent', TemporarilyIgnoreMyProppingFunctionalZonesComponent, VOID, [Component]);
initMetadataForCompanion(Companion_70);
initMetadataForClass(ColoredOutlineComponent, 'ColoredOutlineComponent', ColoredOutlineComponent, VOID, [Component]);
initMetadataForClass(ColoredOutlineSystem, 'ColoredOutlineSystem', ColoredOutlineSystem, SystemBase);
initMetadataForCompanion(Companion_71);
initMetadataForClass(OutlineBlockingComponent, 'OutlineBlockingComponent', OutlineBlockingComponent, VOID, [Component]);
initMetadataForCompanion(Companion_72);
initMetadataForClass(OutlineEntityGroupDeselectSystem, 'OutlineEntityGroupDeselectSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_73);
initMetadataForClass(OutlineSelectedSystem, 'OutlineSelectedSystem', OutlineSelectedSystem, SystemBase);
initMetadataForClass(OutlineSystem, 'OutlineSystem', OutlineSystem, SystemBase4);
initMetadataForCompanion(Companion_74);
initMetadataForClass(OutlinedComponent, 'OutlinedComponent', OutlinedComponent, VOID, [Component]);
initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(AutoAdaptPlacementActor, 'AutoAdaptPlacementActor');
initMetadataForCompanion(Companion_75);
initMetadataForClass(PlacementHelper, 'PlacementHelper', PlacementHelper);
initMetadataForCompanion(Companion_76);
initMetadataForClass(PlacementResult, 'PlacementResult');
initMetadataForClass(PlacementService, 'PlacementService');
initMetadataForCompanion(Companion_77);
initMetadataForClass(PlacementZoneByHeightComponent, 'PlacementZoneByHeightComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_78);
initMetadataForClass(RecommendedInitialPositionFromFloorComponent, 'RecommendedInitialPositionFromFloorComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_79);
initMetadataForClass(RecommendedInitialPositionFromParentComponent, 'RecommendedInitialPositionFromParentComponent', VOID, VOID, [Component]);
initMetadataForObject(SearchDirectionsUtils, 'SearchDirectionsUtils');
initMetadataForCompanion(Companion_80);
initMetadataForClass(CandidateResult, 'CandidateResult');
initMetadataForCompanion(Companion_81);
initMetadataForClass(SnapPlacementActor, 'SnapPlacementActor');
initMetadataForClass(SortCriterionBase, 'SortCriterionBase', VOID, VOID, [SortCriterion]);
initMetadataForClass(DistanceCriterion, 'DistanceCriterion', DistanceCriterion, SortCriterionBase, [SortCriterionBase, SortCriterion]);
initMetadataForInterface(FilterCriterion, 'FilterCriterion');
initMetadataForClass(InActivationDistanceFilter, 'InActivationDistanceFilter', InActivationDistanceFilter, VOID, [FilterCriterion]);
initMetadataForClass(OriginalVariantCriterion, 'OriginalVariantCriterion', OriginalVariantCriterion, SortCriterionBase, [SortCriterionBase, SortCriterion]);
initMetadataForInterface(PriorityCriterionSettings, 'PriorityCriterionSettings');
initMetadataForClass(PriorityCriterionSettings$Companion$all$1, VOID, VOID, VOID, [PriorityCriterionSettings]);
initMetadataForClass(PriorityCriterionSettings$Companion$onlyInActivationDistance$1, VOID, VOID, VOID, [PriorityCriterionSettings]);
initMetadataForCompanion(Companion_82);
initMetadataForClass(PriorityCriterion, 'PriorityCriterion', VOID, SortCriterionBase, [SortCriterionBase, SortCriterion]);
initMetadataForClass(RecommendedDistanceFromFloorCriterion, 'RecommendedDistanceFromFloorCriterion', RecommendedDistanceFromFloorCriterion, SortCriterionBase, [SortCriterionBase, SortCriterion]);
initMetadataForClass(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(SnapSorter, 'SnapSorter');
initMetadataForClass(SnapSorterBuilder, 'SnapSorterBuilder', SnapSorterBuilder);
initMetadataForClass(WarningsCriterion, 'WarningsCriterion', WarningsCriterion, VOID, [SortCriterion]);
initMetadataForClass(sam$kotlin_Comparator$0_7, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_8, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_83);
initMetadataForClass(SpaceFinderUtils, 'SpaceFinderUtils', SpaceFinderUtils);
initMetadataForCompanion(Companion_84);
initMetadataForClass(ProppingData, 'ProppingData');
initMetadataForCompanion(Companion_85);
initMetadataForClass(ProppingFeature, 'ProppingFeature', ProppingFeature);
initMetadataForCompanion(Companion_86);
initMetadataForClass(ProppingHostConnectorsComponent, 'ProppingHostConnectorsComponent', VOID, VOID, [Component]);
initMetadataForClass(ProppingHostConnectorData, 'ProppingHostConnectorData');
initMetadataForCompanion(Companion_87);
initMetadataForClass(ProppingInfoComponent, 'ProppingInfoComponent', VOID, VOID, [Component]);
initMetadataForClass(PropHolderInfo, 'PropHolderInfo');
initMetadataForClass(ProppingSubSystem, 'ProppingSubSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_88);
initMetadataForClass(ProppingSystem, 'ProppingSystem', VOID, SystemBase2);
initMetadataForClass(sam$kotlin_Comparator$0_9, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_89);
initMetadataForClass(ProppingUtils, 'ProppingUtils', ProppingUtils);
initMetadataForClass(ProppingsAvailableForDemand, 'ProppingsAvailableForDemand');
initMetadataForCompanion(Companion_90);
initMetadataForClass(SetPropHolderInfoSystem, 'SetPropHolderInfoSystem', SetPropHolderInfoSystem, SystemBase);
initMetadataForCompanion(Companion_91);
initMetadataForClass(SetProppingHostConnectorDataSystem, 'SetProppingHostConnectorDataSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_92);
initMetadataForClass(CommunicationSizeComponent, 'CommunicationSizeComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_93);
initMetadataForClass(DoorComponent, 'DoorComponent', DoorComponent, VOID, [Component]);
initMetadataForObject(DoorFrontComponent_0, 'DoorFrontComponent', VOID, VOID, [Component]);
initMetadataForObject(DrawerComponent_0, 'DrawerComponent', VOID, VOID, [Component]);
initMetadataForObject(FrameComponent_0, 'FrameComponent', VOID, VOID, [Component]);
initMetadataForObject(HandleComponent_0, 'HandleComponent', VOID, VOID, [Component]);
initMetadataForObject(IncludedHandleComponent_0, 'IncludedHandleComponent', VOID, VOID, [Component]);
initMetadataForObject(LegComponent_0, 'LegComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_94);
initMetadataForClass(LightComponent, 'LightComponent', VOID, VOID, [Component]);
function beforeDeserialize_0(json, catalogVersion, catalogVersions) {
  return json;
}
function beforeParsingComponents_0(serializableTree, catalogVersion, catalogVersions) {
}
function beforeBuildingEntities(serializableTree, catalogVersion, catalogVersions) {
}
function afterDeserializeComplete_0(root, catalogVersion, catalogVersions) {
}
initMetadataForInterface(SerializableCatalogInterceptor, 'SerializableCatalogInterceptor');
initMetadataForCompanion(Companion_95);
initMetadataForClass(ReplaceAssemblyPartUtils, 'ReplaceAssemblyPartUtils', ReplaceAssemblyPartUtils);
initMetadataForCompanion(Companion_96);
initMetadataForClass(ReplacePartResult, 'ReplacePartResult');
initMetadataForClass(ReplacePlacementResult, 'ReplacePlacementResult');
initMetadataForCompanion(Companion_97);
initMetadataForClass(ReplaceUtils, 'ReplaceUtils', ReplaceUtils);
initMetadataForCompanion(Companion_98);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RoomDimensionsComponent, 'RoomDimensionsComponent', VOID, VOID, [JsonSerializable, Component], VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForClass(RoomSurfaceWithNormal, 'RoomSurfaceWithNormal');
initMetadataForCompanion(Companion_99);
initMetadataForClass(RoomUtils, 'RoomUtils', RoomUtils);
initMetadataForClass(StandardSelectionService, 'StandardSelectionService');
initMetadataForCompanion(Companion_100);
initMetadataForClass(StandardSelectionSystem, 'StandardSelectionSystem', VOID, SystemBase4);
initMetadataForCompanion(Companion_101);
initMetadataForClass(GroupSelectionSystem, 'GroupSelectionSystem', VOID, SystemBase3);
initMetadataForCompanion(Companion_102);
initMetadataForClass(RemoveTrivialSelectionGroupsSystem, 'RemoveTrivialSelectionGroupsSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_103);
initMetadataForClass(SelectDraggedGroupSystem, 'SelectDraggedGroupSystem', VOID, SystemBase);
initMetadataForClass(sam$kotlin_Comparator$0_10, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_104);
initMetadataForClass(SelectionGroupUtils, 'SelectionGroupUtils', SelectionGroupUtils);
initMetadataForCompanion(Companion_105);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SelectionGroupsComponent, 'SelectionGroupsComponent', VOID, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForClass(SelectionGroup, 'SelectionGroup');
initMetadataForClass(SelectionGroupsComponentDeserializer, 'SelectionGroupsComponentDeserializer', SelectionGroupsComponentDeserializer, VOID, [ComponentDeserializer]);
initMetadataForClass(SelectionGroupsFeature, 'SelectionGroupsFeature');
initMetadataForCompanion(Companion_106);
initMetadataForClass(StlSystemIds, 'StlSystemIds', StlSystemIds);
initMetadataForCompanion(Companion_107);
initMetadataForClass(DragExtensions, 'DragExtensions', DragExtensions);
initMetadataForClass(TestRoomFeature, 'TestRoomFeature');
initMetadataForCompanion(Companion_108);
initMetadataForClass(TestRoomUtils, 'TestRoomUtils', TestRoomUtils);
initMetadataForCompanion(Companion_109);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RoomGeometryComponent, 'RoomGeometryComponent', VOID, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_110);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TestRoomPartIdComponent, 'TestRoomPartIdComponent', VOID, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_111);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomGeometryData, 'CoreRoomGeometryData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_112);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomSurface, 'CoreRoomSurface', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_113);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RoomSurfaceGeometry, 'RoomSurfaceGeometry', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_114);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomEdge, 'CoreRoomEdge', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_115);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomVertex, 'CoreRoomVertex', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_116);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomObstacle, 'CoreRoomObstacle', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_117);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CoreRoomBoundingBox, 'CoreRoomBoundingBox', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_118);
initMetadataForClass(AddRoomComponentsWhenLoadingSystem, 'AddRoomComponentsWhenLoadingSystem', VOID, SystemBase);
initMetadataForClass(RoomComponentDeserializer, 'RoomComponentDeserializer', RoomComponentDeserializer, VOID, [ComponentDeserializer]);
initMetadataForCompanion(Companion_119);
initMetadataForClass(RoomDimensionToGeometrySystem, 'RoomDimensionToGeometrySystem', VOID, SystemBase);
initMetadataForClass(RoomLoadingInterceptor, 'RoomLoadingInterceptor', RoomLoadingInterceptor, VOID, [DeserializationInterceptor]);
initMetadataForCompanion(Companion_120);
initMetadataForClass(RoomLoadingSystem$snapProductToRoomParts$snaps$1, VOID, VOID, SnapSettings);
initMetadataForClass(RoomLoadingSystem, 'RoomLoadingSystem', VOID, SystemBase);
initMetadataForObject(TestRoomBuildingUtils, 'TestRoomBuildingUtils');
initMetadataForCompanion(Companion_121);
initMetadataForClass(TestRoomGenerator, 'TestRoomGenerator', TestRoomGenerator);
initMetadataForCompanion(Companion_122);
initMetadataForClass(TestRoomRelationsUtils, 'TestRoomRelationsUtils', TestRoomRelationsUtils);
initMetadataForClass(AllowedNumberOfChildrenOfTypeValidation, 'AllowedNumberOfChildrenOfTypeValidation', VOID, ValidationImpl);
initMetadataForCompanion(Companion_123);
initMetadataForClass(DisallowSeparateRequiredHostsValidation, 'DisallowSeparateRequiredHostsValidation', VOID, ValidationImpl);
initMetadataForCompanion(Companion_124);
initMetadataForClass(InvalidNumberOfChildren, 'InvalidNumberOfChildren', VOID, ValidationResult);
initMetadataForCompanion(Companion_125);
initMetadataForClass(PlacementZoneValidation, 'PlacementZoneValidation', PlacementZoneValidation, ValidationImpl);
initMetadataForClass(PlacementZoneWarning, 'PlacementZoneWarning', VOID, ValidationResult);
initMetadataForCompanion(Companion_126);
initMetadataForClass(RequiredConnectorsSatisfiedValidation, 'RequiredConnectorsSatisfiedValidation', RequiredConnectorsSatisfiedValidation, ValidationImpl);
initMetadataForCompanion(Companion_127);
initMetadataForClass(RequiredConnectorsValidationResult, 'RequiredConnectorsValidationResult', VOID, ValidationResult);
initMetadataForCompanion(Companion_128);
initMetadataForClass(ValidationResultIds, 'ValidationResultIds', ValidationResultIds);
initMetadataForCompanion(Companion_129);
initMetadataForClass(ValidationRuleIds, 'ValidationRuleIds', ValidationRuleIds);
initMetadataForClass(CoreVisualization, 'CoreVisualization');
initMetadataForClass(VisualizationState, 'VisualizationState', VisualizationState);
initMetadataForCompanion(Companion_130);
initMetadataForClass(ColliderVisualizationConfigComponent, 'ColliderVisualizationConfigComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_131);
initMetadataForClass(ColliderVisualizationNodeComponent, 'ColliderVisualizationNodeComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_132);
initMetadataForClass(ColliderVisualizerViewerObjectsComponent, 'ColliderVisualizerViewerObjectsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_133);
initMetadataForClass(ConnectorVisualizationConfigComponent, 'ConnectorVisualizationConfigComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_134);
initMetadataForClass(ConnectorVisualizationNodeComponent, 'ConnectorVisualizationNodeComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_135);
initMetadataForClass(ConnectorVisualizerViewerObjectsComponent, 'ConnectorVisualizerViewerObjectsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_136);
initMetadataForClass(DecoratorComponent, 'DecoratorComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_137);
initMetadataForClass(EntityColliderVisualizationComponent, 'EntityColliderVisualizationComponent', EntityColliderVisualizationComponent, VOID, [Component]);
initMetadataForCompanion(Companion_138);
initMetadataForClass(EntityConnectorVisualizationComponent, 'EntityConnectorVisualizationComponent', EntityConnectorVisualizationComponent, VOID, [Component]);
initMetadataForInterface(ConnectorVisualizationData, 'ConnectorVisualizationData');
initMetadataForCompanion(Companion_139);
initMetadataForClass(PolyhedronVisualizationNodeComponent, 'PolyhedronVisualizationNodeComponent', PolyhedronVisualizationNodeComponent, VOID, [Component]);
initMetadataForCompanion(Companion_140);
initMetadataForClass(VisualizationEntityComponent, 'VisualizationEntityComponent', VisualizationEntityComponent, VOID, [Component]);
initMetadataForCompanion(Companion_141);
initMetadataForClass(PolyhedronVisualizationSystem, 'PolyhedronVisualizationSystem', VOID, SystemBase3);
initMetadataForClass(AutoAdaptHostZoneVisualizationSystem, 'AutoAdaptHostZoneVisualizationSystem', VOID, PolyhedronVisualizationSystem);
initMetadataForCompanion(Companion_142);
initMetadataForClass(DragProjectionPointVisualizationSystem, 'DragProjectionPointVisualizationSystem', VOID, PolyhedronVisualizationSystem);
initMetadataForCompanion(Companion_143);
initMetadataForClass(FunctionalMarginVisualizationSystem, 'FunctionalMarginVisualizationSystem', VOID, PolyhedronVisualizationSystem);
initMetadataForCompanion(Companion_144);
initMetadataForClass(FunctionalZoneVisualizationSystem, 'FunctionalZoneVisualizationSystem', VOID, PolyhedronVisualizationSystem);
initMetadataForCompanion(Companion_145);
initMetadataForClass(PolyhedronVisualizationHolderComponent, 'PolyhedronVisualizationHolderComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_146);
initMetadataForClass(ForcedComponentBaseSystem, 'ForcedComponentBaseSystem', VOID, SystemBase4);
initMetadataForClass(ColliderVisualizationSystem, 'ColliderVisualizationSystem', VOID, ForcedComponentBaseSystem);
initMetadataForClass(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1, VOID, VOID, VOID, [ConnectorVisualizationData]);
initMetadataForCompanion(Companion_147);
initMetadataForClass(ConnectorVisualizationSystem, 'ConnectorVisualizationSystem', VOID, ForcedComponentBaseSystem);
initMetadataForCompanion(Companion_148);
initMetadataForClass(EntityColliderVisualizationSystem, 'EntityColliderVisualizationSystem', VOID, SystemBase5);
initMetadataForCompanion(Companion_149);
initMetadataForClass(CollisionVisualizationSceneDataComponent, 'CollisionVisualizationSceneDataComponent', VOID, VOID, [Component]);
initMetadataForClass(CollisionVisualizationSceneData, 'CollisionVisualizationSceneData', CollisionVisualizationSceneData);
initMetadataForCompanion(Companion_150);
initMetadataForClass(EntityCollisionVisualizationSystem, 'EntityCollisionVisualizationSystem', VOID, SystemBase3);
initMetadataForCompanion(Companion_151);
initMetadataForClass(EntityConnectorVisualizationSystem, 'EntityConnectorVisualizationSystem', VOID, SystemBase5);
function createColliderVisualization(entity, polyhedron, color, collides, collisionData, $super) {
  color = color === VOID ? null : color;
  collides = collides === VOID ? false : collides;
  collisionData = collisionData === VOID ? null : collisionData;
  return this.u5b(entity, polyhedron, color, collides, collisionData);
}
initMetadataForInterface(ColliderVisualizer, 'ColliderVisualizer');
initMetadataForClass(CollisionVisualizationData, 'CollisionVisualizationData');
initMetadataForClass(Color, 'Color');
initMetadataForInterface(ConnectorVisualizer, 'ConnectorVisualizer');
initMetadataForCompanion(Companion_152);
initMetadataForClass(DefaultVisualizer, 'DefaultVisualizer', VOID, VOID, [ConnectorVisualizer, ColliderVisualizer]);
initMetadataForCompanion(Companion_153);
initMetadataForClass(CoreDebug, 'CoreDebug');
initMetadataForClass(SortedValidationResult, 'SortedValidationResult');
//endregion
function childConnectionAdded($this, entity, component) {
  handlePositionChange($this, entity);
}
function childConnectionRemoved($this, entity, component) {
  handlePositionChange($this, entity);
}
function childConnectionUpdated($this, entity, oldComponent, component) {
  handlePositionChange($this, entity);
}
function handlePositionChange($this, entity) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = getHierarchyWithComponent(entity, Companion_getInstance().id);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.handlePositionChange.<anonymous>' call
    updateAlignment($this, element);
  }
}
function updateAlignment($this, entity) {
  var oldAlignments = getOldAlignmentConnections($this, entity);
  var newAlignments = Companion_instance.i29(entity, $this.r3n_1.sceneManager.entities);
  var tmp0_safe_receiver = get_connectionRootEntity(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    set_alignmentConnections(tmp0_safe_receiver, newAlignments);
  }
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = oldAlignments.concat(newAlignments);
  updateRelativeAlignments($this, tmp$ret$1);
}
function getOldAlignmentConnections($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_43().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.getOldAlignmentConnections.<anonymous>' call
      if (!element.offeringEntity.isDisposed && !element.demandingEntity.isDisposed) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_1 = [];
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  return tmp_1;
}
function updateRelativeAlignments($this, connections) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = connections.length;
  while (inductionVariable < last) {
    var element = connections[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateRelativeAlignments.<anonymous>' call
    var tmp;
    if (belongsToSameEntityGroup($this, element)) {
      tmp = null;
    } else {
      tmp = get_connectionRootEntity(element.offeringEntity);
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var tmp0_iterator = distinct(destination).k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateRelativeAlignments.<anonymous>' call
    set_alignmentConnections(element_0, Companion_instance.i29(element_0, $this.r3n_1.sceneManager.entities));
  }
}
function belongsToSameEntityGroup($this, it) {
  var tmp;
  var tmp0_safe_receiver = get_parent(it.offeringEntity);
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_getInstance_0().id)) === true) {
    tmp = equals(get_parent(it.offeringEntity), get_parent(it.demandingEntity));
  } else {
    tmp = false;
  }
  return tmp;
}
function Companion() {
  this.ID = 'AlignmentConnectionCreationSystem';
}
protoOf(Companion).j1y = function () {
  return this.ID;
};
var Companion_instance_38;
function Companion_getInstance_42() {
  return Companion_instance_38;
}
function AlignmentConnectionCreationSystem(coreServices) {
  var tmp = Companion_instance_38.ID;
  var tmp_0 = Companion_instance_0.v1q_1;
  var tmp_1 = Companion_instance_0.q1p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [Companion_getInstance_43().id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_getInstance_1().j2a_1];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp$ret$5, null);
  this.r3n_1 = coreServices;
  this.s3n_1 = false;
}
protoOf(AlignmentConnectionCreationSystem).enable = function () {
  protoOf(SystemBase2).enable.call(this);
  this.s3n_1 = false;
};
protoOf(AlignmentConnectionCreationSystem).refreshAlignments = function (entities) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_2().id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>' call
    var tmp0_safe_receiver = element_0.__getComponentForKotlin(Companion_getInstance_3().id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>.<anonymous>' call
      childConnectionAdded(this, element_0, tmp0_safe_receiver);
    }
  }
};
protoOf(AlignmentConnectionCreationSystem).t3n = function (entity, newComponent) {
  this.s3n_1 = true;
};
protoOf(AlignmentConnectionCreationSystem).l1z = function (entity, newComponent) {
  return this.t3n(entity, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentConnectionCreationSystem).u3n = function (entity, oldComponent, newComponent) {
};
protoOf(AlignmentConnectionCreationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE();
  return this.u3n(entity, tmp, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentConnectionCreationSystem).v3n = function (entity, oldComponent) {
  this.s3n_1 = false;
  this.refreshAlignments(this.r3n_1.sceneManager.entities);
};
protoOf(AlignmentConnectionCreationSystem).p1z = function (entity, oldComponent) {
  return this.v3n(entity, oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE());
};
protoOf(AlignmentConnectionCreationSystem).l2a = function (entity, newComponent) {
  if (!this.s3n_1) {
    childConnectionAdded(this, entity, newComponent);
  }
};
protoOf(AlignmentConnectionCreationSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentConnectionCreationSystem).m2a = function (entity, oldComponent, newComponent) {
  if (!this.s3n_1) {
    childConnectionUpdated(this, entity, oldComponent, newComponent);
  }
};
protoOf(AlignmentConnectionCreationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.m2a(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentConnectionCreationSystem).n2a = function (entity, oldComponent) {
  if (!this.s3n_1) {
    childConnectionRemoved(this, entity, oldComponent);
  }
};
protoOf(AlignmentConnectionCreationSystem).z1v = function (entity, oldComponent) {
  return this.n2a(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
function Companion_0() {
  Companion_instance_39 = this;
  this.id = Companion_instance_0.u1o_1;
}
protoOf(Companion_0).n1s = function () {
  return this.id;
};
var Companion_instance_39;
function Companion_getInstance_43() {
  if (Companion_instance_39 == null)
    new Companion_0();
  return Companion_instance_39;
}
function AlignmentConnectionsComponent$lambda(it) {
  return it.demandingEntity.id;
}
function AlignmentConnectionsComponent$lambda_0(it) {
  return it.offeringEntity.id;
}
function AlignmentConnectionsComponent$lambda_1(it) {
  return it.demandingConnector.key;
}
function AlignmentConnectionsComponent$lambda_2(it) {
  return it.offeringConnector.key;
}
function AlignmentConnectionsComponent$toString$lambda(it) {
  return it.toString();
}
function AlignmentConnectionsComponent(connections) {
  Companion_getInstance_43();
  var tmp;
  if (connections === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = connections;
  }
  connections = tmp;
  this.connections = connections;
  var tmp_0 = AlignmentConnectionsComponent$lambda;
  var tmp_1 = AlignmentConnectionsComponent$lambda_0;
  var tmp_2 = AlignmentConnectionsComponent$lambda_1;
  sortWith(this.connections, compareBy([tmp_0, tmp_1, tmp_2, AlignmentConnectionsComponent$lambda_2]));
}
protoOf(AlignmentConnectionsComponent).o29 = function () {
  return this.connections;
};
protoOf(AlignmentConnectionsComponent).p1s = function () {
  return Companion_getInstance_43().id;
};
protoOf(AlignmentConnectionsComponent).toString = function () {
  return 'AlignmentConnectionsComponent[' + joinToString(this.connections, ';', VOID, VOID, VOID, VOID, AlignmentConnectionsComponent$toString$lambda) + ']';
};
protoOf(AlignmentConnectionsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AlignmentConnectionsComponent))
    THROW_CCE();
  if (!contentEquals(this.connections, other.connections))
    return false;
  return true;
};
protoOf(AlignmentConnectionsComponent).hashCode = function () {
  return contentHashCode(this.connections);
};
protoOf(AlignmentConnectionsComponent).eq = function (other) {
  var otherAlignmentConnectionsComponent = other instanceof AlignmentConnectionsComponent ? other : THROW_CCE();
  return contentEquals(this.connections, otherAlignmentConnectionsComponent.connections);
};
function set_alignmentConnections(_this__u8e3s4, value) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (value.length === 0)
    _this__u8e3s4.removeComponent(Companion_getInstance_43().id);
  else {
    _this__u8e3s4.addComponent(new AlignmentConnectionsComponent(value));
  }
}
function AlignmentPlane(planeNormal, planePoint, activationDistance) {
  activationDistance = activationDistance === VOID ? 1.7976931348623157E308 : activationDistance;
  this.planeNormal = planeNormal;
  this.planePoint = planePoint;
  this.activationDistance = activationDistance;
}
protoOf(AlignmentPlane).a2j = function () {
  return this.planeNormal;
};
protoOf(AlignmentPlane).z2i = function () {
  return this.planePoint;
};
protoOf(AlignmentPlane).h2b = function () {
  return this.activationDistance;
};
protoOf(AlignmentPlane).projectPointOnPlane = function (point) {
  return point.projectOnPlane(this.planeNormal, this.planePoint);
};
protoOf(AlignmentPlane).tf = function () {
  return this.planeNormal;
};
protoOf(AlignmentPlane).uf = function () {
  return this.planePoint;
};
protoOf(AlignmentPlane).m1m = function () {
  return this.activationDistance;
};
protoOf(AlignmentPlane).w3n = function (planeNormal, planePoint, activationDistance) {
  return new AlignmentPlane(planeNormal, planePoint, activationDistance);
};
protoOf(AlignmentPlane).copy = function (planeNormal, planePoint, activationDistance, $super) {
  planeNormal = planeNormal === VOID ? this.planeNormal : planeNormal;
  planePoint = planePoint === VOID ? this.planePoint : planePoint;
  activationDistance = activationDistance === VOID ? this.activationDistance : activationDistance;
  return this.w3n(planeNormal, planePoint, activationDistance);
};
protoOf(AlignmentPlane).toString = function () {
  return 'AlignmentPlane(planeNormal=' + this.planeNormal.toString() + ', planePoint=' + this.planePoint.toString() + ', activationDistance=' + this.activationDistance + ')';
};
protoOf(AlignmentPlane).hashCode = function () {
  var result = this.planeNormal.hashCode();
  result = imul(result, 31) + this.planePoint.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.activationDistance) | 0;
  return result;
};
protoOf(AlignmentPlane).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlignmentPlane))
    return false;
  var tmp0_other_with_cast = other instanceof AlignmentPlane ? other : THROW_CCE();
  if (!this.planeNormal.equals(tmp0_other_with_cast.planeNormal))
    return false;
  if (!this.planePoint.equals(tmp0_other_with_cast.planePoint))
    return false;
  if (!equals(this.activationDistance, tmp0_other_with_cast.activationDistance))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_40 = this;
  this.ID = 'HandleRotationSystem';
  this.x3n_1 = LoggerState_getInstance().g1v(this.ID);
}
protoOf(Companion_1).j1y = function () {
  return this.ID;
};
var Companion_instance_40;
function Companion_getInstance_44() {
  if (Companion_instance_40 == null)
    new Companion_1();
  return Companion_instance_40;
}
function onMoveToValidSnapPosition($this, entity, new_0) {
  checkAndCorrectRotation($this, entity);
}
function checkAndCorrectRotation($this, entity) {
  var isDoorOrHandle = entity.hasComponent(HandleComponent_getInstance().id) || entity.hasComponent(Companion_getInstance_136().id) || entity.hasComponent(DoorFrontComponent_getInstance().id);
  if (!isDoorOrHandle) {
    return Unit_instance;
  }
  var tmp;
  if (entity.hasComponent(HandleComponent_getInstance().id)) {
    tmp = listOf(entity);
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_descendants(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.checkAndCorrectRotation.<anonymous>' call
      if (element.hasComponent(HandleComponent_getInstance().id)) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  var handles = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = handles.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.checkAndCorrectRotation.<anonymous>' call
    if (!isUnderAlignment($this, element_0)) {
      findAndApplyPossibleAlignment($this, element_0);
    }
  }
}
function findAndApplyPossibleAlignment($this, entity) {
  markAsUnderAlignment($this, entity);
  validateAndReSnap($this, entity);
  unmarkAsUnderAlignment($this, entity);
}
function validateAndReSnap($this, entity) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp1_elvis_lhs = get_parent(tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var parent = tmp;
  var tmp2_safe_receiver = get_highestPriorityConnection(entity);
  var currentConnector = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnector;
  var possibleSnap = findValidSnapCandidate($this, entity, parent);
  if (!(possibleSnap == null) && !equals(currentConnector, possibleSnap.hostConnector)) {
    possibleSnap.performMoveAndConnect();
  } else if (possibleSnap == null) {
    var tmp_0 = Companion_getInstance_44().x3n_1;
    tmp_0.debug(HandleRotationSystem$validateAndReSnap$lambda(entity));
  }
}
function findValidSnapCandidate($this, entity, parent) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var snappingGuestEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList(Companion_getInstance_4().s35_1.sortAndSelect(Companion_instance_1.getMatchingSnaps$default(snappingGuestEntity, parent)));
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HandleRotationSystem$findValidSnapCandidate$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
  var matchingSnaps = sortedWith(this_0, tmp$ret$0);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$2 = copyToArray(matchingSnaps);
  var validationResults = $this.h3o_1.getFirstValidSnap(tmp$ret$2);
  return validationResults.snap;
}
function isUnderAlignment($this, entity) {
  return entity.hasComponent(HandleUnderAlignmentComponent_getInstance().k3o_1);
}
function markAsUnderAlignment($this, entity) {
  entity.addComponentInternal(HandleUnderAlignmentComponent_getInstance());
}
function unmarkAsUnderAlignment($this, entity) {
  entity.removeComponentInternal(HandleUnderAlignmentComponent_getInstance().k3o_1);
}
function HandleUnderAlignmentComponent() {
  HandleUnderAlignmentComponent_instance = this;
  this.k3o_1 = this.n1s();
}
protoOf(HandleUnderAlignmentComponent).p1s = function () {
  return this.k3o_1;
};
protoOf(HandleUnderAlignmentComponent).n1s = function () {
  return Companion_instance_0.v1o_1;
};
protoOf(HandleUnderAlignmentComponent).eq = function (other) {
  return true;
};
var HandleUnderAlignmentComponent_instance;
function HandleUnderAlignmentComponent_getInstance() {
  if (HandleUnderAlignmentComponent_instance == null)
    new HandleUnderAlignmentComponent();
  return HandleUnderAlignmentComponent_instance;
}
function sam$kotlin_Comparator$0(function_0) {
  this.l3o_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.l3o_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.l3o_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function HandleRotationSystem$validateAndReSnap$lambda($entity) {
  return function () {
    return 'No valid snap found when trying to ensure correct rotation of entity ' + $entity.id + ' ' + $entity.toString();
  };
}
function HandleRotationSystem$findValidSnapCandidate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.findValidSnapCandidate.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.findValidSnapCandidate.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function HandleRotationSystem(validationService, sceneManager) {
  Companion_getInstance_44();
  SystemBase.call(this, Companion_getInstance_44().ID, Companion_instance_0.o1o_1);
  this.h3o_1 = validationService;
  this.i3o_1 = sceneManager;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.j3o_1 = [Companion_instance_0.v1o_1];
}
protoOf(HandleRotationSystem).m3o = function (entity, newComponent) {
  onMoveToValidSnapPosition(this, entity, newComponent);
};
protoOf(HandleRotationSystem).v1v = function (entity, newComponent) {
  return this.m3o(entity, newComponent instanceof MovedToValidSnapPositionComponent ? newComponent : THROW_CCE());
};
protoOf(HandleRotationSystem).n3o = function (entity, oldComponent, newComponent) {
};
protoOf(HandleRotationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE();
  return this.n3o(entity, tmp, newComponent instanceof MovedToValidSnapPositionComponent ? newComponent : THROW_CCE());
};
protoOf(HandleRotationSystem).z2p = function (entity, oldComponent) {
};
protoOf(HandleRotationSystem).z1v = function (entity, oldComponent) {
  return this.z2p(entity, oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE());
};
protoOf(HandleRotationSystem).j1w = function () {
  return this.j3o_1;
};
function validateWithParent($this, guestConnector, hostEntity, hostConnector) {
  var tmp;
  if (guestConnector.hasTag(ConnectorTagConstants_instance.w2b_1)) {
    var tmp_0;
    if (hostConnector.isRotatedUpward(hostEntity)) {
      tmp_0 = null;
    } else {
      tmp_0 = Companion_instance_2.fail('Guest connector requires a host connector that is rotated upwards.');
    }
    tmp = tmp_0;
  } else if (guestConnector.hasTag(ConnectorTagConstants_instance.x2b_1)) {
    var tmp_1;
    if (!hostConnector.isRotatedUpward(hostEntity)) {
      tmp_1 = null;
    } else {
      tmp_1 = Companion_instance_2.fail('Guest connector requires a host connector that is not rotated upwards.');
    }
    tmp = tmp_1;
  } else {
    tmp = null;
  }
  return tmp;
}
function HostConnectorRotationValidation() {
  ValidationImpl.call(this);
  this.p3o_1 = 'HostConnectorRotationValidation';
}
protoOf(HostConnectorRotationValidation).n1s = function () {
  return this.p3o_1;
};
protoOf(HostConnectorRotationValidation).validateCurrentState = function (entity) {
  return null;
};
protoOf(HostConnectorRotationValidation).validateSnap = function (snap) {
  return validateWithParent(this, snap.guestConnector, snap.host, snap.hostConnector);
};
function getCloseKey($this, key) {
  return getCloseKeyFromSet(key, $this.r3o_1.g2(), $this.q3o_1);
}
function getCloseConnectorKey($this, key) {
  return getCloseKeyFromSet(key, $this.s3o_1.g2(), $this.q3o_1);
}
function AlignmentLinesReferenceCounter(epsilon) {
  epsilon = epsilon === VOID ? 1.0 : epsilon;
  this.q3o_1 = epsilon;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.r3o_1 = LinkedHashMap_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.s3o_1 = LinkedHashMap_init_$Create$();
}
protoOf(AlignmentLinesReferenceCounter).t3o = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.s3o_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesReferenceCounter.<get-generatedAlignmentConnectorKeys>.<anonymous>' call
    var tmp$ret$1 = item.c2().key;
    destination.h(tmp$ret$1);
  }
  return destination;
};
protoOf(AlignmentLinesReferenceCounter).u3o = function (key) {
  var usedKey = getCloseKey(this, key);
  var current = this.r3o_1.f2(usedKey);
  if (current == null || current === 0) {
    // Inline function 'kotlin.collections.set' call
    this.r3o_1.q2(usedKey, 1);
    return true;
  }
  // Inline function 'kotlin.collections.set' call
  var this_0 = this.r3o_1;
  var value = current + 1 | 0;
  this_0.q2(usedKey, value);
  return false;
};
protoOf(AlignmentLinesReferenceCounter).v3o = function (key) {
  var usedKey = getCloseKey(this, key);
  var tmp0_elvis_lhs = this.r3o_1.f2(usedKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw Exception_init_$Create$('Tried to remove reference count at ' + key + ' where none existed  Sender: ' + this.toString());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var current = tmp;
  current = current - 1 | 0;
  if (current === 0)
    this.r3o_1.r2(usedKey);
  else {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.r3o_1;
    var value = current;
    this_0.q2(usedKey, value);
  }
  if (current === 0)
    return true;
  return false;
};
protoOf(AlignmentLinesReferenceCounter).w3o = function (connector, key) {
  var usedKey = getCloseKey(this, key);
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var this_0 = this.s3o_1;
  if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).d2(usedKey))
    throw Exception_init_$Create$('Cannot add several connectors to the same position, already has one at ' + key + ' Sender: ' + this.toString());
  // Inline function 'kotlin.collections.set' call
  this.s3o_1.q2(usedKey, connector);
};
protoOf(AlignmentLinesReferenceCounter).x3o = function (key) {
  var usedKey = getCloseConnectorKey(this, key);
  this.s3o_1.r2(usedKey);
};
protoOf(AlignmentLinesReferenceCounter).y3o = function (key) {
  var usedKey = getCloseConnectorKey(this, key);
  var tmp0_elvis_lhs = this.s3o_1.f2(usedKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw Exception_init_$Create$('No connector exists at ' + key + ' Sender: ' + this.toString());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(AlignmentLinesReferenceCounter).toString = function () {
  var str = '';
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this.r3o_1.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesReferenceCounter.toString.<anonymous>' call
    str = str + ('At: ' + element.b2() + ' has ' + element.c2() + ' entries\n');
  }
  return str;
};
function Companion_2() {
  this.ID = 'AlignmentLinesSystem';
}
protoOf(Companion_2).j1y = function () {
  return this.ID;
};
var Companion_instance_41;
function Companion_getInstance_45() {
  return Companion_instance_41;
}
function clearAlignmentEdgesFeature($this) {
  var tmp0_safe_receiver = $this.w3p_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c3q();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>' call
    var tmp0_safe_receiver_0 = $this.t3p_1;
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : get_allRoomParts(tmp0_safe_receiver_0);
    var tmp;
    if (tmp1_safe_receiver_0 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver_0.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_1 = element.__getComponentForKotlin(Companion_getInstance_5().id);
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var this_0 = tmp0_safe_receiver_1.connectors;
          var destination = ArrayList_init_$Create$();
          var inductionVariable_0 = 0;
          var last_0 = this_0.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = this_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            if (!tmp1_safe_receiver.s(element_0.key)) {
              destination.h(element_0);
            }
          }
          var connectorsToKeep = destination;
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$3 = copyToArray(connectorsToKeep);
          var newConnectorsComponent = new ConnectorsComponent(tmp$ret$3);
          element.addComponent(newConnectorsComponent);
        }
      }
      tmp = Unit_instance;
    }
  }
}
function initializeAlignmentEdgesFeature($this) {
  $this.w3p_1 = null;
  var tmp0_safe_receiver = $this.t3p_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = filterInHierarchy(tmp0_safe_receiver, AlignmentLinesSystem$initializeAlignmentEdgesFeature$lambda);
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>' call
      var tmp0_safe_receiver_0 = get_connectorsComponent(element);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.connectors;
      var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : toList(tmp1_safe_receiver_0);
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
        var tmp0_iterator = tmp2_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var item = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new EntityWithConnector(element, item);
          destination_0.h(tmp$ret$0);
        }
        tmp_1 = destination_0;
      }
      var tmp3_elvis_lhs = tmp_1;
      var list = tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs;
      addAll(destination, list);
    }
    tmp_0 = destination;
  }
  var tmp2_safe_receiver_0 = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver_0 == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = tmp2_safe_receiver_0.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>' call
      var connector = element_0.uf();
      var tmp_3;
      // Inline function 'kotlin.collections.isEmpty' call
      if ($this.u3p_1.length === 0) {
        tmp_3 = true;
      } else {
        tmp_3 = contains($this.u3p_1, connector.key);
      }
      if (tmp_3) {
        destination_1.h(element_0);
      }
    }
    tmp_2 = destination_1;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_4;
  if (tmp3_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = tmp3_safe_receiver.k();
    while (tmp0_iterator_1.m()) {
      var element_1 = tmp0_iterator_1.n();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>' call
      var entity = element_1.tf();
      var connector_0 = element_1.uf();
      var tmp_5;
      if (connector_0 instanceof SurfaceConnector) {
        tmp_5 = new SurfaceConnectorWithEntity(entity, connector_0);
      } else {
        tmp_5 = null;
      }
      var tmp0_safe_receiver_1 = tmp_5;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_2.h(tmp0_safe_receiver_1);
      }
    }
    tmp_4 = destination_2;
  }
  var tmp4_safe_receiver = tmp_4;
  var tmp_6;
  if (tmp4_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_safe_receiver, 10));
    var tmp0_iterator_2 = tmp4_safe_receiver.k();
    while (tmp0_iterator_2.m()) {
      var item_0 = tmp0_iterator_2.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>' call
      var ownerEntity = item_0.tf();
      var surfaceConnector = item_0.uf();
      var tmp$ret$14 = new SurfaceAlignmentLines(surfaceConnector, ownerEntity, $this.p3p_1, $this.o3p_1, $this.s3p_1);
      destination_3.h(tmp$ret$14);
    }
    tmp_6 = destination_3;
  }
  var tmp5_safe_receiver = tmp_6;
  var tmp_7;
  if (tmp5_safe_receiver == null) {
    tmp_7 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_7 = copyToArray(tmp5_safe_receiver);
  }
  var tmp6_elvis_lhs = tmp_7;
  var tmp_8;
  if (tmp6_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_8 = [];
  } else {
    tmp_8 = tmp6_elvis_lhs;
  }
  var roomSurfaceConnectors = tmp_8;
  if (!any(roomSurfaceConnectors))
    return Unit_instance;
  var tmp7_safe_receiver = $this.t3p_1;
  if (tmp7_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var newAlignments = new RoomAlignmentEdgesComponent($this.o3p_1, $this.p3p_1, $this.q3p_1, $this.r3p_1, roomSurfaceConnectors);
    tmp7_safe_receiver.addComponent(newAlignments);
    $this.w3p_1 = newAlignments;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = getHierarchyWithComponent(tmp7_safe_receiver, $this.n3p_1);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_2 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = get_guestConnections(element_2);
      var inductionVariable_1 = 0;
      var last_1 = indexedObject_0.length;
      while (inductionVariable_1 < last_1) {
        var element_3 = indexedObject_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>.<anonymous>.<anonymous>' call
        var surfaceConnector_0 = getSurfaceConnector($this, element_3);
        if (surfaceConnector_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          addRoomAlignmentsForAlignmentEntity($this, element_2, surfaceConnector_0);
        }
      }
    }
  }
}
function onAddConnection($this, entity, newConnection) {
  var tmp0_safe_receiver = getSurfaceConnector($this, newConnection);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    addRoomAlignmentsForAlignmentEntity($this, entity, tmp0_safe_receiver);
  }
}
function isPartOfDraggedHierarchy($this, entity) {
  return $this.z3p_1.s(entity);
}
function onRemoveConnection($this, entity, oldConnection) {
  var tmp0_safe_receiver = getSurfaceConnector($this, oldConnection);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    removeRoomAlignmentsForAlignmentEntity($this, entity, tmp0_safe_receiver, oldConnection);
  }
}
function onStartedDragging($this, entity) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var draggedEntity = tmp;
  var tmp_0 = Companion_instance_3;
  tmp_0.d2r(draggedEntity, AlignmentLinesSystem$onStartedDragging$lambda($this));
  $this.y3p_1 = draggedEntity;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = getHierarchyWithComponent(draggedEntity, Companion_getInstance().id);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onStartedDragging.<anonymous>' call
    if (!element.hasComponent(Companion_instance_4.n1s())) {
      destination.h(element);
    }
  }
  $this.z3p_1.p(destination);
  $this.a3q_1 = get_worldTransform(draggedEntity);
}
function onStoppedDragging($this, entity) {
  var tmp0_elvis_lhs = $this.y3p_1;
  var draggedEntity = tmp0_elvis_lhs == null ? get_snapRoot(entity) : tmp0_elvis_lhs;
  var tmp;
  if (draggedEntity == null) {
    tmp = true;
  } else {
    var tmp1_safe_receiver = $this.a3q_1;
    tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.equals(get_worldTransform(draggedEntity))) === true;
  }
  if (tmp) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = $this.z3p_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onStoppedDragging.<anonymous>' call
      var tmp0_safe_receiver = element.__getComponentForKotlin(Companion_getInstance_3().id);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $this.l2a(element, tmp0_safe_receiver);
      }
    }
  }
  clearDragged($this);
}
function clearDragged($this) {
  $this.a3q_1 = null;
  $this.y3p_1 = null;
  $this.z3p_1.m2();
}
function isApplicableGuestEntity($this, entity) {
  var tmp1_elvis_lhs = entity == null ? null : entity.hasComponent($this.n3p_1);
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function getSurfaceConnector($this, connection) {
  if (get_isRoomPart(connection.hostConnectorEntity)) {
    var tmp;
    if (connection.hostConnector instanceof SurfaceConnector) {
      var sc = connection.hostConnector;
      if (!(sc instanceof SurfaceConnector))
        THROW_CCE();
      tmp = new SurfaceConnectorWithEntity(connection.hostConnectorEntity, sc);
    } else {
      tmp = null;
    }
    return tmp;
  }
  return null;
}
function addRoomAlignmentsForAlignmentEntity($this, entity, wallConnector) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var addedConnectors = ArrayList_init_$Create$();
  var tmp0_safe_receiver = $this.t3p_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>' call
    var tmp0_safe_receiver_0 = $this.w3p_1;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.verticalAlignmentKeys;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
        Companion_getInstance_46().g3q(tmp0_safe_receiver, wallConnector, entity, element, addedConnectors);
      }
    }
    var tmp2_safe_receiver = $this.w3p_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.horizontalAlignmentKeys;
    var tmp;
    if (tmp3_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp3_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp3_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
        Companion_getInstance_46().h3q(tmp0_safe_receiver, wallConnector, entity, element_0, addedConnectors);
      }
      tmp = Unit_instance;
    }
  }
  if (addedConnectors.r())
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$();
  var tmp0_iterator = addedConnectors.k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>' call
    var key = element_1.d3q_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.f2(key);
    var tmp_0;
    if (value == null) {
      // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
      var answer = ArrayList_init_$Create$();
      destination.q2(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.h(element_1);
  }
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = destination.i2().k();
  while (tmp0_iterator_0.m()) {
    var element_2 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var ownerEntity = element_2.b2();
    // Inline function 'kotlin.collections.component2' call
    var connectors = element_2.c2();
    var tmp0_elvis_lhs = get_connectorsComponent(ownerEntity);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$11 = [];
      tmp_1 = new ConnectorsComponent(tmp$ret$11);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var connectorsComponent = tmp_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(connectors, 10));
    var tmp0_iterator_1 = connectors.k();
    while (tmp0_iterator_1.m()) {
      var item = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
      var tmp$ret$12 = item.e3q_1;
      destination_0.h(tmp$ret$12);
    }
    var tmp$ret$15 = copyToArray(destination_0);
    ownerEntity.addComponent(connectorsComponent.plusConnectors(tmp$ret$15));
  }
}
function removeRoomAlignmentsForAlignmentEntity($this, entity, wallConnector, oldConnection) {
  var tmp;
  if (oldConnection.guestConnectorEntity.equals(entity)) {
    tmp = get_worldTransform(oldConnection.hostConnectorEntity).concatenate(oldConnection.hostGuestDeltaTransform);
  } else {
    tmp = get_worldTransform(oldConnection.hostConnectorEntity).concatenate(oldConnection.hostGuestDeltaTransform).concatenate(get_worldTransform(entity).delta(get_worldTransform(oldConnection.guestConnectorEntity)));
  }
  var oldTransform = tmp;
  // Inline function 'kotlin.collections.mutableListOf' call
  var removedConnectors = ArrayList_init_$Create$();
  var tmp1_safe_receiver = $this.t3p_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>' call
    var tmp0_safe_receiver = $this.w3p_1;
    var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.verticalAlignmentKeys;
    if (tmp1_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver_0.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
        Companion_getInstance_46().i3q(tmp1_safe_receiver, wallConnector, entity, element, removedConnectors, oldTransform);
      }
    }
    var tmp2_safe_receiver = $this.w3p_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.horizontalAlignmentKeys;
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp3_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp3_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
        Companion_getInstance_46().j3q(tmp1_safe_receiver, wallConnector, entity, element_0, removedConnectors, oldTransform);
      }
      tmp_0 = Unit_instance;
    }
  }
  if (!any_0(removedConnectors))
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$();
  var tmp0_iterator = removedConnectors.k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>' call
    var key = element_1.d3q_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.f2(key);
    var tmp_1;
    if (value == null) {
      // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
      var answer = ArrayList_init_$Create$();
      destination.q2(key, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list = tmp_1;
    list.h(element_1);
  }
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = destination.i2().k();
  while (tmp0_iterator_0.m()) {
    var element_2 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var ownerEntity = element_2.b2();
    // Inline function 'kotlin.collections.component2' call
    var connectors = element_2.c2();
    var tmp0_elvis_lhs = get_connectorsComponent(ownerEntity);
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$11 = [];
      tmp_2 = new ConnectorsComponent(tmp$ret$11);
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var connectorsComponent = tmp_2;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(connectors, 10));
    var tmp0_iterator_1 = connectors.k();
    while (tmp0_iterator_1.m()) {
      var item = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
      var tmp$ret$12 = item.e3q_1;
      destination_0.h(tmp$ret$12);
    }
    var tmp$ret$15 = copyToArray(destination_0);
    ownerEntity.addComponent(connectorsComponent.minusConnectors(tmp$ret$15));
  }
}
function onRoomRebuild($this, room) {
  $this.t3p_1 = room;
  if ($this.v3p_1)
    return Unit_instance;
  initializeAlignmentEdgesFeature($this);
}
function AlignmentLinesSystem$enable$lambda(it) {
  return it.hasComponent(Companion_getInstance_152().id);
}
function AlignmentLinesSystem$initializeAlignmentEdgesFeature$lambda(it) {
  return get_isRoomPart(it);
}
function AlignmentLinesSystem$onStartedDragging$lambda(this$0) {
  return function (hierarchyMember) {
    var tmp0_safe_receiver = hierarchyMember.__getComponentForKotlin(Companion_getInstance_3().id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.n2a(hierarchyMember, tmp0_safe_receiver);
    }
    return Unit_instance;
  };
}
function AlignmentLinesSystem(coreServices, tagComponentId, activationDistance, priority, horizontalAlignmentKeys, verticalAlignmentKeys, offeredTags) {
  activationDistance = activationDistance === VOID ? 100.0 : activationDistance;
  priority = priority === VOID ? 5 : priority;
  var tmp;
  if (horizontalAlignmentKeys === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ['line-align-bottom-left', 'line-align-top-right'];
  } else {
    tmp = horizontalAlignmentKeys;
  }
  horizontalAlignmentKeys = tmp;
  var tmp_0;
  if (verticalAlignmentKeys === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = ['line-align-bottom-left', 'line-align-top-right'];
  } else {
    tmp_0 = verticalAlignmentKeys;
  }
  verticalAlignmentKeys = tmp_0;
  var tmp_1;
  if (offeredTags === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = ['frame'];
  } else {
    tmp_1 = offeredTags;
  }
  offeredTags = tmp_1;
  var tmp_2 = Companion_getInstance_3().id;
  var tmp_3 = Companion_getInstance_152().id;
  var tmp_4 = Companion_instance_73.id;
  var tmp_5 = Companion_instance_5.id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_6 = [Companion_instance_0.h1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = [Companion_getInstance_1().j2a_1];
  SystemBase4.call(this, 'AlignmentLinesSystem', tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$14, null);
  this.m3p_1 = coreServices;
  this.n3p_1 = tagComponentId;
  this.o3p_1 = activationDistance;
  this.p3p_1 = priority;
  this.q3p_1 = horizontalAlignmentKeys;
  this.r3p_1 = verticalAlignmentKeys;
  this.s3p_1 = offeredTags;
  this.t3p_1 = null;
  var tmp_7 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_7.u3p_1 = [];
  this.v3p_1 = false;
  this.w3p_1 = null;
  this.x3p_1 = this.m3p_1.entityManager;
  this.y3p_1 = null;
  var tmp_8 = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp_8.z3p_1 = LinkedHashSet_init_$Create$();
  this.a3q_1 = null;
  this.enable();
}
protoOf(AlignmentLinesSystem).enable = function () {
  protoOf(SystemBase4).enable.call(this);
  this.v3p_1 = false;
  var tmp = this;
  var tmp_0 = this.m3p_1.sceneManager.scene;
  tmp.t3p_1 = findInHierarchy(tmp_0, AlignmentLinesSystem$enable$lambda);
  initializeAlignmentEdgesFeature(this);
};
protoOf(AlignmentLinesSystem).disable = function () {
  protoOf(SystemBase4).disable.call(this);
  clearAlignmentEdgesFeature(this);
};
protoOf(AlignmentLinesSystem).setRoomSurfaceKeys = function (keys) {
  this.u3p_1 = keys;
  clearAlignmentEdgesFeature(this);
  initializeAlignmentEdgesFeature(this);
};
protoOf(AlignmentLinesSystem).l2a = function (entity, newComponent) {
  if (this.v3p_1)
    return Unit_instance;
  if (!isApplicableGuestEntity(this, entity))
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = newComponent.connections;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onAddComponent.<anonymous>' call
    onAddConnection(this, entity, element);
  }
};
protoOf(AlignmentLinesSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).m2a = function (entity, oldComponent, newComponent) {
  if (this.v3p_1)
    return Unit_instance;
  this.l2a(entity, newComponent);
  this.n2a(entity, oldComponent);
};
protoOf(AlignmentLinesSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.m2a(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).n2a = function (entity, oldComponent) {
  if (this.v3p_1)
    return Unit_instance;
  if (!isApplicableGuestEntity(this, entity))
    return Unit_instance;
  if (isPartOfDraggedHierarchy(this, entity)) {
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = oldComponent.connections;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onRemoveComponent.<anonymous>' call
    onRemoveConnection(this, entity, element);
  }
};
protoOf(AlignmentLinesSystem).z1v = function (entity, oldComponent) {
  return this.n2a(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).l3q = function (entity, newComponent) {
  onRoomRebuild(this, entity);
};
protoOf(AlignmentLinesSystem).l1z = function (entity, newComponent) {
  return this.l3q(entity, newComponent instanceof RoomGeometryComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).m3q = function (entity, oldComponent, newComponent) {
  onRoomRebuild(this, entity);
};
protoOf(AlignmentLinesSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof RoomGeometryComponent ? oldComponent : THROW_CCE();
  return this.m3q(entity, tmp, newComponent instanceof RoomGeometryComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).n3q = function (entity, oldComponent) {
};
protoOf(AlignmentLinesSystem).p1z = function (entity, oldComponent) {
  return this.n3q(entity, oldComponent instanceof RoomGeometryComponent ? oldComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).o3q = function (entity, newComponent) {
  onStartedDragging(this, entity);
};
protoOf(AlignmentLinesSystem).n2m = function (entity, newComponent) {
  return this.o3q(entity, newComponent instanceof IsDraggedComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).p3q = function (entity, oldComponent, newComponent) {
};
protoOf(AlignmentLinesSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof IsDraggedComponent ? oldComponent : THROW_CCE();
  return this.p3q(entity, tmp, newComponent instanceof IsDraggedComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).q3q = function (entity, oldComponent) {
  onStoppedDragging(this, entity);
};
protoOf(AlignmentLinesSystem).p2m = function (entity, oldComponent) {
  return this.q3q(entity, oldComponent instanceof IsDraggedComponent ? oldComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).r3q = function (entity, newComponent) {
  this.v3p_1 = true;
};
protoOf(AlignmentLinesSystem).d2n = function (entity, newComponent) {
  return this.r3q(entity, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).s3q = function (entity, oldComponent, newComponent) {
};
protoOf(AlignmentLinesSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE();
  return this.s3q(entity, tmp, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(AlignmentLinesSystem).t3q = function (entity, oldComponent) {
  this.v3p_1 = false;
  initializeAlignmentEdgesFeature(this);
};
protoOf(AlignmentLinesSystem).f2n = function (entity, oldComponent) {
  return this.t3q(entity, oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE());
};
function getConnectorOldPosition($this, oldTransform, connector) {
  return connector.getWorldPositionFromOwnerTransform(oldTransform);
}
function AlignmentLinesUtils$Companion$addVertical$lambda($alignmentEntity, $atAlignmentEntityConnector, $ex) {
  return function () {
    return 'Add vertical failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atAlignmentEntityConnector + ' ' + $ex.toString();
  };
}
function AlignmentLinesUtils$Companion$addHorizontal$lambda($alignmentEntity, $atAlignmentEntityConnector, $ex) {
  return function () {
    return 'Add horizontal failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atAlignmentEntityConnector + ' ' + $ex.toString();
  };
}
function AlignmentLinesUtils$Companion$removeHorizontal$lambda($alignmentEntity, $atConnector, $ex) {
  return function () {
    return 'Remove horizontal failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atConnector + ' ' + $ex.toString();
  };
}
function AlignmentLinesUtils$Companion$removeVertical$lambda($alignmentEntity, $atConnector, $ex) {
  return function () {
    return 'Remove vertical failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atConnector + ' ' + $ex.toString();
  };
}
function Companion_3() {
  Companion_instance_42 = this;
  this.f3q_1 = LoggerState_getInstance().g1v('AlignmentLinesUtils');
}
protoOf(Companion_3).g3q = function (room, wallConnector, alignmentEntity, atAlignmentEntityConnector, addedConnectors) {
  try {
    var tmp0_elvis_lhs = room.__getComponentForKotlin(Companion_getInstance_47().id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var roomAlignments = tmp;
    var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var alignmentLines = tmp_0;
    var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp3_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.alignmentlines.Companion.addVertical.<anonymous>' call
          if (element.key === atAlignmentEntityConnector) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp4_safe_receiver = tmp_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var posWorld = tmp4_safe_receiver.getWorldPositionFromOwnerEntity(alignmentEntity);
      alignmentLines.b3r(posWorld, addedConnectors);
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var ex = $p;
      this.f3q_1.error(AlignmentLinesUtils$Companion$addVertical$lambda(alignmentEntity, atAlignmentEntityConnector, ex));
    } else {
      throw $p;
    }
  }
};
protoOf(Companion_3).h3q = function (room, wallConnector, alignmentEntity, atAlignmentEntityConnector, addedConnectors) {
  try {
    var tmp0_elvis_lhs = room.__getComponentForKotlin(Companion_getInstance_47().id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var roomAlignments = tmp;
    var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var alignmentLines = tmp_0;
    var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp3_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.alignmentlines.Companion.addHorizontal.<anonymous>' call
          if (element.key === atAlignmentEntityConnector) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp4_safe_receiver = tmp_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var posWorld = tmp4_safe_receiver.getWorldPositionFromOwnerEntity(alignmentEntity);
      alignmentLines.c3r(posWorld, addedConnectors);
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var ex = $p;
      this.f3q_1.error(AlignmentLinesUtils$Companion$addHorizontal$lambda(alignmentEntity, atAlignmentEntityConnector, ex));
    } else {
      throw $p;
    }
  }
};
protoOf(Companion_3).j3q = function (room, wallConnector, alignmentEntity, atConnector, removedConnectors, oldTransform) {
  try {
    var tmp0_elvis_lhs = room.__getComponentForKotlin(Companion_getInstance_47().id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('Cannot remove alignment connectors unless there is a room with a ' + toString(Companion_getInstance_47()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var roomAlignments = tmp;
    var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var alignmentLines = tmp_0;
    var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp3_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.alignmentlines.Companion.removeHorizontal.<anonymous>' call
          if (element.key === atConnector) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp4_safe_receiver = tmp_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var oldConnectorPosWorld = getConnectorOldPosition(Companion_getInstance_46(), oldTransform, tmp4_safe_receiver);
      alignmentLines.d3r(oldConnectorPosWorld, removedConnectors);
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var ex = $p;
      this.f3q_1.error(AlignmentLinesUtils$Companion$removeHorizontal$lambda(alignmentEntity, atConnector, ex));
    } else {
      throw $p;
    }
  }
};
protoOf(Companion_3).i3q = function (room, wallConnector, alignmentEntity, atConnector, removedConnectors, oldTransform) {
  try {
    var tmp0_elvis_lhs = room.__getComponentForKotlin(Companion_getInstance_47().id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('Cannot remove alignment connectors unless there is a room with a ' + toString(Companion_getInstance_47()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var roomAlignments = tmp;
    var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var alignmentLines = tmp_0;
    var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp3_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.alignmentlines.Companion.removeVertical.<anonymous>' call
          if (element.key === atConnector) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp4_safe_receiver = tmp_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var oldConnectorPosWorld = getConnectorOldPosition(Companion_getInstance_46(), oldTransform, tmp4_safe_receiver);
      alignmentLines.e3r(oldConnectorPosWorld, removedConnectors);
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var ex = $p;
      this.f3q_1.error(AlignmentLinesUtils$Companion$removeVertical$lambda(alignmentEntity, atConnector, ex));
    } else {
      throw $p;
    }
  }
};
var Companion_instance_42;
function Companion_getInstance_46() {
  if (Companion_instance_42 == null)
    new Companion_3();
  return Companion_instance_42;
}
function EntityWithConnector(entity, connector) {
  this.d3q_1 = entity;
  this.e3q_1 = connector;
}
protoOf(EntityWithConnector).tf = function () {
  return this.d3q_1;
};
protoOf(EntityWithConnector).uf = function () {
  return this.e3q_1;
};
protoOf(EntityWithConnector).toString = function () {
  return 'EntityWithConnector(entity=' + this.d3q_1.toString() + ', connector=' + toString(this.e3q_1) + ')';
};
protoOf(EntityWithConnector).hashCode = function () {
  var result = this.d3q_1.hashCode();
  result = imul(result, 31) + this.e3q_1.hashCode() | 0;
  return result;
};
protoOf(EntityWithConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityWithConnector))
    return false;
  var tmp0_other_with_cast = other instanceof EntityWithConnector ? other : THROW_CCE();
  if (!this.d3q_1.equals(tmp0_other_with_cast.d3q_1))
    return false;
  if (!this.e3q_1.equals(tmp0_other_with_cast.e3q_1))
    return false;
  return true;
};
function IntersectionPointConnectors(priority, tags, offers, localToParentTransform, activationDistance) {
  this.f3r_1 = priority;
  this.g3r_1 = tags;
  this.h3r_1 = offers;
  this.i3r_1 = localToParentTransform;
  this.j3r_1 = activationDistance;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.k3r_1 = LinkedHashMap_init_$Create$();
}
protoOf(IntersectionPointConnectors).t3o = function () {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = this.k3r_1;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alignmentlines.IntersectionPointConnectors.<get-generatedAlignmentConnectorKeys>.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = element.c2().h2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.k();
    while (tmp0_iterator_0.m()) {
      var item = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.IntersectionPointConnectors.<get-generatedAlignmentConnectorKeys>.<anonymous>.<anonymous>' call
      var tmp$ret$1 = item.key;
      destination_0.h(tmp$ret$1);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return destination;
};
protoOf(IntersectionPointConnectors).l3r = function (x, y) {
  var pos = new Vector(x, 0.0, y);
  var posWS = this.i3r_1.transformPosition(pos);
  var tmp0_key = 'Intersection alignment at ' + pos.toString();
  var tmp1_type = Companion_instance_6.n2b_1;
  var tmp2_transform = new Transform(posWS, this.i3r_1.rotation);
  var tmp3_priority = this.f3r_1;
  var tmp4_tagArray = this.g3r_1;
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.h3r_1;
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = ['intersection'];
  var tmp5_offersArray = this_0.concat(tmp$ret$3);
  var tmp6_activationDistance = this.j3r_1;
  var connector = new PointConnector(tmp0_key, tmp1_type, tmp2_transform, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
  if (!this.k3r_1.d2(x)) {
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.k3r_1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    var value = LinkedHashMap_init_$Create$();
    this_1.q2(x, value);
  }
  var tmp7_safe_receiver = this.k3r_1.f2(x);
  if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.d2(y)) === true)
    throw Exception_init_$Create$('Already has connector at (' + x + ',' + y + ')');
  var tmp8_safe_receiver = this.k3r_1.f2(x);
  if (tmp8_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.set' call
    tmp8_safe_receiver.q2(y, connector);
  }
  return connector;
};
protoOf(IntersectionPointConnectors).m3r = function (x, y) {
  var tmp0_safe_receiver = this.k3r_1.f2(x);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2(y);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    throw Exception_init_$Create$('No connector exist at (' + x + ', ' + y + ')');
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
};
function IntersectionPointsTracker$addHorizontalLine$lambda($closeY) {
  return function (x) {
    return new Pair(x, $closeY);
  };
}
function IntersectionPointsTracker$addVerticalLine$lambda($closeX) {
  return function (y) {
    return new Pair($closeX, y);
  };
}
function IntersectionPointsTracker$removeHorizontalLine$lambda($closeY) {
  return function (x) {
    return new Pair(x, $closeY);
  };
}
function IntersectionPointsTracker$removeVerticalLine$lambda($closeX) {
  return function (y) {
    return new Pair($closeX, y);
  };
}
function IntersectionPointsTracker(epsilon) {
  epsilon = epsilon === VOID ? 1.0 : epsilon;
  this.n3r_1 = epsilon;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp.o3r_1 = LinkedHashSet_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp_0.p3r_1 = LinkedHashSet_init_$Create$();
}
protoOf(IntersectionPointsTracker).q3r = function (y) {
  var closeY = getCloseKeyFromSet(y, this.p3r_1, this.n3r_1);
  if (this.p3r_1.s(closeY))
    throw Exception_init_$Create$('Already contains a horizontal line at y:' + y);
  this.p3r_1.h(closeY);
  var tmp = asSequence(this.o3r_1);
  return map(tmp, IntersectionPointsTracker$addHorizontalLine$lambda(closeY));
};
protoOf(IntersectionPointsTracker).r3r = function (x) {
  var closeX = getCloseKeyFromSet(x, this.o3r_1, this.n3r_1);
  if (this.o3r_1.s(closeX))
    throw Exception_init_$Create$('Already contains a vertical line at x:' + closeX);
  this.o3r_1.h(closeX);
  var tmp = asSequence(this.p3r_1);
  return map(tmp, IntersectionPointsTracker$addVerticalLine$lambda(closeX));
};
protoOf(IntersectionPointsTracker).s3r = function (y) {
  var closeY = getCloseKeyFromSet(y, this.p3r_1, this.n3r_1);
  if (!this.p3r_1.s(closeY))
    throw Exception_init_$Create$('Does not contain a horizontal line at y:' + closeY);
  this.p3r_1.j2(closeY);
  var tmp = asSequence(this.o3r_1);
  return map(tmp, IntersectionPointsTracker$removeHorizontalLine$lambda(closeY));
};
protoOf(IntersectionPointsTracker).t3r = function (x) {
  var closeX = getCloseKeyFromSet(x, this.o3r_1, this.n3r_1);
  if (!this.o3r_1.s(closeX))
    throw Exception_init_$Create$('Does not contain a vertical line at x:' + closeX);
  this.o3r_1.j2(closeX);
  var tmp = asSequence(this.p3r_1);
  return map(tmp, IntersectionPointsTracker$removeVerticalLine$lambda(closeX));
};
function Companion_4() {
  Companion_instance_43 = this;
  this.id = Companion_instance_0.h1p_1;
}
protoOf(Companion_4).n1s = function () {
  return this.id;
};
var Companion_instance_43;
function Companion_getInstance_47() {
  if (Companion_instance_43 == null)
    new Companion_4();
  return Companion_instance_43;
}
function RoomAlignmentEdgesComponent(activationDistance, priority, horizontalAlignmentKeys, verticalAlignmentKeys, surfacesAlignmentLines) {
  Companion_getInstance_47();
  this.activationDistance = activationDistance;
  this.priority = priority;
  this.horizontalAlignmentKeys = horizontalAlignmentKeys;
  this.verticalAlignmentKeys = verticalAlignmentKeys;
  this.b3q_1 = surfacesAlignmentLines;
}
protoOf(RoomAlignmentEdgesComponent).h2b = function () {
  return this.activationDistance;
};
protoOf(RoomAlignmentEdgesComponent).n28 = function () {
  return this.priority;
};
protoOf(RoomAlignmentEdgesComponent).u3r = function () {
  return this.horizontalAlignmentKeys;
};
protoOf(RoomAlignmentEdgesComponent).v3r = function () {
  return this.verticalAlignmentKeys;
};
protoOf(RoomAlignmentEdgesComponent).getAlignmentLinesForSurface = function (surfaceConnector) {
  return this.getAlignmentLinesForSurfaceKey(surfaceConnector.surfaceConnector.p2h_1, surfaceConnector.entity);
};
protoOf(RoomAlignmentEdgesComponent).getAlignmentLinesForSurfaceKey = function (surfaceConnectorKey, surfaceEntity) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var indexedObject = this.b3q_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.RoomAlignmentEdgesComponent.getAlignmentLinesForSurfaceKey.<anonymous>' call
      if (element.ownerEntity.equals(surfaceEntity) && element.surfaceConnector.p2h_1 === surfaceConnectorKey) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(RoomAlignmentEdgesComponent).p1s = function () {
  return Companion_getInstance_47().id;
};
protoOf(RoomAlignmentEdgesComponent).eq = function (other) {
  return false;
};
protoOf(RoomAlignmentEdgesComponent).c3q = function () {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var connectorKeys = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.b3q_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignmentlines.RoomAlignmentEdgesComponent.getAllGeneratedAlignmentConnectors.<anonymous>' call
    connectorKeys.p(element.t3o());
  }
  return connectorKeys;
};
function getCloseKeyFromSet(key, set, epsilon) {
  if (!set.s(key)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = set.k();
      if (!iterator.m()) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var minElem = iterator.n();
      if (!iterator.m()) {
        tmp$ret$0 = minElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.stl.alignmentlines.getCloseKeyFromSet.<anonymous>' call
      // Inline function 'kotlin.math.abs' call
      var x = minElem - key;
      var minValue = Math.abs(x);
      do {
        var e = iterator.n();
        // Inline function 'com.ikea.core.stl.alignmentlines.getCloseKeyFromSet.<anonymous>' call
        // Inline function 'kotlin.math.abs' call
        var x_0 = e - key;
        var v = Math.abs(x_0);
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.m());
      tmp$ret$0 = minElem;
    }
    var closestAlternative = tmp$ret$0;
    var tmp;
    var tmp_0;
    if (closestAlternative == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_1 = closestAlternative - key;
      tmp_0 = Math.abs(x_1) >= epsilon;
    }
    if (tmp_0) {
      tmp = key;
    } else {
      tmp = closestAlternative;
    }
    return tmp;
  }
  return key;
}
function createHorizontalAlignmentConnector($this, height) {
  var halfWidth = $this.width / 2.0;
  var p1 = new Vector(halfWidth, VOID, height);
  var p2 = new Vector(-halfWidth, VOID, height);
  var p1EntitySpace = $this.surfaceConnector.y2h_1.transformPosition(p1);
  var p2EntitySpace = $this.surfaceConnector.y2h_1.transformPosition(p2);
  var tmp0_key = 'horizontal alignment height ' + height;
  var tmp1_type = Companion_instance_6.n2b_1;
  var tmp2_rotation = $this.surfaceConnector.y2h_1.rotation;
  var tmp3_priority = $this.u3q_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp4_tagArray = [];
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = $this.w3q_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = ['line'];
  var tmp5_offersArray = tmp$ret$1.concat(tmp$ret$4);
  var tmp6_activationDistance = $this.v3q_1;
  var connector = new EdgeConnector(tmp0_key, tmp1_type, p1EntitySpace, p2EntitySpace, tmp2_rotation, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
  $this.x3q_1.w3o(connector, height);
  return connector;
}
function createVerticalAlignmentConnector($this, x) {
  var halfHeight = $this.height * 0.5;
  var p1 = new Vector(x, 0.0, -halfHeight);
  var p2 = new Vector(x, 0.0, halfHeight);
  var p1EntitySpace = $this.surfaceConnector.y2h_1.transformPosition(p1);
  var p2EntitySpace = $this.surfaceConnector.y2h_1.transformPosition(p2);
  var tmp0_key = 'vertical alignment connector at x: ' + x;
  var tmp1_type = Companion_instance_6.n2b_1;
  var tmp2_rotation = $this.surfaceConnector.y2h_1.rotation;
  var tmp3_priority = $this.u3q_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp4_tagArray = [];
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = $this.w3q_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = ['line'];
  var tmp5_offersArray = tmp$ret$1.concat(tmp$ret$4);
  var tmp6_activationDistance = $this.v3q_1;
  var connector = new EdgeConnector(tmp0_key, tmp1_type, p1EntitySpace, p2EntitySpace, tmp2_rotation, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
  $this.y3q_1.w3o(connector, x);
  return connector;
}
function SurfaceAlignmentLines(surfaceConnector, ownerEntity, priority, activationDistance, offers, epsilon) {
  epsilon = epsilon === VOID ? 1.0 : epsilon;
  this.surfaceConnector = surfaceConnector;
  this.ownerEntity = ownerEntity;
  this.u3q_1 = priority;
  this.v3q_1 = activationDistance;
  this.w3q_1 = offers;
  this.x3q_1 = new AlignmentLinesReferenceCounter(epsilon);
  this.y3q_1 = new AlignmentLinesReferenceCounter(epsilon);
  this.z3q_1 = new IntersectionPointsTracker(epsilon);
  this.normal = this.surfaceConnector.plane.normal;
  this.center = this.surfaceConnector.y2h_1.position;
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.surfaceConnector.vertices;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.<anonymous>' call
    var tmp$ret$0 = this.surfaceConnector.y2h_1.inverseTransformPosition(item);
    destination.h(tmp$ret$0);
  }
  var localSurfaceVertices = destination;
  var tmp = Companion_getInstance_6();
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(localSurfaceVertices);
  var aabb = tmp.z2v(tmp$ret$3);
  var size = aabb.size;
  this.width = size.X;
  this.height = size.Z;
  var tmp_0 = this;
  var tmp0_localToParentTransform = this.surfaceConnector.y2h_1;
  var tmp1_priority = this.u3q_1 + 1 | 0;
  // Inline function 'kotlin.emptyArray' call
  var tmp2_tags = [];
  var tmp3_offers = this.w3q_1;
  var tmp4_activationDistance = this.v3q_1;
  tmp_0.a3r_1 = new IntersectionPointConnectors(tmp1_priority, tmp2_tags, tmp3_offers, tmp0_localToParentTransform, tmp4_activationDistance);
}
protoOf(SurfaceAlignmentLines).w3r = function () {
  return this.surfaceConnector;
};
protoOf(SurfaceAlignmentLines).x3r = function () {
  return this.ownerEntity;
};
protoOf(SurfaceAlignmentLines).f2i = function () {
  return this.normal;
};
protoOf(SurfaceAlignmentLines).o3b = function () {
  return this.center;
};
protoOf(SurfaceAlignmentLines).t2u = function () {
  return this.width;
};
protoOf(SurfaceAlignmentLines).u2u = function () {
  return this.height;
};
protoOf(SurfaceAlignmentLines).t3o = function () {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var keys = LinkedHashSet_init_$Create$();
  keys.p(this.a3r_1.t3o());
  keys.p(this.x3q_1.t3o());
  keys.p(this.y3q_1.t3o());
  return keys;
};
protoOf(SurfaceAlignmentLines).transformWorldSpaceToConnectorSpace = function (pointWorldSpace) {
  var ownerTransform = get_worldTransform(this.ownerEntity);
  var posOwnerSpace = ownerTransform.inverseTransformPosition(pointWorldSpace);
  return this.surfaceConnector.y2h_1.inverseTransformPosition(posOwnerSpace);
};
protoOf(SurfaceAlignmentLines).transformConnectorSpaceToWorldSpace = function (pointInConnectorSpace) {
  var ownerTransform = get_worldTransform(this.ownerEntity);
  var posOwnerSpace = this.surfaceConnector.y2h_1.transformPosition(pointInConnectorSpace);
  return ownerTransform.transformPosition(posOwnerSpace);
};
protoOf(SurfaceAlignmentLines).b3r = function (worldSpacePoint, addedConnectors) {
  var x = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).X;
  if (this.y3q_1.u3o(x)) {
    var newEdgeConnector = createVerticalAlignmentConnector(this, x);
    addedConnectors.h(new EntityWithConnector(this.ownerEntity, newEdgeConnector));
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = this.z3q_1.r3r(x).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.addVerticalLine.<anonymous>' call
      var x_0 = element.tf();
      var y = element.uf();
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var newPointConnector = this.a3r_1.l3r(x_0, y);
      addedConnectors.h(new EntityWithConnector(this.ownerEntity, newPointConnector));
    }
  }
};
protoOf(SurfaceAlignmentLines).c3r = function (worldSpacePoint, addedConnectors) {
  var y = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).Z;
  if (this.x3q_1.u3o(y)) {
    var horizontalConnector = createHorizontalAlignmentConnector(this, y);
    addedConnectors.h(new EntityWithConnector(this.ownerEntity, horizontalConnector));
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = this.z3q_1.q3r(y).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.addHorizontal.<anonymous>' call
      var x = element.tf();
      var y_0 = element.uf();
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var newPointConnector = this.a3r_1.l3r(x, y_0);
      addedConnectors.h(new EntityWithConnector(this.ownerEntity, newPointConnector));
    }
  }
};
protoOf(SurfaceAlignmentLines).d3r = function (worldSpacePoint, removedConnectors) {
  var y = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).Z;
  if (this.x3q_1.v3o(y)) {
    var edgeToRemove = this.x3q_1.y3o(y);
    this.x3q_1.x3o(y);
    removedConnectors.h(new EntityWithConnector(this.ownerEntity, edgeToRemove));
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = this.z3q_1.s3r(y).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.removeHorizontalLine.<anonymous>' call
      var x = element.tf();
      var y_0 = element.uf();
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var removedPointConnector = this.a3r_1.m3r(x, y_0);
      removedConnectors.h(new EntityWithConnector(this.ownerEntity, removedPointConnector));
    }
  }
};
protoOf(SurfaceAlignmentLines).e3r = function (worldSpacePoint, removedConnectors) {
  var x = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).X;
  if (this.y3q_1.v3o(x)) {
    var edgeToRemove = this.y3q_1.y3o(x);
    this.y3q_1.x3o(x);
    removedConnectors.h(new EntityWithConnector(this.ownerEntity, edgeToRemove));
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = this.z3q_1.t3r(x).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.removeVerticalLine.<anonymous>' call
      var x_0 = element.tf();
      var y = element.uf();
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var removedPointConnector = this.a3r_1.m3r(x_0, y);
      removedConnectors.h(new EntityWithConnector(this.ownerEntity, removedPointConnector));
    }
  }
};
function SurfaceConnectorWithEntity(entity, surfaceConnector) {
  this.entity = entity;
  this.surfaceConnector = surfaceConnector;
}
protoOf(SurfaceConnectorWithEntity).v2i = function () {
  return this.entity;
};
protoOf(SurfaceConnectorWithEntity).w3r = function () {
  return this.surfaceConnector;
};
protoOf(SurfaceConnectorWithEntity).tf = function () {
  return this.entity;
};
protoOf(SurfaceConnectorWithEntity).uf = function () {
  return this.surfaceConnector;
};
protoOf(SurfaceConnectorWithEntity).y3r = function (entity, surfaceConnector) {
  return new SurfaceConnectorWithEntity(entity, surfaceConnector);
};
protoOf(SurfaceConnectorWithEntity).copy = function (entity, surfaceConnector, $super) {
  entity = entity === VOID ? this.entity : entity;
  surfaceConnector = surfaceConnector === VOID ? this.surfaceConnector : surfaceConnector;
  return this.y3r(entity, surfaceConnector);
};
protoOf(SurfaceConnectorWithEntity).toString = function () {
  return 'SurfaceConnectorWithEntity(entity=' + this.entity.toString() + ', surfaceConnector=' + this.surfaceConnector.toString() + ')';
};
protoOf(SurfaceConnectorWithEntity).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + this.surfaceConnector.hashCode() | 0;
  return result;
};
protoOf(SurfaceConnectorWithEntity).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SurfaceConnectorWithEntity))
    return false;
  var tmp0_other_with_cast = other instanceof SurfaceConnectorWithEntity ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!this.surfaceConnector.equals(tmp0_other_with_cast.surfaceConnector))
    return false;
  return true;
};
function Companion_5() {
  Companion_instance_44 = this;
  this.id = Companion_instance_0.z1n_1;
}
protoOf(Companion_5).n1s = function () {
  return this.id;
};
var Companion_instance_44;
function Companion_getInstance_48() {
  if (Companion_instance_44 == null)
    new Companion_5();
  return Companion_instance_44;
}
function AllowedDoorPairsComponent(pairs) {
  Companion_getInstance_48();
  this.pairs = pairs;
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = flatten(this.pairs);
  tmp.z3r_1 = copyToArray(this_0);
}
protoOf(AllowedDoorPairsComponent).a3s = function () {
  return this.pairs;
};
protoOf(AllowedDoorPairsComponent).p1s = function () {
  return Companion_getInstance_48().id;
};
protoOf(AllowedDoorPairsComponent).equals = function (other) {
  return other === other;
};
protoOf(AllowedDoorPairsComponent).hashCode = function () {
  var tmp;
  if (any(this.pairs)) {
    var tmp_0 = this.pairs[0][0];
    var tmp0_elvis_lhs = getOrNull(this.pairs[0], 1);
    tmp = tmp_0 + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
  } else {
    tmp = 0;
  }
  return tmp;
};
protoOf(AllowedDoorPairsComponent).allows = function (oneDoorWidth, secondDoorWidth) {
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.pairs;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.allows.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var width1 = element[0];
      // Inline function 'kotlin.collections.component2' call
      var width2 = element[1];
      if (width1 === oneDoorWidth && width2 === secondDoorWidth || (width2 === oneDoorWidth && width1 === secondDoorWidth)) {
        tmp$ret$3 = true;
        break $l$block;
      }
    }
    tmp$ret$3 = false;
  }
  return tmp$ret$3;
};
protoOf(AllowedDoorPairsComponent).isWidthAllowed = function (comSizeWidth) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.z3r_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.isWidthAllowed.<anonymous>' call
      if (element === comSizeWidth) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
};
protoOf(AllowedDoorPairsComponent).eq = function (other) {
  return false;
};
protoOf(AllowedDoorPairsComponent).tf = function () {
  return this.pairs;
};
protoOf(AllowedDoorPairsComponent).b3s = function (pairs) {
  return new AllowedDoorPairsComponent(pairs);
};
protoOf(AllowedDoorPairsComponent).copy = function (pairs, $super) {
  pairs = pairs === VOID ? this.pairs : pairs;
  return this.b3s(pairs);
};
protoOf(AllowedDoorPairsComponent).toString = function () {
  return 'AllowedDoorPairsComponent(pairs=' + toString(this.pairs) + ')';
};
function validate($this, entity, snap) {
  var tmp1_elvis_lhs = snap == null ? null : snap.host;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var parent = tmp;
  var allowedDoorPairs = parent.__getComponentForKotlin(Companion_getInstance_48().id);
  var entityIsDoor = entity.hasComponent(Companion_getInstance_136().id);
  if (!(allowedDoorPairs == null) && entityIsDoor) {
    return allowedToPlaceFrontOnFrame($this, allowedDoorPairs, entity, parent);
  }
  return null;
}
function allowedToPlaceFrontOnFrame($this, allowedDoorPairsComponent, newDoor, frame) {
  var existingDoors = findExistingDoorsOnFrame($this, frame, newDoor);
  if (existingDoors.o() >= 2) {
    return new InvalidDoorPairsResult('Not allowed to have more than 2 doors', get_productRefOrEmptyString(newDoor), $this);
  }
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!existingDoors.r()) {
    tmp = allowedToPlaceSecondDoor($this, allowedDoorPairsComponent, existingDoors.q(0), newDoor);
  } else {
    tmp = allowedToPlaceFirstDoor($this, allowedDoorPairsComponent, newDoor);
  }
  return tmp;
}
function allowedToPlaceSecondDoor($this, allowedDoorPairsComponent, firstDoor, secondDoor) {
  var tmp0_safe_receiver = firstDoor.__getComponentForKotlin(Companion_getInstance_135().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b2y_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
  var tmp;
  if (tmp3_elvis_lhs == null) {
    return new InvalidDoorPairsResult('Door ' + firstDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(secondDoor), $this);
  } else {
    tmp = tmp3_elvis_lhs;
  }
  var firstDoorWidth = tmp;
  var tmp4_safe_receiver = secondDoor.__getComponentForKotlin(Companion_getInstance_135().id);
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.size;
  var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.b2y_1;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
  var tmp_0;
  if (tmp7_elvis_lhs == null) {
    return new InvalidDoorPairsResult('Door ' + secondDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(secondDoor), $this);
  } else {
    tmp_0 = tmp7_elvis_lhs;
  }
  var secondDoorWidth = tmp_0;
  if (!allowedDoorPairsComponent.isWidthAllowed(firstDoorWidth))
    return new InvalidDoorPairsResult('Door (' + firstDoor.id + ') of width ' + firstDoorWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
  if (!allowedDoorPairsComponent.isWidthAllowed(secondDoorWidth))
    return new InvalidDoorPairsResult('Door (' + secondDoor.id + ') of width ' + secondDoorWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
  var tmp_1;
  if (allowedDoorPairsComponent.allows(firstDoorWidth, secondDoorWidth)) {
    tmp_1 = null;
  } else {
    tmp_1 = new InvalidDoorPairsResult('Not allowed to pair a door of width ' + secondDoorWidth + ' with and existing door of width ' + firstDoorWidth + '. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
  }
  return tmp_1;
}
function allowedToPlaceFirstDoor($this, allowedDoorPairsComponent, firstDoor) {
  var tmp0_safe_receiver = firstDoor.__getComponentForKotlin(Companion_getInstance_135().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b2y_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
  var tmp;
  if (tmp3_elvis_lhs == null) {
    return new InvalidDoorPairsResult('Door ' + firstDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(firstDoor), $this);
  } else {
    tmp = tmp3_elvis_lhs;
  }
  var doorPhysicalWidth = tmp;
  var tmp_0;
  if (allowedDoorPairsComponent.isWidthAllowed(doorPhysicalWidth)) {
    tmp_0 = null;
  } else {
    tmp_0 = new InvalidDoorPairsResult('Door (' + firstDoor.id + ') of width ' + doorPhysicalWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(firstDoor), $this);
  }
  return tmp_0;
}
function findExistingDoorsOnFrame($this, frame, newDoor) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(frame);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsValidation.findExistingDoorsOnFrame.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_136().id)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsValidation.findExistingDoorsOnFrame.<anonymous>' call
    if (!element_0.equals(newDoor)) {
      destination_0.h(element_0);
    }
  }
  return destination_0;
}
function Companion_6() {
  this.ID = 'AllowedDoorPairs';
}
protoOf(Companion_6).j1y = function () {
  return this.ID;
};
var Companion_instance_45;
function Companion_getInstance_49() {
  return Companion_instance_45;
}
function AllowedDoorPairsValidation() {
  ValidationImpl.call(this);
  this.d3s_1 = Companion_instance_45.ID;
}
protoOf(AllowedDoorPairsValidation).n1s = function () {
  return this.d3s_1;
};
protoOf(AllowedDoorPairsValidation).validateCurrentState = function (entity) {
  return validate(this, entity, null);
};
protoOf(AllowedDoorPairsValidation).validateSnap = function (snap) {
  return validate(this, snap.guestRoot, snap);
};
function Companion_7() {
  this.e3s_1 = 'InvalidDoorPairsResult';
}
var Companion_instance_46;
function Companion_getInstance_50() {
  return Companion_instance_46;
}
function InvalidDoorPairsResult(message, productRef, rule) {
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
  this.g3s_1 = message;
}
protoOf(InvalidDoorPairsResult).n1s = function () {
  return Companion_instance_46.e3s_1;
};
protoOf(InvalidDoorPairsResult).toString = function () {
  return this.id + ': ' + this.g3s_1;
};
function AssemblyInstructionsService() {
}
protoOf(AssemblyInstructionsService).getAssemblyInstructionsForPointSeries = function (root) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_hierarchy(root);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsService.getAssemblyInstructionsForPointSeries.<anonymous>' call
    if (!get_isPropping(element)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsService.getAssemblyInstructionsForPointSeries.<anonymous>' call
    if (element_0.hasComponent(Companion_getInstance_3().id)) {
      destination_0.h(element_0);
    }
  }
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = destination_0.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsService.getAssemblyInstructionsForPointSeries.<anonymous>' call
    var list = toList(get_guestConnections(element_1));
    addAll(destination_1, list);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_1 = destination_1.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsService.getAssemblyInstructionsForPointSeries.<anonymous>' call
    var tmp = element_2.hostConnector;
    if (tmp instanceof PointSeriesSubConnector) {
      destination_2.h(element_2);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_2, 10));
  var tmp0_iterator_2 = destination_2.k();
  while (tmp0_iterator_2.m()) {
    var item = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsService.getAssemblyInstructionsForPointSeries.<anonymous>' call
    var tmp$ret$12 = new PointSeriesAssemblyInstructionImpl(item);
    destination_3.h(tmp$ret$12);
  }
  var this_1 = toList_0(destination_3);
  return copyToArray(this_1);
};
function PointSeriesAssemblyInstruction() {
}
function _get_hostSubConnector__a6nvli($this) {
  var tmp = $this.k3s_1.hostConnector;
  return tmp instanceof PointSeriesSubConnector ? tmp : THROW_CCE();
}
function PointSeriesAssemblyInstructionImpl(connection) {
  this.k3s_1 = connection;
  this.l3s_1 = _get_hostSubConnector__a6nvli(this).positionInSeries;
  this.m3s_1 = get_worldTransform(this.k3s_1.hostConnectorEntity).transformPosition(_get_hostSubConnector__a6nvli(this).positionInSeries);
}
protoOf(PointSeriesAssemblyInstructionImpl).s3c = function () {
  return this.k3s_1.hostConnectorEntity;
};
protoOf(PointSeriesAssemblyInstructionImpl).t3c = function () {
  return this.k3s_1.guestConnectorEntity;
};
protoOf(PointSeriesAssemblyInstructionImpl).l28 = function () {
  var tmp0_elvis_lhs = get_connectionRootEntity(this.guest);
  return tmp0_elvis_lhs == null ? this.guest : tmp0_elvis_lhs;
};
protoOf(PointSeriesAssemblyInstructionImpl).h3s = function () {
  return _get_hostSubConnector__a6nvli(this).hole;
};
protoOf(PointSeriesAssemblyInstructionImpl).i3s = function () {
  return this.l3s_1;
};
protoOf(PointSeriesAssemblyInstructionImpl).j3s = function () {
  return this.m3s_1;
};
protoOf(PointSeriesAssemblyInstructionImpl).n3s = function (connection) {
  return new PointSeriesAssemblyInstructionImpl(connection);
};
protoOf(PointSeriesAssemblyInstructionImpl).copy = function (connection, $super) {
  connection = connection === VOID ? this.k3s_1 : connection;
  return this.n3s(connection);
};
protoOf(PointSeriesAssemblyInstructionImpl).toString = function () {
  return 'PointSeriesAssemblyInstructionImpl(connection=' + this.k3s_1.toString() + ')';
};
protoOf(PointSeriesAssemblyInstructionImpl).hashCode = function () {
  return this.k3s_1.hashCode();
};
protoOf(PointSeriesAssemblyInstructionImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PointSeriesAssemblyInstructionImpl))
    return false;
  var tmp0_other_with_cast = other instanceof PointSeriesAssemblyInstructionImpl ? other : THROW_CCE();
  if (!this.k3s_1.equals(tmp0_other_with_cast.k3s_1))
    return false;
  return true;
};
function Companion_8() {
}
protoOf(Companion_8).o3s = function (coreServices) {
  var entityManager = coreServices.entityManager;
  // Inline function 'kotlin.collections.find' call
  var this_0 = entityManager.getSystemsRegistered();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.Companion.start.<anonymous>' call
      if (element.id === Companion_instance_53.p3s_1) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp = tmp$ret$1;
  var preExistingCache = tmp instanceof AutoAdaptCacheSystem ? tmp : null;
  var autoAdaptCacheSystem = preExistingCache == null ? new AutoAdaptCacheSystem(coreServices.productManager) : preExistingCache;
  if (preExistingCache == null) {
    entityManager.registerSystem(autoAdaptCacheSystem);
  }
  // Inline function 'kotlin.collections.find' call
  var this_1 = entityManager.getSystemsRegistered();
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.Companion.start.<anonymous>' call
      if (element_0.id === Companion_getInstance_55().ID) {
        tmp$ret$4 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$4 = null;
  }
  var tmp_0 = tmp$ret$4;
  var preExistingChildrenSystem = tmp_0 instanceof AutoAdaptChildrenSystem ? tmp_0 : null;
  var autoAdaptChildrenSystem = preExistingChildrenSystem == null ? new AutoAdaptChildrenSystem(coreServices) : preExistingChildrenSystem;
  if (preExistingChildrenSystem == null) {
    entityManager.registerSystem(autoAdaptChildrenSystem);
  }
  // Inline function 'kotlin.collections.find' call
  var this_2 = entityManager.getSystemsRegistered();
  var tmp$ret$7;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_1 = 0;
    var last_1 = this_2.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = this_2[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.Companion.start.<anonymous>' call
      if (element_1.id === Companion_instance_56.r3s_1) {
        tmp$ret$7 = element_1;
        break $l$block_1;
      }
    }
    tmp$ret$7 = null;
  }
  var tmp_1 = tmp$ret$7;
  var preExistingCleanCacheOnFinishedAutoAdaptSystem = tmp_1 instanceof CleanCacheOnFinishedAutoAdaptSystem ? tmp_1 : null;
  var cleanCacheOnFinishedAutoAdaptSystem = preExistingCleanCacheOnFinishedAutoAdaptSystem == null ? new CleanCacheOnFinishedAutoAdaptSystem() : preExistingCleanCacheOnFinishedAutoAdaptSystem;
  if (preExistingCleanCacheOnFinishedAutoAdaptSystem == null) {
    entityManager.registerSystem(cleanCacheOnFinishedAutoAdaptSystem);
  }
  // Inline function 'kotlin.collections.find' call
  var this_3 = entityManager.getSystemsRegistered();
  var tmp$ret$10;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_2 = 0;
    var last_2 = this_3.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = this_3[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.Companion.start.<anonymous>' call
      if (element_2.id === Companion_getInstance_56().s3s_1) {
        tmp$ret$10 = element_2;
        break $l$block_2;
      }
    }
    tmp$ret$10 = null;
  }
  var tmp_2 = tmp$ret$10;
  var preExistingDisposeFailedChildrenSystem = tmp_2 instanceof AutoAdaptDisposeFailedChildrenSystem ? tmp_2 : null;
  var disposeFailedChildrenSystem = preExistingDisposeFailedChildrenSystem == null ? new AutoAdaptDisposeFailedChildrenSystem() : preExistingDisposeFailedChildrenSystem;
  if (preExistingDisposeFailedChildrenSystem == null) {
    entityManager.registerSystem(disposeFailedChildrenSystem);
  }
};
var Companion_instance_47;
function Companion_getInstance_51() {
  return Companion_instance_47;
}
function start(coreServices) {
  return Companion_instance_47.o3s(coreServices);
}
function AutoAdaptFeature() {
}
function update($this, entity, component) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = component.variants;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptProductSpecificationsSystem.update.<anonymous>' call
    var spec = $this.productManager.productSpecification(element);
    var tmp;
    if (spec == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptProductSpecificationsSystem.update.<anonymous>.<anonymous>' call
      tmp = new SpecificationPair(element, spec);
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var pairs = copyToArray(destination);
  entity.addComponent(new AutoAdaptProductSpecificationsComponent(pairs));
}
function Companion_9() {
  this.ID = 'AutoAdaptProductSpecificationSystem';
}
protoOf(Companion_9).j1y = function () {
  return this.ID;
};
var Companion_instance_48;
function Companion_getInstance_52() {
  return Companion_instance_48;
}
function AutoAdaptProductSpecificationsSystem(productManager) {
  var tmp = Companion_instance_48.ID;
  var tmp_0 = Companion_getInstance_61().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_63().id];
  SystemBase.call(this, tmp, tmp_0, tmp$ret$2);
  this.productManager = productManager;
}
protoOf(AutoAdaptProductSpecificationsSystem).i1k = function () {
  return this.productManager;
};
protoOf(AutoAdaptProductSpecificationsSystem).d3t = function (entity, newComponent) {
  update(this, entity, newComponent);
};
protoOf(AutoAdaptProductSpecificationsSystem).v1v = function (entity, newComponent) {
  return this.d3t(entity, newComponent instanceof AutoAdaptGuestComponent ? newComponent : THROW_CCE());
};
protoOf(AutoAdaptProductSpecificationsSystem).e3t = function (entity, oldComponent, newComponent) {
  update(this, entity, newComponent);
};
protoOf(AutoAdaptProductSpecificationsSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof AutoAdaptGuestComponent ? oldComponent : THROW_CCE();
  return this.e3t(entity, tmp, newComponent instanceof AutoAdaptGuestComponent ? newComponent : THROW_CCE());
};
protoOf(AutoAdaptProductSpecificationsSystem).f3t = function (entity, oldComponent) {
  entity.removeComponent(Companion_getInstance_63().id);
};
protoOf(AutoAdaptProductSpecificationsSystem).z1v = function (entity, oldComponent) {
  return this.f3t(entity, oldComponent instanceof AutoAdaptGuestComponent ? oldComponent : THROW_CCE());
};
function snapToValidAutoAdaptedSnap($this, guest, host, snapSettings, sortAndSelectStrategy) {
  var snapValidationResult = findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy);
  return snapValidationResult;
}
function triggerReplaceEvent(_this__u8e3s4, $this, oldEntity) {
  var event = new ReplacedWithAutoAdaptEventComponent(oldEntity);
  _this__u8e3s4.entityManager.addComponent(_this__u8e3s4, event);
  _this__u8e3s4.entityManager.removeComponent(_this__u8e3s4, event.g3t_1);
}
function findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy) {
  guest.addComponent(new AutoAdaptSessionComponent());
  var invalidSnapResult = {_v: null};
  var tmp0_safe_receiver = get_snapRoot(guest);
  var originalParent = tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver);
  var tmp = asSequence_0(get_variantEntities(guest));
  var tmp_0 = filter(tmp, AutoAdaptService$findWithAutoAdapt$lambda(guest));
  var tmp_1 = filter(tmp_0, AutoAdaptService$findWithAutoAdapt$lambda_0($this, host));
  var tmp_2 = onEach(tmp_1, AutoAdaptService$findWithAutoAdapt$lambda_1($this, guest));
  var tmp_3 = onEach(tmp_2, AutoAdaptService$findWithAutoAdapt$lambda_2($this, guest));
  var tmp_4 = map(tmp_3, AutoAdaptService$findWithAutoAdapt$lambda_3(guest, $this, host, snapSettings, invalidSnapResult, sortAndSelectStrategy));
  var tmp_5 = onEach(tmp_4, AutoAdaptService$findWithAutoAdapt$lambda_4(invalidSnapResult));
  var validSnapResult = firstOrNull(mapNotNull(tmp_5, AutoAdaptService$findWithAutoAdapt$lambda_5($this)));
  var tmp2_safe_receiver = validSnapResult == null ? null : validSnapResult.snap;
  var autoAdaptedEntity = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.guestRoot;
  if (autoAdaptedEntity == null) {
    var tmp3_safe_receiver = get_snapRoot(guest);
    if (tmp3_safe_receiver == null)
      null;
    else {
      setParent(tmp3_safe_receiver, originalParent);
    }
  } else {
    Companion_getInstance_7().g32(guest, true);
    Companion_getInstance_7().h32(autoAdaptedEntity, true);
    var tmp4_safe_receiver = get_snapRoot(guest);
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      triggerReplaceEvent(autoAdaptedEntity, $this, tmp4_safe_receiver);
    }
  }
  var tmp6_elvis_lhs = validSnapResult == null ? invalidSnapResult._v : validSnapResult;
  var tmp_6;
  if (tmp6_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp_7 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = [Companion_instance_2.fail('No snaps', get_productRefOrEmptyString(guest), null)];
    tmp_6 = new ValidSnapActionCandidateOrErrors(null, tmp_7, tmp$ret$4);
  } else {
    tmp_6 = tmp6_elvis_lhs;
  }
  return tmp_6;
}
function findWithAutoAdapt$default($this, host, guest, snapSettings, sortAndSelectStrategy, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings(false, VOID, VOID, false) : snapSettings;
  return findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy);
}
function restrictAllowedRequiredHostsOnVariant($this, originalGuest, variant) {
  var restricted = originalGuest.__getComponentForKotlin(Companion_instance_7.id);
  if (!(restricted == null)) {
    variant.addComponent(restricted);
  } else {
    variant.removeComponent(Companion_instance_7.id);
  }
}
function canSnap($this, guest, host) {
  var tmp$ret$3;
  $l$block_1: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = get_snappingEntitiesSequence(guest).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.canSnap.<anonymous>' call
      var tmp0_safe_receiver = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i1l_1;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp1_safe_receiver, Collection)) {
            tmp_0 = tmp1_safe_receiver.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator_0 = tmp1_safe_receiver.k();
          while (tmp0_iterator_0.m()) {
            var element_0 = tmp0_iterator_0.n();
            // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.canSnap.<anonymous>.<anonymous>' call
            if (any_1(element_0.k2b(get_connectorsComponent(host)))) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      }
      var tmp2_elvis_lhs = tmp;
      if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
        tmp$ret$3 = true;
        break $l$block_1;
      }
    }
    tmp$ret$3 = false;
  }
  return tmp$ret$3;
}
function onlyValidSnap($this, snapResult) {
  var tmp;
  if (snapResult.valid) {
    tmp = snapResult;
  } else {
    tmp = null;
  }
  return tmp;
}
function snapToValidSnap($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy) {
  var anyResult = {_v: null};
  var snapSettings = new SnapSettings(includeSubConnectors, VOID, VOID, includeAlignmentConnectorsOutsideActivationDistance);
  var snapsSorted = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.p1l(guest, host, snapSettings));
  // Inline function 'kotlin.collections.isEmpty' call
  if (snapsSorted.length === 0) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = [new NoValidConnectorAvailableValidationResult(get_productRefOrEmptyString(guest))];
    return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$4);
  }
  var bestWarning = {_v: null};
  var tmp_0 = asSequence_0(snapsSorted);
  var tmp_1 = map(tmp_0, AutoAdaptService$snapToValidSnap$lambda($this, anyResult, bestWarning));
  var valid = firstOrNull(filter(tmp_1, AutoAdaptService$snapToValidSnap$lambda_0(sortByWarnings)));
  var tmp1_elvis_lhs = valid == null ? null : valid.toValidSnapActionCandidateOrErrors();
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = bestWarning._v;
    tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toValidSnapActionCandidateOrErrors();
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? anyResult._v : tmp3_elvis_lhs;
  var tmp_3;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp_4 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [new UnknownErrorValidationResult(get_productRefOrEmptyString(guest))];
    tmp_3 = new ValidSnapActionCandidateOrErrors(null, tmp_4, tmp$ret$8);
  } else {
    tmp_3 = tmp4_elvis_lhs;
  }
  return tmp_3;
}
function snapToValidSnap$default($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy, $super) {
  includeSubConnectors = includeSubConnectors === VOID ? false : includeSubConnectors;
  includeAlignmentConnectorsOutsideActivationDistance = includeAlignmentConnectorsOutsideActivationDistance === VOID ? false : includeAlignmentConnectorsOutsideActivationDistance;
  return snapToValidSnap($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy);
}
function snapAndValidateVariant($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy) {
  var firstInvalidResult = null;
  var snapsSorted = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.p1l(possibleVariant, host, snapSettings));
  // Inline function 'kotlin.collections.isEmpty' call
  if (snapsSorted.length === 0) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = [new NoValidConnectorAvailableValidationResult(get_productRefOrEmptyString(possibleVariant))];
    return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$4);
  }
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = snapsSorted.length;
  while (inductionVariable < last) {
    var element = snapsSorted[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.snapAndValidateVariant.<anonymous>' call
    var result = $this.i3t_1.validateSnapCandidate(element, earlyOut || !(firstInvalidResult == null));
    if (result.valid) {
      return result.toValidSnapActionCandidateOrErrors();
    }
    if (firstInvalidResult == null) {
      firstInvalidResult = result.toValidSnapActionCandidateOrErrors();
    }
  }
  var tmp0_elvis_lhs = firstInvalidResult;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp_1 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [new UnknownErrorValidationResult(get_productRefOrEmptyString(possibleVariant))];
    tmp_0 = new ValidSnapActionCandidateOrErrors(null, tmp_1, tmp$ret$8);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function snapAndValidateVariant$default($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings(false, VOID, VOID, false) : snapSettings;
  return snapAndValidateVariant($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy);
}
function prepareVariantForSnapping($this, originalEntity, variant) {
  var tmp0_elvis_lhs = get_snapRoot(originalEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var originalRootEntity = tmp;
  setParent(variant, null);
  setParent(originalRootEntity, null);
  Companion_instance_8.z1l(variant, get_worldTransform(originalRootEntity));
}
function findWithAutoAdapt$combineInvalidResult(invalidSnapResult, newFail) {
  if (newFail.valid)
    return Unit_instance;
  var tmp;
  if (invalidSnapResult._v == null) {
    tmp = newFail;
  } else {
    var tmp0_safe_receiver = invalidSnapResult._v;
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.combineFailures(newFail);
  }
  invalidSnapResult._v = tmp;
}
function AutoAdaptService$findWithAutoAdapt$lambda($guest) {
  return function (it) {
    return !(get_productRef(it) == get_productRef($guest));
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_0(this$0, $host) {
  return function (it) {
    var tmp0_elvis_lhs = get_snapRoot(it);
    return canSnap(this$0, tmp0_elvis_lhs == null ? it : tmp0_elvis_lhs, $host);
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_1(this$0, $guest) {
  return function (it) {
    restrictAllowedRequiredHostsOnVariant(this$0, $guest, it);
    return Unit_instance;
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_2(this$0, $guest) {
  return function (it) {
    prepareVariantForSnapping(this$0, $guest, it);
    return Unit_instance;
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_3($guest, this$0, $host, $snapSettings, $invalidSnapResult, $sortAndSelectStrategy) {
  return function (it) {
    it.addComponent(new AutoAdaptVariantComponent($guest));
    var result = snapAndValidateVariant(this$0, it, $host, $snapSettings, !($invalidSnapResult._v == null), $sortAndSelectStrategy);
    return result;
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_4($invalidSnapResult) {
  return function (it) {
    var tmp;
    if (!it.valid) {
      findWithAutoAdapt$combineInvalidResult($invalidSnapResult, it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function AutoAdaptService$findWithAutoAdapt$lambda_5(this$0) {
  return function (it) {
    return onlyValidSnap(this$0, it);
  };
}
function AutoAdaptService$snapToValidSnap$lambda(this$0, $anyResult, $bestWarning) {
  return function (it) {
    var res = this$0.i3t_1.validateSnapCandidate(it, !($anyResult._v == null));
    var tmp;
    if ($anyResult._v == null) {
      $anyResult._v = res.toValidSnapActionCandidateOrErrors();
      tmp = Unit_instance;
    }
    var tmp_0;
    if (res.valid && any(res.warnings)) {
      var tmp_1;
      var tmp_2;
      if ($bestWarning._v == null) {
        tmp_2 = true;
      } else {
        // Inline function 'kotlin.collections.count' call
        var tmp_3 = ensureNotNull($bestWarning._v).warnings.length;
        // Inline function 'kotlin.collections.count' call
        tmp_2 = tmp_3 > res.warnings.length;
      }
      if (tmp_2) {
        $bestWarning._v = res;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    var tmp_4;
    if (!ensureNotNull($anyResult._v).valid && !res.valid && !equals(ensureNotNull($anyResult._v).snap, res.snap)) {
      $anyResult._v = ensureNotNull($anyResult._v).combineFailuresWithValidatedSnapCandidate(res);
      tmp_4 = Unit_instance;
    }
    return res;
  };
}
function AutoAdaptService$snapToValidSnap$lambda_0($sortByWarnings) {
  return function (it) {
    return $sortByWarnings ? it.valid && none(it.warnings) : it.valid;
  };
}
function AutoAdaptService(coreServices) {
  this.coreServices = coreServices;
  this.h3t_1 = this.coreServices.sceneManager;
  this.i3t_1 = this.coreServices.validations;
}
protoOf(AutoAdaptService).j3t = function () {
  return this.coreServices;
};
protoOf(AutoAdaptService).k3t = function (guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy) {
  var snapWithoutAutoAdaptResult = snapToValidSnap(this, guest, host, snapSettings.includeAllSubConnectors, sortByWarnings, snapSettings.includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy);
  var tmp;
  if (snapWithoutAutoAdaptResult.valid) {
    tmp = snapWithoutAutoAdaptResult;
  } else {
    var result = snapToValidAutoAdaptedSnap(this, guest, host, snapSettings, sortAndSelectStrategy);
    tmp = result.valid ? result : snapWithoutAutoAdaptResult.combineFailures(result);
  }
  return tmp;
};
protoOf(AutoAdaptService).findValidSnapActionWithAutoAdapt = function (guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings(VOID, VOID, VOID, true) : snapSettings;
  sortByWarnings = sortByWarnings === VOID ? true : sortByWarnings;
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().r35_1 : sortAndSelectStrategy;
  return this.k3t(guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy);
};
protoOf(AutoAdaptService).findClosestAutoAdaptHost = function (entity, point) {
  return Companion_instance_49.l3t(this.h3t_1.scene, entity, point);
};
protoOf(AutoAdaptService).findAutoAdaptHostsContainingPoint = function (entity, point) {
  var tmp0_elvis_lhs = get_parentComponent(this.h3t_1.scene);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var scene = tmp;
  var allHosts = Companion_instance_49.m3t(scene, entity);
  return findAllHostsContainingPointSortedBySize(allHosts, point);
};
function EntityWithSensorZone(entity, zone) {
  this.entity = entity;
  this.zone = zone;
}
protoOf(EntityWithSensorZone).v2i = function () {
  return this.entity;
};
protoOf(EntityWithSensorZone).n3t = function () {
  return this.zone;
};
protoOf(EntityWithSensorZone).tf = function () {
  return this.entity;
};
protoOf(EntityWithSensorZone).uf = function () {
  return this.zone;
};
protoOf(EntityWithSensorZone).o3t = function (entity, zone) {
  return new EntityWithSensorZone(entity, zone);
};
protoOf(EntityWithSensorZone).copy = function (entity, zone, $super) {
  entity = entity === VOID ? this.entity : entity;
  zone = zone === VOID ? this.zone : zone;
  return this.o3t(entity, zone);
};
protoOf(EntityWithSensorZone).toString = function () {
  return 'EntityWithSensorZone(entity=' + this.entity.toString() + ', zone=' + toString(this.zone) + ')';
};
protoOf(EntityWithSensorZone).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + hashCode(this.zone) | 0;
  return result;
};
protoOf(EntityWithSensorZone).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityWithSensorZone))
    return false;
  var tmp0_other_with_cast = other instanceof EntityWithSensorZone ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!equals(this.zone, tmp0_other_with_cast.zone))
    return false;
  return true;
};
function findAllHostsContainingPointSortedBySize(hosts, point) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(hosts.length);
  var inductionVariable = 0;
  var last = hosts.length;
  while (inductionVariable < last) {
    var item = hosts[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var entity = item.tf();
    var zone = item.uf();
    var rotatedPolyhedron = Companion_instance_8.v1y(zone, entity);
    var boundingBox = rotatedPolyhedron.axisAlignedBoundingBox;
    var tmp$ret$0 = new Pair(entity, boundingBox);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var boundingBox_0 = element.uf();
    if (boundingBox_0.containsPoint(point)) {
      destination_0.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
  var tmp0_iterator_0 = destination_0.k();
  while (tmp0_iterator_0.m()) {
    var item_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var entity_0 = item_0.tf();
    var boundingBox_1 = item_0.uf();
    var tmp$ret$6 = new Pair(entity_0, boundingBox_1.size.size);
    destination_1.h(tmp$ret$6);
  }
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = findAllHostsContainingPointSortedBySize$lambda;
  var tmp$ret$9 = new sam$kotlin_Comparator$0_0(tmp);
  var this_0 = sortedWith(destination_1, tmp$ret$9);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator_1 = this_0.k();
  while (tmp0_iterator_1.m()) {
    var item_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var tmp$ret$11 = item_1.rf_1;
    destination_2.h(tmp$ret$11);
  }
  return copyToArray(destination_2);
}
function findClosestHostContainingPoint(hosts, point) {
  return firstOrNull_0(findAllHostsContainingPointSortedBySize(hosts, point));
}
function sam$kotlin_Comparator$0_0(function_0) {
  this.p3t_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).md = function (a, b) {
  return this.p3t_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).s3 = function () {
  return this.p3t_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.s3());
};
function findAllHostsContainingPointSortedBySize$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
  var size = a.uf();
  var tmp = size;
  // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
  var size_0 = b.uf();
  return compareValues(tmp, size_0);
}
function get_defaultHierarchyAutoAdaptSnapSettings() {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  return defaultHierarchyAutoAdaptSnapSettings;
}
var defaultHierarchyAutoAdaptSnapSettings;
function get_defaultMultipleAutoAdaptSnapSettings() {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  return defaultMultipleAutoAdaptSnapSettings;
}
var defaultMultipleAutoAdaptSnapSettings;
function get_defaultSolitaireAutoAdaptSnapSettings() {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  return defaultSolitaireAutoAdaptSnapSettings;
}
var defaultSolitaireAutoAdaptSnapSettings;
function findClosestHost($this, hosts, point) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(hosts.length);
  var inductionVariable = 0;
  var last = hosts.length;
  while (inductionVariable < last) {
    var item = hosts[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.findClosestHost.<anonymous>' call
    var testEntity = item.tf();
    var testPosition = get_worldPosition(testEntity);
    var distance = point.minus(testPosition);
    var tmp$ret$0 = new Pair(distance.size, testEntity);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = AutoAdaptUtils$Companion$findClosestHost$lambda;
  var tmp$ret$3 = new sam$kotlin_Comparator$0_1(tmp);
  var this_0 = sortedWith(destination, tmp$ret$3);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.findClosestHost.<anonymous>' call
    var testEntity_0 = item_0.uf();
    destination_0.h(testEntity_0);
  }
  return firstOrNull_1(destination_0);
}
function sam$kotlin_Comparator$0_1(function_0) {
  this.q3t_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_1).md = function (a, b) {
  return this.q3t_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).s3 = function () {
  return this.q3t_1;
};
protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
  return hashCode(this.s3());
};
function AutoAdaptUtils$Companion$findClosestHost$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.autoadapt.Companion.findClosestHost.<anonymous>' call
  var distance = a.tf();
  var tmp = distance;
  // Inline function 'com.ikea.core.stl.autoadapt.Companion.findClosestHost.<anonymous>' call
  var distance_0 = b.tf();
  return compareValues(tmp, distance_0);
}
function Companion_10() {
}
protoOf(Companion_10).l3t = function (hierarchy, entity, point) {
  var tmp0_elvis_lhs = get_parentComponent(hierarchy);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var scene = tmp;
  var allHosts = this.m3t(scene, entity);
  var tmp1_elvis_lhs = findClosestHostContainingPoint(allHosts, point);
  return tmp1_elvis_lhs == null ? findClosestHost(this, allHosts, point) : tmp1_elvis_lhs;
};
protoOf(Companion_10).r3t = function (hierarchy, entity, point) {
  var tmp0_elvis_lhs = get_parentComponent(hierarchy);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var scene = tmp;
  var allHosts = this.m3t(scene, entity);
  return findClosestHostContainingPoint(allHosts, point);
};
protoOf(Companion_10).m3t = function (scene, entity) {
  var myHierarchy = get_hierarchy(entity);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = scene.allDescendants();
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.findAllAutoAdaptHostsInScene.<anonymous>' call
    if (!contains(myHierarchy, element)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.findAllAutoAdaptHostsInScene.<anonymous>' call
    var autoAdaptHostComponent = element_0.__getComponentForKotlin(Companion_getInstance_62().id);
    var tmp;
    if (!(autoAdaptHostComponent == null)) {
      tmp = new EntityWithSensorZone(element_0, autoAdaptHostComponent.hostZone);
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver);
    }
  }
  return copyToArray(destination_0);
};
protoOf(Companion_10).s3t = function (entity) {
  return get_variantEntities(entity);
};
protoOf(Companion_10).t3t = function (entity) {
  return get_hasAutoAdapted(entity);
};
protoOf(Companion_10).u3t = function (entity) {
  return get_autoAdaptOriginalEntity(entity);
};
protoOf(Companion_10).v3t = function (guest, host, snapSettings) {
  var originalTransform = get_worldTransform(guest);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_variantEntities(guest);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.getAutoAdaptSnapCandidates.<anonymous>' call
    Companion_instance_8.z1l(element, originalTransform);
    var tmp;
    if (snapSettings.includeHostAssemblyParts) {
      tmp = toList(Companion_instance_1.p1l(element, host, snapSettings));
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = Companion_instance_1.d3e(element, host, snapSettings);
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = this_1.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.autoadapt.Companion.getAutoAdaptSnapCandidates.<anonymous>.<anonymous>' call
        if (!element_0.isAlignmentSnap) {
          destination_0.h(element_0);
        }
      }
      tmp = destination_0;
    }
    var list = tmp;
    addAll(destination, list);
  }
  var candidates = copyToArray(destination);
  return candidates;
};
protoOf(Companion_10).getAutoAdaptSnapCandidates$default = function (guest, host, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultSolitaireAutoAdaptSnapSettings() : snapSettings;
  return $super === VOID ? this.v3t(guest, host, snapSettings) : $super.v3t.call(this, guest, host, snapSettings);
};
protoOf(Companion_10).w3t = function (guest, hosts, snapSettings) {
  var originalTransform = get_worldTransform(guest);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_variantEntities(guest);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.getAutoAdaptCandidatesMultipleHosts.<anonymous>' call
    Companion_instance_8.z1l(element, originalTransform);
    var candidates = Companion_instance_1.p39(element, hosts, snapSettings);
    var list = toList(candidates);
    addAll(destination, list);
  }
  var candidatesIncludingAlignment = copyToArray(destination);
  return candidatesIncludingAlignment;
};
protoOf(Companion_10).getAutoAdaptCandidatesMultipleHosts$default = function (guest, hosts, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultMultipleAutoAdaptSnapSettings() : snapSettings;
  return $super === VOID ? this.w3t(guest, hosts, snapSettings) : $super.w3t.call(this, guest, hosts, snapSettings);
};
protoOf(Companion_10).x3t = function (guest, hierarchyRoot, snapSettings) {
  var originalTransform = get_worldTransform(guest);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_variantEntities(guest);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.Companion.getAutoAdaptCandidatesInHierarchy.<anonymous>' call
    Companion_instance_8.z1l(element, originalTransform);
    var candidates = Companion_instance_1.p39(element, hierarchyExceptSubTreeArray(hierarchyRoot, guest), snapSettings);
    var list = toList(candidates);
    addAll(destination, list);
  }
  var candidatesIncludingAlignments = copyToArray(destination);
  return candidatesIncludingAlignments;
};
protoOf(Companion_10).getAutoAdaptCandidatesInHierarchy$default = function (guest, hierarchyRoot, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultHierarchyAutoAdaptSnapSettings() : snapSettings;
  return $super === VOID ? this.x3t(guest, hierarchyRoot, snapSettings) : $super.x3t.call(this, guest, hierarchyRoot, snapSettings);
};
var Companion_instance_49;
function Companion_getInstance_53() {
  return Companion_instance_49;
}
function findClosestAutoAdaptHost(hierarchy, entity, point) {
  return Companion_instance_49.l3t(hierarchy, entity, point);
}
function findClosestAutoAdaptHostContainingPoint(hierarchy, entity, point) {
  return Companion_instance_49.r3t(hierarchy, entity, point);
}
function findAllAutoAdaptHostsInScene(scene, entity) {
  return Companion_instance_49.m3t(scene, entity);
}
function getAutoAdaptVariants(entity) {
  return Companion_instance_49.s3t(entity);
}
function isAutoAdapted(entity) {
  return Companion_instance_49.t3t(entity);
}
function getAutoAdaptOriginalEntity(entity) {
  return Companion_instance_49.u3t(entity);
}
function getAutoAdaptSnapCandidates(guest, host, snapSettings) {
  return Companion_instance_49.v3t(guest, host, snapSettings);
}
function getAutoAdaptSnapCandidates_0(guest, host, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultSolitaireAutoAdaptSnapSettings() : snapSettings;
  return getAutoAdaptSnapCandidates(guest, host, snapSettings);
}
function getAutoAdaptCandidatesMultipleHosts(guest, hosts, snapSettings) {
  return Companion_instance_49.w3t(guest, hosts, snapSettings);
}
function getAutoAdaptCandidatesMultipleHosts_0(guest, hosts, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultMultipleAutoAdaptSnapSettings() : snapSettings;
  return getAutoAdaptCandidatesMultipleHosts(guest, hosts, snapSettings);
}
function getAutoAdaptCandidatesInHierarchy(guest, hierarchyRoot, snapSettings) {
  return Companion_instance_49.x3t(guest, hierarchyRoot, snapSettings);
}
function getAutoAdaptCandidatesInHierarchy_0(guest, hierarchyRoot, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? get_defaultHierarchyAutoAdaptSnapSettings() : snapSettings;
  return getAutoAdaptCandidatesInHierarchy(guest, hierarchyRoot, snapSettings);
}
function AutoAdaptUtils() {
}
function get_variantEntities(_this__u8e3s4) {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  if (!_this__u8e3s4.hasComponent(Companion_getInstance_61().id)) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [_this__u8e3s4];
  }
  _this__u8e3s4.addComponent(new AutoAdaptSessionComponent());
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_58().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.variants;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [_this__u8e3s4];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function get_hasAutoAdapted(_this__u8e3s4) {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  return !(get_autoAdaptOriginalEntity(_this__u8e3s4) == null) && !equals(get_autoAdaptOriginalEntity(_this__u8e3s4), _this__u8e3s4);
}
function get_autoAdaptOriginalEntity(_this__u8e3s4) {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_64().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.originalEntity;
}
function get_variants(_this__u8e3s4) {
  _init_properties_AutoAdaptUtils_kt__z8ot9a();
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_61().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.variants;
}
var properties_initialized_AutoAdaptUtils_kt_l8ymm8;
function _init_properties_AutoAdaptUtils_kt__z8ot9a() {
  if (!properties_initialized_AutoAdaptUtils_kt_l8ymm8) {
    properties_initialized_AutoAdaptUtils_kt_l8ymm8 = true;
    defaultHierarchyAutoAdaptSnapSettings = new SnapSettings(false, false, false, true);
    defaultMultipleAutoAdaptSnapSettings = new SnapSettings(false, false, true, true);
    defaultSolitaireAutoAdaptSnapSettings = new SnapSettings(false, false, false, false);
  }
}
function Companion_11() {
  Companion_instance_50 = this;
  this.ID = Companion_instance_0.w1r_1;
}
protoOf(Companion_11).j1y = function () {
  return this.ID;
};
var Companion_instance_50;
function Companion_getInstance_54() {
  if (Companion_instance_50 == null)
    new Companion_11();
  return Companion_instance_50;
}
function AutoAdaptChildFailedEventComponent() {
  Companion_getInstance_54();
  this.y3t_1 = Companion_getInstance_54().ID;
}
protoOf(AutoAdaptChildFailedEventComponent).p1s = function () {
  return this.y3t_1;
};
protoOf(AutoAdaptChildFailedEventComponent).eq = function (other) {
  return false;
};
function onPostSnapAutoAdaptVariant($this, entity) {
  var tmp0_elvis_lhs = get_connectionRootEntity(entity);
  var root = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  if (!get_hasAutoAdapted(root))
    return Unit_instance;
  var tmp1_safe_receiver = get_autoAdaptOriginalEntity(root);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.onPostSnapAutoAdaptVariant.<anonymous>' call
    tmp = getChildrenToResnap($this, tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var childrenToResnap = tmp_0;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = childrenToResnap.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.onPostSnapAutoAdaptVariant.<anonymous>' call
    reSnap($this, element, root);
  }
}
function reSnap($this, childInfo, host) {
  var tmp0_elvis_lhs = $this.coreServices.entityManager.findEntity(childInfo.l3u_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Could not find entity any more';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var originalChildEntity = tmp;
  var tmp_0 = Companion_getInstance_55().q3s_1;
  tmp_0.debug(AutoAdaptChildrenSystem$reSnap$lambda(originalChildEntity, host));
  var assemblyEntities = Companion_instance_3.w2q(host);
  var tmp1_safe_receiver = childInfo.o3u_1;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.reSnap.<anonymous>' call
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = assemblyEntities.length;
      while (inductionVariable < last) {
        var element = assemblyEntities[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.reSnap.<anonymous>.<anonymous>' call
        if (get_partKey(element) === tmp1_safe_receiver) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_1 = tmp$ret$1;
  }
  var tmp2_elvis_lhs = tmp_1;
  var realHost = tmp2_elvis_lhs == null ? host : tmp2_elvis_lhs;
  originalChildEntity.addComponent(new AutoAdaptSessionComponent());
  var preferredGuest = getPreferredGuestVariant($this, originalChildEntity);
  var candidates = Companion_instance_49.v3t(preferredGuest, realHost, new SnapSettings(true));
  var snapSorter = (new SnapSorterBuilder()).addCustomCriterion(new PreferGuestCriterion(preferredGuest)).addCustomCriterion(new PreferSameConnectorsCriterion(childInfo)).addOriginalVariantCriterion().addDistanceCriterion().build();
  var sortedCandidates = snapSorter.sortCandidates(candidates);
  var result = $this.coreServices.validations.getFirstValidSnap(sortedCandidates, false);
  var validCandidate = result.snap;
  if (!(validCandidate == null)) {
    validCandidate.performMoveAndConnect();
    var tmp_2 = Companion_getInstance_55().q3s_1;
    tmp_2.debug(AutoAdaptChildrenSystem$reSnap$lambda_0(validCandidate));
  } else {
    var tmp_3 = Companion_getInstance_55().q3s_1;
    tmp_3.debug(AutoAdaptChildrenSystem$reSnap$lambda_1(result));
    originalChildEntity.addComponent(new AutoAdaptChildFailedEventComponent());
    originalChildEntity.removeComponent(Companion_getInstance_59().ID);
    originalChildEntity.removeComponent(Companion_getInstance_3().id);
    originalChildEntity.removeComponent(Companion_getInstance_54().ID);
  }
}
function getPreferredGuestVariant($this, originalEntity) {
  var forceAutoAdapt = originalEntity.hasComponent(Companion_getInstance_65().id);
  // Inline function 'kotlin.takeIf' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>' call
  if (forceAutoAdapt) {
    tmp = forceAutoAdapt;
  } else {
    tmp = null;
  }
  var tmp_0;
  if (tmp == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var indexedObject = get_variantEntities(originalEntity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>.<anonymous>' call
        var tmp_1 = get_productRef(element);
        var tmp0_safe_receiver = get_variants(originalEntity);
        if (tmp_1 == (tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver))) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0 = tmp0_elvis_lhs == null ? originalEntity : tmp0_elvis_lhs;
  }
  var tmp1_elvis_lhs = tmp_0;
  var guest = tmp1_elvis_lhs == null ? originalEntity : tmp1_elvis_lhs;
  return guest;
}
function getChildrenToResnap($this, entity) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_immediateConnectionRootDescendants(entity);
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getChildrenToResnap.<anonymous>' call
    if (!get_isPropping(element)) {
      destination.h(element);
    }
  }
  var children = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = children.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getChildrenToResnap.<anonymous>' call
    var tmp0_safe_receiver = createChildInfo($this, element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver);
    }
  }
  return destination_0;
}
function createChildInfo($this, entity) {
  var tmp0_safe_receiver = get_highestPriorityConnection(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var partKey = get_partKey(tmp0_safe_receiver.hostConnectorEntity);
    return new ChildInfo(entity.id, tmp0_safe_receiver.guestConnectorKey, tmp0_safe_receiver.hostConnectorKey, partKey, getChildrenToResnap($this, entity));
  }
  return null;
}
function ChildInfo(originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap) {
  this.l3u_1 = originalEntityId;
  this.m3u_1 = guestConnector;
  this.n3u_1 = hostConnector;
  this.o3u_1 = hostPartKey;
  this.p3u_1 = childrenToResnap;
}
protoOf(ChildInfo).toString = function () {
  return 'ChildInfo(originalEntityId=' + this.l3u_1 + ', guestConnector=' + this.m3u_1 + ', hostConnector=' + this.n3u_1 + ', hostPartKey=' + this.o3u_1 + ', childrenToResnap=' + toString(this.p3u_1) + ')';
};
protoOf(ChildInfo).hashCode = function () {
  var result = this.l3u_1;
  result = imul(result, 31) + getStringHashCode(this.m3u_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.n3u_1) | 0;
  result = imul(result, 31) + (this.o3u_1 == null ? 0 : getStringHashCode(this.o3u_1)) | 0;
  result = imul(result, 31) + hashCode(this.p3u_1) | 0;
  return result;
};
protoOf(ChildInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ChildInfo))
    return false;
  var tmp0_other_with_cast = other instanceof ChildInfo ? other : THROW_CCE();
  if (!(this.l3u_1 === tmp0_other_with_cast.l3u_1))
    return false;
  if (!(this.m3u_1 === tmp0_other_with_cast.m3u_1))
    return false;
  if (!(this.n3u_1 === tmp0_other_with_cast.n3u_1))
    return false;
  if (!(this.o3u_1 == tmp0_other_with_cast.o3u_1))
    return false;
  if (!equals(this.p3u_1, tmp0_other_with_cast.p3u_1))
    return false;
  return true;
};
function PreferGuestCriterion(preferredGuest) {
  this.q3u_1 = preferredGuest;
}
protoOf(PreferGuestCriterion).bestResult = function (a, b) {
  return null;
};
protoOf(PreferGuestCriterion).bestCandidate = function (a, b) {
  var aGuest = a.guest.equals(this.q3u_1);
  var bGuest = b.guest.equals(this.q3u_1);
  if (aGuest === bGuest) {
    return null;
  }
  return aGuest ? a : b;
};
function PreferSameConnectorsCriterion(childInfo) {
  this.r3u_1 = childInfo;
}
protoOf(PreferSameConnectorsCriterion).bestResult = function (a, b) {
  return null;
};
protoOf(PreferSameConnectorsCriterion).bestCandidate = function (a, b) {
  var aGuest = a.guestConnector.key === this.r3u_1.m3u_1;
  var bGuest = b.guestConnector.key === this.r3u_1.m3u_1;
  var aHost = a.hostConnector.key === this.r3u_1.n3u_1;
  var bHost = b.hostConnector.key === this.r3u_1.n3u_1;
  if (aGuest && bGuest) {
    if (aHost && bHost) {
      return null;
    }
    return aHost ? a : b;
  }
  return aGuest ? a : b;
};
function Companion_12() {
  Companion_instance_51 = this;
  this.ID = 'AutoAdaptChildrenSystem';
  this.q3s_1 = LoggerState_getInstance().g1v(this.ID);
}
protoOf(Companion_12).j1y = function () {
  return this.ID;
};
var Companion_instance_51;
function Companion_getInstance_55() {
  if (Companion_instance_51 == null)
    new Companion_12();
  return Companion_instance_51;
}
function AutoAdaptChildrenSystem$reSnap$lambda($originalChildEntity, $host) {
  return function () {
    return Companion_getInstance_55().ID + ' Re-snapping ' + get_displayName($originalChildEntity) + ' to ' + get_displayName($host);
  };
}
function AutoAdaptChildrenSystem$reSnap$lambda_0($validCandidate) {
  return function () {
    var tmp = Companion_getInstance_55().ID + ' successfully snapped ' + get_displayName($validCandidate.guest) + ' to ';
    var tmp0_safe_receiver = get_parent($validCandidate.guest);
    return tmp + (tmp0_safe_receiver == null ? null : get_displayName(tmp0_safe_receiver));
  };
}
function AutoAdaptChildrenSystem$reSnap$lambda_1($result) {
  return function () {
    return Companion_getInstance_55().ID + ' Could not re-snap: ' + $result.toString();
  };
}
function AutoAdaptChildrenSystem(coreServices) {
  Companion_getInstance_55();
  SystemBase.call(this, Companion_getInstance_55().ID, Companion_getInstance_3().id);
  this.coreServices = coreServices;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i3u_1 = [Companion_getInstance_3().id];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.j3u_1 = [Companion_getInstance_1().j2a_1, Companion_instance_9.x29_1];
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_1.k3u_1 = [Companion_instance_56.r3s_1];
}
protoOf(AutoAdaptChildrenSystem).j3t = function () {
  return this.coreServices;
};
protoOf(AutoAdaptChildrenSystem).j1w = function () {
  return this.i3u_1;
};
protoOf(AutoAdaptChildrenSystem).k1w = function () {
  return this.j3u_1;
};
protoOf(AutoAdaptChildrenSystem).l1w = function () {
  return this.k3u_1;
};
protoOf(AutoAdaptChildrenSystem).l2a = function (entity, newComponent) {
  onPostSnapAutoAdaptVariant(this, entity);
};
protoOf(AutoAdaptChildrenSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
function Companion_13() {
  Companion_instance_52 = this;
  this.s3s_1 = 'AutoAdaptDisposeFailedChildrenSystem';
  this.t3s_1 = LoggerState_getInstance().g1v(this.s3s_1);
}
var Companion_instance_52;
function Companion_getInstance_56() {
  if (Companion_instance_52 == null)
    new Companion_13();
  return Companion_instance_52;
}
function AutoAdaptDisposeFailedChildrenSystem$onRemoveComponent$lambda($entity) {
  return function () {
    return Companion_getInstance_56().s3s_1 + ' Disposing entity ' + get_displayName($entity) + ' because auto adapt failed';
  };
}
function AutoAdaptDisposeFailedChildrenSystem() {
  Companion_getInstance_56();
  SystemBase.call(this, Companion_getInstance_56().s3s_1, Companion_getInstance_54().ID);
}
protoOf(AutoAdaptDisposeFailedChildrenSystem).b3v = function (entity, oldComponent) {
  if (entity.isDisposed)
    return Unit_instance;
  var tmp = Companion_getInstance_56().t3s_1;
  tmp.debug(AutoAdaptDisposeFailedChildrenSystem$onRemoveComponent$lambda(entity));
  entity.dispose();
};
protoOf(AutoAdaptDisposeFailedChildrenSystem).z1v = function (entity, oldComponent) {
  return this.b3v(entity, oldComponent instanceof AutoAdaptChildFailedEventComponent ? oldComponent : THROW_CCE());
};
function Companion_14() {
  this.p3s_1 = 'AutoAdaptCacheSystem';
}
var Companion_instance_53;
function Companion_getInstance_57() {
  return Companion_instance_53;
}
function AutoAdaptCacheSystem(productManager) {
  SystemBase.call(this, Companion_instance_53.p3s_1, Companion_getInstance_59().ID);
  this.l3v_1 = productManager;
}
protoOf(AutoAdaptCacheSystem).m3v = function (entity, newComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_61().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.variants;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var variantProductRefs = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(variantProductRefs.length);
  var inductionVariable = 0;
  var last = variantProductRefs.length;
  while (inductionVariable < last) {
    var item = variantProductRefs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onAddComponent.<anonymous>' call
      if (item === get_productRef(entity)) {
        tmp$ret$0 = entity;
        break $l$block_0;
      }
      var tmp0_elvis_lhs = this.l3v_1.createEntity(item);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var variantEntity = tmp_0;
      variantEntity.addComponentInternal(newComponent);
      variantEntity.addComponent(new AutoAdaptVariantComponent(entity));
      tmp$ret$0 = variantEntity;
    }
    destination.h(tmp$ret$0);
  }
  var this_0 = filterNotNull(destination);
  var variants = copyToArray(this_0);
  var tmp_1;
  if (contains(variants, entity)) {
    tmp_1 = variants;
  } else {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = [entity];
    tmp_1 = variants.concat(tmp$ret$7);
  }
  var actualVariants = tmp_1;
  var cachedVariantsComponent = new AutoAdaptCachedVariantsComponent(actualVariants);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = variants.length;
  while (inductionVariable_0 < last_0) {
    var element = variants[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onAddComponent.<anonymous>' call
    element.addComponent(cachedVariantsComponent);
  }
};
protoOf(AutoAdaptCacheSystem).v1v = function (entity, newComponent) {
  return this.m3v(entity, newComponent instanceof AutoAdaptSessionComponent ? newComponent : THROW_CCE());
};
protoOf(AutoAdaptCacheSystem).n3v = function (entity, oldComponent, newComponent) {
  this.o3v(entity, oldComponent);
  this.m3v(entity, newComponent);
};
protoOf(AutoAdaptCacheSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof AutoAdaptSessionComponent ? oldComponent : THROW_CCE();
  return this.n3v(entity, tmp, newComponent instanceof AutoAdaptSessionComponent ? newComponent : THROW_CCE());
};
protoOf(AutoAdaptCacheSystem).o3v = function (entity, oldComponent) {
  var cache = entity.__getComponentForKotlin(Companion_getInstance_58().id);
  var tmp1_safe_receiver = cache == null ? null : cache.variants;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onRemoveComponent.<anonymous>' call
      element.removeComponentInternal(Companion_getInstance_59().ID);
      element.removeComponent(Companion_getInstance_64().id);
      element.removeComponent(Companion_getInstance_58().id);
      if (!element.equals(entity)) {
        element.dispose();
      }
    }
  }
  entity.removeComponent(Companion_getInstance_64().id);
};
protoOf(AutoAdaptCacheSystem).z1v = function (entity, oldComponent) {
  return this.o3v(entity, oldComponent instanceof AutoAdaptSessionComponent ? oldComponent : THROW_CCE());
};
function Companion_15() {
  Companion_instance_54 = this;
  this.id = Companion_instance_0.s1r_1;
}
protoOf(Companion_15).n1s = function () {
  return this.id;
};
var Companion_instance_54;
function Companion_getInstance_58() {
  if (Companion_instance_54 == null)
    new Companion_15();
  return Companion_instance_54;
}
function AutoAdaptCachedVariantsComponent(variants) {
  Companion_getInstance_58();
  this.variants = variants;
}
protoOf(AutoAdaptCachedVariantsComponent).p3v = function () {
  return this.variants;
};
protoOf(AutoAdaptCachedVariantsComponent).p1s = function () {
  return Companion_getInstance_58().id;
};
protoOf(AutoAdaptCachedVariantsComponent).eq = function (other) {
  var otherC = other instanceof AutoAdaptCachedVariantsComponent ? other : THROW_CCE();
  var tmp;
  if (otherC.variants.length === this.variants.length) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var indexedObject = otherC.variants;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCachedVariantsComponent.eq.<anonymous>' call
        if (!contains(this.variants, element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  return tmp;
};
function Companion_16() {
  Companion_instance_55 = this;
  this.ID = Companion_instance_0.p1r_1;
}
protoOf(Companion_16).j1y = function () {
  return this.ID;
};
var Companion_instance_55;
function Companion_getInstance_59() {
  if (Companion_instance_55 == null)
    new Companion_16();
  return Companion_instance_55;
}
function AutoAdaptSessionComponent() {
  Companion_getInstance_59();
}
protoOf(AutoAdaptSessionComponent).p1s = function () {
  return Companion_getInstance_59().ID;
};
protoOf(AutoAdaptSessionComponent).eq = function (other) {
  return true;
};
function Companion_17() {
  this.r3s_1 = 'CleanCacheOnFinishedAutoAdaptSystem';
}
var Companion_instance_56;
function Companion_getInstance_60() {
  return Companion_instance_56;
}
function CleanCacheOnFinishedAutoAdaptSystem() {
  SystemBase2.call(this, Companion_instance_56.r3s_1, Companion_getInstance_3().id, Companion_getInstance_8().id);
}
protoOf(CleanCacheOnFinishedAutoAdaptSystem).l2a = function (entity, newComponent) {
  if (!entity.hasComponent(Companion_getInstance_59().ID))
    return Unit_instance;
  var original = get_autoAdaptOriginalEntity(entity);
  if (!(original == null) && get_hasAutoAdapted(entity)) {
    Companion_instance.j29(original);
  }
  entity.removeComponent(Companion_getInstance_59().ID);
};
protoOf(CleanCacheOnFinishedAutoAdaptSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(CleanCacheOnFinishedAutoAdaptSystem).b3w = function (entity, oldComponent) {
  if (oldComponent.entity.isDisposed)
    return Unit_instance;
  oldComponent.entity.removeComponent(Companion_getInstance_59().ID);
};
protoOf(CleanCacheOnFinishedAutoAdaptSystem).p1z = function (entity, oldComponent) {
  return this.b3w(entity, oldComponent instanceof SomethingIsDraggedComponent ? oldComponent : THROW_CCE());
};
function Companion_18() {
  Companion_instance_57 = this;
  this.id = Companion_instance_0.q1r_1;
}
protoOf(Companion_18).n1s = function () {
  return this.id;
};
var Companion_instance_57;
function Companion_getInstance_61() {
  if (Companion_instance_57 == null)
    new Companion_18();
  return Companion_instance_57;
}
function AutoAdaptGuestComponent(variants, groupName) {
  Companion_getInstance_61();
  groupName = groupName === VOID ? 'auto adapt group' : groupName;
  this.groupName = groupName;
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = distinct_0(variants);
  tmp.variants = copyToArray(this_0);
}
protoOf(AutoAdaptGuestComponent).c3w = function () {
  return this.groupName;
};
protoOf(AutoAdaptGuestComponent).p3v = function () {
  return this.variants;
};
protoOf(AutoAdaptGuestComponent).p1s = function () {
  return Companion_getInstance_61().id;
};
protoOf(AutoAdaptGuestComponent).eq = function (other) {
  var otherC = other instanceof AutoAdaptGuestComponent ? other : THROW_CCE();
  var tmp;
  if (other.groupName === this.groupName && otherC.variants.length === this.variants.length) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var indexedObject = otherC.variants;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.component.AutoAdaptGuestComponent.eq.<anonymous>' call
        if (!contains(this.variants, element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  return tmp;
};
function Companion_19() {
  Companion_instance_58 = this;
  this.id = Companion_instance_0.r1r_1;
}
protoOf(Companion_19).n1s = function () {
  return this.id;
};
var Companion_instance_58;
function Companion_getInstance_62() {
  if (Companion_instance_58 == null)
    new Companion_19();
  return Companion_instance_58;
}
function AutoAdaptHostComponent(hostZone) {
  Companion_getInstance_62();
  this.hostZone = hostZone;
}
protoOf(AutoAdaptHostComponent).d3w = function () {
  return this.hostZone;
};
protoOf(AutoAdaptHostComponent).p1s = function () {
  return Companion_getInstance_62().id;
};
protoOf(AutoAdaptHostComponent).eq = function (other) {
  return equals((other instanceof AutoAdaptHostComponent ? other : THROW_CCE()).hostZone, this.hostZone);
};
function Companion_20() {
  Companion_instance_59 = this;
  this.id = Companion_instance_0.x1r_1;
}
protoOf(Companion_20).n1s = function () {
  return this.id;
};
var Companion_instance_59;
function Companion_getInstance_63() {
  if (Companion_instance_59 == null)
    new Companion_20();
  return Companion_instance_59;
}
function AutoAdaptProductSpecificationsComponent(specifications) {
  Companion_getInstance_63();
  this.specifications = specifications;
  this.e3w_1 = Companion_getInstance_63().id;
}
protoOf(AutoAdaptProductSpecificationsComponent).f3w = function () {
  return this.specifications;
};
protoOf(AutoAdaptProductSpecificationsComponent).p1s = function () {
  return this.e3w_1;
};
protoOf(AutoAdaptProductSpecificationsComponent).eq = function (other) {
  return this.equals(other);
};
protoOf(AutoAdaptProductSpecificationsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AutoAdaptProductSpecificationsComponent))
    THROW_CCE();
  if (!contentEquals(this.specifications, other.specifications))
    return false;
  if (!(this.e3w_1 === other.e3w_1))
    return false;
  return true;
};
protoOf(AutoAdaptProductSpecificationsComponent).hashCode = function () {
  var result = contentHashCode(this.specifications);
  result = imul(31, result) + this.e3w_1 | 0;
  return result;
};
protoOf(AutoAdaptProductSpecificationsComponent).tf = function () {
  return this.specifications;
};
protoOf(AutoAdaptProductSpecificationsComponent).g3w = function (specifications) {
  return new AutoAdaptProductSpecificationsComponent(specifications);
};
protoOf(AutoAdaptProductSpecificationsComponent).copy = function (specifications, $super) {
  specifications = specifications === VOID ? this.specifications : specifications;
  return this.g3w(specifications);
};
protoOf(AutoAdaptProductSpecificationsComponent).toString = function () {
  return 'AutoAdaptProductSpecificationsComponent(specifications=' + toString(this.specifications) + ')';
};
function SpecificationPair(productRef, specification) {
  this.productRef = productRef;
  this.specification = specification;
}
protoOf(SpecificationPair).b1t = function () {
  return this.productRef;
};
protoOf(SpecificationPair).h3w = function () {
  return this.specification;
};
protoOf(SpecificationPair).tf = function () {
  return this.productRef;
};
protoOf(SpecificationPair).uf = function () {
  return this.specification;
};
protoOf(SpecificationPair).i3w = function (productRef, specification) {
  return new SpecificationPair(productRef, specification);
};
protoOf(SpecificationPair).copy = function (productRef, specification, $super) {
  productRef = productRef === VOID ? this.productRef : productRef;
  specification = specification === VOID ? this.specification : specification;
  return this.i3w(productRef, specification);
};
protoOf(SpecificationPair).toString = function () {
  return 'SpecificationPair(productRef=' + this.productRef + ', specification=' + this.specification.toString() + ')';
};
protoOf(SpecificationPair).hashCode = function () {
  var result = getStringHashCode(this.productRef);
  result = imul(result, 31) + this.specification.hashCode() | 0;
  return result;
};
protoOf(SpecificationPair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SpecificationPair))
    return false;
  var tmp0_other_with_cast = other instanceof SpecificationPair ? other : THROW_CCE();
  if (!(this.productRef === tmp0_other_with_cast.productRef))
    return false;
  if (!this.specification.equals(tmp0_other_with_cast.specification))
    return false;
  return true;
};
function Companion_21() {
  Companion_instance_60 = this;
  this.id = Companion_instance_0.t1r_1;
}
protoOf(Companion_21).n1s = function () {
  return this.id;
};
var Companion_instance_60;
function Companion_getInstance_64() {
  if (Companion_instance_60 == null)
    new Companion_21();
  return Companion_instance_60;
}
function AutoAdaptVariantComponent(originalEntity) {
  Companion_getInstance_64();
  this.originalEntity = originalEntity;
}
protoOf(AutoAdaptVariantComponent).j3w = function () {
  return this.originalEntity;
};
protoOf(AutoAdaptVariantComponent).p1s = function () {
  return Companion_getInstance_64().id;
};
protoOf(AutoAdaptVariantComponent).eq = function (other) {
  return (other instanceof AutoAdaptVariantComponent ? other : THROW_CCE()).originalEntity.equals(this.originalEntity);
};
function Companion_22() {
  Companion_instance_61 = this;
  this.id = Companion_instance_0.u1r_1;
}
protoOf(Companion_22).n1s = function () {
  return this.id;
};
var Companion_instance_61;
function Companion_getInstance_65() {
  if (Companion_instance_61 == null)
    new Companion_22();
  return Companion_instance_61;
}
function ForceAutoAdaptWhenParentIsDraggedComponent() {
  Companion_getInstance_65();
}
protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).p1s = function () {
  return Companion_getInstance_65().id;
};
protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).eq = function (other) {
  return true;
};
function Companion_23() {
  Companion_instance_62 = this;
  this.id = Companion_instance_0.v1r_1;
}
protoOf(Companion_23).n1s = function () {
  return this.id;
};
var Companion_instance_62;
function Companion_getInstance_66() {
  if (Companion_instance_62 == null)
    new Companion_23();
  return Companion_instance_62;
}
function ReplacedWithAutoAdaptEventComponent(oldEntity) {
  Companion_getInstance_66();
  this.oldEntity = oldEntity;
  this.g3t_1 = Companion_getInstance_66().id;
}
protoOf(ReplacedWithAutoAdaptEventComponent).k3w = function () {
  return this.oldEntity;
};
protoOf(ReplacedWithAutoAdaptEventComponent).p1s = function () {
  return this.g3t_1;
};
protoOf(ReplacedWithAutoAdaptEventComponent).eq = function (other) {
  if (!(other instanceof ReplacedWithAutoAdaptEventComponent))
    return false;
  return other.oldEntity.equals(this.oldEntity);
};
function snapOrAutoAdapt($this, draggedRoot) {
  var oldParent = get_parent(draggedRoot);
  var hoveredHost = Companion_instance_49.r3t($this.j3t().sceneManager.scene, draggedRoot, get_worldPosition(draggedRoot));
  var candidates = !(hoveredHost == null) ? Companion_instance_49.v3t(draggedRoot, hoveredHost, new SnapSettings(VOID, VOID, true)) : Companion_instance_49.getAutoAdaptCandidatesInHierarchy$default(draggedRoot, $this.j3t().sceneManager.scene);
  var sortedCandidates = sortAndSelect($this, candidates);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = sortedCandidates.length;
  while (inductionVariable < last) {
    var element = sortedCandidates[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.snapOrAutoAdapt.<anonymous>' call
    if (!element.guestRoot.equals(draggedRoot)) {
      setParent(draggedRoot, null);
    }
    var result = $this.j3t().validations.validateSnapCandidate(element, true);
    if (result.valid) {
      if (draggedRoot.equals(element.guestRoot)) {
        setParent(draggedRoot, oldParent);
      } else {
        loadModelOfValidVariant($this, element.guestRoot);
        updateDraggedComponents($this, draggedRoot, element.guestRoot);
        setParent(element.guestRoot, $this.j3t().sceneManager.scene);
        element.performMove();
      }
      return new ValidAutoAdaptDragStrategyResult(element.guestRoot, element, result.warnings);
    }
  }
  setParent(draggedRoot, oldParent);
  return null;
}
function sortAndSelect($this, candidates) {
  var sortedCandidates = $this.p3w_1.sortCandidates(candidates);
  if (any(sortedCandidates))
    return sortedCandidates;
  return $this.q3w_1.sortCandidates(candidates);
}
function updateDraggedComponents($this, draggedRootEntity, foundEntityVariant) {
  draggedRootEntity.removeComponent(Companion_instance_73.id);
  foundEntityVariant.addComponent(new IsDraggedComponent());
  resumeViewerUpdatesOnDraggedEntity($this.j3t().sceneManager);
  $this.j3t().sceneManager.scene.addComponent(new SomethingIsDraggedComponent(foundEntityVariant));
  pauseViewerUpdatesOnDraggedEntity($this.j3t().sceneManager);
}
function loadModelOfValidVariant($this, entity) {
  var tmp0_safe_receiver = $this.j3t().coreModules.viewer();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.loadModelOfValidVariant.<anonymous>' call
    if (!entity.hasComponent(Companion_getInstance_9().id)) {
      Companion_getInstance_7().q31(entity, tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.loadModelOfValidVariant.<anonymous>.<anonymous>' call
      loadModelOfValidVariant($this, element);
    }
  }
}
function AutoAdaptDragStrategy(coreServices) {
  AbstractDragStrategy.call(this);
  this.m3w_1 = coreServices;
  this.n3w_1 = 'AutoAdaptDragStrategy';
  this.o3w_1 = null;
  this.p3w_1 = (new SnapSorterBuilder()).addInActivationDistanceFilter().addOriginalVariantCriterion().addConnectorPriorityCriterion(Companion_getInstance_125().s3w_1).addDistanceCriterion().build();
  this.q3w_1 = (new SnapSorterBuilder()).addConnectorPriorityCriterion(Companion_getInstance_125().r3w_1).addDistanceCriterion().build();
}
protoOf(AutoAdaptDragStrategy).j3t = function () {
  return this.m3w_1;
};
protoOf(AutoAdaptDragStrategy).v2 = function () {
  return this.n3w_1;
};
protoOf(AutoAdaptDragStrategy).dragStart = function (draggedRootEntity) {
  var tmp0_elvis_lhs = get_variants(draggedRootEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var variants = tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (variants.length === 0)
    return Unit_instance;
  this.o3w_1 = draggedRootEntity.id;
  draggedRootEntity.addComponent(new AutoAdaptSessionComponent());
};
protoOf(AutoAdaptDragStrategy).dragMove = function (dragState) {
  var tmp0_elvis_lhs = get_variants(dragState.draggedRootEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var variants = tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (variants.length === 0)
    return null;
  return snapOrAutoAdapt(this, dragState.draggedRootEntity);
};
function connectorsFromSpecifications($this, variants) {
  var tmp = asSequence_0(variants);
  return map(tmp, DragSurfaceCanHostWithAutoAdaptSelector$connectorsFromSpecifications$lambda);
}
function Companion_24() {
  Companion_instance_63 = this;
  this.logger = LoggerState_getInstance().g1v('DragSurfaceCanHostWithAutoAdaptSelector');
}
protoOf(Companion_24).l1k = function () {
  return this.logger;
};
var Companion_instance_63;
function Companion_getInstance_67() {
  if (Companion_instance_63 == null)
    new Companion_24();
  return Companion_instance_63;
}
function DragSurfaceCanHostWithAutoAdaptSelector$lambda() {
  return "System with id '" + Companion_instance_48.ID + "' not enabled which is " + 'required for this system to work. Did you forget to run ' + "'new AutoAdaptProductSpecificationsSystem(entityManager, productManager)'";
}
function DragSurfaceCanHostWithAutoAdaptSelector$canProjectDragOn$lambda(snappingGuest) {
  var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function DragSurfaceCanHostWithAutoAdaptSelector$connectorsFromSpecifications$lambda(specificationPair) {
  var tmp0_safe_receiver = specificationPair.specification.findComponent(Companion_getInstance_5().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function DragSurfaceCanHostWithAutoAdaptSelector(entityManager) {
  Companion_getInstance_67();
  DragSurfaceCanHostSelector.call(this);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = entityManager.getSystemsRegistered();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.drag.DragSurfaceCanHostWithAutoAdaptSelector.<anonymous>' call
      if (element.id === Companion_instance_48.ID) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  var requiredSystemEnabled = tmp$ret$1;
  if (!requiredSystemEnabled) {
    var tmp = Companion_getInstance_67().logger;
    tmp.warn(DragSurfaceCanHostWithAutoAdaptSelector$lambda);
  }
}
protoOf(DragSurfaceCanHostWithAutoAdaptSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
  var tmp0_safe_receiver = get_connectorsComponent(dragSurface.entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var hostConnectors = tmp;
  var tmp_0 = get_snappingGuestEntitiesSequence(draggedEntity);
  var childSequence = map(tmp_0, DragSurfaceCanHostWithAutoAdaptSelector$canProjectDragOn$lambda);
  var tmp2_safe_receiver = draggedEntity.__getComponentForKotlin(Companion_getInstance_63().id);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.specifications;
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_1 = [];
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  var variants = tmp_1;
  var variantConnectorsSequence = connectorsFromSpecifications(this, variants);
  return this.w3w(plus(childSequence, variantConnectorsSequence), hostConnectors, dragSurface.connectorKeys);
};
function ValidAutoAdaptDragStrategyResult(entity, snapCandidate, warnings) {
  ValidDragStrategyResult.call(this, entity, snapCandidate, warnings);
}
protoOf(ValidAutoAdaptDragStrategyResult).performFinalSnapAction = function (state, coreServices) {
  var tmp0_elvis_lhs = get_snapRoot(state.originalDraggableRoot);
  var originalEntity = tmp0_elvis_lhs == null ? state.originalDraggableRoot : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = get_snapRoot(state.draggedRootEntity);
  var snappedEntity = tmp1_elvis_lhs == null ? state.draggedRootEntity : tmp1_elvis_lhs;
  var hasEntityChange = !originalEntity.equals(snappedEntity);
  if (hasEntityChange) {
    setParentMaintainWorldTransform(this.snapCandidate.guestRoot, null);
  }
  var snapFromStartDrag = this.snapCandidate.withInitialTransform(state.initialTransform);
  var hasTransformChange = !get_worldTransform(snapFromStartDrag.guest).equals(state.initialTransform);
  var tmp;
  if (hasEntityChange) {
    setParentMaintainWorldTransform(snappedEntity, null);
    Companion_instance_8.z1l(originalEntity, state.initialTransform);
    this.snapCandidate.performMoveAndConnect();
    tmp = true;
  } else if (hasTransformChange) {
    snapFromStartDrag.performMoveAndConnect();
    tmp = true;
  } else {
    setParent(snappedEntity, state.originalParent);
    Companion_instance_8.z1l(snappedEntity, state.initialTransform);
    var tmp2_safe_receiver = get_parent(snappedEntity);
    var oldParentComponent = tmp2_safe_receiver == null ? null : get_parentComponent(tmp2_safe_receiver);
    var tmp4_safe_receiver = oldParentComponent == null ? null : oldParentComponent.children;
    if ((tmp4_safe_receiver == null ? null : contains(tmp4_safe_receiver, snappedEntity)) === false) {
      var newParentComponent = oldParentComponent.addChild(snappedEntity);
      ensureNotNull(get_parent(snappedEntity)).addComponent(newParentComponent);
    }
    tmp = false;
  }
  return tmp;
};
function drawLines($this, entity, lines) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(lines.length);
  var inductionVariable = 0;
  var last = lines.length;
  while (inductionVariable < last) {
    var item = lines[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.DebugLineDrawingSystem.drawLines.<anonymous>' call
    var tmp0_safe_receiver = $this.coreServices.coreModules.viewer();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createUiLine(item.start, item.end, item.color, item.thickness);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw Exception_init_$Create$('Something went wrong when drawing debug lines in ' + $this.id + ', viewer returned a null line id.');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var lineId = tmp;
    destination.h(lineId);
  }
  var lineIds = copyToArray(destination);
  entity.addComponent(new ViewerLineIdsComponent(lineIds));
}
function cleanLines($this, lineIds) {
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = lineIds.length;
  while (inductionVariable < last) {
    var element = lineIds[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.DebugLineDrawingSystem.cleanLines.<anonymous>' call
    var tmp0_safe_receiver = $this.coreServices.coreModules.viewer();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.removeUiLine(element);
    }
  }
}
function Companion_25() {
  Companion_instance_64 = this;
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = LoggerState_getInstance().g1v('LineDrawingSystem');
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.debug.Companion.logger.<anonymous>' call
  this_0.logLevel = LogLevel_DEBUG_getInstance();
  tmp.j3x_1 = this_0;
  this.ID = 'DebugLineDrawingSystem';
}
protoOf(Companion_25).j1y = function () {
  return this.ID;
};
var Companion_instance_64;
function Companion_getInstance_68() {
  if (Companion_instance_64 == null)
    new Companion_25();
  return Companion_instance_64;
}
function DebugLineDrawingSystem$onAddComponent$lambda() {
  return 'Added debug line component to an entity that already has a ViewerLineIds component.';
}
function DebugLineDrawingSystem$onUpdateComponent$lambda(this$0) {
  return function () {
    return 'Did not find ViewerLineIdsComponent when updating DebugLinesComponent in ' + this$0.id + '.';
  };
}
function DebugLineDrawingSystem$onRemoveComponent$lambda(this$0) {
  return function () {
    return 'Did not find ViewerLineIdsComponent when removing DebugLinesComponent in ' + this$0.id + '.';
  };
}
function DebugLineDrawingSystem(coreServices) {
  Companion_getInstance_68();
  SystemBase2.call(this, 'Line Drawing System', Companion_getInstance_10().id, Companion_getInstance_11().q3e_1);
  this.coreServices = coreServices;
}
protoOf(DebugLineDrawingSystem).j3t = function () {
  return this.coreServices;
};
protoOf(DebugLineDrawingSystem).k3x = function (entity, newComponent) {
  if (entity.hasComponent(Companion_getInstance_12().id)) {
    var tmp = Companion_getInstance_68().j3x_1;
    tmp.warn(DebugLineDrawingSystem$onAddComponent$lambda);
    return Unit_instance;
  }
  drawLines(this, entity, newComponent.lines);
};
protoOf(DebugLineDrawingSystem).v1v = function (entity, newComponent) {
  return this.k3x(entity, newComponent instanceof DebugLinesComponent ? newComponent : THROW_CCE());
};
protoOf(DebugLineDrawingSystem).l3x = function (entity, oldComponent, newComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_12().id);
  var lineIds = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lineIds;
  if (!(lineIds == null)) {
    cleanLines(this, lineIds);
    entity.removeComponent(Companion_getInstance_12().id);
    drawLines(this, entity, newComponent.lines);
  } else {
    var tmp = Companion_getInstance_68().j3x_1;
    tmp.warn(DebugLineDrawingSystem$onUpdateComponent$lambda(this));
  }
};
protoOf(DebugLineDrawingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof DebugLinesComponent ? oldComponent : THROW_CCE();
  return this.l3x(entity, tmp, newComponent instanceof DebugLinesComponent ? newComponent : THROW_CCE());
};
protoOf(DebugLineDrawingSystem).m3x = function (entity, oldComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_12().id);
  var lineIds = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lineIds;
  if (!(lineIds == null)) {
    cleanLines(this, lineIds);
    entity.removeComponent(Companion_getInstance_12().id);
  } else {
    var tmp = Companion_getInstance_68().j3x_1;
    tmp.warn(DebugLineDrawingSystem$onRemoveComponent$lambda(this));
  }
};
protoOf(DebugLineDrawingSystem).z1v = function (entity, oldComponent) {
  return this.m3x(entity, oldComponent instanceof DebugLinesComponent ? oldComponent : THROW_CCE());
};
protoOf(DebugLineDrawingSystem).p3j = function (entity, newComponent) {
  var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getComponent(Companion_getInstance_12().id);
  var oldLineIds = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.lineIds;
  if (!(oldLineIds == null)) {
    cleanLines(this, oldLineIds);
  }
  var newEntity = newComponent.entity;
  var tmp3_safe_receiver = newEntity == null ? null : newEntity.__getComponentForKotlin(Companion_getInstance_10().id);
  var newLines = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.lines;
  if (!(newEntity == null) && !(newLines == null)) {
    drawLines(this, newEntity, newLines);
  }
};
protoOf(DebugLineDrawingSystem).l1z = function (entity, newComponent) {
  return this.p3j(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(DebugLineDrawingSystem).q3j = function (entity, oldComponent, newComponent) {
};
protoOf(DebugLineDrawingSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.q3j(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(DebugLineDrawingSystem).r3j = function (entity, oldComponent) {
};
protoOf(DebugLineDrawingSystem).p1z = function (entity, oldComponent) {
  return this.r3j(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
function LoggingEntityManagerWatcher(entityManager, componentId) {
  this.n3x_1 = entityManager;
  this.o3x_1 = componentId;
  this.n3x_1.addWatcher(this);
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.p3x_1 = ArrayList_init_$Create$();
  this.q3x_1 = 0;
}
protoOf(LoggingEntityManagerWatcher).r3x = function () {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var this_0 = this.p3x_1;
    var tmp;
    if (isInterface(this_0, Collection)) {
      tmp = this_0.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.debug.LoggingEntityManagerWatcher.checkTrace.<anonymous>' call
      if (element.k2d() === this.o3x_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  var shouldPrint = tmp$ret$0;
  if (shouldPrint) {
    this.s3x();
    this.n3x_1.removeWatcher(this);
  }
  this.p3x_1.m2();
};
protoOf(LoggingEntityManagerWatcher).s3x = function () {
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$();
  var indent = 0;
  var _iterator__ex2g4s = this.p3x_1.k();
  while (_iterator__ex2g4s.m()) {
    var trace = _iterator__ex2g4s.n();
    if (equals(trace, DoneEntry_instance)) {
      indent = indent - 1 | 0;
    } else {
      result.h(repeat(' ', imul(indent, 2)) + trace.t3x());
      indent = indent + 1 | 0;
    }
  }
  println(joinToString_0(result, '\n'));
};
protoOf(LoggingEntityManagerWatcher).beforeAddComponent = function (entity, component) {
  this.p3x_1.h(new AddEntry(entity, component));
  this.q3x_1 = this.q3x_1 + 1 | 0;
};
protoOf(LoggingEntityManagerWatcher).afterAddComponent = function (entity, component) {
  this.p3x_1.h(DoneEntry_instance);
  this.q3x_1 = this.q3x_1 - 1 | 0;
  if (this.q3x_1 === 0) {
    this.r3x();
  }
};
protoOf(LoggingEntityManagerWatcher).beforeRemoveComponent = function (entity, componentId) {
  this.p3x_1.h(new RemoveEntry(entity, componentId));
  this.q3x_1 = this.q3x_1 + 1 | 0;
};
protoOf(LoggingEntityManagerWatcher).afterRemoveComponent = function (entity, componentId) {
  this.p3x_1.h(DoneEntry_instance);
  this.q3x_1 = this.q3x_1 - 1 | 0;
  if (this.q3x_1 === 0) {
    this.r3x();
  }
};
protoOf(LoggingEntityManagerWatcher).beforeNotifyOnAdd = function (componentListener) {
  this.p3x_1.h(new CallEntry(componentListener, 'onAdd'));
};
protoOf(LoggingEntityManagerWatcher).afterNotifyOnAdd = function (componentListener) {
  this.p3x_1.h(DoneEntry_instance);
};
protoOf(LoggingEntityManagerWatcher).beforeNotifyOnUpdate = function (componentListener) {
  this.p3x_1.h(new CallEntry(componentListener, 'onUpdate'));
};
protoOf(LoggingEntityManagerWatcher).afterNotifyOnUpdate = function (componentListener) {
  this.p3x_1.h(DoneEntry_instance);
};
protoOf(LoggingEntityManagerWatcher).beforeNotifyOnRemove = function (componentListener) {
  this.p3x_1.h(new CallEntry(componentListener, 'onRemove'));
};
protoOf(LoggingEntityManagerWatcher).afterNotifyOnRemove = function (componentListener) {
  this.p3x_1.h(DoneEntry_instance);
};
function DoneEntry() {
  this.u3x_1 = -1;
  this.v3x_1 = '';
}
protoOf(DoneEntry).k2d = function () {
  return this.u3x_1;
};
protoOf(DoneEntry).t3x = function () {
  return this.v3x_1;
};
var DoneEntry_instance;
function DoneEntry_getInstance() {
  return DoneEntry_instance;
}
function AddEntry(entity, component) {
  this.w3x_1 = entity;
  this.x3x_1 = component;
  this.y3x_1 = this.x3x_1.typeId;
  this.z3x_1 = 'Adding ' + getKClassFromExpression(this.x3x_1).oa() + ' (' + this.x3x_1.typeId + ') to ' + get_displayName(this.w3x_1);
}
protoOf(AddEntry).k2d = function () {
  return this.y3x_1;
};
protoOf(AddEntry).t3x = function () {
  return this.z3x_1;
};
function RemoveEntry(entity, componentId) {
  this.a3y_1 = entity;
  this.b3y_1 = componentId;
  this.c3y_1 = 'Removing ' + componentName(this.b3y_1) + ' from ' + get_displayName(this.a3y_1);
}
protoOf(RemoveEntry).k2d = function () {
  return this.b3y_1;
};
protoOf(RemoveEntry).t3x = function () {
  return this.c3y_1;
};
function CallEntry(listener, method) {
  this.d3y_1 = listener;
  this.e3y_1 = -1;
  this.f3y_1 = 'Calling ' + method + ' on ' + (!(this.d3y_1.ownerSystem == null) ? ensureNotNull(this.d3y_1.ownerSystem).id : getKClassFromExpression(this.d3y_1).oa());
}
protoOf(CallEntry).k2d = function () {
  return this.e3y_1;
};
protoOf(CallEntry).t3x = function () {
  return this.f3y_1;
};
function idForAdd($this, componentListener) {
  var tmp0_safe_receiver = componentListener.ownerSystem;
  return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' add ' + componentListener.componentId;
}
function idForUpdate($this, componentListener) {
  var tmp0_safe_receiver = componentListener.ownerSystem;
  return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' update ' + componentListener.componentId;
}
function idForRemove($this, componentListener) {
  var tmp0_safe_receiver = componentListener.ownerSystem;
  return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' remove ' + componentListener.componentId;
}
function MeasuringEntityManagerWatcher(entityManager) {
  this.g3y_1 = entityManager;
  this.h3y_1 = new Measurer();
}
protoOf(MeasuringEntityManagerWatcher).beforeAddComponent = function (entity, component) {
};
protoOf(MeasuringEntityManagerWatcher).afterAddComponent = function (entity, component) {
};
protoOf(MeasuringEntityManagerWatcher).beforeRemoveComponent = function (entity, componentId) {
};
protoOf(MeasuringEntityManagerWatcher).afterRemoveComponent = function (entity, componentId) {
};
protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnAdd = function (componentListener) {
  this.h3y_1.t3g(idForAdd(this, componentListener));
};
protoOf(MeasuringEntityManagerWatcher).afterNotifyOnAdd = function (componentListener) {
  this.h3y_1.u3g(idForAdd(this, componentListener));
};
protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnUpdate = function (componentListener) {
  this.h3y_1.t3g(idForUpdate(this, componentListener));
};
protoOf(MeasuringEntityManagerWatcher).afterNotifyOnUpdate = function (componentListener) {
  this.h3y_1.u3g(idForUpdate(this, componentListener));
};
protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnRemove = function (componentListener) {
  this.h3y_1.t3g(idForRemove(this, componentListener));
};
protoOf(MeasuringEntityManagerWatcher).afterNotifyOnRemove = function (componentListener) {
  this.h3y_1.u3g(idForRemove(this, componentListener));
};
function clear($this) {
  $this.s3y_1 = null;
  $this.t3y_1 = null;
  $this.u3y_1 = null;
  $this.r3y_1.sceneManager.scene.removeComponent(Companion_getInstance_8().id);
}
function sortedSnaps($this, entity) {
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.sortedSnaps.<anonymous>' call
    var tmp_0 = Companion_getInstance_4().r35_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = Companion_instance_1.i3e(tmp0_safe_receiver, $this.r3y_1.sceneManager, new SnapSettings(VOID, VOID, VOID, false));
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.sortedSnaps.<anonymous>.<anonymous>' call
      if (element.inActivationDistance()) {
        destination.h(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    tmp = tmp_0.sortAndSelect(tmp$ret$3);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_1 = [];
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var matchingSnapActionCandidates = tmp_1;
  return toList(matchingSnapActionCandidates);
}
function Companion_26() {
  Companion_instance_65 = this;
  this.v3y_1 = LoggerState_getInstance().g1v('DragRotationSystem');
  this.ID = 'DragRotationSystem';
}
protoOf(Companion_26).j1y = function () {
  return this.ID;
};
var Companion_instance_65;
function Companion_getInstance_69() {
  if (Companion_instance_65 == null)
    new Companion_26();
  return Companion_instance_65;
}
function DragRotationSystem(coreServices) {
  Companion_getInstance_69();
  SystemBase.call(this, 'DragRotationSystem', Companion_getInstance_13().id);
  this.r3y_1 = coreServices;
  this.s3y_1 = null;
  this.t3y_1 = null;
  this.u3y_1 = null;
  this.angleIncrements = 5.0;
}
protoOf(DragRotationSystem).w3y = function (_set____db54di) {
  this.angleIncrements = _set____db54di;
};
protoOf(DragRotationSystem).x3y = function () {
  return this.angleIncrements;
};
protoOf(DragRotationSystem).enable = function () {
  if (this.isEnabled)
    return Unit_instance;
  protoOf(SystemBase).enable.call(this);
  clear(this);
};
protoOf(DragRotationSystem).y3y = function (entity, newComponent) {
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_guestConnections(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.onAddComponent.<anonymous>' call
        var tmp_0 = element.hostConnector;
        if (tmp_0 instanceof SurfaceConnector) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var connectionToSurface = tmp_1;
  var tmp_2 = connectionToSurface.hostConnector;
  var tmp3_elvis_lhs = tmp_2 instanceof SurfaceConnector ? tmp_2 : THROW_CCE();
  var tmp_3;
  if (tmp3_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_3 = tmp3_elvis_lhs;
  }
  var hostConnector = tmp_3;
  var draggedEntity = entity;
  var selectedEntityRoots = MultiDragUtils_instance.z3y(this.r3y_1.sceneManager, entity);
  // Inline function 'kotlin.collections.count' call
  if (selectedEntityRoots.length > 1) {
    draggedEntity = MultiDragUtils_instance.a3z(this.r3y_1, entity, selectedEntityRoots, true);
  }
  var tmp_4 = this;
  var tmp4_safe_receiver = get_snapRoot(draggedEntity);
  tmp_4.u3y_1 = tmp4_safe_receiver == null ? null : get_worldTransform(tmp4_safe_receiver);
  var hostConnectorWorld = get_worldTransform(connectionToSurface.hostConnectorEntity).concatenate(hostConnector.y2h_1);
  var tmp5_safe_receiver = this.u3y_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.position;
  var tmp_5;
  if (tmp6_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_5 = tmp6_elvis_lhs;
  }
  var initialPosition = tmp_5;
  this.t3y_1 = new Plane(initialPosition, hostConnectorWorld.up);
  var ray = newComponent.rayFromCameraToDragEnd;
  var tmp7_safe_receiver = this.t3y_1;
  var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.raycast(ray);
  var tmp_6;
  if (tmp8_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_6 = tmp8_elvis_lhs;
  }
  var hit = tmp_6;
  var dragPoint = hit.point;
  var vecToDragPoint = dragPoint.minus(initialPosition).normalize();
  this.s3y_1 = vecToDragPoint;
  this.r3y_1.sceneManager.scene.addComponent(new SomethingIsDraggedComponent(draggedEntity));
};
protoOf(DragRotationSystem).v1v = function (entity, newComponent) {
  return this.y3y(entity, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(DragRotationSystem).b3z = function (entity, oldComponent, newComponent) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snapRoot = tmp;
  var ray = newComponent.rayFromCameraToDragEnd;
  var tmp1_safe_receiver = this.t3y_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.raycast(ray);
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var hit = tmp_0;
  var dragPoint = hit.point;
  var tmp3_safe_receiver = this.u3y_1;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.position;
  var tmp_1;
  if (tmp4_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp4_elvis_lhs;
  }
  var initialPosition = tmp_1;
  var tmp5_safe_receiver = this.u3y_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.rotation;
  var tmp_2;
  if (tmp6_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp6_elvis_lhs;
  }
  var initialRotation = tmp_2;
  var vecToDragPoint = dragPoint.minus(initialPosition).normalize();
  var tmp7_elvis_lhs = this.s3y_1;
  var tmp_3;
  if (tmp7_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_3 = tmp7_elvis_lhs;
  }
  var oldDir = tmp_3;
  var rotationDelta = oldDir.getRotationTo(vecToDragPoint);
  var newRotationEulerDegrees = rotationDelta.times(initialRotation).toEulerDegrees();
  var rotationEulerRounded = new Vector(this.angleIncrements > 0.0 ? round(newRotationEulerDegrees.X / this.angleIncrements) * this.angleIncrements : newRotationEulerDegrees.X, this.angleIncrements > 0.0 ? round(newRotationEulerDegrees.Y / this.angleIncrements) * this.angleIncrements : newRotationEulerDegrees.Y, this.angleIncrements > 0.0 ? round(newRotationEulerDegrees.Z / this.angleIncrements) * this.angleIncrements : newRotationEulerDegrees.Z);
  var newRotation = Companion_getInstance_14().fromEulerDegreesVector(rotationEulerRounded);
  var newTransform = new Transform(initialPosition, newRotation);
  Companion_instance_8.z1l(snapRoot, newTransform);
};
protoOf(DragRotationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE();
  return this.b3z(entity, tmp, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(DragRotationSystem).c3z = function (entity, oldComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_78().d3z_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp0_safe_receiver.f3z_1.g2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.onRemoveComponent.<anonymous>.<anonymous>' call
      element.addComponent(new DraggableComponent());
    }
    MultiDragUtils_instance.h3z(tmp0_safe_receiver.e3z_1, entity);
  }
  var snaps = sortedSnaps(this, entity);
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator_0 = snaps.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.onRemoveComponent.<anonymous>' call
      if (this.r3y_1.validations.validateSnapCandidate(element_0).valid) {
        tmp$ret$2 = element_0;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var validSnap = tmp$ret$2;
  var tmp1_safe_receiver = get_snapRoot(entity);
  var multiDrag = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.__getComponentForKotlin(Companion_getInstance_78().d3z_1);
  if (!(validSnap == null)) {
    validSnap.performMoveAndConnect();
  } else {
    var tmp2_safe_receiver = firstOrNull_1(snaps);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.performMoveAndConnect();
    }
  }
  MultiDragUtils_instance.i3z(entity);
  if (multiDrag == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = multiDrag.f3z_1.g2();
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator_1 = this_0.k();
    while (tmp0_iterator_1.m()) {
      var element_1 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.onRemoveComponent.<anonymous>.<anonymous>' call
      if (get_parent(element_1) == null) {
        destination.h(element_1);
      }
    }
    var tmp0_iterator_2 = destination.k();
    while (tmp0_iterator_2.m()) {
      var element_2 = tmp0_iterator_2.n();
      // Inline function 'com.ikea.core.stl.dragging.DragRotationSystem.onRemoveComponent.<anonymous>.<anonymous>' call
      MultiDragUtils_instance.j3z(multiDrag, element_2);
    }
  }
  clear(this);
};
protoOf(DragRotationSystem).z1v = function (entity, oldComponent) {
  return this.c3z(entity, oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE());
};
function calculateEndTransform($this, point, entity) {
  return new Transform(point, get_worldTransform(entity).rotation);
}
function Companion_27() {
}
protoOf(Companion_27).basedOnEntity = function (entity, point, rayFromCameraToDragPoint) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = "Can't drag an entity with no draggable root. The entity or any of its ancestor needs to have the Draggable component";
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var draggedEntity = tmp;
  var tmp1_originalParent = get_parent(draggedEntity);
  var tmp2_initialTransform = get_worldTransform(draggedEntity);
  var tmp3_dragEndTransform = calculateEndTransform(this, point, draggedEntity);
  return new DragState(entity, draggedEntity, tmp1_originalParent, point, tmp2_initialTransform, tmp3_dragEndTransform, rayFromCameraToDragPoint);
};
var Companion_instance_66;
function Companion_getInstance_70() {
  return Companion_instance_66;
}
function DragState(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult) {
  validDragStrategyResult = validDragStrategyResult === VOID ? null : validDragStrategyResult;
  this.originalDraggedEntity = originalDraggedEntity;
  this.draggedRootEntity = draggedRootEntity;
  this.originalParent = originalParent;
  this.dragPoint = dragPoint;
  this.initialTransform = initialTransform;
  this.dragEndTransform = dragEndTransform;
  this.rayFromCameraToDragPoint = rayFromCameraToDragPoint;
  this.validDragStrategyResult = validDragStrategyResult;
}
protoOf(DragState).k3z = function () {
  return this.originalDraggedEntity;
};
protoOf(DragState).l3z = function () {
  return this.draggedRootEntity;
};
protoOf(DragState).m3z = function () {
  return this.originalParent;
};
protoOf(DragState).n3z = function () {
  return this.dragPoint;
};
protoOf(DragState).v3c = function () {
  return this.initialTransform;
};
protoOf(DragState).o3z = function () {
  return this.dragEndTransform;
};
protoOf(DragState).y2j = function () {
  return this.rayFromCameraToDragPoint;
};
protoOf(DragState).p3z = function () {
  return this.validDragStrategyResult;
};
protoOf(DragState).q3z = function () {
  var tmp0_elvis_lhs = get_snapRoot(this.originalDraggedEntity);
  return tmp0_elvis_lhs == null ? this.originalDraggedEntity : tmp0_elvis_lhs;
};
protoOf(DragState).r3z = function () {
  var tmp0_safe_receiver = this.validDragStrategyResult;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.snapCandidate;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.endTransform;
  return tmp2_elvis_lhs == null ? this.initialTransform : tmp2_elvis_lhs;
};
protoOf(DragState).updateDragChange = function (point, rotation, rayFromCameraToDragPoint) {
  return this.copy(VOID, VOID, VOID, point, VOID, new Transform(point, rotation), rayFromCameraToDragPoint);
};
protoOf(DragState).updateWithDragStrategyResult = function (entity, validDragStrategyResult) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  return this.copy(VOID, tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, validDragStrategyResult);
};
protoOf(DragState).tf = function () {
  return this.originalDraggedEntity;
};
protoOf(DragState).uf = function () {
  return this.draggedRootEntity;
};
protoOf(DragState).m1m = function () {
  return this.originalParent;
};
protoOf(DragState).n1m = function () {
  return this.dragPoint;
};
protoOf(DragState).o1m = function () {
  return this.initialTransform;
};
protoOf(DragState).p1m = function () {
  return this.dragEndTransform;
};
protoOf(DragState).q1m = function () {
  return this.rayFromCameraToDragPoint;
};
protoOf(DragState).l2e = function () {
  return this.validDragStrategyResult;
};
protoOf(DragState).s3z = function (originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult) {
  return new DragState(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult);
};
protoOf(DragState).copy = function (originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult, $super) {
  originalDraggedEntity = originalDraggedEntity === VOID ? this.originalDraggedEntity : originalDraggedEntity;
  draggedRootEntity = draggedRootEntity === VOID ? this.draggedRootEntity : draggedRootEntity;
  originalParent = originalParent === VOID ? this.originalParent : originalParent;
  dragPoint = dragPoint === VOID ? this.dragPoint : dragPoint;
  initialTransform = initialTransform === VOID ? this.initialTransform : initialTransform;
  dragEndTransform = dragEndTransform === VOID ? this.dragEndTransform : dragEndTransform;
  rayFromCameraToDragPoint = rayFromCameraToDragPoint === VOID ? this.rayFromCameraToDragPoint : rayFromCameraToDragPoint;
  validDragStrategyResult = validDragStrategyResult === VOID ? this.validDragStrategyResult : validDragStrategyResult;
  return this.s3z(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult);
};
protoOf(DragState).toString = function () {
  return 'DragState(originalDraggedEntity=' + this.originalDraggedEntity.toString() + ', draggedRootEntity=' + this.draggedRootEntity.toString() + ', originalParent=' + toString_0(this.originalParent) + ', dragPoint=' + this.dragPoint.toString() + ', initialTransform=' + this.initialTransform.toString() + ', dragEndTransform=' + this.dragEndTransform.toString() + ', rayFromCameraToDragPoint=' + this.rayFromCameraToDragPoint.toString() + ', validDragStrategyResult=' + toString_0(this.validDragStrategyResult) + ')';
};
protoOf(DragState).hashCode = function () {
  var result = this.originalDraggedEntity.hashCode();
  result = imul(result, 31) + this.draggedRootEntity.hashCode() | 0;
  result = imul(result, 31) + (this.originalParent == null ? 0 : this.originalParent.hashCode()) | 0;
  result = imul(result, 31) + this.dragPoint.hashCode() | 0;
  result = imul(result, 31) + this.initialTransform.hashCode() | 0;
  result = imul(result, 31) + this.dragEndTransform.hashCode() | 0;
  result = imul(result, 31) + this.rayFromCameraToDragPoint.hashCode() | 0;
  result = imul(result, 31) + (this.validDragStrategyResult == null ? 0 : hashCode(this.validDragStrategyResult)) | 0;
  return result;
};
protoOf(DragState).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DragState))
    return false;
  var tmp0_other_with_cast = other instanceof DragState ? other : THROW_CCE();
  if (!this.originalDraggedEntity.equals(tmp0_other_with_cast.originalDraggedEntity))
    return false;
  if (!this.draggedRootEntity.equals(tmp0_other_with_cast.draggedRootEntity))
    return false;
  if (!equals(this.originalParent, tmp0_other_with_cast.originalParent))
    return false;
  if (!this.dragPoint.equals(tmp0_other_with_cast.dragPoint))
    return false;
  if (!this.initialTransform.equals(tmp0_other_with_cast.initialTransform))
    return false;
  if (!this.dragEndTransform.equals(tmp0_other_with_cast.dragEndTransform))
    return false;
  if (!this.rayFromCameraToDragPoint.equals(tmp0_other_with_cast.rayFromCameraToDragPoint))
    return false;
  if (!equals(this.validDragStrategyResult, tmp0_other_with_cast.validDragStrategyResult))
    return false;
  return true;
};
function Companion_28() {
  Companion_instance_67 = this;
  this.id = Companion_instance_0.m1p_1;
}
protoOf(Companion_28).n1s = function () {
  return this.id;
};
var Companion_instance_67;
function Companion_getInstance_71() {
  if (Companion_instance_67 == null)
    new Companion_28();
  return Companion_instance_67;
}
function DragStateComponent(dragState) {
  Companion_getInstance_71();
  this.dragState = dragState;
  this.t3z_1 = false;
}
protoOf(DragStateComponent).u3z = function () {
  return this.dragState;
};
protoOf(DragStateComponent).p1s = function () {
  return Companion_getInstance_71().id;
};
protoOf(DragStateComponent).eq = function (other) {
  return false;
};
protoOf(DragStateComponent).s1s = function () {
  return this.t3z_1;
};
function Companion_29() {
  Companion_instance_68 = this;
  this.ID = 'DragSurfaceNormalVisualizationSystem';
  this.v3z_1 = 500.0;
  this.w3z_1 = 20.0;
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = LoggerState_getInstance().g1v('DragSurfaceNormalVisualizationSystem');
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.dragging.Companion.logger.<anonymous>' call
  this_0.logLevel = LogLevel_DEBUG_getInstance();
  tmp.x3z_1 = this_0;
}
protoOf(Companion_29).j1y = function () {
  return this.ID;
};
var Companion_instance_68;
function Companion_getInstance_72() {
  if (Companion_instance_68 == null)
    new Companion_29();
  return Companion_instance_68;
}
function drawLinesForEntity($this, entity, dragSurfaceComponent) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var lines = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = dragSurfaceComponent.surfaces;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawLinesForEntity.<anonymous>' call
    drawNormals($this, element.surface, lines);
    drawSurfaceEdges($this, element.surface, lines);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$1 = copyToArray(lines);
  entity.addComponent(new DebugLinesComponent(tmp$ret$1));
}
function drawNormals($this, polyhedron, lines) {
  if (polyhedron instanceof ConvexPolyhedron) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = polyhedron.faces;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var faceCenter = Companion_getInstance_15().ZERO;
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = item.indices;
      var inductionVariable_0 = 0;
      var last_0 = indexedObject_0.length;
      while (inductionVariable_0 < last_0) {
        var element = indexedObject_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>.<anonymous>' call
        faceCenter = faceCenter.plus(polyhedron.vertices[element]);
      }
      var tmp = faceCenter;
      // Inline function 'kotlin.collections.count' call
      var tmp$ret$0 = item.indices.length;
      faceCenter = tmp.__divIntForKotlin(tmp$ret$0);
      var faceNormal = polyhedron.normals[tmp1];
      var tmp_0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = faceNormal.dot(Companion_getInstance_15().RIGHT);
      if (Math.abs(this_0) > 0) {
        tmp_0 = faceNormal.cross(Companion_getInstance_15().FORWARD);
      } else {
        tmp_0 = faceNormal.cross(Companion_getInstance_15().RIGHT);
      }
      var right = tmp_0;
      var end = faceCenter.plus(faceNormal.times(Companion_getInstance_72().v3z_1));
      var color = getSurfaceColor($this, faceNormal);
      lines.h(new DebugLine(faceCenter, end, color, Companion_getInstance_72().w3z_1));
      lines.h(new DebugLine(end, end.minus(faceNormal.plus(right).times(0.1).times(Companion_getInstance_72().v3z_1)), color, Companion_getInstance_72().w3z_1));
      lines.h(new DebugLine(end, end.minus(faceNormal.minus(right).times(0.1).times(Companion_getInstance_72().v3z_1)), color, Companion_getInstance_72().w3z_1));
    }
  } else {
    if (polyhedron instanceof PolyhedronGroup) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_1 = polyhedron.polyhedra;
      var inductionVariable_1 = 0;
      var last_1 = indexedObject_1.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = indexedObject_1[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>' call
        drawNormals($this, element_0, lines);
      }
    }
  }
}
function getSurfaceColor($this, faceNormal) {
  // Inline function 'kotlin.math.abs' call
  var x = faceNormal.X;
  var tmp = Math.abs(x);
  // Inline function 'kotlin.math.abs' call
  var x_0 = faceNormal.Y;
  var tmp_0 = Math.abs(x_0);
  // Inline function 'kotlin.math.abs' call
  var x_1 = faceNormal.Z;
  var tmp$ret$2 = Math.abs(x_1);
  var color = new Vector(tmp, tmp_0, tmp$ret$2);
  return color;
}
function drawSurfaceEdges($this, polyhedron, lines) {
  if (polyhedron instanceof ConvexPolyhedron) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = polyhedron.faces;
    var inductionVariable = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable < last_0) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawSurfaceEdges.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var faceNormal = polyhedron.normals[tmp1];
      var color = getSurfaceColor($this, faceNormal);
      var inductionVariable_0 = 1;
      var last_1 = item.indices.length;
      if (inductionVariable_0 < last_1)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var previous = polyhedron.vertices[item.indices[i - 1 | 0]];
          var next = polyhedron.vertices[item.indices[i]];
          lines.h(new DebugLine(previous, next, color, Companion_getInstance_72().w3z_1));
        }
         while (inductionVariable_0 < last_1);
      if (item.indices.length > 1) {
        var first_0 = polyhedron.vertices[first(item.indices)];
        var last_2 = polyhedron.vertices[last(item.indices)];
        lines.h(new DebugLine(first_0, last_2, color, Companion_getInstance_72().w3z_1));
      }
    }
  } else {
    if (polyhedron instanceof PolyhedronGroup) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = polyhedron.polyhedra;
      var inductionVariable_1 = 0;
      var last_3 = indexedObject_0.length;
      while (inductionVariable_1 < last_3) {
        var element = indexedObject_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawSurfaceEdges.<anonymous>' call
        drawSurfaceEdges($this, element, lines);
      }
    }
  }
}
function DragSurfaceNormalVisualizationSystem(coreServices) {
  Companion_getInstance_72();
  var tmp = Companion_getInstance_72().ID;
  var tmp_0 = Companion_getInstance_16().id;
  var tmp_1 = Companion_instance_10.id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_10().id];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp$ret$2);
  this.j40_1 = coreServices;
}
protoOf(DragSurfaceNormalVisualizationSystem).enable = function () {
  protoOf(SystemBase2).enable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.j40_1.entityManager.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.enable.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_17().id)) {
      var dragSurface = element.__getComponentForKotlin(Companion_getInstance_16().id);
      if (!(dragSurface == null)) {
        this.k40(element, dragSurface);
      }
    }
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).disable = function () {
  protoOf(SystemBase2).disable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.j40_1.entityManager.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.disable.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_17().id)) {
      var dragSurface = element.__getComponentForKotlin(Companion_getInstance_16().id);
      if (!(dragSurface == null)) {
        this.l40(element, dragSurface);
      }
    }
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).k40 = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    drawLinesForEntity(this, entity, newComponent);
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).v1v = function (entity, newComponent) {
  return this.k40(entity, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceNormalVisualizationSystem).m40 = function (entity, oldComponent, newComponent) {
  if (get_isInScene(entity)) {
    drawLinesForEntity(this, entity, newComponent);
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE();
  return this.m40(entity, tmp, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceNormalVisualizationSystem).l40 = function (entity, oldComponent) {
  entity.removeComponent(Companion_getInstance_10().id);
};
protoOf(DragSurfaceNormalVisualizationSystem).z1v = function (entity, oldComponent) {
  return this.l40(entity, oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE());
};
protoOf(DragSurfaceNormalVisualizationSystem).u31 = function (entity, newComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_16().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    drawLinesForEntity(this, entity, tmp0_safe_receiver);
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).l1z = function (entity, newComponent) {
  return this.u31(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceNormalVisualizationSystem).v31 = function (entity, oldComponent, newComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_16().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    drawLinesForEntity(this, entity, tmp0_safe_receiver);
  }
};
protoOf(DragSurfaceNormalVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.v31(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceNormalVisualizationSystem).w31 = function (entity, oldComponent) {
  entity.removeComponent(Companion_getInstance_10().id);
};
protoOf(DragSurfaceNormalVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.w31(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
function createDebugSurfaces($this, entity, newComponent) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = newComponent.surfaces;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.createDebugSurfaces.<anonymous>' call
    var tmp$ret$0 = item.surface;
    destination.h(tmp$ret$0);
  }
  var allPolyhedrons = copyToArray(destination);
  var polygons = Companion_getInstance_18().m3c(allPolyhedrons);
  entity.addComponent(new DebugSurfacesComponent(polygons));
}
function Companion_30() {
  this.ID = 'DragSurfaceVisualizationSystem';
}
protoOf(Companion_30).j1y = function () {
  return this.ID;
};
var Companion_instance_69;
function Companion_getInstance_73() {
  return Companion_instance_69;
}
function DragSurfaceVisualizationSystem(entityManager) {
  var tmp = Companion_getInstance_16().id;
  var tmp_0 = Companion_instance_10.id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['DebugSurfaceDrawingSystem'];
  SystemBase2.call(this, 'DragSurfaceVisualizationSystem', tmp, tmp_0, VOID, VOID, tmp$ret$2);
  this.y40_1 = entityManager;
}
protoOf(DragSurfaceVisualizationSystem).enable = function () {
  protoOf(SystemBase2).enable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.y40_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.enable.<anonymous>' call
    var dragSurface = element.__getComponentForKotlin(Companion_getInstance_16().id);
    if (!(dragSurface == null)) {
      this.k40(element, dragSurface);
    }
  }
};
protoOf(DragSurfaceVisualizationSystem).disable = function () {
  protoOf(SystemBase2).disable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.y40_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.disable.<anonymous>' call
    var dragSurface = element.__getComponentForKotlin(Companion_getInstance_16().id);
    if (!(dragSurface == null)) {
      this.l40(element, dragSurface);
    }
  }
};
protoOf(DragSurfaceVisualizationSystem).k40 = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    createDebugSurfaces(this, entity, newComponent);
  }
};
protoOf(DragSurfaceVisualizationSystem).v1v = function (entity, newComponent) {
  return this.k40(entity, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceVisualizationSystem).m40 = function (entity, oldComponent, newComponent) {
  if (get_isInScene(entity)) {
    entity.removeComponent(Companion_instance_0.k1r_1);
    createDebugSurfaces(this, entity, newComponent);
  }
};
protoOf(DragSurfaceVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE();
  return this.m40(entity, tmp, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceVisualizationSystem).l40 = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_0.k1r_1);
};
protoOf(DragSurfaceVisualizationSystem).z1v = function (entity, oldComponent) {
  return this.l40(entity, oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE());
};
protoOf(DragSurfaceVisualizationSystem).u31 = function (entity, newComponent) {
  entity.removeComponent(Companion_instance_0.k1r_1);
  var worldDragSurfacesComponent = entity.__getComponentForKotlin(Companion_instance_0.i1q_1);
  if (!(worldDragSurfacesComponent == null)) {
    createDebugSurfaces(this, entity, worldDragSurfacesComponent);
  }
};
protoOf(DragSurfaceVisualizationSystem).l1z = function (entity, newComponent) {
  return this.u31(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceVisualizationSystem).v31 = function (entity, oldComponent, newComponent) {
  entity.removeComponent(Companion_instance_0.k1r_1);
  var worldDragSurfacesComponent = entity.__getComponentForKotlin(Companion_instance_0.i1q_1);
  if (!(worldDragSurfacesComponent == null)) {
    createDebugSurfaces(this, entity, worldDragSurfacesComponent);
  }
};
protoOf(DragSurfaceVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.v31(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceVisualizationSystem).w31 = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_0.k1r_1);
};
protoOf(DragSurfaceVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.w31(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
function createDragSurface($this, entity) {
  var prevComponent = entity.__getComponentForKotlin(Companion_getInstance_17().id);
  var tmp1_elvis_lhs = prevComponent == null ? null : prevComponent.basedOnCollider;
  var allowedToUpdate = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  if (allowedToUpdate) {
    var tmp2_safe_receiver = get_colliderShapeComponent(entity);
    var collider = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.polyhedron;
    if (collider == null) {
      $this.k41_1.removeComponent(entity, Companion_getInstance_17().id);
      return Unit_instance;
    }
    var tmp3_safe_receiver = get_connectorsComponent(entity);
    var connectors = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r27();
    if (connectors == null || connectors.r()) {
      $this.k41_1.removeComponent(entity, Companion_getInstance_17().id);
      return Unit_instance;
    }
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [new DragSurface(collider, null)];
    $this.k41_1.addComponent(entity, new DragSurfacesComponent(tmp$ret$2, true));
  }
}
function DragSurfacesUpdateSystem(entityManager) {
  var tmp = Companion_getInstance_19().id;
  var tmp_0 = Companion_getInstance_5().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_17().id];
  SystemBase2.call(this, 'DragSurfaceUpdateSystem', tmp, tmp_0, tmp$ret$2);
  this.k41_1 = entityManager;
  this.enable();
}
protoOf(DragSurfacesUpdateSystem).l41 = function (entity, newComponent) {
  createDragSurface(this, entity);
};
protoOf(DragSurfacesUpdateSystem).v1v = function (entity, newComponent) {
  return this.l41(entity, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfacesUpdateSystem).m41 = function (entity, oldComponent, newComponent) {
  createDragSurface(this, entity);
};
protoOf(DragSurfacesUpdateSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE();
  return this.m41(entity, tmp, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfacesUpdateSystem).n41 = function (entity, oldComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_17().id);
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.basedOnCollider) === true) {
    this.k41_1.removeComponent(entity, Companion_getInstance_17().id);
  }
};
protoOf(DragSurfacesUpdateSystem).z1v = function (entity, oldComponent) {
  return this.n41(entity, oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE());
};
protoOf(DragSurfacesUpdateSystem).o41 = function (entity, newComponent) {
  createDragSurface(this, entity);
};
protoOf(DragSurfacesUpdateSystem).l1z = function (entity, newComponent) {
  return this.o41(entity, newComponent instanceof ConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfacesUpdateSystem).p41 = function (entity, oldComponent, newComponent) {
  createDragSurface(this, entity);
};
protoOf(DragSurfacesUpdateSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ConnectorsComponent ? oldComponent : THROW_CCE();
  return this.p41(entity, tmp, newComponent instanceof ConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfacesUpdateSystem).q41 = function (entity, oldComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_17().id);
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.basedOnCollider) === true) {
    this.k41_1.removeComponent(entity, Companion_getInstance_17().id);
  }
};
protoOf(DragSurfacesUpdateSystem).p1z = function (entity, oldComponent) {
  return this.q41(entity, oldComponent instanceof ConnectorsComponent ? oldComponent : THROW_CCE());
};
function _get_sceneManager__lxhb6y($this) {
  return $this.a42_1.sceneManager;
}
function _get_history__d61b7h($this) {
  return $this.a42_1.coreModules.history();
}
function _get_state__b8zcm8($this) {
  var tmp0_safe_receiver = _get_sceneManager__lxhb6y($this).scene.__getComponentForKotlin(Companion_getInstance_71().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dragState;
}
function dragStart_0($this, entity, event) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snapRoot = tmp;
  var newState = Companion_instance_66.basedOnEntity(entity, event.point, event.rayFromCameraToDragPoint);
  updateDragState($this, newState);
  if (addDragComponents($this, snapRoot, newState)) {
    runDragStartOnStrategies($this);
  }
}
function dragStartMulti($this, entity, dragEventComponent, selectedEntityRoots) {
  var tempParent = MultiDragUtils_instance.h42($this.a42_1, entity, selectedEntityRoots);
  tempParent.addComponentInternal(dragEventComponent);
  dragStart_0($this, tempParent, dragEventComponent);
}
function addDragComponents($this, draggableRootEntity, state) {
  if (_get_sceneManager__lxhb6y($this).scene.hasComponent(Companion_getInstance_8().id)) {
    var tmp = Companion_getInstance_74().i42_1;
    tmp.info(DragSystem$addDragComponents$lambda);
    return false;
  }
  _get_sceneManager__lxhb6y($this).scene.addComponent(new DragStateComponent(state));
  _get_sceneManager__lxhb6y($this).scene.addComponent(new SomethingIsDraggedComponent(draggableRootEntity));
  draggableRootEntity.addComponent(new IsDraggedComponent());
  return true;
}
function dragMove($this, event) {
  var tmp0_elvis_lhs = _get_state__b8zcm8($this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var dragState = tmp;
  pauseViewerUpdatesOnDraggedEntity(_get_sceneManager__lxhb6y($this));
  if (!_get_sceneManager__lxhb6y($this).scene.hasComponent(Companion_getInstance_8().id)) {
    var tmp_0 = Companion_getInstance_74().i42_1;
    tmp_0.error(DragSystem$dragMove$lambda);
  }
  var newDragState = dragState.updateDragChange(event.point, dragState.initialTransform.rotation, event.rayFromCameraToDragPoint);
  updateDragState($this, newDragState);
  runDragMoveOnStrategies($this, newDragState);
  resumeViewerUpdatesOnDraggedEntity(_get_sceneManager__lxhb6y($this));
}
function dragStop_0($this) {
  var tmp0_elvis_lhs = _get_state__b8zcm8($this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var dragState = tmp;
  if (!_get_sceneManager__lxhb6y($this).scene.hasComponent(Companion_getInstance_8().id)) {
    var tmp_0 = Companion_getInstance_74().i42_1;
    tmp_0.error(DragSystem$dragStop$lambda);
  }
  var tmp1_safe_receiver = dragState.draggedRootEntity.__getComponentForKotlin(Companion_getInstance_78().d3z_1);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp1_safe_receiver.f3z_1.g2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.DragSystem.dragStop.<anonymous>.<anonymous>' call
      element.addComponent(new DraggableComponent());
    }
    MultiDragUtils_instance.h3z(tmp1_safe_receiver.e3z_1, dragState.draggedRootEntity);
  }
  if (isDragStartedEarlier($this)) {
    var tmp2_safe_receiver = dragState.validDragStrategyResult;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.performFinalSnapAction(dragState, $this.a42_1);
    var snapResult = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
    if (!snapResult) {
      var tmp4_safe_receiver = _get_history__d61b7h($this);
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.discardLatestSnapshot();
      }
    }
    runDragStopOnStrategies($this);
  }
  var tmp_1;
  var tmp6_safe_receiver = _get_state__b8zcm8($this);
  var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.draggedRootEntity;
  if (!((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.isDisposed) === true)) {
    var tmp5_safe_receiver = _get_state__b8zcm8($this);
    tmp_1 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.draggedRootEntity;
  } else {
    tmp_1 = null;
  }
  var draggedRoot = tmp_1;
  if (draggedRoot == null)
    null;
  else
    draggedRoot.removeComponent(Companion_instance_73.id);
  if (draggedRoot == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    MultiDragUtils_instance.i3z(draggedRoot);
  }
  _get_sceneManager__lxhb6y($this).scene.removeComponent(Companion_getInstance_8().id);
  _get_sceneManager__lxhb6y($this).scene.removeComponent(Companion_getInstance_71().id);
  updateDragState($this, null);
}
function runDragStartOnStrategies($this) {
  var tmp0_safe_receiver = _get_state__b8zcm8($this);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.b42_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragStartOnStrategies.<anonymous>.<anonymous>' call
      element.dragStart(tmp0_safe_receiver.draggedRootEntity);
    }
  }
}
function runDragMoveOnStrategies($this, dragState) {
  var draggedRoot = dragState.draggedRootEntity;
  var worldTransformBefore = get_worldTransform(draggedRoot);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.b42_1;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragMoveOnStrategies.<anonymous>' call
    if (element.isEnabled) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragMoveOnStrategies.<anonymous>' call
    Companion_instance_8.z1l(draggedRoot, dragState.dragEndTransform);
    var validSnap = element_0.dragMove(dragState);
    if (!(validSnap == null)) {
      var tmp0_safe_receiver = $this.d42_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.performPostProcess(validSnap, dragState);
      validSnap = tmp1_elvis_lhs == null ? validSnap : tmp1_elvis_lhs;
      validSnap.snapCandidate.performMove();
      var newDragState = dragState.updateWithDragStrategyResult(validSnap.entity, validSnap);
      updateDragState($this, newDragState);
      triggerMovedToValidSnapPositionComponent(newDragState.draggedRootEntity, validSnap.snapCandidate);
      return Unit_instance;
    }
  }
  Companion_instance_8.z1l(draggedRoot, worldTransformBefore);
}
function updateDragState($this, newState) {
  if (!(newState == null)) {
    _get_sceneManager__lxhb6y($this).scene.addComponent(new DragStateComponent(newState));
  } else {
    _get_sceneManager__lxhb6y($this).scene.removeComponent(Companion_getInstance_71().id);
  }
}
function runDragStopOnStrategies($this) {
  var tmp0_safe_receiver = _get_state__b8zcm8($this);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.b42_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragStopOnStrategies.<anonymous>.<anonymous>' call
      element.dragStop(tmp0_safe_receiver.draggedRootEntity);
    }
  }
}
function isDragStartedEarlier($this) {
  return !(_get_state__b8zcm8($this) == null);
}
function Companion_31() {
  Companion_instance_70 = this;
  this.i42_1 = LoggerState_getInstance().g1v('DragSystem');
  this.ID = 'DragSystem';
}
protoOf(Companion_31).j1y = function () {
  return this.ID;
};
protoOf(Companion_31).j42 = function (coreServices, enableMultiDrag) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [new SnapClosestDragStrategy(coreServices), new SnapClosestWithSubConnectorsDragStrategy(coreServices), new ResolveCollisionsDragStrategy(Companion_instance_0.b1o_1, coreServices), new SnapCardinalDirectionsDragStrategy(coreServices)];
  return new DragSystem(coreServices, tmp$ret$2, enableMultiDrag);
};
protoOf(Companion_31).createStandardDragSystem$default = function (coreServices, enableMultiDrag, $super) {
  enableMultiDrag = enableMultiDrag === VOID ? false : enableMultiDrag;
  return $super === VOID ? this.j42(coreServices, enableMultiDrag) : $super.j42.call(this, coreServices, enableMultiDrag);
};
protoOf(Companion_31).k42 = function (coreServices, enableMultiDrag) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [new AutoAdaptDragStrategy(coreServices), new SnapClosestDragStrategy(coreServices), new SnapClosestWithSubConnectorsDragStrategy(coreServices), new ResolveCollisionsDragStrategy(Companion_instance_0.b1o_1, coreServices), new SnapCardinalDirectionsDragStrategy(coreServices)];
  return new DragSystem(coreServices, tmp$ret$2, enableMultiDrag);
};
protoOf(Companion_31).createAutoAdaptDragSystem$default = function (coreServices, enableMultiDrag, $super) {
  enableMultiDrag = enableMultiDrag === VOID ? false : enableMultiDrag;
  return $super === VOID ? this.k42(coreServices, enableMultiDrag) : $super.k42.call(this, coreServices, enableMultiDrag);
};
var Companion_instance_70;
function Companion_getInstance_74() {
  if (Companion_instance_70 == null)
    new Companion_31();
  return Companion_instance_70;
}
function createStandardDragSystem(coreServices, enableMultiDrag) {
  return Companion_getInstance_74().j42(coreServices, enableMultiDrag);
}
function createStandardDragSystem_0(coreServices, enableMultiDrag, $super) {
  enableMultiDrag = enableMultiDrag === VOID ? false : enableMultiDrag;
  return createStandardDragSystem(coreServices, enableMultiDrag);
}
function createAutoAdaptDragSystem(coreServices, enableMultiDrag) {
  return Companion_getInstance_74().k42(coreServices, enableMultiDrag);
}
function createAutoAdaptDragSystem_0(coreServices, enableMultiDrag, $super) {
  enableMultiDrag = enableMultiDrag === VOID ? false : enableMultiDrag;
  return createAutoAdaptDragSystem(coreServices, enableMultiDrag);
}
function DragSystem$addDragComponents$lambda() {
  return 'Something is already dragged, ignoring drag start';
}
function DragSystem$dragMove$lambda() {
  return 'Illegal state: No SomethingIsDraggedComponent found in scene. dragMove was probably called before dragStart';
}
function DragSystem$dragStop$lambda() {
  return 'Illegal state: No SomethingIsDraggedComponent found in scene. dragEnd was probably called before dragStart';
}
function DragSystem(coreServices, dragStrategies, multiDragEnabled) {
  Companion_getInstance_74();
  multiDragEnabled = multiDragEnabled === VOID ? false : multiDragEnabled;
  SystemBase.call(this, Companion_getInstance_74().ID, Companion_getInstance_20().id);
  this.a42_1 = coreServices;
  this.b42_1 = dragStrategies;
  this.c42_1 = multiDragEnabled;
  this.d42_1 = new HigherPriorityAlignmentPostProcess(this.a42_1);
  this.e42_1 = new TakeSnapshotBeforeDragSystem(this.a42_1);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.f42_1 = [Companion_instance_76.l42_1];
  new NoDragConverterDetector(this.a42_1.entityManager);
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.g42_1 = [Companion_getInstance_8().id, Companion_getInstance_71().id, Companion_instance_73.id];
}
protoOf(DragSystem).k1w = function () {
  return this.f42_1;
};
protoOf(DragSystem).onRegister = function () {
  protoOf(SystemBase).onRegister.call(this);
  this.e42_1.l2d(this.a42_1.entityManager);
};
protoOf(DragSystem).onUnregister = function () {
  protoOf(SystemBase).onUnregister.call(this);
  this.e42_1.m2d(this.a42_1.entityManager);
};
protoOf(DragSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  this.e42_1.enable();
};
protoOf(DragSystem).disable = function () {
  protoOf(SystemBase).disable.call(this);
  this.e42_1.disable();
};
protoOf(DragSystem).m42 = function (entity, newComponent) {
  if (this.c42_1) {
    var selectedEntityRoots = MultiDragUtils_instance.z3y(_get_sceneManager__lxhb6y(this), entity);
    var tmp;
    // Inline function 'kotlin.collections.count' call
    if (selectedEntityRoots.length > 1) {
      tmp = true;
    } else {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(selectedEntityRoots.length === 0)) {
        tmp_0 = !first(selectedEntityRoots).equals(entity);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      dragStartMulti(this, entity, newComponent, selectedEntityRoots);
    } else {
      dragStart_0(this, entity, newComponent);
    }
  } else {
    dragStart_0(this, entity, newComponent);
  }
};
protoOf(DragSystem).v1v = function (entity, newComponent) {
  return this.m42(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(DragSystem).n42 = function (entity, oldComponent, newComponent) {
  dragMove(this, newComponent);
};
protoOf(DragSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE();
  return this.n42(entity, tmp, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(DragSystem).o42 = function (entity, oldComponent) {
  dragStop_0(this);
};
protoOf(DragSystem).z1v = function (entity, oldComponent) {
  return this.o42(entity, oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(DragSystem).j1w = function () {
  return this.g42_1;
};
protoOf(DragSystem).setPostProcessStrategy = function (postProcessDragStrategy) {
  this.d42_1 = postProcessDragStrategy;
};
protoOf(DragSystem).getDragStrategies = function () {
  return this.b42_1;
};
protoOf(DragSystem).enableMultiDrag = function () {
  this.c42_1 = true;
};
protoOf(DragSystem).disableMultiDrag = function () {
  this.c42_1 = false;
};
function _get_viewer__pq1i9z($this) {
  return $this.y42_1.coreModules.viewer();
}
function updateGhost($this, dragState) {
  var entity = dragState.draggedRootEntity;
  var transform = dragState.dragEndTransform;
  var currentViewer = _get_viewer__pq1i9z($this);
  var offset = dragState.rayFromCameraToDragPoint.direction.times(Companion_instance_71.OFFSET_ALONG_VIEW_DIRECTION);
  if ($this.d43_1 == null && !(currentViewer == null)) {
    $this.d43_1 = Companion_instance_72.createGhost$default(entity, currentViewer, $this.z42_1, $this.a43_1, $this.b43_1, $this.c43_1);
    var tmp0_safe_receiver = $this.d43_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.setVisible(true);
  }
  var tmp1_safe_receiver = $this.d43_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.DrawDragGhostSystem.updateGhost.<anonymous>' call
    tmp1_safe_receiver.setPosition(transform.position.plus(offset)).setRotation(transform.rotation);
  }
}
function Companion_32() {
  this.ID = 'DrawDragGhostSystem';
  this.OFFSET_ALONG_VIEW_DIRECTION = 0.4;
}
protoOf(Companion_32).j1y = function () {
  return this.ID;
};
protoOf(Companion_32).f43 = function () {
  return this.OFFSET_ALONG_VIEW_DIRECTION;
};
var Companion_instance_71;
function Companion_getInstance_75() {
  return Companion_instance_71;
}
function DrawDragGhostSystem(coreServices, r, g, b, alpha) {
  r = r === VOID ? 0.0 : r;
  g = g === VOID ? 0.0 : g;
  b = b === VOID ? 1.0 : b;
  alpha = alpha === VOID ? 0.5 : alpha;
  SystemBase.call(this, Companion_instance_71.ID, Companion_getInstance_71().id);
  this.y42_1 = coreServices;
  this.z42_1 = r;
  this.a43_1 = g;
  this.b43_1 = b;
  this.c43_1 = alpha;
  this.d43_1 = null;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.e43_1 = [];
}
protoOf(DrawDragGhostSystem).g43 = function (entity, newComponent) {
  updateGhost(this, newComponent.dragState);
};
protoOf(DrawDragGhostSystem).v1v = function (entity, newComponent) {
  return this.g43(entity, newComponent instanceof DragStateComponent ? newComponent : THROW_CCE());
};
protoOf(DrawDragGhostSystem).h43 = function (entity, oldComponent, newComponent) {
  updateGhost(this, newComponent.dragState);
};
protoOf(DrawDragGhostSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof DragStateComponent ? oldComponent : THROW_CCE();
  return this.h43(entity, tmp, newComponent instanceof DragStateComponent ? newComponent : THROW_CCE());
};
protoOf(DrawDragGhostSystem).i43 = function (entity, oldComponent) {
  var tmp0_safe_receiver = this.d43_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.deleteObject();
  }
  this.d43_1 = null;
};
protoOf(DrawDragGhostSystem).z1v = function (entity, oldComponent) {
  return this.i43(entity, oldComponent instanceof DragStateComponent ? oldComponent : THROW_CCE());
};
protoOf(DrawDragGhostSystem).j1w = function () {
  return this.e43_1;
};
function GhostUtils$Companion$createGhost$lambda(it) {
  return it.hasComponent(Companion_getInstance_21().id);
}
function GhostUtils$Companion$createGhost$o($scale, $deltaTransform, $rootNode, $r, $g, $b, $clickEvent) {
  return function (viewerObject) {
    viewerObject.setScaleV($scale).setPosition($deltaTransform.position).setRotation($deltaTransform.rotation).setVisible(true).setParent($rootNode).setOutlined(true).setOutlinedObjectColor($r * 0.75, $g * 0.75, $b * 0.75);
    if ($clickEvent == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      viewerObject.makeClickable($clickEvent);
    }
    return Unit_instance;
  };
}
function Companion_33() {
}
protoOf(Companion_33).j43 = function (entity, viewer, r, g, b, alpha, clickEvent) {
  entity.addComponent(new VisualizationEntityComponent());
  var rootEntityTransform = get_worldTransform(entity);
  var rootNode = viewer.createEmpty();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = filterInHierarchy(entity, GhostUtils$Companion$createGhost$lambda);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.Companion.createGhost.<anonymous>' call
    var tmp0_safe_receiver = element.__getComponentForKotlin(Companion_getInstance_21().id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.modelUrl;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (get_isPropping(entity)) {
          tmp = Companion_getInstance_6().y2v_1;
        } else {
          var tmp0_safe_receiver_1 = get_colliderShapeComponent(entity);
          var tmp1_safe_receiver = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.polyhedron;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
          tmp = tmp2_elvis_lhs == null ? Companion_getInstance_6().y2v_1 : tmp2_elvis_lhs;
        }
        var aabb = tmp;
        var tmp3_safe_receiver = element.__getComponentForKotlin(Companion_instance_11.id);
        var modelTransform = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.transform;
        var tmp_0 = get_worldTransform(element).delta(rootEntityTransform);
        var tmp5_elvis_lhs = modelTransform == null ? null : modelTransform.transform;
        var deltaTransform = tmp_0.concatenate(tmp5_elvis_lhs == null ? Companion_getInstance_22().c1x_1 : tmp5_elvis_lhs);
        var tmp7_elvis_lhs = modelTransform == null ? null : modelTransform.scale;
        var scale = tmp7_elvis_lhs == null ? Companion_getInstance_15().ONE : tmp7_elvis_lhs;
        var onModelLoaded = GhostUtils$Companion$createGhost$o(scale, deltaTransform, rootNode, r, g, b, clickEvent);
        viewer.createGhostModel(tmp0_safe_receiver_0, onModelLoaded, r, g, b, alpha, aabb.size);
      }
    }
  }
  return rootNode;
};
protoOf(Companion_33).createGhost$default = function (entity, viewer, r, g, b, alpha, clickEvent, $super) {
  r = r === VOID ? 0.75 : r;
  g = g === VOID ? 0.75 : g;
  b = b === VOID ? 0.75 : b;
  alpha = alpha === VOID ? 0.5 : alpha;
  clickEvent = clickEvent === VOID ? null : clickEvent;
  return $super === VOID ? this.j43(entity, viewer, r, g, b, alpha, clickEvent) : $super.j43.call(this, entity, viewer, r, g, b, alpha, clickEvent);
};
var Companion_instance_72;
function Companion_getInstance_76() {
  return Companion_instance_72;
}
function createGhost(entity, viewer, r, g, b, alpha, clickEvent) {
  return Companion_instance_72.j43(entity, viewer, r, g, b, alpha, clickEvent);
}
function createGhost_0(entity, viewer, r, g, b, alpha, clickEvent, $super) {
  r = r === VOID ? 0.75 : r;
  g = g === VOID ? 0.75 : g;
  b = b === VOID ? 0.75 : b;
  alpha = alpha === VOID ? 0.5 : alpha;
  clickEvent = clickEvent === VOID ? null : clickEvent;
  return createGhost(entity, viewer, r, g, b, alpha, clickEvent);
}
function GhostUtils() {
}
function HigherPriorityAlignmentPostProcess(coreServices) {
  this.k43_1 = coreServices;
}
protoOf(HigherPriorityAlignmentPostProcess).performPostProcess = function (validResult, dragState) {
  Companion_instance_8.z1l(dragState.draggedRootEntity, validResult.snapCandidate.endTransform);
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = Companion_instance_1.getMatchingSnapsInScene$default(dragState.draggedRootEntity, this.k43_1.sceneManager);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
      if (!(element.alignmentInitiatorCandidate == null)) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = toList_0(destination);
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = this_1.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
      if (element_0.priority > validResult.snapCandidate.priority) {
        destination_0.h(element_0);
      }
    }
    var iterator = destination_0.k();
    if (!iterator.m()) {
      tmp$ret$6 = null;
      break $l$block_0;
    }
    var maxElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$6 = maxElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
    var maxValue = maxElem.priority;
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
      var v = e.priority;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$6 = maxElem;
  }
  var tmp0_safe_receiver = tmp$ret$6;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
    tmp = this.k43_1.validations.validateSnapCandidate(tmp0_safe_receiver);
  }
  var newCandidateResult = tmp;
  var newCandidate = newCandidateResult == null ? null : newCandidateResult.snap;
  if (!(newCandidate == null) && newCandidateResult.valid) {
    var newValidResult = new ValidDragStrategyResult(newCandidate.guestRoot, newCandidate, newCandidateResult.warnings);
    return newValidResult;
  }
  return validResult;
};
function Companion_34() {
}
protoOf(Companion_34).n1s = function () {
  return Companion_instance_0.i1p_1;
};
var Companion_instance_73;
function Companion_getInstance_77() {
  return Companion_instance_73;
}
function IsDraggedComponent() {
  this.l43_1 = false;
}
protoOf(IsDraggedComponent).p1s = function () {
  return Companion_instance_73.id;
};
protoOf(IsDraggedComponent).s1s = function () {
  return this.l43_1;
};
protoOf(IsDraggedComponent).eq = function (other) {
  return true;
};
function get_isBeingDragged(_this__u8e3s4) {
  var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_instance_0.i1p_1)) === true;
}
function Companion_35() {
  Companion_instance_74 = this;
  this.d3z_1 = Companion_instance_0.d1s_1;
}
var Companion_instance_74;
function Companion_getInstance_78() {
  if (Companion_instance_74 == null)
    new Companion_35();
  return Companion_instance_74;
}
function MultiDragCommonParentComponent(originallyDraggedEntity, childrenAndFormerParents) {
  Companion_getInstance_78();
  this.e3z_1 = originallyDraggedEntity;
  this.f3z_1 = childrenAndFormerParents;
  this.g3z_1 = Companion_getInstance_78().d3z_1;
}
protoOf(MultiDragCommonParentComponent).p1s = function () {
  return this.g3z_1;
};
protoOf(MultiDragCommonParentComponent).eq = function (other) {
  var o = other instanceof MultiDragCommonParentComponent ? other : THROW_CCE();
  return this.e3z_1.equals(o.e3z_1) && equals(this.f3z_1, o.f3z_1);
};
function removeDragComponents($this, entity) {
  if (!get_isAutomaticGroup(entity) && Companion_instance_12.w2o(entity))
    return Unit_instance;
  if (!entity.hasComponent(Companion_getInstance_79().m43_1)) {
    entity.addComponent(new RemovedDragComponentsComponent(entity.hasComponent(Companion_getInstance_2().id), entity.hasComponent(Companion_getInstance_23().id)));
  }
  entity.removeComponentInternal(Companion_getInstance_2().id);
  entity.removeComponent(Companion_getInstance_23().id);
}
function addDragComponents_0($this, entity) {
  if (!get_isAutomaticGroup(entity) && Companion_instance_12.w2o(entity))
    return Unit_instance;
  var tmp = entity.removeComponent(Companion_getInstance_79().m43_1);
  var removedDragComponents = (tmp == null ? true : tmp instanceof RemovedDragComponentsComponent) ? tmp : THROW_CCE();
  if (!((removedDragComponents == null ? null : removedDragComponents.hadSnapRoot) === false)) {
    entity.addComponent(new SnapRootComponent());
  }
  if (!((removedDragComponents == null ? null : removedDragComponents.hadDraggable) === false)) {
    entity.addComponent(new DraggableComponent());
  }
}
function removeDragComponentsUpToTemporaryParent($this, entity, tempDragParent) {
  var currentEntity = entity;
  $l$loop: while (!currentEntity.equals(tempDragParent)) {
    removeDragComponents($this, currentEntity);
    var tmp0_elvis_lhs = get_parent(currentEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    currentEntity = tmp;
  }
}
function sam$kotlin_Comparator$0_2(function_0) {
  this.o43_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_2).md = function (a, b) {
  return this.o43_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).s3 = function () {
  return this.o43_1;
};
protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
  return hashCode(this.s3());
};
function MultiDragUtils$getSelectedEntityRoots$lambda($draggedEntity) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
    var tmp = get_worldPosition(a).distanceTo(get_worldPosition($draggedEntity));
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
    var tmp$ret$1 = get_worldPosition(b).distanceTo(get_worldPosition($draggedEntity));
    return compareValues(tmp, tmp$ret$1);
  };
}
function MultiDragUtils() {
}
protoOf(MultiDragUtils).z3y = function (sceneManager, draggedEntity) {
  var tmp;
  var tmp0_safe_receiver = get_selectableRoot(draggedEntity);
  if (!((tmp0_safe_receiver == null ? null : get_isSelected(tmp0_safe_receiver)) === true)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = hierarchyExceptSubTreesWithComponentArray(draggedEntity, Companion_getInstance_2().id);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
        if (get_isSelected(element)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    tmp = !tmp$ret$1;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [draggedEntity];
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = this_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
    if (!equals(get_draggableRootEntity(element_0), get_draggableRootEntity(draggedEntity)) && element_0.hasComponent(Companion_getInstance_24().id) && !hasAncestor(element_0, draggedEntity)) {
      destination.h(element_0);
    }
  }
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
    var tmp0_safe_receiver_0 = get_draggableRootEntity(element_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver_0);
    }
  }
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = MultiDragUtils$getSelectedEntityRoots$lambda(draggedEntity);
  var tmp$ret$12 = new sam$kotlin_Comparator$0_2(tmp_0);
  var tmp$ret$13 = sortedWith(destination_0, tmp$ret$12);
  var selectedEntities = toSet(filterNotNull(plus_0(tmp$ret$13, get_draggableRootEntity(draggedEntity))));
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = selectedEntities.k();
  while (tmp0_iterator_0.m()) {
    var element_2 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>' call
    var tmp$ret$14;
    $l$block_1: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(selectedEntities, Collection)) {
        tmp_1 = selectedEntities.r();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$14 = false;
        break $l$block_1;
      }
      var tmp0_iterator_1 = selectedEntities.k();
      while (tmp0_iterator_1.m()) {
        var element_3 = tmp0_iterator_1.n();
        // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getSelectedEntityRoots.<anonymous>.<anonymous>' call
        if (hasAncestor(element_2, element_3)) {
          tmp$ret$14 = true;
          break $l$block_1;
        }
      }
      tmp$ret$14 = false;
    }
    if (tmp$ret$14) {
      destination_1.h(element_2);
    }
  }
  var entitiesToRemove = destination_1;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = minus(selectedEntities, toSet(entitiesToRemove));
  var roots = copyToArray(this_1);
  return roots;
};
protoOf(MultiDragUtils).p43 = function (entities) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = Companion_getInstance_15().ZERO;
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.getCenterOfEntities.<anonymous>' call
    accumulator = accumulator.plus(get_worldPosition(element));
  }
  var center = accumulator.__divIntForKotlin(entities.length);
  return center;
};
protoOf(MultiDragUtils).i3z = function (draggedRoot) {
  if (draggedRoot.isDisposed)
    return Unit_instance;
  var tmp0_safe_receiver = draggedRoot.__getComponentForKotlin(Companion_getInstance_78().d3z_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(draggedRoot);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.handleRemainingChildrenAfterDragStop.<anonymous>.<anonymous>' call
      MultiDragUtils_instance.j3z(tmp0_safe_receiver, element);
    }
    draggedRoot.removeComponent(Companion_getInstance_78().d3z_1);
    draggedRoot.dispose();
  }
};
protoOf(MultiDragUtils).j3z = function (multiDrag, child) {
  var previousParent = multiDrag.f3z_1.f2(child);
  setParentMaintainWorldTransform(child, previousParent);
  addDragComponents_0(this, child);
};
protoOf(MultiDragUtils).h3z = function (entity, tempDragParent) {
  var currentEntity = entity;
  $l$loop: while (!currentEntity.equals(tempDragParent)) {
    addDragComponents_0(this, currentEntity);
    var tmp0_elvis_lhs = get_parent(currentEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    currentEntity = tmp;
  }
};
protoOf(MultiDragUtils).a3z = function (coreServices, entity, selectedEntityRoots, placeAtCenter) {
  var tempParent = coreServices.entityManager.createEntity();
  setParent(tempParent, coreServices.sceneManager.scene);
  addDragComponents_0(this, tempParent);
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_13().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
    tempParent.addComponentInternal(tmp0_safe_receiver);
    entity.removeComponentInternal(Companion_getInstance_13().id);
  }
  tempParent.addComponent(new TemporaryParentComponent());
  set_displayName(tempParent, 'temporary drag parent');
  if (placeAtCenter) {
    Companion_instance_8.l3g(tempParent, this.p43(selectedEntityRoots));
    var tmp1_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_87().id);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
      tempParent.addComponentInternal(tmp1_safe_receiver);
    }
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = selectedEntityRoots.length;
      while (inductionVariable < last) {
        var element = selectedEntityRoots[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
        if (isDescendantOf(entity, element)) {
          tmp$ret$5 = element;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    var tmp2_elvis_lhs = tmp$ret$5;
    var rootDragProjectionPoint = get_dragProjectionPoint(tmp2_elvis_lhs == null ? entity : tmp2_elvis_lhs);
    Companion_instance_8.l3g(tempParent, rootDragProjectionPoint);
    var tmp3_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_87().id);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
      var grabPoint = get_worldPosition(entity).plus(tmp3_safe_receiver.worldDragProjectionPointOffset).minus(tmp3_safe_receiver.worldGrabOffset);
      var worldGrabOffset = get_worldPosition(tempParent).minus(grabPoint);
      var worldDragProjectionPointOffset = Companion_getInstance_15().ZERO;
      tempParent.addComponentInternal(new GrabOffsetComponent(worldGrabOffset, worldDragProjectionPointOffset));
    }
  }
  entity.removeComponentInternal(Companion_getInstance_87().id);
  entity.removeComponentInternal(Companion_getInstance_20().id);
  // Inline function 'kotlin.collections.associateWith' call
  var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(selectedEntityRoots.length), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable_0 = 0;
  var last_0 = selectedEntityRoots.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = selectedEntityRoots[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
    var tmp$ret$9 = get_parent(element_0);
    result.q2(element_0, tmp$ret$9);
  }
  tempParent.addComponent(new MultiDragCommonParentComponent(entity, result));
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_1 = 0;
  var last_1 = selectedEntityRoots.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = selectedEntityRoots[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.MultiDragUtils.createMultiDragCommonParent.<anonymous>' call
    setParentMaintainWorldTransform(element_1, tempParent);
    removeDragComponents(MultiDragUtils_instance, element_1);
  }
  removeDragComponentsUpToTemporaryParent(this, entity, tempParent);
  return tempParent;
};
protoOf(MultiDragUtils).h42 = function (coreServices, entity, selectedEntityRoots, placeAtCenter, $super) {
  placeAtCenter = placeAtCenter === VOID ? false : placeAtCenter;
  return $super === VOID ? this.a3z(coreServices, entity, selectedEntityRoots, placeAtCenter) : $super.a3z.call(this, coreServices, entity, selectedEntityRoots, placeAtCenter);
};
var MultiDragUtils_instance;
function MultiDragUtils_getInstance() {
  return MultiDragUtils_instance;
}
function PostProcessDragStrategy() {
}
function Companion_36() {
  Companion_instance_75 = this;
  this.m43_1 = Companion_instance_0.e1s_1;
}
protoOf(Companion_36).n1s = function () {
  return this.m43_1;
};
var Companion_instance_75;
function Companion_getInstance_79() {
  if (Companion_instance_75 == null)
    new Companion_36();
  return Companion_instance_75;
}
function get_id() {
  return Companion_getInstance_79().m43_1;
}
function RemovedDragComponentsComponent(hadSnapRoot, hadDraggable) {
  Companion_getInstance_79();
  this.hadSnapRoot = hadSnapRoot;
  this.hadDraggable = hadDraggable;
  this.n43_1 = false;
}
protoOf(RemovedDragComponentsComponent).r43 = function () {
  return this.hadSnapRoot;
};
protoOf(RemovedDragComponentsComponent).s43 = function () {
  return this.hadDraggable;
};
protoOf(RemovedDragComponentsComponent).p1s = function () {
  return Companion_getInstance_79().m43_1;
};
protoOf(RemovedDragComponentsComponent).eq = function (other) {
  var tmp;
  if ((other instanceof RemovedDragComponentsComponent ? other : THROW_CCE()).hadSnapRoot === this.hadSnapRoot) {
    tmp = other.hadDraggable === this.hadDraggable;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(RemovedDragComponentsComponent).s1s = function () {
  return this.n43_1;
};
function Companion_37() {
  this.l42_1 = 'TakeSnapshotBeforeDragSystem';
}
var Companion_instance_76;
function Companion_getInstance_80() {
  return Companion_instance_76;
}
function TakeSnapshotBeforeDragSystem(coreServices) {
  SystemBase.call(this, Companion_instance_76.l42_1, Companion_getInstance_20().id);
  this.c44_1 = coreServices;
}
protoOf(TakeSnapshotBeforeDragSystem).m42 = function (entity, newComponent) {
  if (get_snapRoot(entity) == null)
    return Unit_instance;
  var tmp0_safe_receiver = this.c44_1.coreModules.history();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.takeSnapshot('drag start');
  }
};
protoOf(TakeSnapshotBeforeDragSystem).v1v = function (entity, newComponent) {
  return this.m42(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
function _get_validationService__6mut63($this) {
  return $this.j3t().validations;
}
function AbstractDragStrategy() {
  this.t3w_1 = true;
}
protoOf(AbstractDragStrategy).c1k = function () {
  return this.j3t().entityManager;
};
protoOf(AbstractDragStrategy).s1w = function () {
  return this.t3w_1;
};
protoOf(AbstractDragStrategy).enable = function () {
  this.t3w_1 = true;
};
protoOf(AbstractDragStrategy).disable = function () {
  this.t3w_1 = false;
};
protoOf(AbstractDragStrategy).u3w = function (guestEntity, hostEntity) {
  var tmp0_elvis_lhs = get_snapRoot(guestEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_instance_13.noSnappingEntity(guestEntity);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snappingGuest = tmp;
  var snapsByDistance = Companion_getInstance_4().s35_1.sortAndSelect(Companion_instance_1.getMatchingSnaps$default(snappingGuest, hostEntity));
  var tmp1_elvis_lhs = firstOrNull_0(snapsByDistance);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Companion_instance_13.noSnapCandidates(guestEntity);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var snap = tmp_0;
  return _get_validationService__6mut63(this).validateSnapCandidate(snap).toValidSnapActionCandidateOrErrors();
};
protoOf(AbstractDragStrategy).v3w = function (guestEntity) {
  var tmp0_elvis_lhs = get_snapRoot(guestEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_instance_13.noSnappingEntity(guestEntity);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snappingGuest = tmp;
  var snapsByDistance = Companion_getInstance_4().s35_1.sortAndSelect(Companion_instance_1.getMatchingSnapsInScene$default(snappingGuest, this.j3t().sceneManager));
  var tmp1_elvis_lhs = firstOrNull_0(snapsByDistance);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Companion_instance_13.noSnapCandidates(guestEntity);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var snap = tmp_0;
  return _get_validationService__6mut63(this).validateSnapCandidate(snap).toValidSnapActionCandidateOrErrors();
};
function DragStrategy() {
}
function Companion_38() {
  Companion_instance_77 = this;
  this.id = Companion_instance_0.k1p_1;
}
protoOf(Companion_38).n1s = function () {
  return this.id;
};
var Companion_instance_77;
function Companion_getInstance_81() {
  if (Companion_instance_77 == null)
    new Companion_38();
  return Companion_instance_77;
}
function FreeMoveComponent() {
  Companion_getInstance_81();
}
protoOf(FreeMoveComponent).p1s = function () {
  return Companion_getInstance_81().id;
};
protoOf(FreeMoveComponent).eq = function (other) {
  return true;
};
function findSnapWhereEntityDoesNotCollide($this, draggedEntity, delta) {
  var tmp0_elvis_lhs = get_snapRoot(draggedEntity);
  var entity = tmp0_elvis_lhs == null ? draggedEntity : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = Companion_instance_14.d1y(entity, delta, hierarchyExceptSubTreeArray($this.f44_1.sceneManager.root, entity));
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.ResolveCollisionsDragStrategy.findSnapWhereEntityDoesNotCollide.<anonymous>' call
    var validSnapResult = null;
    var snapResult = $this.u3w(entity, element.other);
    if (snapResult.valid) {
      validSnapResult = snapResult;
    } else {
      var tmp0_safe_receiver = get_snapRoot(draggedEntity);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
      var worldTransformBefore = tmp1_elvis_lhs == null ? Companion_getInstance_22().c1x_1 : tmp1_elvis_lhs;
      var testTransform = new Transform(get_worldPosition(draggedEntity).plus(element.interpenetration), get_worldTransform(draggedEntity).rotation);
      Companion_instance_8.z1l(draggedEntity, testTransform);
      var snapToAnythingSnapResult = $this.v3w(draggedEntity);
      if (snapToAnythingSnapResult.valid)
        validSnapResult = snapToAnythingSnapResult;
      Companion_instance_8.z1l(draggedEntity, worldTransformBefore);
    }
    if (!(validSnapResult == null))
      return validSnapResult;
  }
  return null;
}
function hasConnectionThatDemandsContinuous($this, entity) {
  return !($this.e44_1 === -1) && entity.hasComponent($this.e44_1);
}
function ResolveCollisionsDragStrategy(resolveCollisionFeatureTag, coreServices) {
  AbstractDragStrategy.call(this);
  this.e44_1 = resolveCollisionFeatureTag;
  this.f44_1 = coreServices;
  this.g44_1 = 'ResolveCollisionsDragStrategy';
  this.h44_1 = false;
}
protoOf(ResolveCollisionsDragStrategy).j3t = function () {
  return this.f44_1;
};
protoOf(ResolveCollisionsDragStrategy).v2 = function () {
  return this.g44_1;
};
protoOf(ResolveCollisionsDragStrategy).dragStart = function (draggedRootEntity) {
  this.h44_1 = hasConnectionThatDemandsContinuous(this, draggedRootEntity);
};
protoOf(ResolveCollisionsDragStrategy).dragStop = function (draggedRootEntity) {
  this.h44_1 = false;
};
protoOf(ResolveCollisionsDragStrategy).dragMove = function (dragState) {
  if (!this.h44_1) {
    return null;
  }
  var lastValidWorld = dragState.lastValidWorldTransform;
  var delta = dragState.dragEndTransform.position.minus(lastValidWorld.position);
  var validSnapResult = findSnapWhereEntityDoesNotCollide(this, dragState.draggedRootEntity, delta);
  var dragStrategyResult = Companion_instance_79.fromSnapResult(validSnapResult);
  return dragStrategyResult;
};
function tryLocalDirection($this, localDirection, host, draggedEntity, lastValidWorld, dragDelta, hostConnectorWorld) {
  var dragDeltaProjectedLocally = dragDelta.projectOn(hostConnectorWorld.transformVector(localDirection));
  var candidatePosition = lastValidWorld.position.plus(dragDeltaProjectedLocally);
  Companion_instance_8.z1l(draggedEntity, new Transform(candidatePosition, get_worldTransform(draggedEntity).rotation));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var indexedObject = Companion_getInstance_4().r35_1.sortAndSelect(Companion_instance_1.getMatchingSnaps$default(draggedEntity, host));
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapCardinalDirectionsDragStrategy.tryLocalDirection.<anonymous>' call
      if (element.inActivationDistance()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var localProjectedCandidate = tmp$ret$1;
  var fixedCandidate = localProjectedCandidate == null ? null : localProjectedCandidate.withInitialTransform(lastValidWorld);
  var tmp;
  if (fixedCandidate == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapCardinalDirectionsDragStrategy.tryLocalDirection.<anonymous>' call
    tmp = $this.k44_1.validateSnapCandidate(fixedCandidate);
  }
  var result = tmp;
  if (result == null || !result.valid) {
    return null;
  }
  var dragStrategyResult = Companion_instance_79.fromValidatedSnapResult(result);
  return dragStrategyResult;
}
function SnapCardinalDirectionsDragStrategy(coreServices) {
  AbstractDragStrategy.call(this);
  this.j44_1 = coreServices;
  this.k44_1 = this.j44_1.validations;
  this.l44_1 = 'SnapCardinalDirectionsDragStrategy';
}
protoOf(SnapCardinalDirectionsDragStrategy).j3t = function () {
  return this.j44_1;
};
protoOf(SnapCardinalDirectionsDragStrategy).v2 = function () {
  return this.l44_1;
};
protoOf(SnapCardinalDirectionsDragStrategy).dragMove = function (dragState) {
  var draggedEntity = dragState.draggedRootEntity;
  var tmp0_safe_receiver = dragState.validDragStrategyResult;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.snapCandidate;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hostConnector;
  var tmp;
  if (tmp2_elvis_lhs == null) {
    var tmp3_safe_receiver = get_highestPriorityConnection(draggedEntity);
    tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hostConnector;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var tmp4_elvis_lhs = tmp;
  var tmp_0;
  if (tmp4_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp4_elvis_lhs;
  }
  var hostConnector = tmp_0;
  if (!(hostConnector instanceof SurfaceConnector))
    return null;
  var tmp5_safe_receiver = dragState.validDragStrategyResult;
  var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.snapCandidate;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.host;
  var tmp_1;
  if (tmp7_elvis_lhs == null) {
    var tmp8_safe_receiver = get_highestPriorityConnection(draggedEntity);
    tmp_1 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.hostConnectorEntity;
  } else {
    tmp_1 = tmp7_elvis_lhs;
  }
  var tmp9_elvis_lhs = tmp_1;
  var tmp_2;
  if (tmp9_elvis_lhs == null) {
    return null;
  } else {
    tmp_2 = tmp9_elvis_lhs;
  }
  var host = tmp_2;
  var lastValidWorldTransform = dragState.lastValidWorldTransform;
  var dragDelta = dragState.dragEndTransform.position.minus(lastValidWorldTransform.position);
  var hostConnectorWorld = get_worldTransform(host).concatenate(hostConnector.y2h_1);
  var horizontalResult = tryLocalDirection(this, Companion_getInstance_15().RIGHT, host, draggedEntity, lastValidWorldTransform, dragDelta, hostConnectorWorld);
  if (!(horizontalResult == null))
    return horizontalResult;
  var verticalResult = tryLocalDirection(this, Companion_getInstance_15().FORWARD, host, draggedEntity, lastValidWorldTransform, dragDelta, hostConnectorWorld);
  if (!(verticalResult == null))
    return verticalResult;
  return null;
};
function Companion_39() {
  Companion_instance_78 = this;
  this.ID = 'SnapClosestDragStrategy';
  this.m44_1 = LoggerState_getInstance().g1v('SnapClosestDragStrategy');
}
protoOf(Companion_39).j1y = function () {
  return this.ID;
};
var Companion_instance_78;
function Companion_getInstance_82() {
  if (Companion_instance_78 == null)
    new Companion_39();
  return Companion_instance_78;
}
function sortedSnaps_0($this, entity) {
  var includeAlignment = $this.includeAlignmentConnectorsOutsideActivationDistance;
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.sortedSnaps.<anonymous>' call
    tmp = Companion_getInstance_4().r35_1.sortAndSelect(Companion_instance_1.i3e(tmp0_safe_receiver, $this.o44_1.sceneManager, new SnapSettings(VOID, VOID, VOID, includeAlignment)));
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var matchingSnaps = tmp_0;
  return toList(matchingSnaps);
}
function getDistanceFromEndDragToSnap($this, dragEndTransform, snapCandidate) {
  var connectorDragStatePosition = dragEndTransform.concatenate(snapCandidate.guestRootToGuestConnectorDeltaTransform).position;
  var connectorCandidatePosition = snapCandidate.endTransform.concatenate(snapCandidate.guestRootToGuestConnectorDeltaTransform).position;
  var distanceFromEndDragToSnap = connectorCandidatePosition.minus(connectorDragStatePosition).size;
  return distanceFromEndDragToSnap;
}
function SnapClosestDragStrategy(coreServices) {
  Companion_getInstance_82();
  AbstractDragStrategy.call(this);
  this.o44_1 = coreServices;
  this.includeAlignmentConnectorsOutsideActivationDistance = false;
  this.p44_1 = 'SnapClosestDragStrategy';
  this.q44_1 = this.o44_1.validations;
}
protoOf(SnapClosestDragStrategy).j3t = function () {
  return this.o44_1;
};
protoOf(SnapClosestDragStrategy).r44 = function (_set____db54di) {
  this.includeAlignmentConnectorsOutsideActivationDistance = _set____db54di;
};
protoOf(SnapClosestDragStrategy).y3d = function () {
  return this.includeAlignmentConnectorsOutsideActivationDistance;
};
protoOf(SnapClosestDragStrategy).v2 = function () {
  return this.p44_1;
};
protoOf(SnapClosestDragStrategy).dragMove = function (dragState) {
  var snapCandidates = sortedSnaps_0(this, dragState.draggedRootEntity);
  var tmp0_safe_receiver = dragState.validDragStrategyResult;
  var lastValidSnap = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.snapCandidate;
  var distanceToLastValidSnap = !(lastValidSnap == null) ? getDistanceFromEndDragToSnap(this, dragState.dragEndTransform, lastValidSnap) : dragState.initialTransform.position.distanceTo(dragState.dragEndTransform.position);
  var foundSnap = null;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = snapCandidates.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>' call
    var tmp0_safe_receiver_0 = element.alignmentInitiatorCandidate;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>.<anonymous>' call
      tmp = tmp0_safe_receiver_0.hostConnector.activationDistance + tmp0_safe_receiver_0.guestConnector.activationDistance;
    }
    var tmp1_elvis_lhs = tmp;
    var activationDistance = tmp1_elvis_lhs == null ? element.hostConnector.activationDistance + element.guestConnector.activationDistance : tmp1_elvis_lhs;
    var distanceFromEndDragToSnap = getDistanceFromEndDragToSnap(this, dragState.dragEndTransform, element);
    var isCloserThanLastValidSnap = distanceFromEndDragToSnap - activationDistance <= distanceToLastValidSnap;
    if (isCloserThanLastValidSnap) {
      destination.h(element);
    }
  }
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>' call
    if (foundSnap == null) {
      var res = this.q44_1.validateSnapCandidate(element_0);
      if (res.valid) {
        foundSnap = res;
      }
    }
  }
  var dragStrategyResult = Companion_instance_79.fromValidatedSnapResult(foundSnap);
  return dragStrategyResult;
};
function findValidSnapAmongSubConnectors($this, entity, rayFromCameraToDragPoint) {
  var tmp0_elvis_lhs = findHoveredHost($this, entity, rayFromCameraToDragPoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var hoveredHost = tmp;
  var result = {_v: null};
  forEachInHierarchy(hoveredHost, SnapClosestWithSubConnectorsDragStrategy$findValidSnapAmongSubConnectors$lambda(result, $this, entity));
  var dragResult = Companion_instance_79.fromValidatedSnapResult(result._v);
  return dragResult;
}
function findHoveredHost($this, entity, rayFromCameraToDragPoint) {
  var tmp0_elvis_lhs = Companion_instance_15.raycast$default(rayFromCameraToDragPoint, $this.w44_1.root, entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var result = tmp;
  return findWithComponentInUpwardsHierarchy(result.entity, FrameComponent_getInstance().id);
}
function sortedSnaps_1($this, entity, host) {
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestWithSubConnectorsDragStrategy.sortedSnaps.<anonymous>' call
    tmp = Companion_getInstance_4().r35_1.sortAndSelect(Companion_instance_1.p1l(tmp0_safe_receiver, host, new SnapSettings(true)));
  }
  var matchingSnaps = tmp;
  return matchingSnaps;
}
function SnapClosestWithSubConnectorsDragStrategy$findValidSnapAmongSubConnectors$lambda($result, this$0, $entity) {
  return function (host) {
    var tmp;
    if ($result._v == null) {
      var tmp0_safe_receiver = sortedSnaps_1(this$0, $entity, host);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestWithSubConnectorsDragStrategy.findValidSnapAmongSubConnectors.<anonymous>.<anonymous>' call
          if ($result._v == null) {
            var res = this$0.v44_1.validateSnapCandidate(element, true);
            if (res.valid) {
              $result._v = res;
            }
          }
        }
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SnapClosestWithSubConnectorsDragStrategy(coreServices) {
  AbstractDragStrategy.call(this);
  this.t44_1 = coreServices;
  this.u44_1 = 'SnapClosestWithSubConnectorsDragStrategy';
  this.v44_1 = this.t44_1.validations;
  this.w44_1 = this.t44_1.sceneManager;
}
protoOf(SnapClosestWithSubConnectorsDragStrategy).j3t = function () {
  return this.t44_1;
};
protoOf(SnapClosestWithSubConnectorsDragStrategy).v2 = function () {
  return this.u44_1;
};
protoOf(SnapClosestWithSubConnectorsDragStrategy).dragMove = function (dragState) {
  return findValidSnapAmongSubConnectors(this, dragState.draggedRootEntity, dragState.rayFromCameraToDragPoint);
};
function Companion_40() {
}
protoOf(Companion_40).fromSnapResult = function (result) {
  var validCandidate = result == null ? null : result.snap;
  var tmp;
  if (validCandidate == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.Companion.fromSnapResult.<anonymous>' call
    tmp = new ValidDragStrategyResult(validCandidate.guestRoot, validCandidate, result.warnings);
  }
  return tmp;
};
protoOf(Companion_40).fromValidatedSnapResult = function (result) {
  var validCandidate = result == null ? null : result.snap;
  var tmp;
  if (validCandidate == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.dragstrategy.Companion.fromValidatedSnapResult.<anonymous>' call
    tmp = new ValidDragStrategyResult(validCandidate.guestRoot, validCandidate, result.warnings);
  }
  return tmp;
};
var Companion_instance_79;
function Companion_getInstance_83() {
  return Companion_instance_79;
}
function ValidDragStrategyResult(entity, snapCandidate, warnings) {
  warnings = warnings === VOID ? null : warnings;
  this.entity = entity;
  this.snapCandidate = snapCandidate;
  var tmp = this;
  var tmp_0;
  if (warnings == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = warnings;
  }
  tmp.warnings = tmp_0;
}
protoOf(ValidDragStrategyResult).v2i = function () {
  return this.entity;
};
protoOf(ValidDragStrategyResult).x3w = function () {
  return this.snapCandidate;
};
protoOf(ValidDragStrategyResult).d3h = function () {
  return this.warnings;
};
protoOf(ValidDragStrategyResult).performFinalSnapAction = function (state, coreServices) {
  var snapCandidate = this.snapCandidate.withInitialTransform(state.initialTransform);
  var hasTransformChange = !get_worldTransform(snapCandidate.guest).equals(state.initialTransform.concatenate(get_worldTransform(snapCandidate.guest).delta(get_worldTransform(state.draggedRootEntity))));
  var hasParentChange = !equals(get_parent(snapCandidate.guest), snapCandidate.host);
  var tmp;
  if (hasTransformChange || hasParentChange) {
    var multiDragParent = state.draggedRootEntity.__getComponentForKotlin(Companion_getInstance_78().d3z_1);
    snapCandidate.performMoveAndConnect();
    if (hasTransformChange || multiDragParent == null) {
      return true;
    }
    var isNewParentDifferentFromParentBeforeDragStart = !snapCandidate.host.equals(multiDragParent.f3z_1.f2(snapCandidate.guest));
    return isNewParentDifferentFromParentBeforeDragStart;
  } else {
    tmp = false;
  }
  return tmp;
};
function CanvasTo3DDragConverterSystem_init_$Init$(coreServices, projector, $this) {
  CanvasTo3DDragConverterSystem.call($this, coreServices.entityManager, coreServices.sceneManager, projector);
  return $this;
}
function CanvasTo3DDragConverterSystemFromCoreServices(coreServices, projector) {
  return CanvasTo3DDragConverterSystem_init_$Init$(coreServices, projector, objectCreate(protoOf(CanvasTo3DDragConverterSystem)));
}
function vectorFromGrabPointToDragPoint($this, entity, grabPoint) {
  var tmp0_elvis_lhs = get_draggableRootEntity(entity);
  var dragRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  return get_dragProjectionPoint(dragRoot).minus(grabPoint);
}
function getDragProjectionPointOffsetWorldSpace($this, entity) {
  var tmp0_elvis_lhs = get_draggableRootEntity(entity);
  var dragRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  var dragProjectionPointWorldSpace = get_dragProjectionPoint(dragRoot);
  var dragProjectionPointOffset = dragProjectionPointWorldSpace.minus(get_worldPosition(dragRoot));
  return dragProjectionPointOffset;
}
function sendDragEvent($this, entity, event) {
  var offsetRay = Companion_instance_16.createFromPoints(event.cameraPosition, event.planePoint.plus(getWorldGrabOffset($this, entity)));
  var tmp0_elvis_lhs = $this.i45_1.project(offsetRay, entity, event.planeNormal.__timesIntForKotlin(-1));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var projectionHit = tmp;
  var newWorldPosition = projectionHit.minus(getWorldDragProjectionPointOffset($this, entity));
  var ray = Companion_instance_16.createFromPoints(event.cameraPosition, newWorldPosition);
  var moveDragEvent = new WorldSpaceDragEventComponent(newWorldPosition, ray);
  $this.g45_1.addComponent(entity, moveDragEvent);
}
function getWorldGrabOffset($this, entity) {
  var grabOffsetComponent = entity.__getComponentForKotlin(Companion_getInstance_87().id);
  var tmp1_elvis_lhs = grabOffsetComponent == null ? null : grabOffsetComponent.worldGrabOffset;
  var worldGrabOffset = tmp1_elvis_lhs == null ? Companion_getInstance_15().ZERO : tmp1_elvis_lhs;
  return worldGrabOffset;
}
function getWorldDragProjectionPointOffset($this, entity) {
  var grabOffsetComponent = entity.__getComponentForKotlin(Companion_getInstance_87().id);
  var tmp1_elvis_lhs = grabOffsetComponent == null ? null : grabOffsetComponent.worldDragProjectionPointOffset;
  var worldDragProjectionPointOffset = tmp1_elvis_lhs == null ? Companion_getInstance_15().ZERO : tmp1_elvis_lhs;
  return worldDragProjectionPointOffset;
}
function findCurrentlyDraggedEntity($this) {
  var dragStateComponent = $this.h45_1.scene.__getComponentForKotlin(Companion_instance_0.m1p_1);
  var tmp1_safe_receiver = dragStateComponent == null ? null : dragStateComponent.dragState;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.validDragStrategyResult;
  var candidateSnapAction = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.snapCandidate;
  var tmp4_safe_receiver = candidateSnapAction == null ? null : candidateSnapAction.guest;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : get_draggableRootEntity(tmp4_safe_receiver);
  var tmp;
  if (tmp5_elvis_lhs == null) {
    var tmp7_safe_receiver = dragStateComponent == null ? null : dragStateComponent.dragState;
    tmp = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.draggedRootEntity;
  } else {
    tmp = tmp5_elvis_lhs;
  }
  var realEntity = tmp;
  return realEntity;
}
function Companion_41() {
  Companion_instance_80 = this;
  this.ID = 'CanvasTo3DDragConverterSystem';
  this.m45_1 = LoggerState_getInstance().g1v('CanvasTo3DDragConverterSystem');
}
protoOf(Companion_41).j1y = function () {
  return this.ID;
};
var Companion_instance_80;
function Companion_getInstance_84() {
  if (Companion_instance_80 == null)
    new Companion_41();
  return Companion_instance_80;
}
function CanvasTo3DDragConverterSystem(entityManager, sceneManager, projector) {
  Companion_getInstance_84();
  var tmp = Companion_getInstance_84().ID;
  var tmp_0 = Companion_getInstance_13().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_87().id, Companion_getInstance_20().id];
  SystemBase.call(this, tmp, tmp_0, tmp$ret$2);
  this.g45_1 = entityManager;
  this.h45_1 = sceneManager;
  this.i45_1 = projector;
  this.j45_1 = new DragSurfacesUpdateSystem(this.g45_1);
  this.k45_1 = new DragSurfaceUpdatesListenerSystem(this.i45_1, this.h45_1);
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_1.l45_1 = [Companion_getInstance_20().id];
}
protoOf(CanvasTo3DDragConverterSystem).onRegister = function () {
  protoOf(SystemBase).onRegister.call(this);
  this.j45_1.l2d(this.g45_1);
  this.k45_1.l2d(this.g45_1);
};
protoOf(CanvasTo3DDragConverterSystem).onUnregister = function () {
  protoOf(SystemBase).onUnregister.call(this);
  this.j45_1.m2d(this.g45_1);
  this.k45_1.m2d(this.g45_1);
};
protoOf(CanvasTo3DDragConverterSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  this.j45_1.enable();
  this.k45_1.enable();
};
protoOf(CanvasTo3DDragConverterSystem).disable = function () {
  protoOf(SystemBase).disable.call(this);
  this.j45_1.disable();
  this.k45_1.disable();
};
protoOf(CanvasTo3DDragConverterSystem).y3y = function (entity, newComponent) {
  if (get_draggableRootEntity(entity) == null)
    null;
  else {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.CanvasTo3DDragConverterSystem.onAddComponent.<anonymous>' call
    var grabPoint = newComponent.planePoint;
    var worldGrabOffset = vectorFromGrabPointToDragPoint(this, entity, grabPoint);
    var worldDragProjectionPointOffset = getDragProjectionPointOffsetWorldSpace(this, entity);
    entity.addComponent(new GrabOffsetComponent(worldGrabOffset, worldDragProjectionPointOffset));
    sendDragEvent(this, entity, newComponent);
  }
};
protoOf(CanvasTo3DDragConverterSystem).v1v = function (entity, newComponent) {
  return this.y3y(entity, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(CanvasTo3DDragConverterSystem).b3z = function (entity, oldComponent, newComponent) {
  if (findCurrentlyDraggedEntity(this) == null)
    return Unit_instance;
  sendDragEvent(this, entity, newComponent);
};
protoOf(CanvasTo3DDragConverterSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE();
  return this.b3z(entity, tmp, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(CanvasTo3DDragConverterSystem).c3z = function (entity, oldComponent) {
  this.g45_1.removeComponent(entity, Companion_getInstance_20().id);
};
protoOf(CanvasTo3DDragConverterSystem).z1v = function (entity, oldComponent) {
  return this.c3z(entity, oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(CanvasTo3DDragConverterSystem).j1w = function () {
  return this.l45_1;
};
protoOf(CanvasTo3DDragConverterSystem).setProjector = function (converter) {
  this.i45_1 = converter;
};
protoOf(CanvasTo3DDragConverterSystem).getProjector = function () {
  return this.i45_1;
};
function get_dragProjectionPoint(_this__u8e3s4) {
  var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
  var dragRoot = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  var tmp1_safe_receiver = dragRoot.__getComponentForKotlin(Companion_getInstance_86().id);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return get_worldTransform(_this__u8e3s4).transformPosition(tmp1_safe_receiver.projectionPoint);
  }
  var outgoingConnections = Companion_instance.c29(dragRoot);
  var autoAdaptOriginalEntity = get_autoAdaptOriginalEntity(_this__u8e3s4);
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (outgoingConnections.length === 0) {
    tmp = !((autoAdaptOriginalEntity == null ? null : get_highestPriorityConnection(autoAdaptOriginalEntity)) == null);
  } else {
    tmp = false;
  }
  if (tmp) {
    var originalOutgoingConnections = Companion_instance.c29(autoAdaptOriginalEntity);
    if (any(originalOutgoingConnections))
      return centerOfConnections(originalOutgoingConnections);
  }
  var connectionPoint = any(outgoingConnections) ? centerOfConnections(outgoingConnections) : get_worldPosition(_this__u8e3s4);
  return connectionPoint;
}
function DragSurfaceCanHostSelector$canProjectDragOn$lambda(snappingGuest) {
  var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function DragSurfaceCanHostSelector() {
}
protoOf(DragSurfaceCanHostSelector).shouldBeTested = function (dragSurface) {
  return true;
};
protoOf(DragSurfaceCanHostSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
  var tmp0_safe_receiver = get_connectorsComponent(dragSurface.entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var hostConnectors = tmp;
  var tmp_0 = get_snappingGuestEntitiesSequence(draggedEntity);
  var childSequence = map(tmp_0, DragSurfaceCanHostSelector$canProjectDragOn$lambda);
  return this.w3w(childSequence, hostConnectors, dragSurface.connectorKeys);
};
protoOf(DragSurfaceCanHostSelector).w3w = function (guestConnectorSequence, hostConnectors, connectorKeys) {
  var tmp$ret$5;
  $l$block_3: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = guestConnectorSequence.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>' call
      var tmp$ret$0;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(element, Collection)) {
          tmp = element.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_2;
        }
        var tmp0_iterator_0 = element.k();
        while (tmp0_iterator_0.m()) {
          var element_0 = tmp0_iterator_0.n();
          // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>.<anonymous>' call
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_0;
            if (isInterface(hostConnectors, Collection)) {
              tmp_0 = hostConnectors.r();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            var tmp0_iterator_1 = hostConnectors.k();
            while (tmp0_iterator_1.m()) {
              var element_1 = tmp0_iterator_1.n();
              // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>.<anonymous>.<anonymous>' call
              if ((connectorKeys == null || contains(connectorKeys, element_1.key)) && element_0.hasMatchingTypeAndDemandsTo(element_1)) {
                tmp$ret$1 = true;
                break $l$block_1;
              }
            }
            tmp$ret$1 = false;
          }
          if (tmp$ret$1) {
            tmp$ret$0 = true;
            break $l$block_2;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp$ret$5 = true;
        break $l$block_3;
      }
    }
    tmp$ret$5 = false;
  }
  return tmp$ret$5;
};
function get_snappingGuestEntitiesSequence(_this__u8e3s4) {
  var tmp = hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, Companion_getInstance_2().id);
  return filter(tmp, _get_snappingGuestEntitiesSequence_$lambda_24h0hk);
}
function _get_snappingGuestEntitiesSequence_$lambda_24h0hk(it) {
  var tmp0_safe_receiver = get_connectorsComponent(it);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  return (tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true;
}
function DragSurfaceEntityPair(entity, surface, connectorKeys) {
  this.entity = entity;
  this.surface = surface;
  this.connectorKeys = connectorKeys;
}
protoOf(DragSurfaceEntityPair).v2i = function () {
  return this.entity;
};
protoOf(DragSurfaceEntityPair).q2i = function () {
  return this.surface;
};
protoOf(DragSurfaceEntityPair).r2i = function () {
  return this.connectorKeys;
};
protoOf(DragSurfaceEntityPair).tf = function () {
  return this.entity;
};
protoOf(DragSurfaceEntityPair).uf = function () {
  return this.surface;
};
protoOf(DragSurfaceEntityPair).m1m = function () {
  return this.connectorKeys;
};
protoOf(DragSurfaceEntityPair).n45 = function (entity, surface, connectorKeys) {
  return new DragSurfaceEntityPair(entity, surface, connectorKeys);
};
protoOf(DragSurfaceEntityPair).copy = function (entity, surface, connectorKeys, $super) {
  entity = entity === VOID ? this.entity : entity;
  surface = surface === VOID ? this.surface : surface;
  connectorKeys = connectorKeys === VOID ? this.connectorKeys : connectorKeys;
  return this.n45(entity, surface, connectorKeys);
};
protoOf(DragSurfaceEntityPair).toString = function () {
  return 'DragSurfaceEntityPair(entity=' + this.entity.toString() + ', surface=' + toString(this.surface) + ', connectorKeys=' + toString(this.connectorKeys) + ')';
};
protoOf(DragSurfaceEntityPair).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + hashCode(this.surface) | 0;
  result = imul(result, 31) + (this.connectorKeys == null ? 0 : hashCode(this.connectorKeys)) | 0;
  return result;
};
protoOf(DragSurfaceEntityPair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DragSurfaceEntityPair))
    return false;
  var tmp0_other_with_cast = other instanceof DragSurfaceEntityPair ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!equals(this.surface, tmp0_other_with_cast.surface))
    return false;
  if (!equals(this.connectorKeys, tmp0_other_with_cast.connectorKeys))
    return false;
  return true;
};
function hasMatchingConnector($this, guestConnectorSequence, dragSurface) {
  var tmp$ret$3;
  $l$block_1: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = guestConnectorSequence.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceOnlyRoomSelector.hasMatchingConnector.<anonymous>' call
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(element, Collection)) {
          tmp = element.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator_0 = element.k();
        while (tmp0_iterator_0.m()) {
          var element_0 = tmp0_iterator_0.n();
          // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceOnlyRoomSelector.hasMatchingConnector.<anonymous>.<anonymous>' call
          var tmp_0;
          if (dragSurfaceIsFloor($this, dragSurface) && !contains(element_0.demands(), Companion_getInstance_40().FLOOR_OFFER)) {
            tmp_0 = false;
          } else if (dragSurfaceIsCeiling($this, dragSurface) && !contains(element_0.demands(), Companion_getInstance_40().CEILING_OFFER)) {
            tmp_0 = false;
          } else {
            tmp_0 = true;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp$ret$3 = true;
        break $l$block_1;
      }
    }
    tmp$ret$3 = false;
  }
  return tmp$ret$3;
}
function dragSurfaceIsFloor($this, dragSurface) {
  return dragSurfaceHasConnectorWithOffer($this, dragSurface, Companion_getInstance_40().FLOOR_OFFER);
}
function dragSurfaceIsCeiling($this, dragSurface) {
  return dragSurfaceHasConnectorWithOffer($this, dragSurface, Companion_getInstance_40().CEILING_OFFER);
}
function dragSurfaceHasConnectorWithOffer($this, dragSurface, offer) {
  var tmp;
  if (get_isRoomPart(dragSurface.entity)) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_connectors(dragSurface.entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceOnlyRoomSelector.dragSurfaceHasConnectorWithOffer.<anonymous>' call
        if (element.type === Companion_instance_6.m2b_1 && element.isOffering(offer)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = !(tmp$ret$1 == null);
  } else {
    tmp = false;
  }
  return tmp;
}
function DragSurfaceOnlyRoomSelector$canProjectDragOn$lambda(snappingGuest) {
  var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function DragSurfaceOnlyRoomSelector() {
}
protoOf(DragSurfaceOnlyRoomSelector).shouldBeTested = function (dragSurface) {
  return get_isRoom(dragSurface.entity) || get_isRoomPart(dragSurface.entity);
};
protoOf(DragSurfaceOnlyRoomSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
  var tmp = get_snappingGuestEntitiesSequence(draggedEntity);
  var guestConnectorSequence = map(tmp, DragSurfaceOnlyRoomSelector$canProjectDragOn$lambda);
  return hasMatchingConnector(this, guestConnectorSequence, dragSurface);
};
function DragSurfaceSelector() {
}
function calculateCursorDelta($this, entity, projectionHit) {
  var tmp0_elvis_lhs = get_draggableRootEntity(entity);
  var realEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  return get_worldPosition(realEntity).minus(projectionHit);
}
function rotateDragPointCursorDelta($this, entity, lastTransform, projectionHit) {
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
  var currentTransform = tmp1_elvis_lhs == null ? get_worldTransform(entity) : tmp1_elvis_lhs;
  if (!lastTransform.rotation.almostEquals(currentTransform.rotation)) {
    $this.a46_1 = calculateCursorDelta($this, entity, projectionHit);
  }
}
function setEndTransform($this, entity, newPoint) {
  var tmp0_safe_receiver = get_snapRoot(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
  var currentTransform = tmp1_elvis_lhs == null ? get_worldTransform(entity) : tmp1_elvis_lhs;
  return new Transform(newPoint.plus($this.a46_1), currentTransform.rotation);
}
function sendEvent($this, endTransform, cameraPosition, entity) {
  var moveDragEvent = new WorldSpaceDragEventComponent(endTransform.position, Companion_instance_16.createFromPoints(cameraPosition, endTransform.position));
  $this.x45_1.addComponent(entity, moveDragEvent);
}
function Companion_42() {
  this.ID = 'LegacyCanvasTo3DDragConverterSystem';
}
protoOf(Companion_42).j1y = function () {
  return this.ID;
};
var Companion_instance_81;
function Companion_getInstance_85() {
  return Companion_instance_81;
}
function LegacyCanvasTo3DDragConverterSystem(entityManager, sceneManager, projector) {
  SystemBase.call(this, Companion_instance_81.ID, Companion_getInstance_13().id);
  this.x45_1 = entityManager;
  this.y45_1 = projector;
  this.z45_1 = new DragSurfaceUpdatesListenerSystem(this.y45_1, sceneManager);
  this.a46_1 = Companion_getInstance_15().ZERO;
  this.b46_1 = Companion_getInstance_22().c1x_1;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.c46_1 = [Companion_getInstance_20().id];
}
protoOf(LegacyCanvasTo3DDragConverterSystem).onRegister = function () {
  protoOf(SystemBase).onRegister.call(this);
  this.z45_1.l2d(this.x45_1);
};
protoOf(LegacyCanvasTo3DDragConverterSystem).onUnregister = function () {
  protoOf(SystemBase).onUnregister.call(this);
  this.z45_1.m2d(this.x45_1);
};
protoOf(LegacyCanvasTo3DDragConverterSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  this.z45_1.enable();
};
protoOf(LegacyCanvasTo3DDragConverterSystem).disable = function () {
  protoOf(SystemBase).disable.call(this);
  this.z45_1.disable();
};
protoOf(LegacyCanvasTo3DDragConverterSystem).y3y = function (entity, newComponent) {
  var tmp0_elvis_lhs = get_draggableRootEntity(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var draggedEntity = tmp;
  this.a46_1 = Companion_getInstance_15().ZERO;
  this.b46_1 = Companion_getInstance_22().c1x_1;
  var tmp1_elvis_lhs = this.y45_1.project(newComponent.rayFromCameraToDragEnd, entity, newComponent.planeNormal.__timesIntForKotlin(-1));
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var projectionHit = tmp_0;
  this.a46_1 = calculateCursorDelta(this, entity, projectionHit);
  var endPoint = projectionHit.plus(this.a46_1);
  this.b46_1 = new Transform(endPoint, get_worldTransform(draggedEntity).rotation);
  sendEvent(this, this.b46_1, newComponent.cameraPosition, entity);
};
protoOf(LegacyCanvasTo3DDragConverterSystem).v1v = function (entity, newComponent) {
  return this.y3y(entity, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(LegacyCanvasTo3DDragConverterSystem).b3z = function (entity, oldComponent, newComponent) {
  var tmp0_elvis_lhs = get_draggableRootEntity(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var draggedEntity = tmp;
  var tmp1_elvis_lhs = this.y45_1.project(newComponent.rayFromCameraToDragEnd, entity, newComponent.planeNormal.__timesIntForKotlin(-1));
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var projectionHit = tmp_0;
  rotateDragPointCursorDelta(this, draggedEntity, this.b46_1, projectionHit);
  this.b46_1 = setEndTransform(this, draggedEntity, projectionHit);
  sendEvent(this, this.b46_1, newComponent.cameraPosition, entity);
};
protoOf(LegacyCanvasTo3DDragConverterSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE();
  return this.b3z(entity, tmp, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(LegacyCanvasTo3DDragConverterSystem).c3z = function (entity, oldComponent) {
  this.x45_1.removeComponent(entity, Companion_getInstance_20().id);
};
protoOf(LegacyCanvasTo3DDragConverterSystem).z1v = function (entity, oldComponent) {
  return this.c3z(entity, oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(LegacyCanvasTo3DDragConverterSystem).j1w = function () {
  return this.c46_1;
};
protoOf(LegacyCanvasTo3DDragConverterSystem).setProjector = function (projector) {
  this.y45_1 = projector;
};
protoOf(LegacyCanvasTo3DDragConverterSystem).getProjector = function () {
  return this.y45_1;
};
function checkIfWorldDragWasDetected($this) {
  if ($this.o46_1 && !$this.p46_1) {
    var tmp = Companion_getInstance_25().v2l_1;
    tmp.warn(NoDragConverterDetector$checkIfWorldDragWasDetected$lambda);
  }
  $this.disable();
}
function NoDragConverterDetector$checkIfWorldDragWasDetected$lambda() {
  return 'No converter for canvas drags to 3d drags detected. Did you forget to initiate ' + Companion_getInstance_149().c47_1 + ' ?';
}
function NoDragConverterDetector(entityManager) {
  var tmp = Companion_getInstance_13().id;
  var tmp_0 = Companion_getInstance_20().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  SystemBase2.call(this, 'NoDragConverterDetector', tmp, tmp_0, tmp$ret$2, null, null);
  this.l2d(entityManager);
  this.o46_1 = false;
  this.p46_1 = false;
}
protoOf(NoDragConverterDetector).y3y = function (entity, newComponent) {
  this.o46_1 = true;
};
protoOf(NoDragConverterDetector).v1v = function (entity, newComponent) {
  return this.y3y(entity, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(NoDragConverterDetector).b3z = function (entity, oldComponent, newComponent) {
  checkIfWorldDragWasDetected(this);
};
protoOf(NoDragConverterDetector).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE();
  return this.b3z(entity, tmp, newComponent instanceof ViewerDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(NoDragConverterDetector).c3z = function (entity, oldComponent) {
};
protoOf(NoDragConverterDetector).z1v = function (entity, oldComponent) {
  return this.c3z(entity, oldComponent instanceof ViewerDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(NoDragConverterDetector).g47 = function (entity, newComponent) {
  this.p46_1 = true;
};
protoOf(NoDragConverterDetector).l1z = function (entity, newComponent) {
  return this.g47(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(NoDragConverterDetector).h47 = function (entity, oldComponent, newComponent) {
};
protoOf(NoDragConverterDetector).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE();
  return this.h47(entity, tmp, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(NoDragConverterDetector).i47 = function (entity, oldComponent) {
};
protoOf(NoDragConverterDetector).p1z = function (entity, oldComponent) {
  return this.i47(entity, oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE());
};
function Companion_43() {
  Companion_instance_82 = this;
  this.id = Companion_instance_0.e1r_1;
}
protoOf(Companion_43).n1s = function () {
  return this.id;
};
var Companion_instance_82;
function Companion_getInstance_86() {
  if (Companion_instance_82 == null)
    new Companion_43();
  return Companion_instance_82;
}
function DragProjectionPointComponent(projectionPoint) {
  Companion_getInstance_86();
  this.projectionPoint = projectionPoint;
}
protoOf(DragProjectionPointComponent).j47 = function () {
  return this.projectionPoint;
};
protoOf(DragProjectionPointComponent).p1s = function () {
  return Companion_getInstance_86().id;
};
protoOf(DragProjectionPointComponent).eq = function (other) {
  return (other instanceof DragProjectionPointComponent ? other : THROW_CCE()).projectionPoint.equals(this.projectionPoint);
};
function Companion_44() {
  Companion_instance_83 = this;
  this.id = Companion_instance_0.l1q_1;
}
protoOf(Companion_44).n1s = function () {
  return this.id;
};
var Companion_instance_83;
function Companion_getInstance_87() {
  if (Companion_instance_83 == null)
    new Companion_44();
  return Companion_instance_83;
}
function GrabOffsetComponent(worldGrabOffset, worldDragProjectionPointOffset) {
  Companion_getInstance_87();
  this.worldGrabOffset = worldGrabOffset;
  this.worldDragProjectionPointOffset = worldDragProjectionPointOffset;
  this.q43_1 = Companion_getInstance_87().id;
}
protoOf(GrabOffsetComponent).k47 = function () {
  return this.worldGrabOffset;
};
protoOf(GrabOffsetComponent).l47 = function () {
  return this.worldDragProjectionPointOffset;
};
protoOf(GrabOffsetComponent).p1s = function () {
  return this.q43_1;
};
protoOf(GrabOffsetComponent).eq = function (other) {
  var tmp;
  if ((other instanceof GrabOffsetComponent ? other : THROW_CCE()).worldGrabOffset.equals(this.worldGrabOffset)) {
    tmp = other.worldDragProjectionPointOffset.equals(this.worldDragProjectionPointOffset);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(GrabOffsetComponent).tf = function () {
  return this.worldGrabOffset;
};
protoOf(GrabOffsetComponent).uf = function () {
  return this.worldDragProjectionPointOffset;
};
protoOf(GrabOffsetComponent).l2w = function (worldGrabOffset, worldDragProjectionPointOffset) {
  return new GrabOffsetComponent(worldGrabOffset, worldDragProjectionPointOffset);
};
protoOf(GrabOffsetComponent).copy = function (worldGrabOffset, worldDragProjectionPointOffset, $super) {
  worldGrabOffset = worldGrabOffset === VOID ? this.worldGrabOffset : worldGrabOffset;
  worldDragProjectionPointOffset = worldDragProjectionPointOffset === VOID ? this.worldDragProjectionPointOffset : worldDragProjectionPointOffset;
  return this.l2w(worldGrabOffset, worldDragProjectionPointOffset);
};
protoOf(GrabOffsetComponent).toString = function () {
  return 'GrabOffsetComponent(worldGrabOffset=' + this.worldGrabOffset.toString() + ', worldDragProjectionPointOffset=' + this.worldDragProjectionPointOffset.toString() + ')';
};
protoOf(GrabOffsetComponent).hashCode = function () {
  var result = this.worldGrabOffset.hashCode();
  result = imul(result, 31) + this.worldDragProjectionPointOffset.hashCode() | 0;
  return result;
};
protoOf(GrabOffsetComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GrabOffsetComponent))
    return false;
  var tmp0_other_with_cast = other instanceof GrabOffsetComponent ? other : THROW_CCE();
  if (!this.worldGrabOffset.equals(tmp0_other_with_cast.worldGrabOffset))
    return false;
  if (!this.worldDragProjectionPointOffset.equals(tmp0_other_with_cast.worldDragProjectionPointOffset))
    return false;
  return true;
};
function AnyDragSurfaceProjector_init_$Init$(coreServices, dragSurfaceSelector, $this) {
  dragSurfaceSelector = dragSurfaceSelector === VOID ? new DragSurfaceOnlyRoomSelector() : dragSurfaceSelector;
  AnyDragSurfaceProjector.call($this, coreServices.sceneManager, coreServices.entityManager, dragSurfaceSelector);
  return $this;
}
function AnyDragSurfaceProjectorFromCoreServices(coreServices, dragSurfaceSelector) {
  return AnyDragSurfaceProjector_init_$Init$(coreServices, dragSurfaceSelector, objectCreate(protoOf(AnyDragSurfaceProjector)));
}
function _get_cachedSurfacesEntity__1g8lxc($this) {
  if ($this.r47_1.isDisposed) {
    $this.r47_1 = $this.n47_1.createEntity();
    initCachedServiceEntity($this);
  }
  return $this.r47_1;
}
function initCachedServiceEntity($this) {
  setParent($this.r47_1, $this.m47_1.scene);
  $this.r47_1.addComponent(new UnserializableEntityComponent());
  $this.r47_1.addComponent(new DisplayNameComponent('Drag Surface Cache'));
}
function getSurfaces($this) {
  var tmp0_safe_receiver = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.surfaces;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function getFallbackSurfaces($this) {
  var tmp0_safe_receiver = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fallbackSurfaces;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function addSurfacesToCache($this, surfaces, fallbackSurfaces) {
  var tmp0_elvis_lhs = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
  var component = tmp0_elvis_lhs == null ? new DragSurfaceEntityPairsCacheComponent() : tmp0_elvis_lhs;
  var newSurfaces = plus_1(component.surfaces, surfaces);
  var newFallbackSurfaces = plus_1(component.fallbackSurfaces, fallbackSurfaces);
  _get_cachedSurfacesEntity__1g8lxc($this).addComponentInternal(new DragSurfaceEntityPairsCacheComponent(newSurfaces, newFallbackSurfaces));
}
function selectDragPlane($this, ray, draggedEntity, cameraNormal) {
  var bestDist = Infinity;
  var oldRayHit = equals($this.q47_1, draggedEntity) ? $this.p47_1 : null;
  $this.p47_1 = null;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = getSurfaces($this);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    $l$block_0: {
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.selectDragPlane.<anonymous>' call
      var surfaceEntity = element.tf();
      var surfacePlane = element.uf();
      if (surfaceEntity.equals(draggedEntity) || isDescendantOf(surfaceEntity, draggedEntity)) {
        break $l$block_0;
      }
      var tmp0_elvis_lhs = surfacePlane.raycast(ray);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var rayResult = tmp;
      if ($this.o47_1.canProjectDragOn(draggedEntity, element)) {
        var distance = rayResult.point.distanceTo(ray.origin);
        if (distance < bestDist) {
          bestDist = distance;
          $this.p47_1 = rayResult;
        }
      }
    }
  }
  if ($this.p47_1 == null) {
    $this.p47_1 = tryToFindHitPointOutsideDragSurfaces($this, draggedEntity, ray, oldRayHit, cameraNormal);
  }
  $this.q47_1 = draggedEntity;
}
function tryToFindHitPointOutsideDragSurfaces($this, draggedEntity, ray, oldRayHit, cameraNormal) {
  var bestFallbackHit = raycastAgainstFallbackSurfaces($this, draggedEntity, ray, cameraNormal);
  var currentExtendedDragPlaneHit = findRayHitByExtendingLastDragPlane($this, oldRayHit, ray);
  var onlyHitFallbackSurface = currentExtendedDragPlaneHit == null && !(bestFallbackHit == null);
  var onlyHitExtendedPlane = !(currentExtendedDragPlaneHit == null) && bestFallbackHit == null;
  var hitBothFallbackAndExtendedPlane = !(currentExtendedDragPlaneHit == null) && !(bestFallbackHit == null);
  var tmp;
  if (onlyHitFallbackSurface) {
    tmp = bestFallbackHit == null ? null : bestFallbackHit.asRaycastResult();
  } else if (onlyHitExtendedPlane) {
    tmp = currentExtendedDragPlaneHit;
  } else if (hitBothFallbackAndExtendedPlane) {
    tmp = bestFallbackHit == null ? null : bestFallbackHit.asRaycastResult();
  } else if (!(oldRayHit == null)) {
    tmp = oldRayHit;
  } else {
    tmp = new RaycastResult(get_worldPosition(draggedEntity), ray.direction);
  }
  return tmp;
}
function raycastAgainstFallbackSurfaces($this, draggedEntity, ray, cameraNormal) {
  var bestHit = null;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = getFallbackSurfaces($this);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    $l$block_5: {
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.raycastAgainstFallbackSurfaces.<anonymous>' call
      var surfaceEntity = element.tf();
      var plane = element.uf();
      if (surfaceEntity.equals(draggedEntity) || isDescendantOf(surfaceEntity, draggedEntity)) {
        break $l$block_5;
      }
      var tmp0_elvis_lhs = plane.raycast(ray);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_5;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var rayResult = tmp;
      var wallAngle = -0.5;
      var tmp1_safe_receiver = get_guestConnectors(draggedEntity);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$1;
        $l$block_4: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp1_safe_receiver, Collection)) {
            tmp_1 = tmp1_safe_receiver.r();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$1 = false;
            break $l$block_4;
          }
          var tmp0_iterator = tmp1_safe_receiver.k();
          while (tmp0_iterator.m()) {
            var element_0 = tmp0_iterator.n();
            // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.raycastAgainstFallbackSurfaces.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver = get_hostConnectors(surfaceEntity);
            var tmp_2;
            if (tmp0_safe_receiver == null) {
              tmp_2 = null;
            } else {
              var tmp$ret$2;
              $l$block_3: {
                // Inline function 'kotlin.collections.any' call
                var tmp_3;
                if (isInterface(tmp0_safe_receiver, Collection)) {
                  tmp_3 = tmp0_safe_receiver.r();
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp$ret$2 = false;
                  break $l$block_3;
                }
                var tmp0_iterator_0 = tmp0_safe_receiver.k();
                while (tmp0_iterator_0.m()) {
                  var element_1 = tmp0_iterator_0.n();
                  // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.raycastAgainstFallbackSurfaces.<anonymous>.<anonymous>.<anonymous>' call
                  if (element_0.hasMatchingTypeAndDemandsTo(element_1)) {
                    tmp$ret$2 = true;
                    break $l$block_3;
                  }
                }
                tmp$ret$2 = false;
              }
              tmp_2 = tmp$ret$2;
            }
            var tmp1_elvis_lhs = tmp_2;
            if (tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs) {
              tmp$ret$1 = true;
              break $l$block_4;
            }
          }
          tmp$ret$1 = false;
        }
        tmp_0 = tmp$ret$1;
      }
      var tmp2_elvis_lhs = tmp_0;
      var canBeHostedOnThisSurface = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
      var tmp3_safe_receiver = get_highestPriorityConnection(draggedEntity);
      var tmp_4 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hostConnector;
      var isHostedByASurface = tmp_4 instanceof SurfaceConnector;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = rayResult.surfaceNormal.dot(Companion_getInstance_15().UP);
      var surfaceIsVertical = Math.abs(this_0) <= 0.01;
      var viewAngleTooAcute = rayResult.surfaceNormal.dot(cameraNormal) >= wallAngle;
      if (!canBeHostedOnThisSurface && isHostedByASurface && surfaceIsVertical && viewAngleTooAcute) {
        break $l$block_5;
      }
      var distance = rayResult.point.distanceTo(ray.origin);
      var tmp4_safe_receiver = bestHit;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.distance;
      if (distance < (tmp5_elvis_lhs == null ? 1.7976931348623157E308 : tmp5_elvis_lhs)) {
        bestHit = new RaycastHit(rayResult.point, surfaceEntity, distance, rayResult.surfaceNormal);
      }
    }
  }
  return bestHit;
}
function findRayHitByExtendingLastDragPlane($this, oldRayHit, ray) {
  var currentExtendedDragPlaneHit = null;
  if (!(oldRayHit == null)) {
    var lastDragPlane = new Plane(oldRayHit.point, oldRayHit.surfaceNormal);
    var rayResult = lastDragPlane.raycast(ray);
    if (!(rayResult == null)) {
      currentExtendedDragPlaneHit = rayResult;
    }
  }
  return currentExtendedDragPlaneHit;
}
function Companion_45() {
  Companion_instance_84 = this;
  this.s47_1 = LoggerState_getInstance().g1v('AnyDragSurfaceProjector');
}
var Companion_instance_84;
function Companion_getInstance_88() {
  if (Companion_instance_84 == null)
    new Companion_45();
  return Companion_instance_84;
}
function AnyDragSurfaceProjector(sceneManager, entityManager, dragSurfaceSelector) {
  Companion_getInstance_88();
  dragSurfaceSelector = dragSurfaceSelector === VOID ? new DragSurfaceOnlyRoomSelector() : dragSurfaceSelector;
  this.m47_1 = sceneManager;
  this.n47_1 = entityManager;
  this.o47_1 = dragSurfaceSelector;
  this.p47_1 = null;
  this.q47_1 = null;
  this.r47_1 = this.n47_1.createEntity();
  initCachedServiceEntity(this);
}
protoOf(AnyDragSurfaceProjector).t47 = function (worldDragSurfacesComponent, entity) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = worldDragSurfacesComponent.surfaces;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
    if (!element.isFallbackSurface) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
    var tmp$ret$3 = new DragSurfaceEntityPair(entity, item.surface, item.connectorKeys);
    destination_0.h(tmp$ret$3);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = destination_0.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
    if (this.o47_1.shouldBeTested(element_0)) {
      destination_1.h(element_0);
    }
  }
  var surfaces = destination_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = worldDragSurfacesComponent.surfaces;
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
    if (element_1.isFallbackSurface) {
      destination_2.h(element_1);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_2, 10));
  var tmp0_iterator_1 = destination_2.k();
  while (tmp0_iterator_1.m()) {
    var item_0 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
    var tmp$ret$12 = new DragSurfaceEntityPair(entity, item_0.surface, item_0.connectorKeys);
    destination_3.h(tmp$ret$12);
  }
  var fallbackSurfaces = destination_3;
  addSurfacesToCache(this, surfaces, fallbackSurfaces);
};
protoOf(AnyDragSurfaceProjector).u47 = function (entity) {
  var tmp0_elvis_lhs = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc(this));
  var component = tmp0_elvis_lhs == null ? new DragSurfaceEntityPairsCacheComponent() : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = component.surfaces;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesRemoved.<anonymous>' call
    if (!element.entity.equals(entity)) {
      destination.h(element);
    }
  }
  var surfaces = copyToArray(destination);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = component.fallbackSurfaces;
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesRemoved.<anonymous>' call
    if (!element_0.entity.equals(entity)) {
      destination_0.h(element_0);
    }
  }
  var fallbackSurfaces = copyToArray(destination_0);
  _get_cachedSurfacesEntity__1g8lxc(this).addComponentInternal(new DragSurfaceEntityPairsCacheComponent(surfaces, fallbackSurfaces));
};
protoOf(AnyDragSurfaceProjector).project = function (ray, entity, cameraNormal) {
  selectDragPlane(this, ray, entity, cameraNormal);
  var tmp0_safe_receiver = this.p47_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.point;
};
function Companion_46() {
}
protoOf(Companion_46).n1s = function () {
  return Companion_instance_0.y1p_1;
};
var Companion_instance_85;
function Companion_getInstance_89() {
  return Companion_instance_85;
}
function DragSurfaceEntityPairsCacheComponent(surfaces, fallbackSurfaces) {
  var tmp;
  if (surfaces === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = surfaces;
  }
  surfaces = tmp;
  var tmp_0;
  if (fallbackSurfaces === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = fallbackSurfaces;
  }
  fallbackSurfaces = tmp_0;
  this.surfaces = surfaces;
  this.fallbackSurfaces = fallbackSurfaces;
}
protoOf(DragSurfaceEntityPairsCacheComponent).n2i = function () {
  return this.surfaces;
};
protoOf(DragSurfaceEntityPairsCacheComponent).v47 = function () {
  return this.fallbackSurfaces;
};
protoOf(DragSurfaceEntityPairsCacheComponent).p1s = function () {
  return Companion_instance_85.id;
};
protoOf(DragSurfaceEntityPairsCacheComponent).eq = function (other) {
  return false;
};
function get_projectorSurfacesComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_instance_85.id);
}
function DragSurfaceProjector() {
}
function addSurfaceIfExists($this, entity) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_instance_0.i1q_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var component = tmp;
  $this.h48_1.t47(component, entity);
}
function Companion_47() {
  this.j48_1 = 'MultiWallConvertScreenDragsSystem';
}
var Companion_instance_86;
function Companion_getInstance_90() {
  return Companion_instance_86;
}
function DragSurfaceUpdatesListenerSystem$enable$lambda(it) {
  return it.hasComponent(Companion_getInstance_16().id);
}
function DragSurfaceUpdatesListenerSystem(dragSurfacesChangedListener, sceneManager) {
  SystemBase2.call(this, Companion_instance_86.j48_1, Companion_instance_0.i1q_1, Companion_instance_0.b1n_1);
  this.h48_1 = dragSurfacesChangedListener;
  this.i48_1 = sceneManager;
  this.enable();
}
protoOf(DragSurfaceUpdatesListenerSystem).enable = function () {
  protoOf(SystemBase2).enable.call(this);
  // Inline function 'kotlin.sequences.forEach' call
  var tmp = get_hierarchySequence(this.i48_1.root);
  var tmp0_iterator = filter(tmp, DragSurfaceUpdatesListenerSystem$enable$lambda).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.DragSurfaceUpdatesListenerSystem.enable.<anonymous>' call
    addSurfaceIfExists(this, element);
  }
};
protoOf(DragSurfaceUpdatesListenerSystem).k40 = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    this.h48_1.t47(newComponent, entity);
  }
};
protoOf(DragSurfaceUpdatesListenerSystem).v1v = function (entity, newComponent) {
  return this.k40(entity, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceUpdatesListenerSystem).m40 = function (entity, oldComponent, newComponent) {
  if (get_isInScene(entity)) {
    this.h48_1.u47(entity);
    this.h48_1.t47(newComponent, entity);
  }
};
protoOf(DragSurfaceUpdatesListenerSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE();
  return this.m40(entity, tmp, newComponent instanceof WorldDragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceUpdatesListenerSystem).l40 = function (entity, oldComponent) {
  this.h48_1.u47(entity);
};
protoOf(DragSurfaceUpdatesListenerSystem).z1v = function (entity, oldComponent) {
  return this.l40(entity, oldComponent instanceof WorldDragSurfacesComponent ? oldComponent : THROW_CCE());
};
protoOf(DragSurfaceUpdatesListenerSystem).u31 = function (entity, newComponent) {
  var worldDragSurfacesComponent = entity.__getComponentForKotlin(Companion_getInstance_16().id);
  if (!(worldDragSurfacesComponent == null)) {
    this.h48_1.t47(worldDragSurfacesComponent, entity);
  }
};
protoOf(DragSurfaceUpdatesListenerSystem).l1z = function (entity, newComponent) {
  return this.u31(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceUpdatesListenerSystem).v31 = function (entity, oldComponent, newComponent) {
};
protoOf(DragSurfaceUpdatesListenerSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.v31(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(DragSurfaceUpdatesListenerSystem).w31 = function (entity, oldComponent) {
  var worldDragSurfacesComponent = entity.__getComponentForKotlin(Companion_getInstance_16().id);
  if (!(worldDragSurfacesComponent == null)) {
    this.h48_1.u47(entity);
  }
};
protoOf(DragSurfaceUpdatesListenerSystem).p1z = function (entity, oldComponent) {
  return this.w31(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
function entityHit($this, entity, ray) {
  var hit = Companion_instance_15.raycast$default(ray, entity);
  var cameraNormal = ray.direction.__timesIntForKotlin(-1);
  var tmp;
  if (hit == null) {
    var entityPlane = new Plane(get_worldPosition(entity), cameraNormal);
    var tmp0_safe_receiver = entityPlane.raycast(ray);
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.point;
  } else {
    tmp = hit.point;
  }
  var hitPoint = tmp;
  return hitPoint;
}
function XYPlaneProjector() {
}
protoOf(XYPlaneProjector).t47 = function (worldDragSurfacesComponent, entity) {
};
protoOf(XYPlaneProjector).u47 = function (entity) {
};
protoOf(XYPlaneProjector).project = function (ray, entity, cameraNormal) {
  var tmp0_elvis_lhs = entityHit(this, entity, ray);
  var planePoint = tmp0_elvis_lhs == null ? get_worldPosition(entity) : tmp0_elvis_lhs;
  var frontDragPlane = new Plane(planePoint, Companion_getInstance_15().FORWARD);
  var backDragPlane = new Plane(planePoint, Companion_getInstance_15().BACK);
  var tmp1_elvis_lhs = frontDragPlane.raycast(ray);
  var intersection = tmp1_elvis_lhs == null ? backDragPlane.raycast(ray) : tmp1_elvis_lhs;
  return intersection == null ? null : intersection.point;
};
function Companion_48() {
  Companion_instance_87 = this;
  this.id = Companion_instance_0.f1p_1;
}
protoOf(Companion_48).n1s = function () {
  return this.id;
};
var Companion_instance_87;
function Companion_getInstance_91() {
  if (Companion_instance_87 == null)
    new Companion_48();
  return Companion_instance_87;
}
function FunctionalMarginComponent(worldPolyhedron) {
  Companion_getInstance_91();
  this.worldPolyhedron = worldPolyhedron;
}
protoOf(FunctionalMarginComponent).n1x = function () {
  return this.worldPolyhedron;
};
protoOf(FunctionalMarginComponent).p1s = function () {
  return Companion_instance_0.f1p_1;
};
protoOf(FunctionalMarginComponent).eq = function (other) {
  var o = other instanceof FunctionalMarginComponent ? other : THROW_CCE();
  return equals(o.worldPolyhedron, this.worldPolyhedron);
};
protoOf(FunctionalMarginComponent).tf = function () {
  return this.worldPolyhedron;
};
protoOf(FunctionalMarginComponent).o1x = function (worldPolyhedron) {
  return new FunctionalMarginComponent(worldPolyhedron);
};
protoOf(FunctionalMarginComponent).copy = function (worldPolyhedron, $super) {
  worldPolyhedron = worldPolyhedron === VOID ? this.worldPolyhedron : worldPolyhedron;
  return this.o1x(worldPolyhedron);
};
protoOf(FunctionalMarginComponent).toString = function () {
  return 'FunctionalMarginComponent(worldPolyhedron=' + toString(this.worldPolyhedron) + ')';
};
protoOf(FunctionalMarginComponent).hashCode = function () {
  return hashCode(this.worldPolyhedron);
};
protoOf(FunctionalMarginComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FunctionalMarginComponent))
    return false;
  var tmp0_other_with_cast = other instanceof FunctionalMarginComponent ? other : THROW_CCE();
  if (!equals(this.worldPolyhedron, tmp0_other_with_cast.worldPolyhedron))
    return false;
  return true;
};
function Companion_49() {
  Companion_instance_88 = this;
  this.id = Companion_instance_0.e1p_1;
}
protoOf(Companion_49).n1s = function () {
  return this.id;
};
var Companion_instance_88;
function Companion_getInstance_92() {
  if (Companion_instance_88 == null)
    new Companion_49();
  return Companion_instance_88;
}
function FunctionalMarginShapeComponent(margin) {
  Companion_getInstance_92();
  this.margin = margin;
}
protoOf(FunctionalMarginShapeComponent).k48 = function () {
  return this.margin;
};
protoOf(FunctionalMarginShapeComponent).shape = function (me) {
  var oobb = get_objectOrientedBoundingBoxForHierarchy(me);
  return oobb.applyMargin(this.margin);
};
protoOf(FunctionalMarginShapeComponent).p1s = function () {
  return Companion_instance_0.e1p_1;
};
protoOf(FunctionalMarginShapeComponent).eq = function (other) {
  var o = other instanceof FunctionalMarginShapeComponent ? other : THROW_CCE();
  return o.margin.equals(this.margin);
};
protoOf(FunctionalMarginShapeComponent).tf = function () {
  return this.margin;
};
protoOf(FunctionalMarginShapeComponent).l48 = function (margin) {
  return new FunctionalMarginShapeComponent(margin);
};
protoOf(FunctionalMarginShapeComponent).copy = function (margin, $super) {
  margin = margin === VOID ? this.margin : margin;
  return this.l48(margin);
};
protoOf(FunctionalMarginShapeComponent).toString = function () {
  return 'FunctionalMarginShapeComponent(margin=' + this.margin.toString() + ')';
};
protoOf(FunctionalMarginShapeComponent).hashCode = function () {
  return this.margin.hashCode();
};
protoOf(FunctionalMarginShapeComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FunctionalMarginShapeComponent))
    return false;
  var tmp0_other_with_cast = other instanceof FunctionalMarginShapeComponent ? other : THROW_CCE();
  if (!this.margin.equals(tmp0_other_with_cast.margin))
    return false;
  return true;
};
function Companion_50() {
  this.ID = 'FunctionalMarginSystem';
}
protoOf(Companion_50).j1y = function () {
  return this.ID;
};
var Companion_instance_89;
function Companion_getInstance_93() {
  return Companion_instance_89;
}
function updateFunctionalMarginShape($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_92().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginSystem.updateFunctionalMarginShape.<anonymous>' call
    var shape = Companion_instance_8.v1y(tmp0_safe_receiver.shape(entity), entity);
    entity.addComponent(new FunctionalMarginComponent(shape));
  }
}
function FunctionalMarginSystem() {
  SystemBase2.call(this, Companion_instance_89.ID, Companion_instance_0.g1n_1, Companion_instance_0.e1p_1);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.x48_1 = [Companion_instance_0.f1p_1];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.y48_1 = [Companion_instance_17.ID];
}
protoOf(FunctionalMarginSystem).j1w = function () {
  return this.x48_1;
};
protoOf(FunctionalMarginSystem).k1w = function () {
  return this.y48_1;
};
protoOf(FunctionalMarginSystem).h1z = function (entity, newComponent) {
  updateFunctionalMarginShape(this, entity);
};
protoOf(FunctionalMarginSystem).v1v = function (entity, newComponent) {
  return this.h1z(entity, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalMarginSystem).i1z = function (entity, oldComponent, newComponent) {
  updateFunctionalMarginShape(this, entity);
};
protoOf(FunctionalMarginSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE();
  return this.i1z(entity, tmp, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalMarginSystem).j1z = function (entity, oldComponent) {
  updateFunctionalMarginShape(this, entity);
};
protoOf(FunctionalMarginSystem).z1v = function (entity, oldComponent) {
  return this.j1z(entity, oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE());
};
protoOf(FunctionalMarginSystem).z48 = function (entity, newComponent) {
  updateFunctionalMarginShape(this, entity);
};
protoOf(FunctionalMarginSystem).l1z = function (entity, newComponent) {
  return this.z48(entity, newComponent instanceof FunctionalMarginShapeComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalMarginSystem).a49 = function (entity, oldComponent, newComponent) {
  updateFunctionalMarginShape(this, entity);
};
protoOf(FunctionalMarginSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof FunctionalMarginShapeComponent ? oldComponent : THROW_CCE();
  return this.a49(entity, tmp, newComponent instanceof FunctionalMarginShapeComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalMarginSystem).b49 = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_0.f1p_1);
};
protoOf(FunctionalMarginSystem).p1z = function (entity, oldComponent) {
  return this.b49(entity, oldComponent instanceof FunctionalMarginShapeComponent ? oldComponent : THROW_CCE());
};
function Companion_51() {
  this.ID = 'FunctionalMargin';
}
protoOf(Companion_51).j1y = function () {
  return this.ID;
};
var Companion_instance_90;
function Companion_getInstance_94() {
  return Companion_instance_90;
}
function validate_0($this, entity, snap) {
  var root = Companion_instance_1.f1y(snap, entity);
  var tmp1_elvis_lhs = snap == null ? null : snap.host;
  var parent = tmp1_elvis_lhs == null ? get_parent(entity) : tmp1_elvis_lhs;
  var meAndMyHierarchy = get_hierarchy(entity);
  var tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.none' call
    var inductionVariable = 0;
    var last = meAndMyHierarchy.length;
    while (inductionVariable < last) {
      var element = meAndMyHierarchy[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_92().id)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  if (tmp$ret$1) {
    tmp = findInHierarchy(root, FunctionalMarginValidation$validate$lambda) == null;
  } else {
    tmp = false;
  }
  if (tmp) {
    return null;
  }
  var warn = {_v: null};
  var tmp2_safe_receiver = get_snapRoot(entity);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_hierarchy(tmp2_safe_receiver);
  var snapRootHierarchy = tmp3_elvis_lhs == null ? meAndMyHierarchy : tmp3_elvis_lhs;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = meAndMyHierarchy.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = meAndMyHierarchy[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    $l$block_0: {
      // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>' call
      var tmp0_safe_receiver = element_0.__getComponentForKotlin(Companion_getInstance_91().id);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_safe_receiver_0 = findInHierarchy(root, FunctionalMarginValidation$validate$lambda_0(snapRootHierarchy, tmp1_safe_receiver));
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_safe_receiver_1 = get_collider(tmp0_safe_receiver_0);
          var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.worldPolyhedron;
          var penetration = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(tmp1_safe_receiver);
          warn._v = new FunctionalMarginWarning(tmp0_safe_receiver_0, $this, penetration == null ? Companion_getInstance_15().ZERO : penetration);
          break $l$block_0;
        }
      }
    }
  }
  var myColliders$delegate = lazy(FunctionalMarginValidation$validate$lambda_1(meAndMyHierarchy));
  var tmp_0;
  if (warn._v == null) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0 = !validate$lambda(myColliders$delegate).r();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp4_safe_receiver = $this.f49_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp4_safe_receiver.isDisposed) {
        validate$checkZoneCollisionWithMe(warn, parent, $this, snapRootHierarchy, myColliders$delegate, tmp4_safe_receiver);
      }
    }
    if (warn._v == null) {
      findInHierarchy(root, FunctionalMarginValidation$validate$checkZoneCollisionWithMe$ref(warn, parent, $this, snapRootHierarchy, myColliders$delegate));
    }
  }
  var tmp_1 = $this;
  var tmp5_safe_receiver = warn._v;
  tmp_1.f49_1 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.otherEntity;
  return warn._v;
}
function validate$lambda($myColliders$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('myColliders', KProperty0, false, function () {
    return THROW_ISE();
  });
  return $myColliders$delegate.c2();
}
function validate$checkZoneCollisionWithMe(warn, parent, this$0, snapRootHierarchy, myColliders$delegate, other) {
  if (!(warn._v == null))
    return false;
  if (!(parent == null) && !this$0.d49_1 && hierarchyContains(other, parent))
    return false;
  if (contains(snapRootHierarchy, other))
    return false;
  var funcZone = other.__getComponentForKotlin(Companion_getInstance_91().id);
  var tmp;
  if (!(funcZone == null)) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = validate$lambda(myColliders$delegate);
      var tmp_0;
      if (isInterface(this_0, Collection)) {
        tmp_0 = this_0.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block;
      }
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        var pen = element.penetration(funcZone.worldPolyhedron);
        if (!(pen == null)) {
          warn._v = new FunctionalMarginWarning(other, this$0, pen);
          return true;
        }
        return false;
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  var found = tmp;
  return found;
}
function FunctionalMarginValidation$validate$lambda(it) {
  return it.hasComponent(Companion_getInstance_91().id);
}
function FunctionalMarginValidation$validate$lambda_0($snapRootHierarchy, $worldFuncZone) {
  return function (other) {
    var tmp;
    if (!contains($snapRootHierarchy, other)) {
      var tmp0_safe_receiver = get_collider(other);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      tmp = !((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration($worldFuncZone)) == null);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function FunctionalMarginValidation$validate$lambda_1($meAndMyHierarchy) {
  return function () {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = $meAndMyHierarchy;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = get_collider(element);
      var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_0);
      }
    }
    return destination;
  };
}
function FunctionalMarginValidation$validate$checkZoneCollisionWithMe$ref($warn, $parent, this$0, $snapRootHierarchy, $myColliders$delegate) {
  var l = function (p0) {
    return validate$checkZoneCollisionWithMe($warn, $parent, this$0, $snapRootHierarchy, $myColliders$delegate, p0);
  };
  l.callableName = 'checkZoneCollisionWithMe';
  return l;
}
function FunctionalMarginValidation(generateWarningsForAncestors, entityManager) {
  ValidationImpl.call(this);
  this.d49_1 = generateWarningsForAncestors;
  this.entityManager = entityManager;
  this.e49_1 = Companion_instance_90.ID;
  this.f49_1 = null;
}
protoOf(FunctionalMarginValidation).c1k = function () {
  return this.entityManager;
};
protoOf(FunctionalMarginValidation).n1s = function () {
  return this.e49_1;
};
protoOf(FunctionalMarginValidation).validateCurrentState = function (entity) {
  return validate_0(this, entity, null);
};
protoOf(FunctionalMarginValidation).validateSnap = function (snap) {
  return validate_0(this, snap.guestRoot, snap);
};
function Companion_52() {
  this.ID = 'FunctionalMarginWarning intersects';
}
protoOf(Companion_52).j1y = function () {
  return this.ID;
};
var Companion_instance_91;
function Companion_getInstance_95() {
  return Companion_instance_91;
}
function FunctionalMarginWarning(otherEntity, functionalMarginRule, penetration) {
  ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), get_productRefOrEmptyString(otherEntity), functionalMarginRule);
  this.otherEntity = otherEntity;
  this.functionalMarginRule = functionalMarginRule;
  this.penetration = penetration;
}
protoOf(FunctionalMarginWarning).h49 = function () {
  return this.otherEntity;
};
protoOf(FunctionalMarginWarning).i49 = function () {
  return this.functionalMarginRule;
};
protoOf(FunctionalMarginWarning).j49 = function () {
  return this.penetration;
};
protoOf(FunctionalMarginWarning).toString = function () {
  return this.id + ' ';
};
protoOf(FunctionalMarginWarning).n1s = function () {
  return Companion_instance_91.ID;
};
protoOf(FunctionalMarginWarning).tf = function () {
  return this.otherEntity;
};
protoOf(FunctionalMarginWarning).uf = function () {
  return this.functionalMarginRule;
};
protoOf(FunctionalMarginWarning).m1m = function () {
  return this.penetration;
};
protoOf(FunctionalMarginWarning).k49 = function (otherEntity, functionalMarginRule, penetration) {
  return new FunctionalMarginWarning(otherEntity, functionalMarginRule, penetration);
};
protoOf(FunctionalMarginWarning).copy = function (otherEntity, functionalMarginRule, penetration, $super) {
  otherEntity = otherEntity === VOID ? this.otherEntity : otherEntity;
  functionalMarginRule = functionalMarginRule === VOID ? this.functionalMarginRule : functionalMarginRule;
  penetration = penetration === VOID ? this.penetration : penetration;
  return this.k49(otherEntity, functionalMarginRule, penetration);
};
protoOf(FunctionalMarginWarning).hashCode = function () {
  var result = this.otherEntity.hashCode();
  result = imul(result, 31) + hashCode(this.functionalMarginRule) | 0;
  result = imul(result, 31) + this.penetration.hashCode() | 0;
  return result;
};
protoOf(FunctionalMarginWarning).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FunctionalMarginWarning))
    return false;
  var tmp0_other_with_cast = other instanceof FunctionalMarginWarning ? other : THROW_CCE();
  if (!this.otherEntity.equals(tmp0_other_with_cast.otherEntity))
    return false;
  if (!equals(this.functionalMarginRule, tmp0_other_with_cast.functionalMarginRule))
    return false;
  if (!this.penetration.equals(tmp0_other_with_cast.penetration))
    return false;
  return true;
};
function FunctionalZone(id, layer, polyhedron) {
  this.id = id;
  this.layer = layer;
  this.polyhedron = polyhedron;
}
protoOf(FunctionalZone).n1s = function () {
  return this.id;
};
protoOf(FunctionalZone).l49 = function () {
  return this.layer;
};
protoOf(FunctionalZone).p1x = function () {
  return this.polyhedron;
};
protoOf(FunctionalZone).tf = function () {
  return this.id;
};
protoOf(FunctionalZone).uf = function () {
  return this.layer;
};
protoOf(FunctionalZone).m1m = function () {
  return this.polyhedron;
};
protoOf(FunctionalZone).m49 = function (id, layer, polyhedron) {
  return new FunctionalZone(id, layer, polyhedron);
};
protoOf(FunctionalZone).copy = function (id, layer, polyhedron, $super) {
  id = id === VOID ? this.id : id;
  layer = layer === VOID ? this.layer : layer;
  polyhedron = polyhedron === VOID ? this.polyhedron : polyhedron;
  return this.m49(id, layer, polyhedron);
};
protoOf(FunctionalZone).toString = function () {
  return 'FunctionalZone(id=' + this.id + ', layer=' + this.layer + ', polyhedron=' + toString(this.polyhedron) + ')';
};
protoOf(FunctionalZone).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getStringHashCode(this.layer) | 0;
  result = imul(result, 31) + hashCode(this.polyhedron) | 0;
  return result;
};
protoOf(FunctionalZone).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FunctionalZone))
    return false;
  var tmp0_other_with_cast = other instanceof FunctionalZone ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.layer === tmp0_other_with_cast.layer))
    return false;
  if (!equals(this.polyhedron, tmp0_other_with_cast.polyhedron))
    return false;
  return true;
};
function Companion_53() {
}
protoOf(Companion_53).n49 = function (entity, zoneLayer, otherEntities) {
  var res = null;
  var tmp0_safe_receiver = get_collider(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = otherEntities.length;
    while (inductionVariable < last) {
      var element = otherEntities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.functionalzones.Companion.getFirstColliderIntersectionWithFunctionalZone.<anonymous>.<anonymous>' call
      if (!(element.id === entity.id) && element.hasComponent(Companion_getInstance_99().id)) {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = element.getComponentUnsafe(Companion_getInstance_99().id).zones;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.functionalzones.Companion.getFirstColliderIntersectionWithFunctionalZone.<anonymous>.<anonymous>.<anonymous>' call
          if (element_0.layer === zoneLayer) {
            var tmp0_elvis_lhs = element_0.polyhedron.penetration(tmp1_safe_receiver);
            var interpenetration = tmp0_elvis_lhs == null ? Companion_getInstance_15().ZERO : tmp0_elvis_lhs;
            if (!interpenetration.equals(Companion_getInstance_15().ZERO)) {
              res = new Collision(entity, element, interpenetration);
              return res;
            }
          }
        }
      }
    }
  }
  return res;
};
var Companion_instance_92;
function Companion_getInstance_96() {
  return Companion_instance_92;
}
function getFirstColliderIntersectionWithFunctionalZone(entity, zoneLayer, otherEntities) {
  return Companion_instance_92.n49(entity, zoneLayer, otherEntities);
}
function FunctionalZoneUtils() {
}
function Companion_54() {
  Companion_instance_93 = this;
  this.id = Companion_instance_0.l1r_1;
}
protoOf(Companion_54).n1s = function () {
  return this.id;
};
var Companion_instance_93;
function Companion_getInstance_97() {
  if (Companion_instance_93 == null)
    new Companion_54();
  return Companion_instance_93;
}
function FunctionalZonesLocalComponent(zones) {
  Companion_getInstance_97();
  this.zones = zones;
}
protoOf(FunctionalZonesLocalComponent).o49 = function () {
  return this.zones;
};
protoOf(FunctionalZonesLocalComponent).p1s = function () {
  return Companion_instance_0.l1r_1;
};
protoOf(FunctionalZonesLocalComponent).eq = function (other) {
  var o = other instanceof FunctionalZonesLocalComponent ? other : THROW_CCE();
  return contentEquals(o.zones, this.zones);
};
protoOf(FunctionalZonesLocalComponent).equals = function (other) {
  var tmp;
  if (other instanceof FunctionalZonesLocalComponent) {
    tmp = this.eq(other);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(FunctionalZonesLocalComponent).hashCode = function () {
  return contentHashCode(this.zones);
};
protoOf(FunctionalZonesLocalComponent).getWorldSpaceZones = function (transform) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.zones;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.functionalzones.FunctionalZonesLocalComponent.getWorldSpaceZones.<anonymous>' call
      var zone = this_0[i];
      arr[i] = new FunctionalZone(zone.id, zone.layer, zone.polyhedron.transform(transform));
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new FunctionalZonesWorldComponent(tmp$ret$2);
};
function Companion_55() {
  this.ID = 'FunctionalZonesLocalToWorldSystem';
}
protoOf(Companion_55).j1y = function () {
  return this.ID;
};
var Companion_instance_94;
function Companion_getInstance_98() {
  return Companion_instance_94;
}
function updateFunctionalZonesInWorldSpace($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_97().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.functionalzones.FunctionalZonesLocalToWorldSystem.updateFunctionalZonesInWorldSpace.<anonymous>' call
    var worldSpaceZonesComponent = tmp0_safe_receiver.getWorldSpaceZones(get_worldTransform(entity));
    $this.entityManager.addComponent(entity, worldSpaceZonesComponent);
  }
}
function FunctionalZonesLocalToWorldSystem(entityManager) {
  SystemBase2.call(this, Companion_instance_94.ID, Companion_instance_0.g1n_1, Companion_instance_0.l1r_1);
  this.entityManager = entityManager;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.a4a_1 = [Companion_instance_0.m1r_1];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.b4a_1 = [Companion_instance_17.ID];
}
protoOf(FunctionalZonesLocalToWorldSystem).c1k = function () {
  return this.entityManager;
};
protoOf(FunctionalZonesLocalToWorldSystem).j1w = function () {
  return this.a4a_1;
};
protoOf(FunctionalZonesLocalToWorldSystem).k1w = function () {
  return this.b4a_1;
};
protoOf(FunctionalZonesLocalToWorldSystem).h1z = function (entity, newComponent) {
  updateFunctionalZonesInWorldSpace(this, entity);
};
protoOf(FunctionalZonesLocalToWorldSystem).v1v = function (entity, newComponent) {
  return this.h1z(entity, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalZonesLocalToWorldSystem).i1z = function (entity, oldComponent, newComponent) {
  updateFunctionalZonesInWorldSpace(this, entity);
};
protoOf(FunctionalZonesLocalToWorldSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE();
  return this.i1z(entity, tmp, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalZonesLocalToWorldSystem).j1z = function (entity, oldComponent) {
  updateFunctionalZonesInWorldSpace(this, entity);
};
protoOf(FunctionalZonesLocalToWorldSystem).z1v = function (entity, oldComponent) {
  return this.j1z(entity, oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE());
};
protoOf(FunctionalZonesLocalToWorldSystem).c4a = function (entity, newComponent) {
  updateFunctionalZonesInWorldSpace(this, entity);
};
protoOf(FunctionalZonesLocalToWorldSystem).l1z = function (entity, newComponent) {
  return this.c4a(entity, newComponent instanceof FunctionalZonesLocalComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalZonesLocalToWorldSystem).d4a = function (entity, oldComponent, newComponent) {
  updateFunctionalZonesInWorldSpace(this, entity);
};
protoOf(FunctionalZonesLocalToWorldSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof FunctionalZonesLocalComponent ? oldComponent : THROW_CCE();
  return this.d4a(entity, tmp, newComponent instanceof FunctionalZonesLocalComponent ? newComponent : THROW_CCE());
};
protoOf(FunctionalZonesLocalToWorldSystem).e4a = function (entity, oldComponent) {
  this.entityManager.removeComponent(entity, Companion_instance_0.m1r_1);
};
protoOf(FunctionalZonesLocalToWorldSystem).p1z = function (entity, oldComponent) {
  return this.e4a(entity, oldComponent instanceof FunctionalZonesLocalComponent ? oldComponent : THROW_CCE());
};
function Companion_56() {
  Companion_instance_95 = this;
  this.id = Companion_instance_0.m1r_1;
}
protoOf(Companion_56).n1s = function () {
  return this.id;
};
var Companion_instance_95;
function Companion_getInstance_99() {
  if (Companion_instance_95 == null)
    new Companion_56();
  return Companion_instance_95;
}
function FunctionalZonesWorldComponent(zones) {
  Companion_getInstance_99();
  this.zones = zones;
}
protoOf(FunctionalZonesWorldComponent).o49 = function () {
  return this.zones;
};
protoOf(FunctionalZonesWorldComponent).p1s = function () {
  return Companion_instance_0.m1r_1;
};
protoOf(FunctionalZonesWorldComponent).eq = function (other) {
  var o = other instanceof FunctionalZonesWorldComponent ? other : THROW_CCE();
  return contentEquals(o.zones, this.zones);
};
protoOf(FunctionalZonesWorldComponent).equals = function (other) {
  var tmp;
  if (other instanceof FunctionalZonesWorldComponent) {
    tmp = this.eq(other);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(FunctionalZonesWorldComponent).hashCode = function () {
  return contentHashCode(this.zones);
};
function setChildrenFromParents($this, productsData) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var childrenMap = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = productsData.length;
  while (inductionVariable < last) {
    var element = productsData[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = element.parents;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>.<anonymous>' call
      var childrenList = childrenMap.f2(element_0.id);
      if (childrenList == null) {
        // Inline function 'kotlin.collections.set' call
        var key = element_0.id;
        var value = mutableListOf([element.entity]);
        childrenMap.q2(key, value);
      } else {
        childrenList.h(element.entity);
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(productsData.length);
  var inductionVariable_1 = 0;
  var last_1 = productsData.length;
  while (inductionVariable_1 < last_1) {
    var item = productsData[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>' call
    var tmp0_safe_receiver = childrenMap.f2(item.entity.id);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var children = tmp_0;
    var tmp$ret$3 = item.copy(VOID, VOID, VOID, children);
    destination.h(tmp$ret$3);
  }
  return copyToArray(destination);
}
function createIntegerIds($this, productsData) {
  var nextId = 1;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(productsData.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$_0(capacity);
  var inductionVariable = 0;
  var last = productsData.length;
  while (inductionVariable < last) {
    var element = productsData[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>' call
    var newId = nextId;
    nextId = nextId + 1 | 0;
    var pair = to(element.entity.id, newId);
    destination.q2(pair.rf_1, pair.sf_1);
  }
  var entityIdToIntId = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(productsData.length);
  var inductionVariable_0 = 0;
  var last_0 = productsData.length;
  while (inductionVariable_0 < last_0) {
    var item = productsData[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>' call
    var tmp0_elvis_lhs = entityIdToIntId.f2(item.entity.id);
    var tmp1_id = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = item.children;
    var destination_1 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_1 = 0;
    var last_1 = this_0.length;
    while (inductionVariable_1 < last_1) {
      var element_0 = this_0[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = entityIdToIntId.f2(element_0.id);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_1.h(tmp0_safe_receiver);
      }
    }
    var tmp2_children_ids = copyToArray(destination_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_1 = item.parents;
    var destination_2 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_2 = 0;
    var last_2 = this_1.length;
    while (inductionVariable_2 < last_2) {
      var element_1 = this_1[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = entityIdToIntId.f2(element_1.id);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_2.h(tmp0_safe_receiver_0);
      }
    }
    var tmp3_parent_ids = copyToArray(destination_2);
    var tmp$ret$13 = item.copy(tmp1_id, VOID, VOID, VOID, tmp3_parent_ids, tmp2_children_ids);
    destination_0.h(tmp$ret$13);
  }
  return copyToArray(destination_0);
}
function dataForEntity($this, entity, includedEntities) {
  var tmp = getParents($this, entity, includedEntities);
  // Inline function 'kotlin.emptyArray' call
  var tmp_0 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp_1 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp_2 = [];
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size;
  return new ICFProductData(0, entity, tmp, tmp_0, tmp_1, tmp_2, tmp3_elvis_lhs == null ? Companion_getInstance_15().ZERO : tmp3_elvis_lhs, get_worldTransform(entity));
}
function getParents($this, entity, includedEntities) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (get_guestConnections(entity).length === 0) {
    tmp = getParentIdsFromChildCompoment($this, entity, includedEntities);
  } else {
    tmp = getParentIdsFromConnections($this, get_guestConnections(entity), includedEntities);
  }
  return tmp;
}
function getParentIdsFromChildCompoment($this, entity, includedEntities) {
  var tmp0_elvis_lhs = get_parent(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var tmp_0;
  if (contains(includedEntities, parent.id)) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [parent];
  } else {
    tmp_0 = getParents($this, parent, includedEntities);
  }
  return tmp_0;
}
function getParentIdsFromConnections($this, allParentConnections, includedEntities) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.distinctBy' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(allParentConnections.length);
  var inductionVariable = 0;
  var last = allParentConnections.length;
  while (inductionVariable < last) {
    var item = allParentConnections[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
    var tmp$ret$0 = item.hostConnectorEntity;
    destination.h(tmp$ret$0);
  }
  var set = HashSet_init_$Create$();
  var list = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var e = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
    var key = e.id;
    if (set.h(key)) {
      list.h(e);
    }
  }
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = list.k();
  while (tmp0_iterator_0.m()) {
    var element = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
    var tmp;
    if (contains(includedEntities, element.id)) {
      tmp = listOf(element);
    } else {
      tmp = toList(getParents($this, element, includedEntities));
    }
    var list_0 = tmp;
    addAll(destination_0, list_0);
  }
  return copyToArray(destination_0);
}
function Companion_57() {
  Companion_instance_96 = this;
  this.logger = LoggerState_getInstance().g1v('ICFDataService');
}
protoOf(Companion_57).l1k = function () {
  return this.logger;
};
var Companion_instance_96;
function Companion_getInstance_100() {
  if (Companion_instance_96 == null)
    new Companion_57();
  return Companion_instance_96;
}
function ICFDataService$getICFDataForEntities$lambda($entitiesNotInScene) {
  return function () {
    return 'One or more entities passed could not be found in scene: ' + toString($entitiesNotInScene);
  };
}
function ICFDataService(sceneManager) {
  Companion_getInstance_100();
  this.sceneManager = sceneManager;
}
protoOf(ICFDataService).d1k = function () {
  return this.sceneManager;
};
protoOf(ICFDataService).getICFDataForEntities = function (entityIds) {
  var entitiesInScene = this.sceneManager.entities;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(entitiesInScene.length);
  var inductionVariable = 0;
  var last = entitiesInScene.length;
  while (inductionVariable < last) {
    var item = entitiesInScene[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
    var tmp$ret$0 = item.id;
    destination.h(tmp$ret$0);
  }
  var entityIdsInScene = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = entityIds.length;
  while (inductionVariable_0 < last_0) {
    var element = entityIds[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
    if (!entityIdsInScene.s(element)) {
      destination_0.h(element);
    }
  }
  var entitiesNotInScene = destination_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!entitiesNotInScene.r()) {
    var tmp = Companion_getInstance_100().logger;
    tmp.error(ICFDataService$getICFDataForEntities$lambda(entitiesNotInScene));
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.sceneManager.entities;
  var destination_1 = ArrayList_init_$Create$();
  var inductionVariable_1 = 0;
  var last_1 = this_0.length;
  while (inductionVariable_1 < last_1) {
    var element_0 = this_0[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
    if (contains(entityIds, element_0.id)) {
      destination_1.h(element_0);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_1, 10));
  var tmp0_iterator = destination_1.k();
  while (tmp0_iterator.m()) {
    var item_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
    var tmp$ret$10 = dataForEntity(this, item_0, entityIds);
    destination_2.h(tmp$ret$10);
  }
  var productsData = copyToArray(destination_2);
  var dataWithChildren = setChildrenFromParents(this, productsData);
  return createIntegerIds(this, dataWithChildren);
};
function ICFProductData(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform) {
  this.id = id;
  this.entity = entity;
  this.parents = parents;
  this.children = children;
  this.parent_ids = parent_ids;
  this.children_ids = children_ids;
  this.colliderDimensions = colliderDimensions;
  this.transform = transform;
  this.f4a_1 = 0;
}
protoOf(ICFProductData).n1s = function () {
  return this.id;
};
protoOf(ICFProductData).v2i = function () {
  return this.entity;
};
protoOf(ICFProductData).g4a = function () {
  return this.parents;
};
protoOf(ICFProductData).i1m = function () {
  return this.children;
};
protoOf(ICFProductData).h4a = function () {
  return this.parent_ids;
};
protoOf(ICFProductData).i4a = function () {
  return this.children_ids;
};
protoOf(ICFProductData).j4a = function () {
  return this.colliderDimensions;
};
protoOf(ICFProductData).z2a = function () {
  return this.transform;
};
protoOf(ICFProductData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ICFProductData))
    THROW_CCE();
  return this.entity.id === other.entity.id;
};
protoOf(ICFProductData).hashCode = function () {
  if (this.f4a_1 === 0) {
    this.f4a_1 = this.entity.id;
  }
  return this.f4a_1;
};
protoOf(ICFProductData).tf = function () {
  return this.id;
};
protoOf(ICFProductData).uf = function () {
  return this.entity;
};
protoOf(ICFProductData).m1m = function () {
  return this.parents;
};
protoOf(ICFProductData).n1m = function () {
  return this.children;
};
protoOf(ICFProductData).o1m = function () {
  return this.parent_ids;
};
protoOf(ICFProductData).p1m = function () {
  return this.children_ids;
};
protoOf(ICFProductData).q1m = function () {
  return this.colliderDimensions;
};
protoOf(ICFProductData).l2e = function () {
  return this.transform;
};
protoOf(ICFProductData).k4a = function (id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform) {
  return new ICFProductData(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform);
};
protoOf(ICFProductData).copy = function (id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform, $super) {
  id = id === VOID ? this.id : id;
  entity = entity === VOID ? this.entity : entity;
  parents = parents === VOID ? this.parents : parents;
  children = children === VOID ? this.children : children;
  parent_ids = parent_ids === VOID ? this.parent_ids : parent_ids;
  children_ids = children_ids === VOID ? this.children_ids : children_ids;
  colliderDimensions = colliderDimensions === VOID ? this.colliderDimensions : colliderDimensions;
  transform = transform === VOID ? this.transform : transform;
  return this.k4a(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform);
};
protoOf(ICFProductData).toString = function () {
  return 'ICFProductData(id=' + this.id + ', entity=' + this.entity.toString() + ', parents=' + toString(this.parents) + ', children=' + toString(this.children) + ', parent_ids=' + toString(this.parent_ids) + ', children_ids=' + toString(this.children_ids) + ', colliderDimensions=' + this.colliderDimensions.toString() + ', transform=' + this.transform.toString() + ')';
};
function Companion_58() {
  Companion_instance_97 = this;
  this.id = Companion_instance_0.d1r_1;
}
protoOf(Companion_58).n1s = function () {
  return this.id;
};
var Companion_instance_97;
function Companion_getInstance_101() {
  if (Companion_instance_97 == null)
    new Companion_58();
  return Companion_instance_97;
}
function LabelComponent(text) {
  Companion_getInstance_101();
  this.text = text;
}
protoOf(LabelComponent).l4a = function () {
  return this.text;
};
protoOf(LabelComponent).p1s = function () {
  return Companion_getInstance_101().id;
};
protoOf(LabelComponent).eq = function (other) {
  return this.text === (other instanceof LabelComponent ? other : THROW_CCE()).text;
};
function DebugLogger(logLevel, exceptionLevel) {
  logLevel = logLevel === VOID ? LogLevel_DEBUG_getInstance() : logLevel;
  exceptionLevel = exceptionLevel === VOID ? LogLevel_ERROR_getInstance() : exceptionLevel;
  this.m4a_1 = logLevel;
  this.exceptionLevel = exceptionLevel;
  this.latestLoggedMessage = null;
}
protoOf(DebugLogger).j2u = function (_set____db54di) {
  this.m4a_1 = _set____db54di;
};
protoOf(DebugLogger).k2u = function () {
  return this.m4a_1;
};
protoOf(DebugLogger).n4a = function (_set____db54di) {
  this.exceptionLevel = _set____db54di;
};
protoOf(DebugLogger).o4a = function () {
  return this.exceptionLevel;
};
protoOf(DebugLogger).p4a = function (_set____db54di) {
  this.latestLoggedMessage = _set____db54di;
};
protoOf(DebugLogger).q4a = function () {
  return this.latestLoggedMessage;
};
protoOf(DebugLogger).debug = function (f) {
  if (this.m4a_1.x2(LogLevel_DEBUG_getInstance()) <= 0) {
    this.latestLoggedMessage = f();
    echoStandardConsole(this.latestLoggedMessage);
  }
  if (this.exceptionLevel.x2(LogLevel_DEBUG_getInstance()) <= 0)
    throw new LoggerException(toString_0(f()));
};
protoOf(DebugLogger).error = function (f) {
  if (this.m4a_1.x2(LogLevel_ERROR_getInstance()) <= 0) {
    this.latestLoggedMessage = f();
    echoStandardConsole(this.latestLoggedMessage);
  }
  if (this.exceptionLevel.x2(LogLevel_ERROR_getInstance()) <= 0)
    throw new LoggerException(toString_0(f()));
};
protoOf(DebugLogger).warn = function (f) {
  if (this.m4a_1.x2(LogLevel_WARN_getInstance()) <= 0) {
    this.latestLoggedMessage = f();
    echoStandardConsole(this.latestLoggedMessage);
  }
  if (this.exceptionLevel.x2(LogLevel_WARN_getInstance()) <= 0)
    throw new LoggerException(toString_0(f()));
};
protoOf(DebugLogger).info = function (f) {
  if (this.m4a_1.x2(LogLevel_INFO_getInstance()) <= 0) {
    this.latestLoggedMessage = f();
    echoStandardConsole(this.latestLoggedMessage);
  }
  if (this.exceptionLevel.x2(LogLevel_INFO_getInstance()) <= 0)
    throw new LoggerException(toString_0(f()));
};
function LoggerException(msg) {
  msg = msg === VOID ? null : msg;
  Exception_init_$Init$(msg, this);
  captureStack(this, LoggerException);
}
function Companion_59() {
  Companion_instance_98 = this;
  this.ID = Companion_instance_0.j1s_1;
}
protoOf(Companion_59).j1y = function () {
  return this.ID;
};
var Companion_instance_98;
function Companion_getInstance_102() {
  if (Companion_instance_98 == null)
    new Companion_59();
  return Companion_instance_98;
}
function CurrentProppingComponent(propping) {
  Companion_getInstance_102();
  this.propping = propping;
}
protoOf(CurrentProppingComponent).r4a = function () {
  return this.propping;
};
protoOf(CurrentProppingComponent).p1s = function () {
  return Companion_getInstance_102().ID;
};
protoOf(CurrentProppingComponent).eq = function (other) {
  return (other instanceof CurrentProppingComponent ? other : THROW_CCE()).propping.equals(this.propping);
};
function Companion_60() {
  Companion_instance_99 = this;
  this.s4a_1 = 'DisposeProppingOnReplacedEntitySystem';
  this.t4a_1 = LoggerState_getInstance().g1v('DisposeProppingOnReplacedEntitySystem');
}
var Companion_instance_99;
function Companion_getInstance_103() {
  if (Companion_instance_99 == null)
    new Companion_60();
  return Companion_instance_99;
}
function DisposeProppingOnSlowReplacedEntitySystem() {
  Companion_getInstance_103();
  SystemBase.call(this, 'DisposeProppingOnReplacedEntitySystem', Companion_instance_18.n1s());
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.e4b_1 = [Companion_getInstance_109().u4a_1];
}
protoOf(DisposeProppingOnSlowReplacedEntitySystem).m1w = function () {
  return this.e4b_1;
};
protoOf(DisposeProppingOnSlowReplacedEntitySystem).f4b = function (entity, newComponent) {
  entity.removeComponent(Companion_getInstance_109().u4a_1);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.DisposeProppingOnSlowReplacedEntitySystem.onAddComponent.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_107().g4b_1)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.newpropping.DisposeProppingOnSlowReplacedEntitySystem.onAddComponent.<anonymous>' call
    element_0.dispose();
  }
};
protoOf(DisposeProppingOnSlowReplacedEntitySystem).v1v = function (entity, newComponent) {
  return this.f4b(entity, newComponent instanceof SlowReplaceInProgressComponent ? newComponent : THROW_CCE());
};
function Companion_61() {
  Companion_instance_100 = this;
  this.h4b_1 = Companion_instance_0.h1s_1;
}
protoOf(Companion_61).j1y = function () {
  return this.h4b_1;
};
var Companion_instance_100;
function Companion_getInstance_104() {
  if (Companion_instance_100 == null)
    new Companion_61();
  return Companion_instance_100;
}
function get_ID() {
  return Companion_getInstance_104().h4b_1;
}
function LargestFittingProppingComponent(largestFittingPropping) {
  Companion_getInstance_104();
  this.largestFittingPropping = largestFittingPropping;
}
protoOf(LargestFittingProppingComponent).i4b = function () {
  return this.largestFittingPropping;
};
protoOf(LargestFittingProppingComponent).p1s = function () {
  return Companion_getInstance_104().h4b_1;
};
protoOf(LargestFittingProppingComponent).eq = function (other) {
  return (other instanceof LargestFittingProppingComponent ? other : THROW_CCE()).largestFittingPropping.equals(this.largestFittingPropping);
};
function Companion_62() {
  Companion_instance_101 = this;
  this.j4b_1 = 'ProppingConvertColliderToFunctionalZoneSystem';
  this.k4b_1 = 'propping-layer';
  this.l4b_1 = LoggerState_getInstance().g1v(this.j4b_1);
}
protoOf(Companion_62).j1y = function () {
  return this.j4b_1;
};
protoOf(Companion_62).m4b = function () {
  return this.k4b_1;
};
var Companion_instance_101;
function Companion_getInstance_105() {
  if (Companion_instance_101 == null)
    new Companion_62();
  return Companion_instance_101;
}
function get_ID_0() {
  return Companion_getInstance_105().j4b_1;
}
function get_zoneLayer() {
  return Companion_getInstance_105().k4b_1;
}
function ProppingConvertColliderToFunctionalZoneSystem() {
  Companion_getInstance_105();
  SystemBase.call(this, Companion_getInstance_105().j4b_1, Companion_instance_10.id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.w4b_1 = [Companion_instance_4.n1s()];
}
protoOf(ProppingConvertColliderToFunctionalZoneSystem).m1w = function () {
  return this.w4b_1;
};
protoOf(ProppingConvertColliderToFunctionalZoneSystem).t32 = function (entity, newComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_19().id);
  var collider = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  if (collider == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.newpropping.ProppingConvertColliderToFunctionalZoneSystem.onAddComponent.<anonymous>' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [new FunctionalZone('propping shape', Companion_getInstance_105().k4b_1, collider)];
    entity.addComponent(new FunctionalZonesLocalComponent(tmp$ret$2));
  }
  entity.removeComponent(Companion_getInstance_19().id);
};
protoOf(ProppingConvertColliderToFunctionalZoneSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
function Companion_63() {
  Companion_instance_102 = this;
  this.x4b_1 = 'ProppingDisposalSystem';
  this.y4b_1 = LoggerState_getInstance().g1v('ProppingDisposalSystem');
}
var Companion_instance_102;
function Companion_getInstance_106() {
  if (Companion_instance_102 == null)
    new Companion_63();
  return Companion_instance_102;
}
function ProppingDisposalSystem() {
  Companion_getInstance_106();
  SystemBase2.call(this, 'ProppingDisposalSystem', Companion_getInstance_102().ID, Companion_getInstance_104().h4b_1);
}
protoOf(ProppingDisposalSystem).k4c = function (entity, oldComponent, newComponent) {
  this.l4c(entity, oldComponent);
};
protoOf(ProppingDisposalSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof CurrentProppingComponent ? oldComponent : THROW_CCE();
  return this.k4c(entity, tmp, newComponent instanceof CurrentProppingComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingDisposalSystem).l4c = function (entity, oldComponent) {
  if (oldComponent.propping.isDisposed)
    return Unit_instance;
  oldComponent.propping.dispose();
};
protoOf(ProppingDisposalSystem).z1v = function (entity, oldComponent) {
  return this.l4c(entity, oldComponent instanceof CurrentProppingComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingDisposalSystem).m4c = function (entity, oldComponent) {
  entity.removeComponent(Companion_getInstance_102().ID);
};
protoOf(ProppingDisposalSystem).p1z = function (entity, oldComponent) {
  return this.m4c(entity, oldComponent instanceof LargestFittingProppingComponent ? oldComponent : THROW_CCE());
};
function Companion_64() {
  Companion_instance_103 = this;
  this.g4b_1 = Companion_instance_0.g1s_1;
}
protoOf(Companion_64).j1y = function () {
  return this.g4b_1;
};
var Companion_instance_103;
function Companion_getInstance_107() {
  if (Companion_instance_103 == null)
    new Companion_64();
  return Companion_instance_103;
}
function get_ID_1() {
  return Companion_getInstance_107().g4b_1;
}
function ProppingHostConnectorDataComponent(hostConnectorEntity, proppingHostConnector, proppingSizePrefabs, width, depth) {
  Companion_getInstance_107();
  this.hostConnectorEntity = hostConnectorEntity;
  this.proppingHostConnector = proppingHostConnector;
  this.proppingSizePrefabs = proppingSizePrefabs;
  this.width = width;
  this.depth = depth;
}
protoOf(ProppingHostConnectorDataComponent).i28 = function () {
  return this.hostConnectorEntity;
};
protoOf(ProppingHostConnectorDataComponent).n4c = function () {
  return this.proppingHostConnector;
};
protoOf(ProppingHostConnectorDataComponent).o4c = function () {
  return this.proppingSizePrefabs;
};
protoOf(ProppingHostConnectorDataComponent).t2u = function () {
  return this.width;
};
protoOf(ProppingHostConnectorDataComponent).v2u = function () {
  return this.depth;
};
protoOf(ProppingHostConnectorDataComponent).p1s = function () {
  return Companion_getInstance_107().g4b_1;
};
protoOf(ProppingHostConnectorDataComponent).n28 = function () {
  return this.proppingHostConnector.priority;
};
protoOf(ProppingHostConnectorDataComponent).eq = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  if ((other instanceof ProppingHostConnectorDataComponent ? other : THROW_CCE()).proppingHostConnector.equals(this.proppingHostConnector)) {
    tmp_1 = contentEquals(other.proppingSizePrefabs, this.proppingSizePrefabs);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = other.width === this.width;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = other.depth === this.depth;
  } else {
    tmp = false;
  }
  return tmp;
};
function Companion_65() {
  Companion_instance_104 = this;
  this.p4c_1 = 'ProppingHostConnectorDataCreationSystem';
  this.q4c_1 = LoggerState_getInstance().g1v(this.p4c_1);
}
protoOf(Companion_65).j1y = function () {
  return this.p4c_1;
};
var Companion_instance_104;
function Companion_getInstance_108() {
  if (Companion_instance_104 == null)
    new Companion_65();
  return Companion_instance_104;
}
function clearProppingDataFromScene($this) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.a4d_1.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.clearProppingDataFromScene.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_107().g4b_1)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.clearProppingDataFromScene.<anonymous>' call
    var tmp0_safe_receiver = get_parent(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.removeComponent(Companion_getInstance_109().u4a_1);
    element_0.dispose();
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = $this.a4d_1.sceneManager.entities;
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.clearProppingDataFromScene.<anonymous>' call
    if (element_1.hasComponent(Companion_instance_4.n1s())) {
      destination_0.h(element_1);
    }
  }
  var tmp0_iterator_0 = destination_0.k();
  while (tmp0_iterator_0.m()) {
    var element_2 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.clearProppingDataFromScene.<anonymous>' call
    Companion_instance.k29(element_2);
  }
}
function updateProppingDataInScene($this) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.a4d_1.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataInScene.<anonymous>' call
    if (get_isConnectionRoot(element)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataInScene.<anonymous>' call
    updateProppingDataForProppingHost($this, element_0);
  }
  Companion_instance_128.c4d($this.a4d_1);
}
function updateProppingDataForProppingHost($this, entity) {
  if (entity.hasComponent(Companion_getInstance_109().u4a_1))
    return Unit_instance;
  var counter = 0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>' call
    if (element.hasComponent(Companion_instance_4.n1s())) {
      destination.h(element);
    }
  }
  var currentPropping = destination;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_snappingHierarchyEntities(entity);
  var inductionVariable_0 = 0;
  var last_0 = indexedObject.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>' call
    var hostConnectors = get_hostConnectors(element_0);
    var tmp;
    if (hostConnectors == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = hostConnectors.k();
      while (tmp0_iterator.m()) {
        var element_1 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>' call
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject_0 = element_1.tags();
          var inductionVariable_1 = 0;
          var last_1 = indexedObject_0.length;
          while (inductionVariable_1 < last_1) {
            var element_2 = indexedObject_0[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>' call
            if (element_2 === 'propping-connector') {
              tmp$ret$4 = true;
              break $l$block;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4) {
          destination_0.h(element_1);
        }
      }
      tmp = destination_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = tmp1_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_3 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>' call
        var list = element_3.u2b();
        addAll_0(destination_1, list);
      }
      tmp_0 = destination_1;
    }
    var tmp2_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = tmp2_safe_receiver.k();
      while (tmp0_iterator_1.m()) {
        var element_4 = tmp0_iterator_1.n();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>' call
        var localWidth = Companion_instance_128.d4d(element_4);
        var localDepth = Companion_instance_128.e4d(element_4);
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = $this.b4d_1;
        var destination_3 = ArrayList_init_$Create$();
        var inductionVariable_2 = 0;
        var last_2 = this_1.length;
        while (inductionVariable_2 < last_2) {
          var element_5 = this_1[inductionVariable_2];
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp$ret$14;
          $l$block_2: {
            // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver = get_guestConnectors(element_5.proppingPrefab);
            var tmp_2;
            if (tmp0_safe_receiver == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.collections.find' call
              var tmp$ret$12;
              $l$block_0: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var tmp0_iterator_2 = tmp0_safe_receiver.k();
                while (tmp0_iterator_2.m()) {
                  var element_6 = tmp0_iterator_2.n();
                  // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  if (element_6.hasMatchingTypeAndDemandsTo(element_4)) {
                    tmp$ret$12 = element_6;
                    break $l$block_0;
                  }
                }
                tmp$ret$12 = null;
              }
              tmp_2 = tmp$ret$12;
            }
            var matchingGuestConnector = tmp_2;
            var isMatchingOffersDemands = !(matchingGuestConnector == null);
            if (!isMatchingOffersDemands) {
              tmp$ret$14 = false;
              break $l$block_2;
            }
            var tmp1_safe_receiver_0 = element_5.proppingPrefab.__getComponentForKotlin(Companion_getInstance_19().id);
            var tmp2_safe_receiver_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.polyhedron;
            var tmp3_elvis_lhs = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.axisAlignedBoundingBox;
            var tmp_3;
            if (tmp3_elvis_lhs == null) {
              tmp$ret$14 = isMatchingOffersDemands;
              break $l$block_2;
            } else {
              tmp_3 = tmp3_elvis_lhs;
            }
            var proppingAabb = tmp_3;
            var doesFitSize = (localWidth === -1 || proppingAabb.size.X <= localWidth + 1.0E-4) && (localDepth === -1 || proppingAabb.size.Z <= localDepth + 1.0E-4);
            tmp$ret$14 = (isMatchingOffersDemands && doesFitSize);
          }
          if (tmp$ret$14) {
            destination_3.h(element_5);
          }
        }
        var eligibleProppingPrefabs = copyToArray(destination_3);
        var tmp_4;
        if (any(eligibleProppingPrefabs)) {
          // Inline function 'kotlin.collections.find' call
          var this_2 = get_children(entity);
          var tmp$ret$19;
          $l$block_3: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_3 = 0;
            var last_3 = this_2.length;
            while (inductionVariable_3 < last_3) {
              var element_7 = this_2[inductionVariable_3];
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver_0 = element_7.__getComponentForKotlin(Companion_getInstance_107().g4b_1);
              var tmp1_safe_receiver_1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.proppingHostConnector;
              if ((tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.key) === element_4.key) {
                tmp$ret$19 = element_7;
                break $l$block_3;
              }
            }
            tmp$ret$19 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$19;
          var proppingHolder = tmp0_elvis_lhs == null ? $this.a4d_1.entityManager.createEntity() : tmp0_elvis_lhs;
          proppingHolder.addComponent(new UnserializableEntityComponent());
          counter = counter + 1 | 0;
          proppingHolder.addComponent(new DisplayNameComponent('propping data holder ' + counter));
          setParent(proppingHolder, entity);
          proppingHolder.addComponent(new ProppingHostConnectorDataComponent(element_0, element_4, eligibleProppingPrefabs, localWidth, localDepth));
          Companion_instance_8.b1m(proppingHolder, element_4.transform);
          var tmp$ret$22;
          $l$block_4: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator_3 = currentPropping.k();
            while (tmp0_iterator_3.m()) {
              var element_8 = tmp0_iterator_3.n();
              // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver_1 = get_highestPriorityConnection(element_8);
              var tmp1_safe_receiver_2 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.hostConnector;
              if ((tmp1_safe_receiver_2 == null ? null : tmp1_safe_receiver_2.key) === element_4.key) {
                tmp$ret$22 = element_8;
                break $l$block_4;
              }
            }
            tmp$ret$22 = null;
          }
          var tmp1_safe_receiver_3 = tmp$ret$22;
          if (tmp1_safe_receiver_3 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.updateProppingDataForProppingHost.<anonymous>.<anonymous>.<anonymous>' call
            proppingHolder.addComponent(new CurrentProppingComponent(tmp1_safe_receiver_3));
          }
          tmp_4 = proppingHolder;
        } else {
          tmp_4 = null;
        }
        var tmp0_safe_receiver_2 = tmp_4;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_2.h(tmp0_safe_receiver_2);
        }
      }
      tmp_1 = destination_2;
    }
    var addedProppingHolders = tmp_1;
    if ((addedProppingHolders == null ? null : any_0(addedProppingHolders)) === true) {
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$29 = copyToArray(addedProppingHolders);
      entity.addComponent(new ProppingParentComponent(tmp$ret$29));
    }
  }
}
function get_ID_2() {
  return Companion_getInstance_108().p4c_1;
}
function sam$kotlin_Comparator$0_3(function_0) {
  this.f4d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_3).md = function (a, b) {
  return this.f4d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).s3 = function () {
  return this.f4d_1;
};
protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
  return hashCode(this.s3());
};
function ProppingHostConnectorDataCreationSystem$setProppingProducts$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.setProppingProducts.<anonymous>' call
  var tmp = b.size;
  // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.setProppingProducts.<anonymous>' call
  var tmp$ret$1 = a.size;
  return compareValues(tmp, tmp$ret$1);
}
function ProppingHostConnectorDataCreationSystem(coreServices) {
  Companion_getInstance_108();
  var tmp0_id = Companion_getInstance_108().p4c_1;
  var tmp1_componentId = Companion_instance_10.id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp2_systemsBeforeMe = [Companion_getInstance_1().j2a_1, Companion_instance_9.x29_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp3_doingChangesOnComponent = [Companion_getInstance_109().u4a_1, Companion_getInstance_107().g4b_1, Companion_instance_19.id, Companion_getInstance_26().id, Companion_getInstance_27().z2o_1, Companion_getInstance_28().id];
  SystemBase.call(this, tmp0_id, tmp1_componentId, tmp3_doingChangesOnComponent, tmp2_systemsBeforeMe);
  this.a4d_1 = coreServices;
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.b4d_1 = [];
}
protoOf(ProppingHostConnectorDataCreationSystem).g4d = function () {
  return this.b4d_1;
};
protoOf(ProppingHostConnectorDataCreationSystem).h4d = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.b4d_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.<get-currentProppingProductRefs>.<anonymous>' call
    var tmp$ret$0 = toString_0(get_productRef(item.proppingPrefab));
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(ProppingHostConnectorDataCreationSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  updateProppingDataInScene(this);
};
protoOf(ProppingHostConnectorDataCreationSystem).disable = function () {
  clearProppingDataFromScene(this);
  protoOf(SystemBase).disable.call(this);
};
protoOf(ProppingHostConnectorDataCreationSystem).setProppingProducts = function (proppingProductRefs) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = proppingProductRefs.length;
  while (inductionVariable < last) {
    var element = proppingProductRefs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'com.ikea.core.stl.newpropping.ProppingHostConnectorDataCreationSystem.setProppingProducts.<anonymous>' call
      var tmp0_elvis_lhs = this.a4d_1.productManager.productSpecification(element);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var spec = tmp_0;
      if (!spec.hasComponent(Companion_instance_4.n1s())) {
        tmp$ret$0 = null;
        break $l$block_2;
      }
      var tmp1_elvis_lhs = this.a4d_1.productManager.createFromSpecificationInternal(element, spec);
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block_2;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var prefabEntity = tmp_1;
      var aabb = Companion_getInstance_29().m2z(get_hierarchy(prefabEntity));
      set_displayName(prefabEntity, 'propping prefab - ' + get_displayName(prefabEntity));
      var tmp2_safe_receiver = get_guestConnectors(prefabEntity);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : firstOrNull_1(tmp2_safe_receiver);
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block_2;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      var guestConnector = tmp_2;
      // Inline function 'kotlin.math.abs' call
      var tmp5_safe_receiver = aabb == null ? null : aabb.size;
      var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.dot(guestConnector.transform.up);
      var x = tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs;
      var sizeAlongConnectorUp = Math.abs(x);
      tmp$ret$0 = new SizeProppingPair(sizeAlongConnectorUp, prefabEntity);
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_3 = ProppingHostConnectorDataCreationSystem$setProppingProducts$lambda;
  var tmp$ret$5 = new sam$kotlin_Comparator$0_3(tmp_3);
  var this_0 = sortedWith(destination, tmp$ret$5);
  tmp.b4d_1 = copyToArray(this_0);
  clearProppingDataFromScene(this);
  updateProppingDataInScene(this);
};
protoOf(ProppingHostConnectorDataCreationSystem).t32 = function (entity, newComponent) {
  if (get_isPropping(entity))
    return Unit_instance;
  if (!get_isConnectionRoot(entity))
    return Unit_instance;
  updateProppingDataForProppingHost(this, entity);
};
protoOf(ProppingHostConnectorDataCreationSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
function Companion_66() {
  Companion_instance_105 = this;
  this.u4a_1 = Companion_instance_0.f1s_1;
}
protoOf(Companion_66).j1y = function () {
  return this.u4a_1;
};
var Companion_instance_105;
function Companion_getInstance_109() {
  if (Companion_instance_105 == null)
    new Companion_66();
  return Companion_instance_105;
}
function get_ID_3() {
  return Companion_getInstance_109().u4a_1;
}
function ProppingParentComponent(proppingHolders) {
  Companion_getInstance_109();
  this.proppingHolders = proppingHolders;
}
protoOf(ProppingParentComponent).i4d = function () {
  return this.proppingHolders;
};
protoOf(ProppingParentComponent).p1s = function () {
  return Companion_getInstance_109().u4a_1;
};
protoOf(ProppingParentComponent).eq = function (other) {
  return contentEquals(this.proppingHolders, (other instanceof ProppingParentComponent ? other : THROW_CCE()).proppingHolders);
};
function Companion_67() {
  Companion_instance_106 = this;
  this.ID = 'ProppingSpaceCalculationSystem';
  this.j4d_1 = LoggerState_getInstance().g1v('ProppingSpaceCalculationSystem');
}
protoOf(Companion_67).j1y = function () {
  return this.ID;
};
var Companion_instance_106;
function Companion_getInstance_110() {
  if (Companion_instance_106 == null)
    new Companion_67();
  return Companion_instance_106;
}
function ProppingSpaceCalculationSystem(coreServices) {
  Companion_getInstance_110();
  var tmp = Companion_getInstance_30().id;
  var tmp_0 = Companion_getInstance_3().id;
  var tmp_1 = Companion_instance_5.id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_108().p4c_1, Companion_getInstance_1().j2a_1, Companion_instance_9.x29_1];
  SystemBase3.call(this, 'ProppingSpaceCalculationSystem', tmp, tmp_0, tmp_1, VOID, tmp$ret$2);
  this.w4d_1 = coreServices;
  this.x4d_1 = false;
}
protoOf(ProppingSpaceCalculationSystem).z2p = function (entity, oldComponent) {
  if (this.x4d_1)
    return Unit_instance;
  if (get_isPropping(entity))
    return Unit_instance;
  Companion_instance_128.c4d(this.w4d_1);
};
protoOf(ProppingSpaceCalculationSystem).z1v = function (entity, oldComponent) {
  return this.z2p(entity, oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingSpaceCalculationSystem).y4d = function (entity, oldComponent) {
  if (this.x4d_1)
    return Unit_instance;
  if (get_isPropping(entity))
    return Unit_instance;
  if (!get_isConnectionRoot(entity))
    return Unit_instance;
  if (get_isRoomPart(entity))
    return Unit_instance;
  Companion_instance_128.c4d(this.w4d_1);
};
protoOf(ProppingSpaceCalculationSystem).p1z = function (entity, oldComponent) {
  return this.y4d(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingSpaceCalculationSystem).z4d = function (entity, newComponent) {
  this.x4d_1 = true;
};
protoOf(ProppingSpaceCalculationSystem).n2m = function (entity, newComponent) {
  return this.z4d(entity, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSpaceCalculationSystem).a4e = function (entity, oldComponent) {
  this.x4d_1 = false;
  Companion_instance_128.c4d(this.w4d_1);
};
protoOf(ProppingSpaceCalculationSystem).p2m = function (entity, oldComponent) {
  return this.a4e(entity, oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE());
};
function Companion_68() {
  Companion_instance_107 = this;
  this.b4e_1 = 'SelectLargestProppingPlacementSystem';
  this.c4e_1 = LoggerState_getInstance().g1v(this.b4e_1);
}
protoOf(Companion_68).j1y = function () {
  return this.b4e_1;
};
var Companion_instance_107;
function Companion_getInstance_111() {
  if (Companion_instance_107 == null)
    new Companion_68();
  return Companion_instance_107;
}
function get_ID_4() {
  return Companion_getInstance_111().b4e_1;
}
function SelectLargestProppingPlacementSystem(coreServices) {
  Companion_getInstance_111();
  SystemBase.call(this, Companion_getInstance_111().b4e_1, Companion_getInstance_104().h4b_1);
  this.m4e_1 = coreServices;
}
protoOf(SelectLargestProppingPlacementSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.m4e_1.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.SelectLargestProppingPlacementSystem.enable.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_104().h4b_1)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.newpropping.SelectLargestProppingPlacementSystem.enable.<anonymous>' call
    this.n4e(element_0, element_0.getComponentUnsafe(Companion_getInstance_104().h4b_1));
  }
};
protoOf(SelectLargestProppingPlacementSystem).disable = function () {
  protoOf(SystemBase).disable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.m4e_1.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.newpropping.SelectLargestProppingPlacementSystem.disable.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_104().h4b_1)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.newpropping.SelectLargestProppingPlacementSystem.disable.<anonymous>' call
    Companion_instance_128.o4e(element_0);
  }
};
protoOf(SelectLargestProppingPlacementSystem).n4e = function (entity, newComponent) {
  var productRef = toString_0(get_productRef(newComponent.largestFittingPropping.proppingPrefab));
  Companion_instance_128.p4e(entity, productRef, this.m4e_1);
};
protoOf(SelectLargestProppingPlacementSystem).v1v = function (entity, newComponent) {
  return this.n4e(entity, newComponent instanceof LargestFittingProppingComponent ? newComponent : THROW_CCE());
};
protoOf(SelectLargestProppingPlacementSystem).q4e = function (entity, oldComponent, newComponent) {
  this.n4e(entity, newComponent);
};
protoOf(SelectLargestProppingPlacementSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof LargestFittingProppingComponent ? oldComponent : THROW_CCE();
  return this.q4e(entity, tmp, newComponent instanceof LargestFittingProppingComponent ? newComponent : THROW_CCE());
};
function SizeProppingPair(size, proppingPrefab) {
  this.size = size;
  this.proppingPrefab = proppingPrefab;
}
protoOf(SizeProppingPair).o = function () {
  return this.size;
};
protoOf(SizeProppingPair).r4e = function () {
  return this.proppingPrefab;
};
protoOf(SizeProppingPair).tf = function () {
  return this.size;
};
protoOf(SizeProppingPair).uf = function () {
  return this.proppingPrefab;
};
protoOf(SizeProppingPair).s4e = function (size, proppingPrefab) {
  return new SizeProppingPair(size, proppingPrefab);
};
protoOf(SizeProppingPair).copy = function (size, proppingPrefab, $super) {
  size = size === VOID ? this.size : size;
  proppingPrefab = proppingPrefab === VOID ? this.proppingPrefab : proppingPrefab;
  return this.s4e(size, proppingPrefab);
};
protoOf(SizeProppingPair).toString = function () {
  return 'SizeProppingPair(size=' + this.size + ', proppingPrefab=' + this.proppingPrefab.toString() + ')';
};
protoOf(SizeProppingPair).hashCode = function () {
  var result = getNumberHashCode(this.size);
  result = imul(result, 31) + this.proppingPrefab.hashCode() | 0;
  return result;
};
protoOf(SizeProppingPair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SizeProppingPair))
    return false;
  var tmp0_other_with_cast = other instanceof SizeProppingPair ? other : THROW_CCE();
  if (!equals(this.size, tmp0_other_with_cast.size))
    return false;
  if (!this.proppingPrefab.equals(tmp0_other_with_cast.proppingPrefab))
    return false;
  return true;
};
function Companion_69() {
  Companion_instance_108 = this;
  this.ID = Companion_instance_0.i1s_1;
}
protoOf(Companion_69).j1y = function () {
  return this.ID;
};
var Companion_instance_108;
function Companion_getInstance_112() {
  if (Companion_instance_108 == null)
    new Companion_69();
  return Companion_instance_108;
}
function TemporarilyIgnoreMyProppingFunctionalZonesComponent() {
  Companion_getInstance_112();
}
protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent).p1s = function () {
  return Companion_getInstance_112().ID;
};
protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent).eq = function (other) {
  return true;
};
function Companion_70() {
  Companion_instance_109 = this;
  this.id = Companion_instance_0.f1r_1;
}
protoOf(Companion_70).n1s = function () {
  return this.id;
};
var Companion_instance_109;
function Companion_getInstance_113() {
  if (Companion_instance_109 == null)
    new Companion_70();
  return Companion_instance_109;
}
function ColoredOutlineComponent(r, g, b) {
  Companion_getInstance_113();
  r = r === VOID ? 0.0 : r;
  g = g === VOID ? 0.0 : g;
  b = b === VOID ? 1.0 : b;
  this.r = r;
  this.g = g;
  this.b = b;
}
protoOf(ColoredOutlineComponent).t4e = function () {
  return this.r;
};
protoOf(ColoredOutlineComponent).u4e = function () {
  return this.g;
};
protoOf(ColoredOutlineComponent).v4e = function () {
  return this.b;
};
protoOf(ColoredOutlineComponent).p1s = function () {
  return Companion_getInstance_113().id;
};
protoOf(ColoredOutlineComponent).eq = function (other) {
  var tmp;
  var tmp_0;
  if ((other instanceof ColoredOutlineComponent ? other : THROW_CCE()).r === this.r) {
    tmp_0 = other.g === this.g;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = other.b === this.b;
  } else {
    tmp = false;
  }
  return tmp;
};
function ColoredOutlineSystem() {
  var tmp = Companion_getInstance_113().id;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  SystemBase.call(this, 'ColoredOutlineSystem', tmp, tmp$ret$0);
}
protoOf(ColoredOutlineSystem).f4f = function (entity, newComponent) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, Companion_getInstance().id).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.outlines.ColoredOutlineSystem.onAddComponent.<anonymous>' call
    var tmp0_safe_receiver = get_viewerObject(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_safe_receiver.setOutlined(true);
      tmp0_safe_receiver.setOutlinedObjectColor(newComponent.r, newComponent.g, newComponent.b);
    }
  }
};
protoOf(ColoredOutlineSystem).v1v = function (entity, newComponent) {
  return this.f4f(entity, newComponent instanceof ColoredOutlineComponent ? newComponent : THROW_CCE());
};
protoOf(ColoredOutlineSystem).g4f = function (entity, oldComponent, newComponent) {
  this.f4f(entity, newComponent);
};
protoOf(ColoredOutlineSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColoredOutlineComponent ? oldComponent : THROW_CCE();
  return this.g4f(entity, tmp, newComponent instanceof ColoredOutlineComponent ? newComponent : THROW_CCE());
};
protoOf(ColoredOutlineSystem).h4f = function (entity, oldComponent) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, Companion_getInstance().id).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.outlines.ColoredOutlineSystem.onRemoveComponent.<anonymous>' call
    var tmp0_safe_receiver = get_viewerObject(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_safe_receiver.removeOutlinedObjectColor();
      tmp0_safe_receiver.setOutlined(get_isSelected(entity));
    }
  }
};
protoOf(ColoredOutlineSystem).z1v = function (entity, oldComponent) {
  return this.h4f(entity, oldComponent instanceof ColoredOutlineComponent ? oldComponent : THROW_CCE());
};
function Companion_71() {
  Companion_instance_110 = this;
  this.id = Companion_instance_0.c1r_1;
}
protoOf(Companion_71).n1s = function () {
  return this.id;
};
var Companion_instance_110;
function Companion_getInstance_114() {
  if (Companion_instance_110 == null)
    new Companion_71();
  return Companion_instance_110;
}
function OutlineBlockingComponent() {
  Companion_getInstance_114();
}
protoOf(OutlineBlockingComponent).p1s = function () {
  return Companion_getInstance_114().id;
};
protoOf(OutlineBlockingComponent).eq = function (other) {
  return true;
};
function Companion_72() {
  this.ID = 'OutlineEntityGroupDeselectSystem';
}
protoOf(Companion_72).j1y = function () {
  return this.ID;
};
var Companion_instance_111;
function Companion_getInstance_115() {
  return Companion_instance_111;
}
function removeOutlineFromMembers($this, newComponent) {
  var indexedObject = newComponent.members;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var member = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (!member.hasComponent(Companion_getInstance_24().id) && member.hasComponent(Companion_getInstance_117().id)) {
      member.removeComponent(Companion_getInstance_117().id);
    }
  }
}
function OutlineEntityGroupDeselectSystem(entityManager) {
  SystemBase.call(this, Companion_instance_111.ID, Companion_getInstance_0().id);
  this.entityManager = entityManager;
}
protoOf(OutlineEntityGroupDeselectSystem).c1k = function () {
  return this.entityManager;
};
protoOf(OutlineEntityGroupDeselectSystem).r4f = function (entity, newComponent) {
  removeOutlineFromMembers(this, newComponent);
};
protoOf(OutlineEntityGroupDeselectSystem).v1v = function (entity, newComponent) {
  return this.r4f(entity, newComponent instanceof AutomaticGroupComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineEntityGroupDeselectSystem).s4f = function (entity, oldComponent, newComponent) {
  removeOutlineFromMembers(this, newComponent);
};
protoOf(OutlineEntityGroupDeselectSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof AutomaticGroupComponent ? oldComponent : THROW_CCE();
  return this.s4f(entity, tmp, newComponent instanceof AutomaticGroupComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineEntityGroupDeselectSystem).t4f = function (entity, oldComponent) {
};
protoOf(OutlineEntityGroupDeselectSystem).z1v = function (entity, oldComponent) {
  return this.t4f(entity, oldComponent instanceof AutomaticGroupComponent ? oldComponent : THROW_CCE());
};
function Companion_73() {
  this.ID = 'OutlineSelectedSystem';
}
protoOf(Companion_73).j1y = function () {
  return this.ID;
};
var Companion_instance_112;
function Companion_getInstance_116() {
  return Companion_instance_112;
}
function OutlineSelectedSystem() {
  SystemBase.call(this, Companion_instance_112.ID, Companion_getInstance_24().id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d4g_1 = [Companion_instance_0.k1n_1];
}
protoOf(OutlineSelectedSystem).e4g = function (entity, newComponent) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, Companion_instance_0.w1m_1).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.outlines.OutlineSelectedSystem.onAddComponent.<anonymous>' call
    if (element.hasComponent(Companion_instance_0.a1p_1)) {
      element.addComponent(new OutlinedComponent());
    }
  }
};
protoOf(OutlineSelectedSystem).v1v = function (entity, newComponent) {
  return this.e4g(entity, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSelectedSystem).f4g = function (entity, oldComponent, newComponent) {
};
protoOf(OutlineSelectedSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE();
  return this.f4g(entity, tmp, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSelectedSystem).g4g = function (entity, oldComponent) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, Companion_instance_0.w1m_1).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.outlines.OutlineSelectedSystem.onRemoveComponent.<anonymous>' call
    element.removeComponent(Companion_getInstance_117().id);
  }
};
protoOf(OutlineSelectedSystem).z1v = function (entity, oldComponent) {
  return this.g4g(entity, oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE());
};
protoOf(OutlineSelectedSystem).j1w = function () {
  return this.d4g_1;
};
function onStartedDragging_0($this, entity) {
  setBlockingOnEntity($this, entity, false);
}
function onStoppedDragging_0($this, entity) {
  updateOutline($this, entity);
}
function updateOutline($this, childEntity) {
  var doOutline = hasComponentInUpwardsHierarchy(childEntity, Companion_getInstance_117().id);
  outlineEntity($this, childEntity, doOutline);
  setBlockingOnEntity($this, childEntity, !doOutline);
}
function handleChildComponentChanged($this, childEntity, any) {
  updateOutline($this, childEntity);
}
function handleChildComponentChanged_0($this, childEntity, any, newChildComponent) {
  handleChildComponentChanged($this, childEntity, newChildComponent);
}
function handleOutlineRemoved($this, entity, removed) {
  if (!hasComponentInUpwardsHierarchy(entity, Companion_getInstance_117().id)) {
    outlineEntity($this, entity, false);
    setBlockingOnEntity($this, entity, true);
  }
}
function handleOutlineAdded($this, entity, added) {
  outlineEntity($this, entity, true);
  setBlockingOnEntity($this, entity, false);
}
function outlineEntity($this, entity, doOutline) {
  outlineEntity$setOutlined(doOutline, entity);
}
function setBlockingOnEntity($this, entity, doBlock) {
  setBlockingOnEntity$setBlocking(doBlock, entity);
}
function outlineEntity$setOutlined($doOutline, sub) {
  var tmp0_safe_receiver = get_viewerObject(sub);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.setOutlined($doOutline);
  var tmp1_safe_receiver = get_parentComponent(sub);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp2_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp2_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.outlines.OutlineSystem.outlineEntity.setOutlined.<anonymous>' call
      if (!element.hasComponent(Companion_getInstance_117().id)) {
        outlineEntity$setOutlined($doOutline, element);
      }
    }
  }
}
function setBlockingOnEntity$setBlocking($doBlock, sub) {
  var tmp0_safe_receiver = get_viewerObject(sub);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.setBlockOutlined($doBlock);
  var tmp1_safe_receiver = get_parentComponent(sub);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp2_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp2_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.outlines.OutlineSystem.setBlockingOnEntity.setBlocking.<anonymous>' call
      if (!element.hasComponent(Companion_getInstance_117().id)) {
        setBlockingOnEntity$setBlocking($doBlock, element);
      }
    }
  }
}
function OutlineSystem() {
  var tmp = Companion_getInstance_20().id;
  var tmp_0 = Companion_instance_0.k1n_1;
  var tmp_1 = Companion_instance_0.n1n_1;
  var tmp_2 = Companion_instance_0.q1n_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp_3 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [Companion_instance_20.ID, Companion_instance_21.h2t_1];
  SystemBase4.call(this, 'OutlineSystem', tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$3, null);
}
protoOf(OutlineSystem).m42 = function (entity, newComponent) {
  onStartedDragging_0(this, entity);
};
protoOf(OutlineSystem).v1v = function (entity, newComponent) {
  return this.m42(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).n42 = function (entity, oldComponent, newComponent) {
};
protoOf(OutlineSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE();
  return this.n42(entity, tmp, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).o42 = function (entity, oldComponent) {
  onStoppedDragging_0(this, entity);
};
protoOf(OutlineSystem).z1v = function (entity, oldComponent) {
  return this.o42(entity, oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(OutlineSystem).u4g = function (entity, newComponent) {
  handleOutlineAdded(this, entity, newComponent);
};
protoOf(OutlineSystem).l1z = function (entity, newComponent) {
  return this.u4g(entity, newComponent instanceof OutlinedComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).v4g = function (entity, oldComponent, newComponent) {
};
protoOf(OutlineSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof OutlinedComponent ? oldComponent : THROW_CCE();
  return this.v4g(entity, tmp, newComponent instanceof OutlinedComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).w4g = function (entity, oldComponent) {
  handleOutlineRemoved(this, entity, oldComponent);
};
protoOf(OutlineSystem).p1z = function (entity, oldComponent) {
  return this.w4g(entity, oldComponent instanceof OutlinedComponent ? oldComponent : THROW_CCE());
};
protoOf(OutlineSystem).x4g = function (entity, newComponent) {
  handleChildComponentChanged(this, entity, newComponent);
};
protoOf(OutlineSystem).n2m = function (entity, newComponent) {
  return this.x4g(entity, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).y4g = function (entity, oldComponent, newComponent) {
  handleChildComponentChanged_0(this, entity, oldComponent, newComponent);
};
protoOf(OutlineSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE();
  return this.y4g(entity, tmp, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).z4g = function (entity, oldComponent) {
};
protoOf(OutlineSystem).p2m = function (entity, oldComponent) {
  return this.z4g(entity, oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE());
};
protoOf(OutlineSystem).a4h = function (entity, newComponent) {
  updateOutline(this, entity);
};
protoOf(OutlineSystem).d2n = function (entity, newComponent) {
  return this.a4h(entity, newComponent instanceof LoadedModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).b4h = function (entity, oldComponent, newComponent) {
  updateOutline(this, entity);
};
protoOf(OutlineSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof LoadedModelInfoComponent ? oldComponent : THROW_CCE();
  return this.b4h(entity, tmp, newComponent instanceof LoadedModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(OutlineSystem).c4h = function (entity, oldComponent) {
};
protoOf(OutlineSystem).f2n = function (entity, oldComponent) {
  return this.c4h(entity, oldComponent instanceof LoadedModelInfoComponent ? oldComponent : THROW_CCE());
};
function Companion_74() {
  Companion_instance_113 = this;
  this.id = Companion_instance_0.k1n_1;
}
protoOf(Companion_74).n1s = function () {
  return this.id;
};
var Companion_instance_113;
function Companion_getInstance_117() {
  if (Companion_instance_113 == null)
    new Companion_74();
  return Companion_instance_113;
}
function OutlinedComponent() {
  Companion_getInstance_117();
}
protoOf(OutlinedComponent).p1s = function () {
  return Companion_getInstance_117().id;
};
protoOf(OutlinedComponent).eq = function (other) {
  return true;
};
function moveTo($this, entity, position) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var entityToMove = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  Companion_instance_8.z1l(entityToMove, new Transform(position, get_worldRotation(entityToMove)));
}
function doPlacement($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy) {
  entityToPlace.addComponent(new AutoAdaptSessionComponent());
  $this.e4h_1.addComponent(entityToPlace, new SnapCandidateComponent());
  var snapValidationResult = tryFindValidSnap($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy);
  var placementResult = Companion_instance_115.j4h(snapValidationResult);
  var tmp0_safe_receiver = snapValidationResult.snap;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.performMoveAndConnect();
  }
  var tmp1_elvis_lhs = placementResult.placedEntity;
  var actualEntity = tmp1_elvis_lhs == null ? entityToPlace : tmp1_elvis_lhs;
  actualEntity.removeComponent(Companion_instance_22.id);
  actualEntity.removeComponent(Companion_getInstance_59().ID);
  return placementResult;
}
function tryFindValidSnap($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(hosts.length === 0)) {
    tmp = tryFindFirstValidSnapResult($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
  } else {
    tmp = tryAllHosts($this, entityToPlace, sortByWarnings);
  }
  var result = tmp;
  return result;
}
function tryFindFirstValidSnapResult($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var allResults = ArrayList_init_$Create$();
  // Inline function 'kotlin.sequences.find' call
  var tmp = asSequence_0(hosts);
  var tmp_0 = map(tmp, AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda($this, entityToPlace, sortByWarnings, sortAndSelectStrategy));
  var this_0 = onEach(tmp_0, AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda_0(allResults));
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.sequences.firstOrNull' call
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryFindFirstValidSnapResult.<anonymous>' call
      if (element.valid) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var goodResult = tmp$ret$2;
  if (!(goodResult == null))
    return goodResult;
  var tmp_1;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!allResults.r()) {
    // Inline function 'kotlin.collections.reduce' call
    var iterator = allResults.k();
    if (!iterator.m())
      throw UnsupportedOperationException_init_$Create$("Empty collection can't be reduced.");
    var accumulator = iterator.n();
    while (iterator.m()) {
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryFindFirstValidSnapResult.<anonymous>' call
      var prevResult = accumulator;
      var nextResult = iterator.n();
      accumulator = prevResult.combineFailures(nextResult);
    }
    tmp_1 = accumulator;
  } else {
    // Inline function 'kotlin.emptyArray' call
    var tmp_2 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$10 = [Companion_instance_2.fail('No hosts to snap to', get_productRef(entityToPlace), null)];
    tmp_1 = new ValidSnapActionCandidateOrErrors(null, tmp_2, tmp$ret$10);
  }
  return tmp_1;
}
function tryAllHosts($this, entityToPlace, sortByWarnings) {
  var variants = get_variantEntities(entityToPlace);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.f4h_1.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_62().id)) {
      destination.h(element);
    }
  }
  var allHosts = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = variants.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = variants[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    // Inline function 'kotlin.collections.asIterable' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator = allHosts.k();
    while (tmp0_iterator.m()) {
      var element_1 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>' call
      var list = asSequence_0(Companion_instance_1.p1l(element_0, element_1, new SnapSettings(true, VOID, VOID, true)));
      addAll_0(destination_1, list);
    }
    var list_0 = destination_1;
    addAll(destination_0, list_0);
  }
  var snaps = destination_0;
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = AutoAdaptPlacementActor$tryAllHosts$lambda;
  var tmp$ret$10 = new sam$kotlin_Comparator$0_4(tmp);
  var this_1 = sortedWith(snaps, tmp$ret$10);
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = AutoAdaptPlacementActor$tryAllHosts$lambda_0($this);
  var tmp$ret$12 = new sam$kotlin_Comparator$0_4(tmp_0);
  var this_2 = sortedWith(this_1, tmp$ret$12);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_1 = AutoAdaptPlacementActor$tryAllHosts$lambda_1;
  var tmp$ret$14 = new sam$kotlin_Comparator$0_4(tmp_1);
  var this_3 = sortedWith(this_2, tmp$ret$14);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_2 = AutoAdaptPlacementActor$tryAllHosts$lambda_2(entityToPlace);
  var tmp$ret$16 = new sam$kotlin_Comparator$0_4(tmp_2);
  var sortedSnaps = sortedWith(this_3, tmp$ret$16);
  var goodResult = null;
  var warningResult = null;
  var failedResult = null;
  // Inline function 'kotlin.collections.find' call
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator_0 = sortedSnaps.k();
    while (tmp0_iterator_0.m()) {
      var element_2 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      if (goodResult == null) {
        var myResult = $this.h4h_1.validateSnapCandidate(element_2);
        if (myResult.valid) {
          var tmp_3;
          if (!sortByWarnings) {
            tmp_3 = true;
          } else {
            // Inline function 'kotlin.collections.isEmpty' call
            tmp_3 = myResult.warnings.length === 0;
          }
          if (tmp_3) {
            goodResult = myResult;
          } else {
            if (warningResult == null || myResult.warnings.length < ensureNotNull(warningResult).warnings.length) {
              warningResult = myResult;
            }
          }
        } else {
          var tmp0_safe_receiver = failedResult;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.combineFailuresWithValidatedSnapCandidate(myResult);
          failedResult = tmp1_elvis_lhs == null ? myResult.toValidSnapActionCandidateOrErrors() : tmp1_elvis_lhs;
        }
      }
      if (!(goodResult == null)) {
        break $l$block;
      }
    }
  }
  var tmp$ret$31;
  $l$block_2: {
    // Inline function 'com.ikea.core.utils.otherwise' call
    var tmp0_safe_receiver_0 = goodResult;
    var this_4 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.toValidSnapActionCandidateOrErrors();
    if (this_4 == null) {
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      var tmp$ret$29;
      $l$block_1: {
        // Inline function 'com.ikea.core.utils.otherwise' call
        var tmp0_safe_receiver_1 = warningResult;
        var this_5 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.toValidSnapActionCandidateOrErrors();
        if (this_5 == null) {
          // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>' call
          var tmp$ret$27;
          $l$block_0: {
            // Inline function 'com.ikea.core.utils.otherwise' call
            var this_6 = failedResult;
            if (this_6 == null) {
              // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.emptyArray' call
              var tmp_4 = [];
              // Inline function 'kotlin.arrayOf' call
              // Inline function 'kotlin.js.unsafeCast' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp$ret$25 = [Companion_instance_2.fail('No hosts to snap to', get_productRef(entityToPlace), null)];
              tmp$ret$27 = new ValidSnapActionCandidateOrErrors(null, tmp_4, tmp$ret$25);
              break $l$block_0;
            }
            tmp$ret$27 = this_6;
          }
          tmp$ret$29 = tmp$ret$27;
          break $l$block_1;
        }
        tmp$ret$29 = this_5;
      }
      tmp$ret$31 = tmp$ret$29;
      break $l$block_2;
    }
    tmp$ret$31 = this_4;
  }
  return tmp$ret$31;
}
function recommendationDistance($this, candidate) {
  var result = Companion_getInstance_15().ZERO;
  var tmp0_safe_receiver = candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_121().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
    var diff = Math.abs(this_0);
    result = new Vector(0.0, diff, 0.0);
  }
  if (candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_122().id) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.i4h_1.warn(AutoAdaptPlacementActor$recommendationDistance$lambda);
  }
  return result;
}
function sam$kotlin_Comparator$0_4(function_0) {
  this.k4h_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_4).md = function (a, b) {
  return this.k4h_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).s3 = function () {
  return this.k4h_1;
};
protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
  return hashCode(this.s3());
};
function AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda(this$0, $entityToPlace, $sortByWarnings, $sortAndSelectStrategy) {
  return function (it) {
    return this$0.d4h_1.findValidSnapActionWithAutoAdapt($entityToPlace, it, new SnapSettings($sortByWarnings, VOID, VOID, $sortByWarnings), $sortByWarnings, $sortAndSelectStrategy);
  };
}
function AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda_0($allResults) {
  return function (it) {
    $allResults.h(it);
    return Unit_instance;
  };
}
function AutoAdaptPlacementActor$tryAllHosts$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
  var tmp = a.movement.size;
  // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
  var tmp$ret$1 = b.movement.size;
  return compareValues(tmp, tmp$ret$1);
}
function AutoAdaptPlacementActor$tryAllHosts$lambda_0(this$0) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp = recommendationDistance(this$0, a).size;
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp$ret$1 = recommendationDistance(this$0, b).size;
    return compareValues(tmp, tmp$ret$1);
  };
}
function AutoAdaptPlacementActor$tryAllHosts$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function AutoAdaptPlacementActor$tryAllHosts$lambda_2($entityToPlace) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp = b.guest.equals($entityToPlace);
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp$ret$1 = a.guest.equals($entityToPlace);
    return compareValues(tmp, tmp$ret$1);
  };
}
function AutoAdaptPlacementActor$recommendationDistance$lambda() {
  return 'PositionFromParent is not yet implemented';
}
function AutoAdaptPlacementActor(autoAdaptService, entityManager, sceneManager, productManager, validationService) {
  this.d4h_1 = autoAdaptService;
  this.e4h_1 = entityManager;
  this.f4h_1 = sceneManager;
  this.g4h_1 = productManager;
  this.h4h_1 = validationService;
  this.i4h_1 = LoggerState_getInstance().g1v('AutoAdaptPlacementActor');
}
protoOf(AutoAdaptPlacementActor).l4h = function (entityToPlace, sortAndSelectStrategy) {
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  return doPlacement(this, entityToPlace, tmp$ret$0, true, sortAndSelectStrategy);
};
protoOf(AutoAdaptPlacementActor).m4h = function (entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy) {
  moveTo(this, entityToPlace, initialPosition);
  var hosts = this.d4h_1.findAutoAdaptHostsContainingPoint(entityToPlace, initialPosition);
  return doPlacement(this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
};
protoOf(AutoAdaptPlacementActor).n4h = function (entityToPlace, host, sortAndSelectStrategy) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [host];
  return doPlacement(this, entityToPlace, tmp$ret$2, true, sortAndSelectStrategy);
};
protoOf(AutoAdaptPlacementActor).o4h = function (entityToPlace, targets, sortAndSelectStrategy) {
  return doPlacement(this, entityToPlace, targets, true, sortAndSelectStrategy);
};
function Companion_75() {
  Companion_instance_114 = this;
  this.p4h_1 = (new SnapSorterBuilder()).addWarningsCriterion().addConnectorPriorityCriterion(Companion_getInstance_125().r3w_1).addOriginalVariantCriterion().addRecommendedDistanceFromFloorCriterion().addDistanceCriterion().build();
  this.q4h_1 = (new SnapSorterBuilder()).addOriginalVariantCriterion().addConnectorPriorityCriterion(Companion_getInstance_125().s3w_1).addDistanceCriterion().build();
}
protoOf(Companion_75).r4h = function (guest, position, coreServices) {
  Companion_instance_8.z1l(guest, new Transform(position, get_worldTransform(guest).rotation));
  var snaps = Companion_instance_49.x3t(guest, coreServices.sceneManager.scene, new SnapSettings(true, VOID, VOID, true));
  return this.pickAndPerformSnap(coreServices, snaps, guest, this.q4h_1);
};
protoOf(Companion_75).s4h = function (guest, coreServices) {
  var originalTransform = get_worldTransform(guest);
  var tmp0_elvis_lhs = recommendedPosition(guest, originalTransform.position);
  var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
  Companion_instance_8.z1l(guest, new Transform(recommendedPos, originalTransform.rotation));
  var snaps = Companion_instance_49.x3t(guest, coreServices.sceneManager.scene, new SnapSettings(true, VOID, VOID, true));
  return this.pickAndPerformSnap(coreServices, snaps, guest, this.p4h_1);
};
protoOf(Companion_75).pickAndPerformSnap = function (coreServices, snaps, guest, sorter) {
  var validatedSnaps = coreServices.validations.validateSnapCandidates(snaps);
  var validSnaps = Companion_getInstance_126().u4h(coreServices.validations, validatedSnaps, 5);
  var validSnapsThatRespectsAlignments = Companion_instance_23.q3d(validSnaps);
  var bestValidResult = sorter.bestResult(validSnapsThatRespectsAlignments);
  var bestValidCandidate = bestValidResult == null ? null : bestValidResult.snap;
  if (bestValidCandidate == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    bestValidCandidate.performMoveAndConnect();
    return Companion_instance_115.v4h(bestValidResult);
  }
  var topCandidate = sorter.bestCandidate(snaps);
  if (!(topCandidate == null)) {
    var failedResult = coreServices.validations.validateSnapCandidate(topCandidate, false);
    return Companion_instance_115.v4h(failedResult);
  }
  return Companion_instance_115.failWithMessage$default('No valid snap found', get_productRefOrEmptyString(guest));
};
protoOf(Companion_75).w4h = function (guest, host, coreServices) {
  var snaps = Companion_instance_49.v3t(guest, host, new SnapSettings(true, VOID, true, true));
  return this.pickAndPerformSnap(coreServices, snaps, guest, this.p4h_1);
};
protoOf(Companion_75).x4h = function (guest, hosts, coreServices) {
  var snaps = Companion_instance_49.w3t(guest, hosts, new SnapSettings(true, VOID, true, true));
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var element = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.Companion.snapToHosts.<anonymous>' call
    element.guestRoot.addComponent(new RestrictAllowedRequiredHostsComponent(hosts));
  }
  var placementResults = this.pickAndPerformSnap(coreServices, snaps, guest, this.p4h_1);
  var tmp0_safe_receiver = placementResults.placedEntity;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.removeComponent(Companion_instance_7.id);
  return placementResults;
};
var Companion_instance_114;
function Companion_getInstance_118() {
  if (Companion_instance_114 == null)
    new Companion_75();
  return Companion_instance_114;
}
function snapToPosition(guest, position, coreServices) {
  return Companion_getInstance_118().r4h(guest, position, coreServices);
}
function snapToScene(guest, coreServices) {
  return Companion_getInstance_118().s4h(guest, coreServices);
}
function snapToHost(guest, host, coreServices) {
  return Companion_getInstance_118().w4h(guest, host, coreServices);
}
function snapToHosts(guest, hosts, coreServices) {
  return Companion_getInstance_118().x4h(guest, hosts, coreServices);
}
function PlacementHelper() {
  Companion_getInstance_118();
}
function Companion_76() {
}
protoOf(Companion_76).y4h = function (warningsAndErrors, placedEntity) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = warningsAndErrors.length;
  while (inductionVariable < last) {
    var element = warningsAndErrors[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.Companion.fromValidationResult.<anonymous>' call
    if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
      destination.h(element);
    }
  }
  var warnings = copyToArray(destination);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = warningsAndErrors.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = warningsAndErrors[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.Companion.fromValidationResult.<anonymous>' call
    if (element_0.resultType.equals(ValidationResultType_FAIL_getInstance())) {
      destination_0.h(element_0);
    }
  }
  var errors = copyToArray(destination_0);
  return new PlacementResult(warnings, errors, placedEntity);
};
protoOf(Companion_76).j4h = function (result) {
  var tmp0_safe_receiver = result.snap;
  return new PlacementResult(result.warnings, result.errors, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestRoot);
};
protoOf(Companion_76).v4h = function (result) {
  return new PlacementResult(result.warnings, result.errors, result.snap.guestRoot);
};
protoOf(Companion_76).z4h = function (placedEntity) {
  // Inline function 'kotlin.emptyArray' call
  var tmp = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$1 = [];
  return new PlacementResult(tmp, tmp$ret$1, placedEntity);
};
protoOf(Companion_76).a4i = function (message, productRef, rule) {
  // Inline function 'kotlin.emptyArray' call
  var tmp = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [new ValidationResultFail(message, productRef, rule)];
  return new PlacementResult(tmp, tmp$ret$3, null);
};
protoOf(Companion_76).failWithMessage$default = function (message, productRef, rule, $super) {
  rule = rule === VOID ? null : rule;
  return $super === VOID ? this.a4i(message, productRef, rule) : $super.a4i.call(this, message, productRef, rule);
};
protoOf(Companion_76).b4i = function (results) {
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  return new PlacementResult(tmp$ret$0, results, null);
};
protoOf(Companion_76).c4i = function (message, placedEntity, productRef, rule) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [new ValidationResultWarning(message, productRef, rule)];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$3 = [];
  return new PlacementResult(tmp, tmp$ret$3, placedEntity);
};
var Companion_instance_115;
function Companion_getInstance_119() {
  return Companion_instance_115;
}
function fromValidationResult(warningsAndErrors, placedEntity) {
  return Companion_instance_115.y4h(warningsAndErrors, placedEntity);
}
function fromValidSnapActionCandidateOrErrors(result) {
  return Companion_instance_115.j4h(result);
}
function fromValidatedSnapResult(result) {
  return Companion_instance_115.v4h(result);
}
function ok(placedEntity) {
  return Companion_instance_115.z4h(placedEntity);
}
function failWithMessage(message, productRef, rule) {
  return Companion_instance_115.a4i(message, productRef, rule);
}
function failWithMessage_0(message, productRef, rule, $super) {
  rule = rule === VOID ? null : rule;
  return failWithMessage(message, productRef, rule);
}
function failWithErrors(results) {
  return Companion_instance_115.b4i(results);
}
function warn(message, placedEntity, productRef, rule) {
  return Companion_instance_115.c4i(message, placedEntity, productRef, rule);
}
function PlacementResult(warnings, errors, entity) {
  this.warnings = warnings;
  this.errors = errors;
  var tmp = this;
  var tmp1_elvis_lhs = entity == null ? null : get_snapRoot(entity);
  tmp.placedEntity = tmp1_elvis_lhs == null ? entity : tmp1_elvis_lhs;
}
protoOf(PlacementResult).d3h = function () {
  return this.warnings;
};
protoOf(PlacementResult).c3h = function () {
  return this.errors;
};
protoOf(PlacementResult).e3h = function () {
  return none(this.errors);
};
protoOf(PlacementResult).d4i = function () {
  return this.placedEntity;
};
protoOf(PlacementResult).toString = function () {
  var tmp0_safe_receiver = firstOrNull_0(this.errors);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return 'Placement error ' + tmp0_safe_receiver.toString();
  }
  var tmp1_safe_receiver = firstOrNull_0(this.warnings);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return 'Placement warning ' + tmp1_safe_receiver.toString();
  }
  return 'Placement OK';
};
function get_logger() {
  _init_properties_PlacementService_kt__rip640();
  return logger;
}
var logger;
function noAutoAdaptServiceResult($this, productRef) {
  return Companion_instance_115.a4i('No AutoAdaptService, so no auto adapting allowed', productRef, null);
}
function autoAdaptToScene($this, entityToPlace, sortAndSelectStrategy) {
  if ($this.f4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  if ($this.g4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  return $this.g4i_1.l4h(entityToPlace, sortAndSelectStrategy);
}
function autoAdaptToPosition($this, entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy) {
  if ($this.f4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  if ($this.g4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  return $this.g4i_1.m4h(entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy);
}
function autoAdaptToTarget($this, entityToPlace, target, sortAndSelectStrategy) {
  if ($this.f4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  if ($this.g4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  return $this.g4i_1.n4h(entityToPlace, target, sortAndSelectStrategy);
}
function canAutoAdapt($this, entityToPlace) {
  return !($this.f4i_1 == null) && entityToPlace.hasComponent(Companion_getInstance_61().id);
}
function getInitialPosition($this, entityToPlace, closeTo) {
  var tmp1_safe_receiver = recommendedPosition(entityToPlace, closeTo == null ? get_worldPosition(entityToPlace) : closeTo);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return tmp1_safe_receiver;
  }
  if (closeTo == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return closeTo;
  }
  var tmp3_safe_receiver = get_axisAlignedBoundingBoxForHierarchy(entityToPlace);
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return new Vector(VOID, -tmp3_safe_receiver.min.Y);
  }
  return Companion_getInstance_15().ZERO;
}
function autoAdaptToTargets($this, entityToPlace, targets, sortAndSelectStrategy) {
  if ($this.f4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  if ($this.g4i_1 == null)
    return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
  return $this.g4i_1.o4h(entityToPlace, targets, sortAndSelectStrategy);
}
function PlacementService$snapToTarget$lambda(this$0, $entityToPlace, $sortAndSelectStrategy) {
  return function (host) {
    var tmp;
    if (canAutoAdapt(this$0, $entityToPlace)) {
      tmp = autoAdaptToTarget(this$0, $entityToPlace, host, $sortAndSelectStrategy);
    } else {
      tmp = this$0.h4i_1.snapToTarget($entityToPlace, host, $sortAndSelectStrategy);
    }
    return tmp;
  };
}
function PlacementService$snapToConnector$lambda($guestConnectorKey) {
  return function (it) {
    var tmp0_safe_receiver = get_connectorsComponent(it);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey($guestConnectorKey);
  };
}
function PlacementService$snapToConnector$lambda_0($hostConnectorKey) {
  return function (it) {
    var tmp0_safe_receiver = get_connectorsComponent(it);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey($hostConnectorKey);
  };
}
function PlacementService$dissolveEntity$lambda() {
  return 'Trying to dissolve an entity with no parent, which is not allowed. Use ConnectionUtils.disconnectAndDisposeEntityAndHierarchy() instead.';
}
function PlacementService$replaceProductParts$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return Unit_instance;
}
function PlacementService(coreServices, autoAdaptService) {
  autoAdaptService = autoAdaptService === VOID ? null : autoAdaptService;
  this.e4i_1 = coreServices;
  this.f4i_1 = autoAdaptService;
  var tmp = this;
  var tmp_0;
  if (this.f4i_1 == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.placement.PlacementService.autoAdaptPlacementActor.<anonymous>' call
    tmp_0 = new AutoAdaptPlacementActor(this.f4i_1, this.e4i_1.entityManager, this.e4i_1.sceneManager, this.e4i_1.productManager, this.e4i_1.validations);
  }
  tmp.g4i_1 = tmp_0;
  this.h4i_1 = new SnapPlacementActor(this.e4i_1.entityManager, this.e4i_1.sceneManager, this.e4i_1.validations);
}
protoOf(PlacementService).i4i = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy) {
  var result = canAutoAdapt(this, entityToPlace) ? autoAdaptToPosition(this, entityToPlace, initialPosition, !ignoreWarnings, sortAndSelectStrategy) : null;
  if (result == null || !result.valid) {
    result = this.h4i_1.snapToSceneFromPosition(entityToPlace, initialPosition, !ignoreWarnings, searchDirections, sortAndSelectStrategy);
  }
  return result;
};
protoOf(PlacementService).snapToPosition = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy, $super) {
  var tmp;
  if (searchDirections === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [Companion_getInstance_15().LEFT, Companion_getInstance_15().RIGHT, Companion_getInstance_15().UP, Companion_getInstance_15().DOWN, Companion_getInstance_15().BACK, Companion_getInstance_15().FORWARD];
  } else {
    tmp = searchDirections;
  }
  searchDirections = tmp;
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().r35_1 : sortAndSelectStrategy;
  return this.i4i(entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy);
};
protoOf(PlacementService).j4i = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy) {
  var originalTransform = get_worldTransform(entityToPlace);
  var recommendedPos = getInitialPosition(this, entityToPlace, closeTo);
  Companion_instance_8.z1l(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
  var result = canAutoAdapt(this, entityToPlace) ? autoAdaptToScene(this, entityToPlace, sortAndSelectStrategy) : null;
  if (result == null || !result.valid) {
    result = this.h4i_1.snapToSceneFromPosition(entityToPlace, recommendedPos, true, searchDirections, sortAndSelectStrategy);
  }
  if (!result.valid) {
    Companion_instance_8.z1l(entityToPlace, originalTransform);
  }
  return result;
};
protoOf(PlacementService).snapToScene = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy, $super) {
  closeTo = closeTo === VOID ? null : closeTo;
  var tmp;
  if (searchDirections === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [Companion_getInstance_15().LEFT, Companion_getInstance_15().RIGHT, Companion_getInstance_15().UP, Companion_getInstance_15().DOWN, Companion_getInstance_15().BACK, Companion_getInstance_15().FORWARD];
  } else {
    tmp = searchDirections;
  }
  searchDirections = tmp;
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().t35_1 : sortAndSelectStrategy;
  return this.j4i(entityToPlace, closeTo, searchDirections, sortAndSelectStrategy);
};
protoOf(PlacementService).k4i = function (entityToPlace, target, sortAndSelectStrategy) {
  var originalTransform = get_worldTransform(entityToPlace);
  var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
  var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
  Companion_instance_8.z1l(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
  var snapExact = PlacementService$snapToTarget$lambda(this, entityToPlace, sortAndSelectStrategy);
  var exactResult = snapExact(target);
  if (exactResult.valid) {
    return exactResult;
  }
  var eligibleHosts = minus_0(hierarchyExceptSubTreesWithComponentSequence(target, Companion_getInstance().id), target);
  var _iterator__ex2g4s = eligibleHosts.k();
  while (_iterator__ex2g4s.m()) {
    var host = _iterator__ex2g4s.n();
    var result = snapExact(host);
    if (result.valid) {
      return result;
    }
  }
  Companion_instance_8.z1l(entityToPlace, originalTransform);
  return exactResult;
};
protoOf(PlacementService).snapToTarget = function (entityToPlace, target, sortAndSelectStrategy, $super) {
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().t35_1 : sortAndSelectStrategy;
  return this.k4i(entityToPlace, target, sortAndSelectStrategy);
};
protoOf(PlacementService).l4i = function (entityToPlace, targets, sortAndSelectStrategy) {
  var originalTransform = get_worldTransform(entityToPlace);
  var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
  var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
  Companion_instance_8.z1l(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
  entityToPlace.addComponent(new RestrictAllowedRequiredHostsComponent(targets));
  var tmp;
  if (canAutoAdapt(this, entityToPlace)) {
    tmp = autoAdaptToTargets(this, entityToPlace, targets, sortAndSelectStrategy);
  } else {
    tmp = this.h4i_1.snapToTargets(entityToPlace, targets, sortAndSelectStrategy);
  }
  var result = tmp;
  var tmp1_elvis_lhs = result.placedEntity;
  (tmp1_elvis_lhs == null ? entityToPlace : tmp1_elvis_lhs).removeComponent(Companion_instance_7.id);
  return result;
};
protoOf(PlacementService).snapToTargets = function (entityToPlace, targets, sortAndSelectStrategy, $super) {
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().t35_1 : sortAndSelectStrategy;
  return this.l4i(entityToPlace, targets, sortAndSelectStrategy);
};
protoOf(PlacementService).alignToTarget = function (entityToPlace, target) {
  return this.h4i_1.alignToTarget(entityToPlace, target);
};
protoOf(PlacementService).alignToTargetSpecificConnectors = function (entityToPlace, entityAlignmentConnectorKey, target, targetAlignmentConnectorKey) {
  return this.h4i_1.alignToTarget(entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey);
};
protoOf(PlacementService).addToScene = function (entityToPlace) {
  this.e4i_1.entityManager.addComponent(entityToPlace, new ChildComponent(this.e4i_1.sceneManager.scene));
  return Companion_instance_115.z4h(entityToPlace);
};
protoOf(PlacementService).m4i = function (entityToPlace, position, rotationEulerDegrees) {
  var pos = position == null ? Companion_getInstance_15().ZERO : position;
  var rot = rotationEulerDegrees == null ? Companion_getInstance_15().ZERO : rotationEulerDegrees;
  this.e4i_1.entityManager.addComponent(entityToPlace, LocalTransformComponentFromPosAndRot(pos, Companion_getInstance_14().fromEulerDegreesVector(rot)));
  setParent(entityToPlace, this.e4i_1.sceneManager.scene);
};
protoOf(PlacementService).forcePlaceEntity = function (entityToPlace, position, rotationEulerDegrees, $super) {
  position = position === VOID ? null : position;
  rotationEulerDegrees = rotationEulerDegrees === VOID ? null : rotationEulerDegrees;
  return this.m4i(entityToPlace, position, rotationEulerDegrees);
};
protoOf(PlacementService).n4i = function (entityToPlace, target, sortAndSelectStrategy) {
  var originalTransform = get_worldTransform(entityToPlace);
  var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
  var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
  Companion_instance_8.z1l(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
  var exactResult = this.h4i_1.forceSnapToTarget(entityToPlace, target, sortAndSelectStrategy);
  if (exactResult.valid) {
    return exactResult;
  }
  var eligibleHosts = minus_0(hierarchyExceptSubTreesWithComponentSequence(target, Companion_getInstance().id), target);
  var _iterator__ex2g4s = eligibleHosts.k();
  while (_iterator__ex2g4s.m()) {
    var host = _iterator__ex2g4s.n();
    var result = this.h4i_1.forceSnapToTarget(entityToPlace, host, sortAndSelectStrategy);
    if (result.valid) {
      return result;
    }
  }
  Companion_instance_8.z1l(entityToPlace, originalTransform);
  return exactResult;
};
protoOf(PlacementService).forceSnapEntity = function (entityToPlace, target, sortAndSelectStrategy, $super) {
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().t35_1 : sortAndSelectStrategy;
  return this.n4i(entityToPlace, target, sortAndSelectStrategy);
};
protoOf(PlacementService).o4i = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) {
  Companion_instance_1.c1m(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey).performMoveAndConnect();
  if (get_parent(guestEntity) == null) {
    setParent(guestEntity, hostEntity);
  }
};
protoOf(PlacementService).forceSnapEntityWithConnectors = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey, $super) {
  connectorOnHostKey = connectorOnHostKey === VOID ? '' : connectorOnHostKey;
  connectorOnGuestKey = connectorOnGuestKey === VOID ? '' : connectorOnGuestKey;
  return this.o4i(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
};
protoOf(PlacementService).snapToConnector = function (guestEntity, guestConnectorKey, hostEntity, hostConnectorKey) {
  var tmp = get_hierarchySequence(guestEntity);
  var guestConnector = firstOrNull(mapNotNull(tmp, PlacementService$snapToConnector$lambda(guestConnectorKey)));
  var tmp_0 = get_hierarchySequence(hostEntity);
  var hostConnector = firstOrNull(mapNotNull(tmp_0, PlacementService$snapToConnector$lambda_0(hostConnectorKey)));
  var tmp_1;
  if (!(hostConnector == null) && !(guestConnector == null)) {
    tmp_1 = this.h4i_1.snapToConnector(guestEntity, guestConnector, hostEntity, hostConnector);
  } else if (guestConnector == null) {
    tmp_1 = Companion_instance_115.a4i('guestEntity ' + guestEntity.toString() + ' has no connector with key ' + guestConnectorKey, '', null);
  } else if (hostConnector == null) {
    tmp_1 = Companion_instance_115.a4i('hostEntity ' + hostEntity.toString() + ' has no connector with key ' + hostConnectorKey, '', null);
  } else {
    tmp_1 = Companion_instance_115.a4i('guestEntity ' + guestEntity.toString() + ' has no connector with key ' + guestConnectorKey + ' and hostEntity ' + hostEntity.toString() + ' has no connector with key ' + hostConnectorKey, '', null);
  }
  return tmp_1;
};
protoOf(PlacementService).dissolveEntity = function (dissolvingEntity) {
  var dissolvingEntityParent = get_parent(dissolvingEntity);
  if (dissolvingEntityParent == null) {
    var tmp = get_logger();
    tmp.warn(PlacementService$dissolveEntity$lambda);
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  var dissolvingEntityDescendants = get_immediateConnectionRootDescendants(dissolvingEntity);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = dissolvingEntityDescendants.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.placement.PlacementService.dissolveEntity.<anonymous>' call
    Companion_instance.j29(element);
  }
  Companion_instance.k29(dissolvingEntity);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(dissolvingEntityDescendants, 10));
  var tmp0_iterator_0 = dissolvingEntityDescendants.k();
  while (tmp0_iterator_0.m()) {
    var item = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.placement.PlacementService.dissolveEntity.<anonymous>' call
    var tmp0_elvis_lhs = get_snapRoot(item);
    var entityRoot = tmp0_elvis_lhs == null ? item : tmp0_elvis_lhs;
    var candidates = Companion_instance_1.p1l(entityRoot, dissolvingEntityParent, new SnapSettings(true, false, true, true));
    var sortedCandidates = Companion_getInstance_4().s35_1.sortAndSelect(candidates);
    var result = this.e4i_1.validations.getFirstValidSnap(sortedCandidates);
    var tmp1_safe_receiver = result.snap;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.performMoveAndConnect();
    }
    var tmp$ret$1 = new PlacementResult(result.warnings, result.errors, item);
    destination.h(tmp$ret$1);
  }
  var results = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(results);
};
protoOf(PlacementService).replaceEntity = function (entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter) {
  return Companion_instance_136.p4i(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, this.e4i_1);
};
protoOf(PlacementService).fastReplaceEntity = function (entityToRemove, entityToAdd) {
  return Companion_instance_136.q4i(entityToRemove, entityToAdd, this.e4i_1);
};
protoOf(PlacementService).r4i = function (connectionRoot, partsMap, onReplace) {
  return Companion_getInstance_138().u4i(connectionRoot, partsMap, this.e4i_1, onReplace);
};
protoOf(PlacementService).replaceProductParts = function (connectionRoot, partsMap, onReplace, $super) {
  var tmp;
  if (onReplace === VOID) {
    tmp = PlacementService$replaceProductParts$lambda;
  } else {
    tmp = onReplace;
  }
  onReplace = tmp;
  return this.r4i(connectionRoot, partsMap, onReplace);
};
function recommendedPosition(_this__u8e3s4, originalPosition) {
  _init_properties_PlacementService_kt__rip640();
  var result = null;
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_121().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    result = originalPosition.copy(VOID, tmp0_safe_receiver.offsetY);
  }
  if (_this__u8e3s4.__getComponentForKotlin(Companion_getInstance_122().id) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp = get_logger();
    tmp.warn(recommendedPosition$lambda);
  }
  return result;
}
function recommendedPosition$lambda() {
  _init_properties_PlacementService_kt__rip640();
  return 'PositionFromParent is not yet implemented';
}
var properties_initialized_PlacementService_kt_qk8kha;
function _init_properties_PlacementService_kt__rip640() {
  if (!properties_initialized_PlacementService_kt_qk8kha) {
    properties_initialized_PlacementService_kt_qk8kha = true;
    logger = LoggerState_getInstance().g1v('PlacementService');
  }
}
function Companion_77() {
  Companion_instance_116 = this;
  this.id = Companion_instance_0.b1p_1;
}
protoOf(Companion_77).n1s = function () {
  return this.id;
};
var Companion_instance_116;
function Companion_getInstance_120() {
  if (Companion_instance_116 == null)
    new Companion_77();
  return Companion_instance_116;
}
function PlacementZoneByHeightComponent(minY, maxY) {
  Companion_getInstance_120();
  this.minY = minY;
  this.maxY = maxY;
  this.v4i_1 = Companion_instance_0.b1p_1;
}
protoOf(PlacementZoneByHeightComponent).w4i = function () {
  return this.minY;
};
protoOf(PlacementZoneByHeightComponent).x4i = function () {
  return this.maxY;
};
protoOf(PlacementZoneByHeightComponent).p1s = function () {
  return this.v4i_1;
};
protoOf(PlacementZoneByHeightComponent).eq = function (other) {
  var o = other instanceof PlacementZoneByHeightComponent ? other : THROW_CCE();
  return o.minY === this.minY && o.maxY === this.maxY;
};
protoOf(PlacementZoneByHeightComponent).tf = function () {
  return this.minY;
};
protoOf(PlacementZoneByHeightComponent).uf = function () {
  return this.maxY;
};
protoOf(PlacementZoneByHeightComponent).y4i = function (minY, maxY) {
  return new PlacementZoneByHeightComponent(minY, maxY);
};
protoOf(PlacementZoneByHeightComponent).copy = function (minY, maxY, $super) {
  minY = minY === VOID ? this.minY : minY;
  maxY = maxY === VOID ? this.maxY : maxY;
  return this.y4i(minY, maxY);
};
protoOf(PlacementZoneByHeightComponent).toString = function () {
  return 'PlacementZoneByHeightComponent(minY=' + this.minY + ', maxY=' + this.maxY + ')';
};
protoOf(PlacementZoneByHeightComponent).hashCode = function () {
  var result = this.minY;
  result = imul(result, 31) + this.maxY | 0;
  return result;
};
protoOf(PlacementZoneByHeightComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlacementZoneByHeightComponent))
    return false;
  var tmp0_other_with_cast = other instanceof PlacementZoneByHeightComponent ? other : THROW_CCE();
  if (!(this.minY === tmp0_other_with_cast.minY))
    return false;
  if (!(this.maxY === tmp0_other_with_cast.maxY))
    return false;
  return true;
};
function Companion_78() {
  Companion_instance_117 = this;
  this.id = Companion_instance_0.c1p_1;
}
protoOf(Companion_78).n1s = function () {
  return this.id;
};
protoOf(Companion_78).z4i = function (entity, defaultPosition) {
  var recommendedInitialPositionFromFloorComponent = entity.__getComponentForKotlin(this.id);
  var tmp;
  if (!(recommendedInitialPositionFromFloorComponent == null)) {
    tmp = defaultPosition.copy(VOID, recommendedInitialPositionFromFloorComponent.offsetY);
  } else {
    return defaultPosition;
  }
  return tmp;
};
var Companion_instance_117;
function Companion_getInstance_121() {
  if (Companion_instance_117 == null)
    new Companion_78();
  return Companion_instance_117;
}
function getOrDefault(entity, defaultPosition) {
  return Companion_getInstance_121().z4i(entity, defaultPosition);
}
function RecommendedInitialPositionFromFloorComponent(offsetY) {
  Companion_getInstance_121();
  this.offsetY = offsetY;
}
protoOf(RecommendedInitialPositionFromFloorComponent).a4j = function () {
  return this.offsetY;
};
protoOf(RecommendedInitialPositionFromFloorComponent).p1s = function () {
  return Companion_instance_0.c1p_1;
};
protoOf(RecommendedInitialPositionFromFloorComponent).eq = function (other) {
  var o = other instanceof RecommendedInitialPositionFromFloorComponent ? other : THROW_CCE();
  return o.offsetY === this.offsetY;
};
protoOf(RecommendedInitialPositionFromFloorComponent).tf = function () {
  return this.offsetY;
};
protoOf(RecommendedInitialPositionFromFloorComponent).z3m = function (offsetY) {
  return new RecommendedInitialPositionFromFloorComponent(offsetY);
};
protoOf(RecommendedInitialPositionFromFloorComponent).copy = function (offsetY, $super) {
  offsetY = offsetY === VOID ? this.offsetY : offsetY;
  return this.z3m(offsetY);
};
protoOf(RecommendedInitialPositionFromFloorComponent).toString = function () {
  return 'RecommendedInitialPositionFromFloorComponent(offsetY=' + this.offsetY + ')';
};
protoOf(RecommendedInitialPositionFromFloorComponent).hashCode = function () {
  return this.offsetY;
};
protoOf(RecommendedInitialPositionFromFloorComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecommendedInitialPositionFromFloorComponent))
    return false;
  var tmp0_other_with_cast = other instanceof RecommendedInitialPositionFromFloorComponent ? other : THROW_CCE();
  if (!(this.offsetY === tmp0_other_with_cast.offsetY))
    return false;
  return true;
};
function Companion_79() {
  Companion_instance_118 = this;
  this.id = Companion_instance_0.d1p_1;
}
protoOf(Companion_79).n1s = function () {
  return this.id;
};
var Companion_instance_118;
function Companion_getInstance_122() {
  if (Companion_instance_118 == null)
    new Companion_79();
  return Companion_instance_118;
}
function RecommendedInitialPositionFromParentComponent(referencePoint, offsetX, offsetY, offsetZ) {
  Companion_getInstance_122();
  this.referencePoint = referencePoint;
  this.offsetX = offsetX;
  this.offsetY = offsetY;
  this.offsetZ = offsetZ;
}
protoOf(RecommendedInitialPositionFromParentComponent).b4j = function () {
  return this.referencePoint;
};
protoOf(RecommendedInitialPositionFromParentComponent).c4j = function () {
  return this.offsetX;
};
protoOf(RecommendedInitialPositionFromParentComponent).a4j = function () {
  return this.offsetY;
};
protoOf(RecommendedInitialPositionFromParentComponent).d4j = function () {
  return this.offsetZ;
};
protoOf(RecommendedInitialPositionFromParentComponent).p1s = function () {
  return Companion_instance_0.d1p_1;
};
protoOf(RecommendedInitialPositionFromParentComponent).eq = function (other) {
  var o = other instanceof RecommendedInitialPositionFromParentComponent ? other : THROW_CCE();
  return o.referencePoint.equals(this.referencePoint) && o.offsetX == this.offsetX && o.offsetY == this.offsetY && o.offsetZ == this.offsetZ;
};
protoOf(RecommendedInitialPositionFromParentComponent).tf = function () {
  return this.referencePoint;
};
protoOf(RecommendedInitialPositionFromParentComponent).uf = function () {
  return this.offsetX;
};
protoOf(RecommendedInitialPositionFromParentComponent).m1m = function () {
  return this.offsetY;
};
protoOf(RecommendedInitialPositionFromParentComponent).n1m = function () {
  return this.offsetZ;
};
protoOf(RecommendedInitialPositionFromParentComponent).e4j = function (referencePoint, offsetX, offsetY, offsetZ) {
  return new RecommendedInitialPositionFromParentComponent(referencePoint, offsetX, offsetY, offsetZ);
};
protoOf(RecommendedInitialPositionFromParentComponent).copy = function (referencePoint, offsetX, offsetY, offsetZ, $super) {
  referencePoint = referencePoint === VOID ? this.referencePoint : referencePoint;
  offsetX = offsetX === VOID ? this.offsetX : offsetX;
  offsetY = offsetY === VOID ? this.offsetY : offsetY;
  offsetZ = offsetZ === VOID ? this.offsetZ : offsetZ;
  return this.e4j(referencePoint, offsetX, offsetY, offsetZ);
};
protoOf(RecommendedInitialPositionFromParentComponent).toString = function () {
  return 'RecommendedInitialPositionFromParentComponent(referencePoint=' + this.referencePoint.toString() + ', offsetX=' + this.offsetX + ', offsetY=' + this.offsetY + ', offsetZ=' + this.offsetZ + ')';
};
protoOf(RecommendedInitialPositionFromParentComponent).hashCode = function () {
  var result = this.referencePoint.hashCode();
  result = imul(result, 31) + (this.offsetX == null ? 0 : this.offsetX) | 0;
  result = imul(result, 31) + (this.offsetY == null ? 0 : this.offsetY) | 0;
  result = imul(result, 31) + (this.offsetZ == null ? 0 : this.offsetZ) | 0;
  return result;
};
protoOf(RecommendedInitialPositionFromParentComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecommendedInitialPositionFromParentComponent))
    return false;
  var tmp0_other_with_cast = other instanceof RecommendedInitialPositionFromParentComponent ? other : THROW_CCE();
  if (!this.referencePoint.equals(tmp0_other_with_cast.referencePoint))
    return false;
  if (!(this.offsetX == tmp0_other_with_cast.offsetX))
    return false;
  if (!(this.offsetY == tmp0_other_with_cast.offsetY))
    return false;
  if (!(this.offsetZ == tmp0_other_with_cast.offsetZ))
    return false;
  return true;
};
function getNewPositionToTheSide($this, otherAabb, candidate, ownAabb, direction) {
  var tmp;
  if (direction.equals(Companion_getInstance_15().LEFT) || direction.equals(Companion_getInstance_15().RIGHT)) {
    var dist = otherAabb.center.X + direction.normalize().X * (otherAabb.size.X * 0.5 + ownAabb.size.X * 0.5) - ownAabb.center.X;
    var hostConnectorWorldSpaceRot = get_worldRotation(candidate.host).times(candidate.hostConnector.transform.rotation);
    var tmp_0 = direction.rotate(hostConnectorWorldSpaceRot);
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp$ret$0 = Math.abs(dist);
    var movement = tmp_0.times(tmp$ret$0);
    tmp = candidate.endTransform.position.plus(movement);
  } else if (direction.equals(Companion_getInstance_15().UP) || direction.equals(Companion_getInstance_15().DOWN)) {
    tmp = candidate.endTransform.position.plus(new Vector(VOID, otherAabb.center.Y + direction.normalize().Y * (otherAabb.size.Y * 0.5 + ownAabb.size.Y * 0.5) - ownAabb.center.Y));
  } else {
    tmp = candidate.endTransform.position.plus(new Vector(VOID, VOID, otherAabb.center.Z + direction.normalize().Z * (otherAabb.size.Z * 0.5 + ownAabb.size.Z * 0.5) - ownAabb.center.Z));
  }
  return tmp;
}
function SearchDirectionsUtils() {
}
protoOf(SearchDirectionsUtils).f4j = function (entity, candidate, collisionValidationResult, searchDirections, prioritizeSolvingRoomCollisions) {
  candidate.performMove();
  var tmp0_elvis_lhs = get_axisAlignedBoundingBoxForHierarchy(entity);
  var ownAabb = tmp0_elvis_lhs == null ? new AxisAlignedBox(Companion_getInstance_15().ZERO, Companion_getInstance_15().ZERO) : tmp0_elvis_lhs;
  candidate.rollbackMove();
  var tmp;
  if (prioritizeSolvingRoomCollisions) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = collisionValidationResult.collisions;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
        if (get_isRoomPart(element.other)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.max' call
    var a = ownAabb.width;
    var b = ownAabb.height;
    var a_0 = Math.max(a, b);
    var b_0 = ownAabb.depth;
    var largest = Math.max(a_0, b_0);
    var hostConnectorWorldSpaceRot = get_worldRotation(candidate.host).times(candidate.hostConnector.transform.rotation);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(searchDirections.length);
    var inductionVariable_0 = 0;
    var last_0 = searchDirections.length;
    while (inductionVariable_0 < last_0) {
      var item = searchDirections[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
      var tmp$ret$4 = candidate.endTransform.position.plus(item.normalize().rotate(hostConnectorWorldSpaceRot).times(largest).times(0.5));
      destination.h(tmp$ret$4);
    }
    var newPositions = destination;
    return newPositions;
  }
  var otherAabb = collisionValidationResult.aabbOfAllCollidedWith;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(searchDirections.length);
  var inductionVariable_1 = 0;
  var last_1 = searchDirections.length;
  while (inductionVariable_1 < last_1) {
    var item_0 = searchDirections[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
    var tmp$ret$7 = getNewPositionToTheSide(SearchDirectionsUtils_instance, otherAabb, candidate, ownAabb, item_0);
    destination_0.h(tmp$ret$7);
  }
  return destination_0;
};
var SearchDirectionsUtils_instance;
function SearchDirectionsUtils_getInstance() {
  return SearchDirectionsUtils_instance;
}
function Companion_80() {
}
protoOf(Companion_80).fromSnapValidationResult = function (snapValidationResult) {
  return new CandidateResult(snapValidationResult.snap, snapValidationResult.errorsAndWarnings);
};
var Companion_instance_119;
function Companion_getInstance_123() {
  return Companion_instance_119;
}
function findBestCandidatesInTarget($this, entityToPlace, target, snaps, sortAndSelectStrategy) {
  var result = $this.findBestCandidateAndSnap(entityToPlace, snaps, true);
  var tmp;
  if (!result.valid) {
    var tmp_0 = get_worldPosition(entityToPlace);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [Companion_getInstance_15().LEFT, Companion_getInstance_15().RIGHT, Companion_getInstance_15().UP, Companion_getInstance_15().DOWN, Companion_getInstance_15().BACK, Companion_getInstance_15().FORWARD];
    tmp = $this.snapToHostFromPosition(entityToPlace, target, tmp_0, true, tmp$ret$2, sortAndSelectStrategy);
  } else {
    tmp = result;
  }
  return tmp;
}
function getSnapActionCandidates($this, snappingGuestEntity, target, sortAndSelectStrategy) {
  var tmp;
  if (snappingGuestEntity == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getSnapActionCandidates.<anonymous>' call
    tmp = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.p1l(snappingGuestEntity, target, $this.snapSettings));
  }
  return tmp;
}
function getSnappingEntity($this, entityToAdd) {
  var tmp0_elvis_lhs = get_snapRoot(entityToAdd);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = get_parentComponent(entityToAdd);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.first' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getSnappingEntity.<anonymous>' call
          if (!(get_connectorsComponent(element) == null)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
      }
      tmp_0 = tmp$ret$1;
    }
    var tmp3_safe_receiver = tmp_0;
    tmp = tmp3_safe_receiver == null ? null : get_snapRoot(tmp3_safe_receiver);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findBestSnap($this, snaps, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (snaps.length === 0) {
    return failDueToNoSnaps($this, addedEntity);
  }
  $this.g4j_1.addComponent(addedEntity, new SnapCandidateComponent());
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(snaps.length);
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var item = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestSnap.<anonymous>' call
    var tmp$ret$1 = validate_1($this, item, $this.i4j_1);
    destination.h(tmp$ret$1);
  }
  var validatedCandidates = destination;
  var bestSoFar = null;
  var _iterator__ex2g4s = validatedCandidates.k();
  while (_iterator__ex2g4s.m()) {
    var cr = _iterator__ex2g4s.n();
    if (cr.valid()) {
      bestSoFar = best($this, cr, bestSoFar, sortAndSelectStrategy, sortByWarnings);
    } else if (cr.candidate.hostConnector.isContinuousConnector && cr.candidate.alignmentInitiatorCandidate == null) {
      bestSoFar = findBestValidPositionOnConnector$default($this, validatedCandidates, bestSoFar, listOf(cr), addedEntity, cr.candidate, searchDirections, $this.i4j_1, sortAndSelectStrategy, sortByWarnings);
    }
  }
  var tmp;
  if (!(bestSoFar == null)) {
    var warnings = bestSoFar.results;
    tmp = performSnapAction($this, addedEntity, bestSoFar.candidate, warnings);
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = validatedCandidates.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestSnap.<anonymous>' call
      var list = toList(element.results);
      addAll(destination_0, list);
    }
    var allResults = copyToArray(destination_0);
    tmp = performSnapAction($this, addedEntity, null, allResults);
  }
  var placementResult = tmp;
  $this.g4j_1.removeComponent(addedEntity, Companion_instance_22.id);
  return placementResult;
}
function validate_1($this, candidate, validationService) {
  var candidateResult = Companion_instance_119.fromSnapValidationResult(validationService.validateSnapCandidate(candidate));
  return candidateResult;
}
function getAlignmentCandidatesThatResolvesCollision($this, candidates, failedCandidateResult) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = failedCandidateResult.results;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getAlignmentCandidatesThatResolvesCollision.<anonymous>' call
    if (element instanceof CollisionValidationResult) {
      var tmp0_safe_receiver = firstOrNull_0(element.collisions);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.other;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = candidates.k();
        while (tmp0_iterator.m()) {
          var element_0 = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getAlignmentCandidatesThatResolvesCollision.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          var tmp0_safe_receiver_0 = element_0.candidate.alignmentInitiatorCandidate;
          if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.host, tmp1_safe_receiver)) {
            tmp = element_0.valid();
          } else {
            tmp = false;
          }
          if (tmp) {
            destination.h(element_0);
          }
        }
        return destination;
      }
    }
  }
  return emptyList();
}
function CandidateResult(candidate, results) {
  this.candidate = candidate;
  this.results = results;
  this.j4j_1 = 0;
}
protoOf(CandidateResult).k4j = function () {
  return this.candidate;
};
protoOf(CandidateResult).l4j = function () {
  return this.results;
};
protoOf(CandidateResult).valid = function () {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.none' call
    var indexedObject = this.results;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.CandidateResult.valid.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
};
protoOf(CandidateResult).countWarnings = function () {
  // Inline function 'kotlin.collections.count' call
  var count = 0;
  var indexedObject = this.results;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.CandidateResult.countWarnings.<anonymous>' call
    if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
      count = count + 1 | 0;
    }
  }
  return count;
};
protoOf(CandidateResult).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof CandidateResult))
    THROW_CCE();
  if (!equals(this.candidate, other.candidate))
    return false;
  return true;
};
protoOf(CandidateResult).hashCode = function () {
  if (this.j4j_1 === 0)
    this.j4j_1 = hashCode(this.candidate);
  return this.j4j_1;
};
protoOf(CandidateResult).tf = function () {
  return this.candidate;
};
protoOf(CandidateResult).uf = function () {
  return this.results;
};
protoOf(CandidateResult).f3h = function (candidate, results) {
  return new CandidateResult(candidate, results);
};
protoOf(CandidateResult).copy = function (candidate, results, $super) {
  candidate = candidate === VOID ? this.candidate : candidate;
  results = results === VOID ? this.results : results;
  return this.f3h(candidate, results);
};
protoOf(CandidateResult).toString = function () {
  return 'CandidateResult(candidate=' + this.candidate.toString() + ', results=' + toString(this.results) + ')';
};
function findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level) {
  if (level >= Companion_getInstance_124().MAX_SEARCH_LVL_SNAP_TO_SCENE) {
    var tmp = Companion_getInstance_124().logger;
    tmp.info(SnapPlacementActor$findBestValidPositionOnConnector$lambda(level));
    return bestSoFar;
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = failed.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    var list = getAlignmentCandidatesThatResolvesCollision($this, validatedCandidates, element);
    addAll(destination, list);
  }
  var validAlignments = destination;
  var localBest = null;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = validAlignments.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    localBest = best($this, element_0, localBest, sortAndSelectStrategy, sortByWarnings);
  }
  var tmp0_safe_receiver = localBest;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return best($this, tmp0_safe_receiver, bestSoFar, sortAndSelectStrategy, sortByWarnings);
  }
  var initialTransform = get_worldTransform(entityToAdd);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator_1 = failed.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    var list_0 = findNewPositionThatMightSatisfyFailedResult($this, element_1, entityToAdd, searchDirections, level);
    addAll(destination_0, list_0);
  }
  // Inline function 'kotlin.collections.filterNotTo' call
  var this_0 = distinct(destination_0);
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_2 = this_0.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    if (!triedPositions.s(element_2)) {
      destination_1.h(element_2);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_3 = destination_1.k();
  while (tmp0_iterator_3.m()) {
    var element_3 = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    if (bestSoFar == null || initialTransform.position.distanceTo(element_3) < bestSoFar.candidate.movement.size) {
      destination_2.h(element_3);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$();
  var tmp0_iterator_4 = destination_2.k();
  while (tmp0_iterator_4.m()) {
    var element_4 = tmp0_iterator_4.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    if (Companion_instance_1.isNewPositionOnHostConnector(candidate, element_4)) {
      destination_3.h(element_4);
    }
  }
  var newPositions = destination_3;
  if (newPositions.r() && !(bestSoFar == null)) {
    return bestSoFar;
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newPositions, 10));
  var tmp0_iterator_5 = newPositions.k();
  while (tmp0_iterator_5.m()) {
    var item = tmp0_iterator_5.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    var newCandidate = Companion_instance_1.createCandidate(candidate.guest, candidate.guestConnector, candidate.host, candidate.hostConnector, candidate.endTransform.copy(item), VOID, VOID, initialTransform);
    var tmp$ret$16 = validate_1($this, newCandidate, validationService);
    destination_4.h(tmp$ret$16);
  }
  var newResults = destination_4;
  localBest = null;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_5 = ArrayList_init_$Create$();
  var tmp0_iterator_6 = newResults.k();
  while (tmp0_iterator_6.m()) {
    var element_5 = tmp0_iterator_6.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    if (element_5.valid()) {
      destination_5.h(element_5);
    }
  }
  var tmp0_iterator_7 = destination_5.k();
  while (tmp0_iterator_7.m()) {
    var element_6 = tmp0_iterator_7.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
    localBest = best($this, element_6, localBest, sortAndSelectStrategy, sortByWarnings);
  }
  var tmp1_safe_receiver = localBest;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return best($this, tmp1_safe_receiver, bestSoFar, sortAndSelectStrategy, sortByWarnings);
  }
  return findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, newResults, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, plus_2(triedPositions, newPositions), level + 1 | 0);
}
function findBestValidPositionOnConnector$default($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level, $super) {
  triedPositions = triedPositions === VOID ? emptyList() : triedPositions;
  level = level === VOID ? 0 : level;
  return findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level);
}
function findNewPositionThatMightSatisfyFailedResult($this, failed, entityToAdd, searchDirections, level) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = failed.results;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findNewPositionThatMightSatisfyFailedResult.<anonymous>' call
    var tmp;
    if (element instanceof CollisionValidationResult) {
      tmp = SearchDirectionsUtils_instance.f4j(entityToAdd, failed.candidate, element, searchDirections, level === 0);
    } else {
      tmp = emptyList();
    }
    var list = tmp;
    addAll(destination, list);
  }
  return destination;
}
function best($this, candidate, bestSoFar, sortAndSelectStrategy, sortByWarnings) {
  if (!candidate.valid())
    return bestSoFar;
  if (bestSoFar == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (sortByWarnings && candidate.countWarnings() < bestSoFar.countWarnings()) {
      tmp = candidate;
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [bestSoFar.candidate, candidate.candidate];
      var first = firstOrNull_0(sortAndSelectStrategy.sortAndSelect(tmp$ret$2));
      tmp = equals(first, candidate.candidate) ? candidate : bestSoFar;
    }
    return tmp;
  }
  return candidate;
}
function moveToPosition($this, entity, position) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var snapRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  if (snapRoot.equals(entity)) {
    Companion_instance_8.z1l(entity, new Transform(position, get_worldRotation(entity)));
  } else {
    var delta = position.minus(get_worldPosition(entity));
    Companion_instance_8.z1l(snapRoot, new Transform(get_worldPosition(snapRoot).plus(delta), get_worldRotation(snapRoot)));
  }
}
function failDueToNoSnaps($this, entity) {
  return Companion_instance_115.a4i('Found no snaps', get_productRefOrEmptyString(entity), null);
}
function performSnapAction($this, entity, snap, results) {
  if (snap == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    snap.performMoveAndConnect();
    var tmp;
    if (any(results)) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      tmp = new PlacementResult(results, tmp$ret$0, snap.guest);
    } else {
      tmp = Companion_instance_115.z4h(entity);
    }
    return tmp;
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = results.length;
  while (inductionVariable < last) {
    var element = results[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.performSnapAction.<anonymous>' call
    if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
      destination.h(element);
    }
  }
  var errors = copyToArray(destination);
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(errors.length === 0)) {
    tmp_0 = Companion_instance_115.b4i(errors);
  } else {
    tmp_0 = failDueToNoSnaps($this, entity);
  }
  return tmp_0;
}
function Companion_81() {
  Companion_instance_120 = this;
  this.MAX_SEARCH_LVL_SNAP_TO_SCENE = 5;
  this.logger = LoggerState_getInstance().g1v('SnapPlacementActor');
}
protoOf(Companion_81).m4j = function () {
  return this.MAX_SEARCH_LVL_SNAP_TO_SCENE;
};
protoOf(Companion_81).l1k = function () {
  return this.logger;
};
var Companion_instance_120;
function Companion_getInstance_124() {
  if (Companion_instance_120 == null)
    new Companion_81();
  return Companion_instance_120;
}
function SnapPlacementActor$snapToTargets$lambda(this$0, $entityToPlace, $snaps, $sortAndSelectStrategy) {
  return function (target) {
    return findBestCandidatesInTarget(this$0, $entityToPlace, target, $snaps, $sortAndSelectStrategy);
  };
}
function SnapPlacementActor$findBestValidPositionOnConnector$lambda($level) {
  return function () {
    return 'Reached too deep (lvl: ' + $level + ') when searching for non colliding placement';
  };
}
function SnapPlacementActor(entityManager, sceneManager, validationService) {
  Companion_getInstance_124();
  this.g4j_1 = entityManager;
  this.h4j_1 = sceneManager;
  this.i4j_1 = validationService;
  this.snapSettings = new SnapSettings(true, false, false, true);
}
protoOf(SnapPlacementActor).n4j = function () {
  return this.snapSettings;
};
protoOf(SnapPlacementActor).o4j = function (entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = Companion_instance_1.i3e(entityToPlace, this.h4j_1, this.snapSettings);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    if (element.hostConnector.isContinuousConnector) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    if (element_0.guestConnector.type === Companion_instance_6.l2b_1) {
      destination_0.h(element_0);
    }
  }
  var continuousCandidates = copyToArray(destination_0);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = Companion_instance_1.d3e(entityToPlace, target, this.snapSettings);
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = this_1.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    if (element_1.guestConnector.type === Companion_instance_6.n2b_1) {
      destination_1.h(element_1);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_1 = destination_1.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    if (entityAlignmentConnectorKey == null || element_2.guestConnector.key === entityAlignmentConnectorKey) {
      destination_2.h(element_2);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$();
  var tmp0_iterator_2 = destination_2.k();
  while (tmp0_iterator_2.m()) {
    var element_3 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    if (targetAlignmentConnectorKey == null || element_3.hostConnector.key === targetAlignmentConnectorKey) {
      destination_3.h(element_3);
    }
  }
  var alignmentCandidates = toList_0(destination_3);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_4 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_3 = alignmentCandidates.k();
  while (tmp0_iterator_3.m()) {
    var element_4 = tmp0_iterator_3.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
    var tmp0_safe_receiver = Companion_instance_1.k3e(element_4, continuousCandidates);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_4.h(tmp0_safe_receiver);
    }
  }
  var foundAlignedCandidates = copyToArray(destination_4);
  this.g4j_1.addComponent(entityToPlace, new SnapCandidateComponent());
  var _destruct__k2r9zo = this.i4j_1.getFirstValidSnap(foundAlignedCandidates, true);
  var candidate = _destruct__k2r9zo.tf();
  var results = _destruct__k2r9zo.uf();
  var placementResult = performSnapAction(this, entityToPlace, candidate, results);
  this.g4j_1.removeComponent(entityToPlace, Companion_instance_22.id);
  return placementResult;
};
protoOf(SnapPlacementActor).alignToTarget = function (entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey, $super) {
  entityAlignmentConnectorKey = entityAlignmentConnectorKey === VOID ? null : entityAlignmentConnectorKey;
  targetAlignmentConnectorKey = targetAlignmentConnectorKey === VOID ? null : targetAlignmentConnectorKey;
  return this.o4j(entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey);
};
protoOf(SnapPlacementActor).snapToTarget = function (entityToPlace, target, sortAndSelectStrategy) {
  var snappingGuestEntity = getSnappingEntity(this, entityToPlace);
  var tmp0_elvis_lhs = getSnapActionCandidates(this, snappingGuestEntity, target, sortAndSelectStrategy);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snaps = tmp;
  return findBestCandidatesInTarget(this, entityToPlace, target, snaps, sortAndSelectStrategy);
};
protoOf(SnapPlacementActor).forceSnapToTarget = function (entity, target, sortAndSelectStrategy) {
  var snappingGuestEntity = getSnappingEntity(this, entity);
  var tmp0_safe_receiver = getSnapActionCandidates(this, snappingGuestEntity, target, sortAndSelectStrategy);
  var snap = tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  if (snap == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    this.g4j_1.addComponent(entity, new SnapCandidateComponent());
    if (get_parent(entity) == null) {
      this.g4j_1.addComponent(entity, new ChildComponent(this.h4j_1.scene));
    }
    snap.performMoveAndConnect();
    this.g4j_1.removeComponent(entity, Companion_instance_22.id);
    return Companion_instance_115.z4h(entity);
  }
  return Companion_instance_115.a4i('No possible snapActions in target', get_productRefOrEmptyString(entity), null);
};
protoOf(SnapPlacementActor).snapToTargets = function (entityToPlace, targets, sortAndSelectStrategy) {
  var tmp0_elvis_lhs = getSnappingEntity(this, entityToPlace);
  var snappingGuestEntity = tmp0_elvis_lhs == null ? entityToPlace : tmp0_elvis_lhs;
  var snaps = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.p39(snappingGuestEntity, targets, new SnapSettings(true, false, true, true)));
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'com.ikea.core.utils.otherwise' call
    // Inline function 'kotlin.sequences.find' call
    var tmp = asSequence_0(targets);
    var this_0 = map(tmp, SnapPlacementActor$snapToTargets$lambda(this, entityToPlace, snaps, sortAndSelectStrategy));
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.snapToTargets.<anonymous>' call
        if (element.valid) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var this_1 = tmp$ret$1;
    if (this_1 == null) {
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.snapToTargets.<anonymous>' call
      tmp$ret$4 = Companion_instance_115.a4i('No valid snap for entity', get_productRefOrEmptyString(entityToPlace), null);
      break $l$block_0;
    }
    tmp$ret$4 = this_1;
  }
  return tmp$ret$4;
};
protoOf(SnapPlacementActor).p4j = function (addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy) {
  moveToPosition(this, addedEntity, initialPosition);
  var tmp0_elvis_lhs = get_snapRoot(addedEntity);
  var snappingGuestEntity = tmp0_elvis_lhs == null ? addedEntity : tmp0_elvis_lhs;
  var snaps = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.i3e(snappingGuestEntity, this.h4j_1, this.snapSettings));
  return findBestSnap(this, snaps, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections);
};
protoOf(SnapPlacementActor).snapToSceneFromPosition = function (addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy, $super) {
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().r35_1 : sortAndSelectStrategy;
  return this.p4j(addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy);
};
protoOf(SnapPlacementActor).q4j = function (addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy) {
  moveToPosition(this, addedEntity, initialPosition);
  var tmp0_elvis_lhs = get_snapRoot(addedEntity);
  var snappingGuestEntity = tmp0_elvis_lhs == null ? addedEntity : tmp0_elvis_lhs;
  var snaps = sortAndSelectStrategy.sortAndSelect(Companion_instance_1.p1l(snappingGuestEntity, target, this.snapSettings));
  return findBestSnap(this, snaps, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections);
};
protoOf(SnapPlacementActor).snapToHostFromPosition = function (addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy, $super) {
  sortAndSelectStrategy = sortAndSelectStrategy === VOID ? Companion_getInstance_4().r35_1 : sortAndSelectStrategy;
  return this.q4j(addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy);
};
protoOf(SnapPlacementActor).findBestCandidateAndSnap = function (entity, snaps, sortByWarnings) {
  if (snaps == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    this.g4j_1.addComponent(entity, new SnapCandidateComponent());
    var res = this.i4j_1.getFirstValidSnap(snaps, sortByWarnings);
    // Inline function 'kotlin.collections.plus' call
    var this_0 = res.errors;
    var elements = res.warnings;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this_0.concat(elements);
    var placementResult = performSnapAction(this, entity, res.snap, tmp$ret$1);
    this.g4j_1.removeComponent(entity, Companion_instance_22.id);
    return placementResult;
  }
  return failDueToNoSnaps(this, entity);
};
protoOf(SnapPlacementActor).snapToConnector = function (guestEntity, guestConnector, hostEntity, hostConnector) {
  var snap = Companion_instance_1.f30(guestEntity, guestConnector, hostEntity, hostConnector);
  var tmp;
  if (!(snap == null)) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [snap];
    tmp = this.findBestCandidateAndSnap(guestEntity, tmp$ret$2, true);
  } else {
    tmp = failDueToNoSnaps(this, guestEntity);
  }
  return tmp;
};
function DistanceCriterion() {
  SortCriterionBase.call(this);
}
protoOf(DistanceCriterion).r4j = function (a, b) {
  var tmp;
  if (a.movement.size < b.movement.size) {
    tmp = 1;
  } else if (a.movement.size > b.movement.size) {
    tmp = -1;
  } else {
    tmp = 0;
  }
  return tmp;
};
function FilterCriterion() {
}
function InActivationDistanceFilter() {
}
protoOf(InActivationDistanceFilter).filterCandidates = function (candidates) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = candidates.length;
  while (inductionVariable < last) {
    var element = candidates[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.snapsorting.InActivationDistanceFilter.filterCandidates.<anonymous>' call
    if (this.filterCandidate(element)) {
      destination.h(element);
    }
  }
  return copyToArray(destination);
};
protoOf(InActivationDistanceFilter).filterCandidate = function (candidate) {
  return (candidate == null ? null : candidate.inActivationDistance()) === true;
};
function OriginalVariantCriterion() {
  SortCriterionBase.call(this);
}
protoOf(OriginalVariantCriterion).r4j = function (a, b) {
  var tmp;
  if (get_hasAutoAdapted(a.guestRoot) === get_hasAutoAdapted(b.guestRoot)) {
    tmp = 0;
  } else if (!get_hasAutoAdapted(a.guestRoot)) {
    tmp = 1;
  } else {
    tmp = -1;
  }
  return tmp;
};
function PriorityCriterionSettings$Companion$all$1() {
  this.s4j_1 = false;
}
protoOf(PriorityCriterionSettings$Companion$all$1).t4j = function () {
  return this.s4j_1;
};
function PriorityCriterionSettings$Companion$onlyInActivationDistance$1() {
  this.u4j_1 = true;
}
protoOf(PriorityCriterionSettings$Companion$onlyInActivationDistance$1).t4j = function () {
  return this.u4j_1;
};
function Companion_82() {
  Companion_instance_121 = this;
  var tmp = this;
  tmp.r3w_1 = new PriorityCriterionSettings$Companion$all$1();
  var tmp_0 = this;
  tmp_0.s3w_1 = new PriorityCriterionSettings$Companion$onlyInActivationDistance$1();
}
var Companion_instance_121;
function Companion_getInstance_125() {
  if (Companion_instance_121 == null)
    new Companion_82();
  return Companion_instance_121;
}
function PriorityCriterionSettings() {
}
function PriorityCriterion(settings) {
  SortCriterionBase.call(this);
  this.v4j_1 = settings;
}
protoOf(PriorityCriterion).r4j = function (a, b) {
  var tmp;
  if (a.inActivationDistance() || !this.v4j_1.onlyInActivationDistance) {
    tmp = a.priority;
  } else {
    tmp = -2147483648;
  }
  var aPrio = tmp;
  var tmp_0;
  if (b.inActivationDistance() || !this.v4j_1.onlyInActivationDistance) {
    tmp_0 = b.priority;
  } else {
    tmp_0 = -2147483648;
  }
  var bPrio = tmp_0;
  return compareTo(aPrio, bPrio);
};
function recommendationDistance_0($this, candidate) {
  var result = 0.0;
  var tmp0_safe_receiver = candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_121().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
    result = Math.abs(this_0);
  }
  if (candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_122().id) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.w4j_1.warn(RecommendedDistanceFromFloorCriterion$recommendationDistance$lambda);
  }
  return result;
}
function RecommendedDistanceFromFloorCriterion$recommendationDistance$lambda() {
  return 'PositionFromParent is not yet implemented';
}
function RecommendedDistanceFromFloorCriterion() {
  SortCriterionBase.call(this);
  this.w4j_1 = LoggerState_getInstance().g1v('RecommendedDistanceCriterion');
}
protoOf(RecommendedDistanceFromFloorCriterion).r4j = function (a, b) {
  var aDist = recommendationDistance_0(this, a);
  var bDist = recommendationDistance_0(this, b);
  return compareTo(bDist, aDist);
};
function SnapSorter_init_$Init$(sortCriteria, filters, $this) {
  SnapSorter.call($this);
  $this.x4j_1 = sortCriteria;
  $this.y4j_1 = filters;
  return $this;
}
function SnapSorter_init_$Create$(sortCriteria, filters) {
  return SnapSorter_init_$Init$(sortCriteria, filters, objectCreate(protoOf(SnapSorter)));
}
function bestResult($this, a, b) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var tmp0_iterator = $this.x4j_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>' call
      var result = element.bestResult(a, b);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var best = tmp$ret$1;
  return best;
}
function bestCandidate($this, a, b) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var tmp0_iterator = $this.x4j_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>' call
      var result = element.bestCandidate(a, b);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function sam$kotlin_Comparator$0_5(function_0) {
  this.z4j_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_5).md = function (a, b) {
  return this.z4j_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).s3 = function () {
  return this.z4j_1;
};
protoOf(sam$kotlin_Comparator$0_5).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_5).hashCode = function () {
  return hashCode(this.s3());
};
function sam$kotlin_Comparator$0_6(function_0) {
  this.a4k_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_6).md = function (a, b) {
  return this.a4k_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).s3 = function () {
  return this.a4k_1;
};
protoOf(sam$kotlin_Comparator$0_6).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_6).hashCode = function () {
  return hashCode(this.s3());
};
function SnapSorter$sortResults$lambda(this$0) {
  return function (a, b) {
    var best = bestResult(this$0, a, b);
    var tmp;
    if (best == null) {
      tmp = 0;
    } else if (equals(best, a)) {
      tmp = -1;
    } else {
      tmp = 1;
    }
    return tmp;
  };
}
function SnapSorter$sortCandidates$lambda(this$0) {
  return function (a, b) {
    var best = bestCandidate(this$0, a, b);
    var tmp;
    if (best == null) {
      tmp = 0;
    } else if (equals(best, a)) {
      tmp = -1;
    } else {
      tmp = 1;
    }
    return tmp;
  };
}
protoOf(SnapSorter).filterResults = function (results) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = results.length;
  while (inductionVariable < last) {
    var element = results[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterResults.<anonymous>' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = this.y4j_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterResults.<anonymous>.<anonymous>' call
        if (!element_0.filterCandidate(element.snap)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      destination.h(element);
    }
  }
  return copyToArray(destination);
};
protoOf(SnapSorter).filterCandidates = function (snapCandidates) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = snapCandidates.length;
  while (inductionVariable < last) {
    var element = snapCandidates[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterCandidates.<anonymous>' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = this.y4j_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterCandidates.<anonymous>.<anonymous>' call
        if (!element_0.filterCandidate(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      destination.h(element);
    }
  }
  return copyToArray(destination);
};
protoOf(SnapSorter).sortResults = function (results) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp = this.filterResults(results);
  var tmp_0 = SnapSorter$sortResults$lambda(this);
  var this_0 = sortedWith_0(tmp, new sam$kotlin_Comparator$0_5(tmp_0));
  return copyToArray(this_0);
};
protoOf(SnapSorter).sortCandidates = function (snapCandidates) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp = this.filterCandidates(snapCandidates);
  var tmp_0 = SnapSorter$sortCandidates$lambda(this);
  var this_0 = sortedWith_0(tmp, new sam$kotlin_Comparator$0_6(tmp_0));
  return copyToArray(this_0);
};
protoOf(SnapSorter).bestCandidate = function (snapCandidates) {
  var bestSoFar = null;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = snapCandidates.length;
  while (inductionVariable < last) {
    var element = snapCandidates[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>' call
    var tmp0_safe_receiver = bestSoFar;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>.<anonymous>' call
      tmp = bestCandidate(this, tmp0_safe_receiver, element);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? bestSoFar : tmp1_elvis_lhs;
    bestSoFar = tmp2_elvis_lhs == null ? element : tmp2_elvis_lhs;
  }
  return bestSoFar;
};
protoOf(SnapSorter).bestResult = function (results) {
  var bestSoFar = null;
  var failingBestSoFar = null;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = results.length;
  while (inductionVariable < last) {
    var element = results[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>' call
    if (element.valid) {
      var tmp0_safe_receiver = bestSoFar;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>.<anonymous>' call
        tmp = bestResult(this, tmp0_safe_receiver, element);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? bestSoFar : tmp1_elvis_lhs;
      bestSoFar = tmp2_elvis_lhs == null ? element : tmp2_elvis_lhs;
    } else {
      var tmp_0;
      if (bestSoFar == null) {
        var tmp3_safe_receiver = failingBestSoFar;
        var tmp_1;
        if (tmp3_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>.<anonymous>' call
          tmp_1 = bestResult(this, tmp3_safe_receiver, element);
        }
        var tmp4_elvis_lhs = tmp_1;
        tmp_0 = tmp4_elvis_lhs == null ? element : tmp4_elvis_lhs;
      } else {
        tmp_0 = null;
      }
      failingBestSoFar = tmp_0;
    }
  }
  var tmp0_elvis_lhs = bestSoFar;
  return tmp0_elvis_lhs == null ? failingBestSoFar : tmp0_elvis_lhs;
};
function SnapSorter() {
}
function SnapSorterBuilder() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.b4k_1 = ArrayList_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.c4k_1 = ArrayList_init_$Create$();
}
protoOf(SnapSorterBuilder).build = function () {
  return SnapSorter_init_$Create$(this.b4k_1, this.c4k_1);
};
protoOf(SnapSorterBuilder).addInActivationDistanceFilter = function () {
  this.c4k_1.h(new InActivationDistanceFilter());
  return this;
};
protoOf(SnapSorterBuilder).addDistanceCriterion = function () {
  this.b4k_1.h(new DistanceCriterion());
  return this;
};
protoOf(SnapSorterBuilder).addOriginalVariantCriterion = function () {
  this.b4k_1.h(new OriginalVariantCriterion());
  return this;
};
protoOf(SnapSorterBuilder).addConnectorPriorityCriterion = function (settings) {
  this.b4k_1.h(new PriorityCriterion(settings));
  return this;
};
protoOf(SnapSorterBuilder).addRecommendedDistanceFromFloorCriterion = function () {
  this.b4k_1.h(new RecommendedDistanceFromFloorCriterion());
  return this;
};
protoOf(SnapSorterBuilder).addWarningsCriterion = function () {
  this.b4k_1.h(new WarningsCriterion());
  return this;
};
protoOf(SnapSorterBuilder).addCustomCriterion = function (sortCriterion) {
  this.b4k_1.h(sortCriterion);
  return this;
};
protoOf(SnapSorterBuilder).addCustomFilter = function (filterCriterion) {
  this.c4k_1.h(filterCriterion);
  return this;
};
function SortCriterion() {
}
function SortCriterionBase() {
}
protoOf(SortCriterionBase).bestResult = function (a, b) {
  var aSnap = a.snap;
  var bSnap = b.snap;
  var c = this.r4j(aSnap, bSnap);
  var tmp;
  if (c === 0) {
    tmp = null;
  } else if (c > 0) {
    tmp = a;
  } else {
    tmp = b;
  }
  return tmp;
};
protoOf(SortCriterionBase).bestCandidate = function (a, b) {
  var c = this.r4j(a, b);
  var tmp;
  if (c === 0) {
    tmp = null;
  } else if (c > 0) {
    tmp = a;
  } else {
    tmp = b;
  }
  return tmp;
};
function WarningsCriterion() {
}
protoOf(WarningsCriterion).bestResult = function (a, b) {
  if (!a.valid && !b.valid) {
    return null;
  }
  if (!a.valid)
    return b;
  if (!b.valid)
    return a;
  var aWarnings = a.warnings.length;
  var bWarnings = b.warnings.length;
  var tmp;
  if (aWarnings > bWarnings) {
    tmp = b;
  } else if (aWarnings < bWarnings) {
    tmp = a;
  } else {
    tmp = null;
  }
  return tmp;
};
protoOf(WarningsCriterion).bestCandidate = function (a, b) {
  return null;
};
function sam$kotlin_Comparator$0_7(function_0) {
  this.d4k_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_7).md = function (a, b) {
  return this.d4k_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).s3 = function () {
  return this.d4k_1;
};
protoOf(sam$kotlin_Comparator$0_7).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_7).hashCode = function () {
  return hashCode(this.s3());
};
function sam$kotlin_Comparator$0_8(function_0) {
  this.e4k_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_8).md = function (a, b) {
  return this.e4k_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).s3 = function () {
  return this.e4k_1;
};
protoOf(sam$kotlin_Comparator$0_8).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_8).hashCode = function () {
  return hashCode(this.s3());
};
function SpaceFinderUtils$Companion$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
  var tmp = a.movement.size;
  // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
  var tmp$ret$1 = b.movement.size;
  return compareValues(tmp, tmp$ret$1);
}
function SpaceFinderUtils$Companion$getNewCandidatesOnSameConnectorUsingSearchDirections$lambda($candidateWithContinuousHost) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
    var tmp = $candidateWithContinuousHost.endTransform.position.distanceTo(a);
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
    var tmp$ret$1 = $candidateWithContinuousHost.endTransform.position.distanceTo(b);
    return compareValues(tmp, tmp$ret$1);
  };
}
function Companion_83() {
  Companion_instance_122 = this;
  this.t4h_1 = LoggerState_getInstance().g1v('SpaceFinderUtils');
}
protoOf(Companion_83).u4h = function (validationService, validatedSnaps, iterations) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var testedHostConnectors = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var searchDirectionCandidates = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = validatedSnaps.length;
  while (inductionVariable < last) {
    var element = validatedSnaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    if (!element.valid) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp$ret$5 = item.snap;
    destination_0.h(tmp$ret$5);
  }
  var invalidSnaps = copyToArray(destination_0);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = validatedSnaps.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = validatedSnaps[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    if (element_0.valid) {
      destination_1.h(element_0);
    }
  }
  var originallyValidSnaps = destination_1;
  // Inline function 'kotlin.collections.find' call
  var this_0 = validationService.validations;
  var tmp$ret$13;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_1 = 0;
    var last_1 = this_0.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = this_0[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var tmp;
      if (element_1 instanceof CollisionValidation) {
        tmp = element_1.isEnabled;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$13 = element_1;
        break $l$block;
      }
    }
    tmp$ret$13 = null;
  }
  var tmp_0 = tmp$ret$13;
  var collisionValidation = (tmp_0 == null ? true : tmp_0 instanceof CollisionValidation) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = SpaceFinderUtils$Companion$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda;
  var tmp$ret$15 = new sam$kotlin_Comparator$0_7(tmp_1);
  var tmp0_iterator_0 = sortedWith_0(invalidSnaps, tmp$ret$15).k();
  while (tmp0_iterator_0.m()) {
    var element_2 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var isCandidateForSearchDirections = element_2.hostConnector.isContinuousConnector && !testedHostConnectors.s(element_2.hostConnector);
    if (isCandidateForSearchDirections) {
      var newCandidates = Companion_getInstance_126().f4k(element_2, iterations, collisionValidation);
      addAll_1(searchDirectionCandidates, newCandidates);
      testedHostConnectors.h(element_2.hostConnector);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(searchDirectionCandidates, 10));
  var tmp0_iterator_1 = searchDirectionCandidates.k();
  while (tmp0_iterator_1.m()) {
    var item_0 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp$ret$17 = validationService.validateSnapCandidate(item_0, true);
    destination_2.h(tmp$ret$17);
  }
  var validatedSearchDirectionSnaps = destination_2;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$();
  var tmp0_iterator_2 = validatedSearchDirectionSnaps.k();
  while (tmp0_iterator_2.m()) {
    var element_3 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    if (element_3.valid) {
      destination_3.h(element_3);
    }
  }
  var this_1 = plus_2(originallyValidSnaps, destination_3);
  var validSnaps = copyToArray(this_1);
  return validSnaps;
};
protoOf(Companion_83).g4k = function (candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut) {
  var guestRootWorld = candidateWithContinuousHost.endTransform;
  var hostWorld = get_worldTransform(candidateWithContinuousHost.host);
  var guestOOBB = get_objectOrientedBoundingBoxForHierarchy(candidateWithContinuousHost.guestRoot);
  var guestOOBBCenterWorldPosition = guestRootWorld.transformPosition(guestOOBB.center());
  var sizeWorldSpace = guestRootWorld.transformVector(guestOOBB.size);
  var hostConnectorWorldTransform = hostWorld.concatenate(candidateWithContinuousHost.hostConnector.transform);
  var sizeHostConnectorSpace = hostConnectorWorldTransform.inverseTransformVector(sizeWorldSpace);
  var guestPositionInHostConnectorSpace = hostConnectorWorldTransform.inverseTransformPosition(guestOOBBCenterWorldPosition);
  var collidedSizeLocalSpace = get_objectOrientedBoundingBoxForHierarchy(entityCollidedWith);
  var collidedSizeWorldSpace = collidedSizeLocalSpace.transform(get_worldTransform(entityCollidedWith));
  var collidedSizeHostConnectorSpace = collidedSizeWorldSpace.transform(hostConnectorWorldTransform.inverse()).axisAlignedBoundingBox;
  var diffBetweenEntities = collidedSizeHostConnectorSpace.center.minus(guestPositionInHostConnectorSpace);
  // Inline function 'kotlin.math.sign' call
  var x = directionConnectorSpace.dot(diffBetweenEntities);
  var signMove = sign(x);
  // Inline function 'kotlin.math.abs' call
  var x_0 = directionConnectorSpace.dot(diffBetweenEntities);
  var moveToSamePosition = signMove * Math.abs(x_0);
  // Inline function 'kotlin.math.abs' call
  var x_1 = sizeHostConnectorSpace.dot(directionConnectorSpace);
  var moveDueToOwnSize = Math.abs(x_1);
  var extraSizeMultiplesMovedOutVector = moveDueToOwnSize * extraSizeMultiplesMovedOut;
  // Inline function 'kotlin.math.abs' call
  var x_2 = collidedSizeHostConnectorSpace.size.dot(directionConnectorSpace);
  var move = moveToSamePosition + Math.abs(x_2) / 2 + moveDueToOwnSize / 2 + extraSizeMultiplesMovedOutVector;
  var moveWorldSpace = hostConnectorWorldTransform.transformVector(directionConnectorSpace.times(move));
  var worldSpacePosition = candidateWithContinuousHost.endTransform.position.plus(moveWorldSpace);
  return worldSpacePosition;
};
protoOf(Companion_83).getPositionToDirectionOfCollision$default = function (candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut, $super) {
  extraSizeMultiplesMovedOut = extraSizeMultiplesMovedOut === VOID ? 0 : extraSizeMultiplesMovedOut;
  return $super === VOID ? this.g4k(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut) : $super.g4k.call(this, candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut);
};
protoOf(Companion_83).f4k = function (candidateWithContinuousHost, iterations, collisionValidation) {
  if (!candidateWithContinuousHost.hostConnector.isContinuousConnector) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  var size = get_objectOrientedBoundingBoxForHierarchy(candidateWithContinuousHost.guestRoot).size;
  // Inline function 'kotlin.collections.mutableListOf' call
  var positions = ArrayList_init_$Create$();
  candidateWithContinuousHost.performMove();
  var collisionResult = collisionValidation == null ? null : collisionValidation.validateSnap(candidateWithContinuousHost);
  candidateWithContinuousHost.rollbackMove();
  var tmp2_safe_receiver = collisionResult == null ? null : collisionResult.collisions;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull_0(tmp2_safe_receiver);
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.other;
  var entityCollidedWith = tmp4_safe_receiver == null ? null : get_snapRoot(tmp4_safe_receiver);
  if (!(entityCollidedWith == null)) {
    var iterationsOnSide = iterations / 2 | 0;
    var leftPos = this.g4k(candidateWithContinuousHost, Companion_getInstance_15().LEFT, entityCollidedWith, iterationsOnSide);
    var leftSidePositions = this.h4k(candidateWithContinuousHost, size, iterationsOnSide, leftPos, false);
    addAll_1(positions, leftSidePositions);
    var rightPos = this.g4k(candidateWithContinuousHost, Companion_getInstance_15().RIGHT, entityCollidedWith, iterationsOnSide);
    var rightSidePositions = this.h4k(candidateWithContinuousHost, size, iterationsOnSide, rightPos, false);
    addAll_1(positions, rightSidePositions);
    var forwardPos = this.g4k(candidateWithContinuousHost, Companion_getInstance_15().FORWARD, entityCollidedWith, iterationsOnSide);
    var forwardSidePositions = this.h4k(candidateWithContinuousHost, size, iterationsOnSide, forwardPos, false);
    addAll_1(positions, forwardSidePositions);
    var backwardPos = this.g4k(candidateWithContinuousHost, Companion_getInstance_15().BACK, entityCollidedWith, iterationsOnSide);
    var backSidePositions = this.h4k(candidateWithContinuousHost, size, iterationsOnSide, backwardPos, false);
    addAll_1(positions, backSidePositions);
  } else {
    var newPositions = this.getPositionsOnConnector$default(candidateWithContinuousHost, size, iterations);
    addAll_1(positions, newPositions);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = SpaceFinderUtils$Companion$getNewCandidatesOnSameConnectorUsingSearchDirections$lambda(candidateWithContinuousHost);
  var tmp$ret$2 = new sam$kotlin_Comparator$0_8(tmp);
  var this_0 = sortedWith(positions, tmp$ret$2);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.placement.utils.Companion.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
    var tmp$ret$4 = candidateWithContinuousHost.withNewEndPosition(item);
    destination.h(tmp$ret$4);
  }
  var newCandidates = copyToArray(destination);
  return newCandidates;
};
protoOf(Companion_83).getNewCandidatesOnSameConnectorUsingSearchDirections$default = function (candidateWithContinuousHost, iterations, collisionValidation, $super) {
  collisionValidation = collisionValidation === VOID ? null : collisionValidation;
  return $super === VOID ? this.f4k(candidateWithContinuousHost, iterations, collisionValidation) : $super.f4k.call(this, candidateWithContinuousHost, iterations, collisionValidation);
};
protoOf(Companion_83).h4k = function (candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition) {
  var hostWorld = get_worldTransform(candidateWithContinuousHost.host);
  var hostConnectorWorldTransform = hostWorld.concatenate(candidateWithContinuousHost.hostConnector.transform);
  var endTransform = overridePosition == null ? candidateWithContinuousHost.endTransform : new Transform(overridePosition, candidateWithContinuousHost.endTransform.rotation);
  var guestEndTransformWorld = endTransform.concatenate(candidateWithContinuousHost.guestRootToGuestDeltaTransform);
  var guestConnectorWorldPos = guestEndTransformWorld.transformPosition(candidateWithContinuousHost.guestConnector.transform.position);
  var guestConnectorHostSpacePos = hostWorld.inverseTransformPosition(guestConnectorWorldPos);
  var hostConnector = candidateWithContinuousHost.hostConnector;
  var tmp;
  if (hostConnector instanceof EdgeConnector) {
    var transformedSizeWorld = endTransform.transformVector(size);
    var transformedSizeHostLocal = hostWorld.inverseTransformVector(transformedSizeWorld);
    var sizeAlongHostConnector = hostConnector.direction.dot(transformedSizeHostLocal);
    var incrementHostSpace = hostConnector.direction.times(sizeAlongHostConnector);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = numberRangeToNumber(-iterations | 0, iterations);
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.w_1;
    var last = this_0.x_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.placement.utils.Companion.getPositionsOnConnector.<anonymous>' call
        var i = element;
        var incrementLocalSpace = incrementHostSpace.__timesIntForKotlin(i);
        var isOnConnector = hostConnector.contains(guestConnectorHostSpacePos.plus(incrementLocalSpace));
        var tmp_0;
        if (ignoreSamePosition && i === 0 || !isOnConnector) {
          tmp_0 = null;
        } else {
          var posWorldSpace = endTransform.position.plus(hostWorld.transformVector(incrementLocalSpace));
          tmp_0 = posWorldSpace;
        }
        var tmp0_safe_receiver = tmp_0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver);
        }
      }
       while (!(element === last));
    tmp = destination;
  } else {
    if (hostConnector instanceof SurfaceConnector) {
      var rightGuestSpace = endTransform.inverseTransformVector(hostConnectorWorldTransform.right);
      var forwardGuestSpace = endTransform.inverseTransformVector(hostConnectorWorldTransform.forward);
      var moveAmountRight = rightGuestSpace.dot(size);
      var moveAmountForward = forwardGuestSpace.dot(size);
      var right = hostConnectorWorldTransform.right.times(moveAmountRight);
      var forward = hostConnectorWorldTransform.forward.times(moveAmountForward);
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_1 = numberRangeToNumber(-iterations | 0, iterations);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = this_1.w_1;
      var last_0 = this_1.x_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.placement.utils.Companion.getPositionsOnConnector.<anonymous>' call
          var i_0 = element_0;
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var this_2 = numberRangeToNumber(-iterations | 0, iterations);
          var destination_1 = ArrayList_init_$Create$();
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_1 = this_2.w_1;
          var last_1 = this_2.x_1;
          if (inductionVariable_1 <= last_1)
            do {
              var element_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
              // Inline function 'com.ikea.core.stl.placement.utils.Companion.getPositionsOnConnector.<anonymous>.<anonymous>' call
              var j = element_1;
              var incrementWorldSpace = right.__timesIntForKotlin(i_0).plus(forward.__timesIntForKotlin(j));
              var incrementLocalSpace_0 = hostWorld.inverseTransformVector(incrementWorldSpace);
              var isOnConnector_0 = hostConnector.contains(guestConnectorHostSpacePos.plus(incrementLocalSpace_0));
              var tmp_1;
              if (ignoreSamePosition && i_0 === 0 && j === 0 || !isOnConnector_0) {
                tmp_1 = null;
              } else {
                var posWorldSpace_0 = endTransform.position.plus(incrementWorldSpace);
                tmp_1 = posWorldSpace_0;
              }
              var tmp0_safe_receiver_0 = tmp_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                destination_1.h(tmp0_safe_receiver_0);
              }
            }
             while (!(element_1 === last_1));
          var list = destination_1;
          addAll(destination_0, list);
        }
         while (!(element_0 === last_0));
      tmp = destination_0;
    } else {
      tmp = emptyList();
    }
  }
  var result = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(result);
};
protoOf(Companion_83).getPositionsOnConnector$default = function (candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition, $super) {
  overridePosition = overridePosition === VOID ? null : overridePosition;
  ignoreSamePosition = ignoreSamePosition === VOID ? true : ignoreSamePosition;
  return $super === VOID ? this.h4k(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition) : $super.h4k.call(this, candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition);
};
var Companion_instance_122;
function Companion_getInstance_126() {
  if (Companion_instance_122 == null)
    new Companion_83();
  return Companion_instance_122;
}
function getNewValidCandidatesOnSameConnectorsUsingSearchDirections(validationService, validatedSnaps, iterations) {
  return Companion_getInstance_126().u4h(validationService, validatedSnaps, iterations);
}
function getPositionToDirectionOfCollision(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut) {
  return Companion_getInstance_126().g4k(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut);
}
function getPositionToDirectionOfCollision_0(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut, $super) {
  extraSizeMultiplesMovedOut = extraSizeMultiplesMovedOut === VOID ? 0 : extraSizeMultiplesMovedOut;
  return getPositionToDirectionOfCollision(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut);
}
function getNewCandidatesOnSameConnectorUsingSearchDirections(candidateWithContinuousHost, iterations, collisionValidation) {
  return Companion_getInstance_126().f4k(candidateWithContinuousHost, iterations, collisionValidation);
}
function getNewCandidatesOnSameConnectorUsingSearchDirections_0(candidateWithContinuousHost, iterations, collisionValidation, $super) {
  collisionValidation = collisionValidation === VOID ? null : collisionValidation;
  return getNewCandidatesOnSameConnectorUsingSearchDirections(candidateWithContinuousHost, iterations, collisionValidation);
}
function getPositionsOnConnector(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition) {
  return Companion_getInstance_126().h4k(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition);
}
function getPositionsOnConnector_0(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition, $super) {
  overridePosition = overridePosition === VOID ? null : overridePosition;
  ignoreSamePosition = ignoreSamePosition === VOID ? true : ignoreSamePosition;
  return getPositionsOnConnector(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition);
}
function SpaceFinderUtils() {
  Companion_getInstance_126();
}
function createAndAddPropping($this, proppingHostConnectorData, data, productManager) {
  var propHoldingEntity = proppingHostConnectorData.propHoldingEntity;
  var proppingHostConnector = proppingHostConnectorData.proppingHostConnector;
  var propInfoBefore = getPropHolderInfo(propHoldingEntity, proppingHostConnector);
  var oldProppingBefore = propInfoBefore == null ? null : propInfoBefore.oldPropping;
  removePropping(propHoldingEntity, proppingHostConnector);
  var wantToAddBackOldPropping = !(oldProppingBefore == null) && get_productRef(oldProppingBefore) === data.i4k_1;
  if (wantToAddBackOldPropping) {
    restoreOldPropping(propHoldingEntity, proppingHostConnector);
    if ((oldProppingBefore == null ? null : get_isHanging(oldProppingBefore)) === true) {
      var tmp1_safe_receiver = get_guestConnectors(oldProppingBefore);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : firstOrNull_1(tmp1_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp2_elvis_lhs;
      }
      adjustToHangDown($this, oldProppingBefore, tmp, propHoldingEntity, proppingHostConnector);
    }
    return Unit_instance;
  }
  clearOldPropping(propHoldingEntity, proppingHostConnector);
  var newPropping = productManager.createFromSpecification(data.i4k_1, data.j4k_1);
  setPropping(propHoldingEntity, proppingHostConnector, newPropping);
  if (newPropping == null)
    return Unit_instance;
  setParentMaintainWorldTransform(newPropping, proppingHostConnectorData.propHoldingEntity);
  // Inline function 'kotlin.collections.find' call
  var this_0 = ensureNotNull(get_connectorsComponent(newPropping)).f29();
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.propping.Companion.createAndAddPropping.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject = element.demands();
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element_0 = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.propping.Companion.createAndAddPropping.<anonymous>.<anonymous>' call
          if (element_0 === data.m4k_1) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        tmp$ret$3 = element;
        break $l$block_0;
      }
    }
    tmp$ret$3 = null;
  }
  var tmp$ret$4 = tmp$ret$3;
  var guestConnector = ensureNotNull(tmp$ret$4);
  var snapCandidate = Companion_instance_1.createCandidate(newPropping, guestConnector, proppingHostConnectorData.propHoldingEntity, proppingHostConnector);
  snapCandidate.performMoveAndConnect();
  if (get_isHanging(newPropping)) {
    adjustToHangDown($this, newPropping, snapCandidate.guestConnector, snapCandidate.host, snapCandidate.hostConnector);
  }
}
function adjustToHangDown($this, propping, guestConnector, host, hostConnector) {
  if (!get_isHanging(propping))
    return Unit_instance;
  if (get_worldTransform(propping).up.equals(Companion_getInstance_15().UP))
    return Unit_instance;
  var localRot = get_localTransform(propping).rotation;
  var tmp0_safe_receiver = get_parent(propping);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rotation;
  var parentRotation = tmp2_elvis_lhs == null ? Companion_getInstance_14().q2b_1 : tmp2_elvis_lhs;
  var yAngle = localRot.toEuler().Y + parentRotation.toEuler().Y;
  var rotationAroundY = Companion_getInstance_14().v2v(new Radians(0.0), new Radians(yAngle), new Radians(0.0));
  var newLocalRot = rotationAroundY.times(parentRotation.inverse());
  var adjustment = Companion_getInstance_15().UP.times(hostConnector.worldSpaceOffsetOnHanging).rotate(parentRotation.inverse());
  var newLocalPos = hostConnector.transform.position.plus(adjustment).minus(guestConnector.transform.position.rotate(newLocalRot));
  propping.addComponent(LocalTransformComponentFromPosAndRot(newLocalPos, newLocalRot));
  if (!propping.hasComponent(Companion_getInstance().id))
    return Unit_instance;
  var connectorsDeltaTransform = hostConnector.getDeltaTransformToGuestConnectorEntity(host, propping, guestConnector);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [fromConnectors(propping, guestConnector, host, hostConnector, connectorsDeltaTransform)];
  propping.addComponent(new GuestConnectionsComponent(tmp$ret$2));
  var tmp3_safe_receiver = get_viewerObject(propping);
  if (tmp3_safe_receiver == null)
    null;
  else
    tmp3_safe_receiver.setPosition(get_worldPosition(propping));
  var tmp4_safe_receiver = get_viewerObject(propping);
  if (tmp4_safe_receiver == null)
    null;
  else
    tmp4_safe_receiver.setRotation(get_worldRotation(propping));
}
function addProppingColliders($this, proppingHostEntity, proppingHostConnector) {
  var tmp0_elvis_lhs = getPropHolderInfo(proppingHostEntity, proppingHostConnector);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var propInfo = tmp;
  var tmp1_elvis_lhs = propInfo.propping;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var propping = tmp_0;
  var tmp2_elvis_lhs = propInfo.shapeComponent;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var shapeComponent = tmp_1;
  propping.addComponent(shapeComponent);
}
function removeProppingColliders($this, proppingHostEntity, proppingHostConnector) {
  var tmp0_elvis_lhs = getPropHolderInfo(proppingHostEntity, proppingHostConnector);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var propInfo = tmp;
  var tmp1_elvis_lhs = propInfo.propping;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var propping = tmp_0;
  var tmp2_safe_receiver = propping.__getComponentForKotlin(Companion_getInstance_31().id);
  var colliderBox = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.worldPolyhedron;
  var shapeComponent = get_colliderShapeComponent(propping);
  propping.removeComponent(Companion_getInstance_19().id);
  propping.removeComponent(Companion_getInstance_31().id);
  propping.removeComponent(Companion_getInstance_2().id);
  propping.removeComponent(Companion_getInstance_23().id);
  setProppingProperty(proppingHostEntity, proppingHostConnector, OldProppingUtils$Companion$removeProppingColliders$lambda(colliderBox, shapeComponent));
}
function OldProppingUtils$Companion$removeProppingColliders$lambda($colliderBox, $shapeComponent) {
  return function (it) {
    return it.copy(VOID, VOID, $colliderBox, VOID, $shapeComponent);
  };
}
function Companion_84() {
}
protoOf(Companion_84).n4k = function (proppingCatalog) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var demandToProppingData = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = proppingCatalog.allProductRefs();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    $l$block_1: {
      // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>' call
      var tmp0_elvis_lhs = proppingCatalog.productSpecification(element);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var spec = tmp;
      var tmp1_safe_receiver = spec.findComponent(Companion_instance_0.p1n_1);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.polyhedron;
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      var colliderBox = tmp_0;
      var tmp3_elvis_lhs = spec.findComponent(Companion_instance_0.h1n_1);
      var tmp_1;
      if (tmp3_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp_1 = tmp3_elvis_lhs;
      }
      var snappable = tmp_1;
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = snappable.f29();
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
        if (element_0.hasTag(Companion_getInstance_131().TAG_PROPPING)) {
          destination.h(element_0);
        }
      }
      var tmp0_iterator_0 = destination.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
        var demand = element_1.demands()[0];
        demandToProppingData.h(new ProppingData(element, spec, colliderBox, element_1, demand));
      }
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(demandToProppingData, 10));
  var tmp0_iterator_1 = demandToProppingData.k();
  while (tmp0_iterator_1.m()) {
    var item = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>' call
    var tmp$ret$5 = item.m4k_1;
    destination_0.h(tmp$ret$5);
  }
  var demandKeys = toSet(destination_0);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var demandToProppingMap = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = demandKeys.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_3 = demandToProppingData.k();
    while (tmp0_iterator_3.m()) {
      var element_3 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
      if (element_3.m4k_1 === element_2) {
        destination_1.h(element_3);
      }
    }
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_2 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_4 = destination_1.k();
    while (tmp0_iterator_4.m()) {
      var element_4 = tmp0_iterator_4.n();
      // Inline function 'com.ikea.core.stl.propping.Companion.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
      var key = element_4.p4k();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_2.f2(key);
      var tmp_2;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        destination_2.q2(key, answer);
        tmp_2 = answer;
      } else {
        tmp_2 = value;
      }
      var list = tmp_2;
      list.h(element_4);
    }
    var props = destination_2;
    var sizes = sorted(toList_0(props.g2()));
    // Inline function 'kotlin.collections.set' call
    var value_0 = new ProppingsAvailableForDemand(sizes, props);
    demandToProppingMap.q2(element_2, value_0);
  }
  return demandToProppingMap;
};
protoOf(Companion_84).q4k = function (holder, proppingsAvailableForDemand, entityManager, sceneEntities) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = proppingsAvailableForDemand.s4k_1.h2();
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.findProppingsThatFit.<anonymous>' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = element.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.propping.Companion.findProppingsThatFit.<anonymous>.<anonymous>' call
      if (Companion_instance_123.t4k(holder, element_0, entityManager, sceneEntities)) {
        destination_0.h(element_0);
      }
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return destination;
};
protoOf(Companion_84).t4k = function (holder, propping, entityManager, sceneEntities) {
  var e = entityManager.createEntity();
  var worldTransform = propping.l4k_1.calculateEndTransform(get_worldTransform(holder.propHoldingEntity), holder.proppingHostConnector, Companion_getInstance_22().c1x_1, Companion_getInstance_22().c1x_1);
  setParent(e, holder.propHoldingEntity);
  Companion_instance_8.z1l(e, worldTransform);
  e.addComponentInternal(new DisplayNameComponent('Propping fit test'));
  e.addComponent(new ColliderShapeComponent(propping.k4k_1));
  if (propping.j4k_1.hasComponent(AlwaysHangDownComponent_instance.id)) {
    e.addComponent(AlwaysHangDownComponent_instance);
    adjustToHangDown(this, e, propping.l4k_1, holder.propHoldingEntity, holder.proppingHostConnector);
  }
  var collision = Companion_instance_14.e1y(e, null, sceneEntities);
  entityManager.disposeEntity(e);
  return collision == null;
};
protoOf(Companion_84).u4k = function (demandToProppingMap, entityManager, sceneManager, productManager) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_proppingHostEntitiesInHierarchy(sceneManager.scene);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>' call
    var tmp$ret$0 = get_proppingHostConnectors(item);
    destination.h(tmp$ret$0);
  }
  var tmp$ret$3 = copyToArray(destination);
  var proppingHolders = flatten(tmp$ret$3);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = proppingHolders.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>' call
    addProppingColliders(Companion_instance_123, element.propHoldingEntity, element.proppingHostConnector);
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = proppingHolders.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    $l$block_6: {
      // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>' call
      var proppingHostConnector = element_0.proppingHostConnector;
      var propHoldingEntity = element_0.propHoldingEntity;
      // Inline function 'kotlin.collections.get' call
      var key = firstOrNull_0(proppingHostConnector.offers());
      var tmp0_elvis_lhs = (isInterface(demandToProppingMap, KtMap) ? demandToProppingMap : THROW_CCE()).f2(key);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_6;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var proppingsAvailableForDemand = tmp;
      if (proppingsAvailableForDemand.s4k_1.r()) {
        break $l$block_6;
      }
      var potentialProppingsThatFit = Companion_instance_123.q4k(element_0, proppingsAvailableForDemand, entityManager, sceneManager.entities);
      var propInfoBefore = getPropHolderInfo(propHoldingEntity, proppingHostConnector);
      var tmp_0;
      if (!((propInfoBefore == null ? null : propInfoBefore.oldPropping) == null)) {
        var tmp$ret$6;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(potentialProppingsThatFit, Collection)) {
            tmp_1 = potentialProppingsThatFit.r();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$6 = false;
            break $l$block_2;
          }
          var tmp0_iterator_1 = potentialProppingsThatFit.k();
          while (tmp0_iterator_1.m()) {
            var element_1 = tmp0_iterator_1.n();
            // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>.<anonymous>' call
            if (element_1.i4k_1 === get_productRef(propInfoBefore.oldPropping)) {
              tmp$ret$6 = true;
              break $l$block_2;
            }
          }
          tmp$ret$6 = false;
        }
        tmp_0 = tmp$ret$6;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        restoreOldPropping(propHoldingEntity, proppingHostConnector);
        if (get_isHanging(propInfoBefore.oldPropping)) {
          var tmp1_safe_receiver = get_guestConnectors(propInfoBefore.oldPropping);
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : firstOrNull_1(tmp1_safe_receiver);
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            break $l$block_6;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          var guestConnector = tmp_2;
          adjustToHangDown(Companion_instance_123, propInfoBefore.oldPropping, guestConnector, propHoldingEntity, proppingHostConnector);
        }
        break $l$block_6;
      }
      if (any_0(potentialProppingsThatFit)) {
        // Inline function 'kotlin.let' call
        var tmp$ret$11;
        $l$block_5: {
          // Inline function 'kotlin.collections.maxBy' call
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(potentialProppingsThatFit, 10));
          var tmp0_iterator_2 = potentialProppingsThatFit.k();
          while (tmp0_iterator_2.m()) {
            var item_0 = tmp0_iterator_2.n();
            // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>.<anonymous>' call
            var tmp$ret$8 = new Pair(Default_getInstance().xh(item_0.p4k()), item_0);
            destination_0.h(tmp$ret$8);
          }
          var iterator = destination_0.k();
          if (!iterator.m())
            throw NoSuchElementException_init_$Create$_0();
          var maxElem = iterator.n();
          if (!iterator.m()) {
            tmp$ret$11 = maxElem;
            break $l$block_5;
          }
          // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>.<anonymous>' call
          var maxValue = maxElem.rf_1;
          do {
            var e = iterator.n();
            // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>.<anonymous>' call
            var v = e.rf_1;
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (iterator.m());
          tmp$ret$11 = maxElem;
        }
        // Inline function 'kotlin.contracts.contract' call
        var selectedPropping = tmp$ret$11.sf_1;
        createAndAddPropping(Companion_instance_123, element_0, selectedPropping, productManager);
        break $l$block_6;
      }
      var tmp4_safe_receiver = getOldPropping(propHoldingEntity, proppingHostConnector);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        entityManager.disposeEntity(tmp4_safe_receiver);
        clearOldPropping(propHoldingEntity, proppingHostConnector);
      }
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_3 = proppingHolders.k();
  while (tmp0_iterator_3.m()) {
    var element_2 = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.addProppingWherePossible.<anonymous>' call
    removeProppingColliders(Companion_instance_123, element_2.propHoldingEntity, element_2.proppingHostConnector);
  }
};
var Companion_instance_123;
function Companion_getInstance_127() {
  return Companion_instance_123;
}
function ProppingData(productRef, spec, colliderBox, guestConnector, demands) {
  this.i4k_1 = productRef;
  this.j4k_1 = spec;
  this.k4k_1 = colliderBox;
  this.l4k_1 = guestConnector;
  this.m4k_1 = demands;
}
protoOf(ProppingData).p4k = function () {
  return numberToInt(this.k4k_1.axisAlignedBoundingBox.height);
};
protoOf(ProppingData).toString = function () {
  return 'ProppingData(productRef=' + this.i4k_1 + ', spec=' + this.j4k_1.toString() + ', colliderBox=' + toString(this.k4k_1) + ', guestConnector=' + toString(this.l4k_1) + ', demands=' + this.m4k_1 + ')';
};
protoOf(ProppingData).hashCode = function () {
  var result = getStringHashCode(this.i4k_1);
  result = imul(result, 31) + this.j4k_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.k4k_1) | 0;
  result = imul(result, 31) + this.l4k_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.m4k_1) | 0;
  return result;
};
protoOf(ProppingData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProppingData))
    return false;
  var tmp0_other_with_cast = other instanceof ProppingData ? other : THROW_CCE();
  if (!(this.i4k_1 === tmp0_other_with_cast.i4k_1))
    return false;
  if (!this.j4k_1.equals(tmp0_other_with_cast.j4k_1))
    return false;
  if (!equals(this.k4k_1, tmp0_other_with_cast.k4k_1))
    return false;
  if (!this.l4k_1.equals(tmp0_other_with_cast.l4k_1))
    return false;
  if (!(this.m4k_1 === tmp0_other_with_cast.m4k_1))
    return false;
  return true;
};
function ProppingFeature$Companion$setProppingProductRefs$lambda() {
  return Companion_getInstance_108().p4c_1 + ' not found among EntityManager systems';
}
function ProppingFeature$Companion$getCurrentProppingProductRefs$lambda() {
  return Companion_getInstance_108().p4c_1 + ' not found among EntityManager systems';
}
function Companion_85() {
  Companion_instance_124 = this;
  this.v4k_1 = LoggerState_getInstance().g1v('ProppingFeature');
}
protoOf(Companion_85).w4k = function (coreServices) {
  var tmp0_safe_receiver = coreServices.entityManager.getSystem('DisposeProppingOnReplacedEntitySystem');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp0_safe_receiver.enable();
    tmp = Unit_instance;
  }
  if (tmp == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var disposeProppingOnSlowReplacedEntitySystem = new DisposeProppingOnSlowReplacedEntitySystem();
    coreServices.entityManager.registerSystem(disposeProppingOnSlowReplacedEntitySystem);
  }
  var tmp2_safe_receiver = coreServices.entityManager.getSystem(Companion_getInstance_105().j4b_1);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    tmp2_safe_receiver.enable();
    tmp_0 = Unit_instance;
  }
  if (tmp_0 == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var proppingColliderCalculationSystem = new ProppingConvertColliderToFunctionalZoneSystem();
    coreServices.entityManager.registerSystem(proppingColliderCalculationSystem);
  }
  var tmp4_safe_receiver = coreServices.entityManager.getSystem('ProppingSpaceCalculationSystem');
  var tmp_1;
  if (tmp4_safe_receiver == null) {
    tmp_1 = null;
  } else {
    tmp4_safe_receiver.enable();
    tmp_1 = Unit_instance;
  }
  if (tmp_1 == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var proppingSpaceCalculationSystem = new ProppingSpaceCalculationSystem(coreServices);
    coreServices.entityManager.registerSystem(proppingSpaceCalculationSystem);
  }
  var tmp6_safe_receiver = coreServices.entityManager.getSystem('ProppingDisposalSystem');
  var tmp_2;
  if (tmp6_safe_receiver == null) {
    tmp_2 = null;
  } else {
    tmp6_safe_receiver.enable();
    tmp_2 = Unit_instance;
  }
  if (tmp_2 == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var proppingDisposalSystem = new ProppingDisposalSystem();
    coreServices.entityManager.registerSystem(proppingDisposalSystem);
  }
  var tmp8_safe_receiver = coreServices.entityManager.getSystem(Companion_getInstance_108().p4c_1);
  var tmp_3;
  if (tmp8_safe_receiver == null) {
    tmp_3 = null;
  } else {
    tmp8_safe_receiver.enable();
    tmp_3 = Unit_instance;
  }
  if (tmp_3 == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var proppingHolderCreationSystem = new ProppingHostConnectorDataCreationSystem(coreServices);
    coreServices.entityManager.registerSystem(proppingHolderCreationSystem);
  }
};
protoOf(Companion_85).x4k = function (entityManager) {
  var tmp0_safe_receiver = entityManager.getSystem(Companion_getInstance_108().p4c_1);
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isEnabled) === true;
};
protoOf(Companion_85).y4k = function (coreServices) {
  var tmp0_safe_receiver = coreServices.entityManager.getSystem(Companion_getInstance_108().p4c_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.disable();
  }
  var tmp1_safe_receiver = coreServices.entityManager.getSystem('ProppingSpaceCalculationSystem');
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.disable();
  }
  var tmp2_safe_receiver = coreServices.entityManager.getSystem(Companion_getInstance_105().j4b_1);
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.disable();
  }
  var tmp3_safe_receiver = coreServices.entityManager.getSystem('ProppingDisposalSystem');
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.disable();
  }
  var tmp4_safe_receiver = coreServices.entityManager.getSystem('DisposeProppingOnReplacedEntitySystem');
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.disable();
  }
};
protoOf(Companion_85).z4k = function (proppingProductRefs, entityManager) {
  var system = entityManager.getSystem(Companion_getInstance_108().p4c_1);
  if (system == null) {
    this.v4k_1.error(ProppingFeature$Companion$setProppingProductRefs$lambda);
    return Unit_instance;
  }
  var proppingHolderCreationSystem = system instanceof ProppingHostConnectorDataCreationSystem ? system : THROW_CCE();
  proppingHolderCreationSystem.setProppingProducts(proppingProductRefs);
};
protoOf(Companion_85).a4l = function (entityManager) {
  var system = entityManager.getSystem(Companion_getInstance_108().p4c_1);
  if (system == null) {
    this.v4k_1.error(ProppingFeature$Companion$getCurrentProppingProductRefs$lambda);
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  var proppingHolderCreationSystem = system instanceof ProppingHostConnectorDataCreationSystem ? system : THROW_CCE();
  return proppingHolderCreationSystem.currentProppingProductRefs;
};
var Companion_instance_124;
function Companion_getInstance_128() {
  if (Companion_instance_124 == null)
    new Companion_85();
  return Companion_instance_124;
}
function enable(coreServices) {
  return Companion_getInstance_128().w4k(coreServices);
}
function hasStartedProppingFeature(entityManager) {
  return Companion_getInstance_128().x4k(entityManager);
}
function disable(coreServices) {
  return Companion_getInstance_128().y4k(coreServices);
}
function setProppingProductRefs(proppingProductRefs, entityManager) {
  return Companion_getInstance_128().z4k(proppingProductRefs, entityManager);
}
function getCurrentProppingProductRefs(entityManager) {
  return Companion_getInstance_128().a4l(entityManager);
}
function ProppingFeature() {
  Companion_getInstance_128();
}
function Companion_86() {
  Companion_instance_125 = this;
  this.ID = Companion_instance_0.y1m_1;
}
protoOf(Companion_86).j1y = function () {
  return this.ID;
};
var Companion_instance_125;
function Companion_getInstance_129() {
  if (Companion_instance_125 == null)
    new Companion_86();
  return Companion_instance_125;
}
function ProppingHostConnectorsComponent(proppingHostConnectors) {
  Companion_getInstance_129();
  this.proppingHostConnectors = proppingHostConnectors;
}
protoOf(ProppingHostConnectorsComponent).b4l = function () {
  return this.proppingHostConnectors;
};
protoOf(ProppingHostConnectorsComponent).p1s = function () {
  return Companion_getInstance_129().ID;
};
protoOf(ProppingHostConnectorsComponent).eq = function (other) {
  if (!(other instanceof ProppingHostConnectorsComponent))
    THROW_CCE();
  return contentEquals(this.proppingHostConnectors, other.proppingHostConnectors);
};
function ProppingHostConnectorData(propHoldingEntity, proppingHostConnector) {
  this.propHoldingEntity = propHoldingEntity;
  this.proppingHostConnector = proppingHostConnector;
}
protoOf(ProppingHostConnectorData).c4l = function () {
  return this.propHoldingEntity;
};
protoOf(ProppingHostConnectorData).n4c = function () {
  return this.proppingHostConnector;
};
protoOf(ProppingHostConnectorData).tf = function () {
  return this.propHoldingEntity;
};
protoOf(ProppingHostConnectorData).uf = function () {
  return this.proppingHostConnector;
};
protoOf(ProppingHostConnectorData).d4l = function (propHoldingEntity, proppingHostConnector) {
  return new ProppingHostConnectorData(propHoldingEntity, proppingHostConnector);
};
protoOf(ProppingHostConnectorData).copy = function (propHoldingEntity, proppingHostConnector, $super) {
  propHoldingEntity = propHoldingEntity === VOID ? this.propHoldingEntity : propHoldingEntity;
  proppingHostConnector = proppingHostConnector === VOID ? this.proppingHostConnector : proppingHostConnector;
  return this.d4l(propHoldingEntity, proppingHostConnector);
};
protoOf(ProppingHostConnectorData).toString = function () {
  return 'ProppingHostConnectorData(propHoldingEntity=' + this.propHoldingEntity.toString() + ', proppingHostConnector=' + toString(this.proppingHostConnector) + ')';
};
protoOf(ProppingHostConnectorData).hashCode = function () {
  var result = this.propHoldingEntity.hashCode();
  result = imul(result, 31) + this.proppingHostConnector.hashCode() | 0;
  return result;
};
protoOf(ProppingHostConnectorData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProppingHostConnectorData))
    return false;
  var tmp0_other_with_cast = other instanceof ProppingHostConnectorData ? other : THROW_CCE();
  if (!this.propHoldingEntity.equals(tmp0_other_with_cast.propHoldingEntity))
    return false;
  if (!this.proppingHostConnector.equals(tmp0_other_with_cast.proppingHostConnector))
    return false;
  return true;
};
function get_proppingHostConnectors(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_129().ID);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.proppingHostConnectors;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function get_proppingHostEntitiesInHierarchy(_this__u8e3s4) {
  return Companion_instance_3.n2r(_this__u8e3s4, Companion_instance_0.y1m_1);
}
function Companion_87() {
  Companion_instance_126 = this;
  this.ID = Companion_instance_0.e1q_1;
}
protoOf(Companion_87).j1y = function () {
  return this.ID;
};
var Companion_instance_126;
function Companion_getInstance_130() {
  if (Companion_instance_126 == null)
    new Companion_87();
  return Companion_instance_126;
}
function ProppingInfoComponent(propHolderInfos) {
  Companion_getInstance_130();
  this.propHolderInfos = propHolderInfos;
}
protoOf(ProppingInfoComponent).e4l = function () {
  return this.propHolderInfos;
};
protoOf(ProppingInfoComponent).p1s = function () {
  return Companion_getInstance_130().ID;
};
protoOf(ProppingInfoComponent).eq = function (other) {
  return false;
};
protoOf(ProppingInfoComponent).tf = function () {
  return this.propHolderInfos;
};
protoOf(ProppingInfoComponent).f4l = function (propHolderInfos) {
  return new ProppingInfoComponent(propHolderInfos);
};
protoOf(ProppingInfoComponent).copy = function (propHolderInfos, $super) {
  propHolderInfos = propHolderInfos === VOID ? this.propHolderInfos : propHolderInfos;
  return this.f4l(propHolderInfos);
};
protoOf(ProppingInfoComponent).toString = function () {
  return 'ProppingInfoComponent(propHolderInfos=' + toString(this.propHolderInfos) + ')';
};
protoOf(ProppingInfoComponent).hashCode = function () {
  return hashCode(this.propHolderInfos);
};
protoOf(ProppingInfoComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProppingInfoComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ProppingInfoComponent ? other : THROW_CCE();
  if (!equals(this.propHolderInfos, tmp0_other_with_cast.propHolderInfos))
    return false;
  return true;
};
function PropHolderInfo(connector, propping, colliderBox, oldPropping, shapeComponent) {
  shapeComponent = shapeComponent === VOID ? null : shapeComponent;
  this.connector = connector;
  this.propping = propping;
  this.colliderBox = colliderBox;
  this.oldPropping = oldPropping;
  this.shapeComponent = shapeComponent;
}
protoOf(PropHolderInfo).t1m = function () {
  return this.connector;
};
protoOf(PropHolderInfo).r4a = function () {
  return this.propping;
};
protoOf(PropHolderInfo).g4l = function () {
  return this.colliderBox;
};
protoOf(PropHolderInfo).h4l = function () {
  return this.oldPropping;
};
protoOf(PropHolderInfo).i4l = function () {
  return this.shapeComponent;
};
protoOf(PropHolderInfo).tf = function () {
  return this.connector;
};
protoOf(PropHolderInfo).uf = function () {
  return this.propping;
};
protoOf(PropHolderInfo).m1m = function () {
  return this.colliderBox;
};
protoOf(PropHolderInfo).n1m = function () {
  return this.oldPropping;
};
protoOf(PropHolderInfo).o1m = function () {
  return this.shapeComponent;
};
protoOf(PropHolderInfo).j4l = function (connector, propping, colliderBox, oldPropping, shapeComponent) {
  return new PropHolderInfo(connector, propping, colliderBox, oldPropping, shapeComponent);
};
protoOf(PropHolderInfo).copy = function (connector, propping, colliderBox, oldPropping, shapeComponent, $super) {
  connector = connector === VOID ? this.connector : connector;
  propping = propping === VOID ? this.propping : propping;
  colliderBox = colliderBox === VOID ? this.colliderBox : colliderBox;
  oldPropping = oldPropping === VOID ? this.oldPropping : oldPropping;
  shapeComponent = shapeComponent === VOID ? this.shapeComponent : shapeComponent;
  return this.j4l(connector, propping, colliderBox, oldPropping, shapeComponent);
};
protoOf(PropHolderInfo).toString = function () {
  return 'PropHolderInfo(connector=' + toString(this.connector) + ', propping=' + toString_0(this.propping) + ', colliderBox=' + toString_0(this.colliderBox) + ', oldPropping=' + toString_0(this.oldPropping) + ', shapeComponent=' + toString_0(this.shapeComponent) + ')';
};
protoOf(PropHolderInfo).hashCode = function () {
  var result = this.connector.hashCode();
  result = imul(result, 31) + (this.propping == null ? 0 : this.propping.hashCode()) | 0;
  result = imul(result, 31) + (this.colliderBox == null ? 0 : hashCode(this.colliderBox)) | 0;
  result = imul(result, 31) + (this.oldPropping == null ? 0 : this.oldPropping.hashCode()) | 0;
  result = imul(result, 31) + (this.shapeComponent == null ? 0 : this.shapeComponent.hashCode()) | 0;
  return result;
};
protoOf(PropHolderInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PropHolderInfo))
    return false;
  var tmp0_other_with_cast = other instanceof PropHolderInfo ? other : THROW_CCE();
  if (!this.connector.equals(tmp0_other_with_cast.connector))
    return false;
  if (!equals(this.propping, tmp0_other_with_cast.propping))
    return false;
  if (!equals(this.colliderBox, tmp0_other_with_cast.colliderBox))
    return false;
  if (!equals(this.oldPropping, tmp0_other_with_cast.oldPropping))
    return false;
  if (!equals(this.shapeComponent, tmp0_other_with_cast.shapeComponent))
    return false;
  return true;
};
function getPropHolderInfo(_this__u8e3s4, connector) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_130().ID);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propHolderInfos;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp1_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.propping.getPropHolderInfo.<anonymous>' call
        if (element.connector.key === connector.key) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  return tmp;
}
function setPropping(_this__u8e3s4, proppingHostConnector, propping) {
  setProppingProperty(_this__u8e3s4, proppingHostConnector, setPropping$lambda(propping));
  if (!(propping == null)) {
    clearOldPropping(_this__u8e3s4, proppingHostConnector);
  }
}
function getPropping(_this__u8e3s4, connector) {
  var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propping;
}
function removePropping(_this__u8e3s4, proppingHostConnector) {
  var tmp0_elvis_lhs = getPropping(_this__u8e3s4, proppingHostConnector);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var currentPropping = tmp;
  var tmp1_safe_receiver = getOldPropping(_this__u8e3s4, proppingHostConnector);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.dispose();
  }
  setOldPropping(_this__u8e3s4, proppingHostConnector, currentPropping);
  currentPropping.removeComponent(Companion_instance_24.id);
  setPropping(_this__u8e3s4, proppingHostConnector, null);
}
function setOldPropping(_this__u8e3s4, proppingHostConnector, oldPropping) {
  setProppingProperty(_this__u8e3s4, proppingHostConnector, setOldPropping$lambda(oldPropping));
}
function restoreOldPropping(_this__u8e3s4, proppingHostConnector) {
  var propping = getOldPropping(_this__u8e3s4, proppingHostConnector);
  setOldPropping(_this__u8e3s4, proppingHostConnector, null);
  if (propping == null)
    null;
  else {
    setParentMaintainWorldTransform(propping, _this__u8e3s4);
  }
  setPropping(_this__u8e3s4, proppingHostConnector, propping);
  var tmp1_safe_receiver = getShapeComponent(_this__u8e3s4, proppingHostConnector);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.propping.restoreOldPropping.<anonymous>' call
    propping == null || propping.addComponent(tmp1_safe_receiver);
  }
  if (_this__u8e3s4.hasComponent(Companion_instance_0.f1n_1)) {
    if (propping == null)
      null;
    else
      propping.addComponent(new RenderedComponent());
  }
  setOldPropping(_this__u8e3s4, proppingHostConnector, null);
}
function getOldPropping(_this__u8e3s4, connector) {
  var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.oldPropping;
}
function clearOldPropping(_this__u8e3s4, proppingHostConnector) {
  var oldPropping = getOldPropping(_this__u8e3s4, proppingHostConnector);
  setProppingProperty(_this__u8e3s4, proppingHostConnector, clearOldPropping$lambda);
  if (!((oldPropping == null ? null : oldPropping.isDisposed) === true)) {
    if (oldPropping == null)
      null;
    else {
      oldPropping.dispose();
    }
  }
}
function setProppingProperty(_this__u8e3s4, connector, a) {
  var tmp;
  if (_this__u8e3s4.hasComponent(Companion_getInstance_130().ID)) {
    tmp = _this__u8e3s4.getComponentUnsafe(Companion_getInstance_130().ID);
  } else {
    _this__u8e3s4.addComponent(new ProppingInfoComponent(emptyList()));
    tmp = _this__u8e3s4.getComponentUnsafe(Companion_getInstance_130().ID);
  }
  var proppingComponent = tmp;
  var propHolderInfos = proppingComponent.propHolderInfos;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var tmp0_iterator = propHolderInfos.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.propping.setProppingProperty.<anonymous>' call
      if (item.connector.key === connector.key) {
        tmp$ret$1 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$1 = -1;
  }
  var propHolderInfoIndex = tmp$ret$1;
  var newPropHolderInfo = a(propHolderInfos.q(propHolderInfoIndex));
  var newPropHoldInfos = toMutableList(propHolderInfos);
  newPropHoldInfos.n2(propHolderInfoIndex, newPropHolderInfo);
  _this__u8e3s4.addComponent(new ProppingInfoComponent(newPropHoldInfos));
}
function getShapeComponent(_this__u8e3s4, connector) {
  var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shapeComponent;
}
function setPropping$lambda($propping) {
  return function (it) {
    return it.copy(VOID, $propping);
  };
}
function setOldPropping$lambda($oldPropping) {
  return function (it) {
    return it.copy(VOID, VOID, VOID, $oldPropping);
  };
}
function clearOldPropping$lambda(it) {
  return it.copy(VOID, VOID, VOID, null);
}
function ProppingSubSystem(proppingSystem) {
  var tmp = Companion_getInstance_131().ID + '-internal';
  var tmp_0 = Companion_instance_0.j1p_1;
  var tmp_1 = Companion_instance_0.q1p_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp_2 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [Companion_instance_20.ID, Companion_instance_17.ID, Companion_instance_21.h2t_1];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp$ret$3, null);
  this.v4l_1 = proppingSystem;
}
protoOf(ProppingSubSystem).w4l = function (entity, newComponent) {
  this.v4l_1.p4m(newComponent);
};
protoOf(ProppingSubSystem).v1v = function (entity, newComponent) {
  return this.w4l(entity, newComponent instanceof SomethingIsDraggedComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSubSystem).q4m = function (entity, oldComponent, newComponent) {
};
protoOf(ProppingSubSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SomethingIsDraggedComponent ? oldComponent : THROW_CCE();
  return this.q4m(entity, tmp, newComponent instanceof SomethingIsDraggedComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSubSystem).r4m = function (entity, oldComponent) {
  this.v4l_1.s4m();
};
protoOf(ProppingSubSystem).z1v = function (entity, oldComponent) {
  return this.r4m(entity, oldComponent instanceof SomethingIsDraggedComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingSubSystem).t3n = function (entity, newComponent) {
};
protoOf(ProppingSubSystem).l1z = function (entity, newComponent) {
  return this.t3n(entity, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSubSystem).u3n = function (entity, oldComponent, newComponent) {
};
protoOf(ProppingSubSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE();
  return this.u3n(entity, tmp, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSubSystem).v3n = function (entity, oldComponent) {
  this.v4l_1.s4m();
};
protoOf(ProppingSubSystem).p1z = function (entity, oldComponent) {
  return this.v3n(entity, oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE());
};
function onStartedDragging_1($this, draggedEntity) {
  if (!$this.isEnabled)
    return Unit_instance;
  var draggedHierarchy = get_hierarchy(draggedEntity);
  if (get_isPropping(draggedEntity)) {
    var tmp = $this;
    var tmp0_safe_receiver = get_parent(draggedEntity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_proppingHostConnectors(tmp0_safe_receiver);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>' call
          if (equals(getPropping(element.propHoldingEntity, element.proppingHostConnector), draggedEntity)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_0 = tmp$ret$1;
    }
    tmp.o4m_1 = tmp_0;
    var tmp2_safe_receiver = get_viewerObject(draggedEntity);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.setEnabled(false);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = draggedHierarchy.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = draggedHierarchy[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_proppingHostConnectors(element_0);
    var inductionVariable_1 = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = indexedObject[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>.<anonymous>' call
      var propping = getPropping(element_1.propHoldingEntity, element_1.proppingHostConnector);
      if (!(propping == null) && !equals(propping, draggedEntity)) {
        removePropping(element_1.propHoldingEntity, element_1.proppingHostConnector);
      }
    }
  }
}
function onDragMove($this) {
  var tmp0_safe_receiver = $this.n4m_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.__getComponentForKotlin(Companion_getInstance_31().id);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.worldPolyhedron;
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var movedPolyhedron = tmp;
  var tmp3_safe_receiver = $this.n4m_1;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : get_hierarchy(tmp3_safe_receiver);
  var tmp_0;
  if (tmp4_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp4_elvis_lhs;
  }
  var movedHierarchy = tmp_0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_proppingHostEntitiesInHierarchy($this.i4m_1.sceneManager.scene);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDragMove.<anonymous>' call
    var tmp$ret$0 = get_proppingHostConnectors(item);
    destination.h(tmp$ret$0);
  }
  var tmp$ret$3 = copyToArray(destination);
  var tmp0_iterator = flatten(tmp$ret$3).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    $l$block_1: {
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDragMove.<anonymous>' call
      if (!element.propHoldingEntity.hasComponent(Companion_instance_0.f1n_1)) {
        break $l$block_1;
      }
      var tmp0_elvis_lhs = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var propInfo = tmp_1;
      if (contains(movedHierarchy, element.propHoldingEntity)) {
        break $l$block_1;
      }
      var tmp1_safe_receiver_0 = propInfo.colliderBox;
      var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(movedPolyhedron);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.notZero();
      var hit = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
      if (hit) {
        var tmp4_safe_receiver = propInfo.propping;
        if (tmp4_safe_receiver == null)
          null;
        else
          tmp4_safe_receiver.removeComponent(Companion_instance_24.id);
      } else {
        var tmp5_safe_receiver = propInfo.propping;
        if (tmp5_safe_receiver == null)
          null;
        else
          tmp5_safe_receiver.addComponent(new RenderedComponent());
      }
    }
  }
}
function onStoppedDragging_1($this, originalEntity) {
  var theEntityThatWasDraggedIsNoLongerInScene = !get_isInScene(originalEntity);
  if (theEntityThatWasDraggedIsNoLongerInScene) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_proppingHostConnectors(originalEntity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStoppedDragging.<anonymous>' call
      var propInfo = getPropHolderInfo(originalEntity, element.proppingHostConnector);
      var tmp1_safe_receiver = propInfo == null ? null : propInfo.oldPropping;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        setOldPropping(originalEntity, element.proppingHostConnector, null);
        $this.i4m_1.entityManager.disposeEntity(tmp1_safe_receiver);
      }
    }
  }
  var tmp0_safe_receiver = $this.o4m_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var propInfo_0 = getPropHolderInfo(tmp0_safe_receiver.propHoldingEntity, tmp0_safe_receiver.proppingHostConnector);
    var tmp1_safe_receiver_0 = propInfo_0 == null ? null : propInfo_0.oldPropping;
    var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : get_viewerObject(tmp1_safe_receiver_0);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.setEnabled(true);
    }
    removePropping(tmp0_safe_receiver.propHoldingEntity, tmp0_safe_receiver.proppingHostConnector);
  }
  $this.o4m_1 = null;
}
function handleAddedEntityToScene($this, entity) {
  if (get_isPropping(entity))
    return Unit_instance;
  var tmp;
  if (entity.hasComponent(Companion_getInstance_129().ID)) {
    tmp = true;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = !(getProppingCollidingWithEntity($this, entity).length === 0);
  }
  var needToUpdatePropping = tmp;
  if (needToUpdatePropping) {
    $this.s4m();
  }
}
function onDisconnect($this, entity) {
  if (entity.isDisposed || get_isPropping(entity))
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_proppingHostConnectors(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDisconnect.<anonymous>' call
    var propInfo = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
    var tmp1_safe_receiver = propInfo == null ? null : propInfo.propping;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      if (!get_isBeingDragged(tmp1_safe_receiver)) {
        $this.i4m_1.entityManager.disposeEntity(tmp1_safe_receiver);
      }
    }
  }
}
function clearProps($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_proppingHostEntitiesInHierarchy($this.i4m_1.sceneManager.scene);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.clearProps.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = get_proppingHostConnectors(element);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.clearProps.<anonymous>.<anonymous>' call
      removePropping(element, element_0.proppingHostConnector);
    }
  }
}
function getProppingCollidingWithEntity($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_31().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var movedPolyhedron = tmp;
  var entityHierarchy = get_hierarchy(entity);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_proppingHostEntitiesInHierarchy($this.i4m_1.sceneManager.scene);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.getProppingCollidingWithEntity.<anonymous>' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = get_proppingHostConnectors(element);
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.propping.ProppingSystem.getProppingCollidingWithEntity.<anonymous>.<anonymous>' call
        if (!element_0.propHoldingEntity.hasComponent(Companion_instance_0.f1n_1)) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        if (contains(entityHierarchy, element_0.propHoldingEntity)) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        var propInfo = getPropHolderInfo(element, element_0.proppingHostConnector);
        var tmp1_safe_receiver = propInfo == null ? null : propInfo.colliderBox;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration(movedPolyhedron);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.notZero();
        tmp$ret$1 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
      }
      if (tmp$ret$1) {
        destination_0.h(element_0);
      }
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return copyToArray(destination);
}
function Companion_88() {
  Companion_instance_127 = this;
  this.ID = 'ProppingSystem';
  this.TAG_PROPPING = 'propping-connector';
  this.o4k_1 = LoggerState_getInstance().g1v('ProppingSystem');
}
protoOf(Companion_88).j1y = function () {
  return this.ID;
};
protoOf(Companion_88).t4m = function () {
  return this.TAG_PROPPING;
};
var Companion_instance_127;
function Companion_getInstance_131() {
  if (Companion_instance_127 == null)
    new Companion_88();
  return Companion_instance_127;
}
function ProppingSystem$lambda$lambda(map) {
  var tmp = map.b2();
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var tmp0_iterator = map.c2().s4k_1.h2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    var tmp_0 = sum;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.<anonymous>.<anonymous>.<anonymous>' call
    sum = tmp_0 + element.o() | 0;
  }
  return tmp + ': ' + sum;
}
function ProppingSystem$lambda(this$0) {
  return function () {
    var tmp = this$0.m4m_1.i2();
    var mappedProps = joinToString_0(tmp, ' | ', VOID, VOID, VOID, VOID, ProppingSystem$lambda$lambda);
    return 'loaded props ' + mappedProps;
  };
}
function ProppingSystem(proppingCatalog, coreServices) {
  Companion_getInstance_131();
  var tmp = Companion_getInstance_131().ID;
  var tmp_0 = Companion_getInstance_20().id;
  var tmp_1 = Companion_getInstance_3().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = [Companion_getInstance_1().j2a_1, Companion_instance_9.x29_1, Companion_instance_76.l42_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [Companion_getInstance_74().ID];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$8);
  this.i4m_1 = coreServices;
  this.j4m_1 = new ProppingSubSystem(this);
  this.k4m_1 = new SetPropHolderInfoSystem();
  this.l4m_1 = new SetProppingHostConnectorDataSystem(this.i4m_1.sceneManager);
  this.n4m_1 = null;
  this.o4m_1 = null;
  this.m4m_1 = Companion_instance_123.n4k(proppingCatalog);
  var tmp_4 = Companion_getInstance_131().o4k_1;
  tmp_4.info(ProppingSystem$lambda(this));
  this.s4m();
}
protoOf(ProppingSystem).onRegister = function () {
  protoOf(SystemBase2).onRegister.call(this);
  this.j4m_1.l2d(this.i4m_1.entityManager);
  this.k4m_1.l2d(this.i4m_1.entityManager);
  this.l4m_1.l2d(this.i4m_1.entityManager);
};
protoOf(ProppingSystem).onUnregister = function () {
  protoOf(SystemBase2).onUnregister.call(this);
  this.j4m_1.m2d(this.i4m_1.entityManager);
  this.k4m_1.m2d(this.i4m_1.entityManager);
  this.l4m_1.m2d(this.i4m_1.entityManager);
};
protoOf(ProppingSystem).enable = function () {
  protoOf(SystemBase2).enable.call(this);
  this.j4m_1.enable();
  this.k4m_1.enable();
  this.l4m_1.enable();
  this.s4m();
};
protoOf(ProppingSystem).disable = function () {
  this.j4m_1.disable();
  this.k4m_1.disable();
  this.l4m_1.disable();
  protoOf(SystemBase2).disable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_proppingHostEntitiesInHierarchy(this.i4m_1.sceneManager.scene);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.disable.<anonymous>' call
    var tmp$ret$0 = get_proppingHostConnectors(item);
    destination.h(tmp$ret$0);
  }
  var tmp$ret$3 = copyToArray(destination);
  var tmp0_iterator = flatten(tmp$ret$3).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.disable.<anonymous>' call
    var propHolderInfo = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
    var tmp1_safe_receiver = propHolderInfo == null ? null : propHolderInfo.propping;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.i4m_1.entityManager.disposeEntity(tmp1_safe_receiver);
      setPropping(element.propHoldingEntity, element.proppingHostConnector, null);
    }
  }
};
protoOf(ProppingSystem).m42 = function (entity, newComponent) {
  onStartedDragging_1(this, entity);
};
protoOf(ProppingSystem).v1v = function (entity, newComponent) {
  return this.m42(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSystem).n42 = function (entity, oldComponent, newComponent) {
  onDragMove(this);
};
protoOf(ProppingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE();
  return this.n42(entity, tmp, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSystem).o42 = function (entity, oldComponent) {
  onStoppedDragging_1(this, entity);
};
protoOf(ProppingSystem).z1v = function (entity, oldComponent) {
  return this.o42(entity, oldComponent instanceof WorldSpaceDragEventComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingSystem).u4m = function (entity, newComponent) {
  if (get_isPropping(entity))
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_snapRootSubTree(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onAddComponent2.<anonymous>' call
    handleAddedEntityToScene(this, element);
  }
};
protoOf(ProppingSystem).l1z = function (entity, newComponent) {
  return this.u4m(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSystem).v4m = function (entity, oldComponent, newComponent) {
  if (get_isPropping(entity))
    return Unit_instance;
  this.s4m();
};
protoOf(ProppingSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.v4m(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(ProppingSystem).y4d = function (entity, oldComponent) {
  if (get_isPropping(entity))
    return Unit_instance;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_snapRootSubTree(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onRemoveComponent2.<anonymous>' call
    onDisconnect(this, element);
  }
};
protoOf(ProppingSystem).p1z = function (entity, oldComponent) {
  return this.y4d(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
protoOf(ProppingSystem).dispose = function () {
  this.disable();
  this.m2d(this.i4m_1.entityManager);
};
protoOf(ProppingSystem).p4m = function (c) {
  this.n4m_1 = c.entity;
};
protoOf(ProppingSystem).s4m = function () {
  if (!this.isEnabled)
    return Unit_instance;
  clearProps(this);
  Companion_instance_123.u4k(this.m4m_1, this.i4m_1.entityManager, this.i4m_1.sceneManager, this.i4m_1.productManager);
};
function updateLargestFittingPropping($this, proppingData, proppingHolderEntity, coreServices) {
  var lastCheckedSize = -1.0;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = coreServices.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingPropping.<anonymous>' call
    var tmp;
    if (!element.hasComponent(Companion_getInstance_112().ID) && element.hasComponent(Companion_instance_4.n1s())) {
      var tmp0_safe_receiver = proppingHolderEntity.__getComponentForKotlin(Companion_getInstance_102().ID);
      tmp = !equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propping, element);
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.h(element);
    }
  }
  var existingProppingInScene = copyToArray(destination);
  // Inline function 'kotlin.collections.find' call
  var this_1 = proppingData.proppingSizePrefabs;
  var tmp$ret$9;
  $l$block_7: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp$ret$5;
      $l$block_6: {
        // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingPropping.<anonymous>' call
        var size = element_0.tf();
        var prefab = element_0.uf();
        // Inline function 'kotlin.math.abs' call
        var x = size - lastCheckedSize;
        if (Math.abs(x) < 0.01) {
          tmp$ret$5 = false;
          break $l$block_6;
        }
        var hostConnector = proppingData.proppingHostConnector;
        var tmp0_safe_receiver_0 = get_guestConnectors(prefab);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          var tmp$ret$7;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = tmp0_safe_receiver_0.k();
            while (tmp0_iterator.m()) {
              var element_1 = tmp0_iterator.n();
              // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingPropping.<anonymous>.<anonymous>' call
              if (element_1.hasMatchingTypeAndDemandsTo(hostConnector)) {
                tmp$ret$7 = element_1;
                break $l$block_0;
              }
            }
            tmp$ret$7 = null;
          }
          tmp_0 = tmp$ret$7;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          tmp$ret$5 = false;
          break $l$block_6;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var guestConnector = tmp_1;
        var tmp2_elvis_lhs = get_parent(proppingHolderEntity);
        var tmp_2;
        if (tmp2_elvis_lhs == null) {
          tmp$ret$5 = false;
          break $l$block_6;
        } else {
          tmp_2 = tmp2_elvis_lhs;
        }
        var host = tmp_2;
        var tmp3_elvis_lhs = Companion_instance_1.f30(prefab, guestConnector, host, hostConnector);
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          tmp$ret$5 = false;
          break $l$block_6;
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }
        var snap = tmp_3;
        var isAlwaysHangDown = prefab.hasComponent(AlwaysHangDownComponent_instance.id);
        if (isAlwaysHangDown && !snap.endTransform.up.equals(Companion_getInstance_15().UP)) {
          tmp$ret$5 = false;
          break $l$block_6;
        }
        snap.performMove();
        var oldCollider = prefab.__getComponentForKotlin(Companion_getInstance_19().id);
        if (proppingData.depth > -1 && proppingData.width > -1) {
          var tmp5_safe_receiver = oldCollider == null ? null : oldCollider.polyhedron;
          var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.axisAlignedBoundingBox;
          var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.center;
          var oldColliderCenter = tmp7_elvis_lhs == null ? Companion_getInstance_15().ZERO : tmp7_elvis_lhs;
          var cuboid = fromSizeAndCenter(new Vector(proppingData.width, size, proppingData.depth), oldColliderCenter);
          var newCollider = new ColliderShapeComponent(cuboid);
          prefab.addComponent(newCollider);
        }
        var collision = Companion_instance_14.e1y(prefab, null, coreServices.sceneManager.entities);
        lastCheckedSize = size;
        if (oldCollider == null)
          prefab.removeComponent(Companion_getInstance_19().id);
        else
          prefab.addComponent(oldCollider);
        if (!(collision == null)) {
          tmp$ret$5 = false;
          break $l$block_6;
        }
        var otherProppingCollision = Companion_instance_92.n49(prefab, Companion_getInstance_105().k4b_1, existingProppingInScene);
        if (otherProppingCollision == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp$ret$5 = false;
          break $l$block_6;
        }
        tmp$ret$5 = true;
      }
      if (tmp$ret$5) {
        tmp$ret$9 = element_0;
        break $l$block_7;
      }
    }
    tmp$ret$9 = null;
  }
  var largestFittingPropping = tmp$ret$9;
  if (largestFittingPropping == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingPropping.<anonymous>' call
    proppingHolderEntity.addComponent(new LargestFittingProppingComponent(largestFittingPropping));
  }
  if (largestFittingPropping == null) {
    proppingHolderEntity.removeComponent(Companion_getInstance_104().h4b_1);
  }
}
function sam$kotlin_Comparator$0_9(function_0) {
  this.w4m_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_9).md = function (a, b) {
  return this.w4m_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).s3 = function () {
  return this.w4m_1;
};
protoOf(sam$kotlin_Comparator$0_9).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_9).hashCode = function () {
  return hashCode(this.s3());
};
function ProppingUtils$Companion$updateLargestFittingProppingInScene$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>' call
  var tmp = b.getComponentUnsafe(Companion_getInstance_107().g4b_1).priority;
  // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>' call
  var tmp$ret$1 = a.getComponentUnsafe(Companion_getInstance_107().g4b_1).priority;
  return compareValues(tmp, tmp$ret$1);
}
function Companion_89() {
  this.TAG_PROPPING = 'propping-connector';
}
protoOf(Companion_89).t4m = function () {
  return this.TAG_PROPPING;
};
protoOf(Companion_89).d4d = function (proppingHostConnector) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = proppingHostConnector.tags();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.Companion.getProppingHostLocalWidth.<anonymous>' call
      if (contains_0(element, 'propping-connector-max-width:')) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var localWidthTag = tmp$ret$1;
  var tmp1_safe_receiver = localWidthTag == null ? null : substringAfter(localWidthTag, 'propping-connector-max-width:');
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  var localWidth = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  return localWidth;
};
protoOf(Companion_89).e4d = function (proppingHostConnector) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = proppingHostConnector.tags();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.Companion.getProppingHostLocalDepth.<anonymous>' call
      if (contains_0(element, 'propping-connector-max-depth:')) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var localDepthTag = tmp$ret$1;
  var tmp1_safe_receiver = localDepthTag == null ? null : substringAfter(localDepthTag, 'propping-connector-max-depth:');
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  var localDepth = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  return localDepth;
};
protoOf(Companion_89).x4m = function (proppingHolderEntity) {
  var tmp0_safe_receiver = proppingHolderEntity.__getComponentForKotlin(Companion_getInstance_104().h4b_1);
  var largestFittingPropping = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.largestFittingPropping;
  if (largestFittingPropping == null) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  var allProppingPrefabsForHolder = proppingHolderEntity.getComponentUnsafe(Companion_getInstance_107().g4b_1).proppingSizePrefabs;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var inductionVariable = 0;
    var last = allProppingPrefabsForHolder.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.propping.Companion.getAllFittingProppingSizeProppingPairs.<anonymous>' call
        if (allProppingPrefabsForHolder[index].equals(largestFittingPropping)) {
          tmp$ret$2 = index;
          break $l$block;
        }
      }
       while (inductionVariable <= last);
    tmp$ret$2 = -1;
  }
  var indexOfLargestFittingProppingPrefab = tmp$ret$2;
  var allFittingProppingSizeProppingPairs = copyOfRange(allProppingPrefabsForHolder, indexOfLargestFittingProppingPrefab, allProppingPrefabsForHolder.length);
  return allFittingProppingSizeProppingPairs;
};
protoOf(Companion_89).c4d = function (coreServices) {
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = coreServices.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_107().g4b_1)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = ProppingUtils$Companion$updateLargestFittingProppingInScene$lambda;
  var tmp$ret$3 = new sam$kotlin_Comparator$0_9(tmp);
  var sortedByDescendingPrio = sortedWith(destination, tmp$ret$3);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = sortedByDescendingPrio.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>' call
    var tmp0_safe_receiver = element_0.__getComponentForKotlin(Companion_getInstance_102().ID);
    var propping = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propping;
    if (propping == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      propping.addComponent(new TemporarilyIgnoreMyProppingFunctionalZonesComponent());
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = sortedByDescendingPrio.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>' call
    var tmp0_safe_receiver_0 = element_1.__getComponentForKotlin(Companion_getInstance_102().ID);
    var propping_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.propping;
    if (propping_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.propping.Companion.updateLargestFittingProppingInScene.<anonymous>.<anonymous>' call
      propping_0.removeComponent(Companion_getInstance_112().ID);
    }
    var proppingHostConnectorDataComponent = element_1.getComponentUnsafe(Companion_getInstance_107().g4b_1);
    updateLargestFittingPropping(Companion_instance_128, proppingHostConnectorDataComponent, element_1, coreServices);
  }
};
protoOf(Companion_89).o4e = function (proppingDataHolderEntity) {
  proppingDataHolderEntity.removeComponent(Companion_getInstance_102().ID);
};
protoOf(Companion_89).p4e = function (proppingDataHolderEntity, productRefOfProppingToPlace, coreServices) {
  var tmp0_safe_receiver = proppingDataHolderEntity.__getComponentForKotlin(Companion_getInstance_102().ID);
  var currentPropping = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propping;
  if ((currentPropping == null ? null : get_productRef(currentPropping)) === productRefOfProppingToPlace)
    return Unit_instance;
  proppingDataHolderEntity.removeComponent(Companion_getInstance_102().ID);
  var tmp2_elvis_lhs = coreServices.productManager.createEntity(productRefOfProppingToPlace);
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var newPropping = tmp;
  newPropping.removeComponent(Companion_getInstance_23().id);
  newPropping.removeComponent(Companion_getInstance_32().id);
  newPropping.removeComponent(Companion_getInstance_33().id);
  newPropping.addComponent(new UnserializableEntityComponent());
  var proppingHostConnectorData = proppingDataHolderEntity.getComponentUnsafe(Companion_getInstance_107().g4b_1);
  var host = proppingHostConnectorData.hostConnectorEntity;
  var hostConnector = proppingHostConnectorData.proppingHostConnector;
  var tmp3_safe_receiver = get_guestConnectors(newPropping);
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp3_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.propping.Companion.placePropping.<anonymous>' call
        if (element.hasMatchingTypeAndDemandsTo(hostConnector)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_0 = tmp$ret$1;
  }
  var tmp4_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp4_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp4_elvis_lhs;
  }
  var guestConnector = tmp_1;
  var snap = Companion_instance_1.createCandidate(newPropping, guestConnector, host, hostConnector);
  snap.performMoveAndConnect();
  proppingDataHolderEntity.addComponent(new CurrentProppingComponent(newPropping));
};
protoOf(Companion_89).y4m = function (productRefs, productManager) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = productRefs.length;
  while (inductionVariable < last) {
    var element = productRefs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.ikea.core.stl.propping.Companion.getProppingProductRefs.<anonymous>' call
      var tmp0_elvis_lhs = productManager.productSpecification(element);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var spec = tmp;
      tmp$ret$0 = spec.hasComponent(Companion_instance_4.n1s());
    }
    if (tmp$ret$0) {
      destination.h(element);
    }
  }
  return copyToArray(destination);
};
var Companion_instance_128;
function Companion_getInstance_132() {
  return Companion_instance_128;
}
function getAllFittingProppingSizeProppingPairs(proppingHolderEntity) {
  return Companion_instance_128.x4m(proppingHolderEntity);
}
function setEmptyFromPropping(proppingDataHolderEntity) {
  return Companion_instance_128.o4e(proppingDataHolderEntity);
}
function placePropping(proppingDataHolderEntity, productRefOfProppingToPlace, coreServices) {
  return Companion_instance_128.p4e(proppingDataHolderEntity, productRefOfProppingToPlace, coreServices);
}
function getProppingProductRefs(productRefs, productManager) {
  return Companion_instance_128.y4m(productRefs, productManager);
}
function ProppingUtils() {
}
function ProppingsAvailableForDemand(allSizes, heightProppingForSize) {
  this.r4k_1 = allSizes;
  this.s4k_1 = heightProppingForSize;
}
protoOf(ProppingsAvailableForDemand).toString = function () {
  return 'ProppingsAvailableForDemand(allSizes=' + toString(this.r4k_1) + ', heightProppingForSize=' + toString(this.s4k_1) + ')';
};
protoOf(ProppingsAvailableForDemand).hashCode = function () {
  var result = hashCode(this.r4k_1);
  result = imul(result, 31) + hashCode(this.s4k_1) | 0;
  return result;
};
protoOf(ProppingsAvailableForDemand).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProppingsAvailableForDemand))
    return false;
  var tmp0_other_with_cast = other instanceof ProppingsAvailableForDemand ? other : THROW_CCE();
  if (!equals(this.r4k_1, tmp0_other_with_cast.r4k_1))
    return false;
  if (!equals(this.s4k_1, tmp0_other_with_cast.s4k_1))
    return false;
  return true;
};
function Companion_90() {
  this.z4m_1 = 'SetPropHolderInfoSystem';
}
var Companion_instance_129;
function Companion_getInstance_133() {
  return Companion_instance_129;
}
function SetPropHolderInfoSystem() {
  var tmp = Companion_instance_129.z4m_1;
  var tmp_0 = Companion_instance_0.y1m_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_instance_0.e1q_1];
  SystemBase.call(this, tmp, tmp_0, tmp$ret$2);
}
protoOf(SetPropHolderInfoSystem).n1s = function () {
  return Companion_instance_129.z4m_1;
};
protoOf(SetPropHolderInfoSystem).j4n = function (entity, newComponent) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = newComponent.proppingHostConnectors;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.SetPropHolderInfoSystem.onAddComponent.<anonymous>' call
    var tmp$ret$0 = new PropHolderInfo(item.proppingHostConnector, null, null, null);
    destination.h(tmp$ret$0);
  }
  var newInfoComponent = new ProppingInfoComponent(destination);
  entity.addComponent(newInfoComponent);
};
protoOf(SetPropHolderInfoSystem).v1v = function (entity, newComponent) {
  return this.j4n(entity, newComponent instanceof ProppingHostConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(SetPropHolderInfoSystem).k4n = function (entity, oldComponent, newComponent) {
};
protoOf(SetPropHolderInfoSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ProppingHostConnectorsComponent ? oldComponent : THROW_CCE();
  return this.k4n(entity, tmp, newComponent instanceof ProppingHostConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(SetPropHolderInfoSystem).l4n = function (entity, oldComponent) {
};
protoOf(SetPropHolderInfoSystem).z1v = function (entity, oldComponent) {
  return this.l4n(entity, oldComponent instanceof ProppingHostConnectorsComponent ? oldComponent : THROW_CCE());
};
function handleEntityAddedToScene($this, entity) {
  var tmp0_safe_receiver = get_connectorsComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp1_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.handleEntityAddedToScene.<anonymous>' call
      if (element.hasTag(Companion_getInstance_131().TAG_PROPPING)) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = tmp2_safe_receiver.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.handleEntityAddedToScene.<anonymous>' call
      var tmp_1 = element_0.u2b();
      var list = map(tmp_1, SetProppingHostConnectorDataSystem$handleEntityAddedToScene$lambda(entity));
      addAll_0(destination_0, list);
    }
    tmp_0 = destination_0;
  }
  var proppingHostConnectorData = tmp_0;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(proppingHostConnectorData == null || proppingHostConnectorData.r())) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$7 = copyToArray(proppingHostConnectorData);
    entity.addComponent(new ProppingHostConnectorsComponent(tmp$ret$7));
  }
}
function Companion_91() {
  this.m4n_1 = 'SetPropHolderDataSystem';
}
var Companion_instance_130;
function Companion_getInstance_134() {
  return Companion_instance_130;
}
function SetProppingHostConnectorDataSystem$handleEntityAddedToScene$lambda($entity) {
  return function (subHostConnector) {
    return new ProppingHostConnectorData($entity, subHostConnector);
  };
}
function SetProppingHostConnectorDataSystem(sceneManager) {
  var tmp = Companion_instance_130.m4n_1;
  var tmp_0 = Companion_instance_0.b1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_instance_0.y1m_1];
  SystemBase.call(this, tmp, tmp_0, tmp$ret$2);
  this.w4n_1 = sceneManager;
}
protoOf(SetProppingHostConnectorDataSystem).n1s = function () {
  return Companion_instance_130.m4n_1;
};
protoOf(SetProppingHostConnectorDataSystem).enable = function () {
  protoOf(SystemBase).enable.call(this);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.w4n_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.enable.<anonymous>' call
    handleEntityAddedToScene(this, element);
  }
};
protoOf(SetProppingHostConnectorDataSystem).t32 = function (entity, newComponent) {
  handleEntityAddedToScene(this, entity);
};
protoOf(SetProppingHostConnectorDataSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(SetProppingHostConnectorDataSystem).u32 = function (entity, oldComponent, newComponent) {
};
protoOf(SetProppingHostConnectorDataSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.u32(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(SetProppingHostConnectorDataSystem).v32 = function (entity, oldComponent) {
};
protoOf(SetProppingHostConnectorDataSystem).z1v = function (entity, oldComponent) {
  return this.v32(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
function Companion_92() {
  Companion_instance_131 = this;
  this.id = Companion_instance_0.d1o_1;
}
protoOf(Companion_92).n1s = function () {
  return this.id;
};
var Companion_instance_131;
function Companion_getInstance_135() {
  if (Companion_instance_131 == null)
    new Companion_92();
  return Companion_instance_131;
}
function CommunicationSizeComponent(size) {
  Companion_getInstance_135();
  this.size = size;
}
protoOf(CommunicationSizeComponent).o = function () {
  return this.size;
};
protoOf(CommunicationSizeComponent).p1s = function () {
  return Companion_getInstance_135().id;
};
protoOf(CommunicationSizeComponent).eq = function (other) {
  return (other instanceof CommunicationSizeComponent ? other : THROW_CCE()).size.equals(this.size);
};
function Companion_93() {
  Companion_instance_132 = this;
  this.id = Companion_instance_0.a1o_1;
}
protoOf(Companion_93).n1s = function () {
  return this.id;
};
var Companion_instance_132;
function Companion_getInstance_136() {
  if (Companion_instance_132 == null)
    new Companion_93();
  return Companion_instance_132;
}
function DoorComponent() {
  Companion_getInstance_136();
  this.x4n_1 = Companion_getInstance_136().id;
}
protoOf(DoorComponent).p1s = function () {
  return this.x4n_1;
};
protoOf(DoorComponent).eq = function (other) {
  return true;
};
function DoorFrontComponent_0() {
  DoorFrontComponent_instance = this;
  this.y4n_1 = this.id;
}
protoOf(DoorFrontComponent_0).p1s = function () {
  return this.y4n_1;
};
protoOf(DoorFrontComponent_0).n1s = function () {
  return Companion_instance_0.c1o_1;
};
protoOf(DoorFrontComponent_0).eq = function (other) {
  return true;
};
var DoorFrontComponent_instance;
function DoorFrontComponent_getInstance() {
  if (DoorFrontComponent_instance == null)
    new DoorFrontComponent_0();
  return DoorFrontComponent_instance;
}
function DrawerComponent_0() {
  DrawerComponent_instance = this;
  this.z4n_1 = this.id;
}
protoOf(DrawerComponent_0).p1s = function () {
  return this.z4n_1;
};
protoOf(DrawerComponent_0).n1s = function () {
  return Companion_instance_0.t1o_1;
};
protoOf(DrawerComponent_0).eq = function (other) {
  return true;
};
var DrawerComponent_instance;
function DrawerComponent_getInstance() {
  if (DrawerComponent_instance == null)
    new DrawerComponent_0();
  return DrawerComponent_instance;
}
function FrameComponent_0() {
  FrameComponent_instance = this;
  this.a4o_1 = this.id;
}
protoOf(FrameComponent_0).p1s = function () {
  return this.a4o_1;
};
protoOf(FrameComponent_0).n1s = function () {
  return Companion_instance_0.b1o_1;
};
protoOf(FrameComponent_0).eq = function (other) {
  return true;
};
var FrameComponent_instance;
function FrameComponent_getInstance() {
  if (FrameComponent_instance == null)
    new FrameComponent_0();
  return FrameComponent_instance;
}
function HandleComponent_0() {
  HandleComponent_instance = this;
  this.b4o_1 = this.id;
}
protoOf(HandleComponent_0).p1s = function () {
  return this.b4o_1;
};
protoOf(HandleComponent_0).n1s = function () {
  return Companion_instance_0.i1o_1;
};
protoOf(HandleComponent_0).eq = function (other) {
  return true;
};
var HandleComponent_instance;
function HandleComponent_getInstance() {
  if (HandleComponent_instance == null)
    new HandleComponent_0();
  return HandleComponent_instance;
}
function IncludedHandleComponent_0() {
  IncludedHandleComponent_instance = this;
  this.c4o_1 = this.id;
}
protoOf(IncludedHandleComponent_0).p1s = function () {
  return this.c4o_1;
};
protoOf(IncludedHandleComponent_0).n1s = function () {
  return Companion_instance_0.p1o_1;
};
protoOf(IncludedHandleComponent_0).eq = function (other) {
  return true;
};
var IncludedHandleComponent_instance;
function IncludedHandleComponent_getInstance() {
  if (IncludedHandleComponent_instance == null)
    new IncludedHandleComponent_0();
  return IncludedHandleComponent_instance;
}
function LegComponent_0() {
  LegComponent_instance = this;
  this.d4o_1 = this.id;
}
protoOf(LegComponent_0).p1s = function () {
  return this.d4o_1;
};
protoOf(LegComponent_0).n1s = function () {
  return Companion_instance_0.r1o_1;
};
protoOf(LegComponent_0).eq = function (other) {
  return true;
};
var LegComponent_instance;
function LegComponent_getInstance() {
  if (LegComponent_instance == null)
    new LegComponent_0();
  return LegComponent_instance;
}
function Companion_94() {
  Companion_instance_133 = this;
  this.id = Companion_instance_0.g1p_1;
}
protoOf(Companion_94).n1s = function () {
  return this.id;
};
var Companion_instance_133;
function Companion_getInstance_137() {
  if (Companion_instance_133 == null)
    new Companion_94();
  return Companion_instance_133;
}
function LightComponent(type) {
  Companion_getInstance_137();
  this.type = type;
  this.e4o_1 = Companion_getInstance_137().id;
}
protoOf(LightComponent).w2a = function () {
  return this.type;
};
protoOf(LightComponent).p1s = function () {
  return this.e4o_1;
};
protoOf(LightComponent).eq = function (other) {
  return this.e4o_1 === other.typeId;
};
function SerializableCatalogInterceptor() {
}
function rollbackAndCollectFailedResult($this, replacePartsResult, failedReplaces, connectionRoot) {
  // Inline function 'kotlin.collections.onEach' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.onEach.<anonymous>' call
  var tmp0_iterator = replacePartsResult.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.replace.Companion.rollbackAndCollectFailedResult.<anonymous>' call
    if (element.valid) {
      var tmp0_safe_receiver = element.rollback;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_safe_receiver();
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(failedReplaces, 10));
  var tmp0_iterator_0 = failedReplaces.k();
  while (tmp0_iterator_0.m()) {
    var item = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.replace.Companion.rollbackAndCollectFailedResult.<anonymous>' call
    var tmp0_elvis_lhs = item.newEntity;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? item.originalEntity : tmp0_elvis_lhs;
    var ent = tmp1_elvis_lhs == null ? connectionRoot : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = item.errorMessage;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? get_displayName(ent) : tmp2_elvis_lhs;
    var msg = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    var tmp$ret$3 = Companion_instance_2.fail(msg, get_productRef(ent), null);
    destination.h(tmp$ret$3);
  }
  var errors = copyToArray(destination);
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$7 = [];
  return new PlacementResult(tmp$ret$7, errors, null);
}
function findPart($this, connectionRoot, partKey) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_descendants(connectionRoot);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.replace.Companion.findPart.<anonymous>' call
      if (get_partKey(element) === partKey) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function internalCreateActionForReplaceProductPart($this, connectionRoot, partKey, entityToRemove, entityToAdd, productManager, entityManager, validationService, sceneManager) {
  var tmp0_elvis_lhs = getAssemblyStructure($this, connectionRoot, productManager);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_instance_135.fail(null, 'Can only replace part if the product root has an assembly structure', entityToRemove, entityToAdd);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var assemblyStructure = tmp;
  var oldParent = entityToRemove == null ? null : get_parent(entityToRemove);
  var tmp2_elvis_lhs = findPartAndParentPart(assemblyStructure.parts, partKey);
  var _destruct__k2r9zo = tmp2_elvis_lhs == null ? new Pair(null, null) : tmp2_elvis_lhs;
  var assemblyPart = _destruct__k2r9zo.tf();
  var parentPart = _destruct__k2r9zo.uf();
  var tmp_0;
  if (assemblyPart == null) {
    $this.t4i_1.warn(ReplaceAssemblyPartUtils$Companion$internalCreateActionForReplaceProductPart$lambda(partKey, connectionRoot));
    tmp_0 = new ReplacePartResult(true, null, null, null, null);
  } else if (!(entityToRemove == null)) {
    if (oldParent == null)
      return Companion_instance_135.fail(null, 'Old part did not have a parent. This is an illegal state', entityToRemove, entityToAdd);
    var tmp_1;
    if (entityToAdd == null) {
      tmp_1 = createRemovePartAction($this, entityToRemove, assemblyPart, oldParent, entityToAdd, entityManager, validationService);
    } else {
      tmp_1 = createReplacePartAction($this, entityToAdd, entityToRemove, assemblyPart, oldParent, entityManager, validationService, sceneManager);
    }
    tmp_0 = tmp_1;
  } else if (!(entityToAdd == null)) {
    tmp_0 = createAddPartAction($this, parentPart, connectionRoot, entityToAdd, assemblyPart, entityToRemove, entityManager, validationService);
  } else {
    tmp_0 = new ReplacePartResult(true, null, null, null, null);
  }
  return tmp_0;
}
function getAssemblyStructure($this, connectionRoot, productManager) {
  var connectionRootProductRef = get_productRef(connectionRoot);
  var tmp;
  if (connectionRootProductRef == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.replace.Companion.getAssemblyStructure.<anonymous>' call
    tmp = productManager.productSpecification(connectionRootProductRef);
  }
  var oldAssemblySpecification = tmp;
  var structureFromSpecification = oldAssemblySpecification == null ? null : oldAssemblySpecification.findComponent(Companion_getInstance_34().id);
  return structureFromSpecification == null ? connectionRoot.__getComponentForKotlin(Companion_getInstance_34().id) : structureFromSpecification;
}
function createAddPartAction($this, parentPart, connectionRoot, entityToAdd, assemblyPart, entityToRemove, entityManager, validationService) {
  var tmp;
  if (parentPart == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.replace.Companion.createAddPartAction.<anonymous>' call
    // Inline function 'kotlin.sequences.find' call
    var this_0 = hierarchyExceptSubTreesWithComponentSequence(connectionRoot, Companion_getInstance().id);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.replace.Companion.createAddPartAction.<anonymous>.<anonymous>' call
        if (get_partKey(element) === parentPart.partKey) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp1_elvis_lhs = tmp;
  var parent = tmp1_elvis_lhs == null ? connectionRoot : tmp1_elvis_lhs;
  var replaceAction = new AddPartAction(entityToAdd, assemblyPart, parent, entityManager, validationService);
  var tmp_0 = Companion_instance_135;
  var tmp_1 = AddPartAction$perform$ref(replaceAction);
  return tmp_0.ok(tmp_1, AddPartAction$rollback$ref(replaceAction), entityToRemove, entityToAdd);
}
function createReplacePartAction($this, entityToAdd, entityToRemove, assemblyPart, oldParent, entityManager, validationService, sceneManager) {
  Companion_instance_8.z1l(entityToAdd, get_worldTransform(entityToRemove));
  var replaceAction = new ReplacePartAction(entityToRemove, entityToAdd, assemblyPart, oldParent, entityManager, validationService, sceneManager);
  var tmp = Companion_instance_135;
  var tmp_0 = ReplacePartAction$perform$ref(replaceAction);
  return tmp.ok(tmp_0, ReplacePartAction$rollback$ref(replaceAction), entityToRemove, entityToAdd);
}
function createRemovePartAction($this, entityToRemove, assemblyPart, oldParent, entityToAdd, entityManager, validationService) {
  var removePartAction = new RemovePartAction(entityToRemove, assemblyPart, oldParent, entityManager, validationService);
  var tmp = Companion_instance_135;
  var tmp_0 = RemovePartAction$perform$ref(removePartAction);
  return tmp.ok(tmp_0, RemovePartAction$rollback$ref(removePartAction), entityToRemove, entityToAdd);
}
function ReplaceAssemblyPartUtils$Companion$replaceProductParts$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return Unit_instance;
}
function ReplaceAssemblyPartUtils$Companion$createActionForReplaceProductPart$lambda($msg) {
  return function () {
    return $msg;
  };
}
function ReplaceAssemblyPartUtils$Companion$internalCreateActionForReplaceProductPart$lambda($partKey, $connectionRoot) {
  return function () {
    return 'partKey ' + $partKey + ' does not exist in the product hierarchy of ' + $connectionRoot.toString() + '. Will be ignored.';
  };
}
function AddPartAction$perform$ref($boundThis) {
  var l = function () {
    $boundThis.f1l();
    return Unit_instance;
  };
  l.callableName = 'perform';
  return l;
}
function AddPartAction$rollback$ref($boundThis) {
  var l = function () {
    $boundThis.v1k();
    return Unit_instance;
  };
  l.callableName = 'rollback';
  return l;
}
function ReplacePartAction$perform$ref($boundThis) {
  var l = function () {
    $boundThis.f1l();
    return Unit_instance;
  };
  l.callableName = 'perform';
  return l;
}
function ReplacePartAction$rollback$ref($boundThis) {
  var l = function () {
    $boundThis.v1k();
    return Unit_instance;
  };
  l.callableName = 'rollback';
  return l;
}
function RemovePartAction$perform$ref($boundThis) {
  var l = function () {
    $boundThis.f1l();
    return Unit_instance;
  };
  l.callableName = 'perform';
  return l;
}
function RemovePartAction$rollback$ref($boundThis) {
  var l = function () {
    $boundThis.v1k();
    return Unit_instance;
  };
  l.callableName = 'rollback';
  return l;
}
function Companion_95() {
  Companion_instance_134 = this;
  this.s4i_1 = '';
  this.t4i_1 = LoggerState_getInstance().g1v('ReplaceAssemblyPartUtils');
}
protoOf(Companion_95).u4i = function (connectionRoot, partsMap, coreServices, onReplace) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(partsMap.length);
  var inductionVariable = 0;
  var last = partsMap.length;
  while (inductionVariable < last) {
    var item = partsMap[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.replace.Companion.replaceProductParts.<anonymous>' call
    var result = Companion_getInstance_138().f4o(connectionRoot, item.partKey, item.productRef, coreServices);
    var tmp0_safe_receiver = result.perform;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    destination.h(result);
  }
  var replacePartsResults = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = replacePartsResults.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.replace.Companion.replaceProductParts.<anonymous>' call
    if (!element.valid) {
      destination_0.h(element);
    }
  }
  var failedReplaces = destination_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!failedReplaces.r()) {
    return rollbackAndCollectFailedResult(this, replacePartsResults, failedReplaces, connectionRoot);
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = replacePartsResults.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.replace.Companion.replaceProductParts.<anonymous>' call
      if (element_0.valid && !(element_0.perform == null)) {
        destination_1.h(element_0);
      }
    }
    var validReplaceResults = destination_1;
    // Inline function 'kotlin.collections.onEach' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.onEach.<anonymous>' call
    var tmp0_iterator_1 = validReplaceResults.k();
    while (tmp0_iterator_1.m()) {
      var element_1 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.replace.Companion.replaceProductParts.<anonymous>' call
      if (!(element_1.originalEntity == null) && !(element_1.newEntity == null)) {
        onReplace(element_1.originalEntity, element_1.newEntity);
      }
    }
    Companion_instance_25.y1l(connectionRoot);
  }
  return Companion_instance_115.z4h(connectionRoot);
};
protoOf(Companion_95).replaceProductParts$default = function (connectionRoot, partsMap, coreServices, onReplace, $super) {
  var tmp;
  if (onReplace === VOID) {
    tmp = ReplaceAssemblyPartUtils$Companion$replaceProductParts$lambda;
  } else {
    tmp = onReplace;
  }
  onReplace = tmp;
  return $super === VOID ? this.u4i(connectionRoot, partsMap, coreServices, onReplace) : $super.u4i.call(this, connectionRoot, partsMap, coreServices, onReplace);
};
protoOf(Companion_95).f4o = function (connectionRoot, partKey, productRef, coreServices) {
  var originalPart = findPart(this, connectionRoot, partKey);
  var notSameProduct = !(productRef === (originalPart == null ? null : get_productRef(originalPart)));
  var tmp;
  if (originalPart == null && productRef === this.s4i_1) {
    tmp = new ReplacePartResult(true, null, null, originalPart);
  } else if (notSameProduct) {
    var tmp_0;
    if (productRef === this.s4i_1) {
      tmp_0 = null;
    } else {
      var newEntity = coreServices.productManager.createEntity(productRef);
      if (newEntity == null) {
        var msg = 'Trying to replace ' + (originalPart == null ? null : get_productRef(originalPart)) + ' with an invalid product ref.';
        this.t4i_1.error(ReplaceAssemblyPartUtils$Companion$createActionForReplaceProductPart$lambda(msg));
        return Companion_instance_135.fail(null, msg, originalPart, null);
      }
      tmp_0 = newEntity;
    }
    var newPart = tmp_0;
    tmp = internalCreateActionForReplaceProductPart(this, connectionRoot, partKey, originalPart, newPart, coreServices.productManager, coreServices.entityManager, coreServices.validations, coreServices.sceneManager);
  } else {
    tmp = new ReplacePartResult(true, null, null, null, originalPart);
  }
  return tmp;
};
var Companion_instance_134;
function Companion_getInstance_138() {
  if (Companion_instance_134 == null)
    new Companion_95();
  return Companion_instance_134;
}
function replaceProductParts(connectionRoot, partsMap, coreServices, onReplace) {
  return Companion_getInstance_138().u4i(connectionRoot, partsMap, coreServices, onReplace);
}
function replaceProductParts_0(connectionRoot, partsMap, coreServices, onReplace, $super) {
  var tmp;
  if (onReplace === VOID) {
    tmp = ReplaceAssemblyPartUtils$replaceProductParts$lambda;
  } else {
    tmp = onReplace;
  }
  onReplace = tmp;
  return replaceProductParts(connectionRoot, partsMap, coreServices, onReplace);
}
function createActionForReplaceProductPart(connectionRoot, partKey, productRef, coreServices) {
  return Companion_getInstance_138().f4o(connectionRoot, partKey, productRef, coreServices);
}
function ReplaceAssemblyPartUtils$replaceProductParts$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return Unit_instance;
}
function ReplaceAssemblyPartUtils() {
  Companion_getInstance_138();
}
function findPartAndParentPart(assemblyParts, partKey, parentPart) {
  parentPart = parentPart === VOID ? null : parentPart;
  var tmp;
  if (assemblyParts == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = assemblyParts.length;
    while (inductionVariable < last) {
      var element = assemblyParts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.replace.findPartAndParentPart.<anonymous>' call
      var tmp_0;
      if (element.partKey === partKey) {
        tmp_0 = new Pair(element, parentPart);
      } else {
        tmp_0 = findPartAndParentPart(element.children, partKey, element);
      }
      var tmp0_safe_receiver = tmp_0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  return tmp1_safe_receiver == null ? null : firstOrNull_1(tmp1_safe_receiver);
}
function Companion_96() {
}
protoOf(Companion_96).fail = function (rollback, errorMessage, originalEntity, newEntity) {
  return new ReplacePartResult(false, null, rollback, errorMessage, originalEntity, newEntity);
};
protoOf(Companion_96).ok = function (perform, rollback, originalEntity, newEntity) {
  return new ReplacePartResult(true, perform, rollback, null, originalEntity, newEntity);
};
var Companion_instance_135;
function Companion_getInstance_139() {
  return Companion_instance_135;
}
function ReplacePartResult(valid, perform, rollback, errorMessage, originalEntity, newEntity) {
  perform = perform === VOID ? null : perform;
  rollback = rollback === VOID ? null : rollback;
  errorMessage = errorMessage === VOID ? null : errorMessage;
  originalEntity = originalEntity === VOID ? null : originalEntity;
  newEntity = newEntity === VOID ? null : newEntity;
  this.valid = valid;
  this.perform = perform;
  this.rollback = rollback;
  this.errorMessage = errorMessage;
  this.originalEntity = originalEntity;
  this.newEntity = newEntity;
}
protoOf(ReplacePartResult).e3h = function () {
  return this.valid;
};
protoOf(ReplacePartResult).g4o = function () {
  return this.perform;
};
protoOf(ReplacePartResult).h4o = function () {
  return this.rollback;
};
protoOf(ReplacePartResult).i4o = function () {
  return this.errorMessage;
};
protoOf(ReplacePartResult).j3w = function () {
  return this.originalEntity;
};
protoOf(ReplacePartResult).j4o = function () {
  return this.newEntity;
};
protoOf(ReplacePartResult).tf = function () {
  return this.valid;
};
protoOf(ReplacePartResult).uf = function () {
  return this.perform;
};
protoOf(ReplacePartResult).m1m = function () {
  return this.rollback;
};
protoOf(ReplacePartResult).n1m = function () {
  return this.errorMessage;
};
protoOf(ReplacePartResult).o1m = function () {
  return this.originalEntity;
};
protoOf(ReplacePartResult).p1m = function () {
  return this.newEntity;
};
protoOf(ReplacePartResult).k4o = function (valid, perform, rollback, errorMessage, originalEntity, newEntity) {
  return new ReplacePartResult(valid, perform, rollback, errorMessage, originalEntity, newEntity);
};
protoOf(ReplacePartResult).copy = function (valid, perform, rollback, errorMessage, originalEntity, newEntity, $super) {
  valid = valid === VOID ? this.valid : valid;
  perform = perform === VOID ? this.perform : perform;
  rollback = rollback === VOID ? this.rollback : rollback;
  errorMessage = errorMessage === VOID ? this.errorMessage : errorMessage;
  originalEntity = originalEntity === VOID ? this.originalEntity : originalEntity;
  newEntity = newEntity === VOID ? this.newEntity : newEntity;
  return this.k4o(valid, perform, rollback, errorMessage, originalEntity, newEntity);
};
protoOf(ReplacePartResult).toString = function () {
  return 'ReplacePartResult(valid=' + this.valid + ', perform=' + toString_0(this.perform) + ', rollback=' + toString_0(this.rollback) + ', errorMessage=' + this.errorMessage + ', originalEntity=' + toString_0(this.originalEntity) + ', newEntity=' + toString_0(this.newEntity) + ')';
};
protoOf(ReplacePartResult).hashCode = function () {
  var result = getBooleanHashCode(this.valid);
  result = imul(result, 31) + (this.perform == null ? 0 : hashCode(this.perform)) | 0;
  result = imul(result, 31) + (this.rollback == null ? 0 : hashCode(this.rollback)) | 0;
  result = imul(result, 31) + (this.errorMessage == null ? 0 : getStringHashCode(this.errorMessage)) | 0;
  result = imul(result, 31) + (this.originalEntity == null ? 0 : this.originalEntity.hashCode()) | 0;
  result = imul(result, 31) + (this.newEntity == null ? 0 : this.newEntity.hashCode()) | 0;
  return result;
};
protoOf(ReplacePartResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ReplacePartResult))
    return false;
  var tmp0_other_with_cast = other instanceof ReplacePartResult ? other : THROW_CCE();
  if (!(this.valid === tmp0_other_with_cast.valid))
    return false;
  if (!equals(this.perform, tmp0_other_with_cast.perform))
    return false;
  if (!equals(this.rollback, tmp0_other_with_cast.rollback))
    return false;
  if (!(this.errorMessage == tmp0_other_with_cast.errorMessage))
    return false;
  if (!equals(this.originalEntity, tmp0_other_with_cast.originalEntity))
    return false;
  if (!equals(this.newEntity, tmp0_other_with_cast.newEntity))
    return false;
  return true;
};
function ReplacePlacementResult(replacedEntityResult, childrenResult) {
  this.replacedEntityResult = replacedEntityResult;
  this.childrenResult = childrenResult;
  this.l4o_1 = 0;
}
protoOf(ReplacePlacementResult).m4o = function () {
  return this.replacedEntityResult;
};
protoOf(ReplacePlacementResult).n4o = function () {
  return this.childrenResult;
};
protoOf(ReplacePlacementResult).equals = function (other) {
  return this === other;
};
protoOf(ReplacePlacementResult).hashCode = function () {
  if (this.l4o_1 === 0) {
    this.l4o_1 = hashCode(this.replacedEntityResult) + contentHashCode(this.childrenResult) | 0;
  }
  return this.l4o_1;
};
protoOf(ReplacePlacementResult).tf = function () {
  return this.replacedEntityResult;
};
protoOf(ReplacePlacementResult).uf = function () {
  return this.childrenResult;
};
protoOf(ReplacePlacementResult).o4o = function (replacedEntityResult, childrenResult) {
  return new ReplacePlacementResult(replacedEntityResult, childrenResult);
};
protoOf(ReplacePlacementResult).copy = function (replacedEntityResult, childrenResult, $super) {
  replacedEntityResult = replacedEntityResult === VOID ? this.replacedEntityResult : replacedEntityResult;
  childrenResult = childrenResult === VOID ? this.childrenResult : childrenResult;
  return this.o4o(replacedEntityResult, childrenResult);
};
protoOf(ReplacePlacementResult).toString = function () {
  return 'ReplacePlacementResult(replacedEntityResult=' + this.replacedEntityResult.toString() + ', childrenResult=' + toString(this.childrenResult) + ')';
};
function replaceEntityInternal($this, entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, doItFast, coreServices) {
  var hostedEntitiesBeforeReplace = get_guests(entityToRemove);
  Companion_instance_8.z1l(entityToAdd, get_worldTransform(entityToRemove));
  if (doItFast) {
    (new FastReplaceAction(entityToRemove, entityToAdd, coreServices.entityManager, null, coreServices.sceneManager)).f1l();
  } else {
    (new ReplaceAction(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, null, coreServices.sceneManager)).f1l();
  }
  if (get_parent(entityToAdd) == null) {
    var tmp = Companion_instance_115;
    var tmp0_elvis_lhs = get_productRef(entityToAdd);
    var tmp_0 = tmp.failWithMessage$default('The new entity could not snap to scene', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return new ReplacePlacementResult(tmp_0, tmp$ret$0);
  }
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.replace.Companion.replaceEntityInternal.<anonymous>' call
  coreServices.validations;
  var mainResult = Companion_instance_115.y4h(coreServices.validations.validateCurrentState(entityToAdd, false), entityToAdd);
  var childrenResult = validateChildren($this, entityToAdd, hostedEntitiesBeforeReplace, coreServices.validations);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(childrenResult);
  return new ReplacePlacementResult(mainResult, tmp$ret$3);
}
function validateChildren($this, entityToAdd, childrenBeforeReplace, validationService) {
  var hostedEntitiesAfterReplace = get_guests(entityToAdd);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = childrenBeforeReplace.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.replace.Companion.validateChildren.<anonymous>' call
    if (!element.isDisposed) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var item = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.replace.Companion.validateChildren.<anonymous>' call
    var existsAfterReplace = hostedEntitiesAfterReplace.s(item);
    var tmp;
    if (existsAfterReplace) {
      tmp = validationService == null ? null : validationService.validateCurrentState(item);
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [new ValidationResultFail('Descendant entity ' + item.toString() + ' was removed during replace. Possibly because no matching connectors were found', get_productRefOrEmptyString(item), null)];
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var validationResults = tmp_0;
    var tmp$ret$7 = Companion_instance_115.y4h(validationResults, item);
    destination_0.h(tmp$ret$7);
  }
  return destination_0;
}
function Companion_97() {
}
protoOf(Companion_97).p4i = function (entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, coreServices) {
  var tmp0_safe_receiver = get_parent(entityToRemove);
  var doItFast = (tmp0_safe_receiver == null ? null : get_isAutomaticGroup(tmp0_safe_receiver)) === true;
  return replaceEntityInternal(this, entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, doItFast, coreServices);
};
protoOf(Companion_97).q4i = function (entityToRemove, entityToAdd, coreServices) {
  return replaceEntityInternal(this, entityToRemove, entityToAdd, 0.0, true, coreServices);
};
var Companion_instance_136;
function Companion_getInstance_140() {
  return Companion_instance_136;
}
function replaceEntity(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, coreServices) {
  return Companion_instance_136.p4i(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, coreServices);
}
function fastReplaceEntity(entityToRemove, entityToAdd, coreServices) {
  return Companion_instance_136.q4i(entityToRemove, entityToAdd, coreServices);
}
function ReplaceUtils() {
}
function RoomDimensionsComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_98() {
  Companion_instance_137 = this;
  this.id = Companion_instance_0.k1o_1;
  this.serializationKey = 'RoomDimensionsComponent';
  var tmp = this;
  tmp.p4o_1 = Json(VOID, RoomDimensionsComponent$Companion$serializer$lambda);
}
protoOf(Companion_98).n1s = function () {
  return this.id;
};
protoOf(Companion_98).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_98).x1s = function (json) {
  return this.p4o_1.y16(this.z18(), json);
};
protoOf(Companion_98).z18 = function () {
  return $serializer_getInstance_1();
};
var Companion_instance_137;
function Companion_getInstance_141() {
  if (Companion_instance_137 == null)
    new Companion_98();
  return Companion_instance_137;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.component.RoomDimensionsComponent', this, 2);
  tmp0_serialDesc.lw('d', false);
  tmp0_serialDesc.lw('serializable', true);
  this.q4o_1 = tmp0_serialDesc;
}
protoOf($serializer).r4o = function (encoder, value) {
  var tmp0_desc = this.q4o_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance(), value.dimensions);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.s4o_1 === false)) {
    tmp1_output.iq(tmp0_desc, 1, value.s4o_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer).ul = function (encoder, value) {
  return this.r4o(encoder, value instanceof RoomDimensionsComponent ? value : THROW_CCE());
};
protoOf($serializer).vl = function (decoder) {
  var tmp0_desc = this.q4o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = false;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.dp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.dp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return RoomDimensionsComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer).tl = function () {
  return this.q4o_1;
};
protoOf($serializer).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function RoomDimensionsComponent_init_$Init$(seen0, dimensions, serializable, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().q4o_1);
  }
  $this.dimensions = dimensions;
  if (0 === (seen0 & 2))
    $this.s4o_1 = false;
  else
    $this.s4o_1 = serializable;
  return $this;
}
function RoomDimensionsComponent_init_$Create$(seen0, dimensions, serializable, serializationConstructorMarker) {
  return RoomDimensionsComponent_init_$Init$(seen0, dimensions, serializable, serializationConstructorMarker, objectCreate(protoOf(RoomDimensionsComponent)));
}
function RoomDimensionsComponent(dimensions) {
  Companion_getInstance_141();
  this.dimensions = dimensions;
  this.s4o_1 = false;
}
protoOf(RoomDimensionsComponent).t4o = function () {
  return this.dimensions;
};
protoOf(RoomDimensionsComponent).p1s = function () {
  return Companion_getInstance_141().id;
};
protoOf(RoomDimensionsComponent).r1s = function () {
  return this.s4o_1;
};
protoOf(RoomDimensionsComponent).toJson = function (parse) {
  return Companion_getInstance_141().p4o_1.x16(Companion_getInstance_141().z18(), this);
};
protoOf(RoomDimensionsComponent).serializationKey = function () {
  return Companion_getInstance_141().serializationKey;
};
protoOf(RoomDimensionsComponent).eq = function (other) {
  return (other instanceof RoomDimensionsComponent ? other : THROW_CCE()).dimensions.equals(this.dimensions);
};
protoOf(RoomDimensionsComponent).tf = function () {
  return this.dimensions;
};
protoOf(RoomDimensionsComponent).u4o = function (dimensions) {
  return new RoomDimensionsComponent(dimensions);
};
protoOf(RoomDimensionsComponent).copy = function (dimensions, $super) {
  dimensions = dimensions === VOID ? this.dimensions : dimensions;
  return this.u4o(dimensions);
};
protoOf(RoomDimensionsComponent).toString = function () {
  return 'RoomDimensionsComponent(dimensions=' + this.dimensions.toString() + ')';
};
protoOf(RoomDimensionsComponent).hashCode = function () {
  return this.dimensions.hashCode();
};
protoOf(RoomDimensionsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoomDimensionsComponent))
    return false;
  var tmp0_other_with_cast = other instanceof RoomDimensionsComponent ? other : THROW_CCE();
  if (!this.dimensions.equals(tmp0_other_with_cast.dimensions))
    return false;
  return true;
};
function RoomSurfaceWithNormal(entity, normal) {
  this.entity = entity;
  this.normal = normal;
}
protoOf(RoomSurfaceWithNormal).v2i = function () {
  return this.entity;
};
protoOf(RoomSurfaceWithNormal).f2i = function () {
  return this.normal;
};
protoOf(RoomSurfaceWithNormal).tf = function () {
  return this.entity;
};
protoOf(RoomSurfaceWithNormal).uf = function () {
  return this.normal;
};
protoOf(RoomSurfaceWithNormal).v4o = function (entity, normal) {
  return new RoomSurfaceWithNormal(entity, normal);
};
protoOf(RoomSurfaceWithNormal).copy = function (entity, normal, $super) {
  entity = entity === VOID ? this.entity : entity;
  normal = normal === VOID ? this.normal : normal;
  return this.v4o(entity, normal);
};
protoOf(RoomSurfaceWithNormal).toString = function () {
  return 'RoomSurfaceWithNormal(entity=' + this.entity.toString() + ', normal=' + this.normal.toString() + ')';
};
protoOf(RoomSurfaceWithNormal).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + this.normal.hashCode() | 0;
  return result;
};
protoOf(RoomSurfaceWithNormal).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoomSurfaceWithNormal))
    return false;
  var tmp0_other_with_cast = other instanceof RoomSurfaceWithNormal ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!this.normal.equals(tmp0_other_with_cast.normal))
    return false;
  return true;
};
function RoomUtils$Companion$getRoom$lambda(it) {
  return get_isRoom(it);
}
function RoomUtils$Companion$allRoomParts$lambda(it) {
  return get_isRoomPart(it);
}
function RoomUtils$Companion$roomParts$lambda($type) {
  return function (it) {
    var tmp0_safe_receiver = it.__getComponentForKotlin(Companion_getInstance_41().id);
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.type) === $type;
  };
}
function RoomUtils$Companion$roomConnectors$lambda(it) {
  return get_isRoomPart(it);
}
function Companion_99() {
}
protoOf(Companion_99).w4o = function (sceneManager) {
  var tmp = sceneManager.root;
  return findInHierarchy(tmp, RoomUtils$Companion$getRoom$lambda);
};
protoOf(Companion_99).x4o = function (room) {
  return filterInHierarchy(room, RoomUtils$Companion$allRoomParts$lambda);
};
protoOf(Companion_99).y4o = function (room, type) {
  return filterInHierarchy(room, RoomUtils$Companion$roomParts$lambda(type));
};
protoOf(Companion_99).z4o = function (room) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = filterInHierarchy(room, RoomUtils$Companion$roomConnectors$lambda);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.room.utils.Companion.roomConnectors.<anonymous>' call
    var tmp0_safe_receiver = get_connectorsComponent(element);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
    var list = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
    addAll(destination, list);
  }
  return copyToArray(destination);
};
protoOf(Companion_99).a4p = function (sceneManager) {
  var tmp0_safe_receiver = this.w4o(sceneManager);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_allRoomParts(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.disableAllRoomConnectors.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_connectors(element);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var item = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.disableAllRoomConnectors.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Pair(element, item);
        destination_0.h(tmp$ret$0);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp2_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.disableAllRoomConnectors.<anonymous>' call
      var entity = element_0.tf();
      var connector = element_0.uf();
      Companion_instance_26.q2c(connector.key, entity);
    }
  }
};
protoOf(Companion_99).b4p = function (normal, sceneManager) {
  var normalizedNormal = normal.normalize();
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.c4p(sceneManager);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.room.utils.Companion.roomSurfaceWithNormal.<anonymous>' call
    if (element.normal.equals(normalizedNormal)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.room.utils.Companion.roomSurfaceWithNormal.<anonymous>' call
    var tmp$ret$3 = item.entity;
    destination_0.h(tmp$ret$3);
  }
  return copyToArray(destination_0);
};
protoOf(Companion_99).c4p = function (sceneManager) {
  var tmp0_elvis_lhs = this.w4o(sceneManager);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var room = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_allRoomParts(room);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.room.utils.Companion.getRoomSurfacesAndTheirNormals.<anonymous>' call
    var tmp0_safe_receiver = get_connectorsComponent(element);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp1_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp1_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.room.utils.Companion.getRoomSurfacesAndTheirNormals.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = element_0 instanceof SurfaceConnector ? element_0 : null;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_0.h(tmp0_safe_receiver_0);
        }
      }
      tmp_0 = destination_0;
    }
    var tmp2_elvis_lhs = tmp_0;
    var surfaceConnectors = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(surfaceConnectors, 10));
    var tmp0_iterator = surfaceConnectors.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.getRoomSurfacesAndTheirNormals.<anonymous>.<anonymous>' call
      var tmp$ret$5 = new Pair(item, element);
      destination_1.h(tmp$ret$5);
    }
    var list = destination_1;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var item_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.room.utils.Companion.getRoomSurfacesAndTheirNormals.<anonymous>' call
    var roomConnector = item_0.tf();
    var roomPart = item_0.uf();
    var localSurfaceNormal = roomConnector.plane.normal.normalize();
    var worldSurfaceNormal = get_worldTransform(roomPart).transformVector(localSurfaceNormal);
    var tmp$ret$11 = new RoomSurfaceWithNormal(roomPart, worldSurfaceNormal);
    destination_2.h(tmp$ret$11);
  }
  return copyToArray(destination_2);
};
var Companion_instance_138;
function Companion_getInstance_142() {
  return Companion_instance_138;
}
function getRoom(sceneManager) {
  return Companion_instance_138.w4o(sceneManager);
}
function allRoomParts(room) {
  return Companion_instance_138.x4o(room);
}
function roomParts(room, type) {
  return Companion_instance_138.y4o(room, type);
}
function roomConnectors(room) {
  return Companion_instance_138.z4o(room);
}
function disableAllRoomConnectors(sceneManager) {
  return Companion_instance_138.a4p(sceneManager);
}
function roomSurfaceWithNormal(normal, sceneManager) {
  return Companion_instance_138.b4p(normal, sceneManager);
}
function getRoomSurfacesAndTheirNormals(sceneManager) {
  return Companion_instance_138.c4p(sceneManager);
}
function RoomUtils() {
}
function get_allRoomParts(_this__u8e3s4) {
  return Companion_instance_138.x4o(_this__u8e3s4);
}
function StandardSelectionService(entityManager) {
  this.entityManager = entityManager;
  this.d4p_1 = this.entityManager.createEntity();
  this.entityManager.addComponent(this.d4p_1, new DisplayNameComponent('Config-StandardSelectionService'));
}
protoOf(StandardSelectionService).c1k = function () {
  return this.entityManager;
};
protoOf(StandardSelectionService).isMultiSelect = function () {
  return this.d4p_1.hasComponent(MultiSelectionEnabledComponent_instance.id);
};
protoOf(StandardSelectionService).setMultiSelect = function (multiSelect) {
  if (multiSelect)
    this.entityManager.addComponent(this.d4p_1, MultiSelectionEnabledComponent_instance);
  else
    this.entityManager.removeComponent(this.d4p_1, MultiSelectionEnabledComponent_instance.id);
};
protoOf(StandardSelectionService).select = function (entity) {
  var tmp0_safe_receiver = get_selectableRoot(entity);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.addComponent(new SelectedComponent());
};
protoOf(StandardSelectionService).toggle = function (entity) {
  var tmp0_elvis_lhs = get_selectableRoot(entity);
  var e = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  if (e.hasComponent(Companion_getInstance_24().id)) {
    this.unselect(e);
  } else {
    this.select(e);
  }
};
protoOf(StandardSelectionService).unselect = function (entity) {
  this.entityManager.removeComponent(entity, Companion_getInstance_24().id);
};
protoOf(StandardSelectionService).unselectAll = function () {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.entityManager.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    this.unselect(element);
  }
};
function StandardSelectionSystem_init_$Init$(coreServices, $this) {
  StandardSelectionSystem.call($this, coreServices.entityManager, coreServices.sceneManager);
  return $this;
}
function StandardSelectionSystemFromCoreServices(coreServices) {
  return StandardSelectionSystem_init_$Init$(coreServices, objectCreate(protoOf(StandardSelectionSystem)));
}
function onClickNothing($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.r4p_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.onClickNothing.<anonymous>' call
    $this.r4p_1.removeComponent(element, Companion_getInstance_24().id);
  }
}
function onEntityClicked($this, entity) {
  var tmp0_elvis_lhs = get_selectableRoot(entity);
  var selectableRootEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  if (selectableRootEntity.hasComponent(Companion_getInstance_24().id)) {
    $this.r4p_1.removeComponent(selectableRootEntity, Companion_getInstance_24().id);
  } else if (selectableRootEntity.hasComponent(Companion_getInstance_32().id)) {
    $this.r4p_1.addComponent(selectableRootEntity, new SelectedComponent());
  }
}
function onEntityReplaced($this, oldEntity, entity) {
  if (oldEntity.hasComponent(Companion_getInstance_24().id) && entity.hasComponent(Companion_getInstance_32().id)) {
    oldEntity.removeComponent(Companion_getInstance_24().id);
    entity.addComponent(new SelectedComponent());
  }
}
function onEntityDeleted($this, entity) {
  entity.removeComponent(Companion_getInstance_24().id);
}
function onEntitySelected($this, entity) {
  if (!$this.t4p_1) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.r4p_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.onEntitySelected.<anonymous>' call
      if (!entity.equals(element)) {
        $this.r4p_1.removeComponent(element, Companion_getInstance_24().id);
      }
    }
  }
}
function Companion_100() {
  this.ID = 'StandardSelectionSystem';
}
protoOf(Companion_100).j1y = function () {
  return this.ID;
};
var Companion_instance_139;
function Companion_getInstance_143() {
  return Companion_instance_139;
}
function StandardSelectionSystem$onEntityDeleted$ref($boundThis) {
  var l = function (p0) {
    onEntityDeleted($boundThis, p0);
    return Unit_instance;
  };
  l.callableName = 'onEntityDeleted';
  return l;
}
function StandardSelectionSystem(entityManager, sceneManager) {
  var tmp = Companion_instance_139.ID;
  var tmp_0 = Companion_getInstance_66().id;
  var tmp_1 = Companion_getInstance_35().id;
  var tmp_2 = Companion_instance_0.w1m_1;
  var tmp_3 = Companion_instance_0.z1o_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_instance_0.w1m_1];
  SystemBase4.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$2, null, null);
  this.r4p_1 = entityManager;
  this.s4p_1 = sceneManager;
  this.t4p_1 = false;
  this.r4p_1.subscribeEntityRemoved(StandardSelectionSystem$onEntityDeleted$ref(this));
  var tmp_4 = this;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.r4p_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.<anonymous>' call
      if (element.hasComponent(Companion_instance_0.z1o_1)) {
        tmp$ret$4 = true;
        break $l$block;
      }
    }
    tmp$ret$4 = false;
  }
  tmp_4.t4p_1 = tmp$ret$4;
}
protoOf(StandardSelectionSystem).u4p = function (entity, newComponent) {
  onEntityReplaced(this, newComponent.oldEntity, entity);
};
protoOf(StandardSelectionSystem).v1v = function (entity, newComponent) {
  return this.u4p(entity, newComponent instanceof ReplacedWithAutoAdaptEventComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).v4p = function (entity, oldComponent, newComponent) {
};
protoOf(StandardSelectionSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ReplacedWithAutoAdaptEventComponent ? oldComponent : THROW_CCE();
  return this.v4p(entity, tmp, newComponent instanceof ReplacedWithAutoAdaptEventComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).w4p = function (entity, oldComponent) {
};
protoOf(StandardSelectionSystem).z1v = function (entity, oldComponent) {
  return this.w4p(entity, oldComponent instanceof ReplacedWithAutoAdaptEventComponent ? oldComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).x4p = function (entity, newComponent) {
  if (this.s4p_1.scene.equals(entity)) {
    onClickNothing(this);
  } else {
    onEntityClicked(this, entity);
  }
};
protoOf(StandardSelectionSystem).l1z = function (entity, newComponent) {
  return this.x4p(entity, newComponent instanceof ClickEventComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).y4p = function (entity, oldComponent, newComponent) {
};
protoOf(StandardSelectionSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ClickEventComponent ? oldComponent : THROW_CCE();
  return this.y4p(entity, tmp, newComponent instanceof ClickEventComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).z4p = function (entity, oldComponent) {
};
protoOf(StandardSelectionSystem).p1z = function (entity, oldComponent) {
  return this.z4p(entity, oldComponent instanceof ClickEventComponent ? oldComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).a4q = function (entity, newComponent) {
  onEntitySelected(this, entity);
};
protoOf(StandardSelectionSystem).n2m = function (entity, newComponent) {
  return this.a4q(entity, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).b4q = function (entity, oldComponent, newComponent) {
};
protoOf(StandardSelectionSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE();
  return this.b4q(entity, tmp, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).c4q = function (entity, oldComponent) {
};
protoOf(StandardSelectionSystem).p2m = function (entity, oldComponent) {
  return this.c4q(entity, oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).d4q = function (entity, newComponent) {
  this.t4p_1 = true;
};
protoOf(StandardSelectionSystem).d2n = function (entity, newComponent) {
  return this.d4q(entity, newComponent instanceof MultiSelectionEnabledComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).e4q = function (entity, oldComponent, newComponent) {
};
protoOf(StandardSelectionSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof MultiSelectionEnabledComponent ? oldComponent : THROW_CCE();
  return this.e4q(entity, tmp, newComponent instanceof MultiSelectionEnabledComponent ? newComponent : THROW_CCE());
};
protoOf(StandardSelectionSystem).f4q = function (entity, oldComponent) {
  this.t4p_1 = false;
};
protoOf(StandardSelectionSystem).f2n = function (entity, oldComponent) {
  return this.f4q(entity, oldComponent instanceof MultiSelectionEnabledComponent ? oldComponent : THROW_CCE());
};
function onClickNothing_0($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.s4q_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.onClickNothing.<anonymous>' call
    $this.s4q_1.removeComponent(element, Companion_getInstance_24().id);
  }
}
function onEntityClicked_0($this, entity) {
  var tmp0_elvis_lhs = get_selectableRoot(entity);
  var selectableRootEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
  if (get_isSelected(selectableRootEntity)) {
    clickSelectedEntity($this, selectableRootEntity);
  } else if (get_isSelectable(selectableRootEntity)) {
    clickUnselectedEntity($this, selectableRootEntity);
  }
}
function clickSelectedEntity($this, entity) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_selectionGroups(entity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.clickSelectedEntity.<anonymous>' call
      if (element.isSelected()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var selectedGroup = tmp$ret$1;
  if ($this.u4q_1 || selectedGroup == null) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp1_elvis_lhs = selectedGroup == null ? null : selectedGroup.members;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [entity];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var indexedObject = tmp;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.clickSelectedEntity.<anonymous>' call
      element_0.removeComponent(Companion_getInstance_24().id);
    }
    return Unit_instance;
  }
  var tmp2_safe_receiver = Companion_instance_143.v4q(entity);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.members;
  var tmp_0;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [entity];
  } else {
    tmp_0 = tmp3_elvis_lhs;
  }
  var toKeepSelected = tmp_0;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = selectedGroup.members;
  var inductionVariable_1 = 0;
  var last_1 = indexedObject_0.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = indexedObject_0[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.clickSelectedEntity.<anonymous>' call
    if (!contains(toKeepSelected, element_1)) {
      element_1.removeComponent(Companion_getInstance_24().id);
    }
  }
}
function clickUnselectedEntity($this, entity) {
  var tmp0_safe_receiver = Companion_instance_143.w4q(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.members;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [entity];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var toSelect = tmp;
  selectAll($this, toSelect);
  if (!$this.u4q_1) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.t4q_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.clickUnselectedEntity.<anonymous>' call
      if (!contains(toSelect, element)) {
        element.removeComponent(Companion_getInstance_24().id);
      }
    }
  }
}
function selectAll($this, entities) {
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.selectAll.<anonymous>' call
    element.addComponent(new SelectedComponent());
  }
}
function onEntityReplaced_0($this, oldEntity, entity) {
  if (oldEntity.hasComponent(Companion_getInstance_24().id) && entity.hasComponent(Companion_getInstance_32().id)) {
    oldEntity.removeComponent(Companion_getInstance_24().id);
    entity.addComponent(new SelectedComponent());
  }
}
function onEntityDeleted_0($this, entity) {
  entity.removeComponent(Companion_getInstance_24().id);
}
function Companion_101() {
  this.x4q_1 = 'GroupSelectionSystem';
}
protoOf(Companion_101).j1y = function () {
  return this.x4q_1;
};
var Companion_instance_140;
function Companion_getInstance_144() {
  return Companion_instance_140;
}
function get_ID_5() {
  return Companion_instance_140.x4q_1;
}
function GroupSelectionSystem$onEntityDeleted$ref($boundThis) {
  var l = function (p0) {
    onEntityDeleted_0($boundThis, p0);
    return Unit_instance;
  };
  l.callableName = 'onEntityDeleted';
  return l;
}
function GroupSelectionSystem(entityManager, sceneManager) {
  var tmp = Companion_instance_140.x4q_1;
  var tmp_0 = Companion_getInstance_66().id;
  var tmp_1 = Companion_getInstance_35().id;
  var tmp_2 = Companion_instance_0.z1o_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_instance_0.w1m_1];
  SystemBase3.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp$ret$2, null, null);
  this.s4q_1 = entityManager;
  this.t4q_1 = sceneManager;
  this.u4q_1 = false;
  this.s4q_1.subscribeEntityRemoved(GroupSelectionSystem$onEntityDeleted$ref(this));
  var tmp_3 = this;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.s4q_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.GroupSelectionSystem.<anonymous>' call
      if (element.hasComponent(Companion_instance_0.z1o_1)) {
        tmp$ret$4 = true;
        break $l$block;
      }
    }
    tmp$ret$4 = false;
  }
  tmp_3.u4q_1 = tmp$ret$4;
}
protoOf(GroupSelectionSystem).u4p = function (entity, newComponent) {
  onEntityReplaced_0(this, newComponent.oldEntity, entity);
};
protoOf(GroupSelectionSystem).v1v = function (entity, newComponent) {
  return this.u4p(entity, newComponent instanceof ReplacedWithAutoAdaptEventComponent ? newComponent : THROW_CCE());
};
protoOf(GroupSelectionSystem).x4p = function (entity, newComponent) {
  if (this.t4q_1.scene.equals(entity)) {
    onClickNothing_0(this);
  } else {
    onEntityClicked_0(this, entity);
  }
};
protoOf(GroupSelectionSystem).l1z = function (entity, newComponent) {
  return this.x4p(entity, newComponent instanceof ClickEventComponent ? newComponent : THROW_CCE());
};
protoOf(GroupSelectionSystem).y4q = function (entity, newComponent) {
  this.u4q_1 = true;
};
protoOf(GroupSelectionSystem).n2m = function (entity, newComponent) {
  return this.y4q(entity, newComponent instanceof MultiSelectionEnabledComponent ? newComponent : THROW_CCE());
};
protoOf(GroupSelectionSystem).z4q = function (entity, oldComponent) {
  this.u4q_1 = false;
};
protoOf(GroupSelectionSystem).p2m = function (entity, oldComponent) {
  return this.z4q(entity, oldComponent instanceof MultiSelectionEnabledComponent ? oldComponent : THROW_CCE());
};
function Companion_102() {
  this.a4r_1 = 'RemoveTrivialSelectionGroupsSystem';
}
protoOf(Companion_102).j1y = function () {
  return this.a4r_1;
};
var Companion_instance_141;
function Companion_getInstance_145() {
  return Companion_instance_141;
}
function get_ID_6() {
  return Companion_instance_141.a4r_1;
}
function RemoveTrivialSelectionGroupsSystem$onRemoveComponent$lambda($groupId) {
  return function (it) {
    var tmp0_safe_receiver = it.__getComponentForKotlin(Companion_getInstance_148().c4r_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.groupIds;
    return (tmp1_safe_receiver == null ? null : contains(tmp1_safe_receiver, $groupId)) === true;
  };
}
function RemoveTrivialSelectionGroupsSystem(sceneManager) {
  var tmp = Companion_instance_141.a4r_1;
  var tmp_0 = Companion_getInstance_148().c4r_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_148().c4r_1];
  SystemBase.call(this, tmp, tmp_0, tmp$ret$2, null, null);
  this.o4r_1 = sceneManager;
}
protoOf(RemoveTrivialSelectionGroupsSystem).p4r = function (entity, oldComponent, newComponent) {
  this.q4r(entity, oldComponent);
};
protoOf(RemoveTrivialSelectionGroupsSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SelectionGroupsComponent ? oldComponent : THROW_CCE();
  return this.p4r(entity, tmp, newComponent instanceof SelectionGroupsComponent ? newComponent : THROW_CCE());
};
protoOf(RemoveTrivialSelectionGroupsSystem).q4r = function (entity, oldComponent) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = oldComponent.groupIds;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.RemoveTrivialSelectionGroupsSystem.onRemoveComponent.<anonymous>' call
    var tmp = Companion_instance_3;
    var tmp_0 = this.o4r_1.scene;
    var remainingGroupMembers = tmp.j2r(tmp_0, RemoveTrivialSelectionGroupsSystem$onRemoveComponent$lambda(element));
    if (remainingGroupMembers.length === 1) {
      Companion_instance_143.r4r(remainingGroupMembers[0], element);
    }
  }
};
protoOf(RemoveTrivialSelectionGroupsSystem).z1v = function (entity, oldComponent) {
  return this.q4r(entity, oldComponent instanceof SelectionGroupsComponent ? oldComponent : THROW_CCE());
};
function selectDraggedGroupMembers($this, draggedEntity) {
  var tmp;
  var tmp_0;
  var tmp2_safe_receiver = get_selectableRoot(draggedEntity);
  if (!((tmp2_safe_receiver == null ? null : get_isSelected(tmp2_safe_receiver)) === true)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = hierarchyExceptSubTreesWithComponentArray(draggedEntity, Companion_getInstance_2().id);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        if (get_isSelected(element)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    tmp_0 = !tmp$ret$1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp0_safe_receiver = get_draggableRootEntity(draggedEntity);
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
      deselectAll($this);
      tmp_1 = mutableListOf([tmp0_safe_receiver]);
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_2 = ArrayList_init_$Create$();
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    tmp = tmp_2;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.b4s_1.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
      if (get_isSelected(element_0)) {
        destination.h(element_0);
      }
    }
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = destination.k();
    while (tmp0_iterator.m()) {
      var element_1 = tmp0_iterator.n();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
      var tmp0_safe_receiver_0 = get_draggableRootEntity(element_1);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.h(tmp0_safe_receiver_0);
      }
    }
    tmp = toMutableList(distinct(destination_0));
  }
  var draggableRoots = tmp;
  var groupDraggableRoots;
  $l$1: do {
    $l$0: do {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = draggableRoots.k();
      while (tmp0_iterator_0.m()) {
        var element_2 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        var list = toList(getHierarchyWithComponent(element_2, Companion_getInstance_148().c4r_1));
        addAll(destination_1, list);
      }
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$();
      var tmp0_iterator_1 = destination_1.k();
      while (tmp0_iterator_1.m()) {
        var element_3 = tmp0_iterator_1.n();
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        if (!get_isSelected(element_3)) {
          destination_2.h(element_3);
        }
      }
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_3 = ArrayList_init_$Create$();
      var tmp0_iterator_2 = destination_2.k();
      while (tmp0_iterator_2.m()) {
        var element_4 = tmp0_iterator_2.n();
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        var tmp0_safe_receiver_1 = firstOrNull_0(get_selectionGroups(element_4));
        var tmp1_safe_receiver = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.members;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
        var list_0 = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
        addAll(destination_3, list_0);
      }
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_3 = destination_3.k();
      while (tmp0_iterator_3.m()) {
        var element_5 = tmp0_iterator_3.n();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        var tmp0_safe_receiver_2 = get_selectableRoot(element_5);
        if (tmp0_safe_receiver_2 == null)
          null;
        else
          tmp0_safe_receiver_2.addComponent(new SelectedComponent());
        var tmp0_safe_receiver_3 = get_draggableRootEntity(element_5);
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_4.h(tmp0_safe_receiver_3);
        }
      }
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = distinct(destination_4);
      var destination_5 = ArrayList_init_$Create$();
      var tmp0_iterator_4 = this_1.k();
      while (tmp0_iterator_4.m()) {
        var element_6 = tmp0_iterator_4.n();
        // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.selectDraggedGroupMembers.<anonymous>' call
        if (!draggableRoots.s(element_6)) {
          destination_5.h(element_6);
        }
      }
      groupDraggableRoots = destination_5;
      draggableRoots.p(groupDraggableRoots);
    }
     while (false);
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$28 = !groupDraggableRoots.r();
  }
   while (tmp$ret$28);
}
function deselectAll($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.b4s_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.SelectDraggedGroupSystem.deselectAll.<anonymous>' call
    element.removeComponent(Companion_getInstance_24().id);
  }
}
function Companion_103() {
  this.c4s_1 = 'SelectDraggedGroupSystem';
}
protoOf(Companion_103).j1y = function () {
  return this.c4s_1;
};
var Companion_instance_142;
function Companion_getInstance_146() {
  return Companion_instance_142;
}
function get_ID_7() {
  return Companion_instance_142.c4s_1;
}
function SelectDraggedGroupSystem(sceneManager) {
  var tmp = Companion_instance_142.c4s_1;
  var tmp_0 = Companion_getInstance_20().id;
  // Inline function 'kotlin.emptyArray' call
  var tmp_1 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [Companion_getInstance_74().ID];
  SystemBase.call(this, tmp, tmp_0, tmp_1, null, tmp$ret$3);
  this.b4s_1 = sceneManager;
}
protoOf(SelectDraggedGroupSystem).m42 = function (entity, newComponent) {
  selectDraggedGroupMembers(this, entity);
};
protoOf(SelectDraggedGroupSystem).v1v = function (entity, newComponent) {
  return this.m42(entity, newComponent instanceof WorldSpaceDragEventComponent ? newComponent : THROW_CCE());
};
function sam$kotlin_Comparator$0_10(function_0) {
  this.d4s_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_10).md = function (a, b) {
  return this.d4s_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).s3 = function () {
  return this.d4s_1;
};
protoOf(sam$kotlin_Comparator$0_10).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_10).hashCode = function () {
  return hashCode(this.s3());
};
function SelectionGroupUtils$Companion$group$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>' call
  var tmp = a.id;
  // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>' call
  var tmp$ret$1 = b.id;
  return compareValues(tmp, tmp$ret$1);
}
function SelectionGroupUtils$Companion$group$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>.<anonymous>' call
  var tmp = a.id;
  // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.id;
  return compareValues(tmp, tmp$ret$1);
}
function Companion_104() {
}
protoOf(Companion_104).e4s = function (entities) {
  if (entities.length <= 1) {
    return null;
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>' call
    var tmp0_safe_receiver = firstOrNull_0(get_selectionGroups(element));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.members;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
    var list = tmp2_elvis_lhs == null ? listOf(element) : tmp2_elvis_lhs;
    addAll(destination, list);
  }
  var this_0 = distinct(destination);
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = SelectionGroupUtils$Companion$group$lambda;
  var tmp$ret$3 = new sam$kotlin_Comparator$0_10(tmp);
  var this_1 = sortedWith(this_0, tmp$ret$3);
  var toGroup = copyToArray(this_1);
  var tmp0_safe_receiver_0 = firstOrNull_0(toGroup);
  var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : get_selectionGroups(tmp0_safe_receiver_0);
  var tmp_0;
  if (tmp1_safe_receiver_0 == null) {
    tmp_0 = null;
  } else {
    var tmp$ret$10;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable_0 = 0;
      var last_0 = tmp1_safe_receiver_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp1_safe_receiver_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.sortedBy' call
        var this_2 = element_0.members;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_1 = SelectionGroupUtils$Companion$group$lambda_0;
        var tmp$ret$6 = new sam$kotlin_Comparator$0_10(tmp_1);
        var this_3 = sortedWith_0(this_2, tmp$ret$6);
        var tmp$ret$8 = copyToArray(this_3);
        if (contentEquals(tmp$ret$8, toGroup)) {
          tmp$ret$10 = true;
          break $l$block;
        }
      }
      tmp$ret$10 = false;
    }
    tmp_0 = tmp$ret$10;
  }
  if (tmp_0 === true) {
    return null;
  }
  var groupId = Companion_getInstance_39().ak().toString();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_1 = 0;
  var last_1 = toGroup.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = toGroup[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.Companion.group.<anonymous>' call
    // Inline function 'kotlin.arrayOf' call
    var tmp0_safe_receiver_1 = get_selectionGroupsComponent(element_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.groupIds;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_2 = [];
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = arrayConcat([[groupId], tmp_2]);
    element_1.addComponent(new SelectionGroupsComponent(tmp$ret$14));
  }
  return groupId;
};
protoOf(Companion_104).f4s = function (entityManager, groupId) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = entityManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.selectiongroups.Companion.ungroup.<anonymous>' call
    var tmp0_safe_receiver = element.__getComponentForKotlin(Companion_getInstance_148().c4r_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.groupIds;
    if ((tmp1_safe_receiver == null ? null : contains(tmp1_safe_receiver, groupId)) === true) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.selectiongroups.Companion.ungroup.<anonymous>' call
    Companion_instance_143.r4r(element_0, groupId);
  }
};
protoOf(Companion_104).r4r = function (entity, groupId) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_148().c4r_1);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.groupIds;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var groupIds = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = minus_1(asList(groupIds), groupId);
  var newGroupIds = copyToArray(this_0);
  // Inline function 'kotlin.collections.isEmpty' call
  if (newGroupIds.length === 0) {
    entity.removeComponent(Companion_getInstance_148().c4r_1);
  } else {
    entity.addComponent(new SelectionGroupsComponent(newGroupIds));
  }
};
protoOf(Companion_104).g4s = function (entity) {
  var tmp0_safe_receiver = get_selectionGroupsComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.groupIds;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var item = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.Companion.getGroups.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = entity.entityManager.entities;
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var element = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.selectiongroups.Companion.getGroups.<anonymous>.<anonymous>' call
        var tmp_0;
        if (get_isInScene(element)) {
          var tmp0_safe_receiver_0 = get_selectionGroupsComponent(element);
          var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.groupIds;
          var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : contains(tmp1_safe_receiver_0, item);
          tmp_0 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          destination_0.h(element);
        }
      }
      var tmp$ret$3 = copyToArray(destination_0);
      var tmp$ret$4 = new SelectionGroup(item, tmp$ret$3);
      destination.h(tmp$ret$4);
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_1 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_1;
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_2 = [];
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  return tmp_2;
};
protoOf(Companion_104).h4s = function (entity) {
  return firstOrNull_0(this.g4s(entity));
};
protoOf(Companion_104).w4q = function (entity) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = this.g4s(entity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.Companion.getLargestUnselectedGroupContainingEntity.<anonymous>' call
      if (!element.isAnyMemberSelected()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(Companion_104).v4q = function (entity) {
  var groups = get_selectionGroups(entity);
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = groups.length;
    while (inductionVariable < last) {
      var element = groups[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.Companion.getNextLargestSelectedGroupContainingEntity.<anonymous>' call
      if (element.isSelected()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var selectedGroup = tmp;
  var indexOfSelectedGroup = indexOf(groups, selectedGroup);
  if (indexOfSelectedGroup < (groups.length - 1 | 0)) {
    return groups[indexOfSelectedGroup + 1 | 0];
  }
  return null;
};
var Companion_instance_143;
function Companion_getInstance_147() {
  return Companion_instance_143;
}
function group(entities) {
  return Companion_instance_143.e4s(entities);
}
function ungroup(entityManager, groupId) {
  return Companion_instance_143.f4s(entityManager, groupId);
}
function removeFromGroup(entity, groupId) {
  return Companion_instance_143.r4r(entity, groupId);
}
function getGroups(entity) {
  return Companion_instance_143.g4s(entity);
}
function getLargestGroupContainingEntity(entity) {
  return Companion_instance_143.h4s(entity);
}
function getLargestUnselectedGroupContainingEntity(entity) {
  return Companion_instance_143.w4q(entity);
}
function getNextLargestSelectedGroupContainingEntity(entity) {
  return Companion_instance_143.v4q(entity);
}
function SelectionGroupUtils() {
}
function SelectionGroupsComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_105() {
  Companion_instance_144 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.b4r_1 = [new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance()), null];
  this.c4r_1 = Companion_instance_0.l1s_1;
  this.serializationKey = 'SelectionGroupsComponent';
  var tmp_0 = this;
  tmp_0.d4r_1 = Json(VOID, SelectionGroupsComponent$Companion$serializer$lambda);
}
protoOf(Companion_105).j1y = function () {
  return this.c4r_1;
};
protoOf(Companion_105).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_105).fromJson = function (json) {
  var result = this.d4r_1.y16(this.z18(), json);
  return result;
};
protoOf(Companion_105).z18 = function () {
  return $serializer_getInstance_2();
};
var Companion_instance_144;
function Companion_getInstance_148() {
  if (Companion_instance_144 == null)
    new Companion_105();
  return Companion_instance_144;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.selectiongroups.SelectionGroupsComponent', this, 2);
  tmp0_serialDesc.lw('groupIds', false);
  tmp0_serialDesc.lw('typeId', true);
  this.i4s_1 = tmp0_serialDesc;
}
protoOf($serializer_0).j4s = function (encoder, value) {
  var tmp0_desc = this.i4s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_148().b4r_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.groupIds);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.e4r_1 === Companion_getInstance_148().c4r_1)) {
    tmp1_output.lq(tmp0_desc, 1, value.e4r_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_0).ul = function (encoder, value) {
  return this.j4s(encoder, value instanceof SelectionGroupsComponent ? value : THROW_CCE());
};
protoOf($serializer_0).vl = function (decoder) {
  var tmp0_desc = this.i4s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_input = decoder.bp(tmp0_desc);
  var tmp7_cached = Companion_getInstance_148().b4r_1;
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return SelectionGroupsComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_0).tl = function () {
  return this.i4s_1;
};
protoOf($serializer_0).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_148().b4r_1[0], IntSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_2() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function SelectionGroupsComponent_init_$Init$(seen0, groupIds, typeId, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_2().i4s_1);
  }
  $this.groupIds = groupIds;
  if (0 === (seen0 & 2))
    $this.e4r_1 = Companion_getInstance_148().c4r_1;
  else
    $this.e4r_1 = typeId;
  return $this;
}
function SelectionGroupsComponent_init_$Create$(seen0, groupIds, typeId, serializationConstructorMarker) {
  return SelectionGroupsComponent_init_$Init$(seen0, groupIds, typeId, serializationConstructorMarker, objectCreate(protoOf(SelectionGroupsComponent)));
}
function get_ID_8() {
  return Companion_getInstance_148().c4r_1;
}
function SelectionGroupsComponent(groupIds) {
  Companion_getInstance_148();
  this.groupIds = groupIds;
  this.e4r_1 = Companion_getInstance_148().c4r_1;
}
protoOf(SelectionGroupsComponent).k4s = function () {
  return this.groupIds;
};
protoOf(SelectionGroupsComponent).toJson = function (parse) {
  return Companion_getInstance_148().d4r_1.x16(Companion_getInstance_148().z18(), this);
};
protoOf(SelectionGroupsComponent).serializationKey = function () {
  return Companion_getInstance_148().serializationKey;
};
protoOf(SelectionGroupsComponent).p1s = function () {
  return this.e4r_1;
};
protoOf(SelectionGroupsComponent).eq = function (other) {
  return contentEquals((other instanceof SelectionGroupsComponent ? other : THROW_CCE()).groupIds, this.groupIds);
};
function SelectionGroup(id, members) {
  this.id = id;
  this.members = members;
}
protoOf(SelectionGroup).n1s = function () {
  return this.id;
};
protoOf(SelectionGroup).r2o = function () {
  return this.members;
};
protoOf(SelectionGroup).isSelected = function () {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var indexedObject = this.members;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.SelectionGroup.isSelected.<anonymous>' call
      if (!get_isSelected(element)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
};
protoOf(SelectionGroup).isAnyMemberSelected = function () {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.members;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selectiongroups.SelectionGroup.isAnyMemberSelected.<anonymous>' call
      if (get_isSelected(element)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
};
protoOf(SelectionGroup).tf = function () {
  return this.id;
};
protoOf(SelectionGroup).uf = function () {
  return this.members;
};
protoOf(SelectionGroup).l4s = function (id, members) {
  return new SelectionGroup(id, members);
};
protoOf(SelectionGroup).copy = function (id, members, $super) {
  id = id === VOID ? this.id : id;
  members = members === VOID ? this.members : members;
  return this.l4s(id, members);
};
protoOf(SelectionGroup).toString = function () {
  return 'SelectionGroup(id=' + this.id + ', members=' + toString(this.members) + ')';
};
protoOf(SelectionGroup).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + hashCode(this.members) | 0;
  return result;
};
protoOf(SelectionGroup).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SelectionGroup))
    return false;
  var tmp0_other_with_cast = other instanceof SelectionGroup ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!equals(this.members, tmp0_other_with_cast.members))
    return false;
  return true;
};
function get_selectionGroups(_this__u8e3s4) {
  return Companion_instance_143.g4s(_this__u8e3s4);
}
function get_selectionGroupsComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_148().c4r_1);
}
function SelectionGroupsComponentDeserializer() {
  this.m4s_1 = true;
}
protoOf(SelectionGroupsComponentDeserializer).s1t = function () {
  return this.m4s_1;
};
protoOf(SelectionGroupsComponentDeserializer).canHandle = function (serializationKey) {
  return serializationKey === Companion_getInstance_148().serializationKey;
};
protoOf(SelectionGroupsComponentDeserializer).deserialize = function (serializationKey, json) {
  return Companion_getInstance_148().fromJson(json);
};
function SelectionGroupsFeature(coreServices) {
  this.n4s_1 = coreServices;
  this.o4s_1 = this.n4s_1.componentDeserializerRegistry;
  this.p4s_1 = new RemoveTrivialSelectionGroupsSystem(this.n4s_1.sceneManager);
  this.q4s_1 = new SelectDraggedGroupSystem(this.n4s_1.sceneManager);
  this.r4s_1 = new SelectionGroupsComponentDeserializer();
  this.s4s_1 = new GroupSelectionSystem(this.n4s_1.entityManager, this.n4s_1.sceneManager);
}
protoOf(SelectionGroupsFeature).enable = function () {
  this.o4s_1.register(this.r4s_1);
  this.n4s_1.entityManager.registerSystem(this.p4s_1);
  this.n4s_1.entityManager.registerSystem(this.q4s_1);
  this.n4s_1.entityManager.registerSystem(this.s4s_1);
};
protoOf(SelectionGroupsFeature).disable = function () {
  this.o4s_1.unregister(this.r4s_1);
  this.n4s_1.entityManager.unregisterSystem(this.p4s_1);
  this.n4s_1.entityManager.unregisterSystem(this.q4s_1);
  this.n4s_1.entityManager.unregisterSystem(this.s4s_1);
};
function Companion_106() {
  Companion_instance_145 = this;
  this.q46_1 = Companion_instance_38.ID;
  this.r46_1 = Companion_instance_41.ID;
  this.s46_1 = Companion_getInstance_74().ID;
  this.t46_1 = 'DragRotationSystem';
  this.u46_1 = Companion_getInstance_44().ID;
  this.v46_1 = Companion_instance_89.ID;
  this.w46_1 = Companion_instance_112.ID;
  this.x46_1 = Companion_getInstance_131().ID;
  this.y46_1 = Companion_instance_157.t4s_1;
  this.z46_1 = Companion_getInstance_163().u4s_1;
  this.a47_1 = 'RoomDimensionToGeometrySystem';
  this.b47_1 = Companion_instance_81.ID;
  this.c47_1 = Companion_getInstance_84().ID;
  this.d47_1 = Companion_instance_48.ID;
  this.e47_1 = Companion_instance_139.ID;
  this.f47_1 = Companion_getInstance_56().s3s_1;
}
protoOf(Companion_106).w4s = function () {
  return this.q46_1;
};
protoOf(Companion_106).x4s = function () {
  return this.r46_1;
};
protoOf(Companion_106).y4s = function () {
  return this.s46_1;
};
protoOf(Companion_106).z4s = function () {
  return this.t46_1;
};
protoOf(Companion_106).a4t = function () {
  return this.u46_1;
};
protoOf(Companion_106).b4t = function () {
  return this.v46_1;
};
protoOf(Companion_106).c4t = function () {
  return this.w46_1;
};
protoOf(Companion_106).d4t = function () {
  return this.x46_1;
};
protoOf(Companion_106).e4t = function () {
  return this.y46_1;
};
protoOf(Companion_106).f4t = function () {
  return this.z46_1;
};
protoOf(Companion_106).g4t = function () {
  return this.a47_1;
};
protoOf(Companion_106).h4t = function () {
  return this.b47_1;
};
protoOf(Companion_106).i4t = function () {
  return this.c47_1;
};
protoOf(Companion_106).j4t = function () {
  return this.d47_1;
};
protoOf(Companion_106).k4t = function () {
  return this.e47_1;
};
protoOf(Companion_106).l4t = function () {
  return this.f47_1;
};
var Companion_instance_145;
function Companion_getInstance_149() {
  if (Companion_instance_145 == null)
    new Companion_106();
  return Companion_instance_145;
}
function get_ALIGNMENT_CONNECTION_CREATION_SYSTEM() {
  return Companion_getInstance_149().q46_1;
}
function get_ALIGNMENT_LINES_SYSTEM_ID() {
  return Companion_getInstance_149().r46_1;
}
function get_DRAG_SYSTEM_ID() {
  return Companion_getInstance_149().s46_1;
}
function get_DRAG_ROTATION_SYSTEM_ID() {
  return Companion_getInstance_149().t46_1;
}
function get_HANDLE_ROTATION_SYSTEM_ID() {
  return Companion_getInstance_149().u46_1;
}
function get_FUNCTIONAL_MARGIN_SYSTEM_ID() {
  return Companion_getInstance_149().v46_1;
}
function get_OUTLINE_SELECTED_SYSTEM_ID() {
  return Companion_getInstance_149().w46_1;
}
function get_PROPPING_SYSTEM_ID() {
  return Companion_getInstance_149().x46_1;
}
function get_ADD_ROOM_COMPONENTS_WHEN_LOADING_SYSTEM_ID() {
  return Companion_getInstance_149().y46_1;
}
function get_ROOM_LOADING_SYSTEM() {
  return Companion_getInstance_149().z46_1;
}
function get_ROOM_DIMENSION_TO_GEOMETRY_SYSTEM_ID() {
  return Companion_getInstance_149().a47_1;
}
function get_LEGACY_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM() {
  return Companion_getInstance_149().b47_1;
}
function get_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM() {
  return Companion_getInstance_149().c47_1;
}
function get_AUTO_ADAPT_PRODUCT_SPECIFICATION_SYSTEM_ID() {
  return Companion_getInstance_149().d47_1;
}
function get_STANDARD_SELECTION_SYSTEM_SYSTEM_ID() {
  return Companion_getInstance_149().e47_1;
}
function get_AUTO_ADAPT_DISPOSE_FAILED_CHILDREN_SYSTEM_ID() {
  return Companion_getInstance_149().f47_1;
}
function StlSystemIds() {
  Companion_getInstance_149();
}
function Companion_107() {
  Companion_instance_146 = this;
  this.accumulatedDelta = Companion_getInstance_15().ZERO;
  this.originalPosition = Companion_getInstance_15().ZERO;
}
protoOf(Companion_107).m4t = function (_set____db54di) {
  this.accumulatedDelta = _set____db54di;
};
protoOf(Companion_107).n4t = function () {
  return this.accumulatedDelta;
};
protoOf(Companion_107).o4t = function (_set____db54di) {
  this.originalPosition = _set____db54di;
};
protoOf(Companion_107).p4t = function () {
  return this.originalPosition;
};
protoOf(Companion_107).q4t = function (_this__u8e3s4, coreServices, delta, steps) {
  return simulateEntireDragInSteps_0(_this__u8e3s4, coreServices, delta, steps);
};
protoOf(Companion_107).simulateEntireDragInSteps = function (_this__u8e3s4, coreServices, delta, steps, $super) {
  steps = steps === VOID ? 100 : steps;
  var tmp;
  if ($super === VOID) {
    this.q4t(_this__u8e3s4, coreServices, delta, steps);
    tmp = Unit_instance;
  } else {
    tmp = $super.q4t.call(this, _this__u8e3s4, coreServices, delta, steps);
  }
  return tmp;
};
protoOf(Companion_107).simulateEntireDrag = function (_this__u8e3s4, coreServices, delta) {
  return simulateEntireDrag_0(_this__u8e3s4, coreServices, delta);
};
protoOf(Companion_107).simulateStartDrag = function (_this__u8e3s4, coreServices) {
  return simulateStartDrag_0(_this__u8e3s4, coreServices);
};
protoOf(Companion_107).simulateOngoingDrag = function (_this__u8e3s4, coreServices, delta) {
  return simulateOngoingDrag_0(_this__u8e3s4, coreServices, delta);
};
protoOf(Companion_107).simulateEndDrag = function (_this__u8e3s4, coreServices) {
  return simulateEndDrag_0(_this__u8e3s4, coreServices);
};
var Companion_instance_146;
function Companion_getInstance_150() {
  if (Companion_instance_146 == null)
    new Companion_107();
  return Companion_instance_146;
}
function simulateEntireDragInStepsJs(_this__u8e3s4, coreServices, delta, steps) {
  return Companion_getInstance_150().q4t(_this__u8e3s4, coreServices, delta, steps);
}
function simulateEntireDragInSteps(_this__u8e3s4, coreServices, delta, steps, $super) {
  steps = steps === VOID ? 100 : steps;
  return simulateEntireDragInStepsJs(_this__u8e3s4, coreServices, delta, steps);
}
function simulateEntireDrag(_this__u8e3s4, coreServices, delta) {
  return Companion_getInstance_150().simulateEntireDrag(_this__u8e3s4, coreServices, delta);
}
function simulateStartDrag(_this__u8e3s4, coreServices) {
  return Companion_getInstance_150().simulateStartDrag(_this__u8e3s4, coreServices);
}
function simulateOngoingDrag(_this__u8e3s4, coreServices, delta) {
  return Companion_getInstance_150().simulateOngoingDrag(_this__u8e3s4, coreServices, delta);
}
function simulateEndDrag(_this__u8e3s4, coreServices) {
  return Companion_getInstance_150().simulateEndDrag(_this__u8e3s4, coreServices);
}
function DragExtensions() {
  Companion_getInstance_150();
}
function simulateEntireDragInSteps_0(_this__u8e3s4, coreServices, totalDelta, steps) {
  steps = steps === VOID ? 100 : steps;
  simulateStartDrag_0(_this__u8e3s4, coreServices);
  var delta = totalDelta.__divIntForKotlin(steps);
  var inductionVariable = 1;
  if (inductionVariable <= steps)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      simulateOngoingDrag_0(_this__u8e3s4, coreServices, delta);
    }
     while (!(i === steps));
  simulateEndDrag_0(_this__u8e3s4, coreServices);
}
function simulateEntireDrag_0(_this__u8e3s4, coreServices, delta) {
  simulateStartDrag_0(_this__u8e3s4, coreServices);
  simulateOngoingDrag_0(_this__u8e3s4, coreServices, delta);
  simulateEndDrag_0(_this__u8e3s4, coreServices);
}
function simulateStartDrag_0(_this__u8e3s4, coreServices, point) {
  point = point === VOID ? null : point;
  var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
  var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  var dragPoint = point == null ? get_worldPosition(draggedEntity) : point;
  Companion_getInstance_150().accumulatedDelta = Companion_getInstance_15().ZERO;
  Companion_getInstance_150().originalPosition = dragPoint;
  draggedEntity.addComponent(new WorldSpaceDragEventComponent(dragPoint, rayFromMiddleOfRoomToDragPoint(dragPoint, coreServices)));
}
function simulateOngoingDrag_0(_this__u8e3s4, coreServices, delta) {
  var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
  var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  Companion_getInstance_150().accumulatedDelta = Companion_getInstance_150().accumulatedDelta.plus(delta);
  var point = Companion_getInstance_150().originalPosition.plus(Companion_getInstance_150().accumulatedDelta);
  draggedEntity.addComponent(new WorldSpaceDragEventComponent(point, rayFromMiddleOfRoomToDragPoint(point, coreServices)));
}
function simulateEndDrag_0(_this__u8e3s4, coreServices) {
  var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
  var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  Companion_getInstance_150().accumulatedDelta = Companion_getInstance_15().ZERO;
  Companion_getInstance_150().originalPosition = Companion_getInstance_15().ZERO;
  coreServices.entityManager.removeComponent(draggedEntity, Companion_getInstance_20().id);
}
function rayFromMiddleOfRoomToDragPoint(point, coreServices) {
  var defaultCamPos = __VectorIntConstructorKotlin(0, 0, 2000);
  var defaultRay = new Ray(defaultCamPos, point.minus(defaultCamPos));
  // Inline function 'kotlin.collections.find' call
  var this_0 = coreServices.sceneManager.entities;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.test.rayFromMiddleOfRoomToDragPoint.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_152().id)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return defaultRay;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var room = tmp;
  var tmp1_elvis_lhs = room.__getComponentForKotlin(Companion_getInstance_152().id);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return defaultRay;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var roomDimensions = tmp_0;
  var middleOfRoom = new Vector(0.0, roomDimensions.dimensions.height / 2, roomDimensions.dimensions.depth / 2);
  return new Ray(middleOfRoom, point.minus(middleOfRoom));
}
function TestRoomFeature(coreServices) {
  this.r4t_1 = coreServices.entityManager;
  this.s4t_1 = coreServices.componentDeserializerRegistry;
  this.t4t_1 = coreServices.deserializationInterceptorRegistry;
  this.u4t_1 = new RoomLoadingInterceptor();
  this.v4t_1 = new AddRoomComponentsWhenLoadingSystem(this.u4t_1, this.r4t_1);
  this.w4t_1 = new RoomDimensionToGeometrySystem(this.r4t_1);
  this.x4t_1 = new RoomComponentDeserializer();
  this.y4t_1 = new RoomLoadingSystem(this.u4t_1, this.r4t_1);
}
protoOf(TestRoomFeature).enable = function () {
  this.w4t_1.l2d(this.r4t_1);
  this.y4t_1.l2d(this.r4t_1);
  this.v4t_1.l2d(this.r4t_1);
  this.s4t_1.register(this.x4t_1);
  this.t4t_1.register(this.u4t_1);
  this.w4t_1.enable();
  this.y4t_1.enable();
  this.v4t_1.enable();
};
protoOf(TestRoomFeature).disable = function () {
  this.w4t_1.m2d(this.r4t_1);
  this.y4t_1.m2d(this.r4t_1);
  this.v4t_1.m2d(this.r4t_1);
  this.s4t_1.unregister(this.x4t_1);
  this.t4t_1.unregister(this.u4t_1);
};
function getOrCreateRoomEntity($this, sceneManager, entityManager) {
  var oldRoom = Companion_instance_138.w4o(sceneManager);
  var tmp;
  if (oldRoom == null) {
    var room = entityManager.createEntity();
    tmp = room;
  } else {
    tmp = oldRoom;
  }
  var room_0 = tmp;
  return room_0;
}
function updateRoom($this, room, geometry, entityManager) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_allRoomParts(room);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.Companion.updateRoom.<anonymous>' call
    var list = get_immediateConnectionRootDescendants(element);
    addAll(destination, list);
  }
  var roomChildren = destination;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = roomChildren.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.testroom.Companion.updateRoom.<anonymous>' call
    Companion_instance.j29(element_0);
    setParentMaintainWorldTransform(element_0, null);
  }
  removeOldData($this, room, entityManager);
  TestRoomBuildingUtils_instance.a4u(room, geometry, entityManager);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = roomChildren.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.testroom.Companion.updateRoom.<anonymous>' call
    setParentMaintainWorldTransform(element_1, room);
  }
}
function removeOldData($this, room, entityManager) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = filterInHierarchy(room, TestRoomUtils$Companion$removeOldData$lambda);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.Companion.removeOldData.<anonymous>' call
    entityManager.disposeEntity(element);
  }
}
function TestRoomUtils$Companion$removeOldData$lambda(it) {
  return get_isRoomPart(it) && !it.isDisposed;
}
function Companion_108() {
}
protoOf(Companion_108).b4u = function (sceneManager, entityManager, dimensions, center) {
  var realCenter = center == null ? new Vector(0.0, dimensions.height / 2, dimensions.depth / 2) : center;
  var room = getOrCreateRoomEntity(this, sceneManager, entityManager);
  var coreRoomGeometryData = Companion_instance_160.generateRectangularRoomGeometry$default(dimensions, realCenter);
  updateRoom(this, room, coreRoomGeometryData, entityManager);
  entityManager.addComponent(room, new RoomGeometryComponent(coreRoomGeometryData));
  setParent(room, sceneManager.scene);
  return room;
};
protoOf(Companion_108).createOrUpdateRectangularRoom$default = function (sceneManager, entityManager, dimensions, center, $super) {
  center = center === VOID ? null : center;
  return $super === VOID ? this.b4u(sceneManager, entityManager, dimensions, center) : $super.b4u.call(this, sceneManager, entityManager, dimensions, center);
};
protoOf(Companion_108).c4u = function (sceneManager, entityManager, roomGeometryData) {
  var room = getOrCreateRoomEntity(this, sceneManager, entityManager);
  updateRoom(this, room, roomGeometryData, entityManager);
  entityManager.addComponent(room, new RoomGeometryComponent(roomGeometryData));
  setParent(room, sceneManager.scene);
  return room;
};
var Companion_instance_147;
function Companion_getInstance_151() {
  return Companion_instance_147;
}
function createOrUpdateRectangularRoom(sceneManager, entityManager, dimensions, center) {
  return Companion_instance_147.b4u(sceneManager, entityManager, dimensions, center);
}
function createOrUpdateRectangularRoom_0(sceneManager, entityManager, dimensions, center, $super) {
  center = center === VOID ? null : center;
  return createOrUpdateRectangularRoom(sceneManager, entityManager, dimensions, center);
}
function createOrUpdateRoomFromGeometry(sceneManager, entityManager, roomGeometryData) {
  return Companion_instance_147.c4u(sceneManager, entityManager, roomGeometryData);
}
function TestRoomUtils() {
}
function RoomGeometryComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  $this$Json.y17_1 = 'itemType';
  return Unit_instance;
}
function getDimensions($this, convertedData) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = convertedData.walls;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.component.RoomGeometryComponent.getDimensions.<anonymous>' call
    var list = toList(element.surfaceGeometry.points);
    addAll(destination, list);
  }
  var vertices = copyToArray(destination);
  return Companion_getInstance_6().z2v(vertices);
}
function getCenter($this, roomGeometryData) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = roomGeometryData.walls;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.component.RoomGeometryComponent.getCenter.<anonymous>' call
    var list = toList(element.surfaceGeometry.points);
    addAll(destination, list);
  }
  var vertices = copyToArray(destination);
  return Companion_getInstance_6().z2v(vertices).center;
}
function Companion_109() {
  Companion_instance_148 = this;
  this.id = Companion_instance_0.n1p_1;
  this.serializationKey = 'RoomGeometry';
  var tmp = this;
  tmp.k3q_1 = Json(VOID, RoomGeometryComponent$Companion$serializer$lambda);
}
protoOf(Companion_109).n1s = function () {
  return this.id;
};
protoOf(Companion_109).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_109).x1s = function (json) {
  return this.k3q_1.y16(this.z18(), json);
};
protoOf(Companion_109).z18 = function () {
  return $serializer_getInstance_3();
};
var Companion_instance_148;
function Companion_getInstance_152() {
  if (Companion_instance_148 == null)
    new Companion_109();
  return Companion_instance_148;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.component.RoomGeometryComponent', this, 1);
  tmp0_serialDesc.lw('data', false);
  this.d4u_1 = tmp0_serialDesc;
}
protoOf($serializer_1).e4u = function (encoder, value) {
  var tmp0_desc = this.d4u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_5(), value.roomGeometryData);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_1).ul = function (encoder, value) {
  return this.e4u(encoder, value instanceof RoomGeometryComponent ? value : THROW_CCE());
};
protoOf($serializer_1).vl = function (decoder) {
  var tmp0_desc = this.d4u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.np(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.np(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return RoomGeometryComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).tl = function () {
  return this.d4u_1;
};
protoOf($serializer_1).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_5()];
};
var $serializer_instance_1;
function $serializer_getInstance_3() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function RoomGeometryComponent_init_$Init$(seen0, roomGeometryData, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_3().d4u_1);
  }
  $this.roomGeometryData = roomGeometryData;
  $this.dimensions = getDimensions($this, $this.roomGeometryData);
  $this.center = getCenter($this, $this.roomGeometryData);
  return $this;
}
function RoomGeometryComponent_init_$Create$(seen0, roomGeometryData, serializationConstructorMarker) {
  return RoomGeometryComponent_init_$Init$(seen0, roomGeometryData, serializationConstructorMarker, objectCreate(protoOf(RoomGeometryComponent)));
}
function RoomGeometryComponent(roomGeometryData) {
  Companion_getInstance_152();
  this.roomGeometryData = roomGeometryData;
  this.dimensions = getDimensions(this, this.roomGeometryData);
  this.center = getCenter(this, this.roomGeometryData);
}
protoOf(RoomGeometryComponent).f4u = function () {
  return this.roomGeometryData;
};
protoOf(RoomGeometryComponent).toJson = function (parse) {
  return Companion_getInstance_152().k3q_1.x16(Companion_getInstance_152().z18(), this);
};
protoOf(RoomGeometryComponent).serializationKey = function () {
  return Companion_getInstance_152().serializationKey;
};
protoOf(RoomGeometryComponent).t4o = function () {
  return this.dimensions;
};
protoOf(RoomGeometryComponent).o3b = function () {
  return this.center;
};
protoOf(RoomGeometryComponent).p1s = function () {
  return Companion_getInstance_152().id;
};
protoOf(RoomGeometryComponent).eq = function (other) {
  return (other instanceof RoomGeometryComponent ? other : THROW_CCE()).roomGeometryData.equals(this.roomGeometryData);
};
protoOf(RoomGeometryComponent).tf = function () {
  return this.roomGeometryData;
};
protoOf(RoomGeometryComponent).g4u = function (roomGeometryData) {
  return new RoomGeometryComponent(roomGeometryData);
};
protoOf(RoomGeometryComponent).copy = function (roomGeometryData, $super) {
  roomGeometryData = roomGeometryData === VOID ? this.roomGeometryData : roomGeometryData;
  return this.g4u(roomGeometryData);
};
protoOf(RoomGeometryComponent).toString = function () {
  return 'RoomGeometryComponent(roomGeometryData=' + this.roomGeometryData.toString() + ')';
};
protoOf(RoomGeometryComponent).hashCode = function () {
  return this.roomGeometryData.hashCode();
};
protoOf(RoomGeometryComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoomGeometryComponent))
    return false;
  var tmp0_other_with_cast = other instanceof RoomGeometryComponent ? other : THROW_CCE();
  if (!this.roomGeometryData.equals(tmp0_other_with_cast.roomGeometryData))
    return false;
  return true;
};
function TestRoomPartIdComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_110() {
  Companion_instance_149 = this;
  this.id = Companion_instance_0.z1r_1;
  this.serializationKey = 'roomPart';
  var tmp = this;
  tmp.h4u_1 = Json(VOID, TestRoomPartIdComponent$Companion$serializer$lambda);
}
protoOf(Companion_110).n1s = function () {
  return this.id;
};
protoOf(Companion_110).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_110).x1s = function (json) {
  return this.h4u_1.y16(this.z18(), json);
};
protoOf(Companion_110).z18 = function () {
  return $serializer_getInstance_4();
};
var Companion_instance_149;
function Companion_getInstance_153() {
  if (Companion_instance_149 == null)
    new Companion_110();
  return Companion_instance_149;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.component.TestRoomPartIdComponent', this, 1);
  tmp0_serialDesc.lw('partId', false);
  this.i4u_1 = tmp0_serialDesc;
}
protoOf($serializer_2).j4u = function (encoder, value) {
  var tmp0_desc = this.i4u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.partId);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_2).ul = function (encoder, value) {
  return this.j4u(encoder, value instanceof TestRoomPartIdComponent ? value : THROW_CCE());
};
protoOf($serializer_2).vl = function (decoder) {
  var tmp0_desc = this.i4u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return TestRoomPartIdComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_2).tl = function () {
  return this.i4u_1;
};
protoOf($serializer_2).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_2;
function $serializer_getInstance_4() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function TestRoomPartIdComponent_init_$Init$(seen0, partId, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_4().i4u_1);
  }
  $this.partId = partId;
  return $this;
}
function TestRoomPartIdComponent_init_$Create$(seen0, partId, serializationConstructorMarker) {
  return TestRoomPartIdComponent_init_$Init$(seen0, partId, serializationConstructorMarker, objectCreate(protoOf(TestRoomPartIdComponent)));
}
function TestRoomPartIdComponent(partId) {
  Companion_getInstance_153();
  this.partId = partId;
}
protoOf(TestRoomPartIdComponent).k4u = function () {
  return this.partId;
};
protoOf(TestRoomPartIdComponent).p1s = function () {
  return Companion_getInstance_153().id;
};
protoOf(TestRoomPartIdComponent).eq = function (other) {
  if (!(other instanceof TestRoomPartIdComponent))
    return false;
  return other.typeId === this.typeId && other.partId === this.partId;
};
protoOf(TestRoomPartIdComponent).toJson = function (parse) {
  return Companion_getInstance_153().h4u_1.x16(Companion_getInstance_153().z18(), this);
};
protoOf(TestRoomPartIdComponent).serializationKey = function () {
  return Companion_getInstance_153().serializationKey;
};
protoOf(TestRoomPartIdComponent).tf = function () {
  return this.partId;
};
protoOf(TestRoomPartIdComponent).h1t = function (partId) {
  return new TestRoomPartIdComponent(partId);
};
protoOf(TestRoomPartIdComponent).copy = function (partId, $super) {
  partId = partId === VOID ? this.partId : partId;
  return this.h1t(partId);
};
protoOf(TestRoomPartIdComponent).toString = function () {
  return 'TestRoomPartIdComponent(partId=' + this.partId + ')';
};
protoOf(TestRoomPartIdComponent).hashCode = function () {
  return getStringHashCode(this.partId);
};
protoOf(TestRoomPartIdComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TestRoomPartIdComponent))
    return false;
  var tmp0_other_with_cast = other instanceof TestRoomPartIdComponent ? other : THROW_CCE();
  if (!(this.partId === tmp0_other_with_cast.partId))
    return false;
  return true;
};
function get_roomPartId(_this__u8e3s4) {
  var tmp0_safe_receiver = get_roomPartIdComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.partId;
}
function get_roomPartIdComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_153().id);
}
function Companion_111() {
  Companion_instance_150 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l4u_1 = [new ReferenceArraySerializer(getKClass(CoreRoomSurface), $serializer_getInstance_6()), null, null, new ReferenceArraySerializer(getKClass(CoreRoomEdge), $serializer_getInstance_8()), new ReferenceArraySerializer(getKClass(CoreRoomVertex), $serializer_getInstance_9()), new ReferenceArraySerializer(getKClass(CoreRoomObstacle), $serializer_getInstance_10())];
}
protoOf(Companion_111).z18 = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_150;
function Companion_getInstance_154() {
  if (Companion_instance_150 == null)
    new Companion_111();
  return Companion_instance_150;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomGeometryData', this, 6);
  tmp0_serialDesc.lw('walls', false);
  tmp0_serialDesc.lw('floor', false);
  tmp0_serialDesc.lw('ceiling', false);
  tmp0_serialDesc.lw('edges', false);
  tmp0_serialDesc.lw('vertices', false);
  tmp0_serialDesc.lw('obstacles', true);
  this.m4u_1 = tmp0_serialDesc;
}
protoOf($serializer_3).n4u = function (encoder, value) {
  var tmp0_desc = this.m4u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_154().l4u_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.walls);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_6(), value.floor);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_6(), value.ceiling);
  tmp1_output.sq(tmp0_desc, 3, tmp2_cached[3], value.edges);
  tmp1_output.sq(tmp0_desc, 4, tmp2_cached[4], value.vertices);
  var tmp;
  if (tmp1_output.yq(tmp0_desc, 5)) {
    tmp = true;
  } else {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp = !equals(value.obstacles, tmp$ret$0);
  }
  if (tmp) {
    tmp1_output.sq(tmp0_desc, 5, tmp2_cached[5], value.obstacles);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_3).ul = function (encoder, value) {
  return this.n4u(encoder, value instanceof CoreRoomGeometryData ? value : THROW_CCE());
};
protoOf($serializer_3).vl = function (decoder) {
  var tmp0_desc = this.m4u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.bp(tmp0_desc);
  var tmp11_cached = Companion_getInstance_154().l4u_1;
  if (tmp10_input.rp()) {
    tmp4_local0 = tmp10_input.np(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.np(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.np(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.np(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.np(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.np(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.np(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.np(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.np(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.np(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.np(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.np(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.cp(tmp0_desc);
  return CoreRoomGeometryData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_3).tl = function () {
  return this.m4u_1;
};
protoOf($serializer_3).ex = function () {
  var tmp0_cached = Companion_getInstance_154().l4u_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp0_cached[0], $serializer_getInstance_6(), $serializer_getInstance_6(), tmp0_cached[3], tmp0_cached[4], tmp0_cached[5]];
};
var $serializer_instance_3;
function $serializer_getInstance_5() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function CoreRoomGeometryData_init_$Init$(seen0, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance_5().m4u_1);
  }
  $this.walls = walls;
  $this.floor = floor;
  $this.ceiling = ceiling;
  $this.edges = edges;
  $this.vertices = vertices;
  if (0 === (seen0 & 32)) {
    var tmp = $this;
    // Inline function 'kotlin.emptyArray' call
    tmp.obstacles = [];
  } else
    $this.obstacles = obstacles;
  return $this;
}
function CoreRoomGeometryData_init_$Create$(seen0, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker) {
  return CoreRoomGeometryData_init_$Init$(seen0, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker, objectCreate(protoOf(CoreRoomGeometryData)));
}
function CoreRoomGeometryData(walls, floor, ceiling, edges, vertices, obstacles) {
  Companion_getInstance_154();
  var tmp;
  if (obstacles === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = obstacles;
  }
  obstacles = tmp;
  this.walls = walls;
  this.floor = floor;
  this.ceiling = ceiling;
  this.edges = edges;
  this.vertices = vertices;
  this.obstacles = obstacles;
}
protoOf(CoreRoomGeometryData).o4u = function () {
  return this.walls;
};
protoOf(CoreRoomGeometryData).p4u = function () {
  return this.floor;
};
protoOf(CoreRoomGeometryData).q4u = function () {
  return this.ceiling;
};
protoOf(CoreRoomGeometryData).r4u = function () {
  return this.edges;
};
protoOf(CoreRoomGeometryData).d2i = function () {
  return this.vertices;
};
protoOf(CoreRoomGeometryData).s4u = function () {
  return this.obstacles;
};
protoOf(CoreRoomGeometryData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof CoreRoomGeometryData))
    THROW_CCE();
  if (!contentEquals(this.walls, other.walls))
    return false;
  if (!this.floor.equals(other.floor))
    return false;
  if (!this.ceiling.equals(other.ceiling))
    return false;
  if (!contentEquals(this.edges, other.edges))
    return false;
  if (!contentEquals(this.vertices, other.vertices))
    return false;
  if (!contentEquals(this.obstacles, other.obstacles))
    return false;
  return true;
};
protoOf(CoreRoomGeometryData).hashCode = function () {
  var result = contentHashCode(this.walls);
  result = imul(11, result) + this.floor.hashCode() | 0;
  result = imul(23, result) + this.ceiling.hashCode() | 0;
  result = imul(31, result) + contentHashCode(this.edges) | 0;
  result = imul(19, result) + contentHashCode(this.vertices) | 0;
  return result;
};
protoOf(CoreRoomGeometryData).tf = function () {
  return this.walls;
};
protoOf(CoreRoomGeometryData).uf = function () {
  return this.floor;
};
protoOf(CoreRoomGeometryData).m1m = function () {
  return this.ceiling;
};
protoOf(CoreRoomGeometryData).n1m = function () {
  return this.edges;
};
protoOf(CoreRoomGeometryData).o1m = function () {
  return this.vertices;
};
protoOf(CoreRoomGeometryData).p1m = function () {
  return this.obstacles;
};
protoOf(CoreRoomGeometryData).t4u = function (walls, floor, ceiling, edges, vertices, obstacles) {
  return new CoreRoomGeometryData(walls, floor, ceiling, edges, vertices, obstacles);
};
protoOf(CoreRoomGeometryData).copy = function (walls, floor, ceiling, edges, vertices, obstacles, $super) {
  walls = walls === VOID ? this.walls : walls;
  floor = floor === VOID ? this.floor : floor;
  ceiling = ceiling === VOID ? this.ceiling : ceiling;
  edges = edges === VOID ? this.edges : edges;
  vertices = vertices === VOID ? this.vertices : vertices;
  obstacles = obstacles === VOID ? this.obstacles : obstacles;
  return this.t4u(walls, floor, ceiling, edges, vertices, obstacles);
};
protoOf(CoreRoomGeometryData).toString = function () {
  return 'CoreRoomGeometryData(walls=' + toString(this.walls) + ', floor=' + this.floor.toString() + ', ceiling=' + this.ceiling.toString() + ', edges=' + toString(this.edges) + ', vertices=' + toString(this.vertices) + ', obstacles=' + toString(this.obstacles) + ')';
};
function Companion_112() {
}
protoOf(Companion_112).z18 = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_151;
function Companion_getInstance_155() {
  return Companion_instance_151;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomSurface', this, 2);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('s', false);
  this.u4u_1 = tmp0_serialDesc;
}
protoOf($serializer_4).v4u = function (encoder, value) {
  var tmp0_desc = this.u4u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_7(), value.surfaceGeometry);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_4).ul = function (encoder, value) {
  return this.v4u(encoder, value instanceof CoreRoomSurface ? value : THROW_CCE());
};
protoOf($serializer_4).vl = function (decoder) {
  var tmp0_desc = this.u4u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return CoreRoomSurface_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_4).tl = function () {
  return this.u4u_1;
};
protoOf($serializer_4).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), $serializer_getInstance_7()];
};
var $serializer_instance_4;
function $serializer_getInstance_6() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function CoreRoomSurface_init_$Init$(seen0, id, surfaceGeometry, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_6().u4u_1);
  }
  $this.id = id;
  $this.surfaceGeometry = surfaceGeometry;
  return $this;
}
function CoreRoomSurface_init_$Create$(seen0, id, surfaceGeometry, serializationConstructorMarker) {
  return CoreRoomSurface_init_$Init$(seen0, id, surfaceGeometry, serializationConstructorMarker, objectCreate(protoOf(CoreRoomSurface)));
}
function CoreRoomSurface(id, surfaceGeometry) {
  this.id = id;
  this.surfaceGeometry = surfaceGeometry;
}
protoOf(CoreRoomSurface).n1s = function () {
  return this.id;
};
protoOf(CoreRoomSurface).w4u = function () {
  return this.surfaceGeometry;
};
protoOf(CoreRoomSurface).tf = function () {
  return this.id;
};
protoOf(CoreRoomSurface).uf = function () {
  return this.surfaceGeometry;
};
protoOf(CoreRoomSurface).x4u = function (id, surfaceGeometry) {
  return new CoreRoomSurface(id, surfaceGeometry);
};
protoOf(CoreRoomSurface).copy = function (id, surfaceGeometry, $super) {
  id = id === VOID ? this.id : id;
  surfaceGeometry = surfaceGeometry === VOID ? this.surfaceGeometry : surfaceGeometry;
  return this.x4u(id, surfaceGeometry);
};
protoOf(CoreRoomSurface).toString = function () {
  return 'CoreRoomSurface(id=' + this.id + ', surfaceGeometry=' + this.surfaceGeometry.toString() + ')';
};
protoOf(CoreRoomSurface).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + this.surfaceGeometry.hashCode() | 0;
  return result;
};
protoOf(CoreRoomSurface).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoreRoomSurface))
    return false;
  var tmp0_other_with_cast = other instanceof CoreRoomSurface ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!this.surfaceGeometry.equals(tmp0_other_with_cast.surfaceGeometry))
    return false;
  return true;
};
function Companion_113() {
  Companion_instance_152 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.y4u_1 = [new ReferenceArraySerializer(getKClass(Vector), $serializer_getInstance())];
}
protoOf(Companion_113).z18 = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_152;
function Companion_getInstance_156() {
  if (Companion_instance_152 == null)
    new Companion_113();
  return Companion_instance_152;
}
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.RoomSurfaceGeometry', this, 1);
  tmp0_serialDesc.lw('p', false);
  this.z4u_1 = tmp0_serialDesc;
}
protoOf($serializer_5).a4v = function (encoder, value) {
  var tmp0_desc = this.z4u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_156().y4u_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.points);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_5).ul = function (encoder, value) {
  return this.a4v(encoder, value instanceof RoomSurfaceGeometry ? value : THROW_CCE());
};
protoOf($serializer_5).vl = function (decoder) {
  var tmp0_desc = this.z4u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  var tmp6_cached = Companion_getInstance_156().y4u_1;
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return RoomSurfaceGeometry_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_5).tl = function () {
  return this.z4u_1;
};
protoOf($serializer_5).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_156().y4u_1[0]];
};
var $serializer_instance_5;
function $serializer_getInstance_7() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function RoomSurfaceGeometry_init_$Init$(seen0, points, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_7().z4u_1);
  }
  $this.points = points;
  return $this;
}
function RoomSurfaceGeometry_init_$Create$(seen0, points, serializationConstructorMarker) {
  return RoomSurfaceGeometry_init_$Init$(seen0, points, serializationConstructorMarker, objectCreate(protoOf(RoomSurfaceGeometry)));
}
function RoomSurfaceGeometry(points) {
  Companion_getInstance_156();
  this.points = points;
}
protoOf(RoomSurfaceGeometry).b4v = function () {
  return this.points;
};
protoOf(RoomSurfaceGeometry).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RoomSurfaceGeometry))
    THROW_CCE();
  if (!contentEquals(this.points, other.points))
    return false;
  return true;
};
protoOf(RoomSurfaceGeometry).hashCode = function () {
  return contentHashCode(this.points);
};
protoOf(RoomSurfaceGeometry).tf = function () {
  return this.points;
};
protoOf(RoomSurfaceGeometry).c4v = function (points) {
  return new RoomSurfaceGeometry(points);
};
protoOf(RoomSurfaceGeometry).copy = function (points, $super) {
  points = points === VOID ? this.points : points;
  return this.c4v(points);
};
protoOf(RoomSurfaceGeometry).toString = function () {
  return 'RoomSurfaceGeometry(points=' + toString(this.points) + ')';
};
function Companion_114() {
}
protoOf(Companion_114).z18 = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_153;
function Companion_getInstance_157() {
  return Companion_instance_153;
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomEdge', this, 5);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('s1', false);
  tmp0_serialDesc.lw('s2', false);
  tmp0_serialDesc.lw('p1', false);
  tmp0_serialDesc.lw('p2', false);
  this.d4v_1 = tmp0_serialDesc;
}
protoOf($serializer_6).e4v = function (encoder, value) {
  var tmp0_desc = this.d4v_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.qq(tmp0_desc, 1, value.surfaceId1);
  tmp1_output.qq(tmp0_desc, 2, value.surfaceId2);
  tmp1_output.sq(tmp0_desc, 3, $serializer_getInstance(), value.point1);
  tmp1_output.sq(tmp0_desc, 4, $serializer_getInstance(), value.point2);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_6).ul = function (encoder, value) {
  return this.e4v(encoder, value instanceof CoreRoomEdge ? value : THROW_CCE());
};
protoOf($serializer_6).vl = function (decoder) {
  var tmp0_desc = this.d4v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.bp(tmp0_desc);
  if (tmp9_input.rp()) {
    tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.np(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.np(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.np(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.np(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.cp(tmp0_desc);
  return CoreRoomEdge_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_6).tl = function () {
  return this.d4v_1;
};
protoOf($serializer_6).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
};
var $serializer_instance_6;
function $serializer_getInstance_8() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function CoreRoomEdge_init_$Init$(seen0, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance_8().d4v_1);
  }
  $this.id = id;
  $this.surfaceId1 = surfaceId1;
  $this.surfaceId2 = surfaceId2;
  $this.point1 = point1;
  $this.point2 = point2;
  return $this;
}
function CoreRoomEdge_init_$Create$(seen0, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker) {
  return CoreRoomEdge_init_$Init$(seen0, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker, objectCreate(protoOf(CoreRoomEdge)));
}
function CoreRoomEdge(id, surfaceId1, surfaceId2, point1, point2) {
  this.id = id;
  this.surfaceId1 = surfaceId1;
  this.surfaceId2 = surfaceId2;
  this.point1 = point1;
  this.point2 = point2;
}
protoOf(CoreRoomEdge).n1s = function () {
  return this.id;
};
protoOf(CoreRoomEdge).f4v = function () {
  return this.surfaceId1;
};
protoOf(CoreRoomEdge).g4v = function () {
  return this.surfaceId2;
};
protoOf(CoreRoomEdge).h4v = function () {
  return this.point1;
};
protoOf(CoreRoomEdge).i4v = function () {
  return this.point2;
};
protoOf(CoreRoomEdge).tf = function () {
  return this.id;
};
protoOf(CoreRoomEdge).uf = function () {
  return this.surfaceId1;
};
protoOf(CoreRoomEdge).m1m = function () {
  return this.surfaceId2;
};
protoOf(CoreRoomEdge).n1m = function () {
  return this.point1;
};
protoOf(CoreRoomEdge).o1m = function () {
  return this.point2;
};
protoOf(CoreRoomEdge).j4v = function (id, surfaceId1, surfaceId2, point1, point2) {
  return new CoreRoomEdge(id, surfaceId1, surfaceId2, point1, point2);
};
protoOf(CoreRoomEdge).copy = function (id, surfaceId1, surfaceId2, point1, point2, $super) {
  id = id === VOID ? this.id : id;
  surfaceId1 = surfaceId1 === VOID ? this.surfaceId1 : surfaceId1;
  surfaceId2 = surfaceId2 === VOID ? this.surfaceId2 : surfaceId2;
  point1 = point1 === VOID ? this.point1 : point1;
  point2 = point2 === VOID ? this.point2 : point2;
  return this.j4v(id, surfaceId1, surfaceId2, point1, point2);
};
protoOf(CoreRoomEdge).toString = function () {
  return 'CoreRoomEdge(id=' + this.id + ', surfaceId1=' + this.surfaceId1 + ', surfaceId2=' + this.surfaceId2 + ', point1=' + this.point1.toString() + ', point2=' + this.point2.toString() + ')';
};
protoOf(CoreRoomEdge).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getStringHashCode(this.surfaceId1) | 0;
  result = imul(result, 31) + getStringHashCode(this.surfaceId2) | 0;
  result = imul(result, 31) + this.point1.hashCode() | 0;
  result = imul(result, 31) + this.point2.hashCode() | 0;
  return result;
};
protoOf(CoreRoomEdge).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoreRoomEdge))
    return false;
  var tmp0_other_with_cast = other instanceof CoreRoomEdge ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.surfaceId1 === tmp0_other_with_cast.surfaceId1))
    return false;
  if (!(this.surfaceId2 === tmp0_other_with_cast.surfaceId2))
    return false;
  if (!this.point1.equals(tmp0_other_with_cast.point1))
    return false;
  if (!this.point2.equals(tmp0_other_with_cast.point2))
    return false;
  return true;
};
function Companion_115() {
  Companion_instance_154 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.k4v_1 = [null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance()), new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance())];
}
protoOf(Companion_115).z18 = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_154;
function Companion_getInstance_158() {
  if (Companion_instance_154 == null)
    new Companion_115();
  return Companion_instance_154;
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomVertex', this, 4);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('p', false);
  tmp0_serialDesc.lw('s', false);
  tmp0_serialDesc.lw('e', false);
  this.l4v_1 = tmp0_serialDesc;
}
protoOf($serializer_7).m4v = function (encoder, value) {
  var tmp0_desc = this.l4v_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_158().k4v_1;
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance(), value.point);
  tmp1_output.sq(tmp0_desc, 2, tmp2_cached[2], value.surfaces);
  tmp1_output.sq(tmp0_desc, 3, tmp2_cached[3], value.edges);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_7).ul = function (encoder, value) {
  return this.m4v(encoder, value instanceof CoreRoomVertex ? value : THROW_CCE());
};
protoOf($serializer_7).vl = function (decoder) {
  var tmp0_desc = this.l4v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.bp(tmp0_desc);
  var tmp9_cached = Companion_getInstance_158().k4v_1;
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.np(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.np(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.np(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.np(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return CoreRoomVertex_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_7).tl = function () {
  return this.l4v_1;
};
protoOf($serializer_7).ex = function () {
  var tmp0_cached = Companion_getInstance_158().k4v_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), $serializer_getInstance(), tmp0_cached[2], tmp0_cached[3]];
};
var $serializer_instance_7;
function $serializer_getInstance_9() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function CoreRoomVertex_init_$Init$(seen0, id, point, surfaces, edges, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_9().l4v_1);
  }
  $this.id = id;
  $this.point = point;
  $this.surfaces = surfaces;
  $this.edges = edges;
  return $this;
}
function CoreRoomVertex_init_$Create$(seen0, id, point, surfaces, edges, serializationConstructorMarker) {
  return CoreRoomVertex_init_$Init$(seen0, id, point, surfaces, edges, serializationConstructorMarker, objectCreate(protoOf(CoreRoomVertex)));
}
function CoreRoomVertex(id, point, surfaces, edges) {
  Companion_getInstance_158();
  this.id = id;
  this.point = point;
  this.surfaces = surfaces;
  this.edges = edges;
}
protoOf(CoreRoomVertex).n1s = function () {
  return this.id;
};
protoOf(CoreRoomVertex).x2j = function () {
  return this.point;
};
protoOf(CoreRoomVertex).n2i = function () {
  return this.surfaces;
};
protoOf(CoreRoomVertex).r4u = function () {
  return this.edges;
};
protoOf(CoreRoomVertex).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof CoreRoomVertex))
    THROW_CCE();
  if (!(this.id === other.id))
    return false;
  if (!this.point.equals(other.point))
    return false;
  if (!contentEquals(this.surfaces, other.surfaces))
    return false;
  if (!contentEquals(this.edges, other.edges))
    return false;
  return true;
};
protoOf(CoreRoomVertex).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(31, result) + this.point.hashCode() | 0;
  result = imul(31, result) + contentHashCode(this.surfaces) | 0;
  result = imul(31, result) + contentHashCode(this.edges) | 0;
  return result;
};
protoOf(CoreRoomVertex).tf = function () {
  return this.id;
};
protoOf(CoreRoomVertex).uf = function () {
  return this.point;
};
protoOf(CoreRoomVertex).m1m = function () {
  return this.surfaces;
};
protoOf(CoreRoomVertex).n1m = function () {
  return this.edges;
};
protoOf(CoreRoomVertex).n4v = function (id, point, surfaces, edges) {
  return new CoreRoomVertex(id, point, surfaces, edges);
};
protoOf(CoreRoomVertex).copy = function (id, point, surfaces, edges, $super) {
  id = id === VOID ? this.id : id;
  point = point === VOID ? this.point : point;
  surfaces = surfaces === VOID ? this.surfaces : surfaces;
  edges = edges === VOID ? this.edges : edges;
  return this.n4v(id, point, surfaces, edges);
};
protoOf(CoreRoomVertex).toString = function () {
  return 'CoreRoomVertex(id=' + this.id + ', point=' + this.point.toString() + ', surfaces=' + toString(this.surfaces) + ', edges=' + toString(this.edges) + ')';
};
function Companion_116() {
}
protoOf(Companion_116).z18 = function () {
  return $serializer_getInstance_10();
};
var Companion_instance_155;
function Companion_getInstance_159() {
  return Companion_instance_155;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomObstacle', this, 3);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('t', false);
  tmp0_serialDesc.lw('b', false);
  this.o4v_1 = tmp0_serialDesc;
}
protoOf($serializer_8).p4v = function (encoder, value) {
  var tmp0_desc = this.o4v_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.qq(tmp0_desc, 1, value.type);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_11(), value.boundingBox);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_8).ul = function (encoder, value) {
  return this.p4v(encoder, value instanceof CoreRoomObstacle ? value : THROW_CCE());
};
protoOf($serializer_8).vl = function (decoder) {
  var tmp0_desc = this.o4v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return CoreRoomObstacle_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_8).tl = function () {
  return this.o4v_1;
};
protoOf($serializer_8).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_11()];
};
var $serializer_instance_8;
function $serializer_getInstance_10() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function CoreRoomObstacle_init_$Init$(seen0, id, type, boundingBox, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_10().o4v_1);
  }
  $this.id = id;
  $this.type = type;
  $this.boundingBox = boundingBox;
  return $this;
}
function CoreRoomObstacle_init_$Create$(seen0, id, type, boundingBox, serializationConstructorMarker) {
  return CoreRoomObstacle_init_$Init$(seen0, id, type, boundingBox, serializationConstructorMarker, objectCreate(protoOf(CoreRoomObstacle)));
}
function CoreRoomObstacle(id, type, boundingBox) {
  this.id = id;
  this.type = type;
  this.boundingBox = boundingBox;
}
protoOf(CoreRoomObstacle).n1s = function () {
  return this.id;
};
protoOf(CoreRoomObstacle).w2a = function () {
  return this.type;
};
protoOf(CoreRoomObstacle).q4v = function () {
  return this.boundingBox;
};
protoOf(CoreRoomObstacle).tf = function () {
  return this.id;
};
protoOf(CoreRoomObstacle).uf = function () {
  return this.type;
};
protoOf(CoreRoomObstacle).m1m = function () {
  return this.boundingBox;
};
protoOf(CoreRoomObstacle).r4v = function (id, type, boundingBox) {
  return new CoreRoomObstacle(id, type, boundingBox);
};
protoOf(CoreRoomObstacle).copy = function (id, type, boundingBox, $super) {
  id = id === VOID ? this.id : id;
  type = type === VOID ? this.type : type;
  boundingBox = boundingBox === VOID ? this.boundingBox : boundingBox;
  return this.r4v(id, type, boundingBox);
};
protoOf(CoreRoomObstacle).toString = function () {
  return 'CoreRoomObstacle(id=' + this.id + ', type=' + this.type + ', boundingBox=' + this.boundingBox.toString() + ')';
};
protoOf(CoreRoomObstacle).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getStringHashCode(this.type) | 0;
  result = imul(result, 31) + this.boundingBox.hashCode() | 0;
  return result;
};
protoOf(CoreRoomObstacle).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoreRoomObstacle))
    return false;
  var tmp0_other_with_cast = other instanceof CoreRoomObstacle ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.type === tmp0_other_with_cast.type))
    return false;
  if (!this.boundingBox.equals(tmp0_other_with_cast.boundingBox))
    return false;
  return true;
};
function Companion_117() {
}
protoOf(Companion_117).z18 = function () {
  return $serializer_getInstance_11();
};
var Companion_instance_156;
function Companion_getInstance_160() {
  return Companion_instance_156;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.testroom.dto.CoreRoomBoundingBox', this, 2);
  tmp0_serialDesc.lw('s', false);
  tmp0_serialDesc.lw('t', false);
  this.s4v_1 = tmp0_serialDesc;
}
protoOf($serializer_9).t4v = function (encoder, value) {
  var tmp0_desc = this.s4v_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance(), value.size);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_0(), value.transform);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_9).ul = function (encoder, value) {
  return this.t4v(encoder, value instanceof CoreRoomBoundingBox ? value : THROW_CCE());
};
protoOf($serializer_9).vl = function (decoder) {
  var tmp0_desc = this.s4v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return CoreRoomBoundingBox_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_9).tl = function () {
  return this.s4v_1;
};
protoOf($serializer_9).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance(), $serializer_getInstance_0()];
};
var $serializer_instance_9;
function $serializer_getInstance_11() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function CoreRoomBoundingBox_init_$Init$(seen0, size, transform, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_11().s4v_1);
  }
  $this.size = size;
  $this.transform = transform;
  return $this;
}
function CoreRoomBoundingBox_init_$Create$(seen0, size, transform, serializationConstructorMarker) {
  return CoreRoomBoundingBox_init_$Init$(seen0, size, transform, serializationConstructorMarker, objectCreate(protoOf(CoreRoomBoundingBox)));
}
function CoreRoomBoundingBox(size, transform) {
  this.size = size;
  this.transform = transform;
}
protoOf(CoreRoomBoundingBox).o = function () {
  return this.size;
};
protoOf(CoreRoomBoundingBox).z2a = function () {
  return this.transform;
};
protoOf(CoreRoomBoundingBox).tf = function () {
  return this.size;
};
protoOf(CoreRoomBoundingBox).uf = function () {
  return this.transform;
};
protoOf(CoreRoomBoundingBox).u4v = function (size, transform) {
  return new CoreRoomBoundingBox(size, transform);
};
protoOf(CoreRoomBoundingBox).copy = function (size, transform, $super) {
  size = size === VOID ? this.size : size;
  transform = transform === VOID ? this.transform : transform;
  return this.u4v(size, transform);
};
protoOf(CoreRoomBoundingBox).toString = function () {
  return 'CoreRoomBoundingBox(size=' + this.size.toString() + ', transform=' + this.transform.toString() + ')';
};
protoOf(CoreRoomBoundingBox).hashCode = function () {
  var result = this.size.hashCode();
  result = imul(result, 31) + this.transform.hashCode() | 0;
  return result;
};
protoOf(CoreRoomBoundingBox).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoreRoomBoundingBox))
    return false;
  var tmp0_other_with_cast = other instanceof CoreRoomBoundingBox ? other : THROW_CCE();
  if (!this.size.equals(tmp0_other_with_cast.size))
    return false;
  if (!this.transform.equals(tmp0_other_with_cast.transform))
    return false;
  return true;
};
function Companion_118() {
  this.t4s_1 = 'AddRoomComponentsWhenLoadingSystem';
}
var Companion_instance_157;
function Companion_getInstance_161() {
  return Companion_instance_157;
}
function AddRoomComponentsWhenLoadingSystem(roomLoadingInterceptor, entityManager) {
  SystemBase.call(this, Companion_instance_157.t4s_1, Companion_getInstance_152().id);
  this.e4w_1 = roomLoadingInterceptor;
  this.f4w_1 = entityManager;
  this.enable();
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g4w_1 = [Companion_instance_0.w1o_1, Companion_instance_0.y1n_1, Companion_instance_0.q1o_1, Companion_instance_0.s1q_1];
}
protoOf(AddRoomComponentsWhenLoadingSystem).j1w = function () {
  return this.g4w_1;
};
protoOf(AddRoomComponentsWhenLoadingSystem).h4w = function (room, newRoomGeometryComponent) {
  if (this.e4w_1.l4w()) {
    TestRoomBuildingUtils_instance.i4w(room, this.f4w_1);
  }
};
protoOf(AddRoomComponentsWhenLoadingSystem).v1v = function (entity, newComponent) {
  return this.h4w(entity, newComponent instanceof RoomGeometryComponent ? newComponent : THROW_CCE());
};
protoOf(AddRoomComponentsWhenLoadingSystem).m4w = function (room, oldComponent, newComponent) {
};
protoOf(AddRoomComponentsWhenLoadingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof RoomGeometryComponent ? oldComponent : THROW_CCE();
  return this.m4w(entity, tmp, newComponent instanceof RoomGeometryComponent ? newComponent : THROW_CCE());
};
protoOf(AddRoomComponentsWhenLoadingSystem).n4w = function (room, oldComponent) {
};
protoOf(AddRoomComponentsWhenLoadingSystem).z1v = function (entity, oldComponent) {
  return this.n4w(entity, oldComponent instanceof RoomGeometryComponent ? oldComponent : THROW_CCE());
};
function RoomComponentDeserializer() {
  this.o4w_1 = true;
}
protoOf(RoomComponentDeserializer).s1t = function () {
  return this.o4w_1;
};
protoOf(RoomComponentDeserializer).canHandle = function (serializationKey) {
  return serializationKey === Companion_getInstance_141().serializationKey ? true : serializationKey === Companion_getInstance_152().serializationKey ? true : serializationKey === Companion_getInstance_153().serializationKey ? true : false;
};
protoOf(RoomComponentDeserializer).deserialize = function (serializationKey, json) {
  var tmp;
  if (serializationKey === Companion_getInstance_141().serializationKey) {
    tmp = Companion_getInstance_141().x1s(json);
  } else if (serializationKey === Companion_getInstance_152().serializationKey) {
    tmp = Companion_getInstance_152().x1s(json);
  } else if (serializationKey === Companion_getInstance_153().serializationKey) {
    tmp = Companion_getInstance_153().x1s(json);
  } else {
    var message = 'No component deserializer found even though we promised that we had one';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return tmp;
};
function Companion_119() {
  this.p4w_1 = 'RoomDimensionToGeometrySystem';
}
var Companion_instance_158;
function Companion_getInstance_162() {
  return Companion_instance_158;
}
function createGeometry($this, room, dimensions) {
  var roomGeometryData = Companion_instance_160.generateRectangularRoomGeometry$default(dimensions, new Vector(0.0, dimensions.height / 2, dimensions.depth / 2));
  $this.z4w_1.addComponent(room, new RoomComponent());
  $this.z4w_1.addComponent(room, new RoomGeometryComponent(roomGeometryData));
  $this.z4w_1.addComponent(room, new StaticComponent());
  $this.z4w_1.removeComponent(room, Companion_getInstance_141().id);
}
function RoomDimensionToGeometrySystem(entityManager) {
  SystemBase.call(this, 'RoomDimensionToGeometrySystem', Companion_getInstance_141().id);
  this.z4w_1 = entityManager;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.a4x_1 = [Companion_instance_0.n1p_1, Companion_instance_0.w1o_1];
}
protoOf(RoomDimensionToGeometrySystem).b4x = function (entity, newComponent) {
  createGeometry(this, entity, newComponent.dimensions);
};
protoOf(RoomDimensionToGeometrySystem).v1v = function (entity, newComponent) {
  return this.b4x(entity, newComponent instanceof RoomDimensionsComponent ? newComponent : THROW_CCE());
};
protoOf(RoomDimensionToGeometrySystem).c4x = function (entity, oldComponent, newComponent) {
  createGeometry(this, entity, newComponent.dimensions);
};
protoOf(RoomDimensionToGeometrySystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof RoomDimensionsComponent ? oldComponent : THROW_CCE();
  return this.c4x(entity, tmp, newComponent instanceof RoomDimensionsComponent ? newComponent : THROW_CCE());
};
protoOf(RoomDimensionToGeometrySystem).d4x = function (entity, oldComponent) {
};
protoOf(RoomDimensionToGeometrySystem).z1v = function (entity, oldComponent) {
  return this.d4x(entity, oldComponent instanceof RoomDimensionsComponent ? oldComponent : THROW_CCE());
};
protoOf(RoomDimensionToGeometrySystem).j1w = function () {
  return this.a4x_1;
};
function RoomLoadingInterceptor() {
  this.j4w_1 = 0;
  this.k4w_1 = false;
}
protoOf(RoomLoadingInterceptor).e4x = function () {
  return this.j4w_1;
};
protoOf(RoomLoadingInterceptor).l4w = function () {
  return this.k4w_1;
};
protoOf(RoomLoadingInterceptor).beforeBuildingEntities = function (serializableTree, catalogVersions) {
  var tmp = this;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var this_0 = serializableTree.n2k();
    var tmp_0;
    if (isInterface(this_0, Collection)) {
      tmp_0 = this_0.r();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.serialization.RoomLoadingInterceptor.beforeBuildingEntities.<anonymous>' call
      var tmp0_safe_receiver = element.components;
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable = 0;
          var last = tmp0_safe_receiver.length;
          while (inductionVariable < last) {
            var element_0 = tmp0_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.testroom.serialization.RoomLoadingInterceptor.beforeBuildingEntities.<anonymous>.<anonymous>' call
            if (element_0.typeId === Companion_getInstance_153().id) {
              tmp$ret$2 = true;
              break $l$block_0;
            }
          }
          tmp$ret$2 = false;
        }
        tmp_1 = tmp$ret$2;
      }
      var tmp1_elvis_lhs = tmp_1;
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  tmp.j4w_1 = tmp$ret$0;
  this.k4w_1 = true;
};
protoOf(RoomLoadingInterceptor).afterDeserializeComplete = function (root, catalogVersions) {
  afterDeserializeComplete.call(this, root, catalogVersions);
  this.k4w_1 = false;
};
function Companion_120() {
  Companion_instance_159 = this;
  this.u4s_1 = 'RoomLoadingSystem';
  this.v4s_1 = LoggerState_getInstance().g1v('RoomLoadingSystem');
}
var Companion_instance_159;
function Companion_getInstance_163() {
  if (Companion_instance_159 == null)
    new Companion_120();
  return Companion_instance_159;
}
function checkIfRoomLoadingIsDone($this, entity) {
  if (!$this.o4x_1.l4w())
    return Unit_instance;
  var isLoadingOldRoom = $this.o4x_1.e4x() === 0;
  if (isLoadingOldRoom) {
    handleLegacyRoom($this, entity);
  } else {
    if (entity.hasComponent(Companion_getInstance_153().id)) {
      var room = findInUpwardsHierarchy(entity, RoomLoadingSystem$checkIfRoomLoadingIsDone$lambda);
      var geometry = room == null ? null : room.__getComponentForKotlin(Companion_getInstance_152().id);
      if (!(geometry == null)) {
        TestRoomBuildingUtils_instance.r4x(entity, geometry.roomGeometryData, $this.p4x_1);
      } else {
        var tmp = Companion_getInstance_163().v4s_1;
        tmp.error(RoomLoadingSystem$checkIfRoomLoadingIsDone$lambda_0);
      }
    }
  }
}
function snapProductToRoomParts($this, entity) {
  var tmp = Companion_instance_1;
  var tmp0_safe_receiver = get_parent(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var tmp_1 = tmp_0;
  var snaps = tmp.p39(entity, tmp_1, new RoomLoadingSystem$snapProductToRoomParts$snaps$1());
  var snapToRoom = firstOrNull_0(Companion_getInstance_4().s35_1.sortAndSelect(snaps));
  if (snapToRoom == null)
    null;
  else {
    snapToRoom.performMoveAndConnect();
  }
}
function handleLegacyRoom($this, entity) {
  if (get_isRoom(entity)) {
    createRoomPartsForOldRoom($this, entity);
  }
  var isProduct = entity.hasComponent(Companion_getInstance_36().id) && get_isConnectionRoot(entity);
  var tmp0_safe_receiver = get_parent(entity);
  var isChildToTheRoom = (tmp0_safe_receiver == null ? null : get_isRoom(tmp0_safe_receiver)) === true;
  if (isProduct && isChildToTheRoom) {
    snapProductToRoomParts($this, entity);
  }
}
function createRoomPartsForOldRoom($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_152().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.roomGeometryData;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    TestRoomBuildingUtils_instance.a4u(entity, tmp1_safe_receiver, $this.p4x_1);
  }
}
function RoomLoadingSystem$checkIfRoomLoadingIsDone$lambda(it) {
  return get_isRoom(it);
}
function RoomLoadingSystem$checkIfRoomLoadingIsDone$lambda_0() {
  return 'Could not find room geometry when rebuilding room';
}
function RoomLoadingSystem$snapProductToRoomParts$snaps$1() {
  SnapSettings.call(this);
  this.w4x_1 = true;
  this.x4x_1 = true;
  this.y4x_1 = true;
  this.z4x_1 = true;
}
protoOf(RoomLoadingSystem$snapProductToRoomParts$snaps$1).v3d = function () {
  return this.w4x_1;
};
protoOf(RoomLoadingSystem$snapProductToRoomParts$snaps$1).w3d = function () {
  return this.x4x_1;
};
protoOf(RoomLoadingSystem$snapProductToRoomParts$snaps$1).x3d = function () {
  return this.y4x_1;
};
protoOf(RoomLoadingSystem$snapProductToRoomParts$snaps$1).y3d = function () {
  return this.z4x_1;
};
function RoomLoadingSystem(roomLoadingInterceptor, entityManager) {
  Companion_getInstance_163();
  SystemBase.call(this, Companion_getInstance_163().u4s_1, Companion_getInstance_27().z2o_1);
  this.o4x_1 = roomLoadingInterceptor;
  this.p4x_1 = entityManager;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.q4x_1 = [Companion_instance_20.ID];
}
protoOf(RoomLoadingSystem).k1w = function () {
  return this.q4x_1;
};
protoOf(RoomLoadingSystem).m2q = function (entity, newComponent) {
  checkIfRoomLoadingIsDone(this, entity);
};
protoOf(RoomLoadingSystem).v1v = function (entity, newComponent) {
  return this.m2q(entity, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(RoomLoadingSystem).o2q = function (entity, oldComponent, newComponent) {
  checkIfRoomLoadingIsDone(this, entity);
};
protoOf(RoomLoadingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE();
  return this.o2q(entity, tmp, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(RoomLoadingSystem).p2q = function (entity, oldComponent) {
};
protoOf(RoomLoadingSystem).z1v = function (entity, oldComponent) {
  return this.p2q(entity, oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE());
};
function addToRoom($this, entity, room) {
  setParentMaintainWorldTransform(entity, room);
}
function generateObstacleEntities($this, roomGeometry, entityManager) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = roomGeometry.obstacles;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateObstacleEntities.<anonymous>' call
    var tmp$ret$0 = createObstacleEntity(TestRoomBuildingUtils_instance, item.id, item.type, item.boundingBox, entityManager);
    destination.h(tmp$ret$0);
  }
  return destination;
}
function generateWallEntities($this, roomGeometry, oldParts, entityManager) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = roomGeometry.walls;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateWallEntities.<anonymous>' call
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = oldParts.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateWallEntities.<anonymous>.<anonymous>' call
        if (get_roomPartId(element) === item.id) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var entity = tmp0_elvis_lhs == null ? entityManager.createEntity() : tmp0_elvis_lhs;
    createRoomSurface(TestRoomBuildingUtils_instance, entity, item.id, item.surfaceGeometry.points);
    destination.h(entity);
  }
  return destination;
}
function generateEdgeEntities($this, roomGeometry, oldParts, entityManager) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  var this_0 = roomGeometry.walls;
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [roomGeometry.ceiling];
  var this_1 = this_0.concat(tmp$ret$3);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [roomGeometry.floor];
  var allSurfaces = this_1.concat(tmp$ret$8);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_2 = roomGeometry.edges;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = this_2.length;
  while (inductionVariable < last) {
    var element = this_2[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    var tmp$ret$10;
    $l$block_0: {
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateEdgeEntities.<anonymous>' call
      var tmp0_elvis_lhs = findSurfacePoints(TestRoomBuildingUtils_instance, allSurfaces, element.surfaceId1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$10 = null;
        break $l$block_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var surface1 = tmp;
      var tmp1_elvis_lhs = findSurfacePoints(TestRoomBuildingUtils_instance, allSurfaces, element.surfaceId2);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$10 = null;
        break $l$block_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var surface2 = tmp_0;
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$12;
      $l$block_1: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = oldParts.k();
        while (tmp0_iterator.m()) {
          var element_0 = tmp0_iterator.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateEdgeEntities.<anonymous>.<anonymous>' call
          if (get_roomPartId(element_0) === element.id) {
            tmp$ret$12 = element_0;
            break $l$block_1;
          }
        }
        tmp$ret$12 = null;
      }
      var tmp2_elvis_lhs = tmp$ret$12;
      var entity = tmp2_elvis_lhs == null ? entityManager.createEntity() : tmp2_elvis_lhs;
      createEdgeEntity(TestRoomBuildingUtils_instance, entity, element.id, element.point1, element.point2, surface1, surface2);
      tmp$ret$10 = entity;
    }
    var tmp0_safe_receiver = tmp$ret$10;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function generateCorners($this, roomGeometry, oldParts, entityManager) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  var this_0 = roomGeometry.walls;
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [roomGeometry.ceiling];
  var this_1 = this_0.concat(tmp$ret$3);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [roomGeometry.floor];
  var allSurfaces = this_1.concat(tmp$ret$8);
  // Inline function 'kotlin.collections.map' call
  var this_2 = roomGeometry.vertices;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_2.length);
  var inductionVariable = 0;
  var last = this_2.length;
  while (inductionVariable < last) {
    var item = this_2[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateCorners.<anonymous>' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_3 = item.surfaces;
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = this_3.length;
    while (inductionVariable_0 < last_0) {
      var element = this_3[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateCorners.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = findSurfacePoints(TestRoomBuildingUtils_instance, allSurfaces, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.h(tmp0_safe_receiver);
      }
    }
    var surfaces = destination_0;
    // Inline function 'kotlin.text.ifEmpty' call
    var this_4 = item.id;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_4) === 0) {
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateCorners.<anonymous>.<anonymous>' call
      tmp = null;
    } else {
      tmp = this_4;
    }
    var id = tmp;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$18;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = oldParts.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateCorners.<anonymous>.<anonymous>' call
        if (get_roomPartId(element_0) == id) {
          tmp$ret$18 = element_0;
          break $l$block;
        }
      }
      tmp$ret$18 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$18;
    var cornerEntity = tmp0_elvis_lhs == null ? entityManager.createEntity() : tmp0_elvis_lhs;
    createCornerEntity$default(TestRoomBuildingUtils_instance, cornerEntity, item.id, item.point, surfaces);
    destination.h(cornerEntity);
  }
  return destination;
}
function generateFloorEntity($this, roomGeometry, oldParts, entityManager) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = oldParts.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateFloorEntity.<anonymous>' call
      if (get_roomPartId(element) === roomGeometry.floor.id) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var entity = tmp0_elvis_lhs == null ? entityManager.createEntity() : tmp0_elvis_lhs;
  createRoomSurface($this, entity, roomGeometry.floor.id, roomGeometry.floor.surfaceGeometry.points);
  return entity;
}
function generateCeilingEntity($this, roomGeometry, oldParts, entityManager) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = oldParts.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.generateCeilingEntity.<anonymous>' call
      if (get_roomPartId(element) === roomGeometry.ceiling.id) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var entity = tmp0_elvis_lhs == null ? entityManager.createEntity() : tmp0_elvis_lhs;
  createRoomSurface($this, entity, roomGeometry.ceiling.id, roomGeometry.ceiling.surfaceGeometry.points);
  return entity;
}
function findSurfacePoints($this, allSurfaces, surfaceId) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = allSurfaces.length;
    while (inductionVariable < last) {
      var element = allSurfaces[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.findSurfacePoints.<anonymous>' call
      if (element.id === surfaceId) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var surface = tmp;
  return surface.surfaceGeometry.points;
}
function createCornerEntity($this, cornerEntity, id, cornerPoint, surfaces, cornerType) {
  var tmp = Companion_instance_35;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(surfaces);
  var definition = tmp.m3m(cornerPoint, tmp$ret$0);
  cornerEntity.addComponent(new TestRoomPartIdComponent(id));
  cornerEntity.addComponent(new DisplayNameComponent(cornerType + '{' + cornerEntity.id + '} - ' + id));
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = definition.asComponents();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.createCornerEntity.<anonymous>' call
    cornerEntity.addComponent(element);
  }
  return cornerEntity;
}
function createCornerEntity$default($this, cornerEntity, id, cornerPoint, surfaces, cornerType, $super) {
  cornerType = cornerType === VOID ? 'Corner' : cornerType;
  return createCornerEntity($this, cornerEntity, id, cornerPoint, surfaces, cornerType);
}
function createRoomSurface($this, entity, id, points) {
  entity.addComponent(new TestRoomPartIdComponent(id));
  entity.addComponent(new DisplayNameComponent('RoomSurface{' + entity.id + '} - ' + id));
  var definitions = Companion_instance_35.j3m(points);
  var colliders = Companion_getInstance_18().j3c(definitions.connector.vertices, 30.0);
  var collider = colliders.length === 1 ? colliders[0] : new PolyhedronGroup(colliders);
  var tmp0_elvis_lhs = get_displayName(entity);
  var name = tmp0_elvis_lhs == null ? 'ColliderId' : tmp0_elvis_lhs;
  if (collider instanceof PolyhedronGroup) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList_0(numberRangeToNumber(1, collider.polyhedra.length));
    var polyhedronNumbers = copyToArray(this_0);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(polyhedronNumbers.length);
    var inductionVariable = 0;
    var last = polyhedronNumbers.length;
    while (inductionVariable < last) {
      var item = polyhedronNumbers[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.createRoomSurface.<anonymous>' call
      var tmp$ret$1 = name + ' ' + item;
      destination.h(tmp$ret$1);
    }
    var ids = copyToArray(destination);
    entity.addComponent(new ColliderShapeComponent(collider, ids));
  } else {
    // Inline function 'kotlin.arrayOf' call
    var tmp1_elvis_lhs = get_displayName(entity);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = [tmp1_elvis_lhs == null ? 'Collider' : tmp1_elvis_lhs];
    entity.addComponent(new ColliderShapeComponent(collider, tmp$ret$7));
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = definitions.asComponents();
  var inductionVariable_0 = 0;
  var last_0 = indexedObject.length;
  while (inductionVariable_0 < last_0) {
    var element = indexedObject[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.createRoomSurface.<anonymous>' call
    entity.addComponent(element);
  }
  return entity;
}
function createEdgeEntity($this, edgeEntity, id, cornerPoint1, cornerPoint2, surface1, surface2) {
  var edgeId = edgeEntity.id;
  var definitions = Companion_instance_35.l3m(cornerPoint1, cornerPoint2, surface1, surface2);
  var includesSurfaceTypes = definitions.adjacentSurfaceTypes;
  var edgeType = contains(includesSurfaceTypes, Companion_instance_36.n3l_1) ? 'CeilingEdge' : contains(includesSurfaceTypes, Companion_instance_36.m3l_1) ? 'FloorEdge' : contains(includesSurfaceTypes, Companion_instance_36.l3l_1) ? 'WallEdge' : 'Edge';
  edgeEntity.addComponent(new DisplayNameComponent('Edge (' + edgeType + ' - ' + edgeId));
  edgeEntity.addComponent(new TestRoomPartIdComponent(id));
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = definitions.asComponents();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.createEdgeEntity.<anonymous>' call
    edgeEntity.addComponent(element);
  }
  return edgeEntity;
}
function createObstacleEntity($this, id, type, boundingBox, entityManager) {
  var entity = entityManager.createEntity();
  var obstaclePolyhedron = fromSize(boundingBox.size);
  var transform = boundingBox.transform;
  entity.addComponent(new DisplayNameComponent(type + '-' + id));
  entity.addComponent(new ColliderShapeComponent(obstaclePolyhedron));
  entity.addComponent(new LocalTransformComponent(transform));
  entity.addComponent(new WorldTransformComponent(transform));
  entity.addComponent(new RoomPartComponent(Companion_instance_37.f3m_1));
  entity.addComponent(new TestRoomPartIdComponent(id));
  return entity;
}
function TestRoomBuildingUtils() {
  this.z4t_1 = 30.0;
}
protoOf(TestRoomBuildingUtils).i4w = function (room, entityManager) {
  entityManager.addComponent(room, new RoomComponent());
  entityManager.addComponent(room, new ConnectionRootComponent());
  entityManager.addComponent(room, new SnapRootComponent());
  entityManager.addComponent(room, new DisplayNameComponent('Room'));
  entityManager.addComponent(room, new StaticComponent());
};
protoOf(TestRoomBuildingUtils).a4u = function (room, roomGeometry, entityManager) {
  this.i4w(room, entityManager);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_hierarchy(room);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    if (get_isRoomPart(element)) {
      destination.h(element);
    }
  }
  var oldParts = destination;
  // Inline function 'kotlin.collections.onEach' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.onEach.<anonymous>' call
  var tmp0_iterator = generateCorners(this, roomGeometry, oldParts, entityManager).k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    addToRoom(TestRoomBuildingUtils_instance, element_0, room);
  }
  // Inline function 'kotlin.also' call
  var this_1 = generateFloorEntity(this, roomGeometry, oldParts, entityManager);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
  addToRoom(TestRoomBuildingUtils_instance, this_1, room);
  // Inline function 'kotlin.also' call
  var this_2 = generateCeilingEntity(this, roomGeometry, oldParts, entityManager);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
  addToRoom(TestRoomBuildingUtils_instance, this_2, room);
  // Inline function 'kotlin.collections.onEach' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.onEach.<anonymous>' call
  var tmp0_iterator_0 = generateWallEntities(this, roomGeometry, oldParts, entityManager).k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    addToRoom(TestRoomBuildingUtils_instance, element_1, room);
  }
  // Inline function 'kotlin.collections.onEach' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.onEach.<anonymous>' call
  var tmp0_iterator_1 = generateEdgeEntities(this, roomGeometry, oldParts, entityManager).k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    addToRoom(TestRoomBuildingUtils_instance, element_2, room);
  }
  // Inline function 'kotlin.collections.onEach' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.onEach.<anonymous>' call
  var tmp0_iterator_2 = generateObstacleEntities(this, roomGeometry, entityManager).k();
  while (tmp0_iterator_2.m()) {
    var element_3 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    addToRoom(TestRoomBuildingUtils_instance, element_3, room);
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_3 = oldParts.k();
  while (tmp0_iterator_3.m()) {
    var element_4 = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildRoomFromGeometry.<anonymous>' call
    if (!element_4.hasComponent(Companion_getInstance_41().id) && !element_4.hasComponent(Companion_getInstance_153().id)) {
      entityManager.removeComponent(element_4, Companion_getInstance_37().id);
      entityManager.disposeEntity(element_4);
    }
  }
};
protoOf(TestRoomBuildingUtils).r4x = function (roomPart, roomGeometry, entityManager) {
  var tmp0_elvis_lhs = get_roomPartId(roomPart);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'buildExistingRoomPart can only be used with an entity that has a RoomPartComponent';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var roomPartId = tmp;
  var oldParts = listOf(roomPart);
  if (roomGeometry.floor.id === roomPartId) {
    generateFloorEntity(this, roomGeometry, oldParts, entityManager);
  } else {
    if (roomGeometry.ceiling.id === roomPartId) {
      generateCeilingEntity(this, roomGeometry, oldParts, entityManager);
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject = roomGeometry.walls;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildExistingRoomPart.<anonymous>' call
          if (element.id === roomPartId) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        generateWallEntities(this, roomGeometry, oldParts, entityManager);
      } else {
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject_0 = roomGeometry.edges;
          var inductionVariable_0 = 0;
          var last_0 = indexedObject_0.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = indexedObject_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildExistingRoomPart.<anonymous>' call
            if (element_0.id === roomPartId) {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          generateEdgeEntities(this, roomGeometry, oldParts, entityManager);
        } else {
          var tmp$ret$5;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var indexedObject_1 = roomGeometry.vertices;
            var inductionVariable_1 = 0;
            var last_1 = indexedObject_1.length;
            while (inductionVariable_1 < last_1) {
              var element_1 = indexedObject_1[inductionVariable_1];
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildExistingRoomPart.<anonymous>' call
              if (element_1.id === roomPartId) {
                tmp$ret$5 = true;
                break $l$block_1;
              }
            }
            tmp$ret$5 = false;
          }
          if (tmp$ret$5) {
            generateCorners(this, roomGeometry, oldParts, entityManager);
          } else {
            $l$block_2: {
              // Inline function 'kotlin.collections.any' call
              var indexedObject_2 = roomGeometry.obstacles;
              var inductionVariable_2 = 0;
              var last_2 = indexedObject_2.length;
              while (inductionVariable_2 < last_2) {
                var element_2 = indexedObject_2[inductionVariable_2];
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                // Inline function 'com.ikea.core.stl.testroom.utils.TestRoomBuildingUtils.buildExistingRoomPart.<anonymous>' call
                if (element_2.id === roomPartId) {
                  break $l$block_2;
                }
              }
            }
          }
        }
      }
    }
  }
};
var TestRoomBuildingUtils_instance;
function TestRoomBuildingUtils_getInstance() {
  return TestRoomBuildingUtils_instance;
}
function detectIfFloorCornersAreCounterClockwise($this, corners) {
  var sum = 0.0;
  var inductionVariable = 0;
  var last = corners.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p1 = corners[i];
      var p2 = corners[(i + 1 | 0) % corners.length | 0];
      sum = sum + (p2.X - p1.X) * (p2.Z + p1.Z);
    }
     while (inductionVariable <= last);
  return sum > 0;
}
function Companion_121() {
}
protoOf(Companion_121).a4y = function (ceilingHeight, floorVertices, scale) {
  var scaledCeilingHeight = ceilingHeight * scale;
  // Inline function 'kotlin.collections.map' call
  var tmp;
  if (detectIfFloorCornersAreCounterClockwise(this, floorVertices)) {
    tmp = reversedArray(floorVertices);
  } else {
    tmp = floorVertices;
  }
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.Companion.generateCustomRoomGeometry.<anonymous>' call
    var tmp$ret$0 = item.times(scale);
    destination.h(tmp$ret$0);
  }
  var cornerClockwiseOrder = destination;
  var index = 0;
  // Inline function 'kotlin.collections.mutableListOf' call
  var walls = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var edges = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var corners = ArrayList_init_$Create$();
  var floorId = 'floor';
  var ceilingId = 'ceiling';
  while (index < cornerClockwiseOrder.o()) {
    var firstIndex = index;
    var secondIndex = (index + 1 | 0) % cornerClockwiseOrder.o() | 0;
    var bottomLeftCorner = cornerClockwiseOrder.q(firstIndex);
    var bottomRightCorner = cornerClockwiseOrder.q(secondIndex);
    var topRightCorner = cornerClockwiseOrder.q(secondIndex).copy(VOID, scaledCeilingHeight);
    var topLeftCorner = cornerClockwiseOrder.q(firstIndex).copy(VOID, scaledCeilingHeight);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var wallVertexes = [bottomLeftCorner, bottomRightCorner, topRightCorner, topLeftCorner];
    var surface1Id = 'wall' + firstIndex;
    var surface2Id = 'wall' + secondIndex;
    walls.h(new CoreRoomSurface(surface1Id, new RoomSurfaceGeometry(wallVertexes)));
    edges.h(new CoreRoomEdge('edgeCorner' + index, surface1Id, surface2Id, bottomRightCorner, topRightCorner));
    edges.h(new CoreRoomEdge('edgeFloor' + index, surface1Id, floorId, bottomLeftCorner, bottomRightCorner));
    edges.h(new CoreRoomEdge('edgeCeiling' + index, surface1Id, ceilingId, topRightCorner, topLeftCorner));
    var tmp_0 = 'cornerFloor' + index;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [surface1Id, surface2Id, floorId];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = ['edgeCorner' + index, 'edgeFloor' + index, 'edgeFloor' + secondIndex];
    corners.h(new CoreRoomVertex(tmp_0, bottomRightCorner, tmp_1, tmp$ret$14));
    var tmp_2 = 'cornerCeiling' + index;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [surface1Id, surface2Id, ceilingId];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$20 = ['edgeCorner' + index, 'edgeCeiling' + index, 'edgeCeiling' + secondIndex];
    corners.h(new CoreRoomVertex(tmp_2, topRightCorner, tmp_3, tmp$ret$20));
    index = index + 1 | 0;
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = reversed(cornerClockwiseOrder);
  var tmp$ret$21 = copyToArray(this_1);
  var floor = new CoreRoomSurface(floorId, new RoomSurfaceGeometry(tmp$ret$21));
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(cornerClockwiseOrder, 10));
  var tmp0_iterator = cornerClockwiseOrder.k();
  while (tmp0_iterator.m()) {
    var item_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.testroom.utils.Companion.generateCustomRoomGeometry.<anonymous>' call
    var tmp$ret$22 = item_0.copy(VOID, scaledCeilingHeight);
    destination_0.h(tmp$ret$22);
  }
  var tmp$ret$25 = copyToArray(destination_0);
  var ceiling = new CoreRoomSurface(ceilingId, new RoomSurfaceGeometry(tmp$ret$25));
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_4 = copyToArray(walls);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_5 = copyToArray(edges);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$28 = copyToArray(corners);
  return new CoreRoomGeometryData(tmp_4, floor, ceiling, tmp_5, tmp$ret$28);
};
protoOf(Companion_121).generateCustomRoomGeometry$default = function (ceilingHeight, floorVertices, scale, $super) {
  scale = scale === VOID ? 1.0 : scale;
  return $super === VOID ? this.a4y(ceilingHeight, floorVertices, scale) : $super.a4y.call(this, ceilingHeight, floorVertices, scale);
};
protoOf(Companion_121).b4y = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var corners = [new Vector(0.0, 0.0, 0.0), new Vector(0.0, 0.0, -5.0), new Vector(-5.0, 0.0, -5.0), new Vector(-5.0, 0.0, 5.0), new Vector(5.0, 0.0, 5.0), new Vector(5.0, 0.0, 0.0)];
  return this.a4y(3.0, corners, 1000.0);
};
protoOf(Companion_121).c4y = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var corners = [new Vector(-5.0, 0.0, -1.6666666666666667), new Vector(-2.5, 0.0, 5.0), new Vector(2.5, 0.0, 5.0), new Vector(5.0, 0.0, -1.6666666666666667), new Vector(0.0, 0.0, -5.0)];
  return this.a4y(3.0, corners, 1000.0);
};
protoOf(Companion_121).d4y = function (dimensions, center, scale) {
  var right = dimensions.X * scale / 2 + center.X * scale;
  var left = -(dimensions.X * scale / 2) + center.X * scale;
  var front = dimensions.Z * scale / 2 + center.Z * scale;
  var back = -(dimensions.Z * scale / 2) + center.Z * scale;
  var up = dimensions.Y * scale / 2 + center.Y * scale;
  var down = -(dimensions.Y * scale / 2) + center.Y * scale;
  var backRightCeiling = new Vector(right, up, back);
  var frontRightCeiling = new Vector(right, up, front);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var rightWallVertices = [new Vector(right, down, front), frontRightCeiling, backRightCeiling, new Vector(right, down, back)];
  var rightWall = new CoreRoomSurface('right-wall-key', new RoomSurfaceGeometry(rightWallVertices));
  var backLeftCeiling = new Vector(left, up, back);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var backWallVertices = [new Vector(left, down, back), new Vector(right, down, back), backRightCeiling, backLeftCeiling];
  var backWall = new CoreRoomSurface('back-wall-key', new RoomSurfaceGeometry(backWallVertices));
  var frontLeftCeiling = new Vector(left, up, front);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var leftWallVertices = [new Vector(left, down, front), new Vector(left, down, back), backLeftCeiling, frontLeftCeiling];
  var leftWall = new CoreRoomSurface('left-wall-key', new RoomSurfaceGeometry(leftWallVertices));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var frontWallVertices = [new Vector(right, down, front), new Vector(left, down, front), frontLeftCeiling, frontRightCeiling];
  var frontWall = new CoreRoomSurface('front-wall-key', new RoomSurfaceGeometry(frontWallVertices));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var floorVertices = [new Vector(left, down, back), new Vector(left, down, front), new Vector(right, down, front), new Vector(right, down, back)];
  var floor = new CoreRoomSurface('floor', new RoomSurfaceGeometry(floorVertices));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var ceilingVertices = [backLeftCeiling, backRightCeiling, frontRightCeiling, frontLeftCeiling];
  var ceiling = new CoreRoomSurface('ceiling', new RoomSurfaceGeometry(ceilingVertices));
  var backEdge = new CoreRoomEdge('back-wall-floor-edge-key', backWall.id, floor.id, new Vector(left, down, back), new Vector(right, down, back));
  var leftEdge = new CoreRoomEdge('left-wall-floor-edge-key', leftWall.id, floor.id, new Vector(left, down, front), new Vector(left, down, back));
  var rightEdge = new CoreRoomEdge('right-wall-floor-edge-key', rightWall.id, floor.id, new Vector(right, down, front), new Vector(right, down, back));
  var frontEdge = new CoreRoomEdge('front-wall-floor-edge-key', frontWall.id, floor.id, new Vector(left, down, front), new Vector(right, down, front));
  var backLeftEdge = new CoreRoomEdge('backLeftEdge', leftWall.id, backWall.id, new Vector(left, down, back), new Vector(left, up, back));
  var backRightEdge = new CoreRoomEdge('backRightEdge', backWall.id, rightWall.id, new Vector(right, down, back), new Vector(right, up, back));
  var frontLeftEdge = new CoreRoomEdge('frontLeftEdge', frontWall.id, leftWall.id, new Vector(left, down, front), new Vector(left, up, front));
  var frontRightEdge = new CoreRoomEdge('frontRightEdge', rightWall.id, frontWall.id, new Vector(right, down, front), new Vector(right, up, front));
  var backCeilingEdge = new CoreRoomEdge('back-wall-ceiling-edge-key', backWall.id, ceiling.id, backLeftCeiling, backRightCeiling);
  var leftCeilingEdge = new CoreRoomEdge('left-wall-ceiling-edge-key', leftWall.id, ceiling.id, frontLeftCeiling, backLeftCeiling);
  var rightCeilingEdge = new CoreRoomEdge('right-wall-ceiling-edge-key', rightWall.id, ceiling.id, frontRightCeiling, backRightCeiling);
  var frontCeilingEdge = new CoreRoomEdge('front-wall-ceiling-edge-key', frontWall.id, ceiling.id, frontLeftCeiling, frontRightCeiling);
  var tmp = new Vector(left, down, back);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [backWall.id, leftWall.id, floor.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$23 = [backEdge.id, leftEdge.id, backLeftEdge.id];
  var backLeftVertex = new CoreRoomVertex('left-back-corner-key', tmp, tmp_0, tmp$ret$23);
  var tmp_1 = new Vector(right, down, back);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [backWall.id, rightWall.id, floor.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$29 = [backEdge.id, rightEdge.id, backRightEdge.id];
  var backRightVertex = new CoreRoomVertex('right-back-corner-key', tmp_1, tmp_2, tmp$ret$29);
  var tmp_3 = new Vector(right, down, front);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = [frontWall.id, rightWall.id, floor.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$35 = [frontEdge.id, rightEdge.id, frontLeftEdge.id];
  var frontRightVertex = new CoreRoomVertex('right-front-corner-key', tmp_3, tmp_4, tmp$ret$35);
  var tmp_5 = new Vector(left, down, front);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_6 = [frontWall.id, leftWall.id, floor.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$41 = [frontEdge.id, leftEdge.id, frontRightEdge.id];
  var frontLeftVertex = new CoreRoomVertex('left-front-corner-key', tmp_5, tmp_6, tmp$ret$41);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_7 = [backWall.id, leftWall.id, ceiling.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$47 = [backCeilingEdge.id, leftCeilingEdge.id, backLeftEdge.id];
  var backLeftCeilingVertex = new CoreRoomVertex('left-back-ceiling-corner-key', backLeftCeiling, tmp_7, tmp$ret$47);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_8 = [backWall.id, rightWall.id, ceiling.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$53 = [backCeilingEdge.id, rightCeilingEdge.id, backRightEdge.id];
  var backRightCeilingVertex = new CoreRoomVertex('right-back-ceiling-corner-key', backRightCeiling, tmp_8, tmp$ret$53);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_9 = [frontWall.id, rightWall.id, ceiling.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$59 = [frontCeilingEdge.id, leftCeilingEdge.id, frontLeftEdge.id];
  var frontRightCeilingVertex = new CoreRoomVertex('right-front-ceiling-corner-key', frontRightCeiling, tmp_9, tmp$ret$59);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_10 = [frontWall.id, leftWall.id, ceiling.id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$65 = [frontCeilingEdge.id, rightCeilingEdge.id, frontRightEdge.id];
  var frontLeftCeilingVertex = new CoreRoomVertex('left-front-ceiling-corner-key', frontLeftCeiling, tmp_10, tmp$ret$65);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_11 = [rightWall, backWall, leftWall, frontWall];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_12 = [backEdge, leftEdge, rightEdge, frontEdge, backCeilingEdge, leftCeilingEdge, rightCeilingEdge, frontCeilingEdge, backLeftEdge, backRightEdge, frontLeftEdge, frontRightEdge];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_13 = [backLeftVertex, backRightVertex, frontRightVertex, frontLeftVertex, backLeftCeilingVertex, backRightCeilingVertex, frontRightCeilingVertex, frontLeftCeilingVertex];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$75 = [];
  return new CoreRoomGeometryData(tmp_11, floor, ceiling, tmp_12, tmp_13, tmp$ret$75);
};
protoOf(Companion_121).generateRectangularRoomGeometry$default = function (dimensions, center, scale, $super) {
  scale = scale === VOID ? 1.0 : scale;
  return $super === VOID ? this.d4y(dimensions, center, scale) : $super.d4y.call(this, dimensions, center, scale);
};
var Companion_instance_160;
function Companion_getInstance_164() {
  return Companion_instance_160;
}
function generateCustomRoomGeometry(ceilingHeight, floorVertices, scale) {
  return Companion_instance_160.a4y(ceilingHeight, floorVertices, scale);
}
function generateCustomRoomGeometry_0(ceilingHeight, floorVertices, scale, $super) {
  scale = scale === VOID ? 1.0 : scale;
  return generateCustomRoomGeometry(ceilingHeight, floorVertices, scale);
}
function generateLShapedRoomGeometry() {
  return Companion_instance_160.b4y();
}
function generate5WallRoomGeometry() {
  return Companion_instance_160.c4y();
}
function generateRectangularRoomGeometry(dimensions, center, scale) {
  return Companion_instance_160.d4y(dimensions, center, scale);
}
function generateRectangularRoomGeometry_0(dimensions, center, scale, $super) {
  scale = scale === VOID ? 1.0 : scale;
  return generateRectangularRoomGeometry(dimensions, center, scale);
}
function TestRoomGenerator() {
}
function getRoomParts($this, roomPart) {
  var tmp0_safe_receiver = findInUpwardsHierarchy(roomPart, TestRoomRelationsUtils$Companion$getRoomParts$lambda);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.getRoomParts.<anonymous>' call
      if (get_isRoomPart(element)) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  return tmp;
}
function areEdgePointsSideInSurfaceConnector($this, edgeEntity, edgeConnector, surfaceEntity, surfaceConnector) {
  var worldP1 = get_worldTransform(edgeEntity).transformPosition(edgeConnector.p1);
  var worldP2 = get_worldTransform(edgeEntity).transformPosition(edgeConnector.p2);
  // Inline function 'kotlin.collections.map' call
  var this_0 = surfaceConnector.vertices;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.testroom.utils.Companion.areEdgePointsSideInSurfaceConnector.<anonymous>' call
    var tmp$ret$0 = get_worldTransform(surfaceEntity).transformPosition(item);
    destination.h(tmp$ret$0);
  }
  var surfaceWorldVertices = destination;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var tmp0_iterator = surfaceWorldVertices.k();
    while (tmp0_iterator.m()) {
      var item_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.areEdgePointsSideInSurfaceConnector.<anonymous>' call
      if (item_0.equals(worldP1)) {
        tmp$ret$4 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$4 = -1;
  }
  var p1Index = tmp$ret$4;
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index_0 = 0;
    var tmp0_iterator_0 = surfaceWorldVertices.k();
    while (tmp0_iterator_0.m()) {
      var item_1 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.areEdgePointsSideInSurfaceConnector.<anonymous>' call
      if (item_1.equals(worldP2)) {
        tmp$ret$6 = index_0;
        break $l$block_0;
      }
      index_0 = index_0 + 1 | 0;
    }
    tmp$ret$6 = -1;
  }
  var p2Index = tmp$ret$6;
  if (p1Index === -1 || p2Index === -1) {
    return false;
  }
  return indexesAreSubsequent($this, p2Index, p1Index, surfaceConnector.vertices.length);
}
function indexesAreSubsequent($this, p2Index, p1Index, arraySize) {
  var indexDiff = ((p2Index - p1Index | 0) + arraySize | 0) % arraySize | 0;
  return indexDiff === 1 || indexDiff === (arraySize - 1 | 0);
}
function areCornerPointInSurfaceConnector($this, cornerEntity, cornerConnector, surfaceEntity, surfaceConnector) {
  var worldCornerPoint = cornerConnector.getWorldPositionFromOwnerEntity(cornerEntity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = surfaceConnector.vertices;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.areCornerPointInSurfaceConnector.<anonymous>' call
      var surfaceCornerWorld = get_worldTransform(surfaceEntity).transformPosition(element);
      if (surfaceCornerWorld.equals(worldCornerPoint)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function isPointOneOfEdgeEnds($this, edgeEntity, edgeConnector, cornerEntity, cornerConnector) {
  var edgeEndWorld1 = get_worldTransform(edgeEntity).transformPosition(edgeConnector.p1);
  var edgeEndWorld2 = get_worldTransform(edgeEntity).transformPosition(edgeConnector.p2);
  var worldCornerPoint = cornerConnector.getWorldPositionFromOwnerEntity(cornerEntity);
  return worldCornerPoint.equals(edgeEndWorld1) || worldCornerPoint.equals(edgeEndWorld2);
}
function TestRoomRelationsUtils$Companion$getRoomParts$lambda(it) {
  return get_isRoom(it);
}
function Companion_122() {
}
protoOf(Companion_122).e4y = function (surfaceEntity) {
  var tmp0_safe_receiver = getRoomParts(this, surfaceEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomSurface.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof EdgeConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomSurface.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomEdges = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(surfaceEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof SurfaceConnector) {
      destination_2.h(element_1);
    }
  }
  var surfaceConnectors = destination_2;
  var tmp_0;
  if (roomEdges == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomEdges.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomSurface.<anonymous>' call
      var edgeEntity = element_2.tf();
      var edgeConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(surfaceConnectors, Collection)) {
          tmp_1 = surfaceConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = surfaceConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomSurface.<anonymous>.<anonymous>' call
          if (areEdgePointsSideInSurfaceConnector(Companion_instance_161, edgeEntity, edgeConnector, surfaceEntity, element_3)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomSurface.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
protoOf(Companion_122).f4y = function (edgeEntity) {
  var tmp0_safe_receiver = getRoomParts(this, edgeEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomEdge.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof SurfaceConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomEdge.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomSurfaces = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(edgeEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof EdgeConnector) {
      destination_2.h(element_1);
    }
  }
  var edgeConnectors = destination_2;
  var tmp_0;
  if (roomSurfaces == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomSurfaces.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomEdge.<anonymous>' call
      var surfaceEntity = element_2.tf();
      var surfaceConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(edgeConnectors, Collection)) {
          tmp_1 = edgeConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = edgeConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomEdge.<anonymous>.<anonymous>' call
          if (areEdgePointsSideInSurfaceConnector(Companion_instance_161, edgeEntity, element_3, surfaceEntity, surfaceConnector)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomEdge.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
protoOf(Companion_122).g4y = function (surfaceEntity) {
  var tmp0_safe_receiver = getRoomParts(this, surfaceEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomSurface.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof PointConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomSurface.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomCorners = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(surfaceEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof SurfaceConnector) {
      destination_2.h(element_1);
    }
  }
  var surfaceConnectors = destination_2;
  var tmp_0;
  if (roomCorners == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomCorners.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomSurface.<anonymous>' call
      var cornerEntity = element_2.tf();
      var cornerConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(surfaceConnectors, Collection)) {
          tmp_1 = surfaceConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = surfaceConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomSurface.<anonymous>.<anonymous>' call
          if (areCornerPointInSurfaceConnector(Companion_instance_161, cornerEntity, cornerConnector, surfaceEntity, element_3)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomSurface.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
protoOf(Companion_122).h4y = function (cornerEntity) {
  var tmp0_safe_receiver = getRoomParts(this, cornerEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomCorner.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof SurfaceConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomCorner.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomSurfaces = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(cornerEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof PointConnector) {
      destination_2.h(element_1);
    }
  }
  var cornerConnectors = destination_2;
  var tmp_0;
  if (roomSurfaces == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomSurfaces.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomCorner.<anonymous>' call
      var surfaceEntity = element_2.tf();
      var surfaceConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(cornerConnectors, Collection)) {
          tmp_1 = cornerConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = cornerConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomCorner.<anonymous>.<anonymous>' call
          if (areCornerPointInSurfaceConnector(Companion_instance_161, cornerEntity, element_3, surfaceEntity, surfaceConnector)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.surfacesForRoomCorner.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
protoOf(Companion_122).i4y = function (cornerEntity) {
  var tmp0_safe_receiver = getRoomParts(this, cornerEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomCorner.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof EdgeConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomCorner.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomEdges = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(cornerEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof PointConnector) {
      destination_2.h(element_1);
    }
  }
  var cornerConnectors = destination_2;
  var tmp_0;
  if (roomEdges == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomEdges.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomCorner.<anonymous>' call
      var edgeEntity = element_2.tf();
      var edgeConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(cornerConnectors, Collection)) {
          tmp_1 = cornerConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = cornerConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomCorner.<anonymous>.<anonymous>' call
          if (isPointOneOfEdgeEnds(Companion_instance_161, edgeEntity, edgeConnector, cornerEntity, element_3)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.edgesForRoomCorner.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
protoOf(Companion_122).j4y = function (edgeEntity) {
  var tmp0_safe_receiver = getRoomParts(this, edgeEntity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomEdge.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = get_connectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_0 instanceof PointConnector) {
          destination_0.h(element_0);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var item = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomEdge.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Pair(element, item);
        destination_1.h(tmp$ret$2);
      }
      var list = destination_1;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var roomCorners = tmp;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_1 = get_connectors(edgeEntity);
  var destination_2 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (element_1 instanceof EdgeConnector) {
      destination_2.h(element_1);
    }
  }
  var edgeConnectors = destination_2;
  var tmp_0;
  if (roomCorners == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = roomCorners.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomEdge.<anonymous>' call
      var cornerEntity = element_2.tf();
      var cornerConnector = element_2.uf();
      var tmp$ret$10;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(edgeConnectors, Collection)) {
          tmp_1 = edgeConnectors.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$10 = false;
          break $l$block_0;
        }
        var tmp0_iterator_2 = edgeConnectors.k();
        while (tmp0_iterator_2.m()) {
          var element_3 = tmp0_iterator_2.n();
          // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomEdge.<anonymous>.<anonymous>' call
          if (isPointOneOfEdgeEnds(Companion_instance_161, edgeEntity, element_3, cornerEntity, cornerConnector)) {
            tmp$ret$10 = true;
            break $l$block_0;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_3.h(element_2);
      }
    }
    tmp_0 = destination_3;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var tmp0_iterator_3 = tmp2_safe_receiver.k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.stl.testroom.utils.Companion.cornersForRoomEdge.<anonymous>' call
      var entity = item_0.tf();
      destination_4.h(entity);
    }
    tmp_2 = destination_4;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp3_safe_receiver);
  }
  var tmp4_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  return tmp_4;
};
var Companion_instance_161;
function Companion_getInstance_165() {
  return Companion_instance_161;
}
function edgesForRoomSurface(surfaceEntity) {
  return Companion_instance_161.e4y(surfaceEntity);
}
function surfacesForRoomEdge(edgeEntity) {
  return Companion_instance_161.f4y(edgeEntity);
}
function cornersForRoomSurface(surfaceEntity) {
  return Companion_instance_161.g4y(surfaceEntity);
}
function surfacesForRoomCorner(cornerEntity) {
  return Companion_instance_161.h4y(cornerEntity);
}
function edgesForRoomCorner(cornerEntity) {
  return Companion_instance_161.i4y(cornerEntity);
}
function cornersForRoomEdge(edgeEntity) {
  return Companion_instance_161.j4y(edgeEntity);
}
function TestRoomRelationsUtils() {
}
function validate_2($this, entity, snap) {
  var tmp1_elvis_lhs = snap == null ? null : snap.host;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_parent(entity) : tmp1_elvis_lhs;
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var parent = tmp;
  var ancestor = oldestAncestorWithComponent(parent, $this, $this.l4y_1);
  if (ancestor == null) {
    return null;
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(ancestor);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.validate.<anonymous>' call
    if (!element.equals(entity)) {
      destination.h(element);
    }
  }
  var currentChildrenWithComponent = countDescendantsWithComponent($this, destination, $this.m4y_1);
  var tmp3_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_64().id);
  var originalEntity = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.originalEntity;
  var interestingChild = countEntitiesInHierarchyWithComponent($this, originalEntity == null ? entity : originalEntity, $this.m4y_1);
  var totalChildrenWithComponent = currentChildrenWithComponent + interestingChild | 0;
  var tmp_0;
  if (totalChildrenWithComponent <= $this.n4y_1) {
    tmp_0 = null;
  } else {
    tmp_0 = new InvalidNumberOfChildren('To many (max: ' + $this.n4y_1 + ') children with component ' + $this.m4y_1 + ' to parent with component ' + $this.l4y_1 + '. Children before: ' + currentChildrenWithComponent + '. Children now: ' + totalChildrenWithComponent, get_productRefOrEmptyString(entity), $this);
  }
  return tmp_0;
}
function countEntitiesInHierarchyWithComponent($this, entity, componentId) {
  var sum = 0;
  if (entity.hasComponent(componentId)) {
    sum = sum + 1 | 0;
  }
  var tmp = sum;
  // Inline function 'kotlin.collections.sumOf' call
  var sum_0 = 0;
  var indexedObject = get_descendants(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp_0 = sum_0;
    // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.countEntitiesInHierarchyWithComponent.<anonymous>' call
    sum_0 = tmp_0 + countEntitiesInHierarchyWithComponent($this, element, componentId) | 0;
  }
  sum = tmp + sum_0 | 0;
  return sum;
}
function countDescendantsWithComponent($this, descendants, componentId) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var tmp0_iterator = descendants.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    var tmp = sum;
    // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.countDescendantsWithComponent.<anonymous>' call
    sum = tmp + countEntitiesInHierarchyWithComponent($this, element, componentId) | 0;
  }
  return sum;
}
function oldestAncestorWithComponent(_this__u8e3s4, $this, componentId) {
  var tmp0_safe_receiver = get_parent(_this__u8e3s4);
  var ancestorWithComponent = tmp0_safe_receiver == null ? null : oldestAncestorWithComponent(tmp0_safe_receiver, $this, componentId);
  if (!(ancestorWithComponent == null)) {
    return ancestorWithComponent;
  }
  if (_this__u8e3s4.hasComponent(componentId)) {
    return _this__u8e3s4;
  }
  return null;
}
function AllowedNumberOfChildrenOfTypeValidation(hostComponentId, childComponentId, allowedChildrenCnt) {
  ValidationImpl.call(this);
  this.l4y_1 = hostComponentId;
  this.m4y_1 = childComponentId;
  this.n4y_1 = allowedChildrenCnt;
  this.o4y_1 = 'AllowedNumberOfChildrenOfTypeValidation hostId: ' + this.l4y_1 + ', childId: ' + this.m4y_1;
}
protoOf(AllowedNumberOfChildrenOfTypeValidation).n1s = function () {
  return this.o4y_1;
};
protoOf(AllowedNumberOfChildrenOfTypeValidation).validateCurrentState = function (entity) {
  return validate_2(this, entity, null);
};
protoOf(AllowedNumberOfChildrenOfTypeValidation).validateSnap = function (snap) {
  return validate_2(this, snap.guestRoot, snap);
};
function Companion_123() {
  this.ID = 'DisallowSeparateRequiredHosts';
}
protoOf(Companion_123).j1y = function () {
  return this.ID;
};
var Companion_instance_162;
function Companion_getInstance_166() {
  return Companion_instance_162;
}
function validate_3($this, entity, snap) {
  if (!entity.hasComponent($this.q4y_1))
    return null;
  var tmp1_elvis_lhs = snap == null ? null : snap.guestRoot;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_snapRoot(entity) : tmp1_elvis_lhs;
  var guestRoot = tmp2_elvis_lhs == null ? entity : tmp2_elvis_lhs;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = Companion_instance.d29(guestRoot, $this.r4y_1.root);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.validation.DisallowSeparateRequiredHostsValidation.validate.<anonymous>' call
    if (element.guestConnector.required) {
      destination.h(element);
    }
  }
  var requiredConnections = destination;
  var tmp3_safe_receiver = firstOrNull_1(requiredConnections);
  var firstRequiredHostRoot = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hostConnectionRoot;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = requiredConnections.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.validation.DisallowSeparateRequiredHostsValidation.validate.<anonymous>' call
    if (!element_0.hostConnectionRoot.equals(firstRequiredHostRoot)) {
      var tmp = Companion_instance_2;
      return tmp.fail(toString(DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe()) + ' failed for ' + entity.toString() + ' as it tried to snap to more than one different host with required connectors', get_productRefOrEmptyString(entity), $this);
    }
  }
  return null;
}
function DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe() {
  var l = function (p0, p1) {
    return new DisallowSeparateRequiredHostsValidation(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function DisallowSeparateRequiredHostsValidation(component, sceneManager) {
  ValidationImpl.call(this);
  this.q4y_1 = component;
  this.r4y_1 = sceneManager;
  this.s4y_1 = Companion_instance_162.ID;
}
protoOf(DisallowSeparateRequiredHostsValidation).n1s = function () {
  return this.s4y_1;
};
protoOf(DisallowSeparateRequiredHostsValidation).validateCurrentState = function (entity) {
  return validate_3(this, entity, null);
};
protoOf(DisallowSeparateRequiredHostsValidation).validateSnap = function (snap) {
  return validate_3(this, snap.guestRoot, snap);
};
function Companion_124() {
  this.t4y_1 = 'InvalidNumberOfChildren';
}
var Companion_instance_163;
function Companion_getInstance_167() {
  return Companion_instance_163;
}
function InvalidNumberOfChildren(message, productRef, rule) {
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
  this.v4y_1 = message;
}
protoOf(InvalidNumberOfChildren).n1s = function () {
  return Companion_instance_163.t4y_1;
};
protoOf(InvalidNumberOfChildren).toString = function () {
  return this.id + ': ' + this.v4y_1;
};
function Companion_125() {
  this.ID = 'PlacementZone';
}
protoOf(Companion_125).j1y = function () {
  return this.ID;
};
var Companion_instance_164;
function Companion_getInstance_168() {
  return Companion_instance_164;
}
function validate_4($this, entity, snap) {
  var tmp1_safe_receiver = snap == null ? null : snap.endTransform;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.position;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.Y;
  var tmp;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = entity.__getComponentForKotlin(Companion_instance_0.g1n_1);
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.transform;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.position;
    tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.Y;
  } else {
    tmp = tmp3_elvis_lhs;
  }
  var tmp7_elvis_lhs = tmp;
  var tmp_0;
  if (tmp7_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp7_elvis_lhs;
  }
  var worldY = tmp_0;
  var tmp8_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_120().id);
  if (tmp8_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp8_safe_receiver.minY > worldY || tmp8_safe_receiver.maxY < worldY) {
      return new PlacementZoneWarning(get_productRefOrEmptyString(entity), $this);
    }
  }
  return null;
}
function PlacementZoneValidation() {
  ValidationImpl.call(this);
  this.x4y_1 = Companion_instance_164.ID;
}
protoOf(PlacementZoneValidation).n1s = function () {
  return this.x4y_1;
};
protoOf(PlacementZoneValidation).validateCurrentState = function (entity) {
  return validate_4(this, entity, null);
};
protoOf(PlacementZoneValidation).validateSnap = function (snap) {
  return validate_4(this, snap.guestRoot, snap);
};
function PlacementZoneWarning(ref, placementZoneRule) {
  ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), ref, placementZoneRule);
  this.z4y_1 = ref;
  this.a4z_1 = placementZoneRule;
}
protoOf(PlacementZoneWarning).n1s = function () {
  return 'PlacementZoneWarning';
};
protoOf(PlacementZoneWarning).toString = function () {
  return 'The product ' + this.z4y_1 + ' is not placed within its Placement Zone';
};
protoOf(PlacementZoneWarning).hashCode = function () {
  var result = getStringHashCode(this.z4y_1);
  result = imul(result, 31) + hashCode(this.a4z_1) | 0;
  return result;
};
protoOf(PlacementZoneWarning).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlacementZoneWarning))
    return false;
  var tmp0_other_with_cast = other instanceof PlacementZoneWarning ? other : THROW_CCE();
  if (!(this.z4y_1 === tmp0_other_with_cast.z4y_1))
    return false;
  if (!equals(this.a4z_1, tmp0_other_with_cast.a4z_1))
    return false;
  return true;
};
function Companion_126() {
  this.b4z_1 = 'RequiredConnectorsSatisfied';
}
protoOf(Companion_126).j1y = function () {
  return this.b4z_1;
};
var Companion_instance_165;
function Companion_getInstance_169() {
  return Companion_instance_165;
}
function validate_5($this, entity, snap) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var roots = [Companion_instance_1.f1y(snap, entity)];
  var hostCandidate = snap == null ? null : snap.host;
  if (hostCandidate == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var indexedObject = roots;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.validation.RequiredConnectorsSatisfiedValidation.validate.<anonymous>.<anonymous>' call
        if (!Companion_instance_3.h29(hostCandidate).equals(element)) {
          tmp$ret$4 = false;
          break $l$block;
        }
      }
      tmp$ret$4 = true;
    }
    if (tmp$ret$4) {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = roots;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [hostCandidate];
      roots = tmp$ret$5.concat(tmp$ret$8);
    }
  }
  var failedConnectors = Companion_instance_26.g2c(roots, entity);
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (failedConnectors.length === 0) {
    tmp = null;
  } else {
    tmp = new RequiredConnectorsValidationResult(failedConnectors, entity, $this);
  }
  return tmp;
}
function get_ID_9() {
  return Companion_instance_165.b4z_1;
}
function RequiredConnectorsSatisfiedValidation() {
  ValidationImpl.call(this);
  this.d4z_1 = Companion_instance_165.b4z_1;
}
protoOf(RequiredConnectorsSatisfiedValidation).n1s = function () {
  return this.d4z_1;
};
protoOf(RequiredConnectorsSatisfiedValidation).validateCurrentState = function (entity) {
  return validate_5(this, entity, null);
};
protoOf(RequiredConnectorsSatisfiedValidation).validateSnap = function (snap) {
  return validate_5(this, snap.guestRoot, snap);
};
function Companion_127() {
  this.ID = 'RequiredConnectorsValidationResult';
}
protoOf(Companion_127).j1y = function () {
  return this.ID;
};
var Companion_instance_166;
function Companion_getInstance_170() {
  return Companion_instance_166;
}
function RequiredConnectorsValidationResult$toString$lambda(connector) {
  return toString(connector);
}
function RequiredConnectorsValidationResult(unfulfilledConnectors, entity, rule) {
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), get_productRef(entity), rule);
  this.unfulfilledConnectors = unfulfilledConnectors;
  this.entity = entity;
}
protoOf(RequiredConnectorsValidationResult).f4z = function () {
  return this.unfulfilledConnectors;
};
protoOf(RequiredConnectorsValidationResult).v2i = function () {
  return this.entity;
};
protoOf(RequiredConnectorsValidationResult).n1s = function () {
  return Companion_instance_166.ID;
};
protoOf(RequiredConnectorsValidationResult).toString = function () {
  var tmp = get_productRefOrEmptyString(this.entity);
  var tmp_0 = get_worldTransform(this.entity).toString();
  return 'Product ' + tmp + ' did not find required connectors needed to support it at ' + tmp_0 + '. Non satisfied connectors: [' + joinToString(this.unfulfilledConnectors, VOID, VOID, VOID, VOID, VOID, RequiredConnectorsValidationResult$toString$lambda) + ']';
};
function Companion_128() {
  Companion_instance_167 = this;
  this.g4z_1 = Companion_instance_163.t4y_1;
  this.h4z_1 = Companion_instance_27.ID;
  this.i4z_1 = Companion_instance_91.ID;
  this.j4z_1 = Companion_instance_166.ID;
  this.k4z_1 = Companion_instance_28.z3g_1;
  this.l4z_1 = Companion_instance_29.g3h_1;
  this.m4z_1 = Companion_instance_46.e3s_1;
}
protoOf(Companion_128).n4z = function () {
  return this.g4z_1;
};
protoOf(Companion_128).o4z = function () {
  return this.h4z_1;
};
protoOf(Companion_128).p4z = function () {
  return this.i4z_1;
};
protoOf(Companion_128).q4z = function () {
  return this.j4z_1;
};
protoOf(Companion_128).r4z = function () {
  return this.k4z_1;
};
protoOf(Companion_128).s4z = function () {
  return this.l4z_1;
};
protoOf(Companion_128).t4z = function () {
  return this.m4z_1;
};
protoOf(Companion_128).u4z = function (validationResult) {
  return validationResult.id === this.h4z_1;
};
protoOf(Companion_128).v4z = function (validationResult) {
  return validationResult.id === this.g4z_1;
};
protoOf(Companion_128).w4z = function (validationResult) {
  var tmp0_safe_receiver = validationResult.failedRule;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) === Companion_instance_30.ID;
};
protoOf(Companion_128).x4z = function (validationResult) {
  return validationResult.id === this.i4z_1;
};
protoOf(Companion_128).y4z = function (validationResult) {
  return validationResult.id === this.j4z_1;
};
protoOf(Companion_128).z4z = function (validationResult) {
  return validationResult.id === this.k4z_1;
};
protoOf(Companion_128).a50 = function (validationResult) {
  return validationResult.id === this.l4z_1;
};
protoOf(Companion_128).b50 = function (validationResult) {
  return validationResult.id === this.m4z_1;
};
var Companion_instance_167;
function Companion_getInstance_171() {
  if (Companion_instance_167 == null)
    new Companion_128();
  return Companion_instance_167;
}
function get_InvalidNumberOfChildrenId() {
  return Companion_getInstance_171().g4z_1;
}
function get_CollisionValidationResultId() {
  return Companion_getInstance_171().h4z_1;
}
function get_FunctionalMarginWarningId() {
  return Companion_getInstance_171().i4z_1;
}
function get_RequiredConnectorsValidationResultId() {
  return Companion_getInstance_171().j4z_1;
}
function get_NoValidConnectorAvailableValidationResultId() {
  return Companion_getInstance_171().k4z_1;
}
function get_UnknownErrorValidationResultId() {
  return Companion_getInstance_171().l4z_1;
}
function get_InvalidDoorPairsResultId() {
  return Companion_getInstance_171().m4z_1;
}
function isCollisionValidationResult(validationResult) {
  return Companion_getInstance_171().u4z(validationResult);
}
function isInvalidNumberOfChildrenValidationResult(validationResult) {
  return Companion_getInstance_171().v4z(validationResult);
}
function isChildConnectionValidationResult(validationResult) {
  return Companion_getInstance_171().w4z(validationResult);
}
function isFunctionalMarginWarningValidationResult(validationResult) {
  return Companion_getInstance_171().x4z(validationResult);
}
function isRequiredConnectorsValidationResult(validationResult) {
  return Companion_getInstance_171().y4z(validationResult);
}
function isNoValidConnectorAvailableValidationResult(validationResult) {
  return Companion_getInstance_171().z4z(validationResult);
}
function isUnknownErrorValidationResult(validationResult) {
  return Companion_getInstance_171().a50(validationResult);
}
function isInvalidDoorPairsResult(validationResult) {
  return Companion_getInstance_171().b50(validationResult);
}
function ValidationResultIds() {
  Companion_getInstance_171();
}
function Companion_129() {
  Companion_instance_168 = this;
  this.c50_1 = Companion_instance_31.ID;
  this.d50_1 = Companion_instance_30.ID;
  this.e50_1 = Companion_instance_165.b4z_1;
  this.f50_1 = Companion_instance_45.ID;
  this.g50_1 = Companion_instance_90.ID;
  this.h50_1 = Companion_instance_162.ID;
  this.i50_1 = Companion_instance_164.ID;
  this.j50_1 = Companion_instance_32.ID;
}
protoOf(Companion_129).k50 = function () {
  return this.c50_1;
};
protoOf(Companion_129).l50 = function () {
  return this.d50_1;
};
protoOf(Companion_129).m50 = function () {
  return this.e50_1;
};
protoOf(Companion_129).n50 = function () {
  return this.f50_1;
};
protoOf(Companion_129).o50 = function () {
  return this.g50_1;
};
protoOf(Companion_129).p50 = function () {
  return this.h50_1;
};
protoOf(Companion_129).q50 = function () {
  return this.i50_1;
};
protoOf(Companion_129).r50 = function () {
  return this.j50_1;
};
var Companion_instance_168;
function Companion_getInstance_172() {
  if (Companion_instance_168 == null)
    new Companion_129();
  return Companion_instance_168;
}
function get_CollisionValidationRuleId() {
  return Companion_getInstance_172().c50_1;
}
function get_ChildConnectionValidationId() {
  return Companion_getInstance_172().d50_1;
}
function get_RequiredConnectorsSatisfiedValidationId() {
  return Companion_getInstance_172().e50_1;
}
function get_AllowedDoorPairsValidationId() {
  return Companion_getInstance_172().f50_1;
}
function get_FunctionalMarginValidationId() {
  return Companion_getInstance_172().g50_1;
}
function get_DisallowSeparateRequiredHostsValidationId() {
  return Companion_getInstance_172().h50_1;
}
function get_PlacementZoneValidationId() {
  return Companion_getInstance_172().i50_1;
}
function get_TemporaryParentConnectionValidationId() {
  return Companion_getInstance_172().j50_1;
}
function ValidationRuleIds() {
  Companion_getInstance_172();
}
function toggle($this, system) {
  if (system.isEnabled) {
    system.disable();
  } else {
    system.enable();
  }
}
function setEnabled($this, system, enabled) {
  if (!system.isEnabled) {
    if (enabled) {
      system.enable();
    }
  } else {
    if (!enabled) {
      system.disable();
    }
  }
}
function setEnabled$default($this, system, enabled, $super) {
  enabled = enabled === VOID ? true : enabled;
  return setEnabled($this, system, enabled);
}
function CoreVisualization(coreServices, colliderVisualizer, connectorVisualizer) {
  this.coreServices = coreServices;
  var systems = this.coreServices.entityManager.getSystemsRegistered();
  var tmp = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = systems.length;
    while (inductionVariable < last) {
      var element = systems[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element.id === Companion_instance_187.ID) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp_0 = tmp$ret$1;
  var tmp0_elvis_lhs = (tmp_0 == null ? true : tmp_0 instanceof EntityColliderVisualizationSystem) ? tmp_0 : THROW_CCE();
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_0 = new EntityColliderVisualizationSystem(this.coreServices, colliderVisualizer);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_0.disable();
    tmp_1 = this_0;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  tmp.entityColliderVisualizationSystem = tmp_1;
  var tmp_2 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = systems.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = systems[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_0.id === Companion_instance_189.ID) {
        tmp$ret$6 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp_3 = tmp$ret$6;
  var tmp1_elvis_lhs = (tmp_3 == null ? true : tmp_3 instanceof EntityCollisionVisualizationSystem) ? tmp_3 : THROW_CCE();
  var tmp_4;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_1 = new EntityCollisionVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_1.disable();
    tmp_4 = this_1;
  } else {
    tmp_4 = tmp1_elvis_lhs;
  }
  tmp_2.entityCollisionVisualizationSystem = tmp_4;
  var tmp_5 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$11;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_1 = 0;
    var last_1 = systems.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = systems[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_1.id === Companion_getInstance_194().ID) {
        tmp$ret$11 = element_1;
        break $l$block_1;
      }
    }
    tmp$ret$11 = null;
  }
  var tmp_6 = tmp$ret$11;
  var tmp2_elvis_lhs = (tmp_6 == null ? true : tmp_6 instanceof EntityConnectorVisualizationSystem) ? tmp_6 : THROW_CCE();
  var tmp_7;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new EntityConnectorVisualizationSystem(this.coreServices, connectorVisualizer);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_2.disable();
    tmp_7 = this_2;
  } else {
    tmp_7 = tmp2_elvis_lhs;
  }
  tmp_5.entityConnectorVisualizationSystem = tmp_7;
  var tmp_8 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$16;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_2 = 0;
    var last_2 = systems.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = systems[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_2.id === Companion_instance_185.ID) {
        tmp$ret$16 = element_2;
        break $l$block_2;
      }
    }
    tmp$ret$16 = null;
  }
  var tmp_9 = tmp$ret$16;
  var tmp3_elvis_lhs = (tmp_9 == null ? true : tmp_9 instanceof ColliderVisualizationSystem) ? tmp_9 : THROW_CCE();
  var tmp_10;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_3 = new ColliderVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_3.disable();
    tmp_10 = this_3;
  } else {
    tmp_10 = tmp3_elvis_lhs;
  }
  tmp_8.colliderVisualizationSystem = tmp_10;
  var tmp_11 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$21;
  $l$block_3: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_3 = 0;
    var last_3 = systems.length;
    while (inductionVariable_3 < last_3) {
      var element_3 = systems[inductionVariable_3];
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_3.id === Companion_instance_186.ID) {
        tmp$ret$21 = element_3;
        break $l$block_3;
      }
    }
    tmp$ret$21 = null;
  }
  var tmp_12 = tmp$ret$21;
  var tmp4_elvis_lhs = (tmp_12 == null ? true : tmp_12 instanceof ConnectorVisualizationSystem) ? tmp_12 : THROW_CCE();
  var tmp_13;
  if (tmp4_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_4 = new ConnectorVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_4.disable();
    tmp_13 = this_4;
  } else {
    tmp_13 = tmp4_elvis_lhs;
  }
  tmp_11.connectorVisualizationSystem = tmp_13;
  var tmp_14 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$26;
  $l$block_4: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_4 = 0;
    var last_4 = systems.length;
    while (inductionVariable_4 < last_4) {
      var element_4 = systems[inductionVariable_4];
      inductionVariable_4 = inductionVariable_4 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_4.id === Companion_instance_182.ID) {
        tmp$ret$26 = element_4;
        break $l$block_4;
      }
    }
    tmp$ret$26 = null;
  }
  var tmp_15 = tmp$ret$26;
  var tmp5_elvis_lhs = (tmp_15 == null ? true : tmp_15 instanceof FunctionalMarginVisualizationSystem) ? tmp_15 : THROW_CCE();
  var tmp_16;
  if (tmp5_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_5 = new FunctionalMarginVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_5);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_5.disable();
    tmp_16 = this_5;
  } else {
    tmp_16 = tmp5_elvis_lhs;
  }
  tmp_14.functionalMarginVisualizationSystem = tmp_16;
  var tmp_17 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$31;
  $l$block_5: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_5 = 0;
    var last_5 = systems.length;
    while (inductionVariable_5 < last_5) {
      var element_5 = systems[inductionVariable_5];
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_5.id === Companion_instance_180.ID) {
        tmp$ret$31 = element_5;
        break $l$block_5;
      }
    }
    tmp$ret$31 = null;
  }
  var tmp_18 = tmp$ret$31;
  var tmp6_elvis_lhs = (tmp_18 == null ? true : tmp_18 instanceof AutoAdaptHostZoneVisualizationSystem) ? tmp_18 : THROW_CCE();
  var tmp_19;
  if (tmp6_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_6 = new AutoAdaptHostZoneVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_6.disable();
    tmp_19 = this_6;
  } else {
    tmp_19 = tmp6_elvis_lhs;
  }
  tmp_17.autoAdaptHostZoneVisualizationSystem = tmp_19;
  var tmp_20 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$36;
  $l$block_6: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_6 = 0;
    var last_6 = systems.length;
    while (inductionVariable_6 < last_6) {
      var element_6 = systems[inductionVariable_6];
      inductionVariable_6 = inductionVariable_6 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_6.id === Companion_getInstance_72().ID) {
        tmp$ret$36 = element_6;
        break $l$block_6;
      }
    }
    tmp$ret$36 = null;
  }
  var tmp7_elvis_lhs = tmp$ret$36;
  var tmp_21;
  if (tmp7_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_7 = new DragSurfaceNormalVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_7);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_7.disable();
    tmp_21 = this_7;
  } else {
    tmp_21 = tmp7_elvis_lhs;
  }
  var tmp_22 = tmp_21;
  tmp_20.dragSurfaceNormalVisualizationSystem = tmp_22 instanceof DragSurfaceNormalVisualizationSystem ? tmp_22 : THROW_CCE();
  var tmp_23 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$41;
  $l$block_7: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_7 = 0;
    var last_7 = systems.length;
    while (inductionVariable_7 < last_7) {
      var element_7 = systems[inductionVariable_7];
      inductionVariable_7 = inductionVariable_7 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_7.id === Companion_instance_181.ID) {
        tmp$ret$41 = element_7;
        break $l$block_7;
      }
    }
    tmp$ret$41 = null;
  }
  var tmp8_elvis_lhs = tmp$ret$41;
  var tmp_24;
  if (tmp8_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_8 = new DragProjectionPointVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_8);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_8.disable();
    tmp_24 = this_8;
  } else {
    tmp_24 = tmp8_elvis_lhs;
  }
  var tmp_25 = tmp_24;
  tmp_23.dragProjectionPointVisualizationSystem = tmp_25 instanceof DragProjectionPointVisualizationSystem ? tmp_25 : THROW_CCE();
  var tmp_26 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$46;
  $l$block_8: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_8 = 0;
    var last_8 = systems.length;
    while (inductionVariable_8 < last_8) {
      var element_8 = systems[inductionVariable_8];
      inductionVariable_8 = inductionVariable_8 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_8.id === Companion_instance_183.ID) {
        tmp$ret$46 = element_8;
        break $l$block_8;
      }
    }
    tmp$ret$46 = null;
  }
  var tmp9_elvis_lhs = tmp$ret$46;
  var tmp_27;
  if (tmp9_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_9 = new FunctionalZoneVisualizationSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_9);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_9.disable();
    tmp_27 = this_9;
  } else {
    tmp_27 = tmp9_elvis_lhs;
  }
  var tmp_28 = tmp_27;
  tmp_26.functionalZoneVisualizationSystem = tmp_28 instanceof FunctionalZoneVisualizationSystem ? tmp_28 : THROW_CCE();
  var tmp_29 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$51;
  $l$block_9: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_9 = 0;
    var last_9 = systems.length;
    while (inductionVariable_9 < last_9) {
      var element_9 = systems[inductionVariable_9];
      inductionVariable_9 = inductionVariable_9 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_9.id === Companion_getInstance_68().ID) {
        tmp$ret$51 = element_9;
        break $l$block_9;
      }
    }
    tmp$ret$51 = null;
  }
  var tmp10_elvis_lhs = tmp$ret$51;
  var tmp_30;
  if (tmp10_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_10 = new DebugLineDrawingSystem(this.coreServices);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_10);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_10.disable();
    tmp_30 = this_10;
  } else {
    tmp_30 = tmp10_elvis_lhs;
  }
  var tmp_31 = tmp_30;
  tmp_29.debugLineDrawingSystem = tmp_31 instanceof DebugLineDrawingSystem ? tmp_31 : THROW_CCE();
  var tmp_32 = this;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$56;
  $l$block_10: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_10 = 0;
    var last_10 = systems.length;
    while (inductionVariable_10 < last_10) {
      var element_10 = systems[inductionVariable_10];
      inductionVariable_10 = inductionVariable_10 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      if (element_10.id === Companion_instance_69.ID) {
        tmp$ret$56 = element_10;
        break $l$block_10;
      }
    }
    tmp$ret$56 = null;
  }
  var tmp11_elvis_lhs = tmp$ret$56;
  var tmp_33;
  if (tmp11_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_11 = new DragSurfaceVisualizationSystem(this.coreServices.entityManager);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this.coreServices.entityManager.registerSystem(this_11);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
    this_11.disable();
    tmp_33 = this_11;
  } else {
    tmp_33 = tmp11_elvis_lhs;
  }
  var tmp_34 = tmp_33;
  tmp_32.dragSurfaceVisualizationSystem = tmp_34 instanceof DragSurfaceVisualizationSystem ? tmp_34 : THROW_CCE();
  this.autoAdaptHostZoneVisualizationSystem.alpha = 0.5;
  this.functionalMarginVisualizationSystem.alpha = 0.5;
}
protoOf(CoreVisualization).j3t = function () {
  return this.coreServices;
};
protoOf(CoreVisualization).k51 = function () {
  return this.entityColliderVisualizationSystem;
};
protoOf(CoreVisualization).l51 = function () {
  return this.entityCollisionVisualizationSystem;
};
protoOf(CoreVisualization).m51 = function () {
  return this.entityConnectorVisualizationSystem;
};
protoOf(CoreVisualization).n51 = function () {
  return this.colliderVisualizationSystem;
};
protoOf(CoreVisualization).o51 = function () {
  return this.connectorVisualizationSystem;
};
protoOf(CoreVisualization).p51 = function () {
  return this.debugLineDrawingSystem;
};
protoOf(CoreVisualization).q51 = function () {
  return this.functionalMarginVisualizationSystem;
};
protoOf(CoreVisualization).r51 = function () {
  return this.autoAdaptHostZoneVisualizationSystem;
};
protoOf(CoreVisualization).s51 = function () {
  return this.dragSurfaceNormalVisualizationSystem;
};
protoOf(CoreVisualization).t51 = function () {
  return this.dragSurfaceVisualizationSystem;
};
protoOf(CoreVisualization).u51 = function () {
  return this.dragProjectionPointVisualizationSystem;
};
protoOf(CoreVisualization).v51 = function () {
  return this.functionalZoneVisualizationSystem;
};
protoOf(CoreVisualization).toggleEntityColliders = function () {
  return toggle(this, this.entityColliderVisualizationSystem);
};
protoOf(CoreVisualization).toggleEntityCollisions = function () {
  return toggle(this, this.entityCollisionVisualizationSystem);
};
protoOf(CoreVisualization).toggleEntityConnectors = function () {
  return toggle(this, this.entityConnectorVisualizationSystem);
};
protoOf(CoreVisualization).toggleColliders = function () {
  toggle(this, this.colliderVisualizationSystem);
  if (this.colliderVisualizationSystem.isEnabled) {
    setEnabled$default(this, this.entityColliderVisualizationSystem);
    setEnabled$default(this, this.entityCollisionVisualizationSystem);
  }
};
protoOf(CoreVisualization).toggleConnectors = function () {
  toggle(this, this.connectorVisualizationSystem);
  if (this.connectorVisualizationSystem.isEnabled) {
    setEnabled$default(this, this.entityConnectorVisualizationSystem);
  }
};
protoOf(CoreVisualization).toggleAutoAdaptHostZone = function () {
  return toggle(this, this.autoAdaptHostZoneVisualizationSystem);
};
protoOf(CoreVisualization).toggleFunctionalMargin = function () {
  return toggle(this, this.functionalMarginVisualizationSystem);
};
protoOf(CoreVisualization).toggleDragSurfaces = function () {
  return toggle(this, this.dragSurfaceNormalVisualizationSystem);
};
protoOf(CoreVisualization).toggleDragProjectionPoint = function () {
  return toggle(this, this.dragProjectionPointVisualizationSystem);
};
protoOf(CoreVisualization).toggleDragSurfaceVisualizationSystem = function () {
  return toggle(this, this.dragSurfaceVisualizationSystem);
};
protoOf(CoreVisualization).toggleDebugLineDrawingSystem = function () {
  return toggle(this, this.debugLineDrawingSystem);
};
protoOf(CoreVisualization).toggleFunctionalZone = function () {
  return toggle(this, this.functionalZoneVisualizationSystem);
};
protoOf(CoreVisualization).setVisualizationState = function (state) {
  setEnabled(this, this.entityColliderVisualizationSystem, state.colliderVisualizationEnabled);
  setEnabled(this, this.colliderVisualizationSystem, state.visualizeAllColliders);
  setEnabled(this, this.entityCollisionVisualizationSystem, state.collisionVisualizationEnabled);
  setEnabled(this, this.entityConnectorVisualizationSystem, state.connectorVisualizationEnabled);
  setEnabled(this, this.connectorVisualizationSystem, state.visualizeAllConnectors);
  this.connectorVisualizationSystem.connectorActivationDistanceVisualizationEnabled = state.connectorActivationDistanceVisualizationEnabled;
  this.connectorVisualizationSystem.connectorTransformVisualizationEnabled = state.connectorTransformVisualizationEnabled;
  setEnabled(this, this.functionalMarginVisualizationSystem, state.functionalMarginVisualizationEnabled);
  setEnabled(this, this.autoAdaptHostZoneVisualizationSystem, state.autoAdaptHostZoneVisualizationEnabled);
  setEnabled(this, this.dragSurfaceNormalVisualizationSystem, state.dragSurfaceNormalVisualizationEnabled);
  setEnabled(this, this.dragProjectionPointVisualizationSystem, state.dragProjectionPointVisualizationEnabled);
  setEnabled(this, this.functionalZoneVisualizationSystem, state.functionalZoneVisualizationEnabled);
  setEnabled(this, this.debugLineDrawingSystem, state.debugLineDrawingSystem);
  setEnabled(this, this.dragSurfaceVisualizationSystem, state.dragSurfaceVisualizationSystem);
};
protoOf(CoreVisualization).getVisualizationState = function () {
  return new VisualizationState(this.entityColliderVisualizationSystem.isEnabled, this.colliderVisualizationSystem.isEnabled, this.entityCollisionVisualizationSystem.isEnabled, this.entityConnectorVisualizationSystem.isEnabled, this.connectorVisualizationSystem.isEnabled, this.connectorVisualizationSystem.connectorActivationDistanceVisualizationEnabled, this.connectorVisualizationSystem.connectorTransformVisualizationEnabled, this.functionalMarginVisualizationSystem.isEnabled, this.autoAdaptHostZoneVisualizationSystem.isEnabled, this.debugLineDrawingSystem.isEnabled, this.dragSurfaceVisualizationSystem.isEnabled);
};
function VisualizationState(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem) {
  colliderVisualizationEnabled = colliderVisualizationEnabled === VOID ? false : colliderVisualizationEnabled;
  visualizeAllColliders = visualizeAllColliders === VOID ? false : visualizeAllColliders;
  collisionVisualizationEnabled = collisionVisualizationEnabled === VOID ? false : collisionVisualizationEnabled;
  connectorVisualizationEnabled = connectorVisualizationEnabled === VOID ? false : connectorVisualizationEnabled;
  visualizeAllConnectors = visualizeAllConnectors === VOID ? false : visualizeAllConnectors;
  connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled === VOID ? false : connectorActivationDistanceVisualizationEnabled;
  connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled === VOID ? false : connectorTransformVisualizationEnabled;
  functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled === VOID ? false : functionalMarginVisualizationEnabled;
  autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled === VOID ? false : autoAdaptHostZoneVisualizationEnabled;
  dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled === VOID ? false : dragSurfaceNormalVisualizationEnabled;
  dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled === VOID ? false : dragProjectionPointVisualizationEnabled;
  functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled === VOID ? false : functionalZoneVisualizationEnabled;
  debugLineDrawingSystem = debugLineDrawingSystem === VOID ? false : debugLineDrawingSystem;
  dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem === VOID ? false : dragSurfaceVisualizationSystem;
  this.colliderVisualizationEnabled = colliderVisualizationEnabled;
  this.visualizeAllColliders = visualizeAllColliders;
  this.collisionVisualizationEnabled = collisionVisualizationEnabled;
  this.connectorVisualizationEnabled = connectorVisualizationEnabled;
  this.visualizeAllConnectors = visualizeAllConnectors;
  this.connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled;
  this.connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled;
  this.functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled;
  this.autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled;
  this.dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled;
  this.dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled;
  this.functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled;
  this.debugLineDrawingSystem = debugLineDrawingSystem;
  this.dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem;
}
protoOf(VisualizationState).w51 = function () {
  return this.colliderVisualizationEnabled;
};
protoOf(VisualizationState).x51 = function () {
  return this.visualizeAllColliders;
};
protoOf(VisualizationState).y51 = function () {
  return this.collisionVisualizationEnabled;
};
protoOf(VisualizationState).z51 = function () {
  return this.connectorVisualizationEnabled;
};
protoOf(VisualizationState).a52 = function () {
  return this.visualizeAllConnectors;
};
protoOf(VisualizationState).b52 = function () {
  return this.connectorActivationDistanceVisualizationEnabled;
};
protoOf(VisualizationState).c52 = function () {
  return this.connectorTransformVisualizationEnabled;
};
protoOf(VisualizationState).d52 = function () {
  return this.functionalMarginVisualizationEnabled;
};
protoOf(VisualizationState).e52 = function () {
  return this.autoAdaptHostZoneVisualizationEnabled;
};
protoOf(VisualizationState).f52 = function () {
  return this.dragSurfaceNormalVisualizationEnabled;
};
protoOf(VisualizationState).g52 = function () {
  return this.dragProjectionPointVisualizationEnabled;
};
protoOf(VisualizationState).h52 = function () {
  return this.functionalZoneVisualizationEnabled;
};
protoOf(VisualizationState).p51 = function () {
  return this.debugLineDrawingSystem;
};
protoOf(VisualizationState).t51 = function () {
  return this.dragSurfaceVisualizationSystem;
};
protoOf(VisualizationState).tf = function () {
  return this.colliderVisualizationEnabled;
};
protoOf(VisualizationState).uf = function () {
  return this.visualizeAllColliders;
};
protoOf(VisualizationState).m1m = function () {
  return this.collisionVisualizationEnabled;
};
protoOf(VisualizationState).n1m = function () {
  return this.connectorVisualizationEnabled;
};
protoOf(VisualizationState).o1m = function () {
  return this.visualizeAllConnectors;
};
protoOf(VisualizationState).p1m = function () {
  return this.connectorActivationDistanceVisualizationEnabled;
};
protoOf(VisualizationState).q1m = function () {
  return this.connectorTransformVisualizationEnabled;
};
protoOf(VisualizationState).l2e = function () {
  return this.functionalMarginVisualizationEnabled;
};
protoOf(VisualizationState).m2e = function () {
  return this.autoAdaptHostZoneVisualizationEnabled;
};
protoOf(VisualizationState).n2e = function () {
  return this.dragSurfaceNormalVisualizationEnabled;
};
protoOf(VisualizationState).o2e = function () {
  return this.dragProjectionPointVisualizationEnabled;
};
protoOf(VisualizationState).p2e = function () {
  return this.functionalZoneVisualizationEnabled;
};
protoOf(VisualizationState).p2g = function () {
  return this.debugLineDrawingSystem;
};
protoOf(VisualizationState).q2g = function () {
  return this.dragSurfaceVisualizationSystem;
};
protoOf(VisualizationState).i52 = function (colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem) {
  return new VisualizationState(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem);
};
protoOf(VisualizationState).copy = function (colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem, $super) {
  colliderVisualizationEnabled = colliderVisualizationEnabled === VOID ? this.colliderVisualizationEnabled : colliderVisualizationEnabled;
  visualizeAllColliders = visualizeAllColliders === VOID ? this.visualizeAllColliders : visualizeAllColliders;
  collisionVisualizationEnabled = collisionVisualizationEnabled === VOID ? this.collisionVisualizationEnabled : collisionVisualizationEnabled;
  connectorVisualizationEnabled = connectorVisualizationEnabled === VOID ? this.connectorVisualizationEnabled : connectorVisualizationEnabled;
  visualizeAllConnectors = visualizeAllConnectors === VOID ? this.visualizeAllConnectors : visualizeAllConnectors;
  connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled === VOID ? this.connectorActivationDistanceVisualizationEnabled : connectorActivationDistanceVisualizationEnabled;
  connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled === VOID ? this.connectorTransformVisualizationEnabled : connectorTransformVisualizationEnabled;
  functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled === VOID ? this.functionalMarginVisualizationEnabled : functionalMarginVisualizationEnabled;
  autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled === VOID ? this.autoAdaptHostZoneVisualizationEnabled : autoAdaptHostZoneVisualizationEnabled;
  dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled === VOID ? this.dragSurfaceNormalVisualizationEnabled : dragSurfaceNormalVisualizationEnabled;
  dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled === VOID ? this.dragProjectionPointVisualizationEnabled : dragProjectionPointVisualizationEnabled;
  functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled === VOID ? this.functionalZoneVisualizationEnabled : functionalZoneVisualizationEnabled;
  debugLineDrawingSystem = debugLineDrawingSystem === VOID ? this.debugLineDrawingSystem : debugLineDrawingSystem;
  dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem === VOID ? this.dragSurfaceVisualizationSystem : dragSurfaceVisualizationSystem;
  return this.i52(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem);
};
protoOf(VisualizationState).toString = function () {
  return 'VisualizationState(colliderVisualizationEnabled=' + this.colliderVisualizationEnabled + ', visualizeAllColliders=' + this.visualizeAllColliders + ', collisionVisualizationEnabled=' + this.collisionVisualizationEnabled + ', connectorVisualizationEnabled=' + this.connectorVisualizationEnabled + ', visualizeAllConnectors=' + this.visualizeAllConnectors + ', connectorActivationDistanceVisualizationEnabled=' + this.connectorActivationDistanceVisualizationEnabled + ', connectorTransformVisualizationEnabled=' + this.connectorTransformVisualizationEnabled + ', functionalMarginVisualizationEnabled=' + this.functionalMarginVisualizationEnabled + ', autoAdaptHostZoneVisualizationEnabled=' + this.autoAdaptHostZoneVisualizationEnabled + ', dragSurfaceNormalVisualizationEnabled=' + this.dragSurfaceNormalVisualizationEnabled + ', dragProjectionPointVisualizationEnabled=' + this.dragProjectionPointVisualizationEnabled + ', functionalZoneVisualizationEnabled=' + this.functionalZoneVisualizationEnabled + ', debugLineDrawingSystem=' + this.debugLineDrawingSystem + ', dragSurfaceVisualizationSystem=' + this.dragSurfaceVisualizationSystem + ')';
};
protoOf(VisualizationState).hashCode = function () {
  var result = getBooleanHashCode(this.colliderVisualizationEnabled);
  result = imul(result, 31) + getBooleanHashCode(this.visualizeAllColliders) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.collisionVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.connectorVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.visualizeAllConnectors) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.connectorActivationDistanceVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.connectorTransformVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.functionalMarginVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.autoAdaptHostZoneVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.dragSurfaceNormalVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.dragProjectionPointVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.functionalZoneVisualizationEnabled) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.debugLineDrawingSystem) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.dragSurfaceVisualizationSystem) | 0;
  return result;
};
protoOf(VisualizationState).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VisualizationState))
    return false;
  var tmp0_other_with_cast = other instanceof VisualizationState ? other : THROW_CCE();
  if (!(this.colliderVisualizationEnabled === tmp0_other_with_cast.colliderVisualizationEnabled))
    return false;
  if (!(this.visualizeAllColliders === tmp0_other_with_cast.visualizeAllColliders))
    return false;
  if (!(this.collisionVisualizationEnabled === tmp0_other_with_cast.collisionVisualizationEnabled))
    return false;
  if (!(this.connectorVisualizationEnabled === tmp0_other_with_cast.connectorVisualizationEnabled))
    return false;
  if (!(this.visualizeAllConnectors === tmp0_other_with_cast.visualizeAllConnectors))
    return false;
  if (!(this.connectorActivationDistanceVisualizationEnabled === tmp0_other_with_cast.connectorActivationDistanceVisualizationEnabled))
    return false;
  if (!(this.connectorTransformVisualizationEnabled === tmp0_other_with_cast.connectorTransformVisualizationEnabled))
    return false;
  if (!(this.functionalMarginVisualizationEnabled === tmp0_other_with_cast.functionalMarginVisualizationEnabled))
    return false;
  if (!(this.autoAdaptHostZoneVisualizationEnabled === tmp0_other_with_cast.autoAdaptHostZoneVisualizationEnabled))
    return false;
  if (!(this.dragSurfaceNormalVisualizationEnabled === tmp0_other_with_cast.dragSurfaceNormalVisualizationEnabled))
    return false;
  if (!(this.dragProjectionPointVisualizationEnabled === tmp0_other_with_cast.dragProjectionPointVisualizationEnabled))
    return false;
  if (!(this.functionalZoneVisualizationEnabled === tmp0_other_with_cast.functionalZoneVisualizationEnabled))
    return false;
  if (!(this.debugLineDrawingSystem === tmp0_other_with_cast.debugLineDrawingSystem))
    return false;
  if (!(this.dragSurfaceVisualizationSystem === tmp0_other_with_cast.dragSurfaceVisualizationSystem))
    return false;
  return true;
};
function Companion_130() {
  Companion_instance_169 = this;
  this.id = Companion_instance_0.a1r_1;
}
protoOf(Companion_130).n1s = function () {
  return this.id;
};
var Companion_instance_169;
function Companion_getInstance_173() {
  if (Companion_instance_169 == null)
    new Companion_130();
  return Companion_instance_169;
}
function ColliderVisualizationConfigComponent(includeRoom) {
  Companion_getInstance_173();
  this.includeRoom = includeRoom;
}
protoOf(ColliderVisualizationConfigComponent).j52 = function () {
  return this.includeRoom;
};
protoOf(ColliderVisualizationConfigComponent).p1s = function () {
  return Companion_getInstance_173().id;
};
protoOf(ColliderVisualizationConfigComponent).eq = function (other) {
  var o = other instanceof ColliderVisualizationConfigComponent ? other : THROW_CCE();
  return o.includeRoom === this.includeRoom;
};
protoOf(ColliderVisualizationConfigComponent).tf = function () {
  return this.includeRoom;
};
protoOf(ColliderVisualizationConfigComponent).k52 = function (includeRoom) {
  return new ColliderVisualizationConfigComponent(includeRoom);
};
protoOf(ColliderVisualizationConfigComponent).copy = function (includeRoom, $super) {
  includeRoom = includeRoom === VOID ? this.includeRoom : includeRoom;
  return this.k52(includeRoom);
};
protoOf(ColliderVisualizationConfigComponent).toString = function () {
  return 'ColliderVisualizationConfigComponent(includeRoom=' + this.includeRoom + ')';
};
protoOf(ColliderVisualizationConfigComponent).hashCode = function () {
  return getBooleanHashCode(this.includeRoom);
};
protoOf(ColliderVisualizationConfigComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ColliderVisualizationConfigComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ColliderVisualizationConfigComponent ? other : THROW_CCE();
  if (!(this.includeRoom === tmp0_other_with_cast.includeRoom))
    return false;
  return true;
};
function Companion_131() {
}
protoOf(Companion_131).n1s = function () {
  return Companion_instance_0.t1n_1;
};
var Companion_instance_170;
function Companion_getInstance_174() {
  return Companion_instance_170;
}
function ColliderVisualizationNodeComponent(ownerEntity, color, collidingBoundIds) {
  this.ownerEntity = ownerEntity;
  this.color = color;
  this.collidingBoundIds = collidingBoundIds;
}
protoOf(ColliderVisualizationNodeComponent).x3r = function () {
  return this.ownerEntity;
};
protoOf(ColliderVisualizationNodeComponent).j2i = function () {
  return this.color;
};
protoOf(ColliderVisualizationNodeComponent).l52 = function () {
  return this.collidingBoundIds;
};
protoOf(ColliderVisualizationNodeComponent).p1s = function () {
  return Companion_instance_170.id;
};
protoOf(ColliderVisualizationNodeComponent).eq = function (other) {
  return (other instanceof ColliderVisualizationNodeComponent ? other : THROW_CCE()).equals(this);
};
protoOf(ColliderVisualizationNodeComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ColliderVisualizationNodeComponent))
    THROW_CCE();
  if (!this.ownerEntity.equals(other.ownerEntity))
    return false;
  if (!equals(this.color, other.color))
    return false;
  if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
    return false;
  return true;
};
protoOf(ColliderVisualizationNodeComponent).hashCode = function () {
  var result = this.ownerEntity.hashCode();
  var tmp = imul(31, result);
  var tmp0_safe_receiver = this.color;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
  result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  result = imul(31, result) + contentHashCode(this.collidingBoundIds) | 0;
  return result;
};
protoOf(ColliderVisualizationNodeComponent).tf = function () {
  return this.ownerEntity;
};
protoOf(ColliderVisualizationNodeComponent).uf = function () {
  return this.color;
};
protoOf(ColliderVisualizationNodeComponent).m1m = function () {
  return this.collidingBoundIds;
};
protoOf(ColliderVisualizationNodeComponent).m52 = function (ownerEntity, color, collidingBoundIds) {
  return new ColliderVisualizationNodeComponent(ownerEntity, color, collidingBoundIds);
};
protoOf(ColliderVisualizationNodeComponent).copy = function (ownerEntity, color, collidingBoundIds, $super) {
  ownerEntity = ownerEntity === VOID ? this.ownerEntity : ownerEntity;
  color = color === VOID ? this.color : color;
  collidingBoundIds = collidingBoundIds === VOID ? this.collidingBoundIds : collidingBoundIds;
  return this.m52(ownerEntity, color, collidingBoundIds);
};
protoOf(ColliderVisualizationNodeComponent).toString = function () {
  return 'ColliderVisualizationNodeComponent(ownerEntity=' + this.ownerEntity.toString() + ', color=' + toString_0(this.color) + ', collidingBoundIds=' + toString(this.collidingBoundIds) + ')';
};
function Companion_132() {
  Companion_instance_171 = this;
  this.id = Companion_instance_0.p1q_1;
}
protoOf(Companion_132).n1s = function () {
  return this.id;
};
var Companion_instance_171;
function Companion_getInstance_175() {
  if (Companion_instance_171 == null)
    new Companion_132();
  return Companion_instance_171;
}
function ColliderVisualizerViewerObjectsComponent(viewerObjets) {
  Companion_getInstance_175();
  this.viewerObjets = viewerObjets;
  this.n52_1 = false;
}
protoOf(ColliderVisualizerViewerObjectsComponent).o52 = function () {
  return this.viewerObjets;
};
protoOf(ColliderVisualizerViewerObjectsComponent).p1s = function () {
  return Companion_getInstance_175().id;
};
protoOf(ColliderVisualizerViewerObjectsComponent).eq = function (other) {
  return true;
};
protoOf(ColliderVisualizerViewerObjectsComponent).s1s = function () {
  return this.n52_1;
};
protoOf(ColliderVisualizerViewerObjectsComponent).tf = function () {
  return this.viewerObjets;
};
protoOf(ColliderVisualizerViewerObjectsComponent).p52 = function (viewerObjets) {
  return new ColliderVisualizerViewerObjectsComponent(viewerObjets);
};
protoOf(ColliderVisualizerViewerObjectsComponent).copy = function (viewerObjets, $super) {
  viewerObjets = viewerObjets === VOID ? this.viewerObjets : viewerObjets;
  return this.p52(viewerObjets);
};
protoOf(ColliderVisualizerViewerObjectsComponent).toString = function () {
  return 'ColliderVisualizerViewerObjectsComponent(viewerObjets=' + toString(this.viewerObjets) + ')';
};
protoOf(ColliderVisualizerViewerObjectsComponent).hashCode = function () {
  return hashCode(this.viewerObjets);
};
protoOf(ColliderVisualizerViewerObjectsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ColliderVisualizerViewerObjectsComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ColliderVisualizerViewerObjectsComponent ? other : THROW_CCE();
  if (!equals(this.viewerObjets, tmp0_other_with_cast.viewerObjets))
    return false;
  return true;
};
function Companion_133() {
  Companion_instance_172 = this;
  this.id = Companion_instance_0.b1r_1;
}
protoOf(Companion_133).n1s = function () {
  return this.id;
};
var Companion_instance_172;
function Companion_getInstance_176() {
  if (Companion_instance_172 == null)
    new Companion_133();
  return Companion_instance_172;
}
function ConnectorVisualizationConfigComponent(includeRoom) {
  Companion_getInstance_176();
  this.includeRoom = includeRoom;
}
protoOf(ConnectorVisualizationConfigComponent).j52 = function () {
  return this.includeRoom;
};
protoOf(ConnectorVisualizationConfigComponent).p1s = function () {
  return Companion_getInstance_176().id;
};
protoOf(ConnectorVisualizationConfigComponent).eq = function (other) {
  var o = other instanceof ConnectorVisualizationConfigComponent ? other : THROW_CCE();
  return o.includeRoom === this.includeRoom;
};
protoOf(ConnectorVisualizationConfigComponent).tf = function () {
  return this.includeRoom;
};
protoOf(ConnectorVisualizationConfigComponent).k52 = function (includeRoom) {
  return new ConnectorVisualizationConfigComponent(includeRoom);
};
protoOf(ConnectorVisualizationConfigComponent).copy = function (includeRoom, $super) {
  includeRoom = includeRoom === VOID ? this.includeRoom : includeRoom;
  return this.k52(includeRoom);
};
protoOf(ConnectorVisualizationConfigComponent).toString = function () {
  return 'ConnectorVisualizationConfigComponent(includeRoom=' + this.includeRoom + ')';
};
protoOf(ConnectorVisualizationConfigComponent).hashCode = function () {
  return getBooleanHashCode(this.includeRoom);
};
protoOf(ConnectorVisualizationConfigComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ConnectorVisualizationConfigComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ConnectorVisualizationConfigComponent ? other : THROW_CCE();
  if (!(this.includeRoom === tmp0_other_with_cast.includeRoom))
    return false;
  return true;
};
function Companion_134() {
}
protoOf(Companion_134).n1s = function () {
  return Companion_instance_0.s1n_1;
};
var Companion_instance_173;
function Companion_getInstance_177() {
  return Companion_instance_173;
}
function ConnectorVisualizationNodeComponent(ownerEntity, data, offersFilter, demandsFilter) {
  this.ownerEntity = ownerEntity;
  this.data = data;
  this.offersFilter = offersFilter;
  this.demandsFilter = demandsFilter;
}
protoOf(ConnectorVisualizationNodeComponent).x3r = function () {
  return this.ownerEntity;
};
protoOf(ConnectorVisualizationNodeComponent).q52 = function () {
  return this.data;
};
protoOf(ConnectorVisualizationNodeComponent).r52 = function () {
  return this.offersFilter;
};
protoOf(ConnectorVisualizationNodeComponent).s52 = function () {
  return this.demandsFilter;
};
protoOf(ConnectorVisualizationNodeComponent).p1s = function () {
  return Companion_instance_173.id;
};
protoOf(ConnectorVisualizationNodeComponent).eq = function (other) {
  return (other instanceof ConnectorVisualizationNodeComponent ? other : THROW_CCE()).equals(this);
};
protoOf(ConnectorVisualizationNodeComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ConnectorVisualizationNodeComponent))
    THROW_CCE();
  if (!this.ownerEntity.equals(other.ownerEntity))
    return false;
  if (!(this.data == null)) {
    if (other.data == null)
      return false;
    if (!contentEquals(this.data, other.data))
      return false;
  } else if (!(other.data == null))
    return false;
  if (!(this.offersFilter == null)) {
    if (other.offersFilter == null)
      return false;
    if (!contentEquals(this.offersFilter, other.offersFilter))
      return false;
  } else if (!(other.offersFilter == null))
    return false;
  if (!(this.demandsFilter == null)) {
    if (other.demandsFilter == null)
      return false;
    if (!contentEquals(this.demandsFilter, other.demandsFilter))
      return false;
  } else if (!(other.demandsFilter == null))
    return false;
  return true;
};
protoOf(ConnectorVisualizationNodeComponent).hashCode = function () {
  var result = this.ownerEntity.hashCode();
  var tmp = imul(31, result);
  var tmp0_safe_receiver = this.data;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contentHashCode(tmp0_safe_receiver);
  result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  var tmp_0 = imul(31, result);
  var tmp2_safe_receiver = this.offersFilter;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : contentHashCode(tmp2_safe_receiver);
  result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
  var tmp_1 = imul(31, result);
  var tmp4_safe_receiver = this.demandsFilter;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : contentHashCode(tmp4_safe_receiver);
  result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
  return result;
};
protoOf(ConnectorVisualizationNodeComponent).tf = function () {
  return this.ownerEntity;
};
protoOf(ConnectorVisualizationNodeComponent).uf = function () {
  return this.data;
};
protoOf(ConnectorVisualizationNodeComponent).m1m = function () {
  return this.offersFilter;
};
protoOf(ConnectorVisualizationNodeComponent).n1m = function () {
  return this.demandsFilter;
};
protoOf(ConnectorVisualizationNodeComponent).t52 = function (ownerEntity, data, offersFilter, demandsFilter) {
  return new ConnectorVisualizationNodeComponent(ownerEntity, data, offersFilter, demandsFilter);
};
protoOf(ConnectorVisualizationNodeComponent).copy = function (ownerEntity, data, offersFilter, demandsFilter, $super) {
  ownerEntity = ownerEntity === VOID ? this.ownerEntity : ownerEntity;
  data = data === VOID ? this.data : data;
  offersFilter = offersFilter === VOID ? this.offersFilter : offersFilter;
  demandsFilter = demandsFilter === VOID ? this.demandsFilter : demandsFilter;
  return this.t52(ownerEntity, data, offersFilter, demandsFilter);
};
protoOf(ConnectorVisualizationNodeComponent).toString = function () {
  return 'ConnectorVisualizationNodeComponent(ownerEntity=' + this.ownerEntity.toString() + ', data=' + toString(this.data) + ', offersFilter=' + toString(this.offersFilter) + ', demandsFilter=' + toString(this.demandsFilter) + ')';
};
function Companion_135() {
  Companion_instance_174 = this;
  this.id = Companion_instance_0.q1q_1;
}
protoOf(Companion_135).n1s = function () {
  return this.id;
};
var Companion_instance_174;
function Companion_getInstance_178() {
  if (Companion_instance_174 == null)
    new Companion_135();
  return Companion_instance_174;
}
function ConnectorVisualizerViewerObjectsComponent(viewerObjets) {
  Companion_getInstance_178();
  this.viewerObjets = viewerObjets;
  this.u52_1 = false;
}
protoOf(ConnectorVisualizerViewerObjectsComponent).o52 = function () {
  return this.viewerObjets;
};
protoOf(ConnectorVisualizerViewerObjectsComponent).p1s = function () {
  return Companion_getInstance_178().id;
};
protoOf(ConnectorVisualizerViewerObjectsComponent).eq = function (other) {
  return true;
};
protoOf(ConnectorVisualizerViewerObjectsComponent).s1s = function () {
  return this.u52_1;
};
protoOf(ConnectorVisualizerViewerObjectsComponent).tf = function () {
  return this.viewerObjets;
};
protoOf(ConnectorVisualizerViewerObjectsComponent).p52 = function (viewerObjets) {
  return new ConnectorVisualizerViewerObjectsComponent(viewerObjets);
};
protoOf(ConnectorVisualizerViewerObjectsComponent).copy = function (viewerObjets, $super) {
  viewerObjets = viewerObjets === VOID ? this.viewerObjets : viewerObjets;
  return this.p52(viewerObjets);
};
protoOf(ConnectorVisualizerViewerObjectsComponent).toString = function () {
  return 'ConnectorVisualizerViewerObjectsComponent(viewerObjets=' + toString(this.viewerObjets) + ')';
};
protoOf(ConnectorVisualizerViewerObjectsComponent).hashCode = function () {
  return hashCode(this.viewerObjets);
};
protoOf(ConnectorVisualizerViewerObjectsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ConnectorVisualizerViewerObjectsComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ConnectorVisualizerViewerObjectsComponent ? other : THROW_CCE();
  if (!equals(this.viewerObjets, tmp0_other_with_cast.viewerObjets))
    return false;
  return true;
};
function Companion_136() {
  Companion_instance_175 = this;
  this.id = Companion_instance_0.a1q_1;
}
protoOf(Companion_136).n1s = function () {
  return this.id;
};
var Companion_instance_175;
function Companion_getInstance_179() {
  if (Companion_instance_175 == null)
    new Companion_136();
  return Companion_instance_175;
}
function DecoratorComponent(placeholder, decorator, model, modelVisible, decoratorVisible) {
  Companion_getInstance_179();
  modelVisible = modelVisible === VOID ? true : modelVisible;
  decoratorVisible = decoratorVisible === VOID ? false : decoratorVisible;
  this.placeholder = placeholder;
  this.decorator = decorator;
  this.model = model;
  this.modelVisible = modelVisible;
  this.decoratorVisible = decoratorVisible;
}
protoOf(DecoratorComponent).v52 = function () {
  return this.placeholder;
};
protoOf(DecoratorComponent).w52 = function () {
  return this.decorator;
};
protoOf(DecoratorComponent).t30 = function () {
  return this.model;
};
protoOf(DecoratorComponent).x52 = function () {
  return this.modelVisible;
};
protoOf(DecoratorComponent).y52 = function () {
  return this.decoratorVisible;
};
protoOf(DecoratorComponent).p1s = function () {
  return Companion_getInstance_179().id;
};
protoOf(DecoratorComponent).eq = function (other) {
  var o = other instanceof DecoratorComponent ? other : THROW_CCE();
  if (!(o.modelVisible === this.modelVisible))
    return false;
  if (!(o.decoratorVisible === this.decoratorVisible))
    return false;
  return equals(o.placeholder, this.placeholder) && equals(o.decorator, this.decorator) && equals(o.model, this.model);
};
protoOf(DecoratorComponent).tf = function () {
  return this.placeholder;
};
protoOf(DecoratorComponent).uf = function () {
  return this.decorator;
};
protoOf(DecoratorComponent).m1m = function () {
  return this.model;
};
protoOf(DecoratorComponent).n1m = function () {
  return this.modelVisible;
};
protoOf(DecoratorComponent).o1m = function () {
  return this.decoratorVisible;
};
protoOf(DecoratorComponent).z52 = function (placeholder, decorator, model, modelVisible, decoratorVisible) {
  return new DecoratorComponent(placeholder, decorator, model, modelVisible, decoratorVisible);
};
protoOf(DecoratorComponent).copy = function (placeholder, decorator, model, modelVisible, decoratorVisible, $super) {
  placeholder = placeholder === VOID ? this.placeholder : placeholder;
  decorator = decorator === VOID ? this.decorator : decorator;
  model = model === VOID ? this.model : model;
  modelVisible = modelVisible === VOID ? this.modelVisible : modelVisible;
  decoratorVisible = decoratorVisible === VOID ? this.decoratorVisible : decoratorVisible;
  return this.z52(placeholder, decorator, model, modelVisible, decoratorVisible);
};
protoOf(DecoratorComponent).toString = function () {
  return 'DecoratorComponent(placeholder=' + toString(this.placeholder) + ', decorator=' + toString(this.decorator) + ', model=' + toString_0(this.model) + ', modelVisible=' + this.modelVisible + ', decoratorVisible=' + this.decoratorVisible + ')';
};
protoOf(DecoratorComponent).hashCode = function () {
  var result = hashCode(this.placeholder);
  result = imul(result, 31) + hashCode(this.decorator) | 0;
  result = imul(result, 31) + (this.model == null ? 0 : hashCode(this.model)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.modelVisible) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.decoratorVisible) | 0;
  return result;
};
protoOf(DecoratorComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DecoratorComponent))
    return false;
  var tmp0_other_with_cast = other instanceof DecoratorComponent ? other : THROW_CCE();
  if (!equals(this.placeholder, tmp0_other_with_cast.placeholder))
    return false;
  if (!equals(this.decorator, tmp0_other_with_cast.decorator))
    return false;
  if (!equals(this.model, tmp0_other_with_cast.model))
    return false;
  if (!(this.modelVisible === tmp0_other_with_cast.modelVisible))
    return false;
  if (!(this.decoratorVisible === tmp0_other_with_cast.decoratorVisible))
    return false;
  return true;
};
function Companion_137() {
  Companion_instance_176 = this;
  this.id = Companion_instance_0.v1p_1;
}
protoOf(Companion_137).n1s = function () {
  return this.id;
};
var Companion_instance_176;
function Companion_getInstance_180() {
  if (Companion_instance_176 == null)
    new Companion_137();
  return Companion_instance_176;
}
function EntityColliderVisualizationComponent(color, collidingBoundIds, isGenerated) {
  Companion_getInstance_180();
  color = color === VOID ? new Color('#1784ba', 0.0901, 0.5176, 0.7294) : color;
  var tmp;
  if (collidingBoundIds === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = collidingBoundIds;
  }
  collidingBoundIds = tmp;
  isGenerated = isGenerated === VOID ? false : isGenerated;
  this.color = color;
  this.collidingBoundIds = collidingBoundIds;
  this.isGenerated = isGenerated;
  this.a53_1 = false;
}
protoOf(EntityColliderVisualizationComponent).j2i = function () {
  return this.color;
};
protoOf(EntityColliderVisualizationComponent).l52 = function () {
  return this.collidingBoundIds;
};
protoOf(EntityColliderVisualizationComponent).b53 = function () {
  return this.isGenerated;
};
protoOf(EntityColliderVisualizationComponent).p1s = function () {
  return Companion_getInstance_180().id;
};
protoOf(EntityColliderVisualizationComponent).s1s = function () {
  return this.a53_1;
};
protoOf(EntityColliderVisualizationComponent).eq = function (other) {
  if (!(other instanceof EntityColliderVisualizationComponent))
    THROW_CCE();
  if (!(this.color.color === other.color.color))
    return false;
  if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
    return false;
  return true;
};
protoOf(EntityColliderVisualizationComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof EntityColliderVisualizationComponent))
    THROW_CCE();
  if (!(this.color.color === other.color.color))
    return false;
  if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
    return false;
  return true;
};
protoOf(EntityColliderVisualizationComponent).hashCode = function () {
  var result = this.color.hashCode();
  result = imul(31, result) + contentHashCode(this.collidingBoundIds) | 0;
  return result;
};
protoOf(EntityColliderVisualizationComponent).tf = function () {
  return this.color;
};
protoOf(EntityColliderVisualizationComponent).uf = function () {
  return this.collidingBoundIds;
};
protoOf(EntityColliderVisualizationComponent).m1m = function () {
  return this.isGenerated;
};
protoOf(EntityColliderVisualizationComponent).d53 = function (color, collidingBoundIds, isGenerated) {
  return new EntityColliderVisualizationComponent(color, collidingBoundIds, isGenerated);
};
protoOf(EntityColliderVisualizationComponent).copy = function (color, collidingBoundIds, isGenerated, $super) {
  color = color === VOID ? this.color : color;
  collidingBoundIds = collidingBoundIds === VOID ? this.collidingBoundIds : collidingBoundIds;
  isGenerated = isGenerated === VOID ? this.isGenerated : isGenerated;
  return this.d53(color, collidingBoundIds, isGenerated);
};
protoOf(EntityColliderVisualizationComponent).toString = function () {
  return 'EntityColliderVisualizationComponent(color=' + this.color.toString() + ', collidingBoundIds=' + toString(this.collidingBoundIds) + ', isGenerated=' + this.isGenerated + ')';
};
function Companion_138() {
  Companion_instance_177 = this;
  this.id = Companion_instance_0.u1p_1;
}
protoOf(Companion_138).n1s = function () {
  return this.id;
};
var Companion_instance_177;
function Companion_getInstance_181() {
  if (Companion_instance_177 == null)
    new Companion_138();
  return Companion_instance_177;
}
function EntityConnectorVisualizationComponent(data) {
  Companion_getInstance_181();
  data = data === VOID ? null : data;
  this.data = data;
  this.e53_1 = Companion_getInstance_181().id;
  this.f53_1 = false;
}
protoOf(EntityConnectorVisualizationComponent).q52 = function () {
  return this.data;
};
protoOf(EntityConnectorVisualizationComponent).p1s = function () {
  return this.e53_1;
};
protoOf(EntityConnectorVisualizationComponent).s1s = function () {
  return this.f53_1;
};
protoOf(EntityConnectorVisualizationComponent).eq = function (other) {
  if (this === other)
    return true;
  if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof EntityConnectorVisualizationComponent))
    THROW_CCE();
  if (!contentEquals(this.data, other.data))
    return false;
  return true;
};
function ConnectorVisualizationData() {
}
function Companion_139() {
}
protoOf(Companion_139).n1s = function () {
  return Companion_instance_0.z1q_1;
};
var Companion_instance_178;
function Companion_getInstance_182() {
  return Companion_instance_178;
}
function PolyhedronVisualizationNodeComponent() {
}
protoOf(PolyhedronVisualizationNodeComponent).p1s = function () {
  return Companion_instance_178.id;
};
protoOf(PolyhedronVisualizationNodeComponent).eq = function (other) {
  return true;
};
function Companion_140() {
}
protoOf(Companion_140).n1s = function () {
  return Companion_instance_0.y1r_1;
};
var Companion_instance_179;
function Companion_getInstance_183() {
  return Companion_instance_179;
}
function VisualizationEntityComponent() {
}
protoOf(VisualizationEntityComponent).p1s = function () {
  return Companion_instance_179.id;
};
protoOf(VisualizationEntityComponent).eq = function (other) {
  return true;
};
function Companion_141() {
  this.ID = 'AutoAdaptHostZoneVisualizationSystem';
}
protoOf(Companion_141).j1y = function () {
  return this.ID;
};
var Companion_instance_180;
function Companion_getInstance_184() {
  return Companion_instance_180;
}
function AutoAdaptHostZoneVisualizationSystem(coreServices) {
  PolyhedronVisualizationSystem.call(this, Companion_instance_180.ID, coreServices);
}
protoOf(AutoAdaptHostZoneVisualizationSystem).getPolyhedron = function (entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_62().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostZone;
};
protoOf(AutoAdaptHostZoneVisualizationSystem).getColor = function (entity, polyhedron) {
  var blue = 0.5 + Default_getInstance().yh(0.3, 0.5);
  return new Color('autoadapthostzone', 0.0, 0.0, blue);
};
function Companion_142() {
  this.ID = 'DragProjectionPointVisualizationSystem';
}
protoOf(Companion_142).j1y = function () {
  return this.ID;
};
var Companion_instance_181;
function Companion_getInstance_185() {
  return Companion_instance_181;
}
function DragProjectionPointVisualizationSystem(coreServices) {
  PolyhedronVisualizationSystem.call(this, Companion_instance_181.ID, coreServices);
}
protoOf(DragProjectionPointVisualizationSystem).getPolyhedron = function (entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_86().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.projectionPoint;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var projectionPoint = tmp;
  return fromSizeAndCenter(__VectorIntConstructorKotlin(50, 50, 50), projectionPoint);
};
protoOf(DragProjectionPointVisualizationSystem).getColor = function (entity, polyhedron) {
  return new Color('dragprojectionpoint', 1.0, 0.0, 0.0);
};
function Companion_143() {
  this.ID = 'FunctionalMarginVisualizationSystem';
}
protoOf(Companion_143).j1y = function () {
  return this.ID;
};
var Companion_instance_182;
function Companion_getInstance_186() {
  return Companion_instance_182;
}
function FunctionalMarginVisualizationSystem(coreServices) {
  PolyhedronVisualizationSystem.call(this, Companion_instance_182.ID, coreServices);
}
protoOf(FunctionalMarginVisualizationSystem).getPolyhedron = function (entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_92().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shape(entity);
};
protoOf(FunctionalMarginVisualizationSystem).getColor = function (entity, polyhedron) {
  var green = Default_getInstance().yh(0.5, 1.0);
  return new Color('functionalmargin', 0.0, green, 0.0);
};
function Companion_144() {
  this.ID = 'FunctionalZoneVisualizationSystem';
}
protoOf(Companion_144).j1y = function () {
  return this.ID;
};
var Companion_instance_183;
function Companion_getInstance_187() {
  return Companion_instance_183;
}
function FunctionalZoneVisualizationSystem(coreServices) {
  PolyhedronVisualizationSystem.call(this, Companion_instance_183.ID, coreServices);
}
protoOf(FunctionalZoneVisualizationSystem).getPolyhedron = function (entity) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_instance_0.l1r_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var functionalZonesComponent = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = functionalZonesComponent.zones;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.FunctionalZoneVisualizationSystem.getPolyhedron.<anonymous>' call
    var tmp$ret$0 = item.polyhedron;
    destination.h(tmp$ret$0);
  }
  var polyhedrons = copyToArray(destination);
  return new PolyhedronGroup(polyhedrons);
};
protoOf(FunctionalZoneVisualizationSystem).getColor = function (entity, polyhedron) {
  var blue = Default_getInstance().yh(0.5, 0.8);
  return new Color('functional zone', 0.9, 0.9, blue);
};
function Companion_145() {
  Companion_instance_184 = this;
  this.id = Companion_instance_0.t1q_1;
}
protoOf(Companion_145).n1s = function () {
  return this.id;
};
var Companion_instance_184;
function Companion_getInstance_188() {
  if (Companion_instance_184 == null)
    new Companion_145();
  return Companion_instance_184;
}
function PolyhedronVisualizationHolderComponent(systemId) {
  Companion_getInstance_188();
  this.systemId = systemId;
  this.e56_1 = Companion_getInstance_188().id;
}
protoOf(PolyhedronVisualizationHolderComponent).f56 = function () {
  return this.systemId;
};
protoOf(PolyhedronVisualizationHolderComponent).p1s = function () {
  return this.e56_1;
};
protoOf(PolyhedronVisualizationHolderComponent).eq = function (other) {
  var tmp0_safe_receiver = other instanceof PolyhedronVisualizationHolderComponent ? other : null;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemId) === this.systemId;
};
protoOf(PolyhedronVisualizationHolderComponent).tf = function () {
  return this.systemId;
};
protoOf(PolyhedronVisualizationHolderComponent).h1t = function (systemId) {
  return new PolyhedronVisualizationHolderComponent(systemId);
};
protoOf(PolyhedronVisualizationHolderComponent).copy = function (systemId, $super) {
  systemId = systemId === VOID ? this.systemId : systemId;
  return this.h1t(systemId);
};
protoOf(PolyhedronVisualizationHolderComponent).toString = function () {
  return 'PolyhedronVisualizationHolderComponent(systemId=' + this.systemId + ')';
};
protoOf(PolyhedronVisualizationHolderComponent).hashCode = function () {
  return getStringHashCode(this.systemId);
};
protoOf(PolyhedronVisualizationHolderComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PolyhedronVisualizationHolderComponent))
    return false;
  var tmp0_other_with_cast = other instanceof PolyhedronVisualizationHolderComponent ? other : THROW_CCE();
  if (!(this.systemId === tmp0_other_with_cast.systemId))
    return false;
  return true;
};
function _get_viewer__pq1i9z_0($this) {
  return $this.h51_1.coreModules.viewer();
}
function createAllVisualizations($this) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.h51_1.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createAllVisualizations.<anonymous>' call
    if (element.hasComponent(Companion_instance_10.id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createAllVisualizations.<anonymous>' call
    createPolyhedronVisualization($this, element_0);
  }
}
function clearVisualizationEntities($this) {
  clearEntityHierarchy($this, $this.h51_1.sceneManager.scene);
}
function hasHolderComponent($this, it) {
  var tmp0_safe_receiver = it.__getComponentForKotlin(Companion_getInstance_188().id);
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemId) === $this.id;
}
function clearEntityHierarchy($this, entity) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_descendants(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.clearEntityHierarchy.<anonymous>' call
    if (hasHolderComponent($this, element)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.clearEntityHierarchy.<anonymous>' call
    var tmp0_safe_receiver = element_0.__getComponentForKotlin(Companion_instance_33.n1s());
    var viewerObject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.viewerObject;
    $this.i51_1.disposeEntity(element_0);
    if (viewerObject == null)
      null;
    else {
      viewerObject.deleteObject();
    }
  }
}
function createPolyhedronVisualization($this, entity) {
  var poly = $this.getPolyhedron(entity);
  if (poly == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
    var tmp0_safe_receiver = _get_viewer__pq1i9z_0($this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var parent = createHolderEntity($this, entity);
      var viewerObject = createPolyhedronVisualization$default($this, tmp0_safe_receiver, poly, parent);
      var tmp1_safe_receiver = get_viewerObject(entity);
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.getVisible()) === false) {
        if (viewerObject == null)
          null;
        else
          viewerObject.setVisible(false);
      }
      if (!(viewerObject == null)) {
        parent.addComponent(new ViewerObjectComponent(viewerObject));
      }
      tmp = Unit_instance;
    }
  }
}
function createHolderEntity($this, entity) {
  var visualizerHolder = $this.i51_1.createEntity();
  setParent(visualizerHolder, entity);
  visualizerHolder.addComponent(new DisplayNameComponent('PolyhedronVisualizerNode[' + $this.id + ']'));
  visualizerHolder.addComponent(new RenderedComponent());
  visualizerHolder.addComponent(new PolyhedronVisualizationHolderComponent($this.id));
  visualizerHolder.addComponent(new PolyhedronVisualizationNodeComponent());
  visualizerHolder.addComponent(new UnserializableEntityComponent());
  visualizerHolder.addComponent(new VisualizationEntityComponent());
  return visualizerHolder;
}
function createPolyhedronVisualization_0($this, viewer, polyhedron, entity, parent) {
  var color = $this.getColor(entity, polyhedron);
  if (polyhedron instanceof ConvexPolyhedron)
    return createPolyhedronVisualization_2($this, viewer, polyhedron, entity, parent, color);
  else {
    if (polyhedron instanceof PolyhedronGroup)
      return createPolyhedronVisualization_1($this, viewer, polyhedron, entity, parent, color);
  }
  return null;
}
function createPolyhedronVisualization$default($this, viewer, polyhedron, entity, parent, $super) {
  parent = parent === VOID ? viewer.createSphere(0.001) : parent;
  return createPolyhedronVisualization_0($this, viewer, polyhedron, entity, parent);
}
function createPolyhedronVisualization_1($this, viewer, polyhedron, entity, parent, color) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = polyhedron.polyhedra;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
    if (element instanceof ConvexPolyhedron) {
      createPolyhedronVisualization_2($this, viewer, element, entity, parent, color);
    }
  }
  return parent;
}
function createPolyhedronVisualization_2($this, viewer, polyhedron, entity, parent, color) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (polyhedron.vertices.length === 0)
    return null;
  var vertices = polyhedron.vertices;
  // Inline function 'kotlin.collections.map' call
  var this_0 = polyhedron.faces;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.indices;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(this_1.length);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>.<anonymous>' call
      var tmp$ret$1 = vertices[item_0];
      destination_0.h(tmp$ret$1);
    }
    var tmp$ret$5 = copyToArray(destination_0);
    destination.h(tmp$ret$5);
  }
  var vectorFaces = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(vectorFaces, 10));
  var tmp0_iterator = vectorFaces.k();
  while (tmp0_iterator.m()) {
    var item_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
    var normal = Companion_getInstance_18().a2i(item_1);
    var viewerObject = viewer.createSurface(item_1, normal, entity);
    viewerObject.setBaseColor(color.r, color.g, color.b);
    setTransparency($this, viewerObject);
    destination_1.h(viewerObject);
  }
  var viewerObjects = destination_1;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$11 = copyToArray(viewerObjects);
  var group = viewer.groupMeshes(tmp$ret$11, entity);
  group.setParent(parent);
  return parent;
}
function setTransparency($this, viewerObject) {
  return viewerObject.setTransparency($this.alpha);
}
function PolyhedronVisualizationSystem(id, coreServices) {
  SystemBase3.call(this, id, Companion_instance_10.id, Companion_getInstance_38().ID, Companion_instance_34.id);
  this.h51_1 = coreServices;
  this.i51_1 = this.h51_1.entityManager;
  this.alpha = 0.8;
  this.colorRandomizationAmount = 0.5;
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.j51_1 = [];
}
protoOf(PolyhedronVisualizationSystem).m53 = function (_set____db54di) {
  this.alpha = _set____db54di;
};
protoOf(PolyhedronVisualizationSystem).n53 = function () {
  return this.alpha;
};
protoOf(PolyhedronVisualizationSystem).o53 = function (_set____db54di) {
  this.colorRandomizationAmount = _set____db54di;
};
protoOf(PolyhedronVisualizationSystem).p53 = function () {
  return this.colorRandomizationAmount;
};
protoOf(PolyhedronVisualizationSystem).enable = function () {
  if (this.isEnabled)
    return Unit_instance;
  protoOf(SystemBase3).enable.call(this);
  createAllVisualizations(this);
};
protoOf(PolyhedronVisualizationSystem).disable = function () {
  if (!this.isEnabled)
    return Unit_instance;
  protoOf(SystemBase3).disable.call(this);
  clearVisualizationEntities(this);
};
protoOf(PolyhedronVisualizationSystem).j1w = function () {
  return this.j51_1;
};
protoOf(PolyhedronVisualizationSystem).t32 = function (entity, newComponent) {
  createPolyhedronVisualization(this, entity);
};
protoOf(PolyhedronVisualizationSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).u32 = function (entity, oldComponent, newComponent) {
  createPolyhedronVisualization(this, entity);
};
protoOf(PolyhedronVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.u32(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).v32 = function (entity, oldComponent) {
  clearEntityHierarchy(this, entity);
};
protoOf(PolyhedronVisualizationSystem).z1v = function (entity, oldComponent) {
  return this.v32(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).q53 = function (entity, newComponent) {
  createAllVisualizations(this);
};
protoOf(PolyhedronVisualizationSystem).l1z = function (entity, newComponent) {
  return this.q53(entity, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).r53 = function (entity, oldComponent, newComponent) {
  this.s53(entity, oldComponent);
  this.q53(entity, newComponent);
};
protoOf(PolyhedronVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE();
  return this.r53(entity, tmp, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).s53 = function (entity, oldComponent) {
  clearVisualizationEntities(this);
};
protoOf(PolyhedronVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.s53(entity, oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).t53 = function (entity, newComponent) {
  clearVisualizationEntities(this);
};
protoOf(PolyhedronVisualizationSystem).n2m = function (entity, newComponent) {
  return this.t53(entity, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).u53 = function (entity, oldComponent, newComponent) {
};
protoOf(PolyhedronVisualizationSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE();
  return this.u53(entity, tmp, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(PolyhedronVisualizationSystem).v53 = function (entity, oldComponent) {
  clearVisualizationEntities(this);
  createAllVisualizations(this);
};
protoOf(PolyhedronVisualizationSystem).p2m = function (entity, oldComponent) {
  return this.v53(entity, oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE());
};
function Companion_146() {
  this.ID = 'ColliderVisualizationSystem';
}
protoOf(Companion_146).j1y = function () {
  return this.ID;
};
protoOf(Companion_146).createEntityColliderVisualizationComponent = function () {
  return new EntityColliderVisualizationComponent(VOID, VOID, true);
};
var Companion_instance_185;
function Companion_getInstance_189() {
  return Companion_instance_185;
}
function ColliderVisualizationSystem(coreServices) {
  ForcedComponentBaseSystem.call(this, Companion_instance_185.ID, Companion_instance_0.v1p_1, Companion_instance_185.createEntityColliderVisualizationComponent(), coreServices);
  this.u56_1.addComponent(new ColliderVisualizationConfigComponent(false));
  this.enable();
}
protoOf(ColliderVisualizationSystem).m57 = function (value) {
  var wasEnabled = this.isEnabled;
  this.disable();
  this.u56_1.addComponent(new ColliderVisualizationConfigComponent(value));
  if (wasEnabled) {
    this.enable();
  }
};
protoOf(ColliderVisualizationSystem).j52 = function () {
  return this.u56_1.getComponentUnsafe(Companion_getInstance_173().id).includeRoom;
};
protoOf(ColliderVisualizationSystem).n57 = function (entity) {
  return get_isRoom(entity) && !this.includeRoom ? false : get_isRoomPart(entity) && !this.includeRoom ? false : entity.hasComponent(Companion_instance_170.id) ? false : !get_isInScene(entity) ? false : true;
};
function ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1($showActivationDistance, $showTransform) {
  this.t57_1 = '';
  this.u57_1 = '';
  this.v57_1 = false;
  this.w57_1 = true;
  this.x57_1 = false;
  var tmp = this;
  tmp.y57_1 = $showActivationDistance == null ? false : $showActivationDistance;
  var tmp_0 = this;
  tmp_0.z57_1 = $showTransform == null ? false : $showTransform;
}
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).w2g = function () {
  return this.t57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).g53 = function () {
  return this.u57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).h53 = function () {
  return this.v57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).i53 = function () {
  return this.w57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).j53 = function () {
  return this.x57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).k53 = function () {
  return this.y57_1;
};
protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).l53 = function () {
  return this.z57_1;
};
function setEnabledFeatures($this, activationDistanceActivate, transformActivate) {
  $this.q57(Companion_instance_186.createEntityConnectorVisualizationComponent(activationDistanceActivate, transformActivate));
}
function Companion_147() {
  this.ID = 'ConnectorVisualizationSystem';
}
protoOf(Companion_147).j1y = function () {
  return this.ID;
};
protoOf(Companion_147).a58 = function (showActivationDistance, showTransform) {
  var data = new ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1(showActivationDistance, showTransform);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [data];
  return new EntityConnectorVisualizationComponent(tmp$ret$2);
};
protoOf(Companion_147).createEntityConnectorVisualizationComponent = function (showActivationDistance, showTransform, $super) {
  showActivationDistance = showActivationDistance === VOID ? null : showActivationDistance;
  showTransform = showTransform === VOID ? null : showTransform;
  return this.a58(showActivationDistance, showTransform);
};
var Companion_instance_186;
function Companion_getInstance_190() {
  return Companion_instance_186;
}
function ConnectorVisualizationSystem(coreServices) {
  ForcedComponentBaseSystem.call(this, Companion_instance_186.ID, Companion_instance_0.u1p_1, Companion_instance_186.createEntityConnectorVisualizationComponent(), coreServices);
  this.r58_1 = coreServices.entityManager;
  this.u56_1.addComponent(new ConnectorVisualizationConfigComponent(false));
  this.enable();
}
protoOf(ConnectorVisualizationSystem).m57 = function (value) {
  var wasEnabled = this.isEnabled;
  this.disable();
  this.u56_1.addComponent(new ConnectorVisualizationConfigComponent(value));
  if (wasEnabled) {
    this.enable();
  }
};
protoOf(ConnectorVisualizationSystem).j52 = function () {
  return this.u56_1.getComponentUnsafe(Companion_getInstance_176().id).includeRoom;
};
protoOf(ConnectorVisualizationSystem).n57 = function (entity) {
  return get_isRoom(entity) && !this.includeRoom ? false : get_isRoomPart(entity) && !this.includeRoom ? false : entity.hasComponent(Companion_instance_173.id) ? false : !get_isInScene(entity) ? false : true;
};
protoOf(ConnectorVisualizationSystem).s58 = function (value) {
  setEnabledFeatures(this, value, this.connectorTransformVisualizationEnabled);
};
protoOf(ConnectorVisualizationSystem).b52 = function () {
  var tmp0_safe_receiver = this.s57(Companion_getInstance_181().id).data;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[0];
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.showActivationDistance;
  return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
};
protoOf(ConnectorVisualizationSystem).t58 = function (value) {
  setEnabledFeatures(this, this.connectorActivationDistanceVisualizationEnabled, value);
};
protoOf(ConnectorVisualizationSystem).c52 = function () {
  var tmp0_safe_receiver = this.s57(Companion_getInstance_181().id).data;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[0];
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.showTransform;
  return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
};
function generateColliderShapeBounds($this, entity, ids, polyhedron, colliderVisualizer, color, collidingBoundIds) {
  var tmp;
  if (polyhedron instanceof ConvexPolyhedron) {
    var tmp_0 = ids[0];
    var tmp1_safe_receiver = get_viewerObject(entity);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.getScale();
    var tmp3_safe_receiver = createVisualization($this, entity, tmp_0, polyhedron, colliderVisualizer, tmp2_elvis_lhs == null ? Companion_getInstance_15().ONE : tmp2_elvis_lhs, color, collidingBoundIds);
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
      var id = tmp3_safe_receiver.tf();
      var viewerObject = tmp3_safe_receiver.uf();
      tmp_1 = mapOf(to(id, viewerObject));
    }
    var tmp4_elvis_lhs = tmp_1;
    tmp = tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs;
  } else {
    if (polyhedron instanceof PolyhedronGroup) {
      // Inline function 'kotlin.collections.associate' call
      // Inline function 'kotlin.collections.mapIndexedNotNull' call
      // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
      var this_0 = polyhedron.polyhedra;
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var item = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
        var tmp_2;
        var tmp_3;
        if (item instanceof ConvexPolyhedron) {
          tmp_3 = ids.length > tmp1;
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          var tmp_4 = Companion_instance_187;
          var tmp_5 = ids[tmp1];
          var tmp0_safe_receiver = get_viewerObject(entity);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getScale();
          tmp_2 = createVisualization(tmp_4, entity, tmp_5, item, colliderVisualizer, tmp1_elvis_lhs == null ? Companion_getInstance_15().ONE : tmp1_elvis_lhs, color, collidingBoundIds);
        } else {
          throw Error_init_$Create$('Unsupported collider type or no id');
        }
        var tmp0_safe_receiver_0 = tmp_2;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = destination.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
        var id_0 = element.tf();
        var viewerObject_0 = element.uf();
        var pair = to(id_0, viewerObject_0);
        destination_0.q2(pair.rf_1, pair.sf_1);
      }
      tmp = destination_0;
    } else {
      tmp = emptyMap();
    }
  }
  return tmp;
}
function createVisualization($this, entity, id, polyhedron, colliderVisualizer, scale, color, collidingBoundIds) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (polyhedron.vertices.length === 0)
    return null;
  var tmp0_safe_receiver = colliderVisualizer.createColliderVisualization(entity, polyhedron, color, contains(collidingBoundIds, id));
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    tmp0_safe_receiver.setScale(1.0 / scale.X, 1.0 / scale.Y, 1.0 / scale.Z);
    tmp0_safe_receiver.setVisible(true);
    return new Pair(id, tmp0_safe_receiver);
  }
  return tmp;
}
function _get_sceneManager__lxhb6y_0($this) {
  return $this.coreServices.sceneManager;
}
function hasNoVisualization($this, entity) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.hasNoVisualization.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_175().id)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return !tmp$ret$1;
}
function hasNewVisualizationData($this, entity, colliderVisualizationData) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.hasNewVisualizationData.<anonymous>' call
      var result = _get_colliderVisualizationNode__i436cf(element, $this);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var currentVisualizationNodeData = tmp$ret$1;
  var newVisualizationNodeData = generateNodeData($this, entity, colliderVisualizationData.color, colliderVisualizationData.collidingBoundIds);
  return !newVisualizationNodeData.equals(currentVisualizationNodeData);
}
function generateNodeData($this, entity, color, collidingBoundIds) {
  return new ColliderVisualizationNodeComponent(entity, color, collidingBoundIds);
}
function addDecoration($this, entity, polyhedron, ids, color, collidingBoundIds) {
  var visualizerHolder = $this.i59_1.createEntity();
  visualizerHolder.addComponent(generateNodeData($this, entity, color, collidingBoundIds));
  visualizerHolder.addComponent(new UnserializableEntityComponent());
  visualizerHolder.addComponent(new DisplayNameComponent('ColliderVisualizerNode'));
  visualizerHolder.addComponent(new RenderedComponent());
  visualizerHolder.addComponent(new VisualizationEntityComponent());
  setParent(visualizerHolder, entity);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var viewerObjects = LinkedHashMap_init_$Create$();
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(ids.length === 0)) {
    var parent = $this.colliderVisualizer.createParent(visualizerHolder);
    if (parent == null)
      null;
    else {
      parent.registerInputEvents();
    }
    var polyhedronDecorator = generateColliderShapeBounds(Companion_instance_187, visualizerHolder, ids, polyhedron, $this.colliderVisualizer, color, collidingBoundIds);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = polyhedronDecorator.i2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.addDecoration.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var id = element.b2();
      // Inline function 'kotlin.collections.component2' call
      var viewerObject = element.c2();
      viewerObject.registerInputEvents();
      viewerObject.setParent(parent);
      // Inline function 'kotlin.collections.set' call
      viewerObjects.q2(id, viewerObject);
    }
    visualizerHolder.addComponent(new ColliderVisualizerViewerObjectsComponent(viewerObjects));
    tmp = parent;
  } else {
    $this.i59_1.disposeEntity(visualizerHolder);
    tmp = null;
  }
  var viewerObject_0 = tmp;
  if (viewerObject_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.addDecoration.<anonymous>' call
    visualizerHolder.addComponent(new ViewerObjectComponent(viewerObject_0));
  }
}
function updateDecoration($this, entity, polyhedron, ids, color, collidingBoundIds) {
  removeDecoration($this, entity);
  addDecoration($this, entity, polyhedron, ids, color, collidingBoundIds);
}
function findVisualizerHolder($this, entity) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_children(entity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.findVisualizerHolder.<anonymous>' call
      if (element.hasComponent(Companion_instance_170.id)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function removeDecoration($this, entity) {
  var holder = findVisualizerHolder($this, entity);
  var tmp1_safe_receiver = holder == null ? null : holder.__getComponentForKotlin(Companion_instance_33.n1s());
  var viewerObject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObject;
  if (holder == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.i59_1.disposeEntity(holder);
  }
  if (viewerObject == null)
    null;
  else {
    viewerObject.deleteObject();
  }
}
function componentsChanged($this, entity) {
  var colliderComponent = entity.__getComponentForKotlin(Companion_getInstance_19().id);
  var visualizationComponent = entity.__getComponentForKotlin(Companion_getInstance_180().id);
  if (!(visualizationComponent == null) && !(colliderComponent == null)) {
    var tmp0_elvis_lhs = colliderComponent.ids;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    updateDecoration($this, entity, colliderComponent.polyhedron, tmp, visualizationComponent.color, visualizationComponent.collidingBoundIds);
  } else {
    removeDecoration($this, entity);
  }
}
function updateColors($this, entity, color, collidingBoundIds) {
  var holder = findVisualizerHolder($this, entity);
  var tmp1_safe_receiver = holder == null ? null : holder.__getComponentForKotlin(Companion_getInstance_175().id);
  var viewerObjects = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObjets;
  if (viewerObjects == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = viewerObjects.i2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.updateColors.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var id = element.b2();
      // Inline function 'kotlin.collections.component2' call
      var viewerObject = element.c2();
      if (contains(collidingBoundIds, id)) {
        $this.colliderVisualizer.indicateCollision(viewerObject);
      } else if (!(color == null)) {
        $this.colliderVisualizer.setColor(viewerObject, color);
      }
    }
  }
}
function _get_colliderVisualizationNode__i436cf(_this__u8e3s4, $this) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_instance_170.id);
}
function Companion_148() {
  this.ID = 'EntityColliderVisualizationSystem';
}
protoOf(Companion_148).j1y = function () {
  return this.ID;
};
var Companion_instance_187;
function Companion_getInstance_191() {
  return Companion_instance_187;
}
function EntityColliderVisualizationSystem(coreServices, colliderVisualizer) {
  var tmp = Companion_instance_187.ID;
  var tmp_0 = Companion_instance_0.p1n_1;
  var tmp_1 = Companion_instance_0.v1p_1;
  var tmp_2 = Companion_getInstance_38().ID;
  var tmp_3 = Companion_instance_34.id;
  var tmp_4 = Companion_getInstance_11().q3e_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp_5 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp_6 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$2 = [];
  SystemBase5.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$2);
  this.coreServices = coreServices;
  this.colliderVisualizer = colliderVisualizer;
  this.i59_1 = this.coreServices.entityManager;
  this.enable();
}
protoOf(EntityColliderVisualizationSystem).j3t = function () {
  return this.coreServices;
};
protoOf(EntityColliderVisualizationSystem).j59 = function (_set____db54di) {
  this.colliderVisualizer = _set____db54di;
};
protoOf(EntityColliderVisualizationSystem).k59 = function () {
  return this.colliderVisualizer;
};
protoOf(EntityColliderVisualizationSystem).l59 = function (entity, newComponent) {
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).n2m = function (entity, newComponent) {
  return this.l59(entity, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).m59 = function (entity, oldComponent, newComponent) {
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE();
  return this.m59(entity, tmp, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).n59 = function (entity, oldComponent) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_hierarchy(_get_sceneManager__lxhb6y_0(this).root);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.onRemoveComponent3.<anonymous>' call
    if (!element.hasComponent(Companion_instance_170.id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.onRemoveComponent3.<anonymous>' call
    removeDecoration(this, element_0);
  }
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).p2m = function (entity, oldComponent) {
  return this.n59(entity, oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).o59 = function (entity, newComponent) {
  var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_instance_170.id);
  var wasAColliderVisualizationNode = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  if (!wasAColliderVisualizationNode) {
    return Unit_instance;
  }
  var newEntity = newComponent.entity;
  var newData = newEntity == null ? null : newEntity.__getComponentForKotlin(Companion_instance_170.id);
  var entityWasRemoved = newEntity == null;
  var shouldRemoveVisualization = newData == null;
  if (entityWasRemoved || shouldRemoveVisualization) {
    var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_33.n1s());
    var oldParentViewerObject = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.viewerObject;
    if (oldParentViewerObject == null)
      null;
    else {
      oldParentViewerObject.deleteObject();
    }
  }
};
protoOf(EntityColliderVisualizationSystem).y2n = function (entity, newComponent) {
  return this.o59(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).p59 = function (entity, oldComponent, newComponent) {
};
protoOf(EntityColliderVisualizationSystem).z2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.p59(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).q59 = function (entity, oldComponent) {
};
protoOf(EntityColliderVisualizationSystem).a2o = function (entity, oldComponent) {
  return this.q59(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).r59 = function (entity, newComponent) {
};
protoOf(EntityColliderVisualizationSystem).d2n = function (entity, newComponent) {
  return this.r59(entity, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).s59 = function (entity, oldComponent, newComponent) {
};
protoOf(EntityColliderVisualizationSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE();
  return this.s59(entity, tmp, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).t59 = function (entity, oldComponent) {
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).f2n = function (entity, oldComponent) {
  return this.t59(entity, oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).enable = function () {
  protoOf(SystemBase5).enable.call(this);
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).disable = function () {
  protoOf(SystemBase5).disable.call(this);
  this.refresh();
};
protoOf(EntityColliderVisualizationSystem).refresh = function () {
  if (this.isEnabled) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_0(this).root).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
      var colliderVisualizationData = element.__getComponentForKotlin(Companion_getInstance_180().id);
      var colliderComponent = element.__getComponentForKotlin(Companion_getInstance_19().id);
      if (!(colliderVisualizationData == null) && !(colliderComponent == null)) {
        if (hasNoVisualization(this, element) || hasNewVisualizationData(this, element, colliderVisualizationData)) {
          var tmp0_elvis_lhs = colliderComponent.ids;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.emptyArray' call
            tmp = [];
          } else {
            tmp = tmp0_elvis_lhs;
          }
          updateDecoration(this, element, colliderComponent.polyhedron, tmp, colliderVisualizationData.color, colliderVisualizationData.collidingBoundIds);
        }
      } else {
        removeDecoration(this, element);
      }
    }
  } else {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.i59_1.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element_0 = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
      if (!element_0.hasComponent(Companion_instance_170.id)) {
        destination.h(element_0);
      }
    }
    var tmp0_iterator_0 = destination.k();
    while (tmp0_iterator_0.m()) {
      var element_1 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
      removeDecoration(this, element_1);
    }
  }
};
protoOf(EntityColliderVisualizationSystem).setVisualizer = function (colliderVisualizer) {
  this.colliderVisualizer = colliderVisualizer;
};
protoOf(EntityColliderVisualizationSystem).l41 = function (entity, newComponent) {
  if (entity.hasComponent(Companion_getInstance_180().id) && get_isInScene(entity)) {
    componentsChanged(this, entity);
  }
};
protoOf(EntityColliderVisualizationSystem).v1v = function (entity, newComponent) {
  return this.l41(entity, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).m41 = function (entity, oldComponent, newComponent) {
  if (entity.hasComponent(Companion_getInstance_180().id) && get_isInScene(entity)) {
    componentsChanged(this, entity);
  }
};
protoOf(EntityColliderVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE();
  return this.m41(entity, tmp, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).n41 = function (entity, oldComponent) {
  removeDecoration(this, entity);
};
protoOf(EntityColliderVisualizationSystem).z1v = function (entity, oldComponent) {
  return this.n41(entity, oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).u59 = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    componentsChanged(this, entity);
  }
};
protoOf(EntityColliderVisualizationSystem).l1z = function (entity, newComponent) {
  return this.u59(entity, newComponent instanceof EntityColliderVisualizationComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).v59 = function (entity, oldComponent, newComponent) {
  if (get_isInScene(entity)) {
    updateColors(this, entity, newComponent.color, newComponent.collidingBoundIds);
  }
};
protoOf(EntityColliderVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof EntityColliderVisualizationComponent ? oldComponent : THROW_CCE();
  return this.v59(entity, tmp, newComponent instanceof EntityColliderVisualizationComponent ? newComponent : THROW_CCE());
};
protoOf(EntityColliderVisualizationSystem).w59 = function (entity, oldComponent) {
  removeDecoration(this, entity);
};
protoOf(EntityColliderVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.w59(entity, oldComponent instanceof EntityColliderVisualizationComponent ? oldComponent : THROW_CCE());
};
function Companion_149() {
  Companion_instance_188 = this;
  this.ID = Companion_instance_0.a1n_1;
}
protoOf(Companion_149).j1y = function () {
  return this.ID;
};
var Companion_instance_188;
function Companion_getInstance_192() {
  if (Companion_instance_188 == null)
    new Companion_149();
  return Companion_instance_188;
}
function CollisionVisualizationSceneDataComponent(data) {
  Companion_getInstance_192();
  this.data = data;
}
protoOf(CollisionVisualizationSceneDataComponent).q52 = function () {
  return this.data;
};
protoOf(CollisionVisualizationSceneDataComponent).p1s = function () {
  return Companion_getInstance_192().ID;
};
protoOf(CollisionVisualizationSceneDataComponent).eq = function (other) {
  return equals(this.data, (other instanceof CollisionVisualizationSceneDataComponent ? other : THROW_CCE()).data);
};
function CollisionVisualizationSceneData(collisionMap) {
  var tmp;
  if (collisionMap === VOID) {
    // Inline function 'kotlin.collections.mapOf' call
    tmp = emptyMap();
  } else {
    tmp = collisionMap;
  }
  collisionMap = tmp;
  this.collisionMap = collisionMap;
}
protoOf(CollisionVisualizationSceneData).x59 = function (_set____db54di) {
  this.collisionMap = _set____db54di;
};
protoOf(CollisionVisualizationSceneData).y59 = function () {
  return this.collisionMap;
};
function _get_sceneManager__lxhb6y_1($this) {
  return $this.coreServices.sceneManager;
}
function _get_collisionData__2ruset($this) {
  var tmp0_safe_receiver = _get_sceneManager__lxhb6y_1($this).scene.__getComponentForKotlin(Companion_getInstance_192().ID);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.data;
}
function detectCollision($this, entity) {
  var tmp0_elvis_lhs = _get_collisionData__2ruset($this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var data = tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = get_hierarchySequence(entity).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_31().id)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var map = LinkedHashMap_init_$Create$();
    var newCollisions = Companion_instance_192.l5a(entity, get_hierarchySequence(_get_sceneManager__lxhb6y_1($this).root));
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(newCollisions.length);
    var inductionVariable = 0;
    var last = newCollisions.length;
    while (inductionVariable < last) {
      var item = newCollisions[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
      var tmp$ret$3 = item.boundId;
      destination.h(tmp$ret$3);
    }
    var value = copyToArray(destination);
    map.q2(entity, value);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = newCollisions.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = newCollisions[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var key = element_0.otherEntity;
      var tmp0_safe_receiver = map.f2(element_0.otherEntity);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$10 = [element_0.otherBoundId];
        tmp_0 = tmp0_safe_receiver.concat(tmp$ret$10);
      }
      var tmp1_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = [element_0.otherBoundId];
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var value_0 = tmp_1;
      map.q2(key, value_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = data.collisionMap.i2().k();
    while (tmp0_iterator_0.m()) {
      var element_1 = tmp0_iterator_0.n();
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key_0 = element_1.b2();
        if (key_0.isDisposed || key_0.equals(entity)) {
          break $l$block_0;
        }
        // Inline function 'kotlin.collections.set' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = Companion_instance_192.l5a(key_0, get_hierarchySequence(_get_sceneManager__lxhb6y_1($this).root));
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(this_0.length);
        var inductionVariable_1 = 0;
        var last_1 = this_0.length;
        while (inductionVariable_1 < last_1) {
          var item_0 = this_0[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>.<anonymous>' call
          var tmp$ret$18 = item_0.boundId;
          destination_0.h(tmp$ret$18);
        }
        var value_1 = copyToArray(destination_0);
        map.q2(key_0, value_1);
      }
    }
    data.collisionMap = map;
    applyCollisions($this);
  }
}
function applyCollisions($this) {
  var tmp0_elvis_lhs = _get_collisionData__2ruset($this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var data = tmp;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = data.collisionMap.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.applyCollisions.<anonymous>' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(element.c2().length === 0)) {
      addColliderVisualizationComponent($this, element.b2(), element.c2());
    } else {
      clearCollision($this, element.b2());
    }
  }
  var tmp_0 = data;
  // Inline function 'kotlin.collections.filterValues' call
  var this_0 = data.collisionMap;
  var result = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = this_0.i2().k();
  while (tmp0_iterator_0.m()) {
    var entry = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.applyCollisions.<anonymous>' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(entry.c2().length === 0)) {
      result.q2(entry.b2(), entry.c2());
    }
  }
  tmp_0.collisionMap = result;
}
function clearCollisions($this) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_1($this).root).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.clearCollisions.<anonymous>' call
    clearCollision($this, element);
  }
}
function clearCollision($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_instance_0.v1p_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(tmp0_safe_receiver.collidingBoundIds.length === 0)) {
      entity.addComponent(new EntityColliderVisualizationComponent(tmp0_safe_receiver.color));
    }
  }
  var tmp1_elvis_lhs = _get_collisionData__2ruset($this);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var data = tmp;
  var tmp_0 = data;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = data.collisionMap;
  var destination = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.clearCollision.<anonymous>' call
    if (!element.b2().equals(entity)) {
      destination.q2(element.b2(), element.c2());
    }
  }
  tmp_0.collisionMap = destination;
}
function addColliderVisualizationComponent($this, entity, boundIds) {
  var component = entity.__getComponentForKotlin(Companion_getInstance_180().id);
  if (component == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.addColliderVisualizationComponent.<anonymous>' call
    entity.addComponent(new EntityColliderVisualizationComponent(component.color, boundIds));
  }
}
function Companion_150() {
  this.ID = 'EntityCollisionVisualizationSystem';
}
protoOf(Companion_150).j1y = function () {
  return this.ID;
};
var Companion_instance_189;
function Companion_getInstance_193() {
  return Companion_instance_189;
}
function EntityCollisionVisualizationSystem(coreServices) {
  var tmp = Companion_instance_189.ID;
  var tmp_0 = Companion_instance_0.p1n_1;
  var tmp_1 = Companion_instance_0.m1p_1;
  var tmp_2 = Companion_instance_0.b1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = [Companion_getInstance_180().id];
  // Inline function 'kotlin.emptyArray' call
  var tmp_4 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$4 = [];
  SystemBase3.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$4);
  this.coreServices = coreServices;
  this.enable();
}
protoOf(EntityCollisionVisualizationSystem).j3t = function () {
  return this.coreServices;
};
protoOf(EntityCollisionVisualizationSystem).enable = function () {
  protoOf(SystemBase3).enable.call(this);
  _get_sceneManager__lxhb6y_1(this).scene.addComponent(new CollisionVisualizationSceneDataComponent(new CollisionVisualizationSceneData()));
  // Inline function 'kotlin.sequences.forEach' call
  var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_1(this).root).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.enable.<anonymous>' call
    detectCollision(this, element);
  }
};
protoOf(EntityCollisionVisualizationSystem).disable = function () {
  protoOf(SystemBase3).disable.call(this);
  _get_sceneManager__lxhb6y_1(this).scene.removeComponent(Companion_getInstance_192().ID);
  clearCollisions(this);
};
protoOf(EntityCollisionVisualizationSystem).l41 = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    detectCollision(this, entity);
  }
};
protoOf(EntityCollisionVisualizationSystem).v1v = function (entity, newComponent) {
  return this.l41(entity, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).m41 = function (entity, oldComponent, newComponent) {
  if (get_isInScene(entity)) {
    detectCollision(this, entity);
  }
};
protoOf(EntityCollisionVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE();
  return this.m41(entity, tmp, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).n5a = function (entity, newComponent) {
  detectCollision(this, newComponent.dragState.draggedRootEntity);
};
protoOf(EntityCollisionVisualizationSystem).l1z = function (entity, newComponent) {
  return this.n5a(entity, newComponent instanceof DragStateComponent ? newComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).o5a = function (entity, oldComponent, newComponent) {
  detectCollision(this, newComponent.dragState.draggedRootEntity);
};
protoOf(EntityCollisionVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof DragStateComponent ? oldComponent : THROW_CCE();
  return this.o5a(entity, tmp, newComponent instanceof DragStateComponent ? newComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).p5a = function (entity, oldComponent) {
  detectCollision(this, oldComponent.dragState.draggedRootEntity);
};
protoOf(EntityCollisionVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.p5a(entity, oldComponent instanceof DragStateComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).q5a = function (entity, newComponent) {
  if (entity.hasComponent(SceneComponent_instance.id)) {
    entity.addComponent(new CollisionVisualizationSceneDataComponent(new CollisionVisualizationSceneData()));
    entity.addComponent(new VisualizationEntityComponent());
    return Unit_instance;
  }
  detectCollision(this, entity);
};
protoOf(EntityCollisionVisualizationSystem).n2m = function (entity, newComponent) {
  return this.q5a(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(EntityCollisionVisualizationSystem).r5a = function (entity, oldComponent, newComponent) {
  detectCollision(this, entity);
};
protoOf(EntityCollisionVisualizationSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.r5a(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
function generateConnectorsDecorator($this, entity, connectorVisualizer, offersFilter, demandsFilter, visualizationData) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_instance_0.h1n_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>' call
    var filteredConnectors = getFilteredEnabledConnectors(Companion_getInstance_194(), tmp0_safe_receiver.i1l_1, offersFilter, demandsFilter);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = filteredConnectors.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>' call
      var tmp_0;
      if (visualizationData == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable = 0;
          var last = visualizationData.length;
          while (inductionVariable < last) {
            var element_0 = visualizationData[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            if (element_0.connectorKey === element.key) {
              tmp$ret$1 = element_0;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = visualizationData.length;
            while (inductionVariable_0 < last_0) {
              var element_1 = visualizationData[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              if (element_1.connectorKey === '') {
                tmp$ret$3 = element_1;
                break $l$block_0;
              }
            }
            tmp$ret$3 = null;
          }
          tmp_1 = tmp$ret$3;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp_0 = tmp_1;
      }
      var data = tmp_0;
      var c = createConnectorViewerObject(Companion_getInstance_194(), entity, connectorVisualizer, element, data);
      var tmp0_safe_receiver_0 = !(c == null) ? to(element.key, c) : null;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_0);
      }
    }
    tmp = toMutableMap(toMap(destination));
  }
  var tmp1_elvis_lhs = tmp;
  var map = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  return map;
}
function createConnectorViewerObject($this, entity, connectorVisualizer, connector, data) {
  var tmp;
  if (connector instanceof PointConnector) {
    tmp = connectorVisualizer.createPointConnector(entity, connector, connector.z2e_1.position, data);
  } else {
    if (connector instanceof PointSeriesConnector) {
      tmp = connectorVisualizer.createPointSeriesConnector(entity, connector, data);
    } else {
      if (connector instanceof SurfaceConnector) {
        tmp = connectorVisualizer.createSurfaceConnector(entity, connector, data);
      } else {
        if (connector instanceof EdgeConnector) {
          tmp = connectorVisualizer.createEdgeConnector(entity, connector, $this.t50_1, data);
        } else {
          tmp = connectorVisualizer.createUnknown(entity, connector, data);
        }
      }
    }
  }
  var viewerObject = tmp;
  if (viewerObject == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.Companion.createConnectorViewerObject.<anonymous>' call
    viewerObject.setVisible(true);
  }
  var tmp2_safe_receiver = connectorVisualizer.createTransform(entity, connector, data);
  if (tmp2_safe_receiver == null)
    null;
  else
    tmp2_safe_receiver.setParent(viewerObject);
  return viewerObject;
}
function getFilteredEnabledConnectors($this, enabledConnectors, offersFilter, demandsFilter) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = enabledConnectors.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>' call
    var tmp;
    if (offersFilter == null) {
      tmp = true;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var inductionVariable = 0;
        var last = offersFilter.length;
        while (inductionVariable < last) {
          var element_0 = offersFilter[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>.<anonymous>' call
          if (contains(element.offers(), element_0)) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      tmp = tmp$ret$1;
    }
    if (tmp) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>' call
    var tmp_0;
    if (demandsFilter == null) {
      tmp_0 = true;
    } else {
      var tmp$ret$6;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var inductionVariable_0 = 0;
        var last_0 = demandsFilter.length;
        while (inductionVariable_0 < last_0) {
          var element_2 = demandsFilter[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>.<anonymous>' call
          if (contains(element_1.demands(), element_2)) {
            tmp$ret$6 = true;
            break $l$block_0;
          }
        }
        tmp$ret$6 = false;
      }
      tmp_0 = tmp$ret$6;
    }
    if (tmp_0) {
      destination_0.h(element_1);
    }
  }
  return destination_0;
}
function EntityConnectorVisualizationSystem$Companion$runOnDecoratable$lambda(entity, runner) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_5().id);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.Companion.runOnDecoratable.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver_0 = entity.__getComponentForKotlin(Companion_getInstance_181().id);
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.runOnDecoratable.<anonymous>.<anonymous>.<anonymous>' call
      runner(tmp0_safe_receiver, tmp0_safe_receiver_0);
      tmp_0 = entity;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function hasNoVisualization_0($this, entity) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.hasNoVisualization.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_178().id)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return !tmp$ret$1;
}
function hasNewVisualizationData_0($this, entity, connectorVisualizationData) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.hasNewVisualizationData.<anonymous>' call
      var result = _get_connectorVisualizationNode__spb9ou(element, $this);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var currentVisualizationNodeData = tmp$ret$1;
  var newVisualizationNodeData = generateNodeData_0($this, entity, connectorVisualizationData.data);
  return !newVisualizationNodeData.equals(currentVisualizationNodeData);
}
function generateNodeData_0($this, entity, data) {
  return new ConnectorVisualizationNodeComponent(entity, data, $this.i5b_1, $this.j5b_1);
}
function addDecoration_0($this, entity, visualizationHolder, data) {
  visualizationHolder.addComponent(generateNodeData_0($this, entity, data));
  visualizationHolder.addComponent(new DisplayNameComponent('ConnectorVisualizerNode'));
  visualizationHolder.addComponent(new RenderedComponent());
  visualizationHolder.addComponent(new UnserializableEntityComponent());
  visualizationHolder.addComponent(new VisualizationEntityComponent());
  setParent(visualizationHolder, entity);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var viewerObjects = LinkedHashMap_init_$Create$();
  var parent = $this.connectorVisualizer.createParent(visualizationHolder);
  if (parent == null)
    null;
  else {
    parent.registerInputEvents();
  }
  var connectorsDecorator = generateConnectorsDecorator(Companion_getInstance_194(), entity, $this.connectorVisualizer, $this.i5b_1, $this.j5b_1, data);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = connectorsDecorator.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.addDecoration.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var id = element.b2();
    // Inline function 'kotlin.collections.component2' call
    var viewerObject = element.c2();
    viewerObject.setParent(parent);
    // Inline function 'kotlin.collections.set' call
    viewerObjects.q2(id, viewerObject);
  }
  visualizationHolder.addComponent(new ConnectorVisualizerViewerObjectsComponent(viewerObjects));
  if (parent == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.addDecoration.<anonymous>' call
    visualizationHolder.addComponent(new ViewerObjectComponent(parent));
  }
}
function removeDecoration_0($this, entity) {
  var holder = findVisualizerHolder_0($this, entity);
  var tmp1_safe_receiver = holder == null ? null : holder.__getComponentForKotlin(Companion_instance_33.n1s());
  var viewerObject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObject;
  if (holder == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.g5b_1.disposeEntity(holder);
  }
  if (viewerObject == null)
    null;
  else {
    viewerObject.deleteObject();
  }
}
function findVisualizerHolder_0($this, entity) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_children(entity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.findVisualizerHolder.<anonymous>' call
      if (element.hasComponent(Companion_instance_173.id)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function updateDecoration_0($this, entity, data) {
  removeDecoration_0($this, entity);
  var visualizerHolder = $this.g5b_1.createEntity();
  addDecoration_0($this, entity, visualizerHolder, data);
}
function componentsChanged_0($this, entity) {
  var tmp = Companion_getInstance_194().s50_1;
  if (tmp(entity, EntityConnectorVisualizationSystem$componentsChanged$lambda($this, entity)) == null) {
    removeDecoration_0($this, entity);
  }
}
function Companion_151() {
  Companion_instance_190 = this;
  this.ID = 'EntityConnectorVisualizationSystem';
  var tmp = this;
  tmp.s50_1 = EntityConnectorVisualizationSystem$Companion$runOnDecoratable$lambda;
  this.t50_1 = 10.0;
  this.u50_1 = 5.0;
}
protoOf(Companion_151).j1y = function () {
  return this.ID;
};
var Companion_instance_190;
function Companion_getInstance_194() {
  if (Companion_instance_190 == null)
    new Companion_151();
  return Companion_instance_190;
}
function _get_connectorVisualizationNode__spb9ou(_this__u8e3s4, $this) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_instance_173.id);
}
function EntityConnectorVisualizationSystem$componentsChanged$lambda(this$0, $entity) {
  return function (_unused_var__etf5q3, visualizationComponent) {
    updateDecoration_0(this$0, $entity, visualizationComponent.data);
    return Unit_instance;
  };
}
function EntityConnectorVisualizationSystem(coreServices, connectorVisualizer) {
  Companion_getInstance_194();
  var tmp = Companion_getInstance_194().ID;
  var tmp_0 = Companion_instance_0.h1n_1;
  var tmp_1 = Companion_instance_0.u1p_1;
  var tmp_2 = Companion_getInstance_38().ID;
  var tmp_3 = Companion_instance_34.id;
  var tmp_4 = Companion_getInstance_11().q3e_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp_5 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp_6 = [];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$2 = [];
  SystemBase5.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$2);
  this.coreServices = coreServices;
  this.connectorVisualizer = connectorVisualizer;
  this.g5b_1 = this.coreServices.entityManager;
  this.h5b_1 = this.coreServices.sceneManager;
  this.enable();
  this.i5b_1 = null;
  this.j5b_1 = null;
}
protoOf(EntityConnectorVisualizationSystem).j3t = function () {
  return this.coreServices;
};
protoOf(EntityConnectorVisualizationSystem).k5b = function (_set____db54di) {
  this.connectorVisualizer = _set____db54di;
};
protoOf(EntityConnectorVisualizationSystem).l5b = function () {
  return this.connectorVisualizer;
};
protoOf(EntityConnectorVisualizationSystem).l59 = function (entity, newComponent) {
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).n2m = function (entity, newComponent) {
  return this.l59(entity, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).m59 = function (entity, oldComponent, newComponent) {
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE();
  return this.m59(entity, tmp, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).n59 = function (entity, oldComponent) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_hierarchy(this.h5b_1.root);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.onRemoveComponent3.<anonymous>' call
    if (!element.hasComponent(Companion_instance_173.id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.onRemoveComponent3.<anonymous>' call
    removeDecoration_0(this, element_0);
  }
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).p2m = function (entity, oldComponent) {
  return this.n59(entity, oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).o59 = function (entity, newComponent) {
  var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_instance_173.id);
  var wasAConnectorVisualizationNode = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  if (!wasAConnectorVisualizationNode) {
    return Unit_instance;
  }
  var newEntity = newComponent.entity;
  var newData = newEntity == null ? null : newEntity.__getComponentForKotlin(Companion_instance_173.id);
  var entityWasRemoved = newEntity == null;
  var shouldRemoveVisualization = newData == null;
  if (entityWasRemoved || shouldRemoveVisualization) {
    var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_33.n1s());
    var oldParentViewerObject = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.viewerObject;
    if (oldParentViewerObject == null)
      null;
    else {
      oldParentViewerObject.deleteObject();
    }
  }
};
protoOf(EntityConnectorVisualizationSystem).y2n = function (entity, newComponent) {
  return this.o59(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).q59 = function (entity, oldComponent) {
};
protoOf(EntityConnectorVisualizationSystem).a2o = function (entity, oldComponent) {
  return this.q59(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).p59 = function (entity, oldComponent, newComponent) {
};
protoOf(EntityConnectorVisualizationSystem).z2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.p59(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).r59 = function (entity, newComponent) {
};
protoOf(EntityConnectorVisualizationSystem).d2n = function (entity, newComponent) {
  return this.r59(entity, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).s59 = function (entity, oldComponent, newComponent) {
};
protoOf(EntityConnectorVisualizationSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE();
  return this.s59(entity, tmp, newComponent instanceof IsLoadingSnapshotComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).t59 = function (entity, oldComponent) {
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).f2n = function (entity, oldComponent) {
  return this.t59(entity, oldComponent instanceof IsLoadingSnapshotComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).enable = function () {
  protoOf(SystemBase5).enable.call(this);
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).disable = function () {
  protoOf(SystemBase5).disable.call(this);
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).m5b = function (value) {
  this.i5b_1 = value;
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).r52 = function () {
  return this.i5b_1;
};
protoOf(EntityConnectorVisualizationSystem).n5b = function (value) {
  this.j5b_1 = value;
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).s52 = function () {
  return this.j5b_1;
};
protoOf(EntityConnectorVisualizationSystem).refresh = function () {
  if (this.isEnabled) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = get_hierarchySequence(this.h5b_1.root).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
      var connectorVisualizationData = element.__getComponentForKotlin(Companion_instance_0.u1p_1);
      if (!(connectorVisualizationData == null)) {
        if (hasNoVisualization_0(this, element) || hasNewVisualizationData_0(this, element, connectorVisualizationData)) {
          updateDecoration_0(this, element, connectorVisualizationData.data);
        }
      } else {
        removeDecoration_0(this, element);
      }
    }
  } else {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.g5b_1.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element_0 = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
      if (!element_0.hasComponent(Companion_instance_173.id)) {
        destination.h(element_0);
      }
    }
    var tmp0_iterator_0 = destination.k();
    while (tmp0_iterator_0.m()) {
      var element_1 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
      removeDecoration_0(this, element_1);
    }
  }
};
protoOf(EntityConnectorVisualizationSystem).setVisualizer = function (connectorVisualizer) {
  this.connectorVisualizer = connectorVisualizer;
  this.refresh();
};
protoOf(EntityConnectorVisualizationSystem).o5b = function (entity, newComponent) {
  if (entity.hasComponent(Companion_getInstance_181().id)) {
    componentsChanged_0(this, entity);
  }
};
protoOf(EntityConnectorVisualizationSystem).v1v = function (entity, newComponent) {
  return this.o5b(entity, newComponent instanceof ConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).p5b = function (entity, oldComponent, newComponent) {
  if (entity.hasComponent(Companion_getInstance_181().id)) {
    componentsChanged_0(this, entity);
  }
};
protoOf(EntityConnectorVisualizationSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ConnectorsComponent ? oldComponent : THROW_CCE();
  return this.p5b(entity, tmp, newComponent instanceof ConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).q5b = function (entity, oldComponent) {
  removeDecoration_0(this, entity);
};
protoOf(EntityConnectorVisualizationSystem).z1v = function (entity, oldComponent) {
  return this.q5b(entity, oldComponent instanceof ConnectorsComponent ? oldComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).r5b = function (entity, newComponent) {
  if (get_isInScene(entity)) {
    componentsChanged_0(this, entity);
  }
};
protoOf(EntityConnectorVisualizationSystem).l1z = function (entity, newComponent) {
  return this.r5b(entity, newComponent instanceof EntityConnectorVisualizationComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).s5b = function (entity, oldComponent, newComponent) {
  if (newComponent.data == null) {
    removeDecoration_0(this, entity);
  } else {
    if (get_isInScene(entity)) {
      updateDecoration_0(this, entity, newComponent.data);
    }
  }
};
protoOf(EntityConnectorVisualizationSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof EntityConnectorVisualizationComponent ? oldComponent : THROW_CCE();
  return this.s5b(entity, tmp, newComponent instanceof EntityConnectorVisualizationComponent ? newComponent : THROW_CCE());
};
protoOf(EntityConnectorVisualizationSystem).t5b = function (entity, oldComponent) {
  removeDecoration_0(this, entity);
};
protoOf(EntityConnectorVisualizationSystem).p1z = function (entity, oldComponent) {
  return this.t5b(entity, oldComponent instanceof EntityConnectorVisualizationComponent ? oldComponent : THROW_CCE());
};
function addConfigComponentToEntities($this, newComponent, oldComponent) {
  // Inline function 'kotlin.sequences.forEach' call
  var tmp = get_hierarchySequence($this.t56_1.sceneManager.root);
  var tmp0_iterator = filter(tmp, ForcedComponentBaseSystem$addConfigComponentToEntities$lambda($this)).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.visualization.system.ForcedComponentBaseSystem.addConfigComponentToEntities.<anonymous>' call
    element.addComponent(new VisualizationEntityComponent());
    var tmp0_safe_receiver = element.__getComponentForKotlin($this.c1w_1);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      if (equals(tmp0_safe_receiver, oldComponent)) {
        element.addComponent(newComponent);
      }
      tmp_0 = Unit_instance;
    }
    if (tmp_0 == null)
      element.addComponent(newComponent);
  }
}
function addConfigComponentToEntities$default($this, newComponent, oldComponent, $super) {
  oldComponent = oldComponent === VOID ? null : oldComponent;
  return addConfigComponentToEntities($this, newComponent, oldComponent);
}
function removeConfigComponentFromEntities($this, configComponent) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.t56_1.entityManager.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.system.ForcedComponentBaseSystem.removeConfigComponentFromEntities.<anonymous>' call
    if (!element.equals($this.u56_1) && !element.isDisposed) {
      removeConfigComponentFromEntity($this, element, configComponent);
    }
  }
}
function removeConfigComponentFromEntities$default($this, configComponent, $super) {
  configComponent = configComponent === VOID ? null : configComponent;
  return removeConfigComponentFromEntities($this, configComponent);
}
function removeConfigComponentFromEntity($this, entity, configComponent) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin($this.c1w_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (equals(tmp0_safe_receiver, configComponent)) {
      entity.removeComponent($this.c1w_1);
    }
  }
}
function refreshComponentOnEntity($this, entity) {
  if ($this.isEnabled) {
    if (!$this.v56_1 && $this.n57(entity)) {
      entity.addComponent(new VisualizationEntityComponent());
      entity.addComponent($this.s57($this.c1w_1));
    }
  } else {
    removeConfigComponentFromEntity($this, entity, $this.s57($this.c1w_1));
  }
}
function ForcedComponentBaseSystem$addConfigComponentToEntities$lambda(this$0) {
  return function (it) {
    return this$0.n57(it);
  };
}
function ForcedComponentBaseSystem(id, componentId, forcedComponent, coreServices) {
  SystemBase4.call(this, id, componentId, Companion_instance_10.id, Companion_instance_5.id, Companion_getInstance_11().q3e_1);
  this.t56_1 = coreServices;
  this.u56_1 = this.t56_1.entityManager.createEntity();
  this.v56_1 = false;
  this.u56_1.addComponent(forcedComponent);
  this.u56_1.addComponent(new DisplayNameComponent('ForcedComponentConfigEntity-Component:' + componentId));
}
protoOf(ForcedComponentBaseSystem).j3t = function () {
  return this.t56_1;
};
protoOf(ForcedComponentBaseSystem).o57 = function () {
  return this.u56_1;
};
protoOf(ForcedComponentBaseSystem).p57 = function (_set____db54di) {
  this.v56_1 = _set____db54di;
};
protoOf(ForcedComponentBaseSystem).l4w = function () {
  return this.v56_1;
};
protoOf(ForcedComponentBaseSystem).enable = function () {
  protoOf(SystemBase4).enable.call(this);
  if (this.v56_1)
    return Unit_instance;
  addConfigComponentToEntities$default(this, this.s57(this.c1w_1));
};
protoOf(ForcedComponentBaseSystem).disable = function () {
  protoOf(SystemBase4).disable.call(this);
  removeConfigComponentFromEntities(this, this.s57(this.c1w_1));
};
protoOf(ForcedComponentBaseSystem).q57 = function (configComponent) {
  var oldComponent = this.u56_1.getComponentUnsafe(this.c1w_1);
  if (!equals(oldComponent, configComponent)) {
    this.u56_1.addComponent(configComponent);
    if (this.isEnabled) {
      removeConfigComponentFromEntities$default(this);
      addConfigComponentToEntities(this, configComponent, oldComponent);
    }
  }
};
protoOf(ForcedComponentBaseSystem).u31 = function (entity, newComponent) {
  refreshComponentOnEntity(this, entity);
};
protoOf(ForcedComponentBaseSystem).l1z = function (entity, newComponent) {
  return this.u31(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).v31 = function (entity, oldComponent, newComponent) {
};
protoOf(ForcedComponentBaseSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.v31(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).w31 = function (entity, oldComponent) {
};
protoOf(ForcedComponentBaseSystem).p1z = function (entity, oldComponent) {
  return this.w31(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).z4d = function (entity, newComponent) {
  this.v56_1 = true;
};
protoOf(ForcedComponentBaseSystem).n2m = function (entity, newComponent) {
  return this.z4d(entity, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).a4e = function (entity, oldComponent) {
  this.v56_1 = false;
  if (this.isEnabled) {
    this.enable();
  }
};
protoOf(ForcedComponentBaseSystem).p2m = function (entity, oldComponent) {
  return this.a4e(entity, oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).r57 = function (entity, oldComponent, newComponent) {
};
protoOf(ForcedComponentBaseSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SceneReloadingComponent ? oldComponent : THROW_CCE();
  return this.r57(entity, tmp, newComponent instanceof SceneReloadingComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).a32 = function (entity, newComponent) {
  if (!this.isEnabled)
    return Unit_instance;
  var tmp0_elvis_lhs = newComponent.entity;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var newEntity = tmp;
  var isNew = newComponent.entityStateBeforeLoadingSnapshot == null;
  if (isNew && this.n57(entity)) {
    newEntity.addComponent(new VisualizationEntityComponent());
    newEntity.addComponentInternal(this.s57(this.c1w_1));
  }
};
protoOf(ForcedComponentBaseSystem).d2n = function (entity, newComponent) {
  return this.a32(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).d32 = function (entity, oldComponent, newComponent) {
};
protoOf(ForcedComponentBaseSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.d32(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).e32 = function (entity, oldComponent) {
};
protoOf(ForcedComponentBaseSystem).f2n = function (entity, oldComponent) {
  return this.e32(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
protoOf(ForcedComponentBaseSystem).v1v = function (entity, newComponent) {
};
protoOf(ForcedComponentBaseSystem).x1v = function (entity, oldComponent, newComponent) {
};
protoOf(ForcedComponentBaseSystem).z1v = function (entity, oldComponent) {
  var configComponent = this.s57(this.c1w_1);
  if (!equals(oldComponent, configComponent) && this.isEnabled) {
    entity.addComponent(configComponent);
  }
};
protoOf(ForcedComponentBaseSystem).s57 = function (componentId) {
  var component = this.u56_1.__getComponentForKotlin(componentId);
  var tmp;
  if (component == null) {
    throw Exception_init_$Create$('Config entity missing forced component ' + componentId);
  } else {
    tmp = component;
  }
  return tmp;
};
function ColliderVisualizer() {
}
function CollisionVisualizationData(penetration, entity, boundId, otherEntity, otherBoundId) {
  this.penetration = penetration;
  this.entity = entity;
  this.boundId = boundId;
  this.otherEntity = otherEntity;
  this.otherBoundId = otherBoundId;
  this.m5a_1 = 0;
}
protoOf(CollisionVisualizationData).j49 = function () {
  return this.penetration;
};
protoOf(CollisionVisualizationData).v2i = function () {
  return this.entity;
};
protoOf(CollisionVisualizationData).v5b = function () {
  return this.boundId;
};
protoOf(CollisionVisualizationData).h49 = function () {
  return this.otherEntity;
};
protoOf(CollisionVisualizationData).w5b = function () {
  return this.otherBoundId;
};
protoOf(CollisionVisualizationData).equals = function (other) {
  if (other === this)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof CollisionVisualizationData))
    THROW_CCE();
  if (!(other.entity.id === this.entity.id))
    return false;
  if (!(other.boundId === this.boundId))
    return false;
  if (!(other.otherEntity.id === this.otherEntity.id))
    return false;
  if (!(other.otherBoundId === this.otherBoundId))
    return false;
  return true;
};
protoOf(CollisionVisualizationData).hashCode = function () {
  if (this.m5a_1 === 0) {
    this.m5a_1 = this.entity.hashCode() + this.penetration.hashCode() | 0;
  }
  return this.m5a_1;
};
protoOf(CollisionVisualizationData).tf = function () {
  return this.penetration;
};
protoOf(CollisionVisualizationData).uf = function () {
  return this.entity;
};
protoOf(CollisionVisualizationData).m1m = function () {
  return this.boundId;
};
protoOf(CollisionVisualizationData).n1m = function () {
  return this.otherEntity;
};
protoOf(CollisionVisualizationData).o1m = function () {
  return this.otherBoundId;
};
protoOf(CollisionVisualizationData).x5b = function (penetration, entity, boundId, otherEntity, otherBoundId) {
  return new CollisionVisualizationData(penetration, entity, boundId, otherEntity, otherBoundId);
};
protoOf(CollisionVisualizationData).copy = function (penetration, entity, boundId, otherEntity, otherBoundId, $super) {
  penetration = penetration === VOID ? this.penetration : penetration;
  entity = entity === VOID ? this.entity : entity;
  boundId = boundId === VOID ? this.boundId : boundId;
  otherEntity = otherEntity === VOID ? this.otherEntity : otherEntity;
  otherBoundId = otherBoundId === VOID ? this.otherBoundId : otherBoundId;
  return this.x5b(penetration, entity, boundId, otherEntity, otherBoundId);
};
protoOf(CollisionVisualizationData).toString = function () {
  return 'CollisionVisualizationData(penetration=' + this.penetration.toString() + ', entity=' + this.entity.toString() + ', boundId=' + this.boundId + ', otherEntity=' + this.otherEntity.toString() + ', otherBoundId=' + this.otherBoundId + ')';
};
function Color(color, r, g, b) {
  this.color = color;
  this.r = r;
  this.g = g;
  this.b = b;
  this.c53_1 = 0;
}
protoOf(Color).j2i = function () {
  return this.color;
};
protoOf(Color).t4e = function () {
  return this.r;
};
protoOf(Color).u4e = function () {
  return this.g;
};
protoOf(Color).v4e = function () {
  return this.b;
};
protoOf(Color).equals = function (other) {
  if (!(other instanceof Color))
    return false;
  return other.color === this.color;
};
protoOf(Color).hashCode = function () {
  if (this.c53_1 === 0)
    this.c53_1 = getStringHashCode(this.color);
  return this.c53_1;
};
protoOf(Color).tf = function () {
  return this.color;
};
protoOf(Color).uf = function () {
  return this.r;
};
protoOf(Color).m1m = function () {
  return this.g;
};
protoOf(Color).n1m = function () {
  return this.b;
};
protoOf(Color).y5b = function (color, r, g, b) {
  return new Color(color, r, g, b);
};
protoOf(Color).copy = function (color, r, g, b, $super) {
  color = color === VOID ? this.color : color;
  r = r === VOID ? this.r : r;
  g = g === VOID ? this.g : g;
  b = b === VOID ? this.b : b;
  return this.y5b(color, r, g, b);
};
protoOf(Color).toString = function () {
  return 'Color(color=' + this.color + ', r=' + this.r + ', g=' + this.g + ', b=' + this.b + ')';
};
function ConnectorVisualizer() {
}
function setBaseColor($this, viewerObject) {
  var green = 1 - $this.colorRandomizationAmount + Default_getInstance().yh(0.0, $this.colorRandomizationAmount);
  return viewerObject.setBaseColor(0.0, green, 0.0);
}
function setCollideColor($this, viewerObject) {
  var red = 1 - $this.colorRandomizationAmount + Default_getInstance().yh(0.0, $this.colorRandomizationAmount);
  return viewerObject.setBaseColor(red, 0.0, 0.0);
}
function setTransparency_0($this, viewerObject) {
  return viewerObject.setTransparency($this.alpha);
}
function getColorSeed($this, connector) {
  var seed = 0;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = connector.tags();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
    seed = seed + getStringHashCode(element) | 0;
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = connector.offers();
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
    seed = seed + getStringHashCode(element_0) | 0;
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_1 = connector.demands();
  var inductionVariable_1 = 0;
  var last_1 = indexedObject_1.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = indexedObject_1[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
    seed = seed + getStringHashCode(element_1) | 0;
  }
  return seed;
}
function Companion_152() {
  Companion_instance_191 = this;
  this.z5b_1 = LoggerState_getInstance().g1v('DefaultVisualizer');
  this.pointConnectorSize = 40.0;
  this.subConnectorSize = 10.0;
  this.colorRandomizationAmount = 0.5;
  this.alpha = 0.8;
}
protoOf(Companion_152).a5c = function () {
  return this.pointConnectorSize;
};
protoOf(Companion_152).b5c = function () {
  return this.subConnectorSize;
};
protoOf(Companion_152).p53 = function () {
  return this.colorRandomizationAmount;
};
protoOf(Companion_152).n53 = function () {
  return this.alpha;
};
var Companion_instance_191;
function Companion_getInstance_195() {
  if (Companion_instance_191 == null)
    new Companion_152();
  return Companion_instance_191;
}
function createCube($this, size, color, transparent, position, viewer) {
  return createBox(size, size, size, color, transparent, position, viewer);
}
function createCube$default($this, size, color, transparent, position, viewer, $super) {
  transparent = transparent === VOID ? false : transparent;
  return createCube($this, size, color, transparent, position, viewer);
}
function DefaultVisualizer$defaultOnConnectorClick$lambda(_unused_var__etf5q3, connector) {
  println(connector.key);
  return Unit_instance;
}
function DefaultVisualizer$createPointConnector$lambda(this$0, $entity, $connector) {
  return function () {
    this$0.f5c_1($entity, $connector);
    return Unit_instance;
  };
}
function DefaultVisualizer$createPointConnector$lambda_0(this$0, $entity, $connector) {
  return function () {
    this$0.f5c_1($entity, $connector);
    return Unit_instance;
  };
}
function DefaultVisualizer$createUnknown$lambda() {
  return 'Unknown connector implementation, unable to visualize';
}
function DefaultVisualizer(coreServices, transformModel) {
  Companion_getInstance_195();
  transformModel = transformModel === VOID ? null : transformModel;
  this.c5c_1 = coreServices;
  this.d5c_1 = transformModel;
  var tmp = this;
  tmp.e5c_1 = DefaultVisualizer$defaultOnConnectorClick$lambda;
  this.f5c_1 = this.e5c_1;
}
protoOf(DefaultVisualizer).k33 = function () {
  return this.c5c_1.coreModules.viewer();
};
protoOf(DefaultVisualizer).setOnConnectorClick = function (onClick) {
  var tmp = this;
  tmp.f5c_1 = onClick == null ? this.e5c_1 : onClick;
};
protoOf(DefaultVisualizer).createParent = function (entity) {
  var tmp0_safe_receiver = this.viewer;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createEmpty();
};
protoOf(DefaultVisualizer).g5c = function (entity, entityManager) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>' call
    var placeholder = tmp0_safe_receiver.createSphere(0.02, entity);
    var tmp0_safe_receiver_0 = entity.__getComponentForKotlin(Companion_instance_0.c1n_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>.<anonymous>' call
      placeholder.setRotation(tmp0_safe_receiver_0.transform.rotation);
      placeholder.setPosition(tmp0_safe_receiver_0.transform.position);
      var tmp0_safe_receiver_1 = get_viewerObject(entity);
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>.<anonymous>.<anonymous>' call
        placeholder.setScaleV(tmp0_safe_receiver_1.getScale());
      }
    }
    tmp = placeholder;
  }
  return tmp;
};
protoOf(DefaultVisualizer).h5c = function (entity, entityManager) {
  var tmp0_safe_receiver = this.viewer;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createSphere(0.02, entity);
};
protoOf(DefaultVisualizer).u5b = function (entity, polyhedron, color, collides, collisionData) {
  var vertices = polyhedron.vertices;
  // Inline function 'kotlin.collections.map' call
  var this_0 = polyhedron.faces;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.indices;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(this_1.length);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>.<anonymous>' call
      var tmp$ret$0 = vertices[item_0];
      destination_0.h(tmp$ret$0);
    }
    var tmp$ret$4 = copyToArray(destination_0);
    destination.h(tmp$ret$4);
  }
  var faces = destination;
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(faces, 10));
    var tmp0_iterator = faces.k();
    while (tmp0_iterator.m()) {
      var item_1 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>.<anonymous>' call
      var normal = Companion_getInstance_18().a2i(item_1);
      var viewerObject = tmp0_safe_receiver.createSurface(item_1, normal, entity);
      if (collides) {
        setCollideColor(Companion_getInstance_195(), viewerObject);
      } else {
        if (!(color == null)) {
          viewerObject.setBaseColor(color.r, color.g, color.b);
        } else {
          setBaseColor(Companion_getInstance_195(), viewerObject);
        }
      }
      setTransparency_0(Companion_getInstance_195(), viewerObject);
      destination_1.h(viewerObject);
    }
    var viewerObjects = destination_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$10 = copyToArray(viewerObjects);
    var colliderVis = tmp0_safe_receiver.groupMeshes(tmp$ret$10, entity);
    tmp = colliderVis;
  }
  return tmp;
};
protoOf(DefaultVisualizer).setColor = function (bound, color) {
  bound.setBaseColor(color.r, color.g, color.b);
};
protoOf(DefaultVisualizer).indicateCollision = function (bound) {
  setCollideColor(Companion_getInstance_195(), bound);
};
protoOf(DefaultVisualizer).createColliderGroupParent = function (entity, polyhedron) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return tmp0_safe_receiver.createSphere(0.001);
  }
  return tmp;
};
protoOf(DefaultVisualizer).createPointConnector = function (entity, connector, position, data) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPointConnector.<anonymous>' call
    var tmp_0;
    if (data == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1;
      if (data.visible) {
        var tmp0_subject = connector.y2e_1;
        var box = tmp0_subject === Companion_instance_6.m2b_1 ? createCube(this, Companion_getInstance_195().pointConnectorSize, 1, false, position, tmp0_safe_receiver) : tmp0_subject === Companion_instance_6.l2b_1 ? createCube(this, Companion_getInstance_195().pointConnectorSize, 1, false, position, tmp0_safe_receiver).setRotation(Companion_getInstance_14().fromEulerDegrees$default(new Degrees(35.264), VOID, new Degrees(45.0))) : createSphere(Companion_getInstance_195().pointConnectorSize / 2, 1, false, position, tmp0_safe_receiver);
        if (data.selected) {
          box.setBaseColor(1.0, 0.0, 0.0);
        } else {
          setRandomColor(box, getColorSeed(Companion_getInstance_195(), connector), false);
        }
        box.makeClickable(DefaultVisualizer$createPointConnector$lambda(this, entity, connector));
        if (data.showActivationDistance && connector.b2f_1 > 0) {
          var sphere = createSphere(connector.b2f_1, 1, true, position, tmp0_safe_receiver);
          sphere.makeClickable(DefaultVisualizer$createPointConnector$lambda_0(this, entity, connector));
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$2 = [box, sphere];
          return tmp0_safe_receiver.groupMeshes(tmp$ret$2);
        } else {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$5 = [box];
          return tmp0_safe_receiver.groupMeshes(tmp$ret$5);
        }
      } else {
        return null;
      }
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp = tmp1_elvis_lhs == null ? createCube(this, Companion_getInstance_195().pointConnectorSize, 1, false, position, tmp0_safe_receiver) : tmp1_elvis_lhs;
  }
  return tmp;
};
protoOf(DefaultVisualizer).createPointSeriesConnector = function (entity, connector, data) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0 = 0;
    var tmp_1 = connector.subConnectorCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = createCube(this, Companion_getInstance_195().subConnectorSize, 1, false, connector.getSubConnectorPosition(tmp_3), tmp0_safe_receiver).setBaseColor(1.0, 1.0, 0.0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var subConnectors = tmp_2;
    return tmp0_safe_receiver.groupMeshes(subConnectors);
  }
  return tmp;
};
protoOf(DefaultVisualizer).createSurfaceConnector = function (entity, connector, data) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var viewerObj = tmp0_safe_receiver.createSurface(connector.vertices, connector.normal, entity);
    return viewerObj;
  }
  return tmp;
};
protoOf(DefaultVisualizer).createEdgeConnector = function (entity, connector, thickness, data) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var colorSeed = getColorSeed(Companion_getInstance_195(), connector);
    return createLine(connector.p1, connector.p2, thickness, colorSeed, tmp0_safe_receiver);
  }
  return tmp;
};
protoOf(DefaultVisualizer).createUnknown = function (entity, connector, data) {
  var tmp0_safe_receiver = this.viewer;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0 = Companion_getInstance_195().z5b_1;
    tmp_0.debug(DefaultVisualizer$createUnknown$lambda);
    return tmp0_safe_receiver.createEmpty();
  }
  return tmp;
};
protoOf(DefaultVisualizer).createTransform = function (entity, connector, data) {
  var tmp;
  var tmp_0;
  if ((data == null ? null : data.showTransform) === true) {
    tmp_0 = !(this.d5c_1 == null);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp0_safe_receiver = this.viewer;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp1_elvis_lhs = this.d5c_1.modelUrl;
      var tmp_2 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = this.d5c_1.texture;
      tmp_1 = tmp0_safe_receiver.loadModel(null, tmp_2, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs, null, null);
    }
    var viewerObject = tmp_1;
    if (viewerObject == null)
      null;
    else
      viewerObject.setRotation(connector.transform.rotation);
    tmp = viewerObject;
  } else {
    tmp = null;
  }
  return tmp;
};
function createSphere(radius, color, transparent, position, viewer) {
  transparent = transparent === VOID ? false : transparent;
  return setRandomColor(viewer.createSphere(radius).setPosition(position), color, transparent);
}
function createLine(p1, p2, thickness, color, viewer) {
  var line = p2.minus(p1);
  var center = p2.plus(p1).__divIntForKotlin(2);
  var length = line.size;
  var rotation = (new Vector(length, 0.0, 0.0)).getRotationTo(line);
  return setRandomColor(viewer.createBox(length, thickness, thickness).setPosition(center).setRotation(rotation), color, false);
}
function createBox(width, height, depth, color, transparent, position, viewer) {
  transparent = transparent === VOID ? false : transparent;
  return setRandomColor(viewer.createBox(width, height, depth).setPosition(position), color, transparent);
}
function setRandomColor(_this__u8e3s4, seed, transparent) {
  var random = Random(seed);
  if (transparent) {
    _this__u8e3s4.setTransparency(0.25);
  }
  return _this__u8e3s4.setBaseColor(random.wh(), random.wh(), random.wh());
}
function getCollisionsForEntity($this, entity, root) {
  var collisions = getWorldCollision($this, entity, root);
  return flatten_0(toList_1(mapNotNull(collisions, VisualizerUtils$Companion$getCollisionsForEntity$lambda(entity))));
}
function getWorldCollision($this, entity, root) {
  var tmp0_safe_receiver = get_collider(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>' call
    tmp = mapNotNull(root, VisualizerUtils$Companion$getWorldCollision$lambda(tmp1_safe_receiver));
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? emptySequence() : tmp2_elvis_lhs;
}
function getBoundCollisions($this, entity, otherEntity, collisionPairs, otherCollisionPairs) {
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = collisionPairs.rf_1;
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var index = 0;
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    // Inline function 'kotlin.collections.mapIndexedNotNull' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var this_1 = otherCollisionPairs.rf_1;
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index_0 = 0;
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
      var tmp1_0 = index_0;
      index_0 = tmp1_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = item_0.penetration(item);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>.<anonymous>.<anonymous>' call
        tmp = !(entity.id === otherEntity.id) ? new CollisionVisualizationData(tmp0_safe_receiver, entity, collisionPairs.sf_1[tmp1], otherEntity, otherCollisionPairs.sf_1[tmp1_0]) : null;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.h(tmp0_safe_receiver_0);
      }
    }
    destination.h(destination_0);
  }
  return flatten_0(destination);
}
function createWorldColliderShapePairs($this, entity) {
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>' call
    var worldTransform = get_worldTransform(entity);
    var tmp0_safe_receiver_0 = tmp0_safe_receiver.ids;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>' call
      var tmp_1 = tmp0_safe_receiver.polyhedron;
      var tmp0_safe_receiver_1 = tmp_1 instanceof PolyhedronGroup ? tmp_1 : null;
      var tmp_2;
      if (tmp0_safe_receiver_1 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = tmp0_safe_receiver_1.polyhedra;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(this_0.length);
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var item = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.transform(worldTransform);
          destination.h(tmp$ret$0);
        }
        var tmp$ret$3 = copyToArray(destination);
        tmp_2 = new Pair(tmp$ret$3, tmp0_safe_receiver_0);
      }
      var tmp1_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [tmp0_safe_receiver.polyhedron.transform(worldTransform)];
        tmp_3 = new Pair(tmp$ret$8, tmp0_safe_receiver_0);
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      tmp_0 = tmp_3;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function VisualizerUtils$Companion$getCollisions$lambda($root) {
  return function (child) {
    return getCollisionsForEntity(Companion_instance_192, child, $root);
  };
}
function VisualizerUtils$Companion$getCollisionsForEntity$lambda($entity) {
  return function (other) {
    var tmp0_safe_receiver = createWorldColliderShapePairs(Companion_instance_192, $entity);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getCollisionsForEntity.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = createWorldColliderShapePairs(Companion_instance_192, other);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getCollisionsForEntity.<anonymous>.<anonymous>.<anonymous>' call
        tmp_0 = getBoundCollisions(Companion_instance_192, $entity, other, tmp0_safe_receiver, tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
}
function VisualizerUtils$Companion$getWorldCollision$lambda($worldPolyhedron) {
  return function (other) {
    var tmp0_safe_receiver = get_collider(other);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>.<anonymous>.<anonymous>' call
      var tmp_0;
      if (tmp1_safe_receiver.penetration($worldPolyhedron) == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        tmp_0 = other;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
}
function Companion_153() {
}
protoOf(Companion_153).l5a = function (entity, root) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp = get_hierarchySequence(entity);
  var this_0 = flatten_0(toList_1(map(tmp, VisualizerUtils$Companion$getCollisions$lambda(root))));
  return copyToArray(this_0);
};
var Companion_instance_192;
function Companion_getInstance_196() {
  return Companion_instance_192;
}
function CoreDebug(core) {
  this.core = core;
  this.coreVisualization = null;
  this.i5c_1 = null;
  this.dragSurfaceNormalVisualizationSystem = new DragSurfaceNormalVisualizationSystem(this.core.services);
  this.drawDragGhostSystem = new DrawDragGhostSystem(this.core.services);
  this.j5c_1 = new ValidationServiceMeasurer();
  this.k5c_1 = new MeasuringEntityManagerWatcher(this.core.services.entityManager);
  this.placementService = new PlacementService(this.core.services);
  this.core.services.entityManager.registerSystem(this.dragSurfaceNormalVisualizationSystem);
  this.dragSurfaceNormalVisualizationSystem.disable();
  this.core.services.entityManager.registerSystem(this.drawDragGhostSystem);
  this.drawDragGhostSystem.disable();
  this.coreVersion = this.core.version();
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.l5c_1 = LinkedHashMap_init_$Create$();
}
protoOf(CoreDebug).m5c = function () {
  return this.core;
};
protoOf(CoreDebug).n5c = function (_set____db54di) {
  this.coreVisualization = _set____db54di;
};
protoOf(CoreDebug).o5c = function () {
  return this.coreVisualization;
};
protoOf(CoreDebug).s51 = function () {
  return this.dragSurfaceNormalVisualizationSystem;
};
protoOf(CoreDebug).p5c = function () {
  return this.drawDragGhostSystem;
};
protoOf(CoreDebug).q5c = function () {
  return this.j5c_1;
};
protoOf(CoreDebug).r5c = function () {
  return this.k5c_1;
};
protoOf(CoreDebug).s5c = function () {
  return this.placementService;
};
protoOf(CoreDebug).setAllOfCore = function (allOfCore) {
  this.i5c_1 = allOfCore;
};
protoOf(CoreDebug).getAllOfCore = function () {
  return this.i5c_1;
};
protoOf(CoreDebug).toggleColliders = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleColliders();
  }
};
protoOf(CoreDebug).t5c = function () {
  return this.coreVersion;
};
protoOf(CoreDebug).toggleConnectors = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleConnectors();
  }
};
protoOf(CoreDebug).toggleFunctionalMargin = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleFunctionalMargin();
  }
};
protoOf(CoreDebug).toggleFunctionalZones = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleFunctionalZone();
  }
};
protoOf(CoreDebug).toggleAutoAdaptHostZone = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleAutoAdaptHostZone();
  }
};
protoOf(CoreDebug).toggleDragSurfaceVisualization = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleDragSurfaces();
  }
};
protoOf(CoreDebug).toggleDragPointVisualization = function () {
  this.enableVisualization(this.core.services);
  var tmp0_safe_receiver = this.coreVisualization;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.toggleDragProjectionPoint();
  }
};
protoOf(CoreDebug).enableVisualization = function (coreServices) {
  if (this.coreVisualization == null) {
    var visualizer = new DefaultVisualizer(coreServices, new ModelInfoComponent('', 'https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/gojxjez4vka8.glb', ''));
    this.coreVisualization = new CoreVisualization(coreServices, visualizer, visualizer);
  }
};
protoOf(CoreDebug).getEntityById = function (id) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = this.core.services.entityManager.entities;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.debug.CoreDebug.getEntityById.<anonymous>' call
      if (element.id === id) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var entity = tmp$ret$1;
  if (entity == null) {
    echoStandardConsole('No entity with given id found');
  }
  return entity;
};
protoOf(CoreDebug).getEntitiesWithComponents = function (componentIds) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.core.services.entityManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.getEntitiesWithComponents.<anonymous>' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var inductionVariable_0 = 0;
      var last_0 = componentIds.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = componentIds[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.debug.CoreDebug.getEntitiesWithComponents.<anonymous>.<anonymous>' call
        if (!element.hasComponent(element_0)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    if (tmp$ret$1) {
      destination.h(element);
    }
  }
  var entities = destination;
  if (entities.r()) {
    echoStandardConsole('No entities with given components found');
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(entities);
};
protoOf(CoreDebug).getSelectedEntity = function () {
  return findSelectedEntity(this.core);
};
protoOf(CoreDebug).validateSelectedEntity = function () {
  var tmp0_safe_receiver = findSelectedEntity(this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var result = this.core.services.validations.validateCurrentState(tmp0_safe_receiver, false);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = result.length;
    while (inductionVariable < last) {
      var element = result[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSelectedEntity.<anonymous>.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination.h(element);
      }
    }
    var failed = copyToArray(destination);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = result.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = result[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSelectedEntity.<anonymous>.<anonymous>' call
      if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        destination_0.h(element_0);
      }
    }
    var warning = copyToArray(destination_0);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(failed.length === 0)) {
      echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validation failed:');
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(warning.length === 0)) {
        echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validated successfully with warnings');
      } else {
        echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validated successfully');
      }
    }
    return new SortedValidationResult(warning, failed);
  }
  return null;
};
protoOf(CoreDebug).printRegisteredSystems = function () {
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var indexedObject = this.core.services.entityManager.getSystemsRegistered();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var item = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.printRegisteredSystems.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
  }
};
protoOf(CoreDebug).printSystemsListeningToComponent = function (componentId) {
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var indexedObject = this.core.services.entityManager.getSystemsRegisteredForComponent(componentId);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var item = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.printSystemsListeningToComponent.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
  }
};
protoOf(CoreDebug).enableSystem = function (i) {
  var tmp0_safe_receiver = getSystem(i, this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.enable();
  }
};
protoOf(CoreDebug).disableSystem = function (i) {
  var tmp0_safe_receiver = getSystem(i, this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.disable();
  }
};
protoOf(CoreDebug).printValidationRules = function () {
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var indexedObject = this.core.getValidations();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var item = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.printValidationRules.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
  }
};
protoOf(CoreDebug).enableValidationRule = function (i) {
  var tmp0_safe_receiver = getValidationRule(i, this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.enable();
  }
};
protoOf(CoreDebug).disableValidationRule = function (i) {
  var tmp0_safe_receiver = getValidationRule(i, this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.disable();
  }
};
protoOf(CoreDebug).startMeasuringValidationRules = function () {
  var tmp = this.core.services.validations;
  // Inline function 'kotlin.also' call
  var this_0 = this.j5c_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.stl.debug.CoreDebug.startMeasuringValidationRules.<anonymous>' call
  this_0.m2();
  tmp.q3h(this_0);
};
protoOf(CoreDebug).stopMeasuringValidationRulesAndPrintResults = function () {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.stopMeasuringValidationRulesAndGetResults();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.stopMeasuringValidationRulesAndPrintResults.<anonymous>' call
    echoStandardConsole(element);
  }
};
protoOf(CoreDebug).stopMeasuringValidationRulesAndGetResults = function () {
  this.core.services.validations.q3h(null);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.j5c_1.v3g();
  return copyToArray(this_0);
};
protoOf(CoreDebug).stopMeasuringValidationRulesAndGetStructuredResults = function () {
  this.core.services.validations.q3h(null);
  return this.j5c_1.o3i();
};
protoOf(CoreDebug).startMeasuringSystems = function () {
  this.core.services.entityManager.addWatcher(this.k5c_1);
  this.k5c_1.h3y_1.m2();
};
protoOf(CoreDebug).stopMeasuringSystemsAndPrintResults = function () {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.stopMeasuringSystemsAndGetResults();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.stopMeasuringSystemsAndPrintResults.<anonymous>' call
    echoStandardConsole(element);
  }
};
protoOf(CoreDebug).stopMeasuringSystemsAndGetResults = function () {
  this.core.services.entityManager.removeWatcher(this.k5c_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.k5c_1.h3y_1.v3g();
  return copyToArray(this_0);
};
protoOf(CoreDebug).traceComponentChainOnce = function (componentId) {
  new LoggingEntityManagerWatcher(this.core.services.entityManager, componentId);
};
protoOf(CoreDebug).validateSnapsForSelectedEntity = function (hostId) {
  var tmp0_safe_receiver = findSelectedEntity(this.core);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    this.l5c_1.m2();
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.core.services.sceneManager.entities;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>' call
        if (element.id === hostId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver_0 = tmp$ret$1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = Companion_instance_1.p1l(tmp0_safe_receiver, tmp0_safe_receiver_0, new SnapSettings(true));
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>' call
        var snapResult = this.core.services.validations.validateSnapCandidate(element_0, false);
        $l$block_0: {
          // Inline function 'com.ikea.core.utils.orElse' call
          var tmp0_safe_receiver_1 = this.l5c_1.f2(element_0.host);
          if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.h(snapResult)) == null) {
            var this_1 = this.l5c_1;
            var key = element_0.host;
            var value = mutableListOf([snapResult]);
            this_1.q2(key, value);
            break $l$block_0;
          }
        }
      }
    }
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.l5c_1.i2().k();
    while (tmp0_iterator.m()) {
      var element_1 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var host = element_1.b2();
      // Inline function 'kotlin.collections.component2' call
      var snapResults = element_1.c2();
      echoStandardConsole('Host ' + get_displayName(host) + ' id: ' + host.id);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = snapResults.k();
      while (tmp0_iterator_0.m()) {
        var element_2 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>' call
        var snap = element_2.tf();
        var result = element_2.uf();
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        var tmp = snap.hostConnector.key;
        var tmp_0 = snap.guestConnector.key;
        var tmp_1 = snap.inActivationDistance();
        var tmp_2;
        // Inline function 'kotlin.collections.isEmpty' call
        if (result.length === 0) {
          tmp_2 = 'SUCCESS';
        } else {
          tmp_2 = 'FAIL due to:';
        }
        echoStandardConsole('' + _unary__edvuaz + '. ' + tmp + ' <--> ' + tmp_0 + ' p=' + snap.priority + ' iad=' + tmp_1 + ' ' + tmp_2);
        var tmp0_safe_receiver_2 = snap.alignmentInitiatorCandidate;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          echoStandardConsole('   (due to alignment ' + tmp0_safe_receiver_2.hostConnector.key + ' <--> ' + tmp0_safe_receiver_2.guestConnector.key + ' p=' + tmp0_safe_receiver_2.priority + ')');
        }
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = result.length;
        while (inductionVariable_1 < last_1) {
          var element_3 = result[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          echoStandardConsole(element_3);
        }
      }
      echoStandardConsole('---------------------------------');
    }
    echoStandardConsole('Perform a snap by calling:');
    echoStandardConsole('CoreDebug.performValidatedSnap(<index number>)');
  }
};
protoOf(CoreDebug).performValidatedSnap = function (snapIndex) {
  var index = 0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this.l5c_1.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.stl.debug.CoreDebug.performValidatedSnap.<anonymous>' call
    // Inline function 'kotlin.collections.component2' call
    var snapResults = element.c2();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = snapResults.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.stl.debug.CoreDebug.performValidatedSnap.<anonymous>.<anonymous>' call
      var snap = element_0.tf();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (_unary__edvuaz === snapIndex) {
        snap.performMove();
        return Unit_instance;
      }
    }
  }
  echoStandardConsole('No candidate with that index. (validateSnapsForSelectedEntity() must be run first)');
};
protoOf(CoreDebug).help = function () {
  printHelp();
};
protoOf(CoreDebug).subscribeBeforeValidate = function (listener) {
  this.core.services.validations.s3h(listener);
};
protoOf(CoreDebug).subscribeAfterValidate = function (listener) {
  this.core.services.validations.t3h(listener);
};
protoOf(CoreDebug).unsubscribeBeforeValidate = function (listener) {
  this.core.services.validations.u3h(listener);
};
protoOf(CoreDebug).unsubscribeAfterValidate = function (listener) {
  this.core.services.validations.v3h(listener);
};
function SortedValidationResult(warning, fail) {
  this.warning = warning;
  this.fail = fail;
}
protoOf(SortedValidationResult).u5c = function () {
  return this.warning;
};
protoOf(SortedValidationResult).v5c = function () {
  return this.fail;
};
protoOf(SortedValidationResult).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof SortedValidationResult))
    THROW_CCE();
  if (!contentEquals(this.warning, other.warning))
    return false;
  if (!contentEquals(this.fail, other.fail))
    return false;
  return true;
};
protoOf(SortedValidationResult).hashCode = function () {
  var result = contentHashCode(this.warning);
  result = imul(31, result) + contentHashCode(this.fail) | 0;
  return result;
};
protoOf(SortedValidationResult).tf = function () {
  return this.warning;
};
protoOf(SortedValidationResult).uf = function () {
  return this.fail;
};
protoOf(SortedValidationResult).w5c = function (warning, fail) {
  return new SortedValidationResult(warning, fail);
};
protoOf(SortedValidationResult).copy = function (warning, fail, $super) {
  warning = warning === VOID ? this.warning : warning;
  fail = fail === VOID ? this.fail : fail;
  return this.w5c(warning, fail);
};
protoOf(SortedValidationResult).toString = function () {
  return 'SortedValidationResult(warning=' + toString(this.warning) + ', fail=' + toString(this.fail) + ')';
};
function findSelectedEntity(core) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = core.services.sceneManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.stl.debug.findSelectedEntity.<anonymous>' call
    if (element.hasComponent(Companion_instance_0.w1m_1)) {
      destination.h(element);
    }
  }
  var selected = destination;
  if (selected.r()) {
    echoStandardConsole('No entity selected');
  } else if (selected.o() > 1) {
    echoStandardConsole('Several entities selected, returning first');
  }
  return firstOrNull_1(selected);
}
function getSystem(i, core) {
  var systems = core.services.entityManager.getSystemsRegistered();
  if (i < 0 || i > systems.length) {
    echoStandardConsole('Invalid system index');
    return null;
  }
  return systems[i];
}
function getValidationRule(i, core) {
  var validationRules = core.getValidations();
  if (i < 0 || i > validationRules.length) {
    echoStandardConsole('Invalid validation rule index');
    return null;
  }
  return validationRules[i];
}
function printHelp() {
  var helpMessage = '###############################\n\n    Welcome to CoreDebug\n\n###############################\n\n### CoreDebug Systems\n\nCall enable() or disable() on any of the\nfollowing system to enable/disable it\n\n* drawDragGhostSystem\n\n### CoreDebug Visualization\n\nTo toggle visualization on and off:\n* toggleColliders()\n* toggleConnectors()\n* toggleAutoAdaptHostZone()\n* toggleFunctionalMargin()\n* toggleFunctionalZone()\n\n### CoreDebug functions:\n\n# Get entity with a specific id\nCoreDebug.getEntityById(id: string)\n\n# Get entities that have specific components. Will include detached entities, call with\n# InSceneComponent id (5) in componentIds array to only get entities that are in scene.\nCoreDebug.getEntitiesWithComponents(componentIds: number[])\n\n# Get selected entity\nCoreDebug.getSelectedEntity()\n\n# Validate selected entity and return results\nCoreDebug.validateSelectedEntity()\n\n# Print registered systems to console (with index)\nCoreDebug.printRegisteredSystems()\n\n# Print systems listening to a component in the order they listen\nCoreDebug.printSystemsListeningToComponent(componentId: number)\n\n# Enable system using index from printRegisteredSystems()\nCoreDebug.enableSystem(index: number)\n\n# Disable system using index from printRegisteredSystems()\nCoreDebug.disableSystem(index: number)\n\n# Print validation rules to console\nCoreDebug.printValidationRules()\n\n# Start measuring number of calls and time spent in each validation rule\nCoreDebug.startMeasuringValidationRules()\n\n# Stop measuring validation rules and print the results to console\nCoreDebug.stopMeasuringValidationRulesAndPrintResults()\n\n# Start measuring number of calls and time spent in each system callback function (add/update/remove per componentId)\nCoreDebug.startMeasuringSystems()\n\n# Stop measuring systems and print the results to console\nCoreDebug.stopMeasuringSystemsAndPrintResults()\n\n# Print a trace for how a component change propagates through systems\n# It will print the next propagation chain that involves the provided component\nCoreDebug.traceComponentChainOnce(componentId: number)\n\n# Find and validate all possible snaps for the selected entity. Optionally pass an entity id\n# to only get snaps with with that host. Prints out info about the snap and the validation\n# results per host entity ordered with an index. This index can be passed to performValidatedSnap()\n# Snap info: connector keys (host <--> guest), priority (p), if it is in activation\n# distance (iad) and if it originated from matching alignment connectors\nCoreDebug.validateSnapsForSelectedEntity(hostId?: string)\n\n# Performs the snap with a given index that you get from running validateSnapsForSelectedEntity()\n# The snap is performed regardless of the validation result\nCoreDebug.performValidatedSnap(snapIndex: number)\n\n# Print this help again\nCoreDebug.help()\n\n###############################';
  echoStandardConsole(helpMessage);
}
function componentName(componentId) {
  var tmp = Object.keys(ComponentIds).find(function (id) {
    return ComponentIds[id] === componentId;
  }) || 'unknown';
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  if (endsWith(name, '_ID')) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = name;
    var endIndex = name.length - 3 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    name = this_0.substring(0, endIndex);
  }
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return name.toLowerCase() + ' (' + componentId + ')';
}
//region block: post-declaration
defineProp(protoOf(AlignmentConnectionCreationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AlignmentConnectionCreationSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(AlignmentConnectionsComponent).r1s = get_serializable;
protoOf(AlignmentConnectionsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AlignmentConnectionsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AlignmentConnectionsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AlignmentConnectionsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(HandleUnderAlignmentComponent).r1s = get_serializable;
protoOf(HandleUnderAlignmentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(HandleUnderAlignmentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(HandleUnderAlignmentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(HandleUnderAlignmentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(HandleRotationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(HandleRotationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(HandleRotationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(HandleRotationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(HandleRotationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(HandleRotationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(HandleRotationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(HandleRotationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AlignmentLinesSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AlignmentLinesSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(RoomAlignmentEdgesComponent).r1s = get_serializable;
protoOf(RoomAlignmentEdgesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RoomAlignmentEdgesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RoomAlignmentEdgesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RoomAlignmentEdgesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AllowedDoorPairsComponent).r1s = get_serializable;
protoOf(AllowedDoorPairsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AllowedDoorPairsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AllowedDoorPairsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AllowedDoorPairsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'host', function () {
  return this.s3c();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'guest', function () {
  return this.t3c();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'guestConnectionRoot', function () {
  return this.l28();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holeNumber', function () {
  return this.h3s();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holePositionHostSpace', function () {
  return this.i3s();
});
defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holePositionWorldSpace', function () {
  return this.j3s();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutoAdaptProductSpecificationsSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(AutoAdaptChildFailedEventComponent).r1s = get_serializable;
protoOf(AutoAdaptChildFailedEventComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutoAdaptChildrenSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutoAdaptDisposeFailedChildrenSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutoAdaptCacheSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(AutoAdaptCachedVariantsComponent).r1s = get_serializable;
protoOf(AutoAdaptCachedVariantsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AutoAdaptSessionComponent).r1s = get_serializable;
protoOf(AutoAdaptSessionComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptSessionComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptSessionComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptSessionComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(CleanCacheOnFinishedAutoAdaptSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(AutoAdaptGuestComponent).r1s = get_serializable;
protoOf(AutoAdaptGuestComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptGuestComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptGuestComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptGuestComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AutoAdaptHostComponent).r1s = get_serializable;
protoOf(AutoAdaptHostComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptHostComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptHostComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptHostComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AutoAdaptProductSpecificationsComponent).r1s = get_serializable;
protoOf(AutoAdaptProductSpecificationsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AutoAdaptVariantComponent).r1s = get_serializable;
protoOf(AutoAdaptVariantComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutoAdaptVariantComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutoAdaptVariantComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutoAdaptVariantComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).r1s = get_serializable;
protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ReplacedWithAutoAdaptEventComponent).r1s = get_serializable;
protoOf(ReplacedWithAutoAdaptEventComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AbstractDragStrategy).dragStart = dragStart;
protoOf(AbstractDragStrategy).dragStop = dragStop;
defineProp(protoOf(AbstractDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AbstractDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(AutoAdaptDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(AutoAdaptDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DebugLineDrawingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DebugLineDrawingSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragRotationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragRotationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragRotationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragRotationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragRotationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragRotationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragRotationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragRotationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragState), 'originalDraggableRoot', protoOf(DragState).q3z);
defineProp(protoOf(DragState), 'lastValidWorldTransform', protoOf(DragState).r3z);
protoOf(DragStateComponent).r1s = get_serializable;
defineProp(protoOf(DragStateComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DragStateComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(DragStateComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragSurfaceNormalVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragSurfaceVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragSurfacesUpdateSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DrawDragGhostSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DrawDragGhostSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Companion_34), 'id', protoOf(Companion_34).n1s);
protoOf(IsDraggedComponent).r1s = get_serializable;
defineProp(protoOf(IsDraggedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(IsDraggedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(IsDraggedComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(MultiDragCommonParentComponent).r1s = get_serializable;
protoOf(MultiDragCommonParentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(MultiDragCommonParentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(MultiDragCommonParentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(MultiDragCommonParentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(RemovedDragComponentsComponent).r1s = get_serializable;
defineProp(protoOf(RemovedDragComponentsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RemovedDragComponentsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(RemovedDragComponentsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(TakeSnapshotBeforeDragSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(FreeMoveComponent).r1s = get_serializable;
protoOf(FreeMoveComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FreeMoveComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FreeMoveComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FreeMoveComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ResolveCollisionsDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(ResolveCollisionsDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SnapCardinalDirectionsDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(SnapCardinalDirectionsDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SnapClosestDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(SnapClosestDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SnapClosestWithSubConnectorsDragStrategy), 'name', function () {
  return this.v2();
});
defineProp(protoOf(SnapClosestWithSubConnectorsDragStrategy), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(CanvasTo3DDragConverterSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(LegacyCanvasTo3DDragConverterSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(NoDragConverterDetector), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(NoDragConverterDetector), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(NoDragConverterDetector), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(NoDragConverterDetector), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(NoDragConverterDetector), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(NoDragConverterDetector), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(NoDragConverterDetector), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(NoDragConverterDetector), 'isEnabled', function () {
  return this.s1w();
});
protoOf(DragProjectionPointComponent).r1s = get_serializable;
protoOf(DragProjectionPointComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DragProjectionPointComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DragProjectionPointComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DragProjectionPointComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(GrabOffsetComponent).r1s = get_serializable;
protoOf(GrabOffsetComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(GrabOffsetComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(GrabOffsetComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(GrabOffsetComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_46), 'id', protoOf(Companion_46).n1s);
protoOf(DragSurfaceEntityPairsCacheComponent).r1s = get_serializable;
protoOf(DragSurfaceEntityPairsCacheComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragSurfaceUpdatesListenerSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(FunctionalMarginComponent).r1s = get_serializable;
protoOf(FunctionalMarginComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FunctionalMarginComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FunctionalMarginComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FunctionalMarginComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(FunctionalMarginShapeComponent).r1s = get_serializable;
protoOf(FunctionalMarginShapeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FunctionalMarginShapeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FunctionalMarginShapeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FunctionalMarginShapeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(FunctionalMarginSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(FunctionalMarginSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(FunctionalMarginSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(FunctionalZonesLocalComponent).r1s = get_serializable;
protoOf(FunctionalZonesLocalComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FunctionalZonesLocalComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FunctionalZonesLocalComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FunctionalZonesLocalComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(FunctionalZonesLocalToWorldSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(FunctionalZonesWorldComponent).r1s = get_serializable;
protoOf(FunctionalZonesWorldComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FunctionalZonesWorldComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FunctionalZonesWorldComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FunctionalZonesWorldComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(LabelComponent).r1s = get_serializable;
protoOf(LabelComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(LabelComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LabelComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(LabelComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(DebugLogger), 'logLevel', function () {
  return this.k2u();
}, function (value) {
  this.j2u(value);
});
protoOf(CurrentProppingComponent).r1s = get_serializable;
protoOf(CurrentProppingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(CurrentProppingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(CurrentProppingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(CurrentProppingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DisposeProppingOnSlowReplacedEntitySystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(LargestFittingProppingComponent).r1s = get_serializable;
protoOf(LargestFittingProppingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(LargestFittingProppingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LargestFittingProppingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(LargestFittingProppingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingConvertColliderToFunctionalZoneSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingDisposalSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingDisposalSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(ProppingHostConnectorDataComponent).r1s = get_serializable;
protoOf(ProppingHostConnectorDataComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProppingHostConnectorDataComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProppingHostConnectorDataComponent), 'priority', protoOf(ProppingHostConnectorDataComponent).n28);
defineProp(protoOf(ProppingHostConnectorDataComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProppingHostConnectorDataComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'allProppingSizePrefabs', protoOf(ProppingHostConnectorDataCreationSystem).g4d);
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'currentProppingProductRefs', protoOf(ProppingHostConnectorDataCreationSystem).h4d);
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingHostConnectorDataCreationSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(ProppingParentComponent).r1s = get_serializable;
protoOf(ProppingParentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProppingParentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProppingParentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProppingParentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingSpaceCalculationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SelectLargestProppingPlacementSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent).r1s = get_serializable;
protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TemporarilyIgnoreMyProppingFunctionalZonesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ColoredOutlineComponent).r1s = get_serializable;
protoOf(ColoredOutlineComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ColoredOutlineComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColoredOutlineComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ColoredOutlineComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ColoredOutlineSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ColoredOutlineSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ColoredOutlineSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(OutlineBlockingComponent).r1s = get_serializable;
protoOf(OutlineBlockingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(OutlineBlockingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(OutlineBlockingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(OutlineBlockingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(OutlineEntityGroupDeselectSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(OutlineSelectedSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(OutlineSelectedSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(OutlineSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(OutlineSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(OutlineSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(OutlineSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(OutlineSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(OutlineSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(OutlineSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(OutlineSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(OutlinedComponent).r1s = get_serializable;
protoOf(OutlinedComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(OutlinedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(OutlinedComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(OutlinedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(PlacementResult), 'valid', protoOf(PlacementResult).e3h);
protoOf(PlacementZoneByHeightComponent).r1s = get_serializable;
protoOf(PlacementZoneByHeightComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(PlacementZoneByHeightComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(PlacementZoneByHeightComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(PlacementZoneByHeightComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(RecommendedInitialPositionFromFloorComponent).r1s = get_serializable;
protoOf(RecommendedInitialPositionFromFloorComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(RecommendedInitialPositionFromParentComponent).r1s = get_serializable;
protoOf(RecommendedInitialPositionFromParentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(PriorityCriterionSettings$Companion$all$1), 'onlyInActivationDistance', function () {
  return this.t4j();
});
defineProp(protoOf(PriorityCriterionSettings$Companion$onlyInActivationDistance$1), 'onlyInActivationDistance', function () {
  return this.t4j();
});
protoOf(ProppingHostConnectorsComponent).r1s = get_serializable;
protoOf(ProppingHostConnectorsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProppingHostConnectorsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProppingHostConnectorsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProppingHostConnectorsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ProppingInfoComponent).r1s = get_serializable;
protoOf(ProppingInfoComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProppingInfoComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProppingInfoComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProppingInfoComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ProppingSubSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingSubSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingSubSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingSubSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingSubSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingSubSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingSubSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingSubSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ProppingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProppingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProppingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProppingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProppingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProppingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProppingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProppingSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SetPropHolderInfoSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SetProppingHostConnectorDataSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(CommunicationSizeComponent).r1s = get_serializable;
protoOf(CommunicationSizeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(CommunicationSizeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(CommunicationSizeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(CommunicationSizeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DoorComponent).r1s = get_serializable;
protoOf(DoorComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DoorComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DoorComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DoorComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DoorFrontComponent_0).r1s = get_serializable;
protoOf(DoorFrontComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DoorFrontComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DoorFrontComponent_0), 'id', protoOf(DoorFrontComponent_0).n1s);
defineProp(protoOf(DoorFrontComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DoorFrontComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DrawerComponent_0).r1s = get_serializable;
protoOf(DrawerComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DrawerComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DrawerComponent_0), 'id', protoOf(DrawerComponent_0).n1s);
defineProp(protoOf(DrawerComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DrawerComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(FrameComponent_0).r1s = get_serializable;
protoOf(FrameComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(FrameComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(FrameComponent_0), 'id', protoOf(FrameComponent_0).n1s);
defineProp(protoOf(FrameComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(FrameComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(HandleComponent_0).r1s = get_serializable;
protoOf(HandleComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(HandleComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(HandleComponent_0), 'id', protoOf(HandleComponent_0).n1s);
defineProp(protoOf(HandleComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(HandleComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(IncludedHandleComponent_0).r1s = get_serializable;
protoOf(IncludedHandleComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(IncludedHandleComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(IncludedHandleComponent_0), 'id', protoOf(IncludedHandleComponent_0).n1s);
defineProp(protoOf(IncludedHandleComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(IncludedHandleComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(LegComponent_0).r1s = get_serializable;
protoOf(LegComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(LegComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LegComponent_0), 'id', protoOf(LegComponent_0).n1s);
defineProp(protoOf(LegComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(LegComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(LightComponent).r1s = get_serializable;
protoOf(LightComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(LightComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LightComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(LightComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer).fx = typeParametersSerializers;
protoOf(RoomDimensionsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RoomDimensionsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RoomDimensionsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RoomDimensionsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(StandardSelectionSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(StandardSelectionSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(StandardSelectionSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(StandardSelectionSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(StandardSelectionSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(StandardSelectionSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(StandardSelectionSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(StandardSelectionSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(GroupSelectionSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(GroupSelectionSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(GroupSelectionSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(GroupSelectionSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(GroupSelectionSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(GroupSelectionSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(GroupSelectionSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(GroupSelectionSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(RemoveTrivialSelectionGroupsSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SelectDraggedGroupSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf($serializer_0).fx = typeParametersSerializers;
protoOf(SelectionGroupsComponent).r1s = get_serializable_0;
protoOf(SelectionGroupsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SelectionGroupsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SelectionGroupsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SelectionGroupsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SelectionGroupsComponentDeserializer), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
protoOf($serializer_1).fx = typeParametersSerializers;
protoOf(RoomGeometryComponent).r1s = get_serializable_0;
protoOf(RoomGeometryComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RoomGeometryComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RoomGeometryComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RoomGeometryComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_2).fx = typeParametersSerializers;
protoOf(TestRoomPartIdComponent).r1s = get_serializable_0;
protoOf(TestRoomPartIdComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(TestRoomPartIdComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(TestRoomPartIdComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TestRoomPartIdComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_3).fx = typeParametersSerializers;
protoOf($serializer_4).fx = typeParametersSerializers;
protoOf($serializer_5).fx = typeParametersSerializers;
protoOf($serializer_6).fx = typeParametersSerializers;
protoOf($serializer_7).fx = typeParametersSerializers;
protoOf($serializer_8).fx = typeParametersSerializers;
protoOf($serializer_9).fx = typeParametersSerializers;
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AddRoomComponentsWhenLoadingSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(RoomComponentDeserializer), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(RoomDimensionToGeometrySystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(RoomLoadingInterceptor).beforeDeserialize = beforeDeserialize;
protoOf(RoomLoadingInterceptor).beforeParsingComponents = beforeParsingComponents;
defineProp(protoOf(RoomLoadingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(RoomLoadingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(RoomLoadingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(RoomLoadingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(RoomLoadingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(RoomLoadingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(RoomLoadingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(RoomLoadingSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(ColliderVisualizationConfigComponent).r1s = get_serializable;
protoOf(ColliderVisualizationConfigComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ColliderVisualizationConfigComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColliderVisualizationConfigComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ColliderVisualizationConfigComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_131), 'id', protoOf(Companion_131).n1s);
protoOf(ColliderVisualizationNodeComponent).r1s = get_serializable;
protoOf(ColliderVisualizationNodeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ColliderVisualizationNodeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColliderVisualizationNodeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ColliderVisualizationNodeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ColliderVisualizerViewerObjectsComponent).r1s = get_serializable;
defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(ConnectorVisualizationConfigComponent).r1s = get_serializable;
protoOf(ConnectorVisualizationConfigComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ConnectorVisualizationConfigComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ConnectorVisualizationConfigComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ConnectorVisualizationConfigComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_134), 'id', protoOf(Companion_134).n1s);
protoOf(ConnectorVisualizationNodeComponent).r1s = get_serializable;
protoOf(ConnectorVisualizationNodeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ConnectorVisualizationNodeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ConnectorVisualizationNodeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ConnectorVisualizationNodeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ConnectorVisualizerViewerObjectsComponent).r1s = get_serializable;
defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(DecoratorComponent).r1s = get_serializable;
protoOf(DecoratorComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DecoratorComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DecoratorComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DecoratorComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(EntityColliderVisualizationComponent).r1s = get_serializable;
defineProp(protoOf(EntityColliderVisualizationComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(EntityColliderVisualizationComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(EntityColliderVisualizationComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(EntityConnectorVisualizationComponent).r1s = get_serializable;
defineProp(protoOf(EntityConnectorVisualizationComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(EntityConnectorVisualizationComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(EntityConnectorVisualizationComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(Companion_139), 'id', protoOf(Companion_139).n1s);
protoOf(PolyhedronVisualizationNodeComponent).r1s = get_serializable;
protoOf(PolyhedronVisualizationNodeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_140), 'id', protoOf(Companion_140).n1s);
protoOf(VisualizationEntityComponent).r1s = get_serializable;
protoOf(VisualizationEntityComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(VisualizationEntityComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(VisualizationEntityComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(VisualizationEntityComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(PolyhedronVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutoAdaptHostZoneVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DragProjectionPointVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(FunctionalMarginVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(FunctionalZoneVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(PolyhedronVisualizationHolderComponent).r1s = get_serializable;
protoOf(PolyhedronVisualizationHolderComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ForcedComponentBaseSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'includeRoom', protoOf(ColliderVisualizationSystem).j52, protoOf(ColliderVisualizationSystem).m57);
defineProp(protoOf(ColliderVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ColliderVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ColliderVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'connectorKey', function () {
  return this.w2g();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'style', function () {
  return this.g53();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'selected', function () {
  return this.h53();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'visible', function () {
  return this.i53();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'active', function () {
  return this.j53();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'showActivationDistance', function () {
  return this.k53();
});
defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'showTransform', function () {
  return this.l53();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'includeRoom', protoOf(ConnectorVisualizationSystem).j52, protoOf(ConnectorVisualizationSystem).m57);
defineProp(protoOf(ConnectorVisualizationSystem), 'connectorActivationDistanceVisualizationEnabled', protoOf(ConnectorVisualizationSystem).b52, protoOf(ConnectorVisualizationSystem).s58);
defineProp(protoOf(ConnectorVisualizationSystem), 'connectorTransformVisualizationEnabled', protoOf(ConnectorVisualizationSystem).c52, protoOf(ConnectorVisualizationSystem).t58);
defineProp(protoOf(ConnectorVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ConnectorVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(EntityColliderVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(CollisionVisualizationSceneDataComponent).r1s = get_serializable;
protoOf(CollisionVisualizationSceneDataComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(EntityCollisionVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'offersFilter', protoOf(EntityConnectorVisualizationSystem).r52, protoOf(EntityConnectorVisualizationSystem).m5b);
defineProp(protoOf(EntityConnectorVisualizationSystem), 'demandsFilter', protoOf(EntityConnectorVisualizationSystem).s52, protoOf(EntityConnectorVisualizationSystem).n5b);
defineProp(protoOf(EntityConnectorVisualizationSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(EntityConnectorVisualizationSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(DefaultVisualizer).createColliderVisualization = createColliderVisualization;
defineProp(protoOf(DefaultVisualizer), 'viewer', protoOf(DefaultVisualizer).k33);
//endregion
//region block: init
Companion_instance_38 = new Companion();
Companion_instance_41 = new Companion_2();
Companion_instance_45 = new Companion_6();
Companion_instance_46 = new Companion_7();
Companion_instance_47 = new Companion_8();
Companion_instance_48 = new Companion_9();
Companion_instance_49 = new Companion_10();
Companion_instance_53 = new Companion_14();
Companion_instance_56 = new Companion_17();
DoneEntry_instance = new DoneEntry();
Companion_instance_66 = new Companion_27();
Companion_instance_69 = new Companion_30();
Companion_instance_71 = new Companion_32();
Companion_instance_72 = new Companion_33();
Companion_instance_73 = new Companion_34();
MultiDragUtils_instance = new MultiDragUtils();
Companion_instance_76 = new Companion_37();
Companion_instance_79 = new Companion_40();
Companion_instance_81 = new Companion_42();
Companion_instance_85 = new Companion_46();
Companion_instance_86 = new Companion_47();
Companion_instance_89 = new Companion_50();
Companion_instance_90 = new Companion_51();
Companion_instance_91 = new Companion_52();
Companion_instance_92 = new Companion_53();
Companion_instance_94 = new Companion_55();
Companion_instance_111 = new Companion_72();
Companion_instance_112 = new Companion_73();
Companion_instance_115 = new Companion_76();
SearchDirectionsUtils_instance = new SearchDirectionsUtils();
Companion_instance_119 = new Companion_80();
Companion_instance_123 = new Companion_84();
Companion_instance_128 = new Companion_89();
Companion_instance_129 = new Companion_90();
Companion_instance_130 = new Companion_91();
Companion_instance_135 = new Companion_96();
Companion_instance_136 = new Companion_97();
Companion_instance_138 = new Companion_99();
Companion_instance_139 = new Companion_100();
Companion_instance_140 = new Companion_101();
Companion_instance_141 = new Companion_102();
Companion_instance_142 = new Companion_103();
Companion_instance_143 = new Companion_104();
Companion_instance_147 = new Companion_108();
Companion_instance_151 = new Companion_112();
Companion_instance_153 = new Companion_114();
Companion_instance_155 = new Companion_116();
Companion_instance_156 = new Companion_117();
Companion_instance_157 = new Companion_118();
Companion_instance_158 = new Companion_119();
TestRoomBuildingUtils_instance = new TestRoomBuildingUtils();
Companion_instance_160 = new Companion_121();
Companion_instance_161 = new Companion_122();
Companion_instance_162 = new Companion_123();
Companion_instance_163 = new Companion_124();
Companion_instance_164 = new Companion_125();
Companion_instance_165 = new Companion_126();
Companion_instance_166 = new Companion_127();
Companion_instance_170 = new Companion_131();
Companion_instance_173 = new Companion_134();
Companion_instance_178 = new Companion_139();
Companion_instance_179 = new Companion_140();
Companion_instance_180 = new Companion_141();
Companion_instance_181 = new Companion_142();
Companion_instance_182 = new Companion_143();
Companion_instance_183 = new Companion_144();
Companion_instance_185 = new Companion_146();
Companion_instance_186 = new Companion_147();
Companion_instance_187 = new Companion_148();
Companion_instance_189 = new Companion_150();
Companion_instance_192 = new Companion_153();
//endregion
//region block: exports
defineProp(AlignmentConnectionCreationSystem, 'Companion', Companion_getInstance_42);
defineProp(AlignmentConnectionsComponent, 'Companion', Companion_getInstance_43);
defineProp(HandleRotationSystem, 'Companion', Companion_getInstance_44);
defineProp(AlignmentLinesSystem, 'Companion', Companion_getInstance_45);
defineProp(RoomAlignmentEdgesComponent, 'Companion', Companion_getInstance_47);
defineProp(AllowedDoorPairsComponent, 'Companion', Companion_getInstance_48);
defineProp(AllowedDoorPairsValidation, 'Companion', Companion_getInstance_49);
AutoAdaptFeature.start = start;
defineProp(AutoAdaptFeature, 'Companion', Companion_getInstance_51);
defineProp(AutoAdaptProductSpecificationsSystem, 'Companion', Companion_getInstance_52);
AutoAdaptService.findWithAutoAdapt$default = findWithAutoAdapt$default;
AutoAdaptService.snapToValidSnap$default = snapToValidSnap$default;
AutoAdaptService.snapAndValidateVariant$default = snapAndValidateVariant$default;
AutoAdaptUtils.findClosestAutoAdaptHost = findClosestAutoAdaptHost;
AutoAdaptUtils.findClosestAutoAdaptHostContainingPoint = findClosestAutoAdaptHostContainingPoint;
AutoAdaptUtils.findAllAutoAdaptHostsInScene = findAllAutoAdaptHostsInScene;
AutoAdaptUtils.getAutoAdaptVariants = getAutoAdaptVariants;
AutoAdaptUtils.isAutoAdapted = isAutoAdapted;
AutoAdaptUtils.getAutoAdaptOriginalEntity = getAutoAdaptOriginalEntity;
AutoAdaptUtils.getAutoAdaptSnapCandidates = getAutoAdaptSnapCandidates_0;
AutoAdaptUtils.getAutoAdaptCandidatesMultipleHosts = getAutoAdaptCandidatesMultipleHosts_0;
AutoAdaptUtils.getAutoAdaptCandidatesInHierarchy = getAutoAdaptCandidatesInHierarchy_0;
defineProp(AutoAdaptUtils, 'Companion', Companion_getInstance_53);
defineProp(AutoAdaptChildFailedEventComponent, 'Companion', Companion_getInstance_54);
defineProp(AutoAdaptChildrenSystem, 'Companion', Companion_getInstance_55);
defineProp(AutoAdaptCachedVariantsComponent, 'Companion', Companion_getInstance_58);
defineProp(AutoAdaptSessionComponent, 'Companion', Companion_getInstance_59);
defineProp(AutoAdaptGuestComponent, 'Companion', Companion_getInstance_61);
defineProp(AutoAdaptHostComponent, 'Companion', Companion_getInstance_62);
defineProp(AutoAdaptProductSpecificationsComponent, 'Companion', Companion_getInstance_63);
defineProp(AutoAdaptVariantComponent, 'Companion', Companion_getInstance_64);
defineProp(ForceAutoAdaptWhenParentIsDraggedComponent, 'Companion', Companion_getInstance_65);
defineProp(ReplacedWithAutoAdaptEventComponent, 'Companion', Companion_getInstance_66);
defineProp(DragSurfaceCanHostWithAutoAdaptSelector, 'Companion', Companion_getInstance_67);
defineProp(DebugLineDrawingSystem, 'Companion', Companion_getInstance_68);
defineProp(DragRotationSystem, 'Companion', Companion_getInstance_69);
defineProp(DragState, 'Companion', Companion_getInstance_70);
defineProp(DragStateComponent, 'Companion', Companion_getInstance_71);
defineProp(DragSurfaceNormalVisualizationSystem, 'Companion', Companion_getInstance_72);
defineProp(DragSurfaceVisualizationSystem, 'Companion', Companion_getInstance_73);
DragSystem.createStandardDragSystem = createStandardDragSystem_0;
DragSystem.createAutoAdaptDragSystem = createAutoAdaptDragSystem_0;
defineProp(DragSystem, 'Companion', Companion_getInstance_74);
defineProp(DrawDragGhostSystem, 'Companion', Companion_getInstance_75);
GhostUtils.createGhost = createGhost_0;
defineProp(GhostUtils, 'Companion', Companion_getInstance_76);
defineProp(IsDraggedComponent, 'Companion', Companion_getInstance_77);
defineProp(RemovedDragComponentsComponent, 'id', get_id);
defineProp(RemovedDragComponentsComponent, 'Companion', Companion_getInstance_79);
defineProp(FreeMoveComponent, 'Companion', Companion_getInstance_81);
defineProp(SnapClosestDragStrategy, 'Companion', Companion_getInstance_82);
defineProp(ValidDragStrategyResult, 'Companion', Companion_getInstance_83);
CanvasTo3DDragConverterSystem.CanvasTo3DDragConverterSystemFromCoreServices = CanvasTo3DDragConverterSystemFromCoreServices;
defineProp(CanvasTo3DDragConverterSystem, 'Companion', Companion_getInstance_84);
defineProp(LegacyCanvasTo3DDragConverterSystem, 'Companion', Companion_getInstance_85);
defineProp(DragProjectionPointComponent, 'Companion', Companion_getInstance_86);
defineProp(GrabOffsetComponent, 'Companion', Companion_getInstance_87);
AnyDragSurfaceProjector.AnyDragSurfaceProjectorFromCoreServices = AnyDragSurfaceProjectorFromCoreServices;
defineProp(AnyDragSurfaceProjector, 'Companion', Companion_getInstance_88);
defineProp(DragSurfaceEntityPairsCacheComponent, 'Companion', Companion_getInstance_89);
defineProp(FunctionalMarginComponent, 'Companion', Companion_getInstance_91);
defineProp(FunctionalMarginShapeComponent, 'Companion', Companion_getInstance_92);
defineProp(FunctionalMarginSystem, 'Companion', Companion_getInstance_93);
defineProp(FunctionalMarginValidation, 'Companion', Companion_getInstance_94);
defineProp(FunctionalMarginWarning, 'Companion', Companion_getInstance_95);
FunctionalZoneUtils.getFirstColliderIntersectionWithFunctionalZone = getFirstColliderIntersectionWithFunctionalZone;
defineProp(FunctionalZoneUtils, 'Companion', Companion_getInstance_96);
defineProp(FunctionalZonesLocalComponent, 'Companion', Companion_getInstance_97);
defineProp(FunctionalZonesLocalToWorldSystem, 'Companion', Companion_getInstance_98);
defineProp(FunctionalZonesWorldComponent, 'Companion', Companion_getInstance_99);
defineProp(ICFDataService, 'Companion', Companion_getInstance_100);
defineProp(LabelComponent, 'Companion', Companion_getInstance_101);
defineProp(CurrentProppingComponent, 'Companion', Companion_getInstance_102);
defineProp(LargestFittingProppingComponent, 'ID', get_ID);
defineProp(LargestFittingProppingComponent, 'Companion', Companion_getInstance_104);
defineProp(ProppingConvertColliderToFunctionalZoneSystem, 'ID', get_ID_0);
defineProp(ProppingConvertColliderToFunctionalZoneSystem, 'zoneLayer', get_zoneLayer);
defineProp(ProppingConvertColliderToFunctionalZoneSystem, 'Companion', Companion_getInstance_105);
defineProp(ProppingHostConnectorDataComponent, 'ID', get_ID_1);
defineProp(ProppingHostConnectorDataComponent, 'Companion', Companion_getInstance_107);
defineProp(ProppingHostConnectorDataCreationSystem, 'ID', get_ID_2);
defineProp(ProppingHostConnectorDataCreationSystem, 'Companion', Companion_getInstance_108);
defineProp(ProppingParentComponent, 'ID', get_ID_3);
defineProp(ProppingParentComponent, 'Companion', Companion_getInstance_109);
defineProp(ProppingSpaceCalculationSystem, 'Companion', Companion_getInstance_110);
defineProp(SelectLargestProppingPlacementSystem, 'ID', get_ID_4);
defineProp(SelectLargestProppingPlacementSystem, 'Companion', Companion_getInstance_111);
defineProp(TemporarilyIgnoreMyProppingFunctionalZonesComponent, 'Companion', Companion_getInstance_112);
defineProp(ColoredOutlineComponent, 'Companion', Companion_getInstance_113);
defineProp(OutlineBlockingComponent, 'Companion', Companion_getInstance_114);
defineProp(OutlineEntityGroupDeselectSystem, 'Companion', Companion_getInstance_115);
defineProp(OutlineSelectedSystem, 'Companion', Companion_getInstance_116);
defineProp(OutlinedComponent, 'Companion', Companion_getInstance_117);
PlacementHelper.snapToPosition = snapToPosition;
PlacementHelper.snapToScene = snapToScene;
PlacementHelper.snapToHost = snapToHost;
PlacementHelper.snapToHosts = snapToHosts;
defineProp(PlacementHelper, 'Companion', Companion_getInstance_118);
PlacementResult.fromValidationResult = fromValidationResult;
PlacementResult.fromValidSnapActionCandidateOrErrors = fromValidSnapActionCandidateOrErrors;
PlacementResult.fromValidatedSnapResult = fromValidatedSnapResult;
PlacementResult.ok = ok;
PlacementResult.failWithMessage = failWithMessage_0;
PlacementResult.failWithErrors = failWithErrors;
PlacementResult.warn = warn;
defineProp(PlacementResult, 'Companion', Companion_getInstance_119);
defineProp(PlacementZoneByHeightComponent, 'Companion', Companion_getInstance_120);
RecommendedInitialPositionFromFloorComponent.getOrDefault = getOrDefault;
defineProp(RecommendedInitialPositionFromFloorComponent, 'Companion', Companion_getInstance_121);
defineProp(RecommendedInitialPositionFromParentComponent, 'Companion', Companion_getInstance_122);
SnapPlacementActor.findBestValidPositionOnConnector$default = findBestValidPositionOnConnector$default;
SnapPlacementActor.CandidateResult = CandidateResult;
defineProp(SnapPlacementActor.CandidateResult, 'Companion', Companion_getInstance_123);
defineProp(SnapPlacementActor, 'Companion', Companion_getInstance_124);
SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections = getNewValidCandidatesOnSameConnectorsUsingSearchDirections;
SpaceFinderUtils.getPositionToDirectionOfCollision = getPositionToDirectionOfCollision_0;
SpaceFinderUtils.getNewCandidatesOnSameConnectorUsingSearchDirections = getNewCandidatesOnSameConnectorUsingSearchDirections_0;
SpaceFinderUtils.getPositionsOnConnector = getPositionsOnConnector_0;
defineProp(SpaceFinderUtils, 'Companion', Companion_getInstance_126);
ProppingFeature.enable = enable;
ProppingFeature.hasStartedProppingFeature = hasStartedProppingFeature;
ProppingFeature.disable = disable;
ProppingFeature.setProppingProductRefs = setProppingProductRefs;
ProppingFeature.getCurrentProppingProductRefs = getCurrentProppingProductRefs;
defineProp(ProppingFeature, 'Companion', Companion_getInstance_128);
defineProp(ProppingHostConnectorsComponent, 'Companion', Companion_getInstance_129);
defineProp(ProppingInfoComponent, 'Companion', Companion_getInstance_130);
defineProp(ProppingSystem, 'Companion', Companion_getInstance_131);
ProppingUtils.getAllFittingProppingSizeProppingPairs = getAllFittingProppingSizeProppingPairs;
ProppingUtils.setEmptyFromPropping = setEmptyFromPropping;
ProppingUtils.placePropping = placePropping;
ProppingUtils.getProppingProductRefs = getProppingProductRefs;
defineProp(ProppingUtils, 'Companion', Companion_getInstance_132);
defineProp(CommunicationSizeComponent, 'Companion', Companion_getInstance_135);
defineProp(DoorComponent, 'Companion', Companion_getInstance_136);
var DoorFrontComponent = {getInstance: DoorFrontComponent_getInstance};
var DrawerComponent = {getInstance: DrawerComponent_getInstance};
var FrameComponent = {getInstance: FrameComponent_getInstance};
var HandleComponent = {getInstance: HandleComponent_getInstance};
var IncludedHandleComponent = {getInstance: IncludedHandleComponent_getInstance};
var LegComponent = {getInstance: LegComponent_getInstance};
defineProp(LightComponent, 'Companion', Companion_getInstance_137);
ReplaceAssemblyPartUtils.replaceProductParts = replaceProductParts_0;
ReplaceAssemblyPartUtils.createActionForReplaceProductPart = createActionForReplaceProductPart;
defineProp(ReplaceAssemblyPartUtils, 'Companion', Companion_getInstance_138);
defineProp(ReplacePartResult, 'Companion', Companion_getInstance_139);
ReplaceUtils.replaceEntity = replaceEntity;
ReplaceUtils.fastReplaceEntity = fastReplaceEntity;
defineProp(ReplaceUtils, 'Companion', Companion_getInstance_140);
defineProp(RoomDimensionsComponent, 'Companion', Companion_getInstance_141);
RoomUtils.getRoom = getRoom;
RoomUtils.allRoomParts = allRoomParts;
RoomUtils.roomParts = roomParts;
RoomUtils.roomConnectors = roomConnectors;
RoomUtils.disableAllRoomConnectors = disableAllRoomConnectors;
RoomUtils.roomSurfaceWithNormal = roomSurfaceWithNormal;
RoomUtils.getRoomSurfacesAndTheirNormals = getRoomSurfacesAndTheirNormals;
defineProp(RoomUtils, 'Companion', Companion_getInstance_142);
StandardSelectionSystem.StandardSelectionSystemFromCoreServices = StandardSelectionSystemFromCoreServices;
defineProp(StandardSelectionSystem, 'Companion', Companion_getInstance_143);
defineProp(GroupSelectionSystem, 'ID', get_ID_5);
defineProp(GroupSelectionSystem, 'Companion', Companion_getInstance_144);
defineProp(RemoveTrivialSelectionGroupsSystem, 'ID', get_ID_6);
defineProp(RemoveTrivialSelectionGroupsSystem, 'Companion', Companion_getInstance_145);
defineProp(SelectDraggedGroupSystem, 'ID', get_ID_7);
defineProp(SelectDraggedGroupSystem, 'Companion', Companion_getInstance_146);
SelectionGroupUtils.group = group;
SelectionGroupUtils.ungroup = ungroup;
SelectionGroupUtils.removeFromGroup = removeFromGroup;
SelectionGroupUtils.getGroups = getGroups;
SelectionGroupUtils.getLargestGroupContainingEntity = getLargestGroupContainingEntity;
SelectionGroupUtils.getLargestUnselectedGroupContainingEntity = getLargestUnselectedGroupContainingEntity;
SelectionGroupUtils.getNextLargestSelectedGroupContainingEntity = getNextLargestSelectedGroupContainingEntity;
defineProp(SelectionGroupUtils, 'Companion', Companion_getInstance_147);
defineProp(SelectionGroupsComponent, 'ID', get_ID_8);
defineProp(SelectionGroupsComponent, 'Companion', Companion_getInstance_148);
defineProp(StlSystemIds, 'ALIGNMENT_CONNECTION_CREATION_SYSTEM', get_ALIGNMENT_CONNECTION_CREATION_SYSTEM);
defineProp(StlSystemIds, 'ALIGNMENT_LINES_SYSTEM_ID', get_ALIGNMENT_LINES_SYSTEM_ID);
defineProp(StlSystemIds, 'DRAG_SYSTEM_ID', get_DRAG_SYSTEM_ID);
defineProp(StlSystemIds, 'DRAG_ROTATION_SYSTEM_ID', get_DRAG_ROTATION_SYSTEM_ID);
defineProp(StlSystemIds, 'HANDLE_ROTATION_SYSTEM_ID', get_HANDLE_ROTATION_SYSTEM_ID);
defineProp(StlSystemIds, 'FUNCTIONAL_MARGIN_SYSTEM_ID', get_FUNCTIONAL_MARGIN_SYSTEM_ID);
defineProp(StlSystemIds, 'OUTLINE_SELECTED_SYSTEM_ID', get_OUTLINE_SELECTED_SYSTEM_ID);
defineProp(StlSystemIds, 'PROPPING_SYSTEM_ID', get_PROPPING_SYSTEM_ID);
defineProp(StlSystemIds, 'ADD_ROOM_COMPONENTS_WHEN_LOADING_SYSTEM_ID', get_ADD_ROOM_COMPONENTS_WHEN_LOADING_SYSTEM_ID);
defineProp(StlSystemIds, 'ROOM_LOADING_SYSTEM', get_ROOM_LOADING_SYSTEM);
defineProp(StlSystemIds, 'ROOM_DIMENSION_TO_GEOMETRY_SYSTEM_ID', get_ROOM_DIMENSION_TO_GEOMETRY_SYSTEM_ID);
defineProp(StlSystemIds, 'LEGACY_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM', get_LEGACY_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM);
defineProp(StlSystemIds, 'CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM', get_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM);
defineProp(StlSystemIds, 'AUTO_ADAPT_PRODUCT_SPECIFICATION_SYSTEM_ID', get_AUTO_ADAPT_PRODUCT_SPECIFICATION_SYSTEM_ID);
defineProp(StlSystemIds, 'STANDARD_SELECTION_SYSTEM_SYSTEM_ID', get_STANDARD_SELECTION_SYSTEM_SYSTEM_ID);
defineProp(StlSystemIds, 'AUTO_ADAPT_DISPOSE_FAILED_CHILDREN_SYSTEM_ID', get_AUTO_ADAPT_DISPOSE_FAILED_CHILDREN_SYSTEM_ID);
defineProp(StlSystemIds, 'Companion', Companion_getInstance_149);
DragExtensions.simulateEntireDragInSteps = simulateEntireDragInSteps;
DragExtensions.simulateEntireDrag = simulateEntireDrag;
DragExtensions.simulateStartDrag = simulateStartDrag;
DragExtensions.simulateOngoingDrag = simulateOngoingDrag;
DragExtensions.simulateEndDrag = simulateEndDrag;
defineProp(DragExtensions, 'Companion', Companion_getInstance_150);
TestRoomUtils.createOrUpdateRectangularRoom = createOrUpdateRectangularRoom_0;
TestRoomUtils.createOrUpdateRoomFromGeometry = createOrUpdateRoomFromGeometry;
defineProp(TestRoomUtils, 'Companion', Companion_getInstance_151);
defineProp(RoomGeometryComponent, 'Companion', Companion_getInstance_152);
defineProp(TestRoomPartIdComponent, 'Companion', Companion_getInstance_153);
defineProp(CoreRoomGeometryData, 'Companion', Companion_getInstance_154);
defineProp(CoreRoomSurface, 'Companion', Companion_getInstance_155);
defineProp(RoomSurfaceGeometry, 'Companion', Companion_getInstance_156);
defineProp(CoreRoomEdge, 'Companion', Companion_getInstance_157);
defineProp(CoreRoomVertex, 'Companion', Companion_getInstance_158);
defineProp(CoreRoomObstacle, 'Companion', Companion_getInstance_159);
defineProp(CoreRoomBoundingBox, 'Companion', Companion_getInstance_160);
TestRoomGenerator.generateCustomRoomGeometry = generateCustomRoomGeometry_0;
TestRoomGenerator.generateLShapedRoomGeometry = generateLShapedRoomGeometry;
TestRoomGenerator.generate5WallRoomGeometry = generate5WallRoomGeometry;
TestRoomGenerator.generateRectangularRoomGeometry = generateRectangularRoomGeometry_0;
defineProp(TestRoomGenerator, 'Companion', Companion_getInstance_164);
TestRoomRelationsUtils.edgesForRoomSurface = edgesForRoomSurface;
TestRoomRelationsUtils.surfacesForRoomEdge = surfacesForRoomEdge;
TestRoomRelationsUtils.cornersForRoomSurface = cornersForRoomSurface;
TestRoomRelationsUtils.surfacesForRoomCorner = surfacesForRoomCorner;
TestRoomRelationsUtils.edgesForRoomCorner = edgesForRoomCorner;
TestRoomRelationsUtils.cornersForRoomEdge = cornersForRoomEdge;
defineProp(TestRoomRelationsUtils, 'Companion', Companion_getInstance_165);
defineProp(DisallowSeparateRequiredHostsValidation, 'Companion', Companion_getInstance_166);
defineProp(PlacementZoneValidation, 'Companion', Companion_getInstance_168);
defineProp(RequiredConnectorsSatisfiedValidation, 'ID', get_ID_9);
defineProp(RequiredConnectorsSatisfiedValidation, 'Companion', Companion_getInstance_169);
defineProp(RequiredConnectorsValidationResult, 'Companion', Companion_getInstance_170);
ValidationResultIds.isCollisionValidationResult = isCollisionValidationResult;
ValidationResultIds.isInvalidNumberOfChildrenValidationResult = isInvalidNumberOfChildrenValidationResult;
ValidationResultIds.isChildConnectionValidationResult = isChildConnectionValidationResult;
ValidationResultIds.isFunctionalMarginWarningValidationResult = isFunctionalMarginWarningValidationResult;
ValidationResultIds.isRequiredConnectorsValidationResult = isRequiredConnectorsValidationResult;
ValidationResultIds.isNoValidConnectorAvailableValidationResult = isNoValidConnectorAvailableValidationResult;
ValidationResultIds.isUnknownErrorValidationResult = isUnknownErrorValidationResult;
ValidationResultIds.isInvalidDoorPairsResult = isInvalidDoorPairsResult;
defineProp(ValidationResultIds, 'InvalidNumberOfChildrenId', get_InvalidNumberOfChildrenId);
defineProp(ValidationResultIds, 'CollisionValidationResultId', get_CollisionValidationResultId);
defineProp(ValidationResultIds, 'FunctionalMarginWarningId', get_FunctionalMarginWarningId);
defineProp(ValidationResultIds, 'RequiredConnectorsValidationResultId', get_RequiredConnectorsValidationResultId);
defineProp(ValidationResultIds, 'NoValidConnectorAvailableValidationResultId', get_NoValidConnectorAvailableValidationResultId);
defineProp(ValidationResultIds, 'UnknownErrorValidationResultId', get_UnknownErrorValidationResultId);
defineProp(ValidationResultIds, 'InvalidDoorPairsResultId', get_InvalidDoorPairsResultId);
defineProp(ValidationResultIds, 'Companion', Companion_getInstance_171);
defineProp(ValidationRuleIds, 'CollisionValidationRuleId', get_CollisionValidationRuleId);
defineProp(ValidationRuleIds, 'ChildConnectionValidationId', get_ChildConnectionValidationId);
defineProp(ValidationRuleIds, 'RequiredConnectorsSatisfiedValidationId', get_RequiredConnectorsSatisfiedValidationId);
defineProp(ValidationRuleIds, 'AllowedDoorPairsValidationId', get_AllowedDoorPairsValidationId);
defineProp(ValidationRuleIds, 'FunctionalMarginValidationId', get_FunctionalMarginValidationId);
defineProp(ValidationRuleIds, 'DisallowSeparateRequiredHostsValidationId', get_DisallowSeparateRequiredHostsValidationId);
defineProp(ValidationRuleIds, 'PlacementZoneValidationId', get_PlacementZoneValidationId);
defineProp(ValidationRuleIds, 'TemporaryParentConnectionValidationId', get_TemporaryParentConnectionValidationId);
defineProp(ValidationRuleIds, 'Companion', Companion_getInstance_172);
CoreVisualization.setEnabled$default = setEnabled$default;
defineProp(ColliderVisualizationConfigComponent, 'Companion', Companion_getInstance_173);
defineProp(ColliderVisualizationNodeComponent, 'Companion', Companion_getInstance_174);
defineProp(ColliderVisualizerViewerObjectsComponent, 'Companion', Companion_getInstance_175);
defineProp(ConnectorVisualizationConfigComponent, 'Companion', Companion_getInstance_176);
defineProp(ConnectorVisualizationNodeComponent, 'Companion', Companion_getInstance_177);
defineProp(ConnectorVisualizerViewerObjectsComponent, 'Companion', Companion_getInstance_178);
defineProp(DecoratorComponent, 'Companion', Companion_getInstance_179);
defineProp(EntityColliderVisualizationComponent, 'Companion', Companion_getInstance_180);
defineProp(EntityConnectorVisualizationComponent, 'Companion', Companion_getInstance_181);
defineProp(PolyhedronVisualizationNodeComponent, 'Companion', Companion_getInstance_182);
defineProp(VisualizationEntityComponent, 'Companion', Companion_getInstance_183);
defineProp(AutoAdaptHostZoneVisualizationSystem, 'Companion', Companion_getInstance_184);
defineProp(DragProjectionPointVisualizationSystem, 'Companion', Companion_getInstance_185);
defineProp(FunctionalMarginVisualizationSystem, 'Companion', Companion_getInstance_186);
defineProp(FunctionalZoneVisualizationSystem, 'Companion', Companion_getInstance_187);
defineProp(PolyhedronVisualizationHolderComponent, 'Companion', Companion_getInstance_188);
PolyhedronVisualizationSystem.createPolyhedronVisualization$default = createPolyhedronVisualization$default;
defineProp(ColliderVisualizationSystem, 'Companion', Companion_getInstance_189);
defineProp(ConnectorVisualizationSystem, 'Companion', Companion_getInstance_190);
defineProp(EntityColliderVisualizationSystem, 'Companion', Companion_getInstance_191);
defineProp(CollisionVisualizationSceneDataComponent, 'Companion', Companion_getInstance_192);
defineProp(EntityCollisionVisualizationSystem, 'Companion', Companion_getInstance_193);
defineProp(EntityConnectorVisualizationSystem, 'Companion', Companion_getInstance_194);
DefaultVisualizer.createCube$default = createCube$default;
defineProp(DefaultVisualizer, 'Companion', Companion_getInstance_195);
export {
  AlignmentConnectionCreationSystem as AlignmentConnectionCreationSystem,
  AlignmentConnectionsComponent as AlignmentConnectionsComponent,
  AlignmentPlane as AlignmentPlane,
  HandleRotationSystem as HandleRotationSystem,
  HostConnectorRotationValidation as HostConnectorRotationValidation,
  AlignmentLinesSystem as AlignmentLinesSystem,
  RoomAlignmentEdgesComponent as RoomAlignmentEdgesComponent,
  SurfaceAlignmentLines as SurfaceAlignmentLines,
  SurfaceConnectorWithEntity as SurfaceConnectorWithEntity,
  AllowedDoorPairsComponent as AllowedDoorPairsComponent,
  AllowedDoorPairsValidation as AllowedDoorPairsValidation,
  AssemblyInstructionsService as AssemblyInstructionsService,
  PointSeriesAssemblyInstructionImpl as PointSeriesAssemblyInstructionImpl,
  AutoAdaptFeature as AutoAdaptFeature,
  AutoAdaptProductSpecificationsSystem as AutoAdaptProductSpecificationsSystem,
  AutoAdaptService as AutoAdaptService,
  EntityWithSensorZone as EntityWithSensorZone,
  AutoAdaptUtils as AutoAdaptUtils,
  AutoAdaptChildFailedEventComponent as AutoAdaptChildFailedEventComponent,
  AutoAdaptChildrenSystem as AutoAdaptChildrenSystem,
  AutoAdaptCachedVariantsComponent as AutoAdaptCachedVariantsComponent,
  AutoAdaptSessionComponent as AutoAdaptSessionComponent,
  AutoAdaptGuestComponent as AutoAdaptGuestComponent,
  AutoAdaptHostComponent as AutoAdaptHostComponent,
  AutoAdaptProductSpecificationsComponent as AutoAdaptProductSpecificationsComponent,
  SpecificationPair as SpecificationPair,
  AutoAdaptVariantComponent as AutoAdaptVariantComponent,
  ForceAutoAdaptWhenParentIsDraggedComponent as ForceAutoAdaptWhenParentIsDraggedComponent,
  ReplacedWithAutoAdaptEventComponent as ReplacedWithAutoAdaptEventComponent,
  AutoAdaptDragStrategy as AutoAdaptDragStrategy,
  DragSurfaceCanHostWithAutoAdaptSelector as DragSurfaceCanHostWithAutoAdaptSelector,
  DebugLineDrawingSystem as DebugLineDrawingSystem,
  DragRotationSystem as DragRotationSystem,
  DragState as DragState,
  DragStateComponent as DragStateComponent,
  DragSurfaceNormalVisualizationSystem as DragSurfaceNormalVisualizationSystem,
  DragSurfaceVisualizationSystem as DragSurfaceVisualizationSystem,
  DragSystem as DragSystem,
  DrawDragGhostSystem as DrawDragGhostSystem,
  GhostUtils as GhostUtils,
  HigherPriorityAlignmentPostProcess as HigherPriorityAlignmentPostProcess,
  IsDraggedComponent as IsDraggedComponent,
  RemovedDragComponentsComponent as RemovedDragComponentsComponent,
  FreeMoveComponent as FreeMoveComponent,
  ResolveCollisionsDragStrategy as ResolveCollisionsDragStrategy,
  SnapCardinalDirectionsDragStrategy as SnapCardinalDirectionsDragStrategy,
  SnapClosestDragStrategy as SnapClosestDragStrategy,
  SnapClosestWithSubConnectorsDragStrategy as SnapClosestWithSubConnectorsDragStrategy,
  ValidDragStrategyResult as ValidDragStrategyResult,
  CanvasTo3DDragConverterSystem as CanvasTo3DDragConverterSystem,
  DragSurfaceCanHostSelector as DragSurfaceCanHostSelector,
  DragSurfaceEntityPair as DragSurfaceEntityPair,
  DragSurfaceOnlyRoomSelector as DragSurfaceOnlyRoomSelector,
  LegacyCanvasTo3DDragConverterSystem as LegacyCanvasTo3DDragConverterSystem,
  DragProjectionPointComponent as DragProjectionPointComponent,
  GrabOffsetComponent as GrabOffsetComponent,
  AnyDragSurfaceProjector as AnyDragSurfaceProjector,
  DragSurfaceEntityPairsCacheComponent as DragSurfaceEntityPairsCacheComponent,
  XYPlaneProjector as XYPlaneProjector,
  FunctionalMarginComponent as FunctionalMarginComponent,
  FunctionalMarginShapeComponent as FunctionalMarginShapeComponent,
  FunctionalMarginSystem as FunctionalMarginSystem,
  FunctionalMarginValidation as FunctionalMarginValidation,
  FunctionalMarginWarning as FunctionalMarginWarning,
  FunctionalZone as FunctionalZone,
  FunctionalZoneUtils as FunctionalZoneUtils,
  FunctionalZonesLocalComponent as FunctionalZonesLocalComponent,
  FunctionalZonesLocalToWorldSystem as FunctionalZonesLocalToWorldSystem,
  FunctionalZonesWorldComponent as FunctionalZonesWorldComponent,
  ICFDataService as ICFDataService,
  ICFProductData as ICFProductData,
  LabelComponent as LabelComponent,
  DebugLogger as DebugLogger,
  CurrentProppingComponent as CurrentProppingComponent,
  LargestFittingProppingComponent as LargestFittingProppingComponent,
  ProppingConvertColliderToFunctionalZoneSystem as ProppingConvertColliderToFunctionalZoneSystem,
  ProppingHostConnectorDataComponent as ProppingHostConnectorDataComponent,
  ProppingHostConnectorDataCreationSystem as ProppingHostConnectorDataCreationSystem,
  ProppingParentComponent as ProppingParentComponent,
  ProppingSpaceCalculationSystem as ProppingSpaceCalculationSystem,
  SelectLargestProppingPlacementSystem as SelectLargestProppingPlacementSystem,
  SizeProppingPair as SizeProppingPair,
  TemporarilyIgnoreMyProppingFunctionalZonesComponent as TemporarilyIgnoreMyProppingFunctionalZonesComponent,
  ColoredOutlineComponent as ColoredOutlineComponent,
  ColoredOutlineSystem as ColoredOutlineSystem,
  OutlineBlockingComponent as OutlineBlockingComponent,
  OutlineEntityGroupDeselectSystem as OutlineEntityGroupDeselectSystem,
  OutlineSelectedSystem as OutlineSelectedSystem,
  OutlineSystem as OutlineSystem,
  OutlinedComponent as OutlinedComponent,
  PlacementHelper as PlacementHelper,
  PlacementResult as PlacementResult,
  PlacementService as PlacementService,
  PlacementZoneByHeightComponent as PlacementZoneByHeightComponent,
  RecommendedInitialPositionFromFloorComponent as RecommendedInitialPositionFromFloorComponent,
  RecommendedInitialPositionFromParentComponent as RecommendedInitialPositionFromParentComponent,
  SnapPlacementActor as SnapPlacementActor,
  PriorityCriterion as PriorityCriterion,
  SnapSorter as SnapSorter,
  SnapSorterBuilder as SnapSorterBuilder,
  SpaceFinderUtils as SpaceFinderUtils,
  ProppingFeature as ProppingFeature,
  ProppingHostConnectorsComponent as ProppingHostConnectorsComponent,
  ProppingHostConnectorData as ProppingHostConnectorData,
  ProppingInfoComponent as ProppingInfoComponent,
  PropHolderInfo as PropHolderInfo,
  ProppingSystem as ProppingSystem,
  ProppingUtils as ProppingUtils,
  CommunicationSizeComponent as CommunicationSizeComponent,
  DoorComponent as DoorComponent,
  DoorFrontComponent as DoorFrontComponent,
  DrawerComponent as DrawerComponent,
  FrameComponent as FrameComponent,
  HandleComponent as HandleComponent,
  IncludedHandleComponent as IncludedHandleComponent,
  LegComponent as LegComponent,
  LightComponent as LightComponent,
  ReplaceAssemblyPartUtils as ReplaceAssemblyPartUtils,
  ReplacePartResult as ReplacePartResult,
  ReplacePlacementResult as ReplacePlacementResult,
  ReplaceUtils as ReplaceUtils,
  RoomDimensionsComponent as RoomDimensionsComponent,
  RoomSurfaceWithNormal as RoomSurfaceWithNormal,
  RoomUtils as RoomUtils,
  StandardSelectionService as StandardSelectionService,
  StandardSelectionSystem as StandardSelectionSystem,
  GroupSelectionSystem as GroupSelectionSystem,
  RemoveTrivialSelectionGroupsSystem as RemoveTrivialSelectionGroupsSystem,
  SelectDraggedGroupSystem as SelectDraggedGroupSystem,
  SelectionGroupUtils as SelectionGroupUtils,
  SelectionGroupsComponent as SelectionGroupsComponent,
  SelectionGroup as SelectionGroup,
  SelectionGroupsComponentDeserializer as SelectionGroupsComponentDeserializer,
  SelectionGroupsFeature as SelectionGroupsFeature,
  StlSystemIds as StlSystemIds,
  DragExtensions as DragExtensions,
  TestRoomFeature as TestRoomFeature,
  TestRoomUtils as TestRoomUtils,
  RoomGeometryComponent as RoomGeometryComponent,
  TestRoomPartIdComponent as TestRoomPartIdComponent,
  CoreRoomGeometryData as CoreRoomGeometryData,
  CoreRoomSurface as CoreRoomSurface,
  RoomSurfaceGeometry as RoomSurfaceGeometry,
  CoreRoomEdge as CoreRoomEdge,
  CoreRoomVertex as CoreRoomVertex,
  CoreRoomObstacle as CoreRoomObstacle,
  CoreRoomBoundingBox as CoreRoomBoundingBox,
  RoomComponentDeserializer as RoomComponentDeserializer,
  TestRoomGenerator as TestRoomGenerator,
  TestRoomRelationsUtils as TestRoomRelationsUtils,
  AllowedNumberOfChildrenOfTypeValidation as AllowedNumberOfChildrenOfTypeValidation,
  DisallowSeparateRequiredHostsValidation as DisallowSeparateRequiredHostsValidation,
  PlacementZoneValidation as PlacementZoneValidation,
  RequiredConnectorsSatisfiedValidation as RequiredConnectorsSatisfiedValidation,
  RequiredConnectorsValidationResult as RequiredConnectorsValidationResult,
  ValidationResultIds as ValidationResultIds,
  ValidationRuleIds as ValidationRuleIds,
  CoreVisualization as CoreVisualization,
  VisualizationState as VisualizationState,
  ColliderVisualizationConfigComponent as ColliderVisualizationConfigComponent,
  ColliderVisualizationNodeComponent as ColliderVisualizationNodeComponent,
  ColliderVisualizerViewerObjectsComponent as ColliderVisualizerViewerObjectsComponent,
  ConnectorVisualizationConfigComponent as ConnectorVisualizationConfigComponent,
  ConnectorVisualizationNodeComponent as ConnectorVisualizationNodeComponent,
  ConnectorVisualizerViewerObjectsComponent as ConnectorVisualizerViewerObjectsComponent,
  DecoratorComponent as DecoratorComponent,
  EntityColliderVisualizationComponent as EntityColliderVisualizationComponent,
  EntityConnectorVisualizationComponent as EntityConnectorVisualizationComponent,
  PolyhedronVisualizationNodeComponent as PolyhedronVisualizationNodeComponent,
  VisualizationEntityComponent as VisualizationEntityComponent,
  AutoAdaptHostZoneVisualizationSystem as AutoAdaptHostZoneVisualizationSystem,
  DragProjectionPointVisualizationSystem as DragProjectionPointVisualizationSystem,
  FunctionalMarginVisualizationSystem as FunctionalMarginVisualizationSystem,
  FunctionalZoneVisualizationSystem as FunctionalZoneVisualizationSystem,
  PolyhedronVisualizationHolderComponent as PolyhedronVisualizationHolderComponent,
  PolyhedronVisualizationSystem as PolyhedronVisualizationSystem,
  ColliderVisualizationSystem as ColliderVisualizationSystem,
  ConnectorVisualizationSystem as ConnectorVisualizationSystem,
  EntityColliderVisualizationSystem as EntityColliderVisualizationSystem,
  CollisionVisualizationSceneDataComponent as CollisionVisualizationSceneDataComponent,
  CollisionVisualizationSceneData as CollisionVisualizationSceneData,
  EntityCollisionVisualizationSystem as EntityCollisionVisualizationSystem,
  EntityConnectorVisualizationSystem as EntityConnectorVisualizationSystem,
  CollisionVisualizationData as CollisionVisualizationData,
  Color as Color,
  DefaultVisualizer as DefaultVisualizer,
  CoreDebug as CoreDebug,
  SortedValidationResult as SortedValidationResult,
};
export {
  AllowedDoorPairsComponent as AllowedDoorPairsComponent3mt210f8oa8rk,
  AutoAdaptSessionComponent as AutoAdaptSessionComponent22ewpf3zhib95,
  AutoAdaptGuestComponent as AutoAdaptGuestComponentm7ystystq256,
  AutoAdaptHostComponent as AutoAdaptHostComponent34qpeh2sq4yhu,
  get_variantEntities as get_variantEntities2smv4ibi292bv,
  DragProjectionPointComponent as DragProjectionPointComponent373iy7kyauua1,
  FunctionalMarginShapeComponent as FunctionalMarginShapeComponent1ipzxulknf0p,
  FunctionalZonesLocalComponent as FunctionalZonesLocalComponent1aj0wo49dpyv3,
  FunctionalZone as FunctionalZone2cyfwjzx0uu9k,
  OutlinedComponent as OutlinedComponent3mbv5ff4jycz6,
  PlacementResult as PlacementResult3tdo3j6xpgae6,
  PlacementService as PlacementService19zued3tbdmh4,
  PlacementZoneByHeightComponent as PlacementZoneByHeightComponent17hvd16v0ynlm,
  RecommendedInitialPositionFromFloorComponent as RecommendedInitialPositionFromFloorComponent2w8snp7w7asn,
  recommendedPosition as recommendedPosition2lbjp2zghgru2,
  CommunicationSizeComponent as CommunicationSizeComponent3b9iyn3tznkse,
  DoorComponent as DoorComponent1aqj2bxcz9fq3,
  LightComponent as LightComponentkx6mitxrp2z0,
  ConnectorVisualizationData as ConnectorVisualizationData12c6o2kaz0oxo,
  Companion_getInstance_59 as Companion_getInstance1daeu5egcxxhc,
  Companion_getInstance_61 as Companion_getInstance1kt5fbscx1wt3,
  Companion_getInstance_62 as Companion_getInstance12g7fz0zzzhna,
  Companion_getInstance_118 as Companion_getInstance2e1jdwk3lbb7j,
  Companion_instance_115 as Companion_instance1ywp8gtysici,
  Companion_getInstance_121 as Companion_getInstance2jl9g5gxyuaw4,
  Companion_getInstance_122 as Companion_getInstance2ylf47lyedbv5,
  SearchDirectionsUtils_instance as SearchDirectionsUtils_instanceep40lkigythz,
  DoorFrontComponent_getInstance as DoorFrontComponent_getInstance2e2t42qmfke7o,
  DrawerComponent_getInstance as DrawerComponent_getInstancev1maoc1j7lic,
  FrameComponent_getInstance as FrameComponent_getInstance2c998mz05aq2i,
  HandleComponent_getInstance as HandleComponent_getInstance3ura479bgq6yv,
  LegComponent_getInstance as LegComponent_getInstance2b9gn5nn97ee3,
  Companion_getInstance_153 as Companion_getInstance1ltn888kcrvkv,
};
//endregion

//# sourceMappingURL=core-core-stl.mjs.map
